/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://127.0.0.1:9393/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/assets/js/main.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/asyncToGenerator.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
        u = i.value;
  } catch (n) {
    return void e(n);
  }

  i.done ? t(u) : Promise.resolve(u).then(r, o);
}

function _asyncToGenerator(n) {
  return function () {
    var t = this,
        e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);

      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }

      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }

      _next(void 0);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/@babel/runtime/helpers/toPropertyKey.js");

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js":
/*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(/*! ./objectWithoutPropertiesLoose.js */ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
      r,
      i = objectWithoutPropertiesLoose(e, t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);

    for (r = 0; r < n.length; r++) {
      o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
  }

  return i;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};

  for (var n in r) {
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  }

  return t;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toPrimitive.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPrimitive.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toPropertyKey.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toPropertyKey.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];

var toPrimitive = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/@babel/runtime/helpers/toPrimitive.js");

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/aos/dist/aos.js":
/*!**************************************!*\
  !*** ./node_modules/aos/dist/aos.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

!function (e, t) {
   true ? module.exports = t() : undefined;
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var i = n[o] = {
        exports: {},
        id: o,
        loaded: !1
      };
      return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.p = "dist/", t(0);
  }([function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    },
        r = n(1),
        a = (o(r), n(6)),
        u = o(a),
        c = n(7),
        s = o(c),
        f = n(8),
        d = o(f),
        l = n(9),
        p = o(l),
        m = n(10),
        b = o(m),
        v = n(11),
        y = o(v),
        g = n(14),
        h = o(g),
        w = [],
        k = !1,
        x = {
      offset: 120,
      delay: 0,
      easing: "ease",
      duration: 400,
      disable: !1,
      once: !1,
      startEvent: "DOMContentLoaded",
      throttleDelay: 99,
      debounceDelay: 50,
      disableMutationObserver: !1
    },
        j = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
    },
        O = function () {
      w = (0, h.default)(), j();
    },
        M = function () {
      w.forEach(function (e, t) {
        e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
      });
    },
        S = function (e) {
      return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
    },
        _ = function (e) {
      x = i(x, e), w = (0, h.default)();
      var t = document.all && !window.atob;
      return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function () {
        j(!0);
      }) : document.addEventListener(x.startEvent, function () {
        j(!0);
      }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function () {
        (0, b.default)(w, x.once);
      }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
    };

    e.exports = {
      init: _,
      refresh: j,
      refreshHard: O
    };
  }, function (e, t) {},,,,, function (e, t) {
    (function (t) {
      "use strict";

      function n(e, t, n) {
        function o(t) {
          var n = b,
              o = v;
          return b = v = void 0, k = t, g = e.apply(o, n);
        }

        function r(e) {
          return k = e, h = setTimeout(f, t), M ? o(e) : g;
        }

        function a(e) {
          var n = e - w,
              o = e - k,
              i = t - n;
          return S ? j(i, y - o) : i;
        }

        function c(e) {
          var n = e - w,
              o = e - k;
          return void 0 === w || n >= t || n < 0 || S && o >= y;
        }

        function f() {
          var e = O();
          return c(e) ? d(e) : void (h = setTimeout(f, a(e)));
        }

        function d(e) {
          return h = void 0, _ && b ? o(e) : (b = v = void 0, g);
        }

        function l() {
          void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
        }

        function p() {
          return void 0 === h ? g : d(O());
        }

        function m() {
          var e = O(),
              n = c(e);

          if (b = arguments, v = this, w = e, n) {
            if (void 0 === h) return r(w);
            if (S) return h = setTimeout(f, t), o(w);
          }

          return void 0 === h && (h = setTimeout(f, t)), g;
        }

        var b,
            v,
            y,
            g,
            h,
            w,
            k = 0,
            M = !1,
            S = !1,
            _ = !0;

        if ("function" != typeof e) throw new TypeError(s);
        return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
      }

      function o(e, t, o) {
        var r = !0,
            a = !0;
        if ("function" != typeof e) throw new TypeError(s);
        return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, {
          leading: r,
          maxWait: t,
          trailing: a
        });
      }

      function i(e) {
        var t = "undefined" == typeof e ? "undefined" : c(e);
        return !!e && ("object" == t || "function" == t);
      }

      function r(e) {
        return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
      }

      function a(e) {
        return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
      }

      function u(e) {
        if ("number" == typeof e) return e;
        if (a(e)) return f;

        if (i(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = i(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(l, "");
        var n = m.test(e);
        return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e;
      }

      var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
          s = "Expected a function",
          f = NaN,
          d = "[object Symbol]",
          l = /^\s+|\s+$/g,
          p = /^[-+]0x[0-9a-f]+$/i,
          m = /^0b[01]+$/i,
          b = /^0o[0-7]+$/i,
          v = parseInt,
          y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t,
          g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self,
          h = y || g || Function("return this")(),
          w = Object.prototype,
          k = w.toString,
          x = Math.max,
          j = Math.min,
          O = function () {
        return h.Date.now();
      };

      e.exports = o;
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    (function (t) {
      "use strict";

      function n(e, t, n) {
        function i(t) {
          var n = b,
              o = v;
          return b = v = void 0, O = t, g = e.apply(o, n);
        }

        function r(e) {
          return O = e, h = setTimeout(f, t), M ? i(e) : g;
        }

        function u(e) {
          var n = e - w,
              o = e - O,
              i = t - n;
          return S ? x(i, y - o) : i;
        }

        function s(e) {
          var n = e - w,
              o = e - O;
          return void 0 === w || n >= t || n < 0 || S && o >= y;
        }

        function f() {
          var e = j();
          return s(e) ? d(e) : void (h = setTimeout(f, u(e)));
        }

        function d(e) {
          return h = void 0, _ && b ? i(e) : (b = v = void 0, g);
        }

        function l() {
          void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
        }

        function p() {
          return void 0 === h ? g : d(j());
        }

        function m() {
          var e = j(),
              n = s(e);

          if (b = arguments, v = this, w = e, n) {
            if (void 0 === h) return r(w);
            if (S) return h = setTimeout(f, t), i(w);
          }

          return void 0 === h && (h = setTimeout(f, t)), g;
        }

        var b,
            v,
            y,
            g,
            h,
            w,
            O = 0,
            M = !1,
            S = !1,
            _ = !0;

        if ("function" != typeof e) throw new TypeError(c);
        return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
      }

      function o(e) {
        var t = "undefined" == typeof e ? "undefined" : u(e);
        return !!e && ("object" == t || "function" == t);
      }

      function i(e) {
        return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
      }

      function r(e) {
        return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f;
      }

      function a(e) {
        if ("number" == typeof e) return e;
        if (r(e)) return s;

        if (o(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = o(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(d, "");
        var n = p.test(e);
        return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e;
      }

      var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
          c = "Expected a function",
          s = NaN,
          f = "[object Symbol]",
          d = /^\s+|\s+$/g,
          l = /^[-+]0x[0-9a-f]+$/i,
          p = /^0b[01]+$/i,
          m = /^0o[0-7]+$/i,
          b = parseInt,
          v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t,
          y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self,
          g = v || y || Function("return this")(),
          h = Object.prototype,
          w = h.toString,
          k = Math.max,
          x = Math.min,
          j = function () {
        return g.Date.now();
      };

      e.exports = n;
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    "use strict";

    function n(e) {
      var t = void 0,
          o = void 0,
          i = void 0;

      for (t = 0; t < e.length; t += 1) {
        if (o = e[t], o.dataset && o.dataset.aos) return !0;
        if (i = o.children && n(o.children)) return !0;
      }

      return !1;
    }

    function o() {
      return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }

    function i() {
      return !!o();
    }

    function r(e, t) {
      var n = window.document,
          i = o(),
          r = new i(a);
      u = t, r.observe(n.documentElement, {
        childList: !0,
        subtree: !0,
        removedNodes: !0
      });
    }

    function a(e) {
      e && e.forEach(function (e) {
        var t = Array.prototype.slice.call(e.addedNodes),
            o = Array.prototype.slice.call(e.removedNodes),
            i = t.concat(o);
        if (n(i)) return u();
      });
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = function () {};

    t.default = {
      isSupported: i,
      ready: r
    };
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o() {
      return navigator.userAgent || navigator.vendor || window.opera || "";
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
        c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        s = function () {
      function e() {
        n(this, e);
      }

      return i(e, [{
        key: "phone",
        value: function () {
          var e = o();
          return !(!r.test(e) && !a.test(e.substr(0, 4)));
        }
      }, {
        key: "mobile",
        value: function () {
          var e = o();
          return !(!u.test(e) && !c.test(e.substr(0, 4)));
        }
      }, {
        key: "tablet",
        value: function () {
          return this.mobile() && !this.phone();
        }
      }]), e;
    }();

    t.default = new s();
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function (e, t, n) {
      var o = e.node.getAttribute("data-aos-once");
      t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !n && "true" !== o) && e.node.classList.remove("aos-animate");
    },
        o = function (e, t) {
      var o = window.pageYOffset,
          i = window.innerHeight;
      e.forEach(function (e, r) {
        n(e, i + o, t);
      });
    };

    t.default = o;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(12),
        r = o(i),
        a = function (e, t) {
      return e.forEach(function (e, n) {
        e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
      }), e;
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(13),
        r = o(i),
        a = function (e, t) {
      var n = 0,
          o = 0,
          i = window.innerHeight,
          a = {
        offset: e.getAttribute("data-aos-offset"),
        anchor: e.getAttribute("data-aos-anchor"),
        anchorPlacement: e.getAttribute("data-aos-anchor-placement")
      };

      switch (a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement) {
        case "top-bottom":
          break;

        case "center-bottom":
          n += e.offsetHeight / 2;
          break;

        case "bottom-bottom":
          n += e.offsetHeight;
          break;

        case "top-center":
          n += i / 2;
          break;

        case "bottom-center":
          n += i / 2 + e.offsetHeight;
          break;

        case "center-center":
          n += i / 2 + e.offsetHeight / 2;
          break;

        case "top-top":
          n += i;
          break;

        case "bottom-top":
          n += e.offsetHeight + i;
          break;

        case "center-top":
          n += e.offsetHeight / 2 + i;
      }

      return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
    };

    t.default = a;
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function (e) {
      for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);) {
        t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
      }

      return {
        top: n,
        left: t
      };
    };

    t.default = n;
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function (e) {
      return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function (e) {
        return {
          node: e
        };
      });
    };

    t.default = n;
  }]);
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/accordions/Accordion.vue?vue&type=script&lang=js&":
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/accordions/Accordion.vue?vue&type=script&lang=js& ***!
  \*********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: 'Accordion'
    },
    startOpen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      index: 0,
      isOpen: this.startOpen,
      contentObserver: null
    };
  },

  mounted() {
    if (this.isOpen) this.open();
    window.addEventListener('resize', this.onResize);
    this.observeContentChange();
  },

  beforeUnmount() {
    this.contentObserver.disconnect();
  },

  methods: {
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    open() {
      this.isOpen = true;

      if (this.$refs.content) {
        this.$refs.content.style.height = this.getHeight();
      }

      this.$emit('accordion-open', {
        index: this.index
      });
    },

    close() {
      this.isOpen = false;
      this.$refs.content.style.height = 0;
    },

    getHeight() {
      return "".concat(this.$refs.contentWrapper.offsetHeight, "px");
    },

    onResize() {
      // Reset height of content element
      this.$nextTick(() => {
        if (this.isOpen) this.open();
      });
    },

    observeContentChange() {
      var config = {
        characterData: true,
        attributes: false,
        childList: true,
        subtree: true
      };
      this.contentObserver = new MutationObserver(this.onResize);
      this.contentObserver.observe(this.$refs.contentWrapper, config);
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/accordions/Accordions.vue?vue&type=script&lang=js&":
/*!**********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/accordions/Accordions.vue?vue&type=script&lang=js& ***!
  \**********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    limitToOneOpen: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      accordions: [],
      contentObserver: null
    };
  },

  mounted() {
    this.getAccordionsFromSlot();
    this.observeContentChange();
  },

  beforeUnmount() {
    this.contentObserver.disconnect();
  },

  methods: {
    getAccordionsFromSlot() {
      var slot = this.$slots.default;
      if (!slot) return;
      var accordions = slot.filter(a => !!a.tag).map(a => a.componentInstance);
      this.accordions = accordions;
      this.setAccordionIndex();
      this.watchAccordionIsOpen();
    },

    setAccordionIndex() {
      this.accordions.forEach((accordion, i) => {
        accordion.index = i;
      });
    },

    watchAccordionIsOpen() {
      this.accordions.forEach((accordion, i) => {
        this.$watch(() => {
          return accordion.isOpen;
        }, open => {
          if (open && this.limitToOneOpen) {
            this.closeOtherAccordion(accordion.index);
          }
        });
      });
    },

    closeOtherAccordion(excludedIndex) {
      this.accordions.forEach((accordion, i) => {
        if (i !== excludedIndex) {
          accordion.close();
        }
      });
    },

    observeContentChange() {
      var config = {
        characterData: true,
        attributes: false,
        childList: true,
        subtree: true
      };
      this.contentObserver = new MutationObserver(this.getAccordionsFromSlot);
      this.contentObserver.observe(this.$refs.accordionsContent, config);
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=script&lang=js&":
/*!**************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=script&lang=js& ***!
  \**************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var lib_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/cart */ "./src/assets/js/lib/cart.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    addToCartText: {
      type: String,
      default: ''
    },
    soldOutText: {
      type: String,
      default: ''
    },
    unavailableText: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      state: lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"],
      product: window.BARREL.product || {},
      selectedBundleItems: null
    };
  },

  computed: {
    initialPrice() {
      if (this.product && this.product.variantPrice) return this.product.variantPrice;

      if (this.product && this.product.firstAvailableVariant && this.product.firstAvailableVariant.price) {
        return this.product.firstAvailableVariant.price;
      }

      return 0;
    },

    data() {
      if (!this.product || !this.product.data) return {};

      try {
        return JSON.parse(this.product.data);
      } catch (e) {
        return {};
      }
    },

    bundleGroup() {
      return this.data.bundleGroup || [];
    },

    activeBundleGroups() {
      return (this.bundleGroup || []).filter(group => group && group.products && group.products.length);
    },

    isBundleUnavailable() {
      if (!this.activeBundleGroups.length) return false;
      return this.activeBundleGroups.some(group => {
        var products = group.products || [];
        return !products.some(item => item && item.available);
      });
    },

    cantAddTocart() {
      return this.isBundleUnavailable || !this.selectedBundleItems;
    },

    submitButtonText() {
      if (this.isBundleUnavailable) return this.soldOutText || this.unavailableText || this.addToCartText;
      return this.cantAddTocart ? this.unavailableText || this.addToCartText : this.addToCartText;
    },

    bundleTotalPrice() {
      if (this.selectedBundleItems && this.selectedBundleItems.length) {
        return this.getBundleTotalPrice(this.selectedBundleItems);
      }

      return this.initialPrice;
    },

    formattedPrice() {
      return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["formatMoney"])(this.bundleTotalPrice || 0, '${{amount_no_decimals}}');
    }

  },
  methods: {
    getBundleTotalPrice(items) {
      if (!items || !items.length) return 0;
      return items.reduce((total, item) => total + (item.variantPrice || 0), 0);
    },

    onBundleComplete(items) {
      this.selectedBundleItems = items;
      var totalPrice = this.getBundleTotalPrice(items);
      lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].bundleItems = {
        items,
        totalPrice
      };
    },

    addToCart() {
      if (!this.selectedBundleItems || !this.selectedBundleItems.length) return null;
      var bundleId = "bundle_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 5));
      var bundleProductTitle = window.BARREL.bundleBuilder && window.BARREL.bundleBuilder.title || window.location.pathname.replace(/^\/pages\//, '').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || '';
      var bundleProductHandle = this.product.handle || window.BARREL.bundleBuilder && window.BARREL.bundleBuilder.url || window.location.pathname;
      var fixedPrice = this.product && this.product.fixedPrice !== undefined && this.product.fixedPrice !== null && this.product.fixedPrice !== '' ? this.product.fixedPrice : '';
      var items = this.selectedBundleItems.map(item => ({
        id: item.variantId,
        quantity: 1,
        properties: {
          _bundle_product_handle: bundleProductHandle,
          _bundle_product_name: bundleProductTitle,
          _bundle_group_title: item.bundleGroupTitle,
          _bundle_featured_image: item.featuredImage,
          _bundle_id: bundleId,
          _bundle_fixed_price: fixedPrice
        }
      }));
      lib_cart__WEBPACK_IMPORTED_MODULE_1__["default"].add(items).then(code => {
        if (code && code.status === 422) return;
        lib_cart__WEBPACK_IMPORTED_MODULE_1__["default"].get().then(data => {
          lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].cart = data;
          lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].isMiniCartOpen = true;
        });
      });
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=script&lang=js&":
/*!******************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=script&lang=js& ***!
  \******************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formattedPrice: {
      type: String,
      default: ''
    },
    isPreOrder: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/button/Button.vue?vue&type=script&lang=js&":
/*!**************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/button/Button.vue?vue&type=script&lang=js& ***!
  \**************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/isEmpty */ "./node_modules/lodash/isEmpty.js");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      type: String,
      default: 'button'
    },
    modifier: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: '/'
    },
    onClick: {
      type: Function,
      default: () => {
        return false;
      }
    },
    overWhite: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    attrs: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    combinedClass() {
      var modifierClass = lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(this.modifier) ? '' : "button--".concat(this.modifier);
      return [modifierClass, {
        'button--over-white': this.overWhite
      }];
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-grid/CartGrid.vue?vue&type=script&lang=js&":
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/cart-grid/CartGrid.vue?vue&type=script&lang=js& ***!
  \*******************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_availability_callout_availability_callout_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/availability-callout/availability-callout.css */ "./src/modules/availability-callout/availability-callout.css");
/* harmony import */ var modules_availability_callout_availability_callout_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(modules_availability_callout_availability_callout_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./@store */ "./src/modules/cart-grid/@store.js");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/button/Button.vue */ "./src/modules/button/Button.vue");
/* harmony import */ var modules_cart_item_CartItem_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/cart-item/CartItem.vue */ "./src/modules/cart-item/CartItem.vue");
/* harmony import */ var modules_cart_item_bundle_CartItemBundle_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! modules/cart-item-bundle/CartItemBundle.vue */ "./src/modules/cart-item-bundle/CartItemBundle.vue");
/* harmony import */ var modules_icons_IconRefresh_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! modules/icons/IconRefresh.vue */ "./src/modules/icons/IconRefresh.vue");
/* harmony import */ var modules_icons_IconLogo_vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! modules/icons/IconLogo.vue */ "./src/modules/icons/IconLogo.vue");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var lib_zapietWidgetControl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! lib/zapietWidgetControl */ "./src/assets/js/lib/zapietWidgetControl.js");
/* harmony import */ var lib_mixedCartPolicy__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! lib/mixedCartPolicy */ "./src/assets/js/lib/mixedCartPolicy.js");
/* harmony import */ var modules_pre_order_note_PreOrderNote_vue__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! modules/pre-order-note/PreOrderNote.vue */ "./src/modules/pre-order-note/PreOrderNote.vue");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-button': modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_5__["default"],
    CartItem: modules_cart_item_CartItem_vue__WEBPACK_IMPORTED_MODULE_6__["default"],
    CartItemBundle: modules_cart_item_bundle_CartItemBundle_vue__WEBPACK_IMPORTED_MODULE_7__["default"],
    IconRefresh: modules_icons_IconRefresh_vue__WEBPACK_IMPORTED_MODULE_8__["default"],
    IconLogo: modules_icons_IconLogo_vue__WEBPACK_IMPORTED_MODULE_9__["default"],
    PreOrderNote: modules_pre_order_note_PreOrderNote_vue__WEBPACK_IMPORTED_MODULE_13__["default"]
  },
  store: _store__WEBPACK_IMPORTED_MODULE_3__["default"],
  props: {
    isMiniCart: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    textEmpty: {
      type: String,
      default: ''
    },
    textSubtotal: {
      type: String,
      default: ''
    },
    textButton: {
      type: String,
      default: ''
    },
    textShipping: {
      type: String,
      default: ''
    },
    textUpdate: {
      type: String,
      default: ''
    },
    textShopLink: {
      type: String,
      default: ''
    },
    textShopText: {
      type: String,
      default: ''
    },
    textKeepShopping: {
      type: String,
      default: ''
    },
    preorderTitle: {
      type: String,
      default: ''
    },
    preorderNote: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      disableCheckoutButton: window.BARREL && window.BARREL.disableCheckoutButton ? window.BARREL.disableCheckoutButton : false,
      cartOrderMinimum: window.BARREL && window.BARREL.cartOrderMinimum ? parseInt(window.BARREL.cartOrderMinimum) : 0,
      cartOrderMinimumInfo: window.BARREL && window.BARREL.cartOrderMinimumInfo ? window.BARREL.cartOrderMinimumInfo : '',
      preOrder: {},
      showPreOrder: false,
      zapietSyncQueued: false,
      zapietMountAttached: false,
      zapietUnsubscribers: [],
      zapietCheckoutEventsSubscribed: [],
      berriesCheckoutEnabled: true
    };
  },

  computed: _objectSpread(_objectSpread(_objectSpread({
    preOrderNote() {
      return modules_pre_order_note_PreOrderNote_vue__WEBPACK_IMPORTED_MODULE_13__["default"];
    },

    availabilityCallout() {
      var _window$BARREL;

      return ((_window$BARREL = window.BARREL) === null || _window$BARREL === void 0 ? void 0 : _window$BARREL.availabilityCallout) || null;
    },

    showAvailabilityCallout() {
      var _this$cart;

      var callout = this.availabilityCallout;
      if (!(callout !== null && callout !== void 0 && callout.text)) return false;
      var items = (_this$cart = this.cart) === null || _this$cart === void 0 ? void 0 : _this$cart.items;
      if (!(items !== null && items !== void 0 && items.length)) return false;
      return items.some(lib_mixedCartPolicy__WEBPACK_IMPORTED_MODULE_12__["isDeliveryOnlyLineItem"]);
    },

    availabilityCalloutStyle() {
      var callout = this.availabilityCallout || {};
      return {
        '--availability-callout-bg': callout.backgroundColor || '#431112',
        '--availability-callout-color': callout.textColor || '#1F211B'
      };
    },

    berriesCartThemeVars() {
      var _window$BARREL2;

      var theme = ((_window$BARREL2 = window.BARREL) === null || _window$BARREL2 === void 0 ? void 0 : _window$BARREL2.berriesCartTheme) || {};
      return {
        '--berries-cart-bg': theme.backgroundColor || '#1F211B',
        '--berries-cart-color': theme.textColor || '#ffffff',
        '--berries-cart-surface-bg': theme.surfaceBackgroundColor || '#2A2D25'
      };
    }

  }, Object(vuex__WEBPACK_IMPORTED_MODULE_4__["mapGetters"])(['subtotal'])), Object(vuex__WEBPACK_IMPORTED_MODULE_4__["mapState"])(['app', 'loading', 'isBootstrapped', 'isMobile', 'removedItem'])), {}, {
    isCheckoutBtndisabled() {
      return this.cartMethod.toLowerCase() === 'delivery' && this.disableCheckoutButton && this.cartOrderMinimum * 100 > this.subtotal;
    },

    hasBerriesInCart() {
      return this.mixedCartState.hasDeliveryOnlyItems;
    },

    isZapietEventApiAvailable() {
      return Boolean(window.ZapietEvent && typeof window.ZapietEvent.listen === 'function');
    },

    showZapietWidget() {
      return this.hasBerriesInCart && !this.isEmpty;
    },

    requiresZapietCheckoutGate() {
      return this.hasBerriesInCart && this.isZapietEventApiAvailable;
    },

    isCheckoutDisabled() {
      if (this.isCheckoutBtndisabled) return true;
      if (this.requiresZapietCheckoutGate && !this.berriesCheckoutEnabled) return true;
      return false;
    },

    berriesCartSignature() {
      var _this$cart2, _this$cart2$items;

      if (!((_this$cart2 = this.cart) !== null && _this$cart2 !== void 0 && (_this$cart2$items = _this$cart2.items) !== null && _this$cart2$items !== void 0 && _this$cart2$items.length)) return '';
      return this.cart.items.filter(lib_mixedCartPolicy__WEBPACK_IMPORTED_MODULE_12__["isDeliveryOnlyLineItem"]).map(item => "".concat(item.key, ":").concat(item.quantity)).join('|');
    },

    visualSubtotal() {
      if (!this.cart || !this.cart.items || !this.cart.items.length) return 0;
      var bundles = {};
      var total = 0;
      this.cart.items.forEach(item => {
        var properties = item.properties || {};
        var bundleId = properties._bundle_id;

        if (!bundleId) {
          total += item.final_line_price || 0;
          return;
        }

        if (!bundles[bundleId]) {
          bundles[bundleId] = {
            fixedPrice: null,
            itemsTotal: 0
          };
        }

        bundles[bundleId].itemsTotal += item.final_line_price || 0;
        var rawFixedPrice = properties._bundle_fixed_price;

        if (rawFixedPrice !== undefined && rawFixedPrice !== null && rawFixedPrice !== '') {
          var numericFixedPrice = Number(rawFixedPrice);

          if (!Number.isNaN(numericFixedPrice)) {
            bundles[bundleId].fixedPrice = numericFixedPrice;
          }
        }
      });
      Object.values(bundles).forEach(bundle => {
        total += bundle.fixedPrice !== null ? bundle.fixedPrice : bundle.itemsTotal;
      });
      return total;
    },

    totalPrice() {
      return Object(lib_util__WEBPACK_IMPORTED_MODULE_10__["formatMoney"])(this.visualSubtotal);
    },

    isEmpty() {
      return this.cart.items.length === 0;
    },

    cart() {
      return this.app.cart;
    },

    groupedCartItems() {
      return this.cart.items.reduce((result, item, index) => {
        if (item.properties._bundle_id) {
          var bundle = result.find(_item => _item.id === item.properties._bundle_id) || {};

          if (!bundle.id) {
            bundle.isBundle = true;
            bundle.id = item.properties._bundle_id;
            bundle.items = [];
            result.push(bundle);
          }

          bundle.items.push(_objectSpread(_objectSpread({}, item), {}, {
            index
          }));
        } else {
          result.push(_objectSpread(_objectSpread({}, item), {}, {
            index
          }));
        }

        return result;
      }, []);
    },

    cartMethod() {
      return this.cart.items && this.cart.items[0].properties._method ? this.cart.items[0].properties._method : '';
    },

    mixedCartState() {
      return Object(lib_mixedCartPolicy__WEBPACK_IMPORTED_MODULE_12__["getMixedCartState"])(this.cart);
    }

  }),
  watch: {
    'app.isMiniCartOpen'(value) {
      if (value) {
        this.getPreOder();
        this.pushDatalayerViewCart();
        this.syncBerriesCartTheme();

        if (this.showZapietWidget) {
          this.$nextTick(() => {
            this.syncZapietMount();
          });
        }

        Object(lib_util__WEBPACK_IMPORTED_MODULE_10__["style"])(document.body, 'overflow', 'hidden');
      } else {
        Object(lib_util__WEBPACK_IMPORTED_MODULE_10__["unstyle"])(document.body, 'overflow');
      }
    },

    'removedItem'(item) {
      if (item && Object.keys(item).length > 0) {
        this.updateRemovedItemStatus(item);
      }
    },

    'app.lastAdd'(value) {
      this.getCart();
    },

    'app.cart'() {
      this.getPreOder();
      this.queueZapietSync();
      this.syncBerriesCartTheme();
    },

    hasBerriesInCart() {
      this.syncBerriesCheckoutGate();
      this.queueZapietSync();
      this.syncBerriesCartTheme();
    },

    showZapietWidget(show) {
      if (show) {
        this.$nextTick(() => {
          this.attachZapietMount();
        });
      } else {
        this.detachZapietMount();
      }
    },

    berriesCartSignature() {
      this.syncBerriesCheckoutGate();
    },

    isEmpty() {
      this.syncBerriesCartTheme();
    }

  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_4__["mapMutations"])(['bootstrap'])), Object(vuex__WEBPACK_IMPORTED_MODULE_4__["mapMutations"])(['toggleMiniCart'])), Object(vuex__WEBPACK_IMPORTED_MODULE_4__["mapActions"])(['getCart'])), {}, {
    applyBerriesCartThemeVars(el, isBerries) {
      if (!el) return;
      var vars = this.berriesCartThemeVars;
      Object.keys(vars).forEach(name => {
        if (isBerries) {
          el.style.setProperty(name, vars[name]);
        } else {
          el.style.removeProperty(name);
        }
      });
    },

    syncBerriesCartTheme() {
      var isBerries = this.hasBerriesInCart && !this.isEmpty;
      var grid = this.$el && this.$el.closest('.cart-grid');
      var miniCart = this.$el && this.$el.closest('.mini-cart');
      this.applyBerriesCartThemeVars(document.body, isBerries);

      if (grid) {
        grid.classList.toggle('cart-grid--berries', isBerries);
        this.applyBerriesCartThemeVars(grid, isBerries);
      }

      if (miniCart) {
        miniCart.classList.toggle('mini-cart--berries', isBerries);
        this.applyBerriesCartThemeVars(miniCart, isBerries);
      }

      if (!this.isMiniCart) {
        document.body.classList.toggle('template-cart--berries', isBerries);
        document.body.classList.toggle('is-transparent-header', isBerries);
        this.applyBerriesCartThemeVars(document.body, isBerries);
      }
    },

    getZapietGridEl() {
      return this.$el && this.$el.closest('.cart-grid');
    },

    getZapietNode() {
      var mount = this.$refs.zapietMount;

      if (mount) {
        var mountedNode = mount.querySelector('#storePickupApp');
        if (mountedNode) return mountedNode;
      }

      var grid = this.getZapietGridEl();
      var seed = grid && grid.previousElementSibling;
      if (seed && seed.id === 'storePickupApp') return seed;
      return null;
    },

    detachZapietMount() {
      var grid = this.getZapietGridEl();
      var mount = this.$refs.zapietMount;
      var node = mount && mount.querySelector('#storePickupApp');

      if (!node && grid) {
        var seed = grid.previousElementSibling;
        if (seed && seed.id === 'storePickupApp') node = seed;
      }

      if (!node) return;
      node.innerHTML = '';
      Object(lib_zapietWidgetControl__WEBPACK_IMPORTED_MODULE_11__["resetZapietWidget"])();

      if (grid && grid.parentNode && node.nextElementSibling !== grid) {
        grid.parentNode.insertBefore(node, grid);
      }

      this.zapietMountAttached = false;
    },

    attachZapietMount() {
      if (!this.showZapietWidget) return;
      var target = this.$refs.zapietMount;
      var node = this.getZapietNode();
      if (!target || !node) return;
      var wasAttached = target.contains(node);

      if (!wasAttached) {
        target.appendChild(node);
        this.zapietMountAttached = true;
        document.dispatchEvent(new CustomEvent('zapiet:start'));
      }

      this.syncZapietMount();
    },

    syncZapietMount() {
      if (!this.showZapietWidget) return;
      Object(lib_zapietWidgetControl__WEBPACK_IMPORTED_MODULE_11__["syncZapietDeliveryPostcodeFromCart"])(this.cart);
      this.queueZapietSync();
    },

    queueZapietSync() {
      if (this.zapietSyncQueued) return;
      this.zapietSyncQueued = true;
      window.requestAnimationFrame(() => {
        this.zapietSyncQueued = false;
        this.syncZapietMethod();
      });
    },

    syncZapietMethod() {
      Object(lib_zapietWidgetControl__WEBPACK_IMPORTED_MODULE_11__["syncZapietMethodByCart"])(this.cart);
    },

    onCartUpdated(event) {
      var cart = event && event.detail && event.detail.cart;
      if (!cart) return;
      Object(lib_zapietWidgetControl__WEBPACK_IMPORTED_MODULE_11__["syncZapietMethodByCart"])(cart);
    },

    onZapietLifecycleEvent() {
      this.queueZapietSync();
    },

    onZapietWidgetLoaded() {
      this.queueZapietSync();
      Object(lib_zapietWidgetControl__WEBPACK_IMPORTED_MODULE_11__["syncZapietDeliveryPostcodeFromCart"])(this.cart);
      this.subscribeZapietCheckoutEvents();
      this.syncBerriesCheckoutGate();
    },

    onZapietCheckoutEnabled() {
      if (!this.hasBerriesInCart) return;
      this.berriesCheckoutEnabled = true;
    },

    onZapietCheckoutDisabled() {
      if (!this.hasBerriesInCart) return;
      this.berriesCheckoutEnabled = false;
    },

    syncBerriesCheckoutGate() {
      if (!this.hasBerriesInCart) {
        this.berriesCheckoutEnabled = true;
        return;
      }

      if (!this.isZapietEventApiAvailable) {
        this.berriesCheckoutEnabled = true;
        return;
      }

      this.berriesCheckoutEnabled = false;
    },

    subscribeZapietCheckoutEvents() {
      var zapietEvent = window.ZapietEvent;
      if (!zapietEvent || typeof zapietEvent.listen !== 'function') return;
      var bindings = [['checkoutEnabled', this.onZapietCheckoutEnabled], ['checkoutDisabled', this.onZapietCheckoutDisabled], ['disableCheckout', this.onZapietCheckoutDisabled]];
      bindings.forEach(([eventName, handler]) => {
        if (this.zapietCheckoutEventsSubscribed.includes(eventName)) return;
        var maybeUnsubscribe = zapietEvent.listen(eventName, handler);
        this.zapietCheckoutEventsSubscribed.push(eventName);

        if (typeof maybeUnsubscribe === 'function') {
          this.zapietUnsubscribers.push(maybeUnsubscribe);
        }
      });
    },

    registerZapietEventListeners() {
      var zapietEvent = window.ZapietEvent;
      if (!zapietEvent || typeof zapietEvent.listen !== 'function') return;

      var subscribe = (eventName, handler) => {
        var maybeUnsubscribe = zapietEvent.listen(eventName, handler);

        if (typeof maybeUnsubscribe === 'function') {
          this.zapietUnsubscribers.push(maybeUnsubscribe);
        }
      };

      subscribe('widget_loaded', this.onZapietWidgetLoaded);
      subscribe('method_selected', this.onZapietLifecycleEvent);
      this.subscribeZapietCheckoutEvents();
    },

    unregisterZapietEventListeners() {
      this.zapietUnsubscribers.forEach(unsubscribe => {
        try {
          unsubscribe();
        } catch (error) {
          console.error('Error unregistering Zapiet event listener:', error);
        }
      });
      this.zapietUnsubscribers = [];
      this.zapietCheckoutEventsSubscribed = [];
    },

    updateRemovedItemStatus(item) {
      var removedItemStatus = this.$refs.removedItemStatus;

      if (!removedItemStatus) {
        return;
      }

      removedItemStatus.textContent = "Removed (".concat(item.quantity, ") ").concat(item.title, " from your cart.");
      removedItemStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        removedItemStatus.setAttribute('aria-hidden', true);
      }, 1000);
    },

    getPreOder() {
      var cartItem = this.cart.items && this.cart.items.some(item => item.properties && item.properties._is_pre_order === 'true');
      this.showPreOrder = cartItem;
    },

    pushDatalayerViewCart() {
      var _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
        var products = [];

        for (var [index, item] of _this.cart.items.entries()) {
          var endpoint = "".concat(window.location.origin, "/products/").concat(item.handle, "?view=json");
          var product = yield Object(lib_util__WEBPACK_IMPORTED_MODULE_10__["fetchData"])(endpoint);
          products.push(_objectSpread(_objectSpread({}, product), {}, {
            quantity: item.quantity,
            index,
            item_list_id: _this.isMiniCart ? 'mini-cart' : 'cart',
            item_list_name: _this.isMiniCart ? 'Mini Cart' : 'Cart'
          }));
        }

        Object(lib_util__WEBPACK_IMPORTED_MODULE_10__["trigger"])('viewCart', document, {
          cart: _this.cart,
          products
        });
      })();
    }

  }),

  mounted() {
    this.bootstrap();
    this.syncZapietMethod();
    document.addEventListener('oishii:cart-updated', this.onCartUpdated);
    this.registerZapietEventListeners();
    this.syncBerriesCheckoutGate();
    this.$nextTick(() => {
      if (this.showZapietWidget) {
        this.attachZapietMount();
      }

      this.syncBerriesCartTheme();
    });

    if (!this.isMiniCart) {
      this.getPreOder();
      this.pushDatalayerViewCart();
    }
  },

  beforeDestroy() {
    var grid = this.$el && this.$el.closest('.cart-grid');
    var miniCart = this.$el && this.$el.closest('.mini-cart');

    if (grid) {
      grid.classList.remove('cart-grid--berries');
      this.applyBerriesCartThemeVars(grid, false);
    }

    if (miniCart) {
      miniCart.classList.remove('mini-cart--berries');
      this.applyBerriesCartThemeVars(miniCart, false);
    }

    document.body.classList.remove('template-cart--berries');
    document.body.classList.remove('is-transparent-header');
    this.applyBerriesCartThemeVars(document.body, false);
    this.unregisterZapietEventListeners();
    document.removeEventListener('oishii:cart-updated', this.onCartUpdated);
  }

});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=script&lang=js&":
/*!********************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=script&lang=js& ***!
  \********************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CartItemBundle',
  props: {
    bundle: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      isRemoving: false
    };
  },

  computed: {
    id() {
      return this.bundle.id;
    },

    items() {
      return this.bundle.items;
    },

    groupedItems() {
      return this.items.reduce((result, item) => {
        if (!item.properties._addonLensId) {
          result.push(item);
          return result;
        }

        var lensKit = result.find(_item => _item.lensKitId === item.properties._addonLensId) || {};

        if (!lensKit.lensKitId) {
          lensKit.lensKitId = item.properties._addonLensId;
          result.push(lensKit);
        }

        if (item.properties._isAddonLens) {
          lensKit.lens = item;
        } else {
          Object.keys(item).forEach(key => {
            lensKit[key] = item[key];
          });
        }

        return result;
      }, []).sort((a, b) => {
        var titleA = a && a.properties && a.properties._bundle_group_title ? a.properties._bundle_group_title : '';
        var titleB = b && b.properties && b.properties._bundle_group_title ? b.properties._bundle_group_title : '';
        return titleA.localeCompare(titleB);
      });
    },

    bundleDisplayPrice() {
      var _this$items$, _this$items$$properti;

      if (!this.items.length) return '';
      var fixedPrice = (_this$items$ = this.items[0]) === null || _this$items$ === void 0 ? void 0 : (_this$items$$properti = _this$items$.properties) === null || _this$items$$properti === void 0 ? void 0 : _this$items$$properti._bundle_fixed_price;

      if (fixedPrice !== undefined && fixedPrice !== null && fixedPrice !== '') {
        return Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["formatMoney"])(Number(fixedPrice));
      }

      var total = this.items.reduce((result, item) => result + item.final_line_price, 0);
      return Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["formatMoney"])(total);
    },

    removeData() {
      return this.items.map(item => ({
        id: item.key,
        quantity: 0
      }));
    },

    bundleProductHandle() {
      return this.items.length ? this.items[0].properties._bundle_product_handle : '';
    }

  },
  methods: _objectSpread(_objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_2__["mapActions"])(['removeItems'])), {}, {
    edit() {
      if (!this.bundleProductHandle) return;
      window.location.href = this.bundleProductHandle;
    },

    remove() {
      var _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
        _this.isRemoving = true;
        yield _this.removeItems(_this.removeData);
        _this.isRemoving = false;
      })();
    }

  })
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-item/CartItem.vue?vue&type=script&lang=js&":
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/cart-item/CartItem.vue?vue&type=script&lang=js& ***!
  \*******************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash/debounce */ "./node_modules/lodash/debounce.js");
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var lib_mixedCartPolicy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lib/mixedCartPolicy */ "./src/assets/js/lib/mixedCartPolicy.js");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_quantity_selector_QuantitySelector_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/quantity-selector/QuantitySelector.vue */ "./src/modules/quantity-selector/QuantitySelector.vue");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_5__["default"],
    QuantitySelector: modules_quantity_selector_QuantitySelector_vue__WEBPACK_IMPORTED_MODULE_6__["default"]
  },
  props: {
    isMiniCart: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    item: {
      type: [Object, Array],
      default: () => {
        return [];
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      product: null
    };
  },

  computed: {
    imageSrc() {
      return this.item.image;
    },

    formattedPrice() {
      return Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["formatMoney"])(this.item.price);
    },

    formattedCompareAtPrice() {
      var variant = this.product && this.product.variants.find(variant => variant.id === this.item.variant_id);
      var compareAtPrice = variant && variant.compareAtPrice > variant.price ? variant.compareAtPrice : false;
      return compareAtPrice ? Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["formatMoney"])(compareAtPrice) : false;
    },

    totalFormattedPrice() {
      if (!this.item.properties) {
        return Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["formatMoney"])(this.item.price * this.item.quantity);
      }

      return this.item.properties.bundle_price ? Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["formatMoney"])(this.item.properties.bundle_price) : Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["formatMoney"])(this.item.price * this.item.quantity);
    },

    variantsToRemove() {
      var list = [];
      list.push({
        id: this.item.key,
        quantity: 0
      });
      return list;
    },

    cartInfo() {
      var methodValue = this.item.properties._method;
      var storeValue = this.item.options_with_values.find(item => item.name === 'Store');
      var dateValue = this.item.options_with_values.find(item => item.name === 'Date');
      var zipcodeValue = this.item.properties._zipcode;
      var preOrderValue = this.item.properties._is_pre_order;
      var method = methodValue ? "Method: ".concat(methodValue) : null;
      var location = storeValue ? "".concat(methodValue, " Location: ").concat(storeValue.value) : null;
      var date = dateValue ? "".concat(methodValue, " Date: ").concat(Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["getDateLabel"])(dateValue.value)) : null;
      var zipcode = zipcodeValue && zipcodeValue != 'null' ? "".concat(methodValue, " Zipcode: ").concat(zipcodeValue) : null;
      var preOrder = preOrderValue && preOrderValue != 'null' && preOrderValue != 'false' ? '*Pre-order Item' : null;
      return {
        method,
        zipcode,
        location,
        date,
        preOrder
      };
    },

    maxQuantity() {
      var _this$item$properties;

      var cartInventory = Number(this.item.inventory_quantity);
      if (Number.isFinite(cartInventory)) return cartInventory;
      var propertyInventory = Number.parseInt((_this$item$properties = this.item.properties) === null || _this$item$properties === void 0 ? void 0 : _this$item$properties._inventory_quantity, 10);
      if (Number.isFinite(propertyInventory)) return propertyInventory;
      return Number.POSITIVE_INFINITY;
    },

    isDeliveryOnly() {
      return Object(lib_mixedCartPolicy__WEBPACK_IMPORTED_MODULE_4__["isDeliveryOnlyLineItem"])(this.item);
    }

  },

  created() {
    var _this = this;

    return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(function* () {
      _this.updateQuantity = lodash_debounce__WEBPACK_IMPORTED_MODULE_2___default()(_this.applyQuantity, 450);
      var endpoint = "".concat(window.location.origin, "/products/").concat(_this.item.handle, "?view=json");
      yield Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["fetchData"])(endpoint).then(data => {
        _this.product = data;
        _this.product.index = _this.index;
        _this.product.item_list_id = _this.isMiniCart ? 'mini-cart' : 'cart';
        _this.product.item_list_name = _this.isMiniCart ? 'Mini Cart' : 'Cart';
      });
    })();
  },

  beforeDestroy() {
    if (this.updateQuantity) this.updateQuantity.flush();
  },

  methods: {
    applyQuantity(quantity) {
      var previousQuantity = this.item.quantity;
      var nextQuantity = Math.min(Math.max(quantity, 1), this.maxQuantity);
      this.$store.dispatch('updateItemQuantity', {
        quantity: nextQuantity,
        id: this.item.key
      });

      if (nextQuantity > previousQuantity) {
        Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["trigger"])('addToCart', document, {
          product: this.product
        });
      } else if (nextQuantity < previousQuantity) {
        Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["trigger"])('removeFromCart', document, {
          product: _objectSpread(_objectSpread({}, this.product), {}, {
            quantity: previousQuantity - nextQuantity
          })
        });
      }
    },

    flushQuantity() {
      this.updateQuantity.flush();
    },

    remove() {
      this.$store.dispatch('removeItems', this.variantsToRemove);
      Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["trigger"])('removeFromCart', document, {
        product: _objectSpread(_objectSpread({}, this.product), {}, {
          quantity: this.item.quantity
        })
      });
    },

    updateCartItemStatus() {
      var cartItemStatus = this.$refs.cartItemStatus[0];

      if (!cartItemStatus) {
        return;
      }

      cartItemStatus.textContent = "Updated: Quantity: ".concat(this.quantity, ", ").concat(this.totalFormattedPrice);
      cartItemStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartItemStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/checkbox/Checkbox.vue?vue&type=script&lang=js&":
/*!******************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/checkbox/Checkbox.vue?vue&type=script&lang=js& ***!
  \******************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    css: {
      type: [Array, String],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    checked: {
      type: [Number, Boolean],
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    srOnly: {
      type: Boolean,
      default: false
    },
    showErrorState: {
      type: Boolean,
      default: false
    },
    forceChecked: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isValid: true,
      isChecked: !!this.checked,
      publicValue: this.value || true,
      randomID: 'Checkbox-' + Math.floor(Math.random() * 1000),
      errorText: this.error ? decode(this.error) : ''
    };
  },

  watch: {
    checked() {
      if (this.forceChecked) {
        this.isChecked = this.checked;
      }
    }

  },
  methods: {
    validate() {
      this.isValid = !this.required || this.required && this.isChecked;
      return this.isValid;
    },

    onChange() {
      this.isChecked = !this.isChecked;
      var value = this.isChecked ? this.publicValue : false;
      this.$emit('change', {
        name: this.name,
        value
      });
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/contact-form/ContactForm.vue?vue&type=script&lang=js&":
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/contact-form/ContactForm.vue?vue&type=script&lang=js& ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var mixins_validate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! mixins/validate */ "./src/assets/js/mixins/validate.js");
/* harmony import */ var scroll_lock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! scroll-lock */ "./node_modules/scroll-lock/dist/scroll-lock.js");
/* harmony import */ var scroll_lock__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(scroll_lock__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var modules_text_input_TextInput_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/text-input/TextInput.vue */ "./src/modules/text-input/TextInput.vue");
/* harmony import */ var modules_select_input_SelectInput_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/select-input/SelectInput.vue */ "./src/modules/select-input/SelectInput.vue");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TextInput: modules_text_input_TextInput_vue__WEBPACK_IMPORTED_MODULE_5__["default"],
    SelectInput: modules_select_input_SelectInput_vue__WEBPACK_IMPORTED_MODULE_6__["default"]
  },
  mixins: [mixins_validate__WEBPACK_IMPORTED_MODULE_3__["default"]],
  props: {
    postedSuccessfully: {
      type: Boolean,
      default: false
    },
    postSuccess: {
      type: String,
      default: ''
    },
    postSuccessClose: {
      type: String,
      default: ''
    },
    postSuccessTitle: {
      type: String,
      default: ''
    },
    postSuccessText: {
      type: String,
      default: ''
    },
    valueName: {
      type: String,
      default: ''
    },
    errorMessageName: {
      type: String,
      default: ''
    },
    labelName: {
      type: String,
      default: ''
    },
    valueEmail: {
      type: String,
      default: ''
    },
    errorMessageEmail: {
      type: String,
      default: ''
    },
    labelEmail: {
      type: String,
      default: ''
    },
    labelZipcode: {
      type: String,
      default: ''
    },
    labelMessage: {
      type: String,
      default: ''
    },
    labelSubject: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: []
    },
    labelSubmit: {
      type: String,
      default: 'Submit'
    }
  },

  data() {
    return {
      isActive: false,
      isFocus: true,
      isSubmitting: false,
      contactMessage: '',
      error: false,
      nameValue: '',
      subjectValue: '',
      isSuccess: false,
      focusEl: null
    };
  },

  watch: {
    contactMessage() {
      this.validateMessage();
    }

  },

  mounted() {
    if (this.postedSuccessfully) {
      this.initSuccessModal();
    }
  },

  methods: {
    onInputChange({
      name,
      value
    }) {
      this.nameValue = value;
    },

    onSelectChange({
      name,
      value
    }) {
      this.subjectValue = value;
    },

    validateMessage() {
      this.error = false;

      if (!this.contactMessage) {
        this.error = true;
      }
    },

    activeField() {
      this.isActive = true;
    },

    deactiveField() {
      if (!this.contactMessage) this.isActive = false;
    },

    autoFocus() {
      setTimeout(() => {
        var errorFieldWrapper = Object(select_dom__WEBPACK_IMPORTED_MODULE_2__["default"])('.has-error', this.$el);

        if (errorFieldWrapper) {
          var inputField = Object(select_dom__WEBPACK_IMPORTED_MODULE_2__["default"])('input', errorFieldWrapper);
          if (inputField) inputField.focus();
        }
      }, 300);
    },

    isValidEmail({
      value
    }) {
      return /\S+@\S+\.\S+/.test(value);
    },

    initSuccessModal() {
      this.isSuccess = true;
      Object(scroll_lock__WEBPACK_IMPORTED_MODULE_4__["disablePageScroll"])();
      var contactFormSuccess = this.$refs.contactFormSuccess;

      if (contactFormSuccess) {
        this.focusEl = document.activeElement;
        contactFormSuccess.focus();
        Object(lib_util__WEBPACK_IMPORTED_MODULE_1__["trapFocus"])(contactFormSuccess);
      }
    },

    closeSuccessModal() {
      this.isSuccess = false;
      Object(scroll_lock__WEBPACK_IMPORTED_MODULE_4__["enablePageScroll"])();

      if (this.focusEl) {
        this.focusEl.focus();
      }
    },

    handleSubmit() {
      var _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
        if (_this.isSubmitting) return;
        _this.isSubmitting = true;

        var isValid = _this.validate();

        _this.autoFocus();

        _this.validateMessage();

        if (isValid && !_this.error) {
          Object(lib_util__WEBPACK_IMPORTED_MODULE_1__["trigger"])('contactFormSubmitted', document);
          yield _this.pushTrackingEventToKlaviyo();
          yield new Promise(resolve => setTimeout(resolve, 1000));
          console.log('Submitting Shopify form...');

          _this.$refs.contactForm.submit();

          yield new Promise(resolve => setTimeout(resolve, 500));
          _this.isSubmitting = false;
        }

        _this.isSubmitting = false;
      })();
    },

    pushTrackingEventToKlaviyo() {
      var _this2 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
        var formEl = _this2.$refs.contactForm;

        if (!formEl) {
          console.error('Contact Form not found');
          return;
        }

        if (!window.klaviyo) {
          console.error('Klaviyo is not loaded');
          return;
        }

        var formData = new FormData(formEl);
        var email = formData.get('contact[email]');
        var fullName = formData.get('contact[name]');
        var zipCode = formData.get('contact[zipcode]');
        var subject = formData.get('contact[subject]');
        var message = formData.get('contact[message]');
        var [firstName, ...lastName] = fullName.split(' ');
        lastName = lastName.join(' ');
        var eventData = {
          email,
          fullName,
          zipCode,
          subject,
          message
        };
        console.log('Pushing Klaviyo tracking event...', eventData);

        try {
          // We need identify before any track event
          yield window.klaviyo.identify({
            email,
            first_name: firstName,
            last_name: lastName,
            zip: zipCode
          });
          console.log('Identified Klaviyo profile, pushing event...'); // Push new metric event for Contact Form Submitted

          yield window.klaviyo.track('Contact Form Submitted', eventData);
          console.log('Pushed Klaviyo tracking event');
        } catch (err) {
          console.error('Failed to push Klaviyo tracking event', err);
        }
      })();
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/example/Example.vue?vue&type=script&lang=js&":
/*!****************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/example/Example.vue?vue&type=script&lang=js& ***!
  \****************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  data() {
    return {
      example: true
    };
  },

  mounted() {
    console.log('Example Vue single file component');
  }

});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=script&lang=js&":
/*!********************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=script&lang=js& ***!
  \********************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var modules_icons_IconShoppingBag_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/icons/IconShoppingBag.vue */ "./src/modules/icons/IconShoppingBag.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IconShoppingBag: modules_icons_IconShoppingBag_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
  },

  data() {
    return {
      state: lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"]
    };
  },

  computed: {
    itemCount() {
      var bundleIds = new Set();
      return (this.state.cart.items || []).reduce((count, item) => {
        if (item.properties && item.properties._bundle_id) {
          if (!bundleIds.has(item.properties._bundle_id)) {
            bundleIds.add(item.properties._bundle_id);
            count += 1;
          }
        } else {
          count += Number(item.quantity);
        }

        return count;
      }, 0);
    }

  },
  methods: {
    toggleMiniCart() {
      this.state.isMiniCartOpen = !this.state.isMiniCartOpen;
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=script&lang=js&":
/*!************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=script&lang=js& ***!
  \************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/video-embed/VideoEmbed.vue */ "./src/modules/video-embed/VideoEmbed.vue");
/* harmony import */ var modules_modal_Modal_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/modal/Modal.vue */ "./src/modules/modal/Modal.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__["default"],
    VideoEmbed: modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
    Modal: modules_modal_Modal_vue__WEBPACK_IMPORTED_MODULE_2__["default"]
  },
  props: {
    image: {
      type: String,
      default: ''
    },
    video: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      isShowModal: false
    };
  },

  methods: {
    openModal() {
      if (!this.video.id) return;
      this.isShowModal = true;
      var video = this.$el.querySelector('iframe');
      if (video) video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":"", "method":"play"}', '*');
    },

    stopAllVideo() {
      var video = this.$el.querySelector('iframe');
      if (video) video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":"", "method":"pause"}', '*');
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/modal/Modal.vue?vue&type=script&lang=js&":
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/modal/Modal.vue?vue&type=script&lang=js& ***!
  \************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var scroll_lock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! scroll-lock */ "./node_modules/scroll-lock/dist/scroll-lock.js");
/* harmony import */ var scroll_lock__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(scroll_lock__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: ''
    }
  },
  computed: {
    isModalOpen: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }

    }
  },
  watch: {
    isModalOpen: {
      immediate: true,

      handler(val) {
        if (val) {
          Object(scroll_lock__WEBPACK_IMPORTED_MODULE_0__["disablePageScroll"])();
          var modalWrapper = this.$refs.modalWrapper;

          if (modalWrapper) {
            this.focusEl = document.activeElement;
            modalWrapper.focus();
            Object(lib_util__WEBPACK_IMPORTED_MODULE_1__["trapFocus"])(modalWrapper);
          }
        } else {
          Object(scroll_lock__WEBPACK_IMPORTED_MODULE_0__["enablePageScroll"])();

          if (this.focusEl) {
            this.focusEl.focus();
          }
        }
      }

    }
  },
  methods: {
    close() {
      this.$emit('on-close');
      this.isModalOpen = false;
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/more/More.vue?vue&type=script&lang=js&":
/*!**********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/more/More.vue?vue&type=script&lang=js& ***!
  \**********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    excerpt: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      show: false
    };
  },

  mounted() {
    var viewMoreEl = this.$refs.viewMore;

    if (viewMoreEl) {
      var previousSibling = viewMoreEl.previousElementSibling.lastElementChild;
      previousSibling.appendChild(viewMoreEl);
    }
  },

  methods: {
    viewMore() {
      console.log('click');
      this.show = true;
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/newsletter-form/NewsletterForm.vue?vue&type=script&lang=js&":
/*!*******************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/newsletter-form/NewsletterForm.vue?vue&type=script&lang=js& ***!
  \*******************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! nanoajax */ "./node_modules/nanoajax/index.js");
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nanoajax__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var lib_countryDialsAndFlags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/countryDialsAndFlags */ "./src/assets/js/lib/countryDialsAndFlags.js");
/* harmony import */ var modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! modules/button/Button.vue */ "./src/modules/button/Button.vue");
/* harmony import */ var modules_text_input_TextInput_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/text-input/TextInput.vue */ "./src/modules/text-input/TextInput.vue");
/* harmony import */ var phone__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! phone */ "./node_modules/phone/dist/index.js");
/* harmony import */ var phone__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(phone__WEBPACK_IMPORTED_MODULE_6__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Button: modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_4__["default"],
    TextInput: modules_text_input_TextInput_vue__WEBPACK_IMPORTED_MODULE_5__["default"]
  },
  props: {
    provider: {
      type: String,
      default: ''
    },
    klaviyoUrl: {
      type: String,
      default: ''
    },
    klaviyoGroup: {
      type: String,
      default: ''
    },
    klaviyoSms: {
      type: String,
      default: ''
    },
    errorText: {
      type: String,
      default: ''
    },
    successText: {
      type: String,
      default: ''
    },
    successSubText: {
      type: String,
      default: ''
    },
    subscribedText: {
      type: String,
      default: ''
    },
    subscribedTextPhone: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    emailPlaceholder: {
      type: String,
      default: ''
    },
    emailLabel: {
      type: String,
      default: ''
    },
    emailAriaLabel: {
      type: String,
      default: ''
    },
    emailFloatingLabel: {
      type: Boolean,
      default: false
    },
    optionPlaceholder: {
      type: String,
      default: ''
    },
    optionName: {
      type: String,
      default: ''
    },
    optionLabel: {
      type: String,
      default: ''
    },
    optionAriaLabel: {
      type: String,
      default: ''
    },
    optionFloatingLabel: {
      type: Boolean,
      default: false
    },
    optionError: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    acceptOneOption: {
      type: Boolean,
      default: false
    },
    klaviyoErrorsOnFields: {
      type: Boolean,
      default: false
    },
    emailOnly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      callbackFnName: 'newsletterSuccess',
      query: _objectSpread({}, this.provider === 'klaviyo' && {
        g: this.klaviyoGroup
      }),
      response: false,
      hasError: false,
      isSuccess: false,
      selectedCountryCode: 'US'
    };
  },

  computed: {
    countryList() {
      return lib_countryDialsAndFlags__WEBPACK_IMPORTED_MODULE_3__["default"];
    },

    responseText() {
      return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["decode"])(this.response);
    },

    isKlaviyoEmailError() {
      return this.responseText.includes('Email');
    },

    isKlaviyoPhoneError() {
      return this.responseText.includes('Phone');
    },

    emailErrorText() {
      if (this.isKlaviyoEmailError) return this.responseText;
      return 'Please enter a valid email address';
    },

    phoneErrorText() {
      if (this.isKlaviyoPhoneError) return this.responseText;
      return this.optionError || 'Please enter a valid phone number';
    },

    selectedCountry() {
      return this.countryList.find(c => c.code === this.selectedCountryCode);
    }

  },
  methods: {
    onInputChange({
      name,
      value
    }) {
      this.query[name] = value;

      if (name === 'phone_number') {
        var formattedPhoneObj = Object(phone__WEBPACK_IMPORTED_MODULE_6__["phone"])(value, {
          country: this.selectedCountryCode
        });
        this.query[name] = formattedPhoneObj.phoneNumber;
      }
    },

    submit(e) {
      e.preventDefault();
      var isValid = this.$children.filter(c => typeof c.validate !== 'undefined').map(c => c.validate()).every(res => res);

      if (!isValid) {
        this.response = '';
        this.hasError = true;
        return;
      }

      var queryParams = this.emailOnly ? _objectSpread(_objectSpread({}, this.query), {}, {
        $fields: '$source,$consent,email'
      }) : _objectSpread(_objectSpread({}, this.query), {}, {
        $fields: '$source,$consent,email,phone_number,sms_consent',
        sms_consent: true,
        $consent: ['sms']
      });
      var query = new URLSearchParams(queryParams).toString();
      nanoajax__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache'
        },
        body: query,
        url: this.klaviyoUrl,
        action: 'POST'
      }, this.klaviyoResponseHandler);
    },

    klaviyoResponseHandler(status, data) {
      if (Number(status) !== 200) {
        this.response = this.errorText;
        this.hasError = true;
        return;
      }

      var parsed = JSON.parse(data);

      if (parsed && parsed.success) {
        this.hasError = false;
        this.response = parsed.data.is_subscribed ? this.getSubscribedText() : this.successText;
        this.isSuccess = !parsed.data.is_subscribed;

        if (this.isSuccess) {
          this.$emit('success', true);
          Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["trigger"])('newsletterSuccess', document);
        } else if (this.klaviyoErrorsOnFields) {
          this.pushKlaviyoErrorsToFields();
        }

        this.sendToKlaviyoSMS();
      } else {
        this.hasError = true;
        this.response = this.errorText;
      }
    },

    sendToKlaviyoSMS() {
      if (this.optionName === 'phone_number' && this.klaviyoSms && Object.prototype.hasOwnProperty.call(this.query, this.optionName)) {
        var queryString = Object.keys(this.query).map(k => {
          var value = k === 'g' ? this.klaviyoSms : this.query[k];
          return "".concat(k, "=").concat(value);
        }).join('&');
        nanoajax__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
          body: queryString,
          url: this.klaviyoUrl,
          action: 'POST'
        }, (status, data) => {
          if (Number(status) !== 200) {
            console.log('Error', status);
            return;
          }
        });
      }
    },

    isValidEmail({
      value
    }) {
      return /\S+@\S+\.\S+/.test(value);
    },

    isValidOption({
      value
    }) {
      if (this.acceptOneOption && this.query.email.length > 0 && !value.length) return true;
      if (this.optionName === 'phone_number') return /(\(?\d{3}\)?-? *\d{3}-? *-?\d{4})/.test(value);
      if (this.optionName === 'zipcode') return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
    },

    getSubscribedText() {
      if (this.query.phone_number && this.query.email.length < 1 && this.subscribedTextPhone) {
        return this.subscribedText.replace(this.subscribedText, this.subscribedTextPhone);
      }

      return this.subscribedText;
    },

    pushKlaviyoErrorsToFields() {
      if (this.isKlaviyoEmailError) this.$refs.inputEmail.isValid = false;
      if (this.isKlaviyoPhoneError) this.$refs.inputPhone.isValid = false;
    },

    getCountryText(country) {
      if (!country) return '';
      var {
        name,
        dial_code,
        flag
      } = country;
      return "".concat(flag, " ").concat(name, " (").concat(dial_code, ")");
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/pagination/Pagination.vue?vue&type=script&lang=js&":
/*!**********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/pagination/Pagination.vue?vue&type=script&lang=js& ***!
  \**********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/range */ "./node_modules/lodash/range.js");
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_0__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    currentPage: {
      type: Number,
      default: 1,
      required: true
    },
    totalCount: {
      type: Number,
      default: 0,
      required: true
    },
    perPage: {
      type: Number,
      default: 1,
      required: true
    },
    limit: {
      type: Number,
      default: 4
    }
  },
  computed: {
    totalPage() {
      return Math.floor(this.totalCount / this.perPage) + (this.totalCount % this.perPage > 0 ? 1 : 0);
    },

    isShowPrev() {
      return this.currentPage > 1;
    },

    isShowNext() {
      return this.totalPage > 1 && this.currentPage < this.totalPage;
    },

    /**
     * Array number of page value
     * @returns {*}
     */
    pages() {
      var pageLists = [];
      var arrayRangePage = lodash_range__WEBPACK_IMPORTED_MODULE_0___default()(1, this.totalPage + 1);

      if (this.totalPage <= this.limit || this.limit === 0) {
        pageLists = arrayRangePage;
      } else {
        if (this.currentPage < this.limit) {
          pageLists = [...lodash_range__WEBPACK_IMPORTED_MODULE_0___default()(1, this.limit + 1)];
        } else if (this.currentPage === this.limit && this.limit + 1 < this.totalPage) {
          pageLists = [...lodash_range__WEBPACK_IMPORTED_MODULE_0___default()(1, this.limit + 2)];
        } else if (this.currentPage > this.totalPage - this.limit) {
          pageLists = [...lodash_range__WEBPACK_IMPORTED_MODULE_0___default()(this.totalPage - this.limit, this.totalPage + 1)];
        } else {
          var numberBefore = this.limit % 2 === 0 ? this.limit / 2 : Math.floor(this.limit / 2);
          var numberAfter = this.limit % 2 === 0 ? this.limit / 2 - 1 : Math.floor(this.limit / 2);
          var pageBefore = this.currentPage - numberBefore;
          var pageAfter = this.currentPage + numberAfter + 1;
          pageLists = [...lodash_range__WEBPACK_IMPORTED_MODULE_0___default()(pageBefore, pageAfter)];
        }
      }

      return pageLists;
    }

  },
  methods: {
    // @eventHandler
    handleClickPage(page) {
      this.$emit('change', page);
    },

    // @eventHandler
    handleClickPrev() {
      var prev = this.currentPage - 1;
      prev > 0 ? this.$emit('change', prev) : this.$emit('change', 1);
    },

    // @eventHandler
    handleClickNext() {
      var next = this.currentPage + 1;
      next <= this.totalPage ? this.$emit('change', next) : this.$emit('change', this.totalPage);
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/picture/Picture.vue?vue&type=script&lang=js&":
/*!****************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/picture/Picture.vue?vue&type=script&lang=js& ***!
  \****************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! object-fit-images */ "./node_modules/object-fit-images/dist/ofi.common-js.js");
/* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(object_fit_images__WEBPACK_IMPORTED_MODULE_1__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    sources: {
      type: [String, Array],
      default: () => {
        return [];
      }
    },
    sourceBreakpoints: {
      type: Array,
      default: () => {
        return ['(max-width: 639px)', '(max-width: 1023px)', '(max-width: 1439px)']; // Aligns with css breakpoints
      }
    },
    sizes: {
      type: Array,
      default: () => {
        return ['100vw'];
      }
    },
    sizeBreakpoints: {
      type: Array,
      default: () => {
        return ['(max-width: 639px)', '(max-width: 1023px)', '(max-width: 1439px)']; // Aligns with css breakpoints
      }
    },
    widths: {
      type: Array,
      default: () => {
        return [3200, 2880, 2560, 1600, 1440, 1280, 1024, 890, 640, 445, 320, 160];
      }
    },
    alt: {
      type: String,
      default: ''
    },
    objectFit: {
      type: String,
      default: 'cover'
    },
    loader: {
      type: Boolean,
      default: false
    },
    fadeIn: {
      type: Boolean,
      default: true
    },
    isLazy: {
      type: Boolean,
      default: false
    },
    explicitWidth: {
      type: Number,
      default: 0
    },
    explicitHeight: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      isLoaded: false,
      sourceEls: null
    };
  },

  computed: {
    imgEl() {
      return this.$refs.img.length ? this.$refs.img[0] : this.$refs.img;
    },

    sourcesArr() {
      return Array.isArray(this.sources) ? this.sources : [this.sources];
    },

    sourcesArrFiltered() {
      // Filter out undefined or empty sources
      return this.sourcesArr.filter(source => source && source.length);
    },

    sourcesSplit() {
      return this.sourcesArrFiltered.map(source => {
        var arr = source.split(/\.(jpg|jpeg|png|gif|svg)/g);
        return {
          source,
          originalPath: arr[0],
          masterPath: arr[0].replace(/_[0-9]*x$/g, ''),
          // masterPath strips out size info from img_url
          ext: arr[1],
          query: arr[2]
        };
      });
    },

    sourcesResized() {
      return this.sourcesSplit.map(sourceSplit => {
        if (sourceSplit.ext === 'svg') {
          // Return original source
          return [{
            widthSrc: sourceSplit.source,
            width: ''
          }];
        } else if (sourceSplit.source.includes('images.prismic.io')) {
          return this.widths.map(width => ({
            widthSrc: this.getPrismicWidthSrc(sourceSplit, width),
            width: " ".concat(width, "w")
          }));
        } else if (sourceSplit.masterPath.includes('cdn.shopify.com')) {
          return this.widths.map(width => ({
            widthSrc: this.getShopifyWidthSrc(sourceSplit, width),
            width: " ".concat(width, "w")
          }));
        } else if (sourceSplit.masterPath.includes('cdn.accentuate.io')) {
          return this.widths.map(width => ({
            widthSrc: this.getAccentuateWidthSrc(sourceSplit, width),
            width: " ".concat(width, "w")
          }));
        } else {
          // Return original source
          return [{
            widthSrc: sourceSplit.source,
            width: ''
          }];
        }
      });
    },

    srcsets() {
      return this.sourcesResized.map(sourceResized => {
        return sourceResized.reduce((srcset, width) => {
          return srcset + width.widthSrc + "".concat(width.width, ", ");
        }, '').slice(0, -2);
      });
    },

    sourceBreakpointsArr() {
      if (this.sourcesArrFiltered.length === 1) {
        // No breakpoints required if there is only one source
        return [];
      } else {
        // Return breakpoints for sources except for last source so that it bubbles up through remaining breakpoints
        return this.sourceBreakpoints.slice(0, this.sourcesArrFiltered.length - 1);
      }
    },

    sizesStr() {
      // Builds sizes value from mobile up, last value in this.sizes is the default
      return this.sizes.reduce((sizeStr, size, i) => {
        if (this.sizes.length === 1) {
          return sizeStr;
        } else if (this.sizeBreakpoints[i]) {
          return sizeStr + "".concat(this.sizeBreakpoints[i], " ").concat(size, ", ");
        } else {
          return sizeStr;
        }
      }, '') + this.sizes[this.sizes.length - 1];
    }

  },
  watch: {
    sources() {
      this.$nextTick(() => {
        this.init(this, this.imgEl, this.sourceEls);
      });
    }

  },

  mounted() {
    this.sourceEls = this.$refs.source;
    this.init(this, this.imgEl, this.sourceEls);
  },

  methods: {
    getPrismicWidthSrc(sourceSplit, width) {
      return sourceSplit.source.replace(/&w=.+/g, '').concat("&w=".concat(width));
    },

    getShopifyWidthSrc(sourceSplit, width) {
      var {
        masterPath,
        ext,
        query
      } = sourceSplit;
      return "".concat(masterPath, "_").concat(width, "x.").concat(ext + query);
    },

    getAccentuateWidthSrc(sourceSplit, width) {
      return "//images.accentuate.io?c_options=w_".concat(width, "&image=").concat(sourceSplit.originalPath, ".").concat(sourceSplit.ext).concat(sourceSplit.query);
    },

    init(component, imgEl, sourceEls) {
      // Init imageObserver as a global variable
      if (!window.imageObserver) this.initImageObserver();
      this.observeNewImage(imgEl);
      dom_event__WEBPACK_IMPORTED_MODULE_0___default()(imgEl, 'load', () => {
        component.isLoaded = true;
        object_fit_images__WEBPACK_IMPORTED_MODULE_1___default()(imgEl);
      });
    },

    loadSrc(el) {
      var dataSrc = el.getAttribute('data-src');

      if (dataSrc) {
        el.setAttribute('src', dataSrc);
        el.removeAttribute('data-src');
      }
    },

    loadSrcsets(els) {
      els.forEach(el => {
        var dataSrcset = el.getAttribute('data-srcset');

        if (dataSrcset) {
          el.setAttribute('srcset', dataSrcset);
          el.removeAttribute('data-srcset');
        }
      });
    },

    initImageObserver() {
      var config = {
        threshold: 0
      };
      window.imageObserver = new IntersectionObserver((entries, self) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target.hasAttribute('data-src')) this.loadSrc(entry.target, true);
            var sourceEls = entry.target.parentElement.querySelectorAll('source');
            if (sourceEls) this.loadSrcsets(sourceEls, true); // Observer has been passed as self to our callback

            self.unobserve(entry.target);
          }
        });
      }, config);
    },

    observeNewImage(el) {
      window.imageObserver.observe(el);
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/pre-order-note/PreOrderNote.vue?vue&type=script&lang=js&":
/*!****************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/pre-order-note/PreOrderNote.vue?vue&type=script&lang=js& ***!
  \****************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-bundle/ProductBundle.vue?vue&type=script&lang=js&":
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-bundle/ProductBundle.vue?vue&type=script&lang=js& ***!
  \*****************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductBundle',
  props: {
    bundleGroup: {
      type: Array,
      default: () => []
    },
    soldOutText: {
      type: String,
      default: 'Sold Out'
    },
    newTagText: {
      type: String,
      default: 'New'
    }
  },
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
  },

  data() {
    return {
      selectedByGroup: {}
    };
  },

  computed: {
    activeGroups() {
      return this.bundleGroup.filter(group => group.products && group.products.length > 0);
    },

    hasBundle() {
      var _this$bundleGroup;

      return ((_this$bundleGroup = this.bundleGroup) === null || _this$bundleGroup === void 0 ? void 0 : _this$bundleGroup.length) > 0;
    },

    selectedItems() {
      return this.bundleGroup.map(group => {
        var product = group.products.find(item => item.id === this.selectedByGroup[group.group_id]);
        if (!product) return null;
        return _objectSpread(_objectSpread({}, product), {}, {
          bundleGroupTitle: group.title,
          bundleGroupId: group.group_id
        });
      }).filter(Boolean);
    },

    isBundleComplete() {
      return this.activeGroups.every(group => this.selectedByGroup[group.group_id]);
    }

  },
  methods: {
    handleClick(group, item) {
      if (!item.available) return;
      this.$set(this.selectedByGroup, group.group_id, item.id);

      if (this.isBundleComplete) {
        this.$emit('update-bundle-complete', this.selectedItems);
      }
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-card/ProductCard.vue?vue&type=script&lang=js&":
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-card/ProductCard.vue?vue&type=script&lang=js& ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/video-embed/VideoEmbed.vue */ "./src/modules/video-embed/VideoEmbed.vue");
/* harmony import */ var modules_video_Video_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/video/Video.vue */ "./src/modules/video/Video.vue");
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var lib_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lib/cart */ "./src/assets/js/lib/cart.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
    'v-video': modules_video_Video_vue__WEBPACK_IMPORTED_MODULE_3__["default"],
    'video-embed': modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_2__["default"]
  },
  props: {
    position: {
      type: Number,
      default: 0
    },
    product: {
      type: Object,
      default: {}
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    list: {
      type: String,
      default: ''
    },
    showAddToCart: {
      type: Boolean,
      default: false
    },
    showShortDescription: {
      type: Boolean,
      default: false
    },
    hoverImage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    productImage() {
      return this.product.media.length > 0 ? this.product.media[0] : null;
    },

    productImageSecond() {
      return this.product.media.length > 1 ? this.product.media[1] : null;
    },

    activeVariant() {
      return this.product.firstAvailableVariant;
    },

    price() {
      if (this.activeVariant) {
        return Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["formatMoney"])(this.activeVariant.price);
      }

      return Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["formatMoney"])(this.product.price);
    },

    hasVariant() {
      return this.activeVariant && Object.keys(this.activeVariant).length;
    },

    cantAddTocart() {
      return !this.hasVariant || !this.activeVariant || !this.activeVariant.available;
    },

    isPreOrder() {
      return this.activeVariant.inventoryQuantity <= 0 && this.activeVariant.available;
    },

    productTags() {
      if (Array.isArray(this.product.tags)) return this.product.tags;

      if (typeof this.product.tags === 'string') {
        return this.product.tags.split(',').map(tag => tag.trim()).filter(Boolean);
      }

      return [];
    },

    isDeliveryOnlyProduct() {
      return this.productTags.includes('Delivery Only');
    },

    videoThresholdGroupd() {
      return "video-product-card-".concat(this.product.id);
    }

  },
  methods: {
    handleClick() {
      Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["trigger"])('productClick', document, {
        product: this.product,
        list: this.list,
        position: this.position
      });
    },

    addToCart() {
      var options = {
        id: this.activeVariant.id,
        quantity: 1,
        properties: {
          _zipcode: localStorage.getItem('zipcode'),
          _inventory_quantity: this.activeVariant.inventoryQuantity,
          _is_pre_order: this.isPreOrder,
          _delivery_only: this.isDeliveryOnlyProduct ? 'true' : 'false'
        }
      };
      lib_cart__WEBPACK_IMPORTED_MODULE_5__["default"].add([options]).then(code => {
        if (code.status === 422) {
          this.error = code.description;
          return;
        }

        lib_cart__WEBPACK_IMPORTED_MODULE_5__["default"].get().then(data => {
          lib_appState__WEBPACK_IMPORTED_MODULE_4__["default"].cart = data;
          lib_appState__WEBPACK_IMPORTED_MODULE_4__["default"].isMiniCartOpen = true;
          localStorage.removeItem('zipcode');
        });
      });
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-form/ProductForm.vue?vue&type=script&lang=js&":
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-form/ProductForm.vue?vue&type=script&lang=js& ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var lib_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/cart */ "./src/assets/js/lib/cart.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    addToCartText: {
      type: String,
      default: ''
    },
    soldOutText: {
      type: String,
      default: ''
    },
    unavailableText: {
      type: String,
      default: ''
    },
    isGiftCard: {
      type: Boolean,
      default: false
    },
    isMerch: {
      type: Boolean,
      default: false
    }
  },

  data() {
    var product = window.BARREL.product;
    return {
      state: lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"],
      product,
      min: 1,
      error: '',
      selectedStore: '',
      showDelivery: false,
      enableDatePickStore: false,
      isShowModal: false
    };
  },

  watch: {
    'state.selectedOptions': {
      handler() {
        this.storeDataSelected();
        this.pickActiveVariant();
      },

      deep: true
    }
  },
  computed: {
    cantAddTocart() {
      return !this.hasVariant || !this.activeVariant.available;
    },

    firstAvailableVariant() {
      return this.product.firstAvailableVariant;
    },

    formattedPrice() {
      if (this.activeVariantPrice) {
        return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["formatMoney"])(this.activeVariantPrice, '${{amount_no_decimals}}');
      } else {
        if (this.product.firstAvailableVariant !== null) {
          return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["formatMoney"])(this.product.firstAvailableVariant.price, '${{amount_no_decimals}}');
        } else {
          return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["formatMoney"])(0, '${{amount_no_decimals}}');
        }
      }
    },

    formattedPriceCompareAt() {
      return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["formatMoney"])(this.activeVariant.compareAtPrice, '${{amount_no_decimals}}');
    },

    hasVariant() {
      console.log(Object.keys(this.activeVariant).length);
      return Object.keys(this.activeVariant).length;
    },

    activeVariantPrice() {
      return this.activeVariant.discount_variant_price || this.activeVariant.price;
    },

    activeVariant() {
      return this.state.activeVariant;
    },

    submitButtonText() {
      if (!this.hasVariant) {
        return this.unavailableText;
      }

      return this.activeVariant.available ? this.addToCartText : this.soldOutText;
    },

    data() {
      return JSON.parse(this.product.data);
    },

    generateOptionArray() {
      var obj = {};
      this.product.options.forEach(item => {
        obj[item] = this.product[item].map(label => ({
          label: Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["getDateLabel"])(label),
          value: label
        }));
      });
      return obj;
    },

    generateOptionStore() {
      var nameStorePosition = this.getOptionNamePosition('Store');

      if (nameStorePosition) {
        var stores = this.product['variants'].map(item => item[nameStorePosition]);
        return [...new Set(stores)].map(label => ({
          label: label,
          value: label
        }));
      }
    },

    generateOptionDate() {
      var list = [{
        label: 'No Data',
        value: 'No Date Can Selected'
      }];

      if (lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].selectedOptions && lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].selectedOptions['Store']) {
        var store = lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].selectedOptions['Store'];
        var nameStorePosition = this.getOptionNamePosition('Store');
        var nameDatePosition = this.getOptionNamePosition('Date');
        var dates = this.product['variants'].filter(variant => variant['available'] && variant[nameStorePosition] === store).map(item => item[nameDatePosition]);
        var dataDates = dates.map(label => ({
          label: Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["getDateLabel"])(label),
          value: label
        }));

        if (dataDates.length > 0) {
          list = dataDates;
        }
      }

      return list;
    },

    deliveryNote() {
      return this.data ? this.data.locationDeliveryNote : '';
    },

    locationZips() {
      return this.data ? this.data.locationZips : '';
    },

    noteTitle() {
      return this.selectedStore ? this.selectedStore.storeName : '';
    },

    noteText() {
      return this.selectedStore ? this.selectedStore.storeAddress + '<br>' + 'Pick Up hours: ' + this.selectedStore.storePickupHouse : '';
    },

    productMethod() {
      return !this.isGiftCard ? this.product.productVendor.split(' - ')[1] : '';
    },

    showPopupMessage() {
      if (!lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].cart) return false; // Show popup message when user try to add both a Delivery and a Pre-Order product to cart

      var hasLegacyVendorConflict = this.productMethod ? lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].cart.items.findIndex(item => !item.vendor.includes(this.productMethod)) > -1 : false;
      return hasLegacyVendorConflict;
    },

    selectedOptions() {
      return this.state.selectedOptions;
    },

    isPriceCompareAt() {
      return this.activeVariant.compareAtPrice > this.activeVariantPrice;
    },

    isPreOrder() {
      return this.activeVariant.inventoryQuantity <= 0 && this.activeVariant.available;
    },

    productTags() {
      if (Array.isArray(this.product.tags)) return this.product.tags;

      if (typeof this.product.tags === 'string') {
        return this.product.tags.split(',').map(tag => tag.trim()).filter(Boolean);
      }

      return [];
    },

    isDeliveryOnlyProduct() {
      return this.productTags.includes('Delivery Only');
    }

  },
  methods: {
    closeMessageModal() {
      this.isShowModal = false;
    },

    pickActiveVariant() {
      var {
        variants = [],
        options = []
      } = this.product;

      var _loop = function (i) {
        var variant = variants[i];
        var isMatch = options.every((option, _i) => {
          return variant["option".concat(_i + 1)] === lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].selectedOptions[option];
        });

        if (isMatch) {
          lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].activeVariant = variant;
          return "break";
        } else {
          lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].activeVariant = {};
        }
      };

      for (var i = 0; i < variants.length; i++) {
        var _ret = _loop(i);

        if (_ret === "break") break;
      }
    },

    updateSelectedOption(name, value) {
      lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].selectedOptions[name] = value;
      this.error = '';
    },

    onSelectChange({
      name,
      value
    }) {
      this.updateSelectedOption(name, value);
    },

    onSelectChangeStore({
      name,
      value
    }) {
      this.enableDatePickStore = !!value;
      this.updateSelectedOption(name, value);
    },

    checkZipCode(value) {
      this.showDelivery = value;
    },

    getOptionNamePosition(optionName) {
      var optionStore = this.product['optionsWithValues'].find(option => option.name === optionName);
      return optionStore ? 'option' + optionStore.position : '';
    },

    escapeHtml(unsafe) {
      return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    },

    storeDataSelected() {
      var stores = this.data['stores'];
      this.selectedStore = stores.find(store => store['storeName'] === this.escapeHtml(lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].selectedOptions['Store']));
    },

    addToCart() {
      if (this.showPopupMessage) {
        this.isShowModal = true;
        return null;
      }

      var options = {
        id: this.activeVariant.id,
        quantity: this.quantity,
        properties: {
          _zipcode: !this.isGiftCard ? localStorage.getItem('zipcode') : '',
          _method: !this.isMerch ? this.productMethod : '',
          _inventory_quantity: this.activeVariant.inventoryQuantity,
          _is_pre_order: this.isPreOrder,
          _delivery_only: this.isDeliveryOnlyProduct ? 'true' : 'false'
        }
      };
      lib_cart__WEBPACK_IMPORTED_MODULE_1__["default"].add([options]).then(code => {
        if (code.status === 422) {
          this.error = code.description;
          return;
        }

        lib_cart__WEBPACK_IMPORTED_MODULE_1__["default"].get().then(data => {
          lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].cart = data;
          lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].isMiniCartOpen = true;
          localStorage.removeItem('zipcode');
        });
      });
    },

    setLabel(value) {
      if (value === 'S') {
        return 'Small';
      }

      if (value === 'M') {
        return 'Medium';
      }

      if (value === 'L') {
        return 'Large';
      }

      if (value === 'XL') {
        return 'Extra Large';
      }
    }

  },

  mounted() {
    var options = this.product.options_with_values.reduce((obj, option) => {
      obj[option.name] = this.isGiftCard || this.isMerch ? option.values[0] : '';
      return obj;
    }, {});
    lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"].selectedOptions = options;
  }

});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-main-header/ProductMainHeader.vue?vue&type=script&lang=js&":
/*!**************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-main-header/ProductMainHeader.vue?vue&type=script&lang=js& ***!
  \**************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formattedPrice: {
      type: String,
      default: ''
    },
    formattedPriceCompareAt: {
      type: String,
      default: ''
    },
    activeVariant: {
      type: Object,

      default() {
        return {};
      }

    },
    isPriceCompareAt: {
      type: Boolean,
      default: false
    },
    isPreOrder: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-note/ProductNote.vue?vue&type=script&lang=js&":
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-note/ProductNote.vue?vue&type=script&lang=js& ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-zip/ProductZip.vue?vue&type=script&lang=js&":
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-zip/ProductZip.vue?vue&type=script&lang=js& ***!
  \***********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_text_input_TextInput_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/text-input/TextInput.vue */ "./src/modules/text-input/TextInput.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TextInput: modules_text_input_TextInput_vue__WEBPACK_IMPORTED_MODULE_0__["default"]
  },
  props: {
    locationZips: Array,
    errorHtml: String
  },

  data() {
    return {
      nameValue: '',
      initialValue: '',
      error: false,
      zips: ''
    };
  },

  created() {
    var currentZip = localStorage.getItem('zipcode');
    var zips = this.locationZips.map(item => item.replace('\n', ''));

    if (zips) {
      this.zips = zips;
    }

    if (currentZip) {
      if (this.zips.includes(currentZip.toString())) {
        this.$emit('change', true);
        this.initialValue = currentZip;
      }
    }
  },

  methods: {
    onInputChange({
      name,
      value
    }) {
      this.error = false;
      this.nameValue = value;
    },

    handle() {
      this.checkZipCode();
    },

    checkZipCode() {
      if (this.zips.includes(this.nameValue.toString())) {
        localStorage.setItem('zipcode', this.nameValue);
        this.$emit('change', true);
      } else {
        localStorage.setItem('zipcode', '');
        this.$emit('change', false);
        this.error = true;
      }
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/quantity-selector/QuantitySelector.vue?vue&type=script&lang=js&":
/*!***********************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/quantity-selector/QuantitySelector.vue?vue&type=script&lang=js& ***!
  \***********************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    initial: {
      type: Number,
      default: NaN
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: NaN
    },
    disabled: {
      type: Boolean,
      default: false
    },
    updateValue: {
      type: Number,
      default: NaN
    }
  },

  data() {
    return {
      value: this.max > this.initial ? this.initial : this.max > 0 ? this.max : 1
    };
  },

  computed: {
    increasable() {
      return this.value < this.max || !this.max && this.max !== 0;
    },

    decreasable() {
      return this.value > this.min;
    }

  },
  watch: {
    updateValue(value) {
      if (typeof value === 'number' && value >= 0) this.value = value;
    },

    item: {
      deep: true,

      handler(val) {
        if (val && Object.prototype.hasOwnProperty.call(val, 'quantity') && typeof val.quantity === 'number' && val.quantity >= 0) this.value = val.quantity;
      }

    }
  },
  methods: {
    decrease() {
      this.setValue(--this.value);
    },

    increase() {
      this.setValue(++this.value);
    },

    onInputChange(event) {
      var value = parseInt(event.target.value);

      if (isNaN(value)) {
        return this.overrideInputValue(this.value);
      }

      this.setValue(value);
    },

    onEnter(event) {
      this.onInputChange(event);
      event.target.blur();
    },

    onBlur() {
      this.$emit('blur', this.value, this.item);
    },

    setValue(value) {
      var oldValue = this.value;
      var newValue = Math.max(this.min, value);
      this.value = this.max ? Math.min(this.max, newValue) : newValue;

      if (oldValue === this.value) {
        this.overrideInputValue(this.value);
      }

      this.$emit('change', this.value, this.item);
    },

    overrideInputValue(value) {
      this.$refs.input.value = value;
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-card/RecipeCard.vue?vue&type=script&lang=js&":
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/recipe-card/RecipeCard.vue?vue&type=script&lang=js& ***!
  \***********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/button/Button.vue */ "./src/modules/button/Button.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__["default"],
    'v-button': modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
  },
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: ''
    },
    largeImage: {
      type: [String, null],
      default: null
    },
    largeImageAlt: {
      type: [String, null],
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    excerpt: {
      type: String,
      default: ''
    },
    buttonUrl: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    externalLink: {
      type: String,
      default: ''
    },
    event: {
      type: Boolean,
      default: false
    },
    publishedAt: {
      type: String,
      default: ''
    },
    eventStartDate: {
      type: String,
      default: ''
    },
    eventDate: {
      type: String,
      default: ''
    },
    hasPopulateStartDate: {
      type: Boolean,
      default: false
    },
    hasPopulateEndDate: {
      type: Boolean,
      default: false
    },
    eventTag: {
      type: Array,
      default: null
    },
    excerptAcf: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    }
  },
  computed: {
    link() {
      return this.externalLink || this.buttonUrl;
    },

    imageSrc() {
      return this.largeImage || this.image;
    },

    imageAltText() {
      return this.largeImageAlt || this.imageAlt;
    },

    eventDateText() {
      if (!this.eventStartDate) return '';
      var eventDate = '';

      if (this.hasPopulateEndDate && this.eventDate) {
        eventDate = "".concat(this.eventStartDate, " - ").concat(this.eventDate);
      } else if (this.hasPopulateStartDate) {
        eventDate = "Available from ".concat(this.eventStartDate);
      }

      if (this.location) {
        var _eventDate;

        var eventDateText = (_eventDate = eventDate) !== null && _eventDate !== void 0 && _eventDate.length ? "".concat(eventDate, "  \u2022 ") : '';
        return "".concat(eventDateText).concat(this.location);
      }

      return eventDate;
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=script&lang=js&":
/*!******************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=script&lang=js& ***!
  \******************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_recipe_card_RecipeCard_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/recipe-card/RecipeCard.vue */ "./src/modules/recipe-card/RecipeCard.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RecipeCard: modules_recipe_card_RecipeCard_vue__WEBPACK_IMPORTED_MODULE_0__["default"]
  },
  props: {
    articles: {
      type: Array,
      default: []
    },
    event: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortedArticles() {
      return [...this.articles].sort((a, b) => {
        return new Date(b.eventStartDate) - new Date(a.eventStartDate);
      });
    },

    tabs() {
      return [{
        label: 'Current',
        value: 'current',
        articles: this.sortedArticles.filter(article => {
          return new Date(article.eventStartDate) >= new Date() || new Date(article.eventDate) >= new Date() || !article.hasPopulateEndDate && new Date(article.eventStartDate) <= new Date();
        })
      }, {
        label: 'Past',
        value: 'past',
        articles: this.sortedArticles.filter(article => {
          return article.hasPopulateEndDate && new Date(article.eventDate) < new Date();
        })
      }];
    }

  },

  data() {
    return {
      activeTab: 'current'
    };
  }

});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-grid/RecipeGrid.vue?vue&type=script&lang=js&":
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/recipe-grid/RecipeGrid.vue?vue&type=script&lang=js& ***!
  \***********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_recipe_card_RecipeCard_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/recipe-card/RecipeCard.vue */ "./src/modules/recipe-card/RecipeCard.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RecipeCard: modules_recipe_card_RecipeCard_vue__WEBPACK_IMPORTED_MODULE_0__["default"]
  },
  props: {
    articles: {
      type: Array,
      default: []
    },
    event: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortedArticles() {
      return [...this.articles].sort((a, b) => {
        return new Date(b.eventStartDate) - new Date(a.eventStartDate);
      });
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/select-input/SelectInput.vue?vue&type=script&lang=js&":
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/select-input/SelectInput.vue?vue&type=script&lang=js& ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    ariaLabelledBy: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    modifier: {
      type: String,
      default: 'default'
    },
    initialValue: {
      type: [String, Boolean],
      default: false
    },
    initialValueGetter: {
      type: [Function, Boolean],
      default: false
    },
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    nullOption: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: 'There was an error.'
    },
    required: Boolean,
    validateMethod: {
      type: [Function, Boolean],
      default: false
    },
    srOnly: Boolean,
    disabled: Boolean
  },

  data() {
    var data = {
      inputValue: '',
      inputOptions: [],
      isValid: true,
      isActive: false,
      isFocus: false,
      randomID: 'select-input-' + Math.floor(Math.random() * 1000)
    };

    if (this.initialValue) {
      data.inputValue = this.initialValue;
    } else if (this.initialValueGetter && this.initialValueGetter.bind !== 'undefined') {
      data.inputValue = this.initialValueGetter(this.name);
    }

    return data;
  },

  watch: {
    options: {
      immediate: true,

      handler(val, oldVal) {
        if (val && val.bind !== 'undefined') {
          var options = typeof val === 'function' ? val() : val;
          this.inputOptions = options.map(opt => {
            if (typeof opt !== 'undefined' && typeof opt.value === 'undefined') {
              return {
                value: opt,
                label: opt
              };
            }

            return opt;
          });
        }

        if (oldVal && oldVal.length && JSON.stringify(val) !== JSON.stringify(oldVal)) this.inputValue = '';
      }

    },

    initialValue(value) {
      this.inputValue = value;
    },

    inputValue(value) {
      this.$emit('change', {
        name: this.name,
        value
      });
      if (this.inputValue) this.setActive();
      if (this.isFocus) this.isFocus = false;
    },

    isValid(value) {
      if (!value) this.$refs.selectEl.focus();
    }

  },

  mounted() {
    this.$emit('change', {
      name: this.name,
      value: this.inputValue
    });
    if (this.inputValue) this.setActive();
    document.addEventListener('keyup', e => {
      // When close select by using Escape on keyboard
      if (e.key === 'Escape') {
        if (this.isFocus) this.isFocus = false;
      }
    });
  },

  methods: {
    validate() {
      if (this.validateMethod) {
        this.isValid = this.validateMethod({
          name: this.name,
          value: this.inputValue
        });
      } else if (this.required && (!('' + this.inputValue) || !this.inputValue)) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }

      return this.isValid;
    },

    setActive() {
      this.isActive = true;
    },

    unsetActive() {
      if (!this.inputValue) this.isActive = false;
      if (this.isFocus) this.isFocus = false;
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/social-links/SocialLinks.vue?vue&type=script&lang=js&":
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/social-links/SocialLinks.vue?vue&type=script&lang=js& ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_icons_IconTiktok_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/icons/IconTiktok.vue */ "./src/modules/icons/IconTiktok.vue");
/* harmony import */ var modules_icons_IconInstagram_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/icons/IconInstagram.vue */ "./src/modules/icons/IconInstagram.vue");
/* harmony import */ var modules_icons_IconFacebook_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/icons/IconFacebook.vue */ "./src/modules/icons/IconFacebook.vue");
/* harmony import */ var modules_icons_IconPinterest_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/icons/IconPinterest.vue */ "./src/modules/icons/IconPinterest.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IconTiktok: modules_icons_IconTiktok_vue__WEBPACK_IMPORTED_MODULE_0__["default"],
    IconInstagram: modules_icons_IconInstagram_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
    IconFacebook: modules_icons_IconFacebook_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
    IconPinterest: modules_icons_IconPinterest_vue__WEBPACK_IMPORTED_MODULE_3__["default"]
  },
  props: {
    css: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    urlTiktok: {
      type: String,
      default: ''
    },
    urlFacebook: {
      type: String,
      default: ''
    },
    urlInstagram: {
      type: String,
      default: ''
    },
    urlPinterest: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=script&lang=js&":
/*!************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=script&lang=js& ***!
  \************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DEFAULT_TABS = [{
  id: 'stockList',
  label: 'FIND IN STORE'
}, {
  id: 'onlineStores',
  label: 'FIND ONLINE'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StoreLocatorTabs',
  props: {
    encodedProps: {
      type: String,
      default: '{}'
    }
  },

  data() {
    var _parsedProps$onlineSt;

    var decodedProps = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["decode"])(this.encodedProps);
    var parsedProps = JSON.parse(decodedProps);
    return {
      DEFAULT_TABS,
      activeTab: 'stockList',
      onlineStores: (_parsedProps$onlineSt = parsedProps.onlineStores) !== null && _parsedProps$onlineSt !== void 0 ? _parsedProps$onlineSt : []
    };
  },

  watch: {
    activeTab(tab) {
      var index = DEFAULT_TABS.findIndex(t => t.id === tab);
      this.$refs.tabs[index].focus();
    }

  },

  mounted() {
    this.loadStockListScript();
  },

  methods: {
    setActiveTab(index) {
      this.activeTab = DEFAULT_TABS[index].id;
    },

    navigateToPreviousTab(index) {
      var previousIndex = index === 0 ? DEFAULT_TABS.length - 1 : index - 1;
      this.activeTab = DEFAULT_TABS[previousIndex].id;
    },

    navigateToNextTab(index) {
      var nextIndex = index === DEFAULT_TABS.length - 1 ? 0 : index + 1;
      this.activeTab = DEFAULT_TABS[nextIndex].id;
    },

    loadStockListScript() {
      var script = document.createElement('script');
      script.src = '//stockist.co/embed/v1/widget.min.js';
      script.async = true;
      document.body.appendChild(script);
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/testimonial-card/TestimonialCard.vue?vue&type=script&lang=js&":
/*!*********************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/testimonial-card/TestimonialCard.vue?vue&type=script&lang=js& ***!
  \*********************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_video_video_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/video/video.vue */ "./src/modules/video/video.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__["default"],
    'v-video': modules_video_video_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
  },
  props: {
    image: {
      type: String,
      default: ''
    },
    video: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    author: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: ''
    },
    thresholdGroup: {
      type: String,
      default: 'default'
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    stopVideo() {
      if (this.$refs.videoEl) this.$refs.videoEl.pauseVideo();
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/text-input/TextInput.vue?vue&type=script&lang=js&":
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/text-input/TextInput.vue?vue&type=script&lang=js& ***!
  \*********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_0__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    ariaLabelledBy: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    modifier: {
      type: String,
      default: 'default'
    },
    initialValue: {
      type: [String, Boolean],
      default: false
    },
    initialValueGetter: {
      type: [Function, Boolean],
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: '*There was an error.'
    },
    required: Boolean,
    validateMethod: {
      type: [Function, Boolean],
      default: false
    },
    srOnly: Boolean,
    floatingLabel: {
      type: Boolean,
      default: false
    }
  },

  data() {
    var data = {
      isValid: true,
      isActive: false,
      randomID: 'text-input-' + Math.floor(Math.random() * 1000)
    };

    if (this.initialValue) {
      data.inputValue = this.initialValue;
    } else if (this.initialValueGetter && this.initialValueGetter.bind !== 'undefined') {
      data.inputValue = this.initialValueGetter(this.name);
    } else {
      data.inputValue = '';
    }

    return data;
  },

  computed: {
    inputLabel() {
      if (this.floatingLabel && this.inputValue.length < 1 && !this.isActive) return this.placeholder;
      return this.label;
    }

  },
  watch: {
    inputValue(value) {
      this.$emit('change', {
        name: this.name,
        value
      });
    },

    isValid(value) {
      if (!value) this.$refs.inputEl.focus();
    }

  },

  mounted() {
    this.$emit('change', {
      name: this.name,
      value: this.inputValue
    });
    if (this.inputValue) this.setActive();

    if (this.$refs.inputEl.type === 'number') {
      dom_event__WEBPACK_IMPORTED_MODULE_0___default()(this.$refs.inputEl, 'wheel', () => {
        this.$refs.inputEl.blur();
      });
    }
  },

  methods: {
    onBlur(e) {
      this.validate();
      this.unsetActive();
    },

    validate() {
      if (this.validateMethod) {
        this.isValid = this.validateMethod({
          name: this.name,
          value: this.inputValue
        });
      } else this.isValid = !(this.required && !this.inputValue);

      return this.isValid;
    },

    setActive() {
      this.isActive = true;
    },

    unsetActive() {
      if (!this.inputValue) this.isActive = false;
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/tiktok-card/TiktokCard.vue?vue&type=script&lang=js&":
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/tiktok-card/TiktokCard.vue?vue&type=script&lang=js& ***!
  \***********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_video_video_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/video/video.vue */ "./src/modules/video/video.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__["default"],
    'v-video': modules_video_video_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
  },
  props: {
    image: {
      type: String,
      default: ''
    },
    video: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    stopVideo() {
      if (this.$refs.videoEl) this.$refs.videoEl.pauseVideo();
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/video-embed/VideoEmbed.vue?vue&type=script&lang=js&":
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/video-embed/VideoEmbed.vue?vue&type=script&lang=js& ***!
  \***********************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var lib_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/dom */ "./src/assets/js/lib/dom.js");
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoEmbed',
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_0__["default"]
  },
  props: {
    uid: {
      type: String,
      default: ''
    },
    youTubeVideoId: {
      type: String,
      default: ''
    },
    vimeoVideoUrl: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: ''
    },
    loader: {
      type: Boolean,
      default: false
    },
    fadeIn: {
      type: Boolean,
      default: true
    },
    stopVideo: {
      type: String,
      default: ''
    },
    allowInit: {
      type: Boolean,
      default: true
    },
    showControlButton: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isLoaded: false,
      hasPlayed: false
    };
  },

  watch: {
    stopVideo(value) {
      if (value) this.stopAllVideos();
    },

    allowInit(val) {
      if (val) this.init();
    }

  },

  mounted() {
    if (this.allowInit) this.init();
  },

  methods: {
    init() {
      var _this$youTubeVideoId, _this$vimeoVideoUrl;

      if ((_this$youTubeVideoId = this.youTubeVideoId) !== null && _this$youTubeVideoId !== void 0 && _this$youTubeVideoId.length) {
        this.youTubeInit();
      } else if ((_this$vimeoVideoUrl = this.vimeoVideoUrl) !== null && _this$vimeoVideoUrl !== void 0 && _this$vimeoVideoUrl.length) {
        this.vimeoInit();
      }
    },

    youTubeInit() {
      window.youTubePlayers = window.youTubePlayers || [];
      window.youTubePlayers.push({
        uid: this.uid,
        videoId: this.youTubeVideoId,
        showControlButton: this.showControlButton
      });

      var initPlayers = () => {
        window.youTubePlayers.forEach(item => {
          if (item.player || !item.uid) return;
          var player = new YT.Player(item.uid, {
            videoId: item.videoId,
            playerVars: {
              color: 'white',
              rel: 0
            }
          });
          item.player = player; // Play button trigger

          if (!item.showControlButton) return;
          var playTrigger = player.h.parentElement.querySelector('.js-video-embed-play');
          if (playTrigger) playTrigger.addEventListener('click', () => {
            player.playVideo();
            Object(lib_dom__WEBPACK_IMPORTED_MODULE_1__["addClass"])('video-embed--has-played', player.h.parentElement.parentElement);
          });
        });
      };

      if (window.YT && window.YT.Player) {
        initPlayers();
        return;
      }

      if (!document.getElementById('youtube-iframe-api')) {
        var tag = document.createElement('script');
        tag.id = 'youtube-iframe-api';
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }

      if (!window._ytReadyBound) {
        window._ytReadyBound = true;

        window.onYouTubeIframeAPIReady = () => {
          initPlayers();
        };
      }
    },

    vimeoInit() {
      // This code loads the Player SDK code asynchronously.
      if (!document.getElementById('vimeo-player-sdk')) {
        var firstScriptTag = document.getElementsByTagName('script')[0];
        var scriptTag = document.createElement('script');
        scriptTag.id = 'vimeo-player-sdk';
        scriptTag.src = 'https://player.vimeo.com/api/player.js';
        scriptTag.onload = this.createVimeoPlayer;
        firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
      }
    },

    createVimeoPlayer() {
      /* eslint-disable no-undef */
      var vimeoPlayer = new Vimeo.Player(this.uid, {
        url: this.vimeoVideoUrl
      });
      /* eslint-enable */

      this.addTrigger(this.$refs.playButton, 'click', vimeoPlayer, 'play', 'pause');
    },

    addTrigger(trigger, event, player, playMethod, pauseMethod) {
      if (!trigger) return;
      trigger.addEventListener('click', () => {
        player[playMethod]();
        this.hasPlayed = true;
      });
    },

    stopAllVideos() {
      var _this$youTubeVideoId2, _this$vimeoVideoUrl2;

      if ((_this$youTubeVideoId2 = this.youTubeVideoId) !== null && _this$youTubeVideoId2 !== void 0 && _this$youTubeVideoId2.length) {
        this.stopYoutube();
      } else if ((_this$vimeoVideoUrl2 = this.vimeoVideoUrl) !== null && _this$vimeoVideoUrl2 !== void 0 && _this$vimeoVideoUrl2.length) {
        this.stopVimeo();
      }
    },

    stopYoutube() {
      var _youtubeVideoObj$play;

      var youtubeVideoObj = window.youTubePlayers.find(p => p.uid === this.uid);
      if (youtubeVideoObj) (_youtubeVideoObj$play = youtubeVideoObj.player) === null || _youtubeVideoObj$play === void 0 ? void 0 : _youtubeVideoObj$play.stopVideo();
    },

    stopVimeo() {
      var iframeVideo = Object(select_dom__WEBPACK_IMPORTED_MODULE_2__["default"])('iframe', this.$el);
      if (!iframeVideo) return;
      iframeVideo.contentWindow.postMessage('{"method":"pause"}', "*");
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/video/Video.vue?vue&type=script&lang=js&":
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/video/Video.vue?vue&type=script&lang=js& ***!
  \************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_icons_IconMute_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/icons/IconMute.vue */ "./src/modules/icons/IconMute.vue");
/* harmony import */ var modules_icons_IconUnmute_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/icons/IconUnmute.vue */ "./src/modules/icons/IconUnmute.vue");
/* harmony import */ var modules_icons_IconPlay_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/icons/IconPlay.vue */ "./src/modules/icons/IconPlay.vue");
/* harmony import */ var modules_icons_IconPause_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/icons/IconPause.vue */ "./src/modules/icons/IconPause.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IconMute: modules_icons_IconMute_vue__WEBPACK_IMPORTED_MODULE_0__["default"],
    IconUnmute: modules_icons_IconUnmute_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
    IconPlay: modules_icons_IconPlay_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
    IconPause: modules_icons_IconPause_vue__WEBPACK_IMPORTED_MODULE_3__["default"]
  },
  props: {
    css: {
      type: String,
      default: ''
    },
    sources: {
      type: [String, Array],
      default: () => {
        return [];
      }
    },
    sourceBreakpoints: {
      type: Array,
      default: () => {
        return ['(max-width: 639px)', '(max-width: 1023px)', '(max-width: 1439px)']; // Aligns with css breakpoints
      }
    },
    poster: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    loop: {
      type: Boolean,
      default: true
    },
    muted: {
      type: Boolean,
      default: false
    },
    playsinline: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Boolean,
      default: false
    },
    threshold: {
      type: Number,
      default: 0
    },
    thresholdGroup: {
      type: String,
      default: 'default'
    },
    loader: {
      type: Boolean,
      default: false
    },
    fadeIn: {
      type: Boolean,
      default: true
    },
    muteControl: {
      type: Boolean,
      default: false
    },
    isForcedPlayLoaded: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hadAlreadyForcedPlay: false,
      isLoaded: false,
      isPlaying: false,
      internalMuted: this.muted
    };
  },

  computed: {
    videoEl() {
      return this.$refs.videoEl.length ? this.$refs.videoEl[0] : this.$refs.videoEl;
    },

    controlButton() {
      return this.$refs.controlButton.length ? this.$refs.controlButton[0] : this.$refs.controlButton;
    },

    sourcesArr() {
      return Array.isArray(this.sources) ? this.sources : [this.sources];
    },

    sourcesArrFiltered() {
      // Filter out undefined or empty sources
      return this.sourcesArr.filter(source => source && source.length);
    },

    sourceBreakpointsArr() {
      if (this.sourcesArrFiltered.length === 1) {
        // No breakpoints required if there is only one source
        return [];
      } else {
        // Return breakpoints for sources except for last source so that it bubbles up through remaining breakpoints
        return this.sourceBreakpoints.slice(0, this.sourcesArrFiltered.length - 1);
      }
    },

    shouldForcedPlay() {
      return this.isLoaded && this.isForcedPlayLoaded;
    }

  },
  watch: {
    shouldForcedPlay(value) {
      if (value && !this.hadAlreadyForcedPlay) {
        setTimeout(() => {
          this.videoEl.play();
          this.hadAlreadyForcedPlay = true;
        }, 500);
      }
    },

    muted(newValue) {
      this.internalMuted = newValue;
    }

  },

  mounted() {
    if (!window.videoObserver || !window.videoObserver[this.thresholdGroup]) this.initVideoObserver();
    this.observeNewVideo(this.videoEl, this.thresholdGroup);
  },

  methods: {
    initVideoObserver() {
      var config = {
        threshold: this.threshold
      };

      if (!window.videoObserver) {
        window.videoObserver = {};
      }

      window.videoObserver[this.thresholdGroup] = new IntersectionObserver((entries, self) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (this.videoEl.readyState === 0) {
              // Video element has no data
              this.loadVideo();
            } else if (this.videoEl.readyState >= 2) {
              // Data is available for the current playback position
              if (this.autoplay) this.playVideo();
            }
          } else if (this.videoEl.readyState >= 2) {
            if (this.autoplay) this.pauseVideo();
          }
        });
      }, config);
    },

    observeNewVideo() {
      window.videoObserver[this.thresholdGroup].observe(this.videoEl);
    },

    loadVideo() {
      this.$refs.source.forEach(source => {
        if (!source.dataset.src) return;
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      /*
       * For IOS15, the video is not rendered even metadata loaded
       * 500ms delay is a good choice after testing many times
       */

      setTimeout(() => {
        this.videoEl.load();
      }, 500);
      if (this.autoplay) this.playVideo(); // Video canPlay event sets this.isLoaded = true
    },

    playVideo() {
      this.videoEl.play();
      this.isPlaying = true;
    },

    pauseVideo() {
      this.videoEl.pause();
      this.isPlaying = false;
    },

    controlButtonClickHandler() {
      if (this.videoEl.paused) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    },

    muteButtonClickHandler() {
      if (this.videoEl.muted) {
        this.videoEl.muted = false;
        this.internalMuted = false;
      } else {
        this.videoEl.muted = true;
        this.internalMuted = true;
      }
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/video/video.vue?vue&type=script&lang=js&":
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/video/video.vue?vue&type=script&lang=js& ***!
  \************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var modules_icons_IconMute_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! modules/icons/IconMute.vue */ "./src/modules/icons/IconMute.vue");
/* harmony import */ var modules_icons_IconUnmute_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/icons/IconUnmute.vue */ "./src/modules/icons/IconUnmute.vue");
/* harmony import */ var modules_icons_IconPlay_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/icons/IconPlay.vue */ "./src/modules/icons/IconPlay.vue");
/* harmony import */ var modules_icons_IconPause_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/icons/IconPause.vue */ "./src/modules/icons/IconPause.vue");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    IconMute: modules_icons_IconMute_vue__WEBPACK_IMPORTED_MODULE_0__["default"],
    IconUnmute: modules_icons_IconUnmute_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
    IconPlay: modules_icons_IconPlay_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
    IconPause: modules_icons_IconPause_vue__WEBPACK_IMPORTED_MODULE_3__["default"]
  },
  props: {
    css: {
      type: String,
      default: ''
    },
    sources: {
      type: [String, Array],
      default: () => {
        return [];
      }
    },
    sourceBreakpoints: {
      type: Array,
      default: () => {
        return ['(max-width: 639px)', '(max-width: 1023px)', '(max-width: 1439px)']; // Aligns with css breakpoints
      }
    },
    poster: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    loop: {
      type: Boolean,
      default: true
    },
    muted: {
      type: Boolean,
      default: false
    },
    playsinline: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Boolean,
      default: false
    },
    threshold: {
      type: Number,
      default: 0
    },
    thresholdGroup: {
      type: String,
      default: 'default'
    },
    loader: {
      type: Boolean,
      default: false
    },
    fadeIn: {
      type: Boolean,
      default: true
    },
    muteControl: {
      type: Boolean,
      default: false
    },
    isForcedPlayLoaded: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hadAlreadyForcedPlay: false,
      isLoaded: false,
      isPlaying: false,
      internalMuted: this.muted
    };
  },

  computed: {
    videoEl() {
      return this.$refs.videoEl.length ? this.$refs.videoEl[0] : this.$refs.videoEl;
    },

    controlButton() {
      return this.$refs.controlButton.length ? this.$refs.controlButton[0] : this.$refs.controlButton;
    },

    sourcesArr() {
      return Array.isArray(this.sources) ? this.sources : [this.sources];
    },

    sourcesArrFiltered() {
      // Filter out undefined or empty sources
      return this.sourcesArr.filter(source => source && source.length);
    },

    sourceBreakpointsArr() {
      if (this.sourcesArrFiltered.length === 1) {
        // No breakpoints required if there is only one source
        return [];
      } else {
        // Return breakpoints for sources except for last source so that it bubbles up through remaining breakpoints
        return this.sourceBreakpoints.slice(0, this.sourcesArrFiltered.length - 1);
      }
    },

    shouldForcedPlay() {
      return this.isLoaded && this.isForcedPlayLoaded;
    }

  },
  watch: {
    shouldForcedPlay(value) {
      if (value && !this.hadAlreadyForcedPlay) {
        setTimeout(() => {
          this.videoEl.play();
          this.hadAlreadyForcedPlay = true;
        }, 500);
      }
    },

    muted(newValue) {
      this.internalMuted = newValue;
    }

  },

  mounted() {
    if (!window.videoObserver || !window.videoObserver[this.thresholdGroup]) this.initVideoObserver();
    this.observeNewVideo(this.videoEl, this.thresholdGroup);
  },

  methods: {
    initVideoObserver() {
      var config = {
        threshold: this.threshold
      };

      if (!window.videoObserver) {
        window.videoObserver = {};
      }

      window.videoObserver[this.thresholdGroup] = new IntersectionObserver((entries, self) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (this.videoEl.readyState === 0) {
              // Video element has no data
              this.loadVideo();
            } else if (this.videoEl.readyState >= 2) {
              // Data is available for the current playback position
              if (this.autoplay) this.playVideo();
            }
          } else if (this.videoEl.readyState >= 2) {
            if (this.autoplay) this.pauseVideo();
          }
        });
      }, config);
    },

    observeNewVideo() {
      window.videoObserver[this.thresholdGroup].observe(this.videoEl);
    },

    loadVideo() {
      this.$refs.source.forEach(source => {
        if (!source.dataset.src) return;
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      /*
       * For IOS15, the video is not rendered even metadata loaded
       * 500ms delay is a good choice after testing many times
       */

      setTimeout(() => {
        this.videoEl.load();
      }, 500);
      if (this.autoplay) this.playVideo(); // Video canPlay event sets this.isLoaded = true
    },

    playVideo() {
      this.videoEl.play();
      this.isPlaying = true;
    },

    pauseVideo() {
      this.videoEl.pause();
      this.isPlaying = false;
    },

    controlButtonClickHandler() {
      if (this.videoEl.paused) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    },

    muteButtonClickHandler() {
      if (this.videoEl.muted) {
        this.videoEl.muted = false;
        this.internalMuted = false;
      } else {
        this.videoEl.muted = true;
        this.internalMuted = true;
      }
    }

  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/zoomable-image/ZoomableImage.vue?vue&type=script&lang=js&":
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/zoomable-image/ZoomableImage.vue?vue&type=script&lang=js& ***!
  \*****************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue_zoom_on_hover__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue-zoom-on-hover */ "./node_modules/vue-zoom-on-hover/dist/index.js");
/* harmony import */ var vue_zoom_on_hover__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_zoom_on_hover__WEBPACK_IMPORTED_MODULE_1__);
//
//
//
//
//
//
//
//
//
//
//
//
//


vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(vue_zoom_on_hover__WEBPACK_IMPORTED_MODULE_1___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ZoomableImage',
  props: {
    srcNormal: {
      type: String,
      default: ''
    },
    srcZoom: {
      type: String,
      default: ''
    },
    isLazy: Boolean
  },
  methods: {
    loaded() {
      var mainComponent = this.$refs['main'];
      var imageEl = mainComponent.$refs['normal'];
      var zoomEl = mainComponent.$refs['zoom'];

      if (imageEl) {
        imageEl.setAttribute('loading', this.isLazy ? 'lazy' : 'eager');
      }

      if (zoomEl) {
        zoomEl.setAttribute('loading', 'lazy');
      }
    }

  }
});

/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/effect-fade/effect-fade.min.css":
/*!*******************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/effect-fade/effect-fade.min.css ***!
  \*******************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.i, ".swiper-fade.swiper-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/free-mode/free-mode.min.css":
/*!***************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/free-mode/free-mode.min.css ***!
  \***************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.i, ".swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/pagination/pagination.min.css":
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/pagination/pagination.min.css ***!
  \*****************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.i, ".swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:50%;background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-lock{display:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/swiper.min.css":
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/swiper.min.css ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.i, "/**\n * Swiper 7.4.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2021 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: December 24, 2021\n */\n\n@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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');font-weight:400;font-style:normal}\n\n:root{--swiper-theme-color:#007aff}\n\n.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}\n\n.swiper-vertical>.swiper-wrapper{flex-direction:column}\n\n.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}\n\n.swiper-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}\n\n.swiper-pointer-events{touch-action:pan-y}\n\n.swiper-pointer-events.swiper-vertical{touch-action:pan-x}\n\n.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}\n\n.swiper-slide-invisible-blank{visibility:hidden}\n\n.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}\n\n.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}\n\n.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}\n\n.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper{transform-style:preserve-3d}\n\n.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}\n\n.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}\n\n.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}\n\n.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}\n\n.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}\n\n.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}\n\n.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}\n\n.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}\n\n.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}\n\n.swiper-horizontal.swiper-css-mode>.swiper-wrapper{-webkit-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory}\n\n.swiper-vertical.swiper-css-mode>.swiper-wrapper{-webkit-scroll-snap-type:y mandatory;scroll-snap-type:y mandatory}\n\n.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}\n\n[dir=\"ltr\"] .swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-left:var(--swiper-centered-offset-before)}\n\n[dir=\"rtl\"] .swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-right:var(--swiper-centered-offset-before)}\n\n.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}\n\n.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-top:var(--swiper-centered-offset-before)}\n\n.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}\n\n.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./src/assets/css/main.css":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./src/assets/css/main.css ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.i, "/* stylelint-disable */\n\n/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n*/\n\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tfont-size: 100%;\n\tfont: inherit;\n\tvertical-align: baseline;\n}\n\n/* HTML5 display-role reset for older browsers */\n\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section {\n\tdisplay: block;\n}\n\nbody {\n\tline-height: 1;\n}\n\nol, ul {\n\tlist-style: none;\n}\n\nblockquote, q {\n\tquotes: none;\n}\n\nblockquote:before, blockquote:after,\nq:before, q:after {\n\tcontent: '';\n\tcontent: none;\n}\n\ntable {\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n}\n\n/* Additions */\n\n* {\n  box-sizing: border-box;\n}\n\nol,\nul {\n  list-style: none;\n}\n\ninput,\nselect,\nbutton {\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  color: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n  font-style: inherit;\n  font-size: inherit;\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n          appearance: none;\n}\n\n/* stylelint-disable */\n\n/* Breakpoint Queries */\n\n:root {\n  /* Widths */\n  --xxs: 320px;\n  --xs: 445px;\n  --s: 768px;\n  --m: 1024px;\n  --l: 1240px;\n  --xl: 1440px;\n  --xxl: 1600px;\n  --xxxl: 1920px;\n\n  --tablet: 640px;\n  --laptop: 1024px;\n  --desktop: 1440px;\n  --large-desktop: 1600px;\n\n  /* Section Margins */\n  --margin: 40px;\n  --margin-tablet: 40px;\n  --margin-laptop: 60px;\n  --margin-desktop: 80px;\n  --margin-large-desktop: 100px;\n  --margin-large-desktop-2: 120px;\n\n  /* Gutters */\n  --gutter: 20px;\n  --gutter-tablet: 30px;\n  --gutter-laptop: 40px;\n  --gutter-desktop: 50px;\n  --gutter-large-desktop: 60px;\n\n  /* Typography */\n  --serif: 'Tiempos Headline', serif;\n  --sans-serif: 'Founders Grotesk Text', sans-serif;\n\n  /* Colors */\n  --white: #ffffff;\n  --white-o-75: rgba(255, 255, 255, 0.75);\n  --white-o-50: rgba(255, 255, 255, 0.5);\n  --white-o-25: rgba(255, 255, 255, 0.25);\n  --grey: #333333;\n  --grey-25: #f2f2f2;\n  --grey-50: #fafafa;\n  --grey-100: #f5f5f5;\n  --grey-200: #eeeeee;\n  --grey-300: #828282;\n  --grey-320: #cccccc;\n  --grey-400: #bdbdbd;\n  --grey-500: #9e9e9e;\n  --grey-600: #757575;\n  --grey-680: #666666;\n  --grey-700: #616161;\n  --grey-800: #424242;\n  --grey-900: #212121;\n  --gray: #e0e0e0;\n  --black: #000000;\n  --black-o-75: rgba(0, 0, 0, 0.75);\n  --black-o-50: rgba(0, 0, 0, 0.5);\n  --black-o-25: rgba(0, 0, 0, 0.25);\n  --black-o-20: rgba(0, 0, 0, 0.20);\n  --black-o-10: rgba(0, 0, 0, 0.10);\n\n  --red: #DA2924;\n  --red-1: #A61B17;\n  --ruby: #431112;\n  --pine: #1F211B;\n  --berries-cart-charcoal: #2A2D25;\n  --celadon: #ACC5B1;\n  --melon: #F9AC83;\n  --buff: #EED9BC;\n  --parchment: #F3F0E7;\n  --sage: #D5E1D6;\n  --fire-opal: #EB5757;\n\n  --border-color: var(--black);\n  --border-color-grey: var(--black-o-20);\n\n    /* Transitions */\n  --speed: 0.1s;\n  --duration: 0.25s;\n  --duration-slow: 1s;\n  --ease: ease-in-out;\n  --transition-default: var(--duration) var(--ease);\n\n  /* Aspect Ratios */\n  --ratio: 100%;\n  --ratio-5x6: calc(6 / 5 * 100%);\n  --ratio-4x5: calc(5 / 4 * 100%);\n  --ratio-3x4: calc(4 / 3 * 100%);\n  --ratio-2x3: calc(3 / 2 * 100%);\n  --ratio-golden-portrait: calc(1.6180 * 100%);\n  --ratio-golden-landscape: calc(1 / 1.6180 * 100%);\n  --ratio-16x9: calc(9 / 16 * 100%);\n  --ratio-3x2: calc(2 / 3 * 100%);\n  --ratio-4x3: calc(3 / 4 * 100%);\n  --ratio-5x4: calc(4 / 5 * 100%);\n  --ratio-6x5: calc(5 / 6 * 100%);\n\n  /* Border radius */\n  --radius-default: 20px;\n\n  /* Heights */\n  --h-header: 50px;\n  --h-header-tablet: 65px;\n  --h-header-laptop: 70px;\n  --h-header-desktop: 80px;\n}\n\n/* Breakpoint Queries */\n\nbody:not(.keyboard-active) button:focus,\n  body:not(.keyboard-active) input:focus,\n  body:not(.keyboard-active) select:focus,\n  body:not(.keyboard-active) textarea:focus {\n    outline: none !important;\n  }\n\n.sr-only {\n  display: block;\n  height: 0;\n  overflow: hidden;\n  text-indent: -9999px;\n  width: 0;\n}\n\n.align-l { text-align: left; }\n\n.align-c { text-align: center; }\n\n.align-r { text-align: right; }\n\n.align-j { text-align: justify; }\n\n.align-m { vertical-align: middle; }\n\n.align-t { vertical-align: top; }\n\n.align-b { vertical-align: baseline; }\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes underlineAnimated {\n  from {\n    background: linear-gradient(to right, var(--red), var(--red)) no-repeat left bottom / 0% 1px;\n  }\n\n  to {\n    background: linear-gradient(to right, var(--red), var(--red)) no-repeat left bottom / 100% 1px;\n  }\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translate3d(-30%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translate3d(30%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n[data-aos][data-aos][data-aos-duration=\"50\"],\nbody[data-aos-duration=\"50\"] [data-aos] {\n  transition-duration: 50ms;\n}\n\n[data-aos][data-aos][data-aos-delay=\"50\"],\nbody[data-aos-delay=\"50\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"50\"].aos-animate,\nbody[data-aos-delay=\"50\"] [data-aos].aos-animate {\n  transition-delay: 50ms;\n}\n\n[data-aos][data-aos][data-aos-duration=\"100\"],\nbody[data-aos-duration=\"100\"] [data-aos] {\n  transition-duration: 0.1s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"100\"],\nbody[data-aos-delay=\"100\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"100\"].aos-animate,\nbody[data-aos-delay=\"100\"] [data-aos].aos-animate {\n  transition-delay: 0.1s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"150\"],\nbody[data-aos-duration=\"150\"] [data-aos] {\n  transition-duration: 0.15s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"150\"],\nbody[data-aos-delay=\"150\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"150\"].aos-animate,\nbody[data-aos-delay=\"150\"] [data-aos].aos-animate {\n  transition-delay: 0.15s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"200\"],\nbody[data-aos-duration=\"200\"] [data-aos] {\n  transition-duration: 0.2s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"200\"],\nbody[data-aos-delay=\"200\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"200\"].aos-animate,\nbody[data-aos-delay=\"200\"] [data-aos].aos-animate {\n  transition-delay: 0.2s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"250\"],\nbody[data-aos-duration=\"250\"] [data-aos] {\n  transition-duration: 0.25s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"250\"],\nbody[data-aos-delay=\"250\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"250\"].aos-animate,\nbody[data-aos-delay=\"250\"] [data-aos].aos-animate {\n  transition-delay: 0.25s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"300\"],\nbody[data-aos-duration=\"300\"] [data-aos] {\n  transition-duration: 0.3s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"300\"],\nbody[data-aos-delay=\"300\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"300\"].aos-animate,\nbody[data-aos-delay=\"300\"] [data-aos].aos-animate {\n  transition-delay: 0.3s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"350\"],\nbody[data-aos-duration=\"350\"] [data-aos] {\n  transition-duration: 0.35s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"350\"],\nbody[data-aos-delay=\"350\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"350\"].aos-animate,\nbody[data-aos-delay=\"350\"] [data-aos].aos-animate {\n  transition-delay: 0.35s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"400\"],\nbody[data-aos-duration=\"400\"] [data-aos] {\n  transition-duration: 0.4s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"400\"],\nbody[data-aos-delay=\"400\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"400\"].aos-animate,\nbody[data-aos-delay=\"400\"] [data-aos].aos-animate {\n  transition-delay: 0.4s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"450\"],\nbody[data-aos-duration=\"450\"] [data-aos] {\n  transition-duration: 0.45s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"450\"],\nbody[data-aos-delay=\"450\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"450\"].aos-animate,\nbody[data-aos-delay=\"450\"] [data-aos].aos-animate {\n  transition-delay: 0.45s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"500\"],\nbody[data-aos-duration=\"500\"] [data-aos] {\n  transition-duration: 0.5s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"500\"],\nbody[data-aos-delay=\"500\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"500\"].aos-animate,\nbody[data-aos-delay=\"500\"] [data-aos].aos-animate {\n  transition-delay: 0.5s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"550\"],\nbody[data-aos-duration=\"550\"] [data-aos] {\n  transition-duration: 0.55s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"550\"],\nbody[data-aos-delay=\"550\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"550\"].aos-animate,\nbody[data-aos-delay=\"550\"] [data-aos].aos-animate {\n  transition-delay: 0.55s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"600\"],\nbody[data-aos-duration=\"600\"] [data-aos] {\n  transition-duration: 0.6s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"600\"],\nbody[data-aos-delay=\"600\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"600\"].aos-animate,\nbody[data-aos-delay=\"600\"] [data-aos].aos-animate {\n  transition-delay: 0.6s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"650\"],\nbody[data-aos-duration=\"650\"] [data-aos] {\n  transition-duration: 0.65s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"650\"],\nbody[data-aos-delay=\"650\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"650\"].aos-animate,\nbody[data-aos-delay=\"650\"] [data-aos].aos-animate {\n  transition-delay: 0.65s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"700\"],\nbody[data-aos-duration=\"700\"] [data-aos] {\n  transition-duration: 0.7s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"700\"],\nbody[data-aos-delay=\"700\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"700\"].aos-animate,\nbody[data-aos-delay=\"700\"] [data-aos].aos-animate {\n  transition-delay: 0.7s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"750\"],\nbody[data-aos-duration=\"750\"] [data-aos] {\n  transition-duration: 0.75s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"750\"],\nbody[data-aos-delay=\"750\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"750\"].aos-animate,\nbody[data-aos-delay=\"750\"] [data-aos].aos-animate {\n  transition-delay: 0.75s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"800\"],\nbody[data-aos-duration=\"800\"] [data-aos] {\n  transition-duration: 0.8s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"800\"],\nbody[data-aos-delay=\"800\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"800\"].aos-animate,\nbody[data-aos-delay=\"800\"] [data-aos].aos-animate {\n  transition-delay: 0.8s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"850\"],\nbody[data-aos-duration=\"850\"] [data-aos] {\n  transition-duration: 0.85s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"850\"],\nbody[data-aos-delay=\"850\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"850\"].aos-animate,\nbody[data-aos-delay=\"850\"] [data-aos].aos-animate {\n  transition-delay: 0.85s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"900\"],\nbody[data-aos-duration=\"900\"] [data-aos] {\n  transition-duration: 0.9s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"900\"],\nbody[data-aos-delay=\"900\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"900\"].aos-animate,\nbody[data-aos-delay=\"900\"] [data-aos].aos-animate {\n  transition-delay: 0.9s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"950\"],\nbody[data-aos-duration=\"950\"] [data-aos] {\n  transition-duration: 0.95s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"950\"],\nbody[data-aos-delay=\"950\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"950\"].aos-animate,\nbody[data-aos-delay=\"950\"] [data-aos].aos-animate {\n  transition-delay: 0.95s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1000\"],\nbody[data-aos-duration=\"1000\"] [data-aos] {\n  transition-duration: 1s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1000\"],\nbody[data-aos-delay=\"1000\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1000\"].aos-animate,\nbody[data-aos-delay=\"1000\"] [data-aos].aos-animate {\n  transition-delay: 1s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1050\"],\nbody[data-aos-duration=\"1050\"] [data-aos] {\n  transition-duration: 1.05s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1050\"],\nbody[data-aos-delay=\"1050\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1050\"].aos-animate,\nbody[data-aos-delay=\"1050\"] [data-aos].aos-animate {\n  transition-delay: 1.05s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1100\"],\nbody[data-aos-duration=\"1100\"] [data-aos] {\n  transition-duration: 1.1s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1100\"],\nbody[data-aos-delay=\"1100\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1100\"].aos-animate,\nbody[data-aos-delay=\"1100\"] [data-aos].aos-animate {\n  transition-delay: 1.1s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1150\"],\nbody[data-aos-duration=\"1150\"] [data-aos] {\n  transition-duration: 1.15s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1150\"],\nbody[data-aos-delay=\"1150\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1150\"].aos-animate,\nbody[data-aos-delay=\"1150\"] [data-aos].aos-animate {\n  transition-delay: 1.15s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1200\"],\nbody[data-aos-duration=\"1200\"] [data-aos] {\n  transition-duration: 1.2s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1200\"],\nbody[data-aos-delay=\"1200\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1200\"].aos-animate,\nbody[data-aos-delay=\"1200\"] [data-aos].aos-animate {\n  transition-delay: 1.2s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1250\"],\nbody[data-aos-duration=\"1250\"] [data-aos] {\n  transition-duration: 1.25s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1250\"],\nbody[data-aos-delay=\"1250\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1250\"].aos-animate,\nbody[data-aos-delay=\"1250\"] [data-aos].aos-animate {\n  transition-delay: 1.25s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1300\"],\nbody[data-aos-duration=\"1300\"] [data-aos] {\n  transition-duration: 1.3s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1300\"],\nbody[data-aos-delay=\"1300\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1300\"].aos-animate,\nbody[data-aos-delay=\"1300\"] [data-aos].aos-animate {\n  transition-delay: 1.3s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1350\"],\nbody[data-aos-duration=\"1350\"] [data-aos] {\n  transition-duration: 1.35s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1350\"],\nbody[data-aos-delay=\"1350\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1350\"].aos-animate,\nbody[data-aos-delay=\"1350\"] [data-aos].aos-animate {\n  transition-delay: 1.35s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1400\"],\nbody[data-aos-duration=\"1400\"] [data-aos] {\n  transition-duration: 1.4s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1400\"],\nbody[data-aos-delay=\"1400\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1400\"].aos-animate,\nbody[data-aos-delay=\"1400\"] [data-aos].aos-animate {\n  transition-delay: 1.4s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1450\"],\nbody[data-aos-duration=\"1450\"] [data-aos] {\n  transition-duration: 1.45s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1450\"],\nbody[data-aos-delay=\"1450\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1450\"].aos-animate,\nbody[data-aos-delay=\"1450\"] [data-aos].aos-animate {\n  transition-delay: 1.45s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1500\"],\nbody[data-aos-duration=\"1500\"] [data-aos] {\n  transition-duration: 1.5s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1500\"],\nbody[data-aos-delay=\"1500\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1500\"].aos-animate,\nbody[data-aos-delay=\"1500\"] [data-aos].aos-animate {\n  transition-delay: 1.5s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1550\"],\nbody[data-aos-duration=\"1550\"] [data-aos] {\n  transition-duration: 1.55s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1550\"],\nbody[data-aos-delay=\"1550\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1550\"].aos-animate,\nbody[data-aos-delay=\"1550\"] [data-aos].aos-animate {\n  transition-delay: 1.55s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1600\"],\nbody[data-aos-duration=\"1600\"] [data-aos] {\n  transition-duration: 1.6s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1600\"],\nbody[data-aos-delay=\"1600\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1600\"].aos-animate,\nbody[data-aos-delay=\"1600\"] [data-aos].aos-animate {\n  transition-delay: 1.6s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1650\"],\nbody[data-aos-duration=\"1650\"] [data-aos] {\n  transition-duration: 1.65s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1650\"],\nbody[data-aos-delay=\"1650\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1650\"].aos-animate,\nbody[data-aos-delay=\"1650\"] [data-aos].aos-animate {\n  transition-delay: 1.65s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1700\"],\nbody[data-aos-duration=\"1700\"] [data-aos] {\n  transition-duration: 1.7s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1700\"],\nbody[data-aos-delay=\"1700\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1700\"].aos-animate,\nbody[data-aos-delay=\"1700\"] [data-aos].aos-animate {\n  transition-delay: 1.7s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1750\"],\nbody[data-aos-duration=\"1750\"] [data-aos] {\n  transition-duration: 1.75s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1750\"],\nbody[data-aos-delay=\"1750\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1750\"].aos-animate,\nbody[data-aos-delay=\"1750\"] [data-aos].aos-animate {\n  transition-delay: 1.75s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1800\"],\nbody[data-aos-duration=\"1800\"] [data-aos] {\n  transition-duration: 1.8s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1800\"],\nbody[data-aos-delay=\"1800\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1800\"].aos-animate,\nbody[data-aos-delay=\"1800\"] [data-aos].aos-animate {\n  transition-delay: 1.8s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1850\"],\nbody[data-aos-duration=\"1850\"] [data-aos] {\n  transition-duration: 1.85s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1850\"],\nbody[data-aos-delay=\"1850\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1850\"].aos-animate,\nbody[data-aos-delay=\"1850\"] [data-aos].aos-animate {\n  transition-delay: 1.85s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1900\"],\nbody[data-aos-duration=\"1900\"] [data-aos] {\n  transition-duration: 1.9s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1900\"],\nbody[data-aos-delay=\"1900\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1900\"].aos-animate,\nbody[data-aos-delay=\"1900\"] [data-aos].aos-animate {\n  transition-delay: 1.9s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"1950\"],\nbody[data-aos-duration=\"1950\"] [data-aos] {\n  transition-duration: 1.95s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1950\"],\nbody[data-aos-delay=\"1950\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"1950\"].aos-animate,\nbody[data-aos-delay=\"1950\"] [data-aos].aos-animate {\n  transition-delay: 1.95s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2000\"],\nbody[data-aos-duration=\"2000\"] [data-aos] {\n  transition-duration: 2s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2000\"],\nbody[data-aos-delay=\"2000\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2000\"].aos-animate,\nbody[data-aos-delay=\"2000\"] [data-aos].aos-animate {\n  transition-delay: 2s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2050\"],\nbody[data-aos-duration=\"2050\"] [data-aos] {\n  transition-duration: 2.05s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2050\"],\nbody[data-aos-delay=\"2050\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2050\"].aos-animate,\nbody[data-aos-delay=\"2050\"] [data-aos].aos-animate {\n  transition-delay: 2.05s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2100\"],\nbody[data-aos-duration=\"2100\"] [data-aos] {\n  transition-duration: 2.1s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2100\"],\nbody[data-aos-delay=\"2100\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2100\"].aos-animate,\nbody[data-aos-delay=\"2100\"] [data-aos].aos-animate {\n  transition-delay: 2.1s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2150\"],\nbody[data-aos-duration=\"2150\"] [data-aos] {\n  transition-duration: 2.15s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2150\"],\nbody[data-aos-delay=\"2150\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2150\"].aos-animate,\nbody[data-aos-delay=\"2150\"] [data-aos].aos-animate {\n  transition-delay: 2.15s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2200\"],\nbody[data-aos-duration=\"2200\"] [data-aos] {\n  transition-duration: 2.2s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2200\"],\nbody[data-aos-delay=\"2200\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2200\"].aos-animate,\nbody[data-aos-delay=\"2200\"] [data-aos].aos-animate {\n  transition-delay: 2.2s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2250\"],\nbody[data-aos-duration=\"2250\"] [data-aos] {\n  transition-duration: 2.25s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2250\"],\nbody[data-aos-delay=\"2250\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2250\"].aos-animate,\nbody[data-aos-delay=\"2250\"] [data-aos].aos-animate {\n  transition-delay: 2.25s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2300\"],\nbody[data-aos-duration=\"2300\"] [data-aos] {\n  transition-duration: 2.3s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2300\"],\nbody[data-aos-delay=\"2300\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2300\"].aos-animate,\nbody[data-aos-delay=\"2300\"] [data-aos].aos-animate {\n  transition-delay: 2.3s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2350\"],\nbody[data-aos-duration=\"2350\"] [data-aos] {\n  transition-duration: 2.35s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2350\"],\nbody[data-aos-delay=\"2350\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2350\"].aos-animate,\nbody[data-aos-delay=\"2350\"] [data-aos].aos-animate {\n  transition-delay: 2.35s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2400\"],\nbody[data-aos-duration=\"2400\"] [data-aos] {\n  transition-duration: 2.4s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2400\"],\nbody[data-aos-delay=\"2400\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2400\"].aos-animate,\nbody[data-aos-delay=\"2400\"] [data-aos].aos-animate {\n  transition-delay: 2.4s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2450\"],\nbody[data-aos-duration=\"2450\"] [data-aos] {\n  transition-duration: 2.45s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2450\"],\nbody[data-aos-delay=\"2450\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2450\"].aos-animate,\nbody[data-aos-delay=\"2450\"] [data-aos].aos-animate {\n  transition-delay: 2.45s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2500\"],\nbody[data-aos-duration=\"2500\"] [data-aos] {\n  transition-duration: 2.5s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2500\"],\nbody[data-aos-delay=\"2500\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2500\"].aos-animate,\nbody[data-aos-delay=\"2500\"] [data-aos].aos-animate {\n  transition-delay: 2.5s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2550\"],\nbody[data-aos-duration=\"2550\"] [data-aos] {\n  transition-duration: 2.55s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2550\"],\nbody[data-aos-delay=\"2550\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2550\"].aos-animate,\nbody[data-aos-delay=\"2550\"] [data-aos].aos-animate {\n  transition-delay: 2.55s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2600\"],\nbody[data-aos-duration=\"2600\"] [data-aos] {\n  transition-duration: 2.6s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2600\"],\nbody[data-aos-delay=\"2600\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2600\"].aos-animate,\nbody[data-aos-delay=\"2600\"] [data-aos].aos-animate {\n  transition-delay: 2.6s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2650\"],\nbody[data-aos-duration=\"2650\"] [data-aos] {\n  transition-duration: 2.65s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2650\"],\nbody[data-aos-delay=\"2650\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2650\"].aos-animate,\nbody[data-aos-delay=\"2650\"] [data-aos].aos-animate {\n  transition-delay: 2.65s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2700\"],\nbody[data-aos-duration=\"2700\"] [data-aos] {\n  transition-duration: 2.7s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2700\"],\nbody[data-aos-delay=\"2700\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2700\"].aos-animate,\nbody[data-aos-delay=\"2700\"] [data-aos].aos-animate {\n  transition-delay: 2.7s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2750\"],\nbody[data-aos-duration=\"2750\"] [data-aos] {\n  transition-duration: 2.75s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2750\"],\nbody[data-aos-delay=\"2750\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2750\"].aos-animate,\nbody[data-aos-delay=\"2750\"] [data-aos].aos-animate {\n  transition-delay: 2.75s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2800\"],\nbody[data-aos-duration=\"2800\"] [data-aos] {\n  transition-duration: 2.8s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2800\"],\nbody[data-aos-delay=\"2800\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2800\"].aos-animate,\nbody[data-aos-delay=\"2800\"] [data-aos].aos-animate {\n  transition-delay: 2.8s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2850\"],\nbody[data-aos-duration=\"2850\"] [data-aos] {\n  transition-duration: 2.85s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2850\"],\nbody[data-aos-delay=\"2850\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2850\"].aos-animate,\nbody[data-aos-delay=\"2850\"] [data-aos].aos-animate {\n  transition-delay: 2.85s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2900\"],\nbody[data-aos-duration=\"2900\"] [data-aos] {\n  transition-duration: 2.9s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2900\"],\nbody[data-aos-delay=\"2900\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2900\"].aos-animate,\nbody[data-aos-delay=\"2900\"] [data-aos].aos-animate {\n  transition-delay: 2.9s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"2950\"],\nbody[data-aos-duration=\"2950\"] [data-aos] {\n  transition-duration: 2.95s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2950\"],\nbody[data-aos-delay=\"2950\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"2950\"].aos-animate,\nbody[data-aos-delay=\"2950\"] [data-aos].aos-animate {\n  transition-delay: 2.95s;\n}\n\n[data-aos][data-aos][data-aos-duration=\"3000\"],\nbody[data-aos-duration=\"3000\"] [data-aos] {\n  transition-duration: 3s;\n}\n\n[data-aos][data-aos][data-aos-delay=\"3000\"],\nbody[data-aos-delay=\"3000\"] [data-aos] {\n  transition-delay: 0;\n}\n\n[data-aos][data-aos][data-aos-delay=\"3000\"].aos-animate,\nbody[data-aos-delay=\"3000\"] [data-aos].aos-animate {\n  transition-delay: 3s;\n}\n\n[data-aos][data-aos][data-aos-easing=\"linear\"],\nbody[data-aos-easing=\"linear\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.25, 0.25, 0.75, 0.75);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease\"],\nbody[data-aos-easing=\"ease\"] [data-aos] {\n  transition-timing-function: ease;\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in\"],\nbody[data-aos-easing=\"ease-in\"] [data-aos] {\n  transition-timing-function: ease-in;\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out\"],\nbody[data-aos-easing=\"ease-out\"] [data-aos] {\n  transition-timing-function: ease-out;\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out\"],\nbody[data-aos-easing=\"ease-in-out\"] [data-aos] {\n  transition-timing-function: ease-in-out;\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-back\"],\nbody[data-aos-easing=\"ease-in-back\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-back\"],\nbody[data-aos-easing=\"ease-out-back\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-back\"],\nbody[data-aos-easing=\"ease-in-out-back\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-sine\"],\nbody[data-aos-easing=\"ease-in-sine\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-sine\"],\nbody[data-aos-easing=\"ease-out-sine\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-sine\"],\nbody[data-aos-easing=\"ease-in-out-sine\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-quad\"],\nbody[data-aos-easing=\"ease-in-quad\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-quad\"],\nbody[data-aos-easing=\"ease-out-quad\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-quad\"],\nbody[data-aos-easing=\"ease-in-out-quad\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-cubic\"],\nbody[data-aos-easing=\"ease-in-cubic\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-cubic\"],\nbody[data-aos-easing=\"ease-out-cubic\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-cubic\"],\nbody[data-aos-easing=\"ease-in-out-cubic\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-quart\"],\nbody[data-aos-easing=\"ease-in-quart\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-out-quart\"],\nbody[data-aos-easing=\"ease-out-quart\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n[data-aos][data-aos][data-aos-easing=\"ease-in-out-quart\"],\nbody[data-aos-easing=\"ease-in-out-quart\"] [data-aos] {\n  transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n[data-aos^=\"fade\"][data-aos^=\"fade\"] {\n  opacity: 0;\n  transition-property: opacity, transform;\n}\n\n[data-aos^=\"fade\"][data-aos^=\"fade\"].aos-animate {\n  opacity: 1;\n  transform: translateZ(0);\n}\n\n[data-aos=\"fade-up\"] {\n  transform: translate3d(0, 0.9375rem, 0);\n}\n\n[data-aos=\"fade-down\"] {\n  transform: translate3d(0, -100px, 0);\n}\n\n[data-aos=\"fade-right\"] {\n  transform: translate3d(-100px, 0, 0);\n}\n\n[data-aos=\"fade-left\"] {\n  transform: translate3d(100px, 0, 0);\n}\n\n[data-aos=\"fade-up-right\"] {\n  transform: translate3d(-100px, 100px, 0);\n}\n\n[data-aos=\"fade-up-left\"] {\n  transform: translate3d(100px, 100px, 0);\n}\n\n[data-aos=\"fade-down-right\"] {\n  transform: translate3d(-100px, -100px, 0);\n}\n\n[data-aos=\"fade-down-left\"] {\n  transform: translate3d(100px, -100px, 0);\n}\n\n[data-aos^=\"zoom\"][data-aos^=\"zoom\"] {\n  opacity: 0;\n  transition-property: opacity, transform;\n}\n\n[data-aos^=\"zoom\"][data-aos^=\"zoom\"].aos-animate {\n  opacity: 1;\n  transform: translateZ(0) scale(1);\n}\n\n[data-aos=\"zoom-in\"] {\n  transform: scale(0.6);\n}\n\n[data-aos=\"zoom-in-up\"] {\n  transform: translate3d(0, 100px, 0) scale(0.6);\n}\n\n[data-aos=\"zoom-in-down\"] {\n  transform: translate3d(0, -100px, 0) scale(0.6);\n}\n\n[data-aos=\"zoom-in-right\"] {\n  transform: translate3d(-100px, 0, 0) scale(0.6);\n}\n\n[data-aos=\"zoom-in-left\"] {\n  transform: translate3d(100px, 0, 0) scale(0.6);\n}\n\n[data-aos=\"zoom-out\"] {\n  transform: scale(1.2);\n}\n\n[data-aos=\"zoom-out-up\"] {\n  transform: translate3d(0, 100px, 0) scale(1.2);\n}\n\n[data-aos=\"zoom-out-down\"] {\n  transform: translate3d(0, -100px, 0) scale(1.2);\n}\n\n[data-aos=\"zoom-out-right\"] {\n  transform: translate3d(-100px, 0, 0) scale(1.2);\n}\n\n[data-aos=\"zoom-out-left\"] {\n  transform: translate3d(100px, 0, 0) scale(1.2);\n}\n\n[data-aos^=\"slide\"][data-aos^=\"slide\"] {\n  transition-property: transform;\n}\n\n[data-aos^=\"slide\"][data-aos^=\"slide\"].aos-animate {\n  transform: translateZ(0);\n}\n\n[data-aos=\"slide-up\"] {\n  transform: translate3d(0, 100%, 0);\n}\n\n[data-aos=\"slide-down\"] {\n  transform: translate3d(0, -100%, 0);\n}\n\n[data-aos=\"slide-right\"] {\n  transform: translate3d(-100%, 0, 0);\n}\n\n[data-aos=\"slide-left\"] {\n  transform: translate3d(100%, 0, 0);\n}\n\n[data-aos^=\"flip\"][data-aos^=\"flip\"] {\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  transition-property: transform;\n}\n\n[data-aos=\"flip-left\"] {\n  transform: perspective(2500px) rotateY(-100deg);\n}\n\n[data-aos=\"flip-left\"].aos-animate {\n  transform: perspective(2500px) rotateY(0);\n}\n\n[data-aos=\"flip-right\"] {\n  transform: perspective(2500px) rotateY(100deg);\n}\n\n[data-aos=\"flip-right\"].aos-animate {\n  transform: perspective(2500px) rotateY(0);\n}\n\n[data-aos=\"flip-up\"] {\n  transform: perspective(2500px) rotateX(-100deg);\n}\n\n[data-aos=\"flip-up\"].aos-animate {\n  transform: perspective(2500px) rotateX(0);\n}\n\n[data-aos=\"flip-down\"] {\n  transform: perspective(2500px) rotateX(100deg);\n}\n\n[data-aos=\"flip-down\"].aos-animate {\n  transform: perspective(2500px) rotateX(0);\n}\n\n/* Colors */\n\n.black {\n  color: var(--black);\n}\n\n.white {\n  color: var(--white);\n}\n\n.color-headings {\n  color: var(--black);\n}\n\n.color-text {\n  color: var(--black);\n}\n\n.color-background {\n  color: var(--white);\n}\n\n.color-secondary-background {\n  color: var(--grey-300);\n}\n\n.color-accent {\n  color: var(--grey-600);\n}\n\n.color-errors {\n  color: var(--red);\n}\n\n.red {\n  color: var(--red);\n}\n\n/* Background Colors  */\n\n.bg-white {\n    background-color: var(--white);\n  }\n\n.bg-black {\n    background-color: var(--black);\n  }\n\n.bg-red {\n    background-color: var(--red);\n  }\n\n.bg-ruby {\n    background-color: var(--ruby);\n  }\n\n.bg-pine {\n    background-color: var(--pine);\n  }\n\n.bg-celadon {\n    background-color: var(--celadon);\n  }\n\n.bg-melon {\n    background-color: var(--melon);\n  }\n\n.bg-buff {\n    background-color: var(--buff);\n  }\n\n.bg-parchment {\n    background-color: var(--parchment);\n  }\n\n.bg-sage {\n    background-color: var(--sage);\n  }\n\n.container {\n  margin: 0 auto;\n  position: relative;\n  width: calc(100% - var(--gutter) * 2);\n}\n\n@media (min-width: 768px) {\n\n.container {\n    width: calc(100% - var(--gutter-tablet) * 2)\n}\n  }\n\n@media (min-width: 1024px) {\n\n.container {\n    width: calc(100% - var(--gutter-laptop) * 2)\n}\n  }\n\n@media (min-width: 1440px) {\n\n.container {\n    width: calc(100% - var(--gutter-desktop) * 2)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.container {\n    width: calc(100% - var(--gutter-large-desktop) * 2)\n}\n  }\n\n.container--xxs {\n  max-width: var(--xxs);\n}\n\n.container--xs {\n  max-width: var(--xs);\n}\n\n.container--s {\n  max-width: var(--s);\n}\n\n.container--m {\n  max-width: var(--m);\n}\n\n.container--l {\n  max-width: var(--l);\n}\n\n.container--xl {\n  max-width: var(--xl);\n}\n\n.container--xxl {\n  max-width: var(--xxl);\n}\n\n.container--xxxl {\n  max-width: var(--xxxl);\n}\n\n.block {\n  display: block;\n}\n\n.inline {\n  display: inline;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\n.table {\n  display: table;\n}\n\n.hide {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.hide-tablet {\n    display: none\n}\n  }\n\n@media (min-width: 768px) {\n\n.display-tablet {\n    display: block\n}\n  }\n\n.visually-hidden {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */\n  clip: rect(1px, 1px, 1px, 1px);\n  white-space: nowrap; /* added line */\n}\n\n[v-cloak] {\n  display: none;\n}\n\n/* stylelint-disable */\n\n.f { display: flex; }\n\n.inline-f { display: inline-flex }\n\n.fw { flex-wrap: wrap; }\n\n.ais { align-items: flex-start; }\n\n.aie { align-items: flex-end; }\n\n.aic { align-items: center; }\n\n.aib { align-items: baseline; }\n\n.aist { align-items: stretch; }\n\n.jcs { justify-content: flex-start; }\n\n.jce { justify-content: flex-end; }\n\n.jcc { justify-content: center; }\n\n.jcb { justify-content: space-between; }\n\n.jca { justify-content: space-around;; }\n\n.jcev { justify-content: space-evenly; }\n\n.fa {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n}\n\n.ff { flex-shrink: 0; }\n\n.fdc { flex-direction: column; }\n\n/* stylelint-disable */\n\n/* --------------------------------\n* GRID SYSTEM HELPER\n* This file provides CSS classes which support us to create Grid quickly on our screen breakpoints\n* \n* Easy to use:\n* 1. Defining a grid with its total columns and grid gaps for parent element.\n* 2. (Optional) Defining cells with its span (col/row) for child elements.\n* 3. (Optional) Use can use the classes for specific breakpoints.\n* \n* Example:\n* <section class=\"gr gr--2 gr--3:s gr--6:ml gr--12:xl gr-gap--xs gr-gap--md:xl\">\n*   <div class=\"gr-c-span--2 gr-c-span--3:s gr-r-span--2:s gr-r-span--3:xl\">\n*      ...\n*   </div>\n*  ...\n* </section>\n-------------------------------- */\n\n.gr {\n  display: grid;\n  grid-gap: var(--gutter-tablet);\n  grid-template-columns: repeat(1, 1fr);\n}\n\n/* Generate grid template columns - used in parent element */\n\n.gr--1 {\n        grid-template-columns: repeat(1, 1fr);\n  }\n\n@media (min-width: 445px) {\n\n.gr--1\\:xs {\n        grid-template-columns: repeat(1, 1fr)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr--1\\:s {\n        grid-template-columns: repeat(1, 1fr)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr--1\\:m {\n        grid-template-columns: repeat(1, 1fr)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr--1\\:l {\n        grid-template-columns: repeat(1, 1fr)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr--1\\:xl {\n        grid-template-columns: repeat(1, 1fr)\n    }\n      }\n\n.gr--2 {\n        grid-template-columns: repeat(2, 1fr);\n  }\n\n@media (min-width: 445px) {\n\n.gr--2\\:xs {\n        grid-template-columns: repeat(2, 1fr)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr--2\\:s {\n        grid-template-columns: repeat(2, 1fr)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr--2\\:m {\n        grid-template-columns: repeat(2, 1fr)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr--2\\:l {\n        grid-template-columns: repeat(2, 1fr)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr--2\\:xl {\n        grid-template-columns: repeat(2, 1fr)\n    }\n      }\n\n.gr--3 {\n        grid-template-columns: repeat(3, 1fr);\n  }\n\n@media (min-width: 445px) {\n\n.gr--3\\:xs {\n        grid-template-columns: repeat(3, 1fr)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr--3\\:s {\n        grid-template-columns: repeat(3, 1fr)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr--3\\:m {\n        grid-template-columns: repeat(3, 1fr)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr--3\\:l {\n        grid-template-columns: repeat(3, 1fr)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr--3\\:xl {\n        grid-template-columns: repeat(3, 1fr)\n    }\n      }\n\n.gr--4 {\n        grid-template-columns: repeat(4, 1fr);\n  }\n\n@media (min-width: 445px) {\n\n.gr--4\\:xs {\n        grid-template-columns: repeat(4, 1fr)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr--4\\:s {\n        grid-template-columns: repeat(4, 1fr)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr--4\\:m {\n        grid-template-columns: repeat(4, 1fr)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr--4\\:l {\n        grid-template-columns: repeat(4, 1fr)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr--4\\:xl {\n        grid-template-columns: repeat(4, 1fr)\n    }\n      }\n\n.gr--6 {\n        grid-template-columns: repeat(6, 1fr);\n  }\n\n@media (min-width: 445px) {\n\n.gr--6\\:xs {\n        grid-template-columns: repeat(6, 1fr)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr--6\\:s {\n        grid-template-columns: repeat(6, 1fr)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr--6\\:m {\n        grid-template-columns: repeat(6, 1fr)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr--6\\:l {\n        grid-template-columns: repeat(6, 1fr)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr--6\\:xl {\n        grid-template-columns: repeat(6, 1fr)\n    }\n      }\n\n.gr--8 {\n        grid-template-columns: repeat(8, 1fr);\n  }\n\n@media (min-width: 445px) {\n\n.gr--8\\:xs {\n        grid-template-columns: repeat(8, 1fr)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr--8\\:s {\n        grid-template-columns: repeat(8, 1fr)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr--8\\:m {\n        grid-template-columns: repeat(8, 1fr)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr--8\\:l {\n        grid-template-columns: repeat(8, 1fr)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr--8\\:xl {\n        grid-template-columns: repeat(8, 1fr)\n    }\n      }\n\n.gr--12 {\n        grid-template-columns: repeat(12, 1fr);\n  }\n\n@media (min-width: 445px) {\n\n.gr--12\\:xs {\n        grid-template-columns: repeat(12, 1fr)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr--12\\:s {\n        grid-template-columns: repeat(12, 1fr)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr--12\\:m {\n        grid-template-columns: repeat(12, 1fr)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr--12\\:l {\n        grid-template-columns: repeat(12, 1fr)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr--12\\:xl {\n        grid-template-columns: repeat(12, 1fr)\n    }\n      }\n\n/* Generate grid column spans - used in child elements */\n\n.gr > .gr-c-span--1 {\n            grid-column: span 1;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--1\\:xs {\n            grid-column: span 1\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--1\\:s {\n            grid-column: span 1\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--1\\:m {\n            grid-column: span 1\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--1\\:l {\n            grid-column: span 1\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--1\\:xl {\n            grid-column: span 1\n    }\n      }\n\n.gr > .gr-c-span--2 {\n            grid-column: span 2;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--2\\:xs {\n            grid-column: span 2\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--2\\:s {\n            grid-column: span 2\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--2\\:m {\n            grid-column: span 2\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--2\\:l {\n            grid-column: span 2\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--2\\:xl {\n            grid-column: span 2\n    }\n      }\n\n.gr > .gr-c-span--3 {\n            grid-column: span 3;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--3\\:xs {\n            grid-column: span 3\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--3\\:s {\n            grid-column: span 3\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--3\\:m {\n            grid-column: span 3\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--3\\:l {\n            grid-column: span 3\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--3\\:xl {\n            grid-column: span 3\n    }\n      }\n\n.gr > .gr-c-span--4 {\n            grid-column: span 4;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--4\\:xs {\n            grid-column: span 4\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--4\\:s {\n            grid-column: span 4\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--4\\:m {\n            grid-column: span 4\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--4\\:l {\n            grid-column: span 4\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--4\\:xl {\n            grid-column: span 4\n    }\n      }\n\n.gr > .gr-c-span--5 {\n            grid-column: span 5;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--5\\:xs {\n            grid-column: span 5\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--5\\:s {\n            grid-column: span 5\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--5\\:m {\n            grid-column: span 5\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--5\\:l {\n            grid-column: span 5\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--5\\:xl {\n            grid-column: span 5\n    }\n      }\n\n.gr > .gr-c-span--6 {\n            grid-column: span 6;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--6\\:xs {\n            grid-column: span 6\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--6\\:s {\n            grid-column: span 6\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--6\\:m {\n            grid-column: span 6\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--6\\:l {\n            grid-column: span 6\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--6\\:xl {\n            grid-column: span 6\n    }\n      }\n\n.gr > .gr-c-span--7 {\n            grid-column: span 7;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--7\\:xs {\n            grid-column: span 7\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--7\\:s {\n            grid-column: span 7\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--7\\:m {\n            grid-column: span 7\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--7\\:l {\n            grid-column: span 7\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--7\\:xl {\n            grid-column: span 7\n    }\n      }\n\n.gr > .gr-c-span--8 {\n            grid-column: span 8;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--8\\:xs {\n            grid-column: span 8\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--8\\:s {\n            grid-column: span 8\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--8\\:m {\n            grid-column: span 8\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--8\\:l {\n            grid-column: span 8\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--8\\:xl {\n            grid-column: span 8\n    }\n      }\n\n.gr > .gr-c-span--9 {\n            grid-column: span 9;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--9\\:xs {\n            grid-column: span 9\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--9\\:s {\n            grid-column: span 9\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--9\\:m {\n            grid-column: span 9\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--9\\:l {\n            grid-column: span 9\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--9\\:xl {\n            grid-column: span 9\n    }\n      }\n\n.gr > .gr-c-span--10 {\n            grid-column: span 10;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--10\\:xs {\n            grid-column: span 10\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--10\\:s {\n            grid-column: span 10\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--10\\:m {\n            grid-column: span 10\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--10\\:l {\n            grid-column: span 10\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--10\\:xl {\n            grid-column: span 10\n    }\n      }\n\n.gr > .gr-c-span--11 {\n            grid-column: span 11;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--11\\:xs {\n            grid-column: span 11\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--11\\:s {\n            grid-column: span 11\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--11\\:m {\n            grid-column: span 11\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--11\\:l {\n            grid-column: span 11\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--11\\:xl {\n            grid-column: span 11\n    }\n      }\n\n.gr > .gr-c-span--12 {\n            grid-column: span 12;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-c-span--12\\:xs {\n            grid-column: span 12\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-c-span--12\\:s {\n            grid-column: span 12\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-c-span--12\\:m {\n            grid-column: span 12\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-c-span--12\\:l {\n            grid-column: span 12\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-c-span--12\\:xl {\n            grid-column: span 12\n    }\n      }\n\n/* Generate grid row spans - used in child elements */\n\n.gr > .gr-r-span--1 {\n            grid-row: span 1;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--1\\:xs {\n            grid-row: span 1\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--1\\:s {\n            grid-row: span 1\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--1\\:m {\n            grid-row: span 1\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--1\\:l {\n            grid-row: span 1\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--1\\:xl {\n            grid-row: span 1\n    }\n      }\n\n.gr > .gr-r-span--2 {\n            grid-row: span 2;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--2\\:xs {\n            grid-row: span 2\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--2\\:s {\n            grid-row: span 2\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--2\\:m {\n            grid-row: span 2\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--2\\:l {\n            grid-row: span 2\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--2\\:xl {\n            grid-row: span 2\n    }\n      }\n\n.gr > .gr-r-span--3 {\n            grid-row: span 3;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--3\\:xs {\n            grid-row: span 3\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--3\\:s {\n            grid-row: span 3\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--3\\:m {\n            grid-row: span 3\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--3\\:l {\n            grid-row: span 3\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--3\\:xl {\n            grid-row: span 3\n    }\n      }\n\n.gr > .gr-r-span--4 {\n            grid-row: span 4;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--4\\:xs {\n            grid-row: span 4\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--4\\:s {\n            grid-row: span 4\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--4\\:m {\n            grid-row: span 4\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--4\\:l {\n            grid-row: span 4\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--4\\:xl {\n            grid-row: span 4\n    }\n      }\n\n.gr > .gr-r-span--5 {\n            grid-row: span 5;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--5\\:xs {\n            grid-row: span 5\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--5\\:s {\n            grid-row: span 5\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--5\\:m {\n            grid-row: span 5\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--5\\:l {\n            grid-row: span 5\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--5\\:xl {\n            grid-row: span 5\n    }\n      }\n\n.gr > .gr-r-span--6 {\n            grid-row: span 6;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--6\\:xs {\n            grid-row: span 6\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--6\\:s {\n            grid-row: span 6\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--6\\:m {\n            grid-row: span 6\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--6\\:l {\n            grid-row: span 6\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--6\\:xl {\n            grid-row: span 6\n    }\n      }\n\n.gr > .gr-r-span--7 {\n            grid-row: span 7;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--7\\:xs {\n            grid-row: span 7\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--7\\:s {\n            grid-row: span 7\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--7\\:m {\n            grid-row: span 7\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--7\\:l {\n            grid-row: span 7\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--7\\:xl {\n            grid-row: span 7\n    }\n      }\n\n.gr > .gr-r-span--8 {\n            grid-row: span 8;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--8\\:xs {\n            grid-row: span 8\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--8\\:s {\n            grid-row: span 8\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--8\\:m {\n            grid-row: span 8\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--8\\:l {\n            grid-row: span 8\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--8\\:xl {\n            grid-row: span 8\n    }\n      }\n\n.gr > .gr-r-span--9 {\n            grid-row: span 9;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--9\\:xs {\n            grid-row: span 9\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--9\\:s {\n            grid-row: span 9\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--9\\:m {\n            grid-row: span 9\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--9\\:l {\n            grid-row: span 9\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--9\\:xl {\n            grid-row: span 9\n    }\n      }\n\n.gr > .gr-r-span--10 {\n            grid-row: span 10;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--10\\:xs {\n            grid-row: span 10\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--10\\:s {\n            grid-row: span 10\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--10\\:m {\n            grid-row: span 10\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--10\\:l {\n            grid-row: span 10\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--10\\:xl {\n            grid-row: span 10\n    }\n      }\n\n.gr > .gr-r-span--11 {\n            grid-row: span 11;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--11\\:xs {\n            grid-row: span 11\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--11\\:s {\n            grid-row: span 11\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--11\\:m {\n            grid-row: span 11\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--11\\:l {\n            grid-row: span 11\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--11\\:xl {\n            grid-row: span 11\n    }\n      }\n\n.gr > .gr-r-span--12 {\n            grid-row: span 12;\n  }\n\n@media (min-width: 445px) {\n\n.gr > .gr-r-span--12\\:xs {\n            grid-row: span 12\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr > .gr-r-span--12\\:s {\n            grid-row: span 12\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr > .gr-r-span--12\\:m {\n            grid-row: span 12\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr > .gr-r-span--12\\:l {\n            grid-row: span 12\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr > .gr-r-span--12\\:xl {\n            grid-row: span 12\n    }\n      }\n\n/* Generate grid gap - used in parent element */\n\n.gr-gap--xs {\n  grid-gap: var(--gutter);\n  }\n\n@media (min-width: 445px) {\n\n.gr-gap--xs\\:xs {\n  grid-gap: var(--gutter)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr-gap--xs\\:s {\n  grid-gap: var(--gutter)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr-gap--xs\\:m {\n  grid-gap: var(--gutter)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr-gap--xs\\:l {\n  grid-gap: var(--gutter)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr-gap--xs\\:xl {\n  grid-gap: var(--gutter)\n    }\n      }\n\n.gr-gap--sm {\n  grid-gap: var(--gutter-tablet);\n  }\n\n@media (min-width: 445px) {\n\n.gr-gap--sm\\:xs {\n  grid-gap: var(--gutter-tablet)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr-gap--sm\\:s {\n  grid-gap: var(--gutter-tablet)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr-gap--sm\\:m {\n  grid-gap: var(--gutter-tablet)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr-gap--sm\\:l {\n  grid-gap: var(--gutter-tablet)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr-gap--sm\\:xl {\n  grid-gap: var(--gutter-tablet)\n    }\n      }\n\n.gr-gap--md {\n  grid-gap: var(--gutter-laptop);\n  }\n\n@media (min-width: 445px) {\n\n.gr-gap--md\\:xs {\n  grid-gap: var(--gutter-laptop)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr-gap--md\\:s {\n  grid-gap: var(--gutter-laptop)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr-gap--md\\:m {\n  grid-gap: var(--gutter-laptop)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr-gap--md\\:l {\n  grid-gap: var(--gutter-laptop)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr-gap--md\\:xl {\n  grid-gap: var(--gutter-laptop)\n    }\n      }\n\n.gr-gap--lg {\n  grid-gap: var(--gutter:xl);\n  }\n\n@media (min-width: 445px) {\n\n.gr-gap--lg\\:xs {\n  grid-gap: var(--gutter:xl)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.gr-gap--lg\\:s {\n  grid-gap: var(--gutter:xl)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.gr-gap--lg\\:m {\n  grid-gap: var(--gutter:xl)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.gr-gap--lg\\:l {\n  grid-gap: var(--gutter:xl)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.gr-gap--lg\\:xl {\n  grid-gap: var(--gutter:xl)\n    }\n      }\n\n.form-row + .form-row {\n  margin-top: 20px;\n}\n\n@media (min-width: 1024px) {\n\n.form-row + .form-row {\n    margin-top: 30px\n}\n  }\n\ntextarea,\nselect {\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px var(--white) inset !important;\n}\n\n.ratio {\n  position: relative;\n}\n\n.ratio::before {\n    content: '';\n    display: block;\n    width: 100%;\n  }\n\n/* Square */\n\n.ro-1::before {\n  padding-bottom: 100%;\n}\n\n/* Rectangle */\n\n.ro-2::before {\n  padding-bottom: calc(575 / 765 * 100%);\n}\n\n/**\n * For dynamic one, we use CSS variables, which makes it only compatible for newer browsers\n * For older browsers we use the padding-bottom trick, so make sure to remove it here\n */\n\nbody:not(.ie) .aspect-ratio--natural {\n    padding-bottom: 0 !important;\n  }\n\n.aspect-ratio::before {\n  padding-bottom: calc(100% / (var(--aspect-ratio)));\n}\n\n.aspect-ratio--square::before {\n  padding-bottom: 100%;\n}\n\n.aspect-ratio--tall::before {\n  padding-bottom: calc(7 / 5 * 100%);\n}\n\n.clear::before,\n  .clear::after {\n    content: ' ';\n    display: table;\n  }\n\n.clear::after {\n    clear: both;\n  }\n\n/* Common */\n\n.hidden {\n  display: none;\n}\n\n/* Visually hidden but read by screen readers */\n\n.sr-only {\n  display: block;\n  height: 0;\n  overflow: hidden;\n  text-indent: -9999em;\n  width: 0;\n}\n\n.fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n.main {\n  position: relative;\n}\n\n/* critical:start */\n\n.shopify-section--header {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 20;\n}\n\nbody:not(.header-sticky) .shopify-section--header {\n    position: relative;\n  }\n\n/* critical:end */\n\nhtml {\n  height: -webkit-fill-available;\n  padding-bottom: 0 !important;\n}\n\n/* force remove padding from Shopify preview bar */\n\nhtml.menu--active,\n  html.filter--active {\n    overflow: hidden !important;\n  }\n\nhtml,\nbody {\n  scroll-behavior: smooth;\n}\n\nhtml.menu--active,\n  html.filter--active,\n  body.menu--active,\n  body.filter--active {\n    /* Allows content to fill the viewport and go beyond the bottom */\n    min-height: 100vh;\n    min-height: -webkit-fill-available;\n\n    /* Allows you to scroll below the viewport; default value is visible */\n    overflow-y: scroll;\n\n    /* To smooth any scrolling behavior */\n    -webkit-overflow-scrolling: touch;\n  }\n\n.static { position: static; }\n\n.relative { position: relative; }\n\n.absolute { position: absolute; }\n\n.fixed { position: fixed; }\n\n.ratio {\n  position: relative;\n}\n\n.ratio::before {\n    content: '';\n    display: block;\n    width: 100%;\n    padding-bottom: var(--ratio);\n  }\n\n.ratio--5x6::before { padding-bottom: var(--ratio-5x6); }\n\n.ratio--4x5::before { padding-bottom: var(--ratio-4x5); }\n\n.ratio--3x4::before { padding-bottom: var(--ratio-3x4); }\n\n.ratio--2x3::before { padding-bottom: var(--ratio-2x3); }\n\n.ratio--golden-portrait::before { padding-bottom: var(--ratio-golden-portrait); }\n\n.ratio--golden-landscape::before { padding-bottom: var(--ratio-golden-landscape); }\n\n.ratio--16x9::before { padding-bottom: var(--ratio-16x9); }\n\n.ratio--3x2::before { padding-bottom: var(--ratio-3x2); }\n\n.ratio--4x3::before { padding-bottom: var(--ratio-4x3); }\n\n.ratio--5x4::before { padding-bottom: var(--ratio-5x4); }\n\n.ratio-6x5::before { padding-bottom: var(--ratio6x5); }\n\n.ratio--video-gallery::before {\n    padding-bottom: calc(350 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.ratio--video-gallery::before {\n      padding-bottom: calc(436 / 349 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.ratio--video-gallery::before {\n      padding-bottom: calc(581 / 465 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.ratio--video-gallery::before {\n      padding-bottom: calc(825 / 660 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.ratio--video-gallery::before {\n      padding-bottom: calc(825 / 728 * 100%)\n  }\n    }\n\n.mha,\n.mxa {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.mva,\n.mxa {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.mt0,\n.mv0,\n.mx0 { margin-top: 0; }\n\n.mb0,\n.mv0,\n.mx0 { margin-bottom: 0; }\n\n.pt0,\n.pv0,\n.px0 { padding-top: 0; }\n\n.pb0,\n.pv0,\n.px0 { padding-bottom: 0; }\n\n.pr0,\n.ph0,\n.px0 { padding-right: 0; }\n\n.pl0,\n.ph0,\n.px0 { padding-left: 0; }\n\n.mt025,\n.mv025,\n.mx025 { margin-top: 0.25em; }\n\n.mb025,\n.mv025,\n.mx025 { margin-bottom: 0.25em; }\n\n.ml025,\n.mh025,\n.mx025 { margin-left: 0.25em; }\n\n.mr025,\n.mh025,\n.mx025 { margin-right: 0.25em; }\n\n.pt025,\n.pv025,\n.px025 { padding-top: 0.25em; }\n\n.pb025,\n.pv025,\n.px025 { padding-bottom: 0.25em; }\n\n.pl025,\n.ph025,\n.px025 { padding-left: 0.25em; }\n\n.pr025,\n.ph025,\n.px025 { padding-right: 0.25em; }\n\n.mt05,\n.mv05,\n.mx05 { margin-top: 0.5em; }\n\n.mb05,\n.mv05,\n.mx05 { margin-bottom: 0.5em; }\n\n.ml05,\n.mh05,\n.mx05 { margin-left: 0.5em; }\n\n.mr05,\n.mh05,\n.mx05 { margin-right: 0.5em; }\n\n.pt05,\n.pv05,\n.px05 { padding-top: 0.5em; }\n\n.pb05,\n.pv05,\n.px05 { padding-bottom: 0.5em; }\n\n.pl05,\n.ph05,\n.px05 { padding-left: 0.5em; }\n\n.pr05,\n.ph05,\n.px05 { padding-right: 0.5em; }\n\n.mt075,\n.mv075,\n.mx075 { margin-top: 0.75em; }\n\n.mb075,\n.mv075,\n.mx075 { margin-bottom: 0.75em; }\n\n.ml075,\n.mh075,\n.mx075 { margin-left: 0.75em; }\n\n.mr075,\n.mh075,\n.mx075 { margin-right: 0.75em; }\n\n.pt075,\n.pv075,\n.px075 { padding-top: 0.75em; }\n\n.pb075,\n.pv075,\n.px075 { padding-bottom: 0.75em; }\n\n.pl075,\n.ph075,\n.px075 { padding-left: 0.75em; }\n\n.pr075,\n.ph075,\n.px075 { padding-right: 0.75em; }\n\n.mt1,\n.mv1,\n.mx1 { margin-top: 1em; }\n\n.mb1,\n.mv1,\n.mx1 { margin-bottom: 1em; }\n\n.ml1,\n.mh1,\n.mx1 { margin-left: 1em; }\n\n.mr1,\n.mh1,\n.mx1 { margin-right: 1em; }\n\n.mln1 { margin-left: -1em; }\n\n.mrn1 { margin-right: -1em; }\n\n.mhn1 {\n  margin-left: -1em;\n  margin-right: -1em;\n}\n\n.pt1,\n.pv1,\n.px1 { padding-top: 1em; }\n\n.pb1,\n.pv1,\n.px1 { padding-bottom: 1em; }\n\n.pl1,\n.ph1,\n.px1 { padding-left: 1em; }\n\n.pr1,\n.ph1,\n.px1 { padding-right: 1em; }\n\n.mt15,\n.mv15,\n.mx15 { margin-top: 1.5em; }\n\n.mb15,\n.mv15,\n.mx15 { margin-bottom: 1.5em; }\n\n.ml15,\n.mh15,\n.mx15 { margin-left: 1.5em; }\n\n.mr15,\n.mh15,\n.mx15 { margin-right: 1.5em; }\n\n.mln15 { margin-left: -1.5em; }\n\n.mrn15 { margin-right: -1.5em; }\n\n.mhn15 {\n  margin-left: -1.5em;\n  margin-right: -15em;\n}\n\n.pt15,\n.pv15,\n.px15 { padding-top: 1.5em; }\n\n.pb15,\n.pv15,\n.px15 { padding-bottom: 1.5em; }\n\n.pl15,\n.ph15,\n.px15 { padding-left: 1.5em; }\n\n.pr15,\n.ph15,\n.px15 { padding-right: 1.5em; }\n\n.mt2,\n.mv2,\n.mx2 { margin-top: 2em; }\n\n.mb2,\n.mv2,\n.mx2 { margin-bottom: 2em; }\n\n.ml2,\n.mh2,\n.mx2 { margin-left: 2em; }\n\n.mr2,\n.mh2,\n.mx2 { margin-right: 2em; }\n\n.mln2 { margin-left: -2em; }\n\n.mrn2 { margin-right: -2em; }\n\n.mhn2 {\n  margin-left: -2em;\n  margin-right: -2em;\n}\n\n.pt2,\n.pv2,\n.px2 { padding-top: 2em; }\n\n.pb2,\n.pv2,\n.px2 { padding-bottom: 2em; }\n\n.pl2,\n.ph2,\n.px2 { padding-left: 2em; }\n\n.pr2,\n.ph2,\n.px2 { padding-right: 2em; }\n\n/* Use on sections, utilizes margin collapsing to create consistent spacing between sections */\n\n.section-margins {\n  margin: var(--margin) 0;\n}\n\n@media (min-width: 768px) {\n\n.section-margins {\n    margin: var(--margin-tablet) 0\n}\n  }\n\n@media (min-width: 1024px) {\n\n.section-margins {\n    margin: var(--margin-laptop) 0\n}\n  }\n\n@media (min-width: 1440px) {\n\n.section-margins {\n    margin: var(--margin-desktop) 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.section-margins {\n    margin: var(--margin-large-desktop) 0\n}\n  }\n\n.fade-in-down-enter-active,\n.fade-in-down-leave-active {\n  transform: translateY(0);\n  transition: all 200ms ease-in-out;\n}\n\n.fade-in-down-enter,\n.fade-in-down-leave-to {\n  opacity: 0;\n  transform: translateY(10px);\n}\n\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 500ms ease-in-out;\n}\n\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n\n.slide-in-enter-active,\n.slide-in-leave-active {\n  transition: all 0.45s var(--ease);\n}\n\n.slide-in-enter,\n.slide-in-leave-to {\n  transform: translate3d(100%, 0, 0);\n}\n\n.slide-in-right-leave-active,\n.slide-in-right-enter-active {\n  transition: all 0.45s var(--ease);\n}\n\n.slide-in-right-enter-to {\n  transform: translate3d(0, 0, 0);\n}\n\n.slide-in-right-enter,\n.slide-in-right-leave-to {\n  transform: translate3d(100%, 0, 0);\n}\n\n/* Global */\n\nhtml {\n  font-size: 62.5%; /* Set base font-size to 10px */\n}\n\nbody {\n  font-size: 15px;\n  line-height: 1.2;\n  font-family: var(--sans-serif);\n\n  color: var(--black);\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Headings */\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  margin: 0.66em 0;\n}\n\n.h1:first-child, .h2:first-child, .h3:first-child, .h4:first-child, .h5:first-child, .h6:first-child {\n    margin-top: 0;\n  }\n\n.h1:last-child, .h2:last-child, .h3:last-child, .h4:last-child, .h5:last-child, .h6:last-child {\n    margin-bottom: 0;\n  }\n\nh1,\n.h1 {\n  font-size: 24px;\n  line-height: 1.2;\n  font-family: var(--serif);\n}\n\n@media (min-width: 1024px) {\n\nh1,\n.h1 {\n    font-size: 32px;\n}\n  }\n\n@media (min-width: 1440px) {\n\nh1,\n.h1 {\n    font-size: 40px;\n}\n  }\n\n.h1--large {\n  font-size: 31px;\n}\n\n@media (min-width: 768px) {\n\n.h1--large {\n    font-size: 36px;\n}\n  }\n\n@media (min-width: 1024px) {\n\n.h1--large {\n    font-size: 48px;\n}\n  }\n\n@media (min-width: 1440px) {\n\n.h1--large {\n    font-size: 60px;\n}\n  }\n\nh2,\n.h2 {\n  font-size: 21px;\n  line-height: 1.2;\n  font-family: var(--serif);\n}\n\n@media (min-width: 1024px) {\n\nh2,\n.h2 {\n    font-size: 26px;\n}\n  }\n\n@media (min-width: 1440px) {\n\nh2,\n.h2 {\n    font-size: 32px;\n}\n  }\n\n@media (min-width: 1024px) {\n\n.h2--large {\n    font-size: 32px;\n}\n  }\n\nh3,\n.h3 {\n  font-size: 18px;\n  line-height: 1.2;\n  font-family: var(--serif);\n}\n\n@media (min-width: 1024px) {\n\nh3,\n.h3 {\n    font-size: 20px;\n}\n  }\n\n@media (min-width: 1440px) {\n\nh3,\n.h3 {\n    font-size: 24px;\n}\n  }\n\nh4,\n.h4 {\n  font-size: 16px;\n  line-height: 1.2;\n  font-family: var(--sans-serif);\n}\n\n@media (min-width: 1024px) {\n\nh4,\n.h4 {\n    font-size: 18px;\n}\n  }\n\n@media (min-width: 1440px) {\n\nh4,\n.h4 {\n    font-size: 20px;\n    line-height: 1.1;\n}\n  }\n\n@media (min-width: 1024px) {\n\n.h4--large {\n    font-size: 20px;\n    line-height: 1.1;\n}\n  }\n\n.button,\n.label,\nh5,\n.h5,\nh6,\n.h6 {\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  font-family: var(--sans-serif);\n}\n\n@media (min-width: 1024px) {\n\n.button,\n.label,\nh5,\n.h5,\nh6,\n.h6 {\n    font-size: 14px;\n}\n  }\n\n.label--small {\n  font-size: 6px;\n  line-height: 1;\n}\n\n@media (min-width: 1024px) {\n\n.label--small {\n    font-size: 7px;\n}\n  }\n\n/* Label */\n\n.button,\n.label {\n  text-transform: uppercase;\n}\n\n/* Paragraph */\n\n.p1 {\n  font-size: 14px;\n  line-height: 1.3;\n  font-family: var(--sans-serif);\n}\n\n@media (min-width: 1024px) {\n\n.p1 {\n    font-size: 17px;\n}\n  }\n\n.p2 {\n  font-size: 15px;\n  line-height: 1.2;\n  font-family: var(--sans-serif);\n}\n\n.p2--small {\n    font-size: 12px;\n  }\n\n@media (min-width: 1024px) {\n\n.p2--small {\n    font-size: 13px;\n  }\n  }\n\n@media (max-width: 1023px) {\n\n.p2--small-lg-max {\n    font-size: 12px;\n    line-height: 1.45;\n  }\n  }\n\n@media (max-width: 1023px) {\n\n.p2--small-2-lg-max {\n    font-size: 13px;\n  }\n  }\n\n.p1,\n.p2 {\n  margin: 0.66em 0;\n}\n\n.p1:first-child, .p2:first-child {\n    margin-top: 0;\n  }\n\n.p1:last-child, .p2:last-child {\n    margin-bottom: 0;\n  }\n\n/* Blockquote */\n\n.bq {\n  font-size: 2.2rem;\n}\n\n@media (min-width: 768px) {\n\n.bq {\n    font-size: 3.6rem\n}\n  }\n\n/* Links */\n\na.button {\n  text-decoration: none;\n}\n\na,\n.link {\n  position: relative;\n  display: inline-block;\n  color: var(--black);\n  text-decoration: none;\n  cursor: pointer;\n  border-bottom: 1px solid var(--red);\n}\n\na::after, .link::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    transform: scaleX(0);\n    transform-origin: 0 0;\n    background: var(--red);\n  }\n\na:hover, .link:hover {\n    border-color: transparent;\n  }\n\na:hover::after, .link:hover::after {\n      transition: all 0.7s 0.1s ease;\n      transform: scaleX(1);\n    }\n\na.logo,\n  a.icon,\n  .link.logo,\n  .link.icon {\n    border-bottom: none;\n  }\n\na.logo::after, a.icon::after, .link.logo::after, .link.icon::after {\n      content: none;\n    }\n\na[disabled], .link[disabled] {\n    display: none;\n  }\n\n.nav-link {\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  font-family: var(--sans-serif);\n\n  border-color: transparent;\n  text-transform: uppercase;\n  color: var(--black);\n}\n\n@media (min-width: 1024px) {\n\n.nav-link {\n    font-size: 14px\n}\n  }\n\n.nav-link::after {\n    background-color: var(--black);\n  }\n\n@media (min-width: 768px) {\n\n.is-transparent-header:not(.is-scrolling) .nav-link {\n      color: var(--white)\n  }\n    }\n\n.is-transparent-header:not(.is-scrolling) .nav-link::after {\n      background-color: var(--white);\n    }\n\n.is-transparent-header:not(.is-scrolling) .nav-link:focus::before {\n      border-color: var(--white);\n    }\n\n.footer-link {\n  border-color: transparent;\n  color: var(--white);\n}\n\n.footer-link::after {\n    background: var(--white);\n  }\n\n.link--with-icon {\n  display: inline-flex;\n  align-items: center;\n}\n\n.link--with-icon .icon {\n    height: 1em;\n    width: 1em;\n    margin-left: 0.5ch;\n  }\n\n/* Horizontal Rule */\n\nhr,\n.hr {\n  border-style: solid;\n  border-width: 0 0 1px 0;\n  border-color: var(--black);\n}\n\n.hr-grey {\n  border-color: var(--border-color-grey);\n}\n\n/* Styles */\n\n.font-heading {\n  font-family: var(--serif);\n}\n\n.font-primary {\n  font-family: var(--sans-serif);\n}\n\n.italic {\n  font-style: italic;\n}\n\n.bold {\n  font-weight: 700;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.text-line-through {\n  text-decoration: line-through;\n}\n\n.decoration--none {\n  text-decoration: none;\n}\n\n.no-wrap {\n  white-space: nowrap;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.text-error {\n  color: var(--red);\n}\n\n/* Rich Text Element */\n\n.rte h1 {\n  margin: 0.66em 0; }\n\n.rte h1:first-child {\n    margin-top: 0;\n  }\n\n.rte h1:last-child {\n    margin-bottom: 0;\n  }\n\n.rte h2 { @extend .h2; }\n\n.rte h3 { @extend .h3; }\n\n.rte h4 { @extend .h4; }\n\n.rte h5 { @extend .h5; }\n\n.rte h6 { @extend .h6; }\n\n.rte p { @extend .p1; }\n\n.rte strong { font-weight: 700; }\n\n.rte em { font-style: italic; }\n\n.rte a { position: relative; display: inline-block; color: var(--black); text-decoration: none; cursor: pointer; border-bottom: 1px solid var(--red); }\n\n.rte a::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    transform: scaleX(0);\n    transform-origin: 0 0;\n    background: var(--red);\n  }\n\n.rte a:hover {\n    border-color: transparent;\n  }\n\n.rte a:hover::after {\n      transition: all 0.7s 0.1s ease;\n      transform: scaleX(1);\n    }\n\n.rte a.logo,\n  .rte a.icon {\n    border-bottom: none;\n  }\n\n.rte a.logo::after, .rte a.icon::after {\n      content: none;\n    }\n\n.rte a[disabled] {\n    display: none;\n  }\n\n.rte ol {\n    list-style: decimal inside;\n    margin: 0.66em 0;\n  }\n\n.rte ul {\n    list-style: disc inside;\n    margin: 0.66em 0;\n  }\n\n.w1 {\n  width: 100%;\n}\n\n.fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n.z0 { z-index: 0; }\n\n.z01 { z-index: 1; }\n\n.z1 { z-index: 100; }\n\n.z2 { z-index: 200; }\n\n.z3 { z-index: 300; }\n\n.z5 { z-index: 500; }\n\n.z6 { z-index: 600; }\n\n.z7 { z-index: 700; }\n\n.z8 { z-index: 800; }\n\n.z9 { z-index: 900; }\n\n.z10 { z-index: 1000; }\n\niframe[src*=\"localhost\"]#preview-bar-iframe {\n  display: none;\n}\n\n.shopify-challenge__container {\n  margin-top: 30px !important;\n  margin-bottom: 30px !important;\n}\n\n.shopify-challenge__message {\n  margin-bottom: 10px !important;\n}\n\n.shopify-challenge__button {\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  font-family: var(--sans-serif);\n\n  margin-top: 10px !important;\n  padding: 5px 0;\n  background: linear-gradient(to right, var(--red), var(--red)) no-repeat left bottom / 100% 1px;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n\n@media (min-width: 1024px) {\n\n.shopify-challenge__button {\n    font-size: 14px\n}\n  }\n\n.shopify-challenge__button:hover {\n    animation: underlineAnimated 0.7s forwards;\n  }\n\n/**\n * Custom Showcase style\n * !important property might be used to overwrite default app styles, please ignore\n */\n\n.instagram-feed {\n  overflow: hidden;\n}\n\n.instagram-feed .showcase-slider {\n    margin-bottom: 50px;\n  }\n\n@media (min-width: 768px) {\n\n.instagram-feed .showcase-slider {\n      margin-bottom: 0\n  }\n    }\n\n.instagram-feed .showcase-track {\n    padding: 0 !important;\n  }\n\n@media (min-width: 768px) {\n\n.instagram-feed .showcase-track {\n      padding: 0 40px !important\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.instagram-feed .showcase-track {\n      padding: 0 75px !important\n  }\n    }\n\n.instagram-feed .showcase-grid-item {\n    max-width: calc(100% / 3);\n    padding: 0 !important;\n  }\n\n@media (min-width: 768px) {\n\n.instagram-feed .showcase-grid-item {\n      max-width: calc(100% / 6)\n  }\n    }\n\n.instagram-feed .showcase-slider-control {\n    position: absolute;\n    top: auto !important;\n    bottom: -50px !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    border: 1px solid var(--black);\n    border-radius: 50%;\n    width: 30px !important;\n    height: 30px !important;\n  }\n\n@media (min-width: 768px) {\n\n.instagram-feed .showcase-slider-control {\n      top: 50% !important;\n      bottom: auto !important;\n      transform: translate3d(0, -50%, 0)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.instagram-feed .showcase-slider-control {\n      width: 45px !important;\n      height: 45px !important\n  }\n    }\n\n.instagram-feed .showcase-slider-control::after {\n      content: '';\n      border-top: 1px solid var(--black);\n      border-left: 1px solid var(--black);\n      width: 10px;\n      height: 10px;\n    }\n\n@media (min-width: 1240px) {\n\n.instagram-feed .showcase-slider-control::after {\n        width: 14px;\n        height: 14px\n    }\n      }\n\n.instagram-feed .showcase-slider-control > * {\n    display: none !important;\n  }\n\n.instagram-feed .showcase-slider-control.prev {\n    left: calc(50% - 35px) !important;\n  }\n\n@media (min-width: 768px) {\n\n.instagram-feed .showcase-slider-control.prev {\n      left: 0 !important\n  }\n    }\n\n.instagram-feed .showcase-slider-control.prev::after {\n      transform: rotate(-45deg);\n      margin-left: 3px;\n    }\n\n@media (min-width: 1240px) {\n\n.instagram-feed .showcase-slider-control.prev::after {\n        margin-left: 4px\n    }\n      }\n\n.instagram-feed .showcase-slider-control.next {\n    left: calc(50% + 5px) !important;\n  }\n\n@media (min-width: 768px) {\n\n.instagram-feed .showcase-slider-control.next {\n      right: 0 !important;\n      left: auto !important\n  }\n    }\n\n.instagram-feed .showcase-slider-control.next::after {\n      transform: rotate(135deg);\n      margin-right: 3px;\n    }\n\n@media (min-width: 1240px) {\n\n.instagram-feed .showcase-slider-control.next::after {\n        margin-right: 4px\n    }\n      }\n\n.instagram-feed .fa-instagram {\n    justify-content: center;\n    align-items: center;\n    display: flex !important;\n  }\n\n.instagram-feed .showcase-gallery .showcase-slider .showcase-slider-control.disabled {\n    opacity: 0.5 !important;\n    visibility: visible !important;\n    pointer-events: none;\n  }\n\n.showcase-viewer-page a {\n  border-bottom: none;\n}\n\n.showcase-viewer-page a::after {\n    content: none;\n  }\n\n.showcase-gallery .showcase-grid .showcase-grid-items .showcase-grid-item .showcase-grid-item-post .showcase-grid-item-post-media::after {\n    content: '' !important;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n  }\n\nbody.keyboard-active .showcase-gallery .showcase-grid .showcase-grid-items .showcase-grid-item .showcase-grid-item-post:focus .showcase-grid-item-post-media::after {\n      border: 3px solid var(--red);\n    }\n\n#showcase-viewer .showcase-viewer-control.prev button,\n#showcase-viewer .showcase-viewer-control.next button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nbody.keyboard-active button.showcase-button.load-more.button:focus {\n    outline: 1px solid var(--red);\n    outline-offset: 5px;\n  }\n\nbody.keyboard-active #showcase-viewer .showcase-viewer-control.prev button:focus, body.keyboard-active #showcase-viewer .showcase-viewer-control.next button:focus, body.keyboard-active #showcase-viewer .showcase-viewer-header .showcase-dismiss:focus {\n      outline: 1px solid var(--red);\n      outline-offset: -2px;\n    }\n\n#stockist-widget.stockist-widget {\n  flex-wrap: wrap;\n  display: flex;\n}\n\n#stockist-widget.stockist-widget .stockist-search-form {\n    width: 100%;\n    margin-bottom: 30px;\n  }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget .stockist-search-form {\n      margin-bottom: 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n#stockist-widget.stockist-widget .stockist-search-form {\n      margin-bottom: 60px\n  }\n    }\n\n#stockist-widget.stockist-widget .stockist-query-entry {\n    width: 100%;\n  }\n\n@media (min-width: 768px) {\n\n#stockist-widget.stockist-widget .stockist-query-entry {\n      max-width: 280px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget .stockist-query-entry {\n      max-width: 380px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n#stockist-widget.stockist-widget .stockist-query-entry {\n      max-width: 434px\n  }\n    }\n\n#stockist-widget.stockist-widget .stockist-query-entry .stockist-search-field {\n    border-color: var(--black-o-20);\n    height: 35px;\n    padding: 9px 90px 10px 39px;\n    background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='13' fill='none'%3E%3Cpath clip-rule='evenodd' d='M4.983 8.966a3.983 3.983 0 1 0 0-7.966 3.983 3.983 0 0 0 0 7.966Z' stroke='%231F211B'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m7.88 7.88 3.62 3.62-3.62-3.62Z' fill='%231F211B'/%3E%3Cpath d='m7.88 7.88 3.62 3.62' stroke='%231F211B' stroke-linecap='square'/%3E%3C/svg%3E\") no-repeat left 20px center / 11.5px;\n    color: var(--black);\n  }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget .stockist-query-entry .stockist-search-field {\n      height: 40px;\n      padding: 10px 117px 12px 41px;\n      background-size: 13px\n  }\n    }\n\n#stockist-widget.stockist-widget .stockist-query-entry .stockist-search-button {\n    top: 5px;\n    right: 5px;\n  }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget .stockist-query-entry .stockist-search-button {\n      top: 7px;\n      right: 7px\n  }\n    }\n\n#stockist-widget.stockist-widget .stockist-query-entry .stockist-search-button button {\n      font-size: 12px;\n      line-height: 1.25;\n      letter-spacing: 1px;\n      font-family: var(--sans-serif);\n\n      height: 25px;\n      padding: 5px 15px;\n      font-weight: 400;\n      text-transform: uppercase;\n    }\n\n@media (min-width: 1024px) {\n\n#stockist-widget.stockist-widget .stockist-query-entry .stockist-search-button button {\n    font-size: 14px\n    }\n  }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget .stockist-query-entry .stockist-search-button button {\n        height: 26px;\n        padding: 4px 21.5px\n    }\n      }\n\n#stockist-widget.stockist-widget .stockist-horizontal {\n    z-index: 5;\n    flex-wrap: wrap;\n    display: flex;\n    width: 100%;\n  }\n\n@media (min-width: 768px) {\n\n#stockist-widget.stockist-widget .stockist-map + .stockist-horizontal {\n      width: auto\n  }\n    }\n\n#stockist-widget.stockist-widget .stockist-horizontal .stockist-side-panel {\n    order: 1;\n    width: 100%;\n  }\n\n@media (min-width: 768px) {\n\n#stockist-widget.stockist-widget .stockist-horizontal .stockist-side-panel {\n      order: 0;\n      width: 239px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget .stockist-horizontal .stockist-side-panel {\n      width: 320px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n#stockist-widget.stockist-widget .stockist-horizontal .stockist-side-panel {\n      width: 453px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n#stockist-widget.stockist-widget .stockist-horizontal .stockist-side-panel {\n      width: 502px\n  }\n    }\n\n#stockist-widget.stockist-widget .stockist-result .stockist-result-custom-field span {\n    font-weight: 400;\n  }\n\n#stockist-widget.stockist-widget .stockist-list-result > div {\n    margin-top: 5px;\n    padding-left: 0;\n  }\n\n#stockist-widget.stockist-widget .stockist-result-list ul {\n    font-size: 15px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n\n    margin-right: 0;\n  }\n\n#stockist-widget.stockist-widget .stockist-result-list ul > li {\n    margin-bottom: -1px;\n    padding: 20px;\n  }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget .stockist-result-list ul > li {\n      padding: 25px 30px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n#stockist-widget.stockist-widget .stockist-result-list ul > li {\n      padding-top: 30px;\n      padding-bottom: 30px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n#stockist-widget.stockist-widget .stockist-result-list ul > li {\n      padding-right: 35px;\n      padding-left: 35px\n  }\n    }\n\n#stockist-widget.stockist-widget .stockist-result-list ul > li::before {\n      content: none;\n    }\n\n#stockist-widget.stockist-widget .stockist-result.stockist-list-result.stockist-selected {\n    position: relative;\n    z-index: 5;\n    border-color: transparent !important;\n  }\n\n#stockist-widget.stockist-widget .stockist-result.stockist-list-result.stockist-selected::after {\n      content: '';\n      position: absolute;\n      top: -1px;\n      right: -1px;\n      bottom: -1px;\n      left: -1px;\n      border: 2px solid var(--red);\n      pointer-events: none;\n    }\n\n#stockist-widget.stockist-widget .stockist-result .stockist-result-name {\n    font-size: 16px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n\n    margin-bottom: 5px;\n    font-weight: 400;\n  }\n\n@media (min-width: 1024px) {\n\n#stockist-widget.stockist-widget .stockist-result .stockist-result-name {\n    font-size: 18px\n  }\n  }\n\n@media (min-width: 1440px) {\n\n#stockist-widget.stockist-widget .stockist-result .stockist-result-name {\n    font-size: 20px;\n    line-height: 1.1\n  }\n  }\n\n@media (min-width: 1240px) {\n\n#stockist-widget.stockist-widget .stockist-result .stockist-result-name {\n      margin-bottom: 10px\n  }\n    }\n\n#stockist-widget.stockist-widget .stockist-powered-by-link,\n  #stockist-widget.stockist-widget .stockist-result-distance {\n    display: none;\n  }\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-map {\n      position: relative;\n      top: auto;\n      right: auto;\n      bottom: auto;\n      left: auto;\n      width: 100%;\n      height: 300px;\n      margin-bottom: 0;\n    }\n\n@media (min-width: 768px) {\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-map {\n        order: 1;\n        width: calc(100% - 239px);\n        height: auto\n    }\n      }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-map {\n        width: calc(100% - 320px)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-map {\n        width: calc(100% - 453px)\n    }\n      }\n\n@media (min-width: 1600px) {\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-map {\n        width: calc(100% - 502px)\n    }\n      }\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-map .stockist-map-inner {\n        min-height: auto !important;\n      }\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-result-list {\n      position: relative;\n      height: 100% !important;\n      max-height: 467px;\n    }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-result-list {\n        height: 615px !important;\n        max-height: 615px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n#stockist-widget.stockist-widget.stockist-responsive .stockist-result-list {\n        height: 650px !important;\n        max-height: 650px\n    }\n      }\n\n#stockist-widget.stockist-widget .stockist-side-panel::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      border: 1px solid var(--grey-320);\n      pointer-events: none;\n    }\n\n#stockist-widget.stockist-widget .stockist-map-inner iframe + div {\n    border: none !important;\n  }\n\n#stockist-widget.stockist-widget .stockist-result-list .stockist-result-address::before {\n      content: \"Address:\";\n      display: inline-block;\n      margin-right: 0.2em;\n    }\n\n#stockist-widget.stockist-widget .stockist-result-list .stockist-result-address > div {\n    display: inline-block;\n  }\n\n#stockist-widget.stockist-widget .stockist-result-list .stockist-result-address > div:not(:last-child)::after {\n      content: \",\";\n      display: inline-block;\n      margin-right: 0.2em;\n    }\n\n#stockist-widget.stockist-widget .stockist-result-list .stockist-result-phone::before {\n      content: \"Phone:\";\n      display: inline-block;\n      margin-right: 0.2em;\n    }\n\n#stockist-widget.stockist-widget .stockist-result-list .stockist-result-email {\n    margin-top: 5px;\n  }\n\n#stockist-widget.stockist-widget .stockist-result-list .stockist-result-email::before {\n      content: \"Email:\";\n      display: inline-block;\n      margin-right: 0.2em;\n    }\n\n#stockist-widget.stockist-widget .stockist-feature-bg-color {\n    background-color: var(--black);\n  }\n\n@media (min-width: 1000px) {\n\n#stockist-widget.stockist-widget .stockist-feature-bg-color {\n      background-color: var(--pine)\n  }\n    }\n\nbody #shopify-privacy-banner-div {\n  padding: 25px 28px;\n}\n\n@media (min-width: 1240px) {\n\nbody #shopify-privacy-banner-div {\n    padding: 37px 45px\n}\n  }\n\nbody #shopify-privacy-banner-div a {\n    font-size: 15px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n\n    text-decoration: none;\n  }\n\nbody #shopify-privacy-banner-div h3 {\n    font-size: 16px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n\n    margin-bottom: 4px;\n    font-weight: normal;\n  }\n\n@media (min-width: 1024px) {\n\nbody #shopify-privacy-banner-div h3 {\n    font-size: 18px\n  }\n  }\n\n@media (min-width: 1440px) {\n\nbody #shopify-privacy-banner-div h3 {\n    font-size: 20px;\n    line-height: 1.1\n  }\n  }\n\n@media (min-width: 1024px) {\n\nbody #shopify-privacy-banner-div h3 {\n    font-size: 20px;\n    line-height: 1.1\n  }\n  }\n\n@media (min-width: 1240px) {\n\nbody #shopify-privacy-banner-div h3 {\n      margin-bottom: 7px\n  }\n    }\n\nbody #shopify-privacy-banner-div p {\n    font-size: 15px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n  }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-inner-div {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div {\n    display: inline-block;\n    float: none;\n    width: 100%;\n    margin-top: 16px;\n  }\n\n@media (min-width: 768px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      width: calc(100% - 447px);\n      margin: auto;\n      padding-left: 70px\n  }\n    }\n\n@media (min-width: 1000px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div {\n      width: calc(100% - 693px);\n      padding-left: 19px\n  }\n    }\n\n@media (min-width: 1240px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div {\n      width: 20%;\n      padding-left: 30px\n  }\n    }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div button {\n      font-size: 12px;\n      line-height: 1.25;\n      letter-spacing: 1px;\n      font-family: var(--sans-serif);\n\n      width: auto;\n      margin: 0;\n      text-transform: uppercase;\n    }\n\n@media (min-width: 1024px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div button {\n    font-size: 14px;\n    }\n  }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-body-div {\n    width: 100%;\n  }\n\n@media (min-width: 768px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-body-div {\n      max-width: 447px\n  }\n    }\n\n@media (min-width: 1000px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-body-div {\n      max-width: 693px\n  }\n    }\n\n@media (min-width: 1240px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-body-div {\n      max-width: 80%\n  }\n    }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .accept {\n    width: 100%;\n    max-width: 137px;\n    margin-right: 29px;\n    border: 1px solid var(--red);\n    border-radius: 20px;\n    padding: 9px 30px;\n    color: var(--black);\n    background-color: transparent;\n  }\n\n@media (min-width: 768px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .accept {\n      max-width: 86px;\n      margin-left: 13px;\n      margin-right: 0;\n      order: 2\n  }\n    }\n\n@media (min-width: 1000px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .accept {\n      max-width: 115px;\n      margin-left: 26px\n  }\n    }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .accept:hover {\n      border-color: var(--pine);\n    }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .decline {\n    position: relative;\n    display: inline-block;\n    color: var(--black);\n    text-decoration: none;\n    cursor: pointer;\n    border: none;\n    border-bottom: 1px solid var(--red);\n    border-radius: 0;\n    padding: 0;\n    background: transparent;\n  }\n\n@media (min-width: 768px) {\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .decline {\n      height: 20px;\n      order: 1\n  }\n    }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .decline::after {\n      content: '';\n      position: absolute;\n      bottom: -1px;\n      left: 0;\n      width: 100%;\n      height: 1px;\n      transform: scaleX(0);\n      transform-origin: 0 0;\n      background: var(--red);\n    }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .decline:hover {\n      border-color: transparent;\n    }\n\nbody #shopify-privacy-banner-div #shopify-privacy-banner-button-div .decline:hover::after {\n        transition: all 0.7s 0.1s ease;\n        transform: scaleX(1);\n      }\n\n.klaviyo-form-footer .klaviyo-form {\n    max-width: none !important;\n    margin: 0;\n    padding: 0 !important;\n    background-color: transparent !important;\n  }\n\n.klaviyo-form-footer p {\n    text-align: left !important;\n  }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:not(button) {\n    padding: 0 !important;\n    color: var(--black) !important;\n  }\n\n.klaviyo-form-footer #downshift-17-menu > .kl-private-reset-css-Xuajs {\n    padding: 8px !important;\n  }\n\n.klaviyo-form-footer .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor strong {\n    display: block;\n    margin-bottom: 4px;\n    font-size: 16px !important;\n    line-height: 1.2 !important;\n    font-family: var(--sans-serif) !important;\n    font-weight: 400 !important;\n  }\n\n@media (min-width: 1000px) {\n\n.klaviyo-form-footer .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor strong {\n      margin-bottom: 5px;\n      font-size: 18px !important\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.klaviyo-form-footer .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor strong {\n      margin-bottom: 9px;\n      font-size: 20px !important;\n      line-height: 1.1 !important\n  }\n    }\n\n.klaviyo-form-footer input[type='tel']::-webkit-input-placeholder, .klaviyo-form-footer input[type='email']::-webkit-input-placeholder, .klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button input::-webkit-input-placeholder {\n    color: var(--white) !important;\n  }\n\n.klaviyo-form-footer input[type='tel'],\n  .klaviyo-form-footer input[type='tel']::placeholder,\n  .klaviyo-form-footer input[type='email'],\n  .klaviyo-form-footer input[type='email']::placeholder,\n  .klaviyo-form-footer a,\n  .klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button input,\n  .klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button input::placeholder,\n  .klaviyo-form-footer .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor span,\n  .klaviyo-form-footer .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor strong,\n  .klaviyo-form-footer .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor p {\n    color: var(--white) !important;\n  }\n\n.klaviyo-form-footer input[type='tel']::-webkit-input-placeholder, .klaviyo-form-footer input[type='email']::-webkit-input-placeholder, .klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button input::-webkit-input-placeholder {\n    font-size: 15px !important;\n    line-height: 1.2 !important;\n    font-family: var(--sans-serif) !important;\n  }\n\n.klaviyo-form-footer input[type='tel'],\n  .klaviyo-form-footer input[type='tel']::placeholder,\n  .klaviyo-form-footer input[type='email'],\n  .klaviyo-form-footer input[type='email']::placeholder,\n  .klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button input,\n  .klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button input::placeholder,\n  .klaviyo-form-footer .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor span,\n  .klaviyo-form-footer span[role='alert'] {\n    font-size: 15px !important;\n    line-height: 1.2 !important;\n    font-family: var(--sans-serif) !important;\n  }\n\n@media (min-width: 768px) {\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 {\n      flex-wrap: wrap;\n      flex-direction: row !important;\n      justify-content: space-between !important;\n      min-height: auto !important\n  }\n    }\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1 {\n    width: 100%;\n  }\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1 strong,\n  .klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1 p,\n  .klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1 p span {\n    color: #fff !important;\n  }\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1 {\n    margin: 0 !important;\n  }\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1 img {\n    margin-bottom: 20px;\n  }\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1 button img {\n    margin: 0;\n  }\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(2) {\n    display: block;\n    margin-bottom: 15px;\n  }\n\n@media (min-width: 1000px) {\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(2) .kl-private-reset-css-Xuajs1 {\n      max-width: 335px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(3),\n  .klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(4) {\n      width: calc(50% - 38px)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(3),\n  .klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(4) {\n      width: 100%\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(3),\n  .klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(4) {\n      width: calc(50% - 44px)\n  }\n    }\n\n@media (min-width: 768px) {\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(6) {\n      align-items: flex-start !important;\n      width: auto !important\n  }\n    }\n\n.klaviyo-form-footer form > .kl-private-reset-css-Xuajs1 > .kl-private-reset-css-Xuajs1:nth-child(6) .kl-private-reset-css-Xuajs1 {\n      align-items: flex-start;\n    }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button {\n      width: 40px !important;\n      height: 35px !important;\n      margin-right: 5px;\n      padding: 0 !important;\n      border: none !important;\n      background-color: transparent !important;\n      box-shadow: none !important;\n    }\n\n@media (min-width: 1000px) {\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button {\n        height: 40px !important\n    }\n      }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) button svg {\n      fill: var(--white) !important;\n      color: var(--white) !important;\n    }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) input {\n      height: 100%;\n      margin: 0 !important;\n    }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) input:-webkit-autofill,\n    .klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) input:autofill {\n      background-color: transparent !important;\n    }\n\n.klaviyo-form-footer #downshift-73-menu > .kl-private-reset-css-Xuajs1 {\n    padding: 8px !important;\n  }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(5) {\n    order: 2;\n    margin-top: 15px !important;\n  }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(5) .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor span {\n      font-size: 12px !important;\n    }\n\n@media (min-width: 1000px) {\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(5) .kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor span {\n        font-size: 13px !important\n    }\n      }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) > div > div > div:first-child,\n  .klaviyo-form-footer input[type='email'] {\n    height: 35px !important;\n    margin-bottom: 10px !important;\n    padding: 0 15px !important;\n    border: 1px solid var(--white-o-50) !important;\n    border-radius: 30px !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n  }\n\n@media (min-width: 768px) {\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) > div > div > div:first-child,\n  .klaviyo-form-footer input[type='email'] {\n      margin-bottom: 0 !important\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) > div > div > div:first-child,\n  .klaviyo-form-footer input[type='email'] {\n      height: 40px !important;\n      margin-bottom: 10px !important\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(4) > div > div > div:first-child,\n  .klaviyo-form-footer input[type='email'] {\n      margin-bottom: 0 !important\n  }\n    }\n\n.klaviyo-form-footer .go3380653497.go3380653497.go3380653497:hover {\n    border: 1px solid var(--white-o-50) !important;\n  }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(6) button {\n      height: auto !important;\n      padding: 5px 0 !important;\n      border: none !important;\n      border-bottom: 1px solid var(--white) !important;\n      border-radius: 0 !important;\n      background-color: transparent !important;\n      font-size: 12px !important;\n      line-height: 1.25 !important;\n      letter-spacing: 1px !important;\n      font-family: var(--sans-serif) !important;\n      font-weight: 400 !important;\n      text-transform: uppercase;\n      box-shadow: none !important;\n    }\n\n@media (min-width: 1440px) {\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(6) button {\n        font-size: 14px !important\n    }\n      }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(6) button::after {\n      content: '';\n      position: absolute;\n      bottom: -1px;\n      left: 0;\n      width: 100%;\n      height: 1px;\n      transform: scaleX(0);\n      transform-origin: 0 0;\n      background: var(--red);\n    }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(6) button:hover {\n      background-color: transparent !important;\n    }\n\n.klaviyo-form-footer .kl-private-reset-css-Xuajs1:nth-child(6) button:hover::after {\n      transition: all 0.7s 0.1s ease;\n      transform: scaleX(1);\n    }\n\n.klaviyo-form-footer span[role='alert'] {\n    padding: 8px !important;\n  }\n\n.klaviyo-form-footer .klaviyo-form.klaviyo-form.klaviyo-form .klaviyo-spinner::after {\n    content: none;\n  }\n\n.klaviyo-form-footer .go3582494590.go3582494590.go3582494590:focus,\n  .klaviyo-form-footer input.focus-visible,\n  .klaviyo-form-footer button.focus-visible {\n    outline: -webkit-focus-ring-color auto 1px !important;\n  }\n\n.klaviyo-form-footer .go3582494590.go3582494590.go3582494590:focus,\n  .klaviyo-form-footer input:focus-visible,\n  .klaviyo-form-footer button:focus-visible {\n    outline: -webkit-focus-ring-color auto 1px !important;\n  }\n\n.accordions {\n  width: 100%;\n}\n\n.accordion {\n  border-bottom: 1px solid var(--black-o-20);\n}\n\n@media (min-width: 768px) {\n\n.accordion {\n    padding-bottom: 0\n}\n  }\n\n.accordion:first-child {\n    border-top: 1px solid var(--black-o-20);\n  }\n\n.accordion.accordion--is-open {\n    padding-bottom: 25px;\n  }\n\n@media (min-width: 1000px) {\n\n.accordion.accordion--is-open {\n      padding-bottom: 30px\n  }\n    }\n\n.accordion.accordion--is-open.accordion--gift-card {\n      padding-bottom: 15px;\n    }\n\n@media (min-width: 1000px) {\n\n.accordion.accordion--is-open.accordion--gift-card {\n        padding-bottom: 30px\n    }\n      }\n\n.accordion__button {\n  position: relative;\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  transition: padding var(--transition-default);\n  width: 100%;\n  margin: 0;\n  padding: 17px 0;\n  cursor: pointer;\n  text-align: left;\n}\n\n@media (min-width: 1000px) {\n\n.accordion__button {\n    padding: 20px 0\n}\n  }\n\n.accordion--gift-card .accordion__button {\n    padding: 15px 0;\n  }\n\n@media (min-width: 1000px) {\n\n.accordion--gift-card .accordion__button {\n      padding: 20px 0\n  }\n    }\n\n.accordion--is-open .accordion__button {\n    padding-bottom: 0;\n  }\n\n.product-description__accordions .accordion__button {\n    font-size: 12px;\n    line-height: 1.25;\n    letter-spacing: 1px;\n    font-family: var(--sans-serif);\n\n    text-transform: uppercase;\n  }\n\n@media (min-width: 1024px) {\n\n.product-description__accordions .accordion__button {\n    font-size: 14px;\n  }\n  }\n\n.accordion__icon {\n  position: relative;\n  width: 15px;\n  height: 15px;\n  margin-left: 1rem;\n}\n\n.accordion__icon::before,\n  .accordion__icon::after {\n    content: '';\n    position: absolute;\n    display: block;\n    background: var(--red);\n  }\n\n.accordion__icon::before {\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    transform: translate3d(0, -50%, 0);\n  }\n\n@media (min-width: 1000px) {\n\n.faq--storytelling .accordion__icon::before {\n        height: 2px\n    }\n      }\n\n.accordion__icon::after {\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0) rotate(90deg);\n    transition: transform var(--transition-default);\n    width: 100%;\n    height: 1px;\n  }\n\n@media (min-width: 1000px) {\n\n.faq--storytelling .accordion__icon::after {\n        width: 2px\n    }\n      }\n\n.accordion--is-open .accordion__icon::after {\n      transform: translate3d(-50%, -50%, 0) rotate(0);\n    }\n\n.faq--storytelling .accordion__icon {\n    width: 11px;\n    height: 11px;\n  }\n\n@media (min-width: 768px) {\n\n.faq--storytelling .accordion__icon {\n      width: 13px;\n      height: 13px\n  }\n    }\n\n.accordion__content {\n  overflow: hidden;\n  transition: height var(--transition-default);\n  height: 0;\n}\n\n.faq--storytelling .accordion__content {\n    padding-right: 26px;\n  }\n\n@media (min-width: 768px) {\n\n.faq--storytelling .accordion__content {\n      max-width: 429px;\n      padding: 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.faq--storytelling .accordion__content {\n      max-width: 574px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.faq--storytelling .accordion__content {\n      max-width: 813px\n  }\n    }\n\n.accordion__content-wrapper {\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity var(--transition-default), visibility var(--transition-default);\n  padding-top: 10px;\n}\n\n@media (min-width: 1000px) {\n\n.accordion__content-wrapper {\n    padding-top: 10px\n}\n  }\n\n.accordion--is-open .accordion__content-wrapper {\n    opacity: 1;\n    visibility: visible;\n  }\n\n.accordion__content-wrapper p + p {\n    margin-top: 10px;\n  }\n\n.accordion__content-wrapper ul {\n    padding-left: 20px;\n    list-style-type: disc;\n  }\n\n.accordion__content-wrapper ul ul {\n      list-style-type: circle;\n      padding-left: 15px;\n    }\n\n/* critical:start */\n\n.animated-hero {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  overflow: clip;\n  color: var(--white);\n  background-color: var(--letterbox-top-bg, #0f2118);\n  margin-top: calc(-1 * (var(--sticky-promo-banner-height, 95px) + var(--h-header, 50px) + 1px));\n}\n\n@media (min-width: 768px) {\n\n.animated-hero {\n    margin-top: calc(-1 * (var(--sticky-promo-banner-height, 32px) + var(--h-header-tablet, 65px) + 1px))\n}\n  }\n\n@media (min-width: 1024px) {\n\n.animated-hero {\n    margin-top: calc(-1 * (var(--sticky-promo-banner-height, 40px) + var(--h-header-laptop, 70px) + 1px))\n}\n  }\n\n@media (min-width: 1440px) {\n\n.animated-hero {\n    margin-top: calc(-1 * (var(--sticky-promo-banner-height, 40px) + var(--h-header-desktop, 80px) + 1px))\n}\n  }\n\n.animated-hero__scrub {\n  position: relative;\n  width: 100%;\n  height: var(--scrub-scroll-height, 250vh);\n}\n\n.animated-hero__scrub-sticky {\n  --scrub-sticky-min-height: 765px;\n\n  position: -webkit-sticky;\n\n  position: sticky;\n  top: 0;\n  width: 100%;\n  height: max(100vh, var(--scrub-sticky-min-height));\n  height: max(100dvh, var(--scrub-sticky-min-height));\n  overflow: hidden;\n  isolation: isolate;\n  background-color: var(--letterbox-top-bg, #0f2118);\n}\n\n@media (min-width: 768px) {\n\n.animated-hero__scrub-sticky {\n    --scrub-sticky-min-height: 600px\n}\n  }\n\n@media (min-width: 1024px) {\n\n.animated-hero__scrub-sticky {\n    --scrub-sticky-min-height: 700px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.animated-hero__scrub-sticky {\n    --scrub-sticky-min-height: 960px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.animated-hero__scrub-sticky {\n    --scrub-sticky-min-height: 1024px\n}\n  }\n\n.animated-hero__sequence-stage {\n  display: grid;\n  grid-template-rows: 1fr auto 1fr;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n}\n\n.animated-hero__canvas-wrap {\n  position: relative;\n  display: block;\n  grid-row: 2;\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  aspect-ratio: var(--canvas-aspect-ratio, 16 / 9);\n  line-height: 0;\n}\n\n.animated-hero__poster {\n  display: block;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  object-position: center;\n}\n\n.animated-hero--canvas-ready .animated-hero__poster {\n  visibility: hidden;\n}\n\n.animated-hero__letterbox {\n  position: relative;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.animated-hero__letterbox--top {\n    grid-row: 1;\n    align-self: stretch;\n    background-color: var(--letterbox-top-bg, #0f2118);\n  }\n\n.animated-hero__letterbox--bottom {\n    grid-row: 3;\n    align-self: stretch;\n    background-color: var(--letterbox-bottom-bg, #0f2118);\n  }\n\n.animated-hero__letterbox-img {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.animated-hero__canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.animated-hero__overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 226px 20px 80px;\n  text-align: center;\n  pointer-events: none;\n}\n\n@media (min-width: 768px) {\n\n.animated-hero__overlay {\n    padding: 176px 30px 60px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.animated-hero__overlay {\n    padding: 190px 30px 60px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.animated-hero__overlay {\n    padding: 230px 30px 80px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.animated-hero__overlay {\n    padding: 250px 30px 100px\n}\n  }\n\n.animated-hero__overlay-top {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  pointer-events: auto;\n}\n\n.animated-hero__top-heading {\n  display: flex;\n  grid-gap: 10px;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 100%;\n}\n\n@media (min-width: 768px) {\n\n.animated-hero__top-heading {\n    grid-gap: 20px;\n    gap: 20px\n}\n  }\n\n.animated-hero__accent {\n  flex-shrink: 0;\n  width: 27px;\n  height: 70px;\n}\n\n@media (min-width: 1024px) {\n\n.animated-hero__accent {\n    width: 34px;\n    height: 88px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.animated-hero__accent {\n    width: 47px;\n    height: 120px\n}\n  }\n\n.animated-hero__top-title {\n  margin: 0;\n  text-align: center;\n  width: 218px;\n  font-family: var(--serif);\n  font-size: 31px;\n  line-height: 1.2;\n}\n\n@media (min-width: 768px) {\n\n.animated-hero__top-title {\n    font-size: 36px\n}\n  }\n\n@media (min-width: 1024px) {\n\n.animated-hero__top-title {\n    font-size: 48px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.animated-hero__top-title {\n    font-size: 60px\n}\n  }\n\n@media (min-width: 768px) {\n\n.animated-hero__top-title {\n    width: auto\n}\n  }\n\n.animated-hero__bottom-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  grid-gap: 10px;\n  gap: 10px;\n  width: 100%;\n  pointer-events: auto;\n}\n\n@media (min-width: 1024px) {\n\n.animated-hero__bottom-content {\n    grid-gap: 16px;\n    gap: 16px;\n    max-width: none\n}\n  }\n\n@media (min-width: 1440px) {\n\n.animated-hero__bottom-content {\n    grid-gap: 20px;\n    gap: 20px\n}\n  }\n\n.animated-hero__bottom-title {\n  margin: 0;\n  font-family: var(--serif);\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 300;\n}\n\n@media (min-width: 1024px) {\n\n.animated-hero__bottom-title {\n    font-size: 32px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.animated-hero__bottom-title {\n    font-size: 40px\n}\n  }\n\n.animated-hero__bottom-text {\n  margin: 0;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n  font-weight: 400;\n  opacity: 0.6;\n}\n\n@media (min-width: 1024px) {\n\n.animated-hero__bottom-text {\n    font-size: 15px\n}\n  }\n\n.animated-hero__bottom-link {\n  margin-top: 0;\n}\n\n.animated-hero__bottom-link,\n  .animated-hero__bottom-link a {\n    font-family: var(--sans-serif);\n    font-size: 12px;\n    line-height: 1.25;\n    font-weight: 400;\n    letter-spacing: 1px;\n    color: var(--white);\n    text-transform: uppercase;\n    text-decoration: none;\n  }\n\n@media (min-width: 1024px) {\n\n.animated-hero__bottom-link,\n  .animated-hero__bottom-link a {\n      font-size: 14px\n  }\n    }\n\n.animated-hero__bottom-link a {\n    display: inline-flex;\n    flex-direction: column;\n    grid-gap: 5px;\n    gap: 5px;\n    align-items: center;\n    padding-bottom: 4px;\n  }\n\n.animated-hero__bottom-link a::after {\n      content: '';\n      display: block;\n      width: 100%;\n      height: 1px;\n      background-color: currentcolor;\n    }\n\n/* critical:end */\n\n.availability-callout {\n  background: var(--availability-callout-bg, var(--celadon));\n  color: var(--availability-callout-color, var(--pine));\n  padding: 20px;\n}\n\n.availability-callout__title {\n  margin: 0 0 10px;\n  font-family: var(--sans-serif);\n  font-size: 14px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: inherit;\n}\n\n@media (max-width: 767px) {\n\n.availability-callout__title {\n    font-size: 12px !important\n}\n  }\n\n.availability-callout__text {\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n  color: inherit;\n}\n\n.availability-callout__text p {\n    margin: 0;\n    color: inherit;\n  }\n\n.availability-callout__text a {\n    color: inherit;\n  }\n\n@media (min-width: 1000px) {\n\n.availability-callout__text {\n    font-size: 15px !important\n}\n  }\n\n.cart-grid__availability-callout--sidebar {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-grid__availability-callout--sidebar {\n      display: block !important;\n      margin-bottom: 30px !important\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart-grid__availability-callout--sidebar {\n      margin-bottom: 40px !important\n  }\n    }\n\n.cart-grid--default .cart-grid__availability-callout--items {\n    display: block;\n    margin: 30px 0;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-grid__availability-callout--items {\n      display: none !important\n  }\n    }\n\n.cart-grid--mini-cart .cart-grid__availability-callout--items {\n    flex-shrink: 0;\n    margin: 20px 0;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-grid__availability-callout--items {\n      margin: 30px 0 !important\n  }\n    }\n\n.banner-cta {\n  position: relative;\n  overflow: hidden;\n  padding: 20px 0;\n}\n\n@media (min-width: 768px) {\n\n.banner-cta {\n    padding: 30px 0 34px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-cta {\n    padding: 40px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-cta {\n    padding: 50px 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.banner-cta {\n    padding: 60px 0\n}\n  }\n\n.banner-cta__inner {\n  min-height: 350px;\n  padding: 100px 20px;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.banner-cta__inner {\n    min-height: 200px;\n    padding: 35px 150px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-cta__inner {\n    min-height: 250px;\n    padding: 45px 245px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-cta__inner {\n    min-height: 300px;\n    padding-top: 65px;\n    padding-bottom: 65px\n}\n  }\n\n.banner-cta__image {\n  position: absolute;\n  z-index: 10;\n  opacity: 0;\n  animation-duration: 0.5s;\n  animation-fill-mode: forwards;\n  pointer-events: none;\n}\n\n.banner-cta__image--left {\n  top: 5px;\n  left: -51px;\n  width: 166px;\n}\n\n@media (min-width: 768px) {\n\n.banner-cta__image--left {\n    top: 54px;\n    left: -21px;\n    width: 187px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-cta__image--left {\n    top: 31px;\n    left: -55px;\n    width: 294px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-cta__image--left {\n    top: 17px;\n    left: -80px;\n    width: 400px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.banner-cta__image--left {\n    top: 26px;\n    left: 0\n}\n  }\n\n.banner-cta__image--left::before {\n    padding-bottom: calc(580 / 800 * 100%);\n  }\n\n.banner-cta.is-active .banner-cta__image--left {\n    animation-name: fadeInLeft;\n  }\n\n.banner-cta__image--right {\n  right: -39px;\n  bottom: 36px;\n  width: 160px;\n}\n\n@media (min-width: 768px) {\n\n.banner-cta__image--right {\n    top: 23px;\n    right: -16px;\n    bottom: auto;\n    width: 181px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-cta__image--right {\n    top: -18px;\n    right: -46px;\n    width: 284px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-cta__image--right {\n    top: -56px;\n    right: -59px;\n    width: 390px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.banner-cta__image--right {\n    top: -46px;\n    right: 0\n}\n  }\n\n.banner-cta__image--right::before {\n    padding-bottom: calc(740 / 780 * 100%);\n  }\n\n.banner-cta.is-active .banner-cta__image--right {\n    animation-name: fadeInRight;\n    animation-delay: 500ms;\n  }\n\n.banner-cta__logo {\n  width: 30px;\n  margin: 0 auto 15px;\n}\n\n@media (min-width: 1000px) {\n\n.banner-cta__logo {\n    width: 41px;\n    margin-bottom: 20px\n}\n  }\n\n.banner-cta__logo::before {\n    padding-bottom: calc(40 / 30 * 100%);\n  }\n\n@media (min-width: 1000px) {\n\n.banner-cta__logo::before {\n      padding-bottom: calc(54 / 41 * 100%)\n  }\n    }\n\n.banner-cta__title {\n  margin: 0 0 5px;\n}\n\n.banner-cta__text {\n  margin: 0 0 10px;\n}\n\n@media (min-width: 1000px) {\n\n.banner-cta__text {\n    margin-bottom: 20px\n}\n  }\n\n.banner-image {\n  position: relative;\n  overflow: hidden;\n  color: var(--white);\n  background: var(--pine);\n  padding-bottom: 30px;\n}\n\n@media (min-width: 768px) {\n\n.banner-image {\n    padding-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-image {\n    padding-bottom: 80px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.banner-image {\n    padding-bottom: 60px\n}\n  }\n\n.banner-image__media {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.banner-image__media .picture,\n  .banner-image__media picture,\n  .banner-image__media img {\n    width: 100%;\n    height: 100%;\n  }\n\n.banner-image__media .picture,\n  .banner-image__media img {\n    object-fit: cover;\n  }\n\n.banner-image__content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 30px 20px;\n  min-height: 500px;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.banner-image__content {\n    padding: 24px 49px;\n    min-height: 422px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-image__content {\n    min-height: 563px;\n    padding: 60px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.banner-image__content {\n    min-height: 800px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.banner-image__content {\n    min-height: 792px;\n    aspect-ratio: 1480 / 792\n}\n  }\n\n@media (max-width: 767px) {\n\n.banner-image__content {\n    align-items: center !important\n}\n  }\n\n.banner-image__content--v-top {\n  justify-content: flex-start;\n}\n\n.banner-image__content--v-center {\n  justify-content: center;\n}\n\n.banner-image__content--v-bottom {\n  justify-content: flex-end;\n}\n\n.banner-image__content--h-left {\n  align-items: flex-start;\n}\n\n.banner-image__content--h-center {\n  align-items: center;\n  text-align: center;\n}\n\n.banner-image__content--h-right {\n  align-items: flex-end;\n}\n\n.banner-image__content-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.banner-image__title-wrap {\n  position: relative;\n  display: inline-grid;\n  justify-items: center;\n  align-items: start;\n  margin: 0 auto 19px;\n}\n\n@media (min-width: 768px) {\n\n.banner-image__title-wrap {\n    margin: 0 0 18px\n}\n  }\n\n.banner-image__content--h-left .banner-image__title-wrap {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.banner-image__content--h-right .banner-image__title-wrap {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.banner-image__title {\n  margin: 11px 37px 0;\n  font-family: var(--serif);\n  font-weight: 300;\n  text-align: center;\n  font-size: 21px;\n  line-height: 1.2;\n  max-width: 182px;\n}\n\n@media (min-width: 768px) {\n\n.banner-image__title {\n    margin: 11px 37px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-image__title {\n    margin: 10px 67px 0;\n    font-size: 32px;\n    max-width: 286px\n}\n  }\n\n.banner-image__accent {\n  position: absolute;\n  top: 0;\n  width: 27px;\n  height: 70px;\n}\n\n@media (min-width: 1000px) {\n\n.banner-image__accent {\n    width: 37px;\n    height: 95px\n}\n  }\n\n.banner-image__accent--left {\n  left: 0;\n}\n\n.banner-image__accent--right {\n  right: 0;\n}\n\n.banner-image__text {\n  max-width: 245px;\n  margin: 0 auto;\n  text-align: center;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n}\n\n@media (min-width: 1000px) {\n\n.banner-image__text {\n    font-size: 15px;\n    max-width: 347px\n}\n  }\n\n.banner-image__text p {\n    margin: 0;\n  }\n\n.banner-image__content--h-left .banner-image__text {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.banner-image__content--h-right .banner-image__text {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.banner-image__cta {\n  display: inline-block;\n  margin: 15px auto 0;\n  font-family: var(--sans-serif);\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--white);\n  opacity: 0.9;\n  border-bottom-color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.banner-image__cta {\n    margin-top: 20px\n}\n  }\n\n.banner-image__cta::after {\n    background: var(--white);\n  }\n\n@media (min-width: 1000px) {\n\n.banner-image__cta {\n    font-size: 14px\n}\n  }\n\n.banner-image__content--h-left .banner-image__cta {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.banner-image__content--h-right .banner-image__cta {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.banner-with-text {\n  background-color: var(--banner-with-text-bg, #1F211B);\n  color: var(--white);\n  padding: 20px 0 80px;\n}\n\n@media (min-width: 768px) {\n\n.banner-with-text {\n    padding: 40px 0 80px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-with-text {\n    padding: 40px 0 100px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-with-text {\n    padding: 50px 0 120px\n}\n  }\n\n@media (min-width: 1920px) {\n\n.banner-with-text {\n    padding: 60px 0 120px\n}\n  }\n\n.banner-with-text__media {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 362 / 400;\n  margin: 0 auto 40px;\n}\n\n@media (min-width: 768px) {\n\n.banner-with-text__media {\n    aspect-ratio: 706 / 316\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-with-text__media {\n    aspect-ratio: 944 / 422;\n    margin-bottom: 60px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-with-text__media {\n    aspect-ratio: 1340 / 600;\n    margin-bottom: 80px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.banner-with-text__media {\n    aspect-ratio: 1480 / 663\n}\n  }\n\n.banner-with-text__media .picture {\n    width: 100%;\n  }\n\n.banner-with-text__media img {\n    display: block;\n    width: 100%;\n    height: auto;\n  }\n\n.banner-with-text__content {\n  width: 100%;\n  grid-gap: 10px;\n  gap: 10px;\n}\n\n@media (min-width: 768px) {\n\n.banner-with-text__content {\n    max-width: 363px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-with-text__content {\n    max-width: 492px;\n    grid-gap: 20px;\n    gap: 20px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-with-text__content {\n    max-width: 622px\n}\n  }\n\n.banner-with-text__title {\n  margin: 0;\n  color: var(--white);\n  font-family: var(--serif);\n  text-wrap: balance;\n}\n\n.banner-with-text__title p {\n    margin: 0;\n  }\n\n.banner-with-text__title-icon {\n  display: inline-block;\n  width: 30px;\n  height: 39px;\n  vertical-align: -5px;\n  object-fit: contain;\n}\n\n@media (min-width: 768px) {\n\n.banner-with-text__title-icon {\n    vertical-align: -9px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.banner-with-text__title-icon {\n    width: 37px;\n    height: 48px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.banner-with-text__title-icon {\n    width: 42px;\n    height: 56px\n}\n  }\n\n.banner-with-text__description {\n  margin: 0;\n  color: var(--white);\n  opacity: 0.6;\n  font-size: 13px;\n  line-height: 1.2;\n  text-wrap: balance;\n}\n\n@media (min-width: 1024px) {\n\n.banner-with-text__description {\n    font-size: 15px\n}\n  }\n\n.banner-with-text__description p {\n    margin: 0;\n  }\n\n.banner-with-text__cta {\n  margin-top: 4px;\n  border-bottom-color: var(--red) !important;\n}\n\n.banner-with-text__cta::after {\n    background: var(--red) !important;\n  }\n\n@media (min-width: 1000px) {\n\n.banner-with-text__cta {\n    margin-top: 8px\n}\n  }\n\n.banner-with-text__cta--static {\n  cursor: default;\n  pointer-events: none;\n}\n\n.basic-content-cta {\n  margin: 40px 0;\n}\n\n@media (min-width: 1000px) {\n\n.basic-content-cta {\n    margin: 60px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.basic-content-cta {\n    margin: 80px 0\n}\n  }\n\n@media (min-width: 768px) {\n\n.basic-content-cta__container {\n    max-width: 510px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.basic-content-cta__container {\n    max-width: 610px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.basic-content-cta__container {\n    max-width: 797px\n}\n  }\n\n.basic-content-cta__title {\n  margin: 0 auto 5px;\n}\n\n@media (min-width: 768px) {\n\n.basic-content-cta__title {\n    max-width: 100%\n}\n  }\n\n@media (min-width: 1240px) {\n\n.basic-content-cta__title {\n    margin-bottom: 10px\n}\n  }\n\n.basic-content-cta__description {\n  margin: 0;\n}\n\n@media (min-width: 1240px) {\n\n.basic-content-cta__description {\n    max-width: 610px;\n    margin: 0 auto\n}\n  }\n\n.basic-content-cta__button {\n  margin-top: 15px;\n}\n\n@media (min-width: 1000px) {\n\n.basic-content-cta__button {\n    margin-top: 20px\n}\n  }\n\n.berry-comparison {\n  --berry-comparison-border: rgba(255, 255, 255, 0.1);\n  --berry-comparison-accent: #1a1c17;\n\n  background-color: var(--berry-comparison-bg, var(--pine));\n  color: var(--white);\n  padding: 80px 0;\n}\n\n@media (min-width: 1240px) {\n\n.berry-comparison {\n    padding: 120px 0\n}\n  }\n\n.berry-comparison__header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  grid-gap: 20px;\n  gap: 20px;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  text-align: center;\n  max-width: 356px;\n}\n\n@media (min-width: 1240px) {\n\n.berry-comparison__header {\n    margin-bottom: 80px;\n    max-width: 504px\n}\n  }\n\n.berry-comparison__title {\n  margin: 0;\n  color: var(--white);\n  font-weight: 300;\n  text-wrap: balance;\n  font-size: 21px;\n}\n\n@media (min-width: 1240px) {\n\n.berry-comparison__title {\n    font-size: 32px\n}\n  }\n\n.berry-comparison__title p {\n    margin: 0;\n  }\n\n.berry-comparison__title--accents {\n  max-width: 432px;\n}\n\n@media (min-width: 1000px) {\n\n.berry-comparison__title--accents {\n    max-width: none\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-comparison__title--accents {\n    grid-gap: 30px;\n    gap: 30px\n}\n  }\n\n.berry-comparison__title--accents p {\n    width: 182px;\n  }\n\n@media (min-width: 1240px) {\n\n.berry-comparison__title--accents p {\n      width: 298px\n  }\n    }\n\n.berry-comparison__left-accent,\n.berry-comparison__right-accent {\n  flex-shrink: 0;\n  height: 37px;\n  height: 70px;\n}\n\n@media (min-width: 1240px) {\n\n.berry-comparison__left-accent,\n.berry-comparison__right-accent {\n    width: auto;\n    height: 80px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.berry-comparison__left-accent,\n.berry-comparison__right-accent {\n    height: 95px;\n    width: 37px\n}\n  }\n\n.berry-comparison__description {\n  margin: 0;\n  max-width: 504px;\n  color: var(--white);\n  text-wrap: balance;\n  font-size: 13px;\n  line-height: 1.2;\n  opacity: 0.6;\n}\n\n@media (min-width: 1240px) {\n\n.berry-comparison__description {\n    font-size: 15px\n}\n  }\n\n.berry-comparison__description p {\n    margin: 0;\n  }\n\n.berry-comparison__table {\n  width: 100%;\n}\n\n.berry-comparison__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin: 0 auto;\n  width: 100%;\n  border: 1px solid var(--berry-comparison-border);\n}\n\n@media (min-width: 768px) {\n\n.berry-comparison__grid {\n    max-width: 588px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-comparison__grid {\n    max-width: 784px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-comparison__grid {\n    max-width: 1114px\n}\n  }\n\n.berry-comparison__cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 12px;\n  text-align: center;\n  border-right: 1px solid var(--berry-comparison-border);\n  border-bottom: 1px solid var(--berry-comparison-border);\n  min-height: 88px;\n}\n\n.berry-comparison__cell:nth-child(2n) {\n    border-right: none;\n  }\n\n.berry-comparison__cell:nth-last-child(-n + 2) {\n    border-bottom: none;\n  }\n\n@media (min-width: 768px) {\n\n.berry-comparison__cell {\n    padding: 20px 16px;\n    min-height: 72px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-comparison__cell {\n    min-height: 78px\n}\n  }\n\n.berry-comparison__cell--accent {\n  background-color: var(--berry-comparison-accent);\n}\n\n.berry-comparison__cell--header {\n  grid-gap: 20px;\n  gap: 20px;\n  min-height: 208px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n\n.berry-comparison__cell--header {\n    min-height: 178px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-comparison__cell--header {\n    min-height: 340px;\n    grid-gap: 30px;\n    gap: 30px\n}\n  }\n\n.berry-comparison__product-image {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 138px;\n  min-height: 96px;\n}\n\n@media (min-width: 1240px) {\n\n.berry-comparison__product-image {\n    max-width: 281px;\n    min-height: 197px\n}\n  }\n\n.berry-comparison__product-image .picture,\n  .berry-comparison__product-image img {\n    position: relative;\n    display: block;\n    max-width: 100%;\n    height: 100%;\n    max-height: 96px;\n    margin: 0 auto;\n    object-fit: contain;\n  }\n\n@media (min-width: 1240px) {\n\n.berry-comparison__product-image .picture,\n  .berry-comparison__product-image img {\n      max-height: 197px\n  }\n    }\n\n.berry-comparison__product-label {\n  margin: 0;\n  color: var(--white);\n}\n\n.berry-comparison__row-text {\n  margin: 0;\n  color: var(--white);\n  font-size: 13px;\n  line-height: 1.2;\n  text-wrap: balance;\n  max-width: 131px;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) {\n\n.berry-comparison__row-text {\n    max-width: 182px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-comparison__row-text {\n    font-size: 15px;\n    max-width: none\n}\n  }\n\n.berry-props {\n  padding: 40px 0;\n  background-color: var(--parchment);\n}\n\n@media (min-width: 768px) {\n\n.berry-props {\n    padding: 40px 0 60px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props {\n    padding: 60px 0 73px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props {\n    padding: 80px 0 124px\n}\n  }\n\n.berry-props__title {\n  margin: 0 0 20px;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.berry-props__title {\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__title {\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props__title {\n    margin-bottom: 50px\n}\n  }\n\n@media (min-width: 768px) {\n\n.berry-props__inner {\n    position: relative;\n    max-width: 708px;\n    margin: 0 auto;\n    padding-top: 63px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__inner {\n    max-width: 864px;\n    padding-top: 82px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props__inner {\n    max-width: 1140px;\n    padding-top: 92px\n}\n  }\n\n@media (min-width: 768px) {\n\n.berry-props--secondary .berry-props__inner {\n      padding: 0\n  }\n    }\n\n.berry-props--main-image-carousel .berry-props__inner {\n    position: relative;\n  }\n\n.berry-props__main-image {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.berry-props__main-image {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    transform: translate3d(-50%, 0, 0);\n    width: 230px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__main-image {\n    width: 304px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props__main-image {\n    width: 418px\n}\n  }\n\n.berry-props--image-large .berry-props__main-image {\n    width: 304px;\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props--image-large .berry-props__main-image {\n      width: 430px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__main-image {\n      width: 699px\n  }\n    }\n\n@media (max-width: 767px) {\n\n.berry-props--main-image-carousel .berry-props__main-image {\n      position: absolute;\n      top: 0;\n      left: 50%;\n      pointer-events: none;\n      transform: translate(-50%, 0);\n      width: 100%;\n      max-width: 174px;\n      display: block\n  }\n    }\n\n@media (max-width: 999px) {\n\n.berry-props--main-image-carousel.berry-props--image-large .berry-props__main-image {\n      width: 100%;\n      max-width: 304px\n  }\n    }\n\n.berry-props__main-image::before {\n    padding-bottom: calc(255 / 230 * 100%);\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__main-image::before {\n      padding-bottom: calc(337 / 304 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props__main-image::before {\n      padding-bottom: calc(465 / 418 * 100%)\n  }\n    }\n\n.berry-props--image-large .berry-props__main-image::before {\n      padding-bottom: calc(185 / 303 * 100%);\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props--image-large .berry-props__main-image::before {\n        padding-bottom: calc(428 / 699 * 100%)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props__carousel.swiper {\n    overflow: visible;\n    min-height: 180px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__carousel.swiper {\n    min-height: 240px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props__carousel.swiper {\n    min-height: 326px\n}\n  }\n\n@media (min-width: 768px) {\n\n.berry-props__carousel.swiper .swiper-wrapper {\n      flex-wrap: wrap\n  }\n    }\n\n@media (min-width: 768px) {\n\n.berry-props__carousel.swiper .swiper-slide {\n      width: 50%;\n      height: auto\n  }\n    }\n\n.berry-props__card {\n  position: relative;\n}\n\n@media (min-width: 768px) {\n\n.berry-props__card {\n    display: flex;\n    min-height: 56px;\n    margin-top: 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__card {\n    min-height: 60px;\n    margin-top: 60px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props__card {\n    min-height: 63px;\n    margin-top: 100px\n}\n  }\n\n.berry-props__card::after {\n    position: absolute;\n    top: 10px;\n    left: 162px;\n    width: calc(100% - 278px);\n    height: 1px;\n    background-color: var(--black);\n  }\n\n@media (min-width: 768px) {\n\n.berry-props__card::after {\n      content: ''\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props__card::after {\n      left: 180px;\n      width: calc(100% - 332px)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props__card::after {\n      left: 220px;\n      width: calc(100% - 429px)\n  }\n    }\n\n.berry-props__card:nth-child(even)::after {\n    top: -18px;\n    right: 199px;\n    left: auto;\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__card:nth-child(even)::after {\n      top: -46px;\n      right: 220px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props__card:nth-child(even)::after {\n      top: -57px\n  }\n    }\n\n.berry-props__card:nth-child(2)::after {\n    width: calc(100% - 292px);\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__card:nth-child(2)::after {\n      width: calc(100% - 320px)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props__card:nth-child(2)::after {\n      width: calc(100% - 363px)\n  }\n    }\n\n.berry-props__card:nth-child(3)::after {\n    width: calc(100% - 234px);\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__card:nth-child(3)::after {\n      width: calc(100% - 276px)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props__card:nth-child(3)::after {\n      width: calc(100% - 359px)\n  }\n    }\n\n.berry-props__card:nth-child(4)::after {\n    width: calc(100% - 289px);\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__card:nth-child(4)::after {\n      width: calc(100% - 344px)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props__card:nth-child(4)::after {\n      width: calc(100% - 400px)\n  }\n    }\n\n.berry-props__card-content {\n  width: 100%;\n  max-width: 216px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.berry-props__card-content {\n    max-width: 169px;\n    margin: 0;\n    text-align: left\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props__card-content {\n    max-width: 200px\n}\n  }\n\n@media (min-width: 768px) {\n\n.berry-props__card:nth-child(even) .berry-props__card-content {\n      transform: translate3d(0, -28px, 0);\n      max-width: 179px;\n      margin-left: auto\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props__card:nth-child(even) .berry-props__card-content {\n      transform: translate3d(0, -56px, 0);\n      max-width: 200px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props__card:nth-child(even) .berry-props__card-content {\n      transform: translate3d(0, -67px, 0)\n  }\n    }\n\n.berry-props__card-title {\n  margin: 0 0 5px;\n}\n\n@media (min-width: 768px) {\n\n.berry-props__card-title {\n    margin-bottom: 3px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props__card-title {\n    margin-bottom: 5px\n}\n  }\n\n@media (min-width: 768px) {\n\n.berry-props__card:nth-child(odd) .berry-props__card-title {\n      margin-bottom: 6px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props__card:nth-child(odd) .berry-props__card-title {\n      margin-bottom: 3px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props__card:nth-child(odd) .berry-props__card-title {\n      margin-bottom: 5px\n  }\n    }\n\n.berry-props__card-text {\n  opacity: 0.6;\n  margin: 0;\n}\n\n@media (min-width: 768px) {\n\n.berry-props__card-text {\n    min-height: calc(2em * 1.2)\n}\n  }\n\n.berry-props__card-image {\n  width: 100%;\n  max-width: 174px;\n  margin: 0 auto 14px;\n}\n\n.berry-props--image-large .berry-props__card-image {\n    max-width: 303px;\n  }\n\n@media (min-width: 768px) {\n\n.berry-props__card-image {\n    display: none\n}\n  }\n\n.berry-props__card-image::before {\n    padding-bottom: calc(193 / 174 * 100%);\n  }\n\n.berry-props--image-large .berry-props__card-image::before {\n      padding-bottom: calc(185 / 303 * 100%);\n    }\n\n.berry-props--main-image-carousel .berry-props__card-image {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n.berry-props__pagination.swiper-pagination {\n  position: relative;\n  bottom: auto !important;\n  margin-top: 20px;\n}\n\n.berry-props__pagination.swiper-pagination:not(.swiper-pagination-lock) {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n  }\n\n@media (min-width: 768px) {\n\n.berry-props__pagination.swiper-pagination:not(.swiper-pagination-lock) {\n      display: none\n  }\n    }\n\n.berry-props__pagination.swiper-pagination .swiper-pagination-bullet {\n    width: 8px;\n    height: 8px;\n    background-color: var(--black);\n  }\n\n.berry-props__pagination.swiper-pagination .swiper-pagination-bullet-active {\n    opacity: 1;\n  }\n\n@media (min-width: 768px) {\n\n.berry-props--secondary {\n    padding-bottom: 80px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.berry-props--secondary {\n    padding-bottom: 100px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary {\n    padding-bottom: 170px\n}\n  }\n\n@media (min-width: 768px) {\n\n.berry-props--secondary .berry-props__card {\n      margin-top: 20px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props--secondary .berry-props__card {\n      margin-top: 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card {\n      margin-top: 66px\n  }\n    }\n\n.berry-props--secondary .berry-props__card::after {\n      width: 28%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card::after {\n        left: 200px;\n        width: 33%\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--secondary .berry-props__card:nth-child(even) .berry-props__card-content {\n        transform: translate3d(0, 30px, 0)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:nth-child(even) .berry-props__card-content {\n        transform: translate3d(0, 58px, 0)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:nth-child(4) .berry-props__card-content {\n        transform: translate3d(0, 61px, 0)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:nth-child(5) .berry-props__card-content {\n        transform: translate3d(0, -10px, 0)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:first-child,\n    .berry-props--secondary .berry-props__card:nth-child(2) {\n        margin-top: 47px\n    }\n      }\n\n.berry-props--secondary .berry-props__card:nth-child(even)::after {\n      top: 43px;\n      width: 25%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:nth-child(even)::after {\n        top: 69px;\n        right: 225px;\n        left: auto;\n        width: 36%\n    }\n      }\n\n.berry-props--secondary .berry-props__card:nth-child(3)::after {\n      width: 20%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:nth-child(3)::after {\n        width: 26%\n    }\n      }\n\n.berry-props--secondary .berry-props__card:nth-child(4)::after {\n      width: 12%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:nth-child(4)::after {\n        width: 23%\n    }\n      }\n\n.berry-props--secondary .berry-props__card:nth-child(5)::after {\n      width: 26%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:nth-child(5)::after {\n        top: 0;\n        width: 29%\n    }\n      }\n\n.berry-props--secondary .berry-props__card:nth-child(6)::after {\n      width: 23%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--secondary .berry-props__card:nth-child(6)::after {\n        width: 34%\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large {\n    padding-bottom: 114px\n}\n  }\n\n@media (min-width: 768px) {\n\n.berry-props--image-large .berry-props__card {\n      margin-top: 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props--image-large .berry-props__card {\n      margin-top: 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card {\n      margin-top: 66px\n  }\n    }\n\n.berry-props--image-large .berry-props__card::after {\n      width: 28%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card::after {\n        left: 200px;\n        width: 33%\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--image-large .berry-props__card:nth-child(even) .berry-props__card-content {\n        transform: translate3d(0, 10px, 0)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(even) .berry-props__card-content {\n        transform: translate3d(0, 58px, 0)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--image-large .berry-props__card:nth-child(4) .berry-props__card-content {\n        transform: translate3d(0, -26px, 0)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(4) .berry-props__card-content {\n        transform: translate3d(0, -61px, 0)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(5) .berry-props__card-content {\n        transform: translate3d(0, -10px, 0)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--image-large .berry-props__card:nth-child(6) .berry-props__card-content {\n        transform: translate3d(0, -26px, 0)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.berry-props--image-large .berry-props__card:nth-child(6) .berry-props__card-content {\n        transform: translate3d(0, -40px, 0)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(6) .berry-props__card-content {\n        transform: translate3d(0, -68px, 0)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--image-large .berry-props__card:first-child {\n        margin-top: 38px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:first-child {\n        margin-top: 121px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(2) {\n        margin-top: 0\n    }\n      }\n\n.berry-props--image-large .berry-props__card:nth-child(even)::after {\n      top: 22px;\n      width: 25%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(even)::after {\n        top: 69px;\n        right: 225px;\n        left: auto;\n        width: 46%\n    }\n      }\n\n.berry-props--image-large .berry-props__card:nth-child(3)::after {\n      width: 20%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(3)::after {\n        width: 36%\n    }\n      }\n\n.berry-props--image-large .berry-props__card:nth-child(4)::after {\n      width: 12%;\n    }\n\n@media (min-width: 768px) {\n\n.berry-props--image-large .berry-props__card:nth-child(4)::after {\n        width: 26%;\n        top: -16px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(4)::after {\n        width: 36%;\n        top: -48px\n    }\n      }\n\n.berry-props--image-large .berry-props__card:nth-child(5)::after {\n      width: 26%;\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(5)::after {\n        top: 0;\n        width: 29%\n    }\n      }\n\n.berry-props--image-large .berry-props__card:nth-child(6)::after {\n      width: 23%;\n    }\n\n@media (min-width: 768px) {\n\n.berry-props--image-large .berry-props__card:nth-child(6)::after {\n        width: 26%;\n        top: -16px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.berry-props--image-large .berry-props__card:nth-child(6)::after {\n        width: 26%;\n        top: -28px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--image-large .berry-props__card:nth-child(6)::after {\n        width: 41%;\n        top: -58px\n    }\n      }\n\n/* stylelint-disable */\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle {\n    padding-bottom: 80px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__carousel.swiper {\n      min-height: 429px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__main-image {\n      position: absolute;\n      top: 0;\n      left: 50%;\n      display: block;\n      transform: translate3d(-50%, 0, 0);\n      width: calc(700 / 1440 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__main-image {\n      width: calc(700 / 1140 * 100%)\n  }\n    }\n\n.berry-props--3.berry-props--rectangle .berry-props__main-image::before {\n      padding-bottom: calc(429 / 700 * 100%);\n    }\n\n@media (max-width: 767px) {\n\n.berry-props--3.berry-props--rectangle.berry-props--main-image-carousel .berry-props__main-image {\n        max-width: calc(300 / 375 * 100%)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__inner {\n      padding-top: 10px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__inner {\n      padding-top: 15px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card {\n      margin-top: 40px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card {\n      margin-top: 60px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card {\n      margin-top: 135px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:last-child {\n        margin-top: 40px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:last-child {\n        margin-top: 55px\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:first-child::after {\n          width: calc(100% - 300px)\n      }\n        }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:first-child::after {\n          width: calc(100% - 430px)\n      }\n        }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:nth-child(even) .berry-props__card-content {\n          transform: none\n      }\n        }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:nth-child(even)::after {\n          top: 10px;\n          width: calc(100% - 300px)\n      }\n        }\n\n@media (min-width: 1000px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:nth-child(even)::after {\n          width: calc(100% - 400px)\n      }\n        }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:nth-child(even)::after {\n          width: calc(100% - 500px)\n      }\n        }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:nth-child(3)::after {\n          left: 158px;\n          width: calc(100% - 300px)\n      }\n        }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card:nth-child(3)::after {\n          left: 190px;\n          width: calc(100% - 430px)\n      }\n        }\n\n@media (max-width: 767px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__card-image {\n      max-width: calc(300 / 375 * 100%)\n  }\n\n      .berry-props--3.berry-props--rectangle .berry-props__card-image::before {\n        padding-bottom: calc(429 / 700 * 100%);\n      }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--rectangle .berry-props__title {\n      margin-bottom: 80px\n  }\n    }\n\n/* square */\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--square {\n    padding-bottom: 150px\n}\n  }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--square .berry-props__main-image {\n      position: absolute;\n      top: 0;\n      left: 50%;\n      display: block;\n      transform: translate3d(-50%, 0, 0);\n      width: calc(700 / 1440 * 100%)\n  }\n    }\n\n.berry-props--3.berry-props--square .berry-props__main-image::before {\n      padding-bottom: calc(500 / 500 * 100%);\n    }\n\n@media (max-width: 767px) {\n\n.berry-props--3.berry-props--square.berry-props--main-image-carousel .berry-props__main-image {\n        max-width: calc(300 / 375 * 100%)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--square .berry-props__inner {\n      padding-top: 140px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--square .berry-props__inner {\n      padding-top: 175px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--square .berry-props__card {\n      margin-top: 8px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.berry-props--3.berry-props--square .berry-props__card {\n      margin-top: 38px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--square .berry-props__card {\n      margin-top: 75px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--square .berry-props__card:last-child {\n        margin-top: 40px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--square .berry-props__card:last-child {\n        margin-top: 85px\n    }\n      }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--square .berry-props__card:first-child::after {\n          width: calc(100% - 300px)\n      }\n        }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--square .berry-props__card:first-child::after {\n          width: calc(100% - 430px)\n      }\n        }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--square .berry-props__card:nth-child(even) .berry-props__card-content {\n          transform: none\n      }\n        }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--square .berry-props__card:nth-child(even)::after {\n          top: 10px;\n          width: calc(100% - 300px)\n      }\n        }\n\n@media (min-width: 1000px) {\n\n.berry-props--3.berry-props--square .berry-props__card:nth-child(even)::after {\n          width: calc(100% - 400px)\n      }\n        }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--square .berry-props__card:nth-child(even)::after {\n          width: calc(100% - 500px)\n      }\n        }\n\n@media (min-width: 768px) {\n\n.berry-props--3.berry-props--square .berry-props__card:nth-child(3)::after {\n          left: 158px;\n          width: calc(100% - 300px)\n      }\n        }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--square .berry-props__card:nth-child(3)::after {\n          left: 190px;\n          width: calc(100% - 430px)\n      }\n        }\n\n@media (max-width: 767px) {\n\n.berry-props--3.berry-props--square .berry-props__card-image {\n      max-width: calc(300 / 375 * 100%)\n  }\n\n      .berry-props--3.berry-props--square .berry-props__card-image::before {\n        padding-bottom: calc(500 / 500 * 100%);\n      }\n    }\n\n@media (min-width: 1240px) {\n\n.berry-props--3.berry-props--square .berry-props__title {\n      margin-bottom: 50px\n  }\n    }\n\n.breadcrumbs {\n  padding-top: 10px;\n}\n\n@media (min-width: 768px) {\n\n.breadcrumbs {\n    padding-top: 15px\n}\n  }\n\n.breadcrumbs.breadcrumbs--blog-event {\n    padding-top: 20px;\n  }\n\n.breadcrumbs__link {\n  border-bottom: 1px solid var(--black-o-50);\n  color: var(--black-o-50);\n}\n\n.breadcrumbs__link::after {\n    content: none;\n  }\n\n.breadcrumbs--blog-event .breadcrumbs__link::after {\n      content: \"\";\n    }\n\n.breadcrumbs--blog-event .breadcrumbs__link {\n    border-bottom: none;\n    color: var(--black);\n  }\n\n.button {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 5px;\n  color: var(--black);\n  cursor: pointer;\n  border: none;\n  border-bottom: 1px solid var(--red);\n}\n\n.button::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    transform: scaleX(0);\n    transform-origin: 0 0;\n    background: var(--red);\n  }\n\n.button:not([disabled]):hover {\n    color: var(--black);\n    border-color: transparent;\n  }\n\n.button:not([disabled]):hover::after {\n      transition: all 0.7s 0.1s ease;\n      transform: scaleX(1);\n    }\n\n.button.hidden {\n    display: none;\n  }\n\n.button.disabled,\n  .button[disabled] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n.button.button--reverse {\n    border-bottom: 1px solid var(--white);\n    color: var(--white);\n  }\n\n.button.button--reverse::after {\n      background: var(--white);\n    }\n\n.button.button--reverse:not([disabled]):hover {\n      background-color: transparent;\n      color: var(--white);\n      border-color: transparent;\n    }\n\n.button.button--reverse.disabled,\n    .button.button--reverse[disabled] {\n      display: none;\n    }\n\n.button.button--black {\n    background-color: var(--white);\n    color: var(--black);\n  }\n\n.button.button--black:not([disabled]):hover {\n      background-color: var(--red);\n      color: var(--white);\n      border-color: var(--white);\n    }\n\n.button.button--secondary {\n    padding: 5px 0;\n    height: auto;\n    background-color: transparent;\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid var(--red);\n    color: var(--black);\n  }\n\n.button.button--secondary::after {\n      content: '';\n      position: absolute;\n      bottom: -1px;\n      left: 0;\n      width: 100%;\n      height: 1px;\n      transform: scaleX(0);\n      transform-origin: 0 0;\n      background: var(--red);\n    }\n\n.button.button--secondary:not([disabled]):hover {\n      color: var(--black);\n      border-color: transparent;\n    }\n\n.button.button--secondary:not([disabled]):hover::after {\n        transition: all 0.7s 0.1s ease;\n        transform: scaleX(1);\n      }\n\n.button.button--secondary.disabled,\n    .button.button--secondary[disabled] {\n      display: none;\n    }\n\n.button.button--secondary.white:not(.newsletter-form--newsletter-signup-banner-new .button) {\n    border-bottom: 1px solid var(--white);\n    color: var(--white);\n  }\n\n.button.button--secondary.white:not(.newsletter-form--newsletter-signup-banner-new .button)::after {\n      background: var(--white);\n    }\n\n.button.button--secondary.white:not(.newsletter-form--newsletter-signup-banner-new .button):not([disabled]):hover {\n      border-color: transparent;\n      background-color: transparent;\n      color: var(--white);\n    }\n\n.button.button--link {\n    position: relative;\n    display: inline-block;\n    color: var(--black);\n    text-decoration: none;\n    cursor: pointer;\n    border-bottom: 1px solid var(--red);\n  }\n\n.button.button--link::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    transform: scaleX(0);\n    transform-origin: 0 0;\n    background: var(--red);\n  }\n\n.button.button--link:hover {\n    border-color: transparent;\n  }\n\n.button.button--link:hover::after {\n      transition: all 0.7s 0.1s ease;\n      transform: scaleX(1);\n    }\n\n.button.button--link.logo,\n  .button.button--link.icon {\n    border-bottom: none;\n  }\n\n.button.button--link.logo::after, .button.button--link.icon::after {\n      content: none;\n    }\n\n.button.button--link[disabled] {\n    display: none;\n  }\n\n.button.button--link {\n\n    max-width: unset;\n    padding: 0;\n    border: none;\n}\n\n.button.btn--add-to-cart {\n    min-width: 0;\n  }\n\n.button.btn--add-to-cart.disabled,\n    .button.btn--add-to-cart[disabled] {\n      display: block;\n    }\n\n.button--auto-width {\n  min-width: auto;\n}\n\n.button--full-width {\n  width: 100%;\n}\n\n.button--small {\n  min-width: 120px;\n  min-height: auto;\n  padding: 5px 17px;\n}\n\n.carousel-button {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  border-radius: 100%;\n  background: var(--black);\n  text-indent: -9999em;\n  border: 1px solid transparent;\n}\n\n@media (min-width: 1000px) {\n\n.carousel-button {\n    width: 35px;\n    height: 35px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.carousel-button {\n    width: 40px;\n    height: 40px\n}\n  }\n\n.carousel-button::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 10px;\n    height: 10px;\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDEwIj4KICA8cGF0aCBkPSJtMS43NzggOSAzLjU1NS00LjExMkwxLjc3OCAxIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    transform: translate(-50%, -50%);\n  }\n\n.carousel-button:hover {\n    cursor: pointer;\n    background-color: var(--white);\n    border-color: var(--black);\n  }\n\n.carousel-button.disabled,\n  .carousel-button[disabled] {\n    display: none;\n  }\n\n.carousel-button--prev::after {\n      background-image: url(\"data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDEwIj4KICA8cGF0aCBkPSJNNS4yMjIgOSAxLjY2NyA0Ljg4OCA1LjIyMiAxIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=\");\n    }\n\n.carousel-button--prev:hover::after {\n      background-image: url(\"data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDEwIj4KICA8cGF0aCBkPSJNNS4yMjIgOSAxLjY2NyA0Ljg4OCA1LjIyMiAxIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=\");\n    }\n\n.carousel-button--prev.carousel-button--reverse::after {\n        background-image: url(\"data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDEwIj4KICA8cGF0aCBkPSJNNS4yMjIgOSAxLjY2NyA0Ljg4OCA1LjIyMiAxIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=\");\n      }\n\n.carousel-button--prev.carousel-button--reverse:hover::after {\n        background-image: url(\"data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDEwIj4KICA8cGF0aCBkPSJNNS4yMjIgOSAxLjY2NyA0Ljg4OCA1LjIyMiAxIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=\");\n      }\n\n.carousel-button--next:hover::after {\n      background-image: url(\"data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDEwIj4KICA8cGF0aCBkPSJtMS43NzggOSAzLjU1NS00LjExMkwxLjc3OCAxIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=\");\n    }\n\n.carousel-button--next.carousel-button--reverse::after {\n        background-image: url(\"data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDEwIj4KICA8cGF0aCBkPSJtMS43NzggOSAzLjU1NS00LjExMkwxLjc3OCAxIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=\");\n      }\n\n.carousel-button--next.carousel-button--reverse:hover::after {\n        background-image: url(\"data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDEwIj4KICA8cGF0aCBkPSJtMS43NzggOSAzLjU1NS00LjExMkwxLjc3OCAxIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=\");\n      }\n\n.carousel-button--reverse {\n    background-color: var(--white);\n  }\n\n.carousel-button--reverse:hover {\n      background-color: var(--black);\n    }\n\n.button--newsletter {\n  min-width: auto;\n}\n\n.newsletter-form--newsletter-signup-banner-new .button--newsletter {\n    margin: 0 auto;\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter-form--newsletter-signup-banner-new .button--newsletter {\n      padding-top: 1px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.newsletter-form--newsletter-signup-banner-new .button--newsletter {\n      padding-top: 5px\n  }\n    }\n\n.button--banner-cta {\n  min-width: auto;\n}\n\n.button--banner-cta:not([disabled]):hover {\n    background-color: transparent;\n  }\n\n.button--zip {\n  min-width: 80px;\n  min-height: 26px;\n  padding: 3px 10px;\n  color: var(--white);\n  background: var(--pine);\n  border: none;\n  border-radius: 20px;\n}\n\n@media (min-width: 1000px) {\n\n.button--zip {\n    min-width: 100px\n}\n  }\n\n.button--zip:not([disabled]):hover {\n    color: var(--white);\n  }\n\n.button--zip::after {\n    content: none;\n  }\n\n.skip_link {\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  font-family: var(--sans-serif);\n}\n\n@media (min-width: 1024px) {\n\n.skip_link {\n    font-size: 14px\n}\n  }\n\n.skip_link {\n  text-transform: uppercase\n}\n\n.skip_link {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 5px;\n  color: var(--black);\n  cursor: pointer;\n  border: none;\n  border-bottom: 1px solid var(--red)\n}\n\n.skip_link::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    transform: scaleX(0);\n    transform-origin: 0 0;\n    background: var(--red);\n  }\n\n.skip_link:not([disabled]):hover {\n    color: var(--black);\n    border-color: transparent\n  }\n\n.skip_link:not([disabled]):hover::after {\n      transition: all 0.7s 0.1s ease;\n      transform: scaleX(1);\n    }\n\n.skip_link.hidden {\n    display: none;\n  }\n\n.skip_link.disabled,\n  .skip_link[disabled] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n.skip_link.button--reverse {\n    border-bottom: 1px solid var(--white);\n    color: var(--white)\n  }\n\n.skip_link.button--reverse::after {\n      background: var(--white);\n    }\n\n.skip_link.button--reverse:not([disabled]):hover {\n      background-color: transparent;\n      color: var(--white);\n      border-color: transparent;\n    }\n\n.skip_link.button--reverse.disabled,\n    .skip_link.button--reverse[disabled] {\n      display: none;\n    }\n\n.skip_link.button--black {\n    background-color: var(--white);\n    color: var(--black)\n  }\n\n.skip_link.button--black:not([disabled]):hover {\n      background-color: var(--red);\n      color: var(--white);\n      border-color: var(--white);\n    }\n\n.skip_link.button--secondary {\n    padding: 5px 0;\n    height: auto;\n    background-color: transparent;\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid var(--red);\n    color: var(--black)\n  }\n\n.skip_link.button--secondary::after {\n      content: '';\n      position: absolute;\n      bottom: -1px;\n      left: 0;\n      width: 100%;\n      height: 1px;\n      transform: scaleX(0);\n      transform-origin: 0 0;\n      background: var(--red);\n    }\n\n.skip_link.button--secondary:not([disabled]):hover {\n      color: var(--black);\n      border-color: transparent\n    }\n\n.skip_link.button--secondary:not([disabled]):hover::after {\n        transition: all 0.7s 0.1s ease;\n        transform: scaleX(1);\n      }\n\n.skip_link.button--secondary.disabled,\n    .skip_link.button--secondary[disabled] {\n      display: none;\n    }\n\n.skip_link.button--secondary.white:not(.newsletter-form--newsletter-signup-banner-new .skip_link) {\n    border-bottom: 1px solid var(--white);\n    color: var(--white)\n  }\n\n.skip_link.button--secondary.white:not(.newsletter-form--newsletter-signup-banner-new .skip_link)::after {\n      background: var(--white);\n    }\n\n.skip_link.button--secondary.white:not(.newsletter-form--newsletter-signup-banner-new .skip_link):not([disabled]):hover {\n      border-color: transparent;\n      background-color: transparent;\n      color: var(--white);\n    }\n\n.skip_link.button--link {\n    position: relative;\n    display: inline-block;\n    color: var(--black);\n    text-decoration: none;\n    cursor: pointer;\n    border-bottom: 1px solid var(--red);\n  }\n\n.skip_link.button--link::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    transform: scaleX(0);\n    transform-origin: 0 0;\n    background: var(--red);\n  }\n\n.skip_link.button--link:hover {\n    border-color: transparent;\n  }\n\n.skip_link.button--link:hover::after {\n      transition: all 0.7s 0.1s ease;\n      transform: scaleX(1);\n    }\n\n.skip_link.button--link.logo,\n  .skip_link.button--link.icon {\n    border-bottom: none;\n  }\n\n.skip_link.button--link.logo::after, .skip_link.button--link.icon::after {\n      content: none;\n    }\n\n.skip_link.button--link[disabled] {\n    display: none;\n  }\n\n.skip_link.button--link {\n\n    max-width: unset;\n    padding: 0;\n    border: none;\n}\n\n.skip_link.btn--add-to-cart {\n    min-width: 0\n  }\n\n.skip_link.btn--add-to-cart.disabled,\n    .skip_link.btn--add-to-cart[disabled] {\n      display: block;\n    }\n\n.skip_link #storePickupApp .checkoutMethodContainer .inputWithButton {\n        width: 40px;\n        height: 40px;\n        color: var(--white);\n        background-color: var(--red);\n        border-radius: 100%;\n        border: 0\n    }\n\n.skip_link #storePickupApp .checkoutMethodContainer .inputWithButton:not([disabled]):hover {\n          color: var(--white);\n          background-color: var(--red-1)\n        }\n\n.skip_link #storePickupApp .checkoutMethodContainer .inputWithButton:not([disabled]):hover::after {\n            content: none;\n          }\n\n.skip_link #storePickupApp .checkoutMethodContainer .inputWithButton .searchIcon {\n          width: 12px;\n          height: 12px;\n          background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M11.0667%2012L6.86667%207.8C6.53333%208.06667%206.15%208.27778%205.71667%208.43333C5.28333%208.58889%204.82222%208.66667%204.33333%208.66667C3.12222%208.66667%202.09733%208.24711%201.25867%207.408C0.42%206.56889%200.000444797%205.544%203.52734e-07%204.33333C-0.000444092%203.12267%200.419111%202.09778%201.25867%201.25867C2.09822%200.419556%203.12311%200%204.33333%200C5.54356%200%206.56867%200.419556%207.40867%201.25867C8.24867%202.09778%208.668%203.12267%208.66667%204.33333C8.66667%204.82222%208.58889%205.28333%208.43333%205.71667C8.27778%206.15%208.06667%206.53333%207.8%206.86667L12%2011.0667L11.0667%2012ZM4.33333%207.33333C5.16667%207.33333%205.87511%207.04178%206.45867%206.45867C7.04222%205.87556%207.33378%205.16711%207.33333%204.33333C7.33289%203.49956%207.04133%202.79133%206.45867%202.20867C5.876%201.626%205.16756%201.33422%204.33333%201.33333C3.49911%201.33244%202.79089%201.62422%202.20867%202.20867C1.62644%202.79311%201.33467%203.50133%201.33333%204.33333C1.332%205.16533%201.62378%205.87378%202.20867%206.45867C2.79356%207.04356%203.50178%207.33511%204.33333%207.33333Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E');\n          background-size: 100%;\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n\n.skip_link #storePickupApp .checkoutMethodContainer .inputWithButton .searchIcon svg {\n            display: none;\n          }\n\n.skip_link.button--secondary.contact-form__submit {\n  min-width: auto\n}\n\n.skip_link.button--secondary.contact-form__submit:disabled {\n    display: inline-flex;\n    opacity: 0.8;\n    cursor: not-allowed;\n  }\n\n.skip_link {\n\n  /* critical:start */\n\n  /* critical:end */\n}\n\n.skip_link .product-form__add-to-cart {\n    width: 100%;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-radius: 20px\n}\n\n@media (min-width: 1000px) {\n\n.skip_link .product-form__add-to-cart {\n      padding-top: 12px;\n      padding-bottom: 11px\n}\n    }\n\n.skip_link .social-image-gallery__social-item {\n    text-transform: none\n}\n\n.skip_link .wysiwyg--basic {\n    min-width: auto\n}\n\n.skip_link {\n\n  position: fixed;\n  top: -100px;\n  left: 50%;\n  z-index: 999;\n  display: none;\n\n  display: block;\n  opacity: 0;\n  transform: translate3d(-50%, 0, 0);\n  transition: all 0.3s ease;\n  border: 1px solid var(--red);\n  border-radius: 30px;\n  min-height: 36px;\n  padding: 9px 15px;\n  background-color: var(--white);\n}\n\n.skip_link:active,\n  .skip_link:focus {\n    top: 100px;\n    opacity: 1;\n    background-color: var(--white);\n    pointer-events: auto;\n  }\n\n.skip_link::after {\n    content: none;\n  }\n\n.button--red {\n  min-width: 130px;\n  border: none;\n  padding: 12px 25px;\n  color: var(--white);\n  background-color: var(--red);\n}\n\n@media (min-width: 768px) {\n\n.button--red {\n    min-width: 153px\n}\n  }\n\n.button--red:not([disabled]):hover {\n    color: var(--white);\n    background-color: var(--red-1);\n  }\n\n.button--red:not([disabled]):hover::after {\n      content: none;\n    }\n\n.button--red.disabled,\n  .button--red[disabled] {\n    opacity: 0.5;\n  }\n\n.button--red.button--red-custom {\n    width: 100%;\n    border-radius: 20px;\n  }\n\n@media (min-width: 1000px) {\n\n.button--red.button--red-custom {\n      max-width: 320px\n  }\n    }\n\n.cart-gift-message {\n  overflow: hidden;\n  border-top: 1px solid var(--black-o-20);\n  border-bottom: 1px solid var(--black-o-20);\n  margin-bottom: 20px;\n  padding: 15px 0;\n}\n\n@media (min-width: 768px) {\n\n.cart-gift-message {\n    margin-bottom: 15px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart-gift-message {\n    padding: 20px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart-gift-message {\n    margin-bottom: 20px\n}\n  }\n\n.cart-grid--mini-cart .cart-gift-message {\n    margin-right: 20px;\n    margin-left: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart-gift-message {\n      margin: 0 25px 25px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-gift-message {\n      margin: 0 30px 20px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart .cart-gift-message {\n      margin: 0 40px 30px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--mini-cart .cart-gift-message {\n      margin: 0 50px 40px\n  }\n    }\n\n.cart-gift-message__toggle {\n  margin: 0;\n  cursor: pointer;\n}\n\n.cart-gift-message__toggle-icon {\n  position: relative;\n  flex-shrink: 0;\n  width: 10px;\n  height: 10px;\n  margin-left: 10px;\n}\n\n.cart-gift-message__toggle-icon::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0);\n    width: 10px;\n    height: 1px;\n    background-color: var(--red);\n  }\n\n.cart-gift-message__toggle-icon::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0);\n    transition: transform var(--duration) var(--ease);\n    width: 1px;\n    height: 10px;\n    background-color: var(--red);\n  }\n\n.cart-gift-message__toggle-icon.is-open::after {\n      transform: translate3d(-50%, -50%, 0) rotate(-90deg);\n    }\n\n.cart-gift-message__input {\n  opacity: 0;\n  visibility: hidden;\n  transition: max-height var(--duration) var(--ease), visibility var(--duration) var(--ease), opacity var(--duration) var(--ease);\n  max-height: 0;\n}\n\n.cart-gift-message__input::before {\n    content: '';\n    display: block;\n    padding-bottom: 15px;\n  }\n\n.cart-gift-message__input.is-open {\n    opacity: 1;\n    visibility: visible;\n    max-height: 200px;\n  }\n\n.cart-gift-message__input label {\n    margin: 0;\n  }\n\n.cart-gift-message__input textarea {\n    border-color: var(--black-o-20);\n    width: 100%;\n    height: 80px;\n    padding: 10px;\n    resize: none;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-gift-message__input textarea {\n        height: 110px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart-gift-message__input textarea {\n        height: 130px\n    }\n      }\n\n.cart-grid {\n  position: relative;\n}\n\n.cart-grid--mini-cart {\n    height: calc(100% - 60px);\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart {\n      height: calc(100% - 75px)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart {\n      height: calc(100% - 91px)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart {\n      height: calc(100% - 101px)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--mini-cart {\n      height: calc(100% - 118px)\n  }\n    }\n\n.cart-grid--mini-cart .cart-grid__container {\n    display: flex;\n    height: 100%;\n  }\n\n.cart-grid--mini-cart .cart-grid__container-inner {\n    width: 100%;\n    height: 100%;\n  }\n\n.cart-grid--mini-cart .cart-grid__inner {\n    flex-direction: column;\n    display: flex;\n    width: 100%;\n    height: 100%;\n  }\n\n.cart-grid__header {\n  padding: 30px 0;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.cart-grid__header {\n    padding-bottom: 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid__header {\n    padding-top: 60px;\n    padding-bottom: 50px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart-grid__header {\n    padding-top: 80px;\n    padding-bottom: 60px\n}\n  }\n\n.cart-grid__content {\n  height: 100%;\n}\n\n.cart-grid--default .cart-grid__content {\n    height: auto;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-grid__content {\n      padding-bottom: 60px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart-grid__content {\n      padding-bottom: 80px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--default .cart-grid__content {\n      padding-bottom: 80px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--default .cart-grid__content {\n      padding-bottom: 80px\n  }\n    }\n\n.cart__header {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart__header {\n      display: table-header-group;\n      border-bottom: 1px solid var(--black)\n  }\n    }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart__header__item {\n      display: table-cell;\n      padding: 0 0 8px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart__header__item {\n      padding-bottom: 15px\n  }\n    }\n\n.cart__header__item:first-child {\n    width: 45%;\n  }\n\n@media (min-width: 1000px) {\n\n.cart__header__item:first-child {\n      width: 45.248%\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart__header__item:first-child {\n      width: 45.2%\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart__header__item:first-child {\n      width: 45.38%\n  }\n    }\n\n.cart__header__item:nth-of-type(2),\n  .cart__header__item:nth-of-type(3) {\n    width: 20.79%;\n  }\n\n@media (min-width: 1000px) {\n\n.cart__header__item:nth-of-type(2),\n  .cart__header__item:nth-of-type(3) {\n      width: 20.03%\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart__header__item:nth-of-type(2),\n  .cart__header__item:nth-of-type(3) {\n      width: 20.7%\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart__header__item:nth-of-type(2),\n  .cart__header__item:nth-of-type(3) {\n      width: 20.38%\n  }\n    }\n\n.cart__header__item:last-child {\n    width: 13.42%;\n  }\n\n@media (min-width: 1000px) {\n\n.cart__header__item:last-child {\n      width: 14.692%\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart__header__item:last-child {\n      width: 13.4%\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart__header__item:last-child {\n      width: 13.86%\n  }\n    }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart__body {\n      display: table-row-group\n  }\n    }\n\n.cart__error {\n  margin-top: -5px;\n  margin-bottom: 20px;\n  padding: 10px 10px 16px;\n  background-color: var(--sage);\n}\n\n@media (min-width: 768px) {\n\n.cart__error {\n    max-width: 65.79%;\n    margin-top: 0;\n    padding-bottom: 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart__error {\n    max-width: 65.278%;\n    margin-bottom: 25px;\n    padding: 15px 20px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart__error {\n    max-width: 65.9%;\n    margin-bottom: 30px;\n    padding-bottom: 21px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.cart__error {\n    max-width: 65.76%\n}\n  }\n\n.cart__error p {\n    margin: 0;\n  }\n\n.cart-grid--mini-cart .cart__error {\n    max-width: none;\n    margin-top: 0;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart__error {\n      padding: 10px 15px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart__error {\n      padding: 15px 20px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--mini-cart .cart__error {\n      padding-bottom: 20px\n  }\n    }\n\n.cart__update {\n  border-top: 1px solid var(--black-o-20);\n  padding: 15px 0 27px;\n}\n\n@media (min-width: 768px) {\n\n.cart__update {\n    padding: 20px 0 0\n}\n  }\n\n.cart__footer {\n  padding: 30px 20px 20px;\n  background-color: var(--parchment);\n}\n\n@media (min-width: 768px) {\n\n.cart__footer {\n    padding: 15px 15px 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart__footer {\n    padding: 20px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart__footer {\n    padding: 30px\n}\n  }\n\n.cart-grid--mini-cart .cart__footer {\n    padding: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart__footer {\n      padding: 20px 25px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart__footer {\n      padding: 25px 30px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart .cart__footer {\n      padding: 25px 40px 30px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--mini-cart .cart__footer {\n      padding: 35px 50px 30px\n  }\n    }\n\n.template-cart .cart__footer {\n    margin-left: -20px;\n    margin-right: -20px;\n  }\n\n@media (min-width: 768px) {\n\n.template-cart .cart__footer {\n      margin: 0\n  }\n    }\n\n.cart__subtotal {\n  border-bottom: 1px solid var(--black-o-20);\n  margin: 0 0 15px;\n  padding-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n\n.cart__subtotal {\n    padding-bottom: 15px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart__subtotal {\n    padding-bottom: 25px\n}\n  }\n\n.cart__subtotal .h3 {\n    margin: 0;\n  }\n\n.cart-grid--mini-cart .cart__subtotal {\n    margin: 0;\n    border-bottom: none;\n    padding-bottom: 18px;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart__subtotal {\n      padding-bottom: 22px\n  }\n    }\n\n.cart-grid--default .cart__footer-bottom-text {\n    margin: 0 0 20px;\n    text-align: left;\n  }\n\n.cart-grid--mini-cart .cart__footer-bottom-text {\n    margin: 10px 0 0;\n    text-align: left;\n    font-size: 13px;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart__footer-bottom-text {\n      margin-top: 20px;\n      font-size: 15px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-grid__form {\n      display: block\n  }\n    }\n\n@media (min-width: 1024px) {\n\n.cart-grid--default .cart-grid__form {\n      display: flex;\n      align-items: flex-start\n  }\n    }\n\n.cart-grid--mini-cart .cart-grid__form {\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: stretch;\n    display: flex;\n    height: 100%;\n  }\n\n.cart-grid__items.is-loading {\n    opacity: 0.6;\n    pointer-events: none;\n  }\n\n.cart-grid--default .cart-grid__items {\n    width: 100%;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-grid__items {\n      display: table;\n      table-layout: fixed;\n      border-collapse: collapse\n  }\n    }\n\n.cart-grid--mini-cart .cart-grid__items {\n    position: relative;\n    z-index: 0;\n    overflow-y: auto;\n    flex: 1 1 auto;\n    min-height: 0;\n    margin-bottom: 0;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart__inner {\n      width: 100%;\n      padding-right: 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart__inner {\n      width: calc(100% - 300px);\n      padding-right: 15px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--default .cart__inner {\n      width: calc(100% - 320px);\n      padding-right: 20px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--default .cart__inner {\n      width: calc(100% - 351px);\n      padding-right: 25px\n  }\n    }\n\n.cart-grid--mini-cart .cart__inner {\n    flex-direction: column;\n    flex: 1 1 auto;\n    display: flex;\n    overflow: hidden;\n    padding: 0 20px;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart__inner {\n      padding: 0 25px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart__inner {\n      padding: 0 30px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart .cart__inner {\n      padding: 0 40px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--mini-cart .cart__inner {\n      padding: 0 50px\n  }\n    }\n\n.cart__footer-wrapper {\n  flex-direction: column;\n}\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart__footer-wrapper {\n      width: 100%\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart__footer-wrapper {\n      width: 300px;\n      padding-top: 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--default .cart__footer-wrapper {\n      width: 320px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--default .cart__footer-wrapper {\n      width: 351px\n  }\n    }\n\n.cart__footer-button-group {\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n@media (min-width: 768px) {\n\n.cart__footer-button-group {\n    justify-content: flex-start\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart__footer-button-group {\n    justify-content: space-between;\n    align-items: center\n}\n  }\n\n.cart__footer-button {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.cart-grid--default .cart__footer-button:not(:last-child) {\n      width: 100%;\n      min-width: auto;\n      margin-bottom: 15px;\n    }\n\n.cart-grid--default .cart__footer-button:last-child {\n      margin-right: auto;\n    }\n\n.mini-cart .cart__footer-button {\n    width: 100%;\n  }\n\nbutton.cart__footer-button {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  border-radius: 20px;\n  height: 35px;\n}\n\n@media (min-width: 1024px) {\n\nbutton.cart__footer-button {\n    padding-top: 14px;\n    padding-bottom: 14px\n}\n  }\n\n.cart__update-btn {\n  color: var(--red);\n}\n\n.cart__update-btn svg {\n    margin-right: 8px;\n  }\n\n@media (min-width: 1000px) {\n\n.cart__update-btn svg {\n      margin-right: 10px\n  }\n    }\n\n.cart-grid__empty {\n  padding: 93px 0 171px;\n}\n\n@media (min-width: 768px) {\n\n.cart-grid__empty {\n    padding: 123px 0 246px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid__empty {\n    padding: 119px 0 228px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart-grid__empty {\n    padding: 127px 0 345px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.cart-grid__empty {\n    padding: 152px 0 287px\n}\n  }\n\n.cart-grid--mini-cart .cart-grid__empty {\n    margin: auto;\n    padding: 20px 0 96px;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart-grid__empty {\n      padding-bottom: 107px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-grid__empty {\n      padding-bottom: 128px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart .cart-grid__empty {\n      padding-bottom: 145px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.cart-grid--mini-cart .cart-grid__empty {\n      padding-bottom: 155px\n  }\n    }\n\n.cart-grid__empty-icon {\n  width: 27px;\n  margin: 0 auto 10px;\n  color: var(--red);\n}\n\n@media (min-width: 1000px) {\n\n.cart-grid__empty-icon {\n    width: 35px;\n    margin-bottom: 20px\n}\n  }\n\n.cart-grid__empty-title {\n  margin: 0 0 16px;\n}\n\n@media (min-width: 1000px) {\n\n.cart-grid__empty-title {\n    margin-bottom: 20px\n}\n  }\n\n.cart__footer-bottom-error {\n  margin-top: 10px;\n}\n\n.cart-grid__zapiet-seed {\n  display: none;\n}\n\n.cart-grid__zapiet {\n  width: 100%;\n}\n\n#storePickupApp {\n  width: 100%;\n  margin: 0 0 20px !important;\n}\n\n#storePickupApp:empty {\n    display: none;\n  }\n\n#storePickupApp input[type=\"text\"] {\n    padding: 9px 15px !important;\n    background: transparent !important;\n    border-radius: 20px !important;\n    border: 1px solid rgba(0, 0, 0, 0.20) !important;\n    color: var(--black) !important;\n    font-size: 13px !important;\n    line-height: 1.2 !important;\n  }\n\n#storePickupApp input[type=\"text\"]::-webkit-input-placeholder {\n      color: rgba(0, 0, 0, 0.80) !important;\n    }\n\n#storePickupApp input[type=\"text\"]::placeholder {\n      color: rgba(0, 0, 0, 0.80) !important;\n    }\n\n#storePickupApp input[type=\"text\"]:focus {\n      border-color: var(--black) !important;\n    }\n\n#storePickupApp .checkoutMethodsContainer .checkoutMethod,\n    #storePickupApp .checkoutMethodsContainer .checkoutMethod.active {\n      padding: 16px;\n      border-radius: 8px;\n      border: 1px solid rgba(0, 0, 0, 0.20);\n      border-color: rgba(0, 0, 0, 0.20) !important;\n      background: transparent !important;\n    }\n\n@media (min-width: 1000px) {\n\n#storePickupApp .checkoutMethodsContainer .checkoutMethod,\n    #storePickupApp .checkoutMethodsContainer .checkoutMethod.active {\n        padding: 20px\n    }\n      }\n\n#storePickupApp .checkoutMethodsContainer .checkoutMethod .checkoutMethodImage, #storePickupApp .checkoutMethodsContainer .checkoutMethod.active .checkoutMethodImage {\n        padding-bottom: 4px;\n      }\n\n#storePickupApp .checkoutMethodsContainer .checkoutMethod .checkoutMethodImage .deliveryIcon, #storePickupApp .checkoutMethodsContainer .checkoutMethod.active .checkoutMethodImage .deliveryIcon {\n          width: 20px;\n          height: 20px;\n          background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.24805%203.25C3.65131%203.25%203.07901%203.48705%202.65706%203.90901C2.2351%204.33097%201.99805%204.90326%201.99805%205.5V16C1.99805%2016.5967%202.2351%2017.169%202.65706%2017.591C3.07901%2018.0129%203.65131%2018.25%204.24805%2018.25H4.30005C4.43236%2018.9523%204.80586%2019.5864%205.356%2020.0425C5.90615%2020.4987%206.59837%2020.7484%207.31304%2020.7484C8.02772%2020.7484%208.71994%2020.4987%209.27009%2020.0425C9.82023%2019.5864%2010.1937%2018.9523%2010.326%2018.25H14.05C14.1824%2018.9523%2014.5559%2019.5864%2015.106%2020.0425C15.6561%2020.4987%2016.3484%2020.7484%2017.063%2020.7484C17.7777%2020.7484%2018.4699%2020.4987%2019.0201%2020.0425C19.5702%2019.5864%2019.9437%2018.9523%2020.076%2018.25H21.998C22.1969%2018.25%2022.3877%2018.171%2022.5284%2018.0303C22.669%2017.8897%2022.748%2017.6989%2022.748%2017.5C22.748%2017.3011%2022.669%2017.1103%2022.5284%2016.9697C22.3877%2016.829%2022.1969%2016.75%2021.998%2016.75V12.405C21.998%2011.955%2021.864%2011.516%2021.612%2011.145L19.065%207.379C18.859%207.07447%2018.5814%206.82509%2018.2566%206.65267C17.9318%206.48026%2017.5697%206.39007%2017.202%206.39H15.748V5.5C15.748%204.90326%2015.511%204.33097%2015.089%203.90901C14.6671%203.48705%2014.0948%203.25%2013.498%203.25H4.24805ZM7.31304%2014.62C6.6636%2014.6205%206.03106%2014.827%205.50638%2015.2098C4.98169%2015.5925%204.5919%2016.1318%204.39305%2016.75H4.24805C4.04913%2016.75%203.85837%2016.671%203.71772%2016.5303C3.57706%2016.3897%203.49805%2016.1989%203.49805%2016V5.5C3.49805%205.30109%203.57706%205.11032%203.71772%204.96967C3.85837%204.82902%204.04913%204.75%204.24805%204.75H13.498C13.697%204.75%2013.8877%204.82902%2014.0284%204.96967C14.169%205.11032%2014.248%205.30109%2014.248%205.5V16.47C14.208%2016.5613%2014.173%2016.6547%2014.143%2016.75H10.233C10.0342%2016.1318%209.6444%2015.5925%209.11971%2015.2098C8.59503%2014.827%207.96249%2014.6205%207.31304%2014.62ZM17.063%2014.62C16.593%2014.62%2016.146%2014.726%2015.748%2014.916V12.695H20.498V16.75H19.983C19.7842%2016.1318%2019.3944%2015.5925%2018.8697%2015.2098C18.345%2014.827%2017.7125%2014.6205%2017.063%2014.62ZM19.835%2011.195H15.748V7.89H17.202C17.3245%207.89022%2017.445%207.92042%2017.5531%207.97794C17.6611%208.03546%2017.7535%208.11857%2017.822%208.22L19.835%2011.195ZM15.498%2017.685C15.498%2017.4795%2015.5385%2017.276%2015.6172%2017.0861C15.6958%2016.8962%2015.8111%2016.7237%2015.9564%2016.5784C16.1017%2016.4331%2016.2743%2016.3178%2016.4641%2016.2391C16.654%2016.1605%2016.8575%2016.12%2017.063%2016.12C17.2686%2016.12%2017.4721%2016.1605%2017.6619%2016.2391C17.8518%2016.3178%2018.0243%2016.4331%2018.1697%2016.5784C18.315%2016.7237%2018.4303%2016.8962%2018.5089%2017.0861C18.5876%2017.276%2018.628%2017.4795%2018.628%2017.685C18.628%2018.1001%2018.4632%2018.4981%2018.1697%2018.7916C17.8762%2019.0851%2017.4781%2019.25%2017.063%2019.25C16.648%2019.25%2016.2499%2019.0851%2015.9564%2018.7916C15.6629%2018.4981%2015.498%2018.1001%2015.498%2017.685ZM5.74804%2017.685C5.74804%2017.4795%205.78853%2017.276%205.86717%2017.0861C5.94582%2016.8962%206.0611%2016.7237%206.20642%2016.5784C6.35175%2016.4331%206.52427%2016.3178%206.71414%2016.2391C6.90402%2016.1605%207.10753%2016.12%207.31304%2016.12C7.51856%2016.12%207.72207%2016.1605%207.91194%2016.2391C8.10182%2016.3178%208.27434%2016.4331%208.41967%2016.5784C8.56499%2016.7237%208.68027%2016.8962%208.75892%2017.0861C8.83756%2017.276%208.87804%2017.4795%208.87804%2017.685C8.87804%2018.1001%208.71316%2018.4981%208.41967%2018.7916C8.12617%2019.0851%207.72811%2019.25%207.31304%2019.25C6.89798%2019.25%206.49992%2019.0851%206.20642%2018.7916C5.91293%2018.4981%205.74805%2018.1001%205.74804%2017.685Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E');\n          background-size: 100%;\n          background-repeat: no-repeat;\n          background-position: center;\n          filter: invert(1);\n        }\n\n#storePickupApp .checkoutMethodsContainer .checkoutMethod .checkoutMethodImage .deliveryIcon svg, #storePickupApp .checkoutMethodsContainer .checkoutMethod.active .checkoutMethodImage .deliveryIcon svg {\n            display: none;\n          }\n\n#storePickupApp .checkoutMethodsContainer .checkoutMethod .checkoutMethodName, #storePickupApp .checkoutMethodsContainer .checkoutMethod.active .checkoutMethodName {\n        font-size: 13px;\n        line-height: 1.2;\n        color: var(--black) !important;\n      }\n\n@media (min-width: 1000px) {\n\n#storePickupApp .checkoutMethodsContainer .checkoutMethod .checkoutMethodName, #storePickupApp .checkoutMethodsContainer .checkoutMethod.active .checkoutMethodName {\n          font-size: 15px\n      }\n        }\n\n#storePickupApp .checkoutMethodContainer {\n    padding-top: 20px;\n  }\n\n#storePickupApp .checkoutMethodContainer .delivery_note {\n      font-size: 13px;\n      line-height: 1.2;\n      color: var(--black) !important;\n      margin-bottom: 20px;\n    }\n\n@media (min-width: 1000px) {\n\n#storePickupApp .checkoutMethodContainer .delivery_note {\n        font-size: 15px\n    }\n      }\n\n#storePickupApp .checkoutMethodContainer .inputWithButton {\n      grid-gap: 8px;\n      gap: 8px;\n      height: 40px;\n    }\n\n#storePickupApp .checkoutMethodContainer .inputWithButton .button {\n        width: 40px;\n        height: 40px;\n        color: var(--white);\n        background-color: var(--red);\n        border-radius: 100%;\n        border: 0;\n      }\n\n#storePickupApp .checkoutMethodContainer .inputWithButton .button:not([disabled]):hover {\n          color: var(--white);\n          background-color: var(--red-1);\n        }\n\n#storePickupApp .checkoutMethodContainer .inputWithButton .button:not([disabled]):hover::after {\n            content: none;\n          }\n\n#storePickupApp .checkoutMethodContainer .inputWithButton .button .searchIcon {\n          width: 12px;\n          height: 12px;\n          background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M11.0667%2012L6.86667%207.8C6.53333%208.06667%206.15%208.27778%205.71667%208.43333C5.28333%208.58889%204.82222%208.66667%204.33333%208.66667C3.12222%208.66667%202.09733%208.24711%201.25867%207.408C0.42%206.56889%200.000444797%205.544%203.52734e-07%204.33333C-0.000444092%203.12267%200.419111%202.09778%201.25867%201.25867C2.09822%200.419556%203.12311%200%204.33333%200C5.54356%200%206.56867%200.419556%207.40867%201.25867C8.24867%202.09778%208.668%203.12267%208.66667%204.33333C8.66667%204.82222%208.58889%205.28333%208.43333%205.71667C8.27778%206.15%208.06667%206.53333%207.8%206.86667L12%2011.0667L11.0667%2012ZM4.33333%207.33333C5.16667%207.33333%205.87511%207.04178%206.45867%206.45867C7.04222%205.87556%207.33378%205.16711%207.33333%204.33333C7.33289%203.49956%207.04133%202.79133%206.45867%202.20867C5.876%201.626%205.16756%201.33422%204.33333%201.33333C3.49911%201.33244%202.79089%201.62422%202.20867%202.20867C1.62644%202.79311%201.33467%203.50133%201.33333%204.33333C1.332%205.16533%201.62378%205.87378%202.20867%206.45867C2.79356%207.04356%203.50178%207.33511%204.33333%207.33333Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E');\n          background-size: 100%;\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n\n#storePickupApp .checkoutMethodContainer .inputWithButton .button .searchIcon svg {\n            display: none;\n          }\n\n#storePickupApp .checkoutMethodContainer .delivery_success p {\n      margin: 20px 0;\n      font-size: 13px;\n      line-height: 1.2;\n      color: var(--black) !important;\n    }\n\n@media (min-width: 1000px) {\n\n#storePickupApp .checkoutMethodContainer .delivery_success p {\n        font-size: 15px !important\n    }\n      }\n\n#storePickupApp .ZapietStack .Zapiet-InputWithPrefix__Wrapper {\n      background: transparent;\n      border: 1px solid rgba(0, 0, 0, 0.20);\n      border-radius: 20px;\n    }\n\n#storePickupApp .ZapietStack .Zapiet-InputWithPrefix__Wrapper .Zapiet-InputWithPrefix .Zapiet-InputWithPrefix__Input {\n        padding: 9px 41px !important;\n      }\n\n#storePickupApp .ZapietStack .Zapiet-InputWithPrefix__Wrapper .Zapiet-InputWithPrefix__Prefix .datepickerIcon {\n          width: 16px;\n          height: 16px;\n          background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M12.6667%2012.6665H3.33333V5.33317H12.6667M10.6667%200.666504V1.99984H5.33333V0.666504H4V1.99984H3.33333C2.59333%201.99984%202%202.59317%202%203.33317V12.6665C2%2013.0201%202.14048%2013.3593%202.39052%2013.6093C2.64057%2013.8594%202.97971%2013.9998%203.33333%2013.9998H12.6667C13.0203%2013.9998%2013.3594%2013.8594%2013.6095%2013.6093C13.8595%2013.3593%2014%2013.0201%2014%2012.6665V3.33317C14%202.97955%2013.8595%202.64041%2013.6095%202.39036C13.3594%202.14031%2013.0203%201.99984%2012.6667%201.99984H12V0.666504M11.3333%207.99984H8V11.3332H11.3333V7.99984Z%22%20fill%3D%22black%22%2F%3E%0A%3C%2Fsvg%3E');\n          background-size: 100%;\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n\n#storePickupApp .ZapietStack .Zapiet-InputWithPrefix__Wrapper .Zapiet-InputWithPrefix__Prefix .datepickerIcon svg {\n            display: none;\n          }\n\n#storePickupApp .Zapiet-Calendar__Wrapper {\n    border-radius: 8px;\n    border: 1px solid rgba(0, 0, 0, 0.10);\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.25);\n  }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar {\n      padding: 16px;\n    }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Month {\n        font-size: 15px;\n        line-height: 1.2;\n        color: var(--black) !important;\n        margin-bottom: 10px;\n      }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Month .Zapiet-Calendar__Nav {\n          border-radius: 48px;\n          border: 1px solid rgba(0, 0, 0, 0.10) !important;\n        }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Month .Zapiet-Calendar__Nav:after {\n            content: none;\n          }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Days {\n        margin-bottom: 16px;\n        color: var(--black) !important;\n        opacity: 0.4;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 125%;\n        letter-spacing: 1px;\n        text-transform: uppercase;\n      }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Dates {\n        grid-gap: 16px 0;\n        gap: 16px 0;\n      }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Dates button {\n          position: relative;\n          font-size: 14px;\n          font-weight: 400;\n          line-height: 125%;\n          letter-spacing: 1px;\n          text-transform: uppercase;\n          height: 18px;\n          background: transparent !important;\n          opacity: 1 !important;\n        }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Dates button::after {\n            border-top-color: var(--red) !important;\n          }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Dates button::before {\n            content: '';\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            width: 32px;\n            height: 32px;\n            background: var(--red);\n            transform: translate(-50%, -50%);\n            opacity: 0;\n            border-radius: 100%;\n            transition: all 0.3s ease;\n            z-index: -1;\n            pointer-events: none;\n          }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Dates button.picker__day--disabled {\n            opacity: 0.2 !important;\n          }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Dates button:not(.picker__day--disabled):hover {\n            color: var(--white) !important;\n          }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Dates button:not(.picker__day--disabled):hover::before {\n              opacity: 1;\n            }\n\n#storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar .Zapiet-Calendar__Dates button.picker__day--selected::before {\n              opacity: 1;\n            }\n\n#storePickupApp .ZapietStack.ZapietStack--spacing-tight {\n    grid-gap: 0;\n    gap: 0;\n  }\n\n#storePickupApp .Zapiet-Select__Wrapper {\n    margin-top: 20px;\n    background: transparent;\n    border-radius: 20px;\n    border: 1px solid rgba(0, 0, 0, 0.20);\n    height: 40px;\n  }\n\n#storePickupApp .Zapiet-Select__Wrapper .Zapiet-Select__Prefix .datepickerIcon {\n        width: 16px;\n        height: 16px;\n        background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M8%2014.4C9.69739%2014.4%2011.3253%2013.7257%2012.5255%2012.5255C13.7257%2011.3253%2014.4%209.69739%2014.4%208C14.4%206.30261%2013.7257%204.67475%2012.5255%203.47452C11.3253%202.27428%209.69739%201.6%208%201.6C6.30261%201.6%204.67475%202.27428%203.47452%203.47452C2.27428%204.67475%201.6%206.30261%201.6%208C1.6%209.69739%202.27428%2011.3253%203.47452%2012.5255C4.67475%2013.7257%206.30261%2014.4%208%2014.4ZM8%200C9.05058%200%2010.0909%200.206926%2011.0615%200.608964C12.0321%201.011%2012.914%201.60028%2013.6569%202.34315C14.3997%203.08601%2014.989%203.96793%2015.391%204.93853C15.7931%205.90914%2016%206.94943%2016%208C16%2010.1217%2015.1571%2012.1566%2013.6569%2013.6569C12.1566%2015.1571%2010.1217%2016%208%2016C3.576%2016%200%2012.4%200%208C0%205.87827%200.842855%203.84344%202.34315%202.34315C3.84344%200.842855%205.87827%200%208%200ZM8.4%204V8.2L12%2010.336L11.4%2011.32L7.2%208.8V4H8.4Z%22%20fill%3D%22black%22%2F%3E%0A%3C%2Fsvg%3E');\n        background-size: 100%;\n        background-repeat: no-repeat;\n        background-position: center;\n      }\n\n#storePickupApp .Zapiet-Select__Wrapper .Zapiet-Select__Prefix .datepickerIcon svg {\n          display: none;\n        }\n\n#storePickupApp .Zapiet-Select__Wrapper .Zapiet-Select__Prefix .Zapiet-Select__Value {\n        color: var(--White);\n        font-size: 13px;\n        line-height: 120%;\n        margin-left: 10px;\n      }\n\n#storePickupApp .Zapiet-Select__Wrapper::after {\n      content: '';\n      width: 11px;\n      height: 6px;\n      background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%227%22%20viewBox%3D%220%200%2012%207%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M0%200.699863L5.66%206.35986L11.32%200.699863L10.61%20-0.000137329L5.66%204.94986L0.71%20-0.000137329L0%200.699863Z%22%20fill%3D%22black%22%2F%3E%0A%3C%2Fsvg%3E');\n      background-size: 100%;\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n.Zapiet-Daily-Limits {\n  z-index: 1000;\n}\n\n/* Berries cart / mini-cart — colors from theme settings (Cart → Berries cart colors) */\n\n.template-cart.template-cart--berries {\n  background-color: var(--berries-cart-bg, var(--pine));\n}\n\n.template-cart.template-cart--berries.is-transparent-header .header {\n    border-bottom-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent);\n  }\n\n.template-cart.template-cart--berries .main {\n    background-color: var(--berries-cart-bg, var(--pine));\n  }\n\n/* —— Cart page —— */\n\n.cart-grid--berries.cart-grid--default {\n  background-color: var(--berries-cart-bg, var(--pine));\n  color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries.cart-grid--default .cart-grid__header {\n  background-color: transparent;\n}\n\n.cart-grid--berries.cart-grid--default .cart-grid__header .h1 {\n  color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries.cart-grid--default .cart__header__item,\n.cart-grid--berries.cart-grid--default .cart__update-btn span,\n.cart-grid--berries.cart-grid--default .label:not(.color-errors) {\n  color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries .cart__update {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.cart-grid--berries.cart-grid--default .cart__header {\n    border-bottom-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent)\n}\n  }\n\n.cart-grid--berries.cart-grid--default .cart__footer {\n  background-color: var(--berries-cart-surface-bg, var(--berries-cart-charcoal));\n}\n\n.cart-grid--berries.cart-grid--default .cart__subtotal {\n  border-bottom-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent);\n}\n\n.cart-grid--berries.cart-grid--default .cart__subtotal .h3,\n.cart-grid--berries.cart-grid--default .cart__footer-bottom-text {\n  color: var(--berries-cart-color, var(--white));\n}\n\n/* —— Mini cart drawer —— */\n\n.mini-cart--berries {\n  background-color: var(--berries-cart-bg, var(--pine));\n  color: var(--berries-cart-color, var(--white));\n}\n\n.mini-cart--berries .mini-cart__header {\n  background-color: var(--berries-cart-surface-bg, var(--berries-cart-charcoal));\n}\n\n.mini-cart--berries .mini-cart__header-title {\n  color: var(--berries-cart-color, var(--white));\n}\n\n.mini-cart--berries .mini-cart__close {\n  color: var(--berries-cart-color, var(--white));\n}\n\n.mini-cart--berries .cart-grid__items,\n.mini-cart--berries .cart__inner {\n  background-color: var(--berries-cart-surface-bg, var(--berries-cart-charcoal));\n}\n\n.mini-cart--berries .cart__footer {\n  background-color: var(--berries-cart-bg, var(--pine));\n}\n\n/* —— Line items (cart + mini cart) —— */\n\n.cart-grid--berries .cart-item {\n  border-top-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent);\n}\n\n.cart-grid--berries .cart-item__details-link,\n.cart-grid--berries .cart-item__details-price,\n.cart-grid--berries .cart-item__total,\n.cart-grid--berries .cart-item__details-quantity-text,\n.cart-grid--berries .cart-item__remove {\n  color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries .cart-item__remove:hover {\n    color: var(--berries-cart-color, var(--white));\n  }\n\n.cart-grid--berries .cart-item__details-content {\n  color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 75%, transparent);\n}\n\n.cart-grid--berries .cart-item-bundle__title,\n.cart-grid--berries .cart-item-bundle__price,\n.cart-grid--berries .cart-item-bundle__item-title {\n  color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries .cart__subtotal .h3,\n.cart-grid--berries .cart__subtotal .label,\n.cart-grid--berries .cart__footer-bottom-text {\n  color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries .quantity-selector {\n  border-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent);\n  color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries .quantity-selector__field {\n  color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries .quantity-selector__field:focus {\n    box-shadow: inset 0 0 0 1px var(--berries-cart-color, var(--white));\n  }\n\n.cart-grid--berries .cart__footer-button.button--primary {\n  color: var(--berries-cart-color, var(--white));\n  border-bottom-color: var(--berries-cart-color, var(--white));\n}\n\n.cart-grid--berries .cart__footer-button.button--primary::after {\n    background: var(--berries-cart-color, var(--white));\n  }\n\n.cart-grid--berries .cart__footer-button.button--primary:not([disabled]):hover {\n    color: var(--berries-cart-color, var(--white));\n    border-bottom-color: transparent;\n  }\n\n/* Zapiet widget on dark footer */\n\n.cart-grid--berries #storePickupApp input[type=\"text\"] {\n    border-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent) !important;\n    color: var(--berries-cart-color, var(--white)) !important;\n  }\n\n.cart-grid--berries #storePickupApp input[type=\"text\"]::-webkit-input-placeholder {\n      color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 75%, transparent) !important;\n    }\n\n.cart-grid--berries #storePickupApp input[type=\"text\"]::placeholder {\n      color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 75%, transparent) !important;\n    }\n\n.cart-grid--berries #storePickupApp input[type=\"text\"]:focus {\n      border-color: var(--berries-cart-color, var(--white)) !important;\n    }\n\n.cart-grid--berries #storePickupApp .checkoutMethodsContainer .checkoutMethod,\n    .cart-grid--berries #storePickupApp .checkoutMethodsContainer .checkoutMethod.active {\n      border-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent) !important;\n    }\n\n.cart-grid--berries #storePickupApp .checkoutMethodsContainer .checkoutMethod .checkoutMethodImage .deliveryIcon, .cart-grid--berries #storePickupApp .checkoutMethodsContainer .checkoutMethod.active .checkoutMethodImage .deliveryIcon {\n        filter: none;\n      }\n\n.cart-grid--berries #storePickupApp .checkoutMethodsContainer .checkoutMethod .checkoutMethodName, .cart-grid--berries #storePickupApp .checkoutMethodsContainer .checkoutMethod.active .checkoutMethodName {\n        color: var(--berries-cart-color, var(--white)) !important;\n      }\n\n.cart-grid--berries #storePickupApp .checkoutMethodsContainer .checkoutMethodName {\n      color: var(--berries-cart-color, var(--white)) !important;\n    }\n\n.cart-grid--berries #storePickupApp .checkoutMethodsContainer .deliveryIcon {\n      filter: none;\n    }\n\n.cart-grid--berries #storePickupApp .checkoutMethodContainer .delivery_note,\n  .cart-grid--berries #storePickupApp .checkoutMethodContainer .delivery_success p {\n    color: var(--berries-cart-color, var(--white)) !important;\n  }\n\n.cart-grid--berries #storePickupApp .spinnerContainer {\n    filter: invert(1);\n  }\n\n.cart-grid--berries #storePickupApp .ZapietStack .Zapiet-InputWithPrefix__Wrapper {\n    border-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent) !important;\n    height: 42px !important;\n  }\n\n.cart-grid--berries #storePickupApp .ZapietStack .Zapiet-InputWithPrefix__Wrapper .Zapiet-InputWithPrefix .Zapiet-InputWithPrefix__Input {\n      color: var(--berries-cart-color, var(--white)) !important;\n    }\n\n.cart-grid--berries #storePickupApp .ZapietStack .Zapiet-InputWithPrefix__Wrapper .Zapiet-InputWithPrefix__Prefix .datepickerIcon {\n      filter: invert(1);\n    }\n\n.cart-grid--berries #storePickupApp .Zapiet-Calendar__Wrapper {\n    background: var(--berries-cart-bg, var(--pine));\n    border-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 10%, transparent);\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.25);\n  }\n\n.cart-grid--berries #storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar__Month {\n      color: var(--berries-cart-color, var(--white)) !important;\n    }\n\n.cart-grid--berries #storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar__Month .Zapiet-Calendar__Nav {\n        border-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 10%, transparent) !important;\n        filter: invert(1);\n      }\n\n.cart-grid--berries #storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar__Days {\n      color: var(--berries-cart-color, var(--white)) !important;\n    }\n\n.cart-grid--berries #storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar__Dates button {\n      color: var(--berries-cart-color, var(--white)) !important;\n    }\n\n.cart-grid--berries #storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar__Dates button.picker__day--highlighted,\n      .cart-grid--berries #storePickupApp .Zapiet-Calendar__Wrapper .Zapiet-Calendar__Dates button.picker__day--selected {\n        color: var(--white) !important;\n      }\n\n.cart-grid--berries #storePickupApp .Zapiet-Select__Wrapper {\n    border-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent);\n    color: var(--berries-cart-color, var(--white)) !important;\n  }\n\n.cart-grid--berries #storePickupApp .Zapiet-Select__Wrapper .Zapiet-Select__Prefix .datepickerIcon {\n        filter: invert(1);\n      }\n\n.cart-grid--berries #storePickupApp .Zapiet-Select__Wrapper .Zapiet-Select__Prefix .Zapiet-Select__Value {\n        color: var(--berries-cart-color, var(--white));\n      }\n\n.cart-grid--berries #storePickupApp .Zapiet-Select__Wrapper::after {\n      filter: invert(1);\n    }\n\n.cart-grid--berries #storePickupApp .Zapiet-Select__Wrapper .Zapiet-Select__List {\n    background: var(--berries-cart-bg, var(--pine));\n    border-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 10%, transparent);\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.25);\n  }\n\n.cart-grid--berries #storePickupApp .Zapiet-Select__Wrapper .Zapiet-Select__Option:hover,\n  .cart-grid--berries #storePickupApp .Zapiet-Select__Wrapper .Zapiet-Select__Option.Zapiet-Select__Option--selected {\n    background: var(--berries-cart-bg, var(--pine));\n    color: var(--berries-cart-color, var(--white)) !important;\n  }\n\n.Zapiet-Daily-Limits .Zapiet-Daily-Limits-modal {\n  background-color: var(--berries-cart-bg, var(--pine)) !important;\n}\n\n.Zapiet-Daily-Limits .Zapiet-Daily-Limits-modal .Zapiet-Daily-Limits-header .text,\n  .Zapiet-Daily-Limits .Zapiet-Daily-Limits-modal .Zapiet-Daily-Limits-content .variants .variant .variant-name,\n  .Zapiet-Daily-Limits .Zapiet-Daily-Limits-modal .Zapiet-Daily-Limits-content .variants .variant .stock-status,\n  .Zapiet-Daily-Limits .Zapiet-Daily-Limits-modal .Zapiet-Daily-Limits-content .affected-count {\n    color: var(--berries-cart-color, var(--white)) !important;\n  }\n\n.Zapiet-DailyLimits__ItemsLeft {\n  margin-top: 8px !important;\n}\n\n.cart-item {\n  position: relative;\n  border-top: 1px solid var(--black-o-20);\n  padding: 20px 0 17px;\n}\n\n@media (min-width: 768px) {\n\n.cart-item {\n    padding-top: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart-item {\n    padding-top: 25px;\n    padding-bottom: 25px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart-item {\n    padding-top: 30px;\n    padding-bottom: 30px\n}\n  }\n\n.cart-item:first-child {\n    border-top: none;\n    padding-top: 0;\n  }\n\n.cart-item--disabled {\n    display: none !important;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-item {\n      display: table-row;\n      padding: 0\n  }\n    }\n\n.cart-grid--mini-cart .cart-item {\n    border-top: none;\n    margin-bottom: 17px;\n    padding: 0;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart-item {\n      margin-bottom: 20px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-item {\n      margin-bottom: 30px\n  }\n    }\n\n.cart-grid--mini-cart .cart-item:last-child {\n      margin-bottom: 0;\n    }\n\n.cart-item__info {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-item__info {\n      position: static;\n      align-items: flex-start;\n      padding-top: 20px;\n      padding-right: 10px;\n      padding-bottom: 20px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart-item__info {\n      padding-top: 25px;\n      padding-bottom: 25px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--default .cart-item__info {\n      padding-top: 30px;\n      padding-bottom: 30px\n  }\n    }\n\n.cart-item__featured {\n  width: 176px;\n}\n\n@media (min-width: 768px) {\n\n.cart-item__featured {\n    width: 75px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart-item__featured {\n    width: 85px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart-item__featured {\n    width: 112px\n}\n  }\n\n.cart-grid--mini-cart .cart-item__featured {\n    width: 120px;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-item__featured {\n      width: 90px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart .cart-item__featured {\n      width: 122px\n  }\n    }\n\n.cart-item__featured-inner {\n  display: block;\n  border-bottom: none;\n  width: 176px;\n  height: 219px;\n  margin-bottom: 10px;\n}\n\n@media (min-width: 768px) {\n\n.cart-item__featured-inner {\n    width: 75px;\n    height: 94px;\n    margin-bottom: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart-item__featured-inner {\n    width: 85px;\n    height: 107px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart-item__featured-inner {\n    width: 112px;\n    height: 140px\n}\n  }\n\n.cart-item__featured-inner::after {\n    content: none;\n  }\n\n.cart-grid--mini-cart .cart-item__featured-inner {\n    width: 120px;\n    height: 150px;\n    margin-bottom: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-item__featured-inner {\n      width: 90px;\n      height: 112px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart .cart-item__featured-inner {\n      width: 122px;\n      height: 152px\n  }\n    }\n\n.cart-item__details {\n  flex-direction: column;\n  display: flex;\n  width: calc(100% - 176px);\n  padding-left: 10px;\n}\n\n@media (min-width: 768px) {\n\n.cart-item__details {\n    width: calc(100% - 75px)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.cart-item__details {\n    width: calc(100% - 85px)\n}\n  }\n\n@media (min-width: 1240px) {\n\n.cart-item__details {\n    width: calc(100% - 112px);\n    padding-left: 20px\n}\n  }\n\n.cart-grid--mini-cart .cart-item__details {\n    width: calc(100% - 120px);\n    padding-left: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-item__details {\n      width: calc(100% - 90px);\n      padding-left: 15px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart .cart-item__details {\n      width: calc(100% - 122px)\n  }\n    }\n\n.cart-item__details-title {\n  margin: 0 0 5px;\n}\n\n@media (min-width: 1240px) {\n\n.cart-grid--mini-cart .cart-item__details-title {\n      margin-bottom: 8px\n  }\n    }\n\n.cart-item__details-link {\n  border-bottom: none;\n}\n\n.cart-item__details-link::after {\n    content: none;\n  }\n\n.cart-item__details-content {\n  margin: 0;\n  color: var(--black-o-50);\n}\n\n.cart-item__remove {\n  margin-top: 5px;\n  cursor: pointer;\n}\n\n@media (min-width: 1000px) {\n\n.cart-item__remove {\n    margin-top: 10px\n}\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart-item__remove {\n      margin-top: 0\n  }\n    }\n\n.cart-item__details-quantity {\n  margin-top: auto;\n}\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart-item__details-quantity {\n      display: inline-block;\n      margin-right: 15px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart-item__details-quantity {\n      flex-shrink: 0;\n      margin-right: 10px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-item__details-quantity {\n      margin-right: 15px\n  }\n    }\n\n.cart-item__details-price {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\n@media (min-width: 768px) {\n\n.cart-item__details-price {\n    margin-bottom: 0\n}\n  }\n\n.cart-grid--mini-cart .cart-item__details-price {\n    margin-bottom: 5px;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-grid--mini-cart .cart-item__details-price {\n      margin-bottom: 10px\n  }\n    }\n\n@media (min-width: 768px) {\n      .cart-grid--default .cart-item__details-price--mobile {\n        display: none;\n      }\n    }\n\n.cart-item__details-price--desktop {\n    display: none;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-item__details-price--desktop {\n        position: static;\n        display: table-cell;\n        padding-top: 20px;\n        padding-bottom: 20px;\n        vertical-align: top\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart-item__details-price--desktop {\n        padding-top: 25px;\n        padding-bottom: 25px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.cart-grid--default .cart-item__details-price--desktop {\n        padding-top: 30px;\n        padding-bottom: 30px\n    }\n      }\n\n.cart-item__details-price span {\n    font-size: 13px;\n    line-height: 1.2;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-item__details-price span {\n      font-size: 15px\n  }\n    }\n\n.cart-item__details-quantity-text {\n  display: block;\n  margin-bottom: 4px;\n  color: var(--black-text);\n}\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-item__details-quantity-text {\n      display: none\n  }\n    }\n\n.cart-item__total {\n  position: absolute;\n  top: 15px;\n  right: 0;\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.cart-item__total {\n    display: table-cell\n}\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-item__total {\n      position: static;\n      display: table-cell;\n      padding-top: 20px;\n      padding-bottom: 20px;\n      vertical-align: top\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart-item__total {\n      padding-top: 25px;\n      padding-bottom: 25px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.cart-grid--default .cart-item__total {\n      padding-top: 30px;\n      padding-bottom: 30px\n  }\n    }\n\n.cart-item:first-child .cart-item__total {\n    top: 10px;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-item__quantity--mobile {\n        display: none\n    }\n      }\n\n@media (min-width: 768px) {\n\n.cart-grid--mini-cart .cart-item__quantity--mobile {\n        align-items: center;\n        display: flex\n    }\n      }\n\n.cart-item__quantity--desktop {\n    display: none;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .cart-item__quantity--desktop {\n        position: static;\n        display: table-cell;\n        padding-top: 20px;\n        padding-bottom: 20px;\n        vertical-align: top\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.cart-grid--default .cart-item__quantity--desktop {\n        padding-top: 25px;\n        padding-bottom: 25px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.cart-grid--default .cart-item__quantity--desktop {\n        padding-top: 30px;\n        padding-bottom: 30px\n    }\n      }\n\n.cart-item__compare-price {\n  margin-right: 5px;\n  opacity: 0.6;\n}\n\n.cart-item__details-content-pre-order {\n  color: var(--ruby);\n}\n\n.cart-item-bundle {\n  transition: all var(--slow) var(--ease);\n}\n\n.cart-item-bundle--removing {\n    opacity: 0.3;\n  }\n\n.cart-item-bundle__cell {\n  display: none;\n}\n\n@media (min-width: 1000px) {\n\n.cart-item-bundle__cell:not(.cart-item-bundle__cell--info) {\n      display: table-cell\n  }\n\n      .mini-cart .cart-item-bundle__cell:not(.cart-item-bundle__cell--info) {\n        display: none;\n      }\n    }\n\n@media (min-width: 1000px) {\n\n.template-cart .cart-item-bundle__cell {\n      padding: 20px 0\n  }\n    }\n\n.cart-item-bundle__cell--info {\n    display: block;\n  }\n\n@media (min-width: 1000px) {\n\n.cart-item-bundle__cell--info {\n      display: table-cell\n  }\n    }\n\n.cart-item-bundle__cell--total-price {\n    text-align: right;\n  }\n\n.cart-item-bundle__header {\n  display: flex;\n  flex-direction: column;\n  grid-gap: 8px;\n  gap: 8px;\n}\n\n.cart-item-bundle__title {\n  margin: 0;\n}\n\n@media (min-width: 1000px) {\n\n.cart-item-bundle__title {\n    min-width: 130px\n}\n  }\n\n.cart-item-bundle__price {\n  margin: 0;\n}\n\n@media (min-width: 1000px) {\n\n.template-cart .cart-item-bundle__price {\n      display: none\n  }\n    }\n\n.cart-item-bundle__actions {\n  display: flex;\n  align-items: center;\n  grid-gap: 10px;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.cart-item-bundle__items {\n  margin-top: 10px;\n}\n\n.cart-item-bundle__item {\n  display: flex;\n  align-items: center;\n}\n\n.cart-item-bundle__item-image {\n  position: relative;\n  display: block;\n  border-bottom: none;\n  width: 50px;\n}\n\n.cart-item-bundle__item-image img {\n    display: block;\n    width: 100%;\n  }\n\n.cart-item-bundle__item-info {\n  flex-direction: column;\n  display: flex;\n  flex: 1 1;\n  padding-left: 10px;\n}\n\n@media (min-width: 1240px) {\n\n.cart-item-bundle__item-info {\n    padding-left: 20px\n}\n  }\n\n.cart-item-bundle__item-name {\n  margin-top: 6px;\n}\n\n.cart-item-bundle__item-text {\n  font-weight: 500;\n}\n\n.checkbox {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.checkbox__icon {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n}\n\n.checkbox__icon-el {\n  position: relative;\n  z-index: 1;\n  display: block;\n  height: 20px;\n  width: 20px;\n  margin-right: 10px;\n  border: 1px solid var(--black-o-20);\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.is-error .checkbox__icon-el {\n    border: 1px solid var(--red);\n  }\n\n.is-active .checkbox__icon-el {\n    border-color: var(--black);\n  }\n\nbody.keyboard-active .checkbox__icon-el:focus {\n      outline: 1px solid var(--red);\n      outline-offset: 5px;\n    }\n\n.checkbox__text {\n  line-height: 20px;\n}\n\n.checkbox__icon-el:checked + .checkbox__icon-tick {\n  opacity: 1;\n}\n\n.checkbox__icon-tick {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 0;\n  width: 10px;\n  margin: auto;\n  opacity: 0;\n  transition: opacity var(--transition-default);\n}\n\n.claims-bar {\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n@media (min-width: 768px) {\n\n.claims-bar {\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n  }\n\n.claims-bar__grid {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  grid-gap: 24px;\n  gap: 24px;\n}\n\n@media (min-width: 768px) {\n\n.claims-bar__grid {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    grid-gap: 48px;\n    gap: 48px\n}\n  }\n\n.claims-bar__item {\n  display: flex;\n  grid-gap: 16px;\n  gap: 16px;\n  width: -webkit-fit-content !important;\n  width: -moz-fit-content !important;\n  width: fit-content !important;\n  justify-content: start;\n  align-items: center;\n  white-space: nowrap;\n}\n\n@media (min-width: 768px) {\n\n.claims-bar__item {\n    grid-gap: 24px;\n    gap: 24px;\n    justify-content: center\n}\n  }\n\n.claims-bar__icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 100%;\n  overflow: hidden;\n}\n\n.claims-bar__carousel.swiper {\n  overflow: hidden;\n  padding: 0 20px;\n  margin: 0 -20px;\n}\n\n@media (min-width: 768px) {\n\n.claims-bar__carousel.swiper {\n    padding: 0;\n    margin: 0\n}\n  }\n\n@media (min-width: 768px) {\n\n.claims-bar__wrapper {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    grid-gap: 24px;\n    gap: 24px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.claims-bar__wrapper {\n    grid-gap: 48px;\n    gap: 48px\n}\n  }\n\n.collaboration {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n\n.collaboration {\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration {\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.collaboration {\n    margin-bottom: 50px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.collaboration {\n    margin-bottom: 60px\n}\n  }\n\n.collaboration__body {\n  position: relative;\n  padding: 30px 20px 40px;\n  z-index: 1;\n}\n\n@media (min-width: 768px) {\n\n.collaboration__body {\n    padding: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration__body {\n    padding: 40px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.collaboration__body {\n    padding: 50px 50px 60px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.collaboration__body {\n    padding: 50px 80px 60px\n}\n  }\n\n.collaboration__inner {\n  display: flex;\n  flex-direction: column;\n}\n\n@media (min-width: 768px) {\n\n.collaboration__inner {\n    flex-direction: row;\n    justify-content: center\n}\n  }\n\n.collaboration__title {\n  margin-bottom: 5px;\n  color: var(--white);\n}\n\n.collaboration__logos {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.collaboration__logos {\n    flex-direction: column;\n    min-width: calc(50% - 157px);\n    padding: 0 30px 0 15px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration__logos {\n    min-width: calc(50% - 207.5px);\n    padding: 0 25px 0 12px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.collaboration__logos {\n    min-width: calc(50% - 315px);\n    padding: 0 55px 0 62px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.collaboration__logos {\n    min-width: calc(50% - 350px)\n}\n  }\n\n.collaboration__logo img {\n  width: 100%;\n  height: auto;\n}\n\n.collaboration__logo--2,\n.collaboration__logo--1 {\n  width: 50px;\n}\n\n@media (min-width: 768px) {\n\n.collaboration__logo--2,\n.collaboration__logo--1 {\n    width: 63px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration__logo--2,\n.collaboration__logo--1 {\n    width: 98px\n}\n  }\n\n.collaboration__logo-separator {\n  margin: 0 15px;\n}\n\n@media (min-width: 768px) {\n\n.collaboration__logo-separator {\n    margin: 10px 0 15px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration__logo-separator {\n    margin: 20px 0\n}\n  }\n\n.collaboration__image {\n  margin-bottom: 20px;\n}\n\n.collaboration__image::before {\n    padding-bottom: calc(317 / 240 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.collaboration__image::before {\n      padding-bottom: calc(363 / 274 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.collaboration__image::before {\n      padding-bottom: calc(484 / 365 * 100%)\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.collaboration__image::before {\n      padding-bottom: calc(690 / 520 * 100%)\n  }\n    }\n\n@media (min-width: 768px) {\n\n.collaboration__image {\n    min-width: 274px;\n    margin: 0 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration__image {\n    min-width: 365px;\n    margin: 0 25px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.collaboration__image {\n    min-width: 520px;\n    margin: 0 55px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.collaboration__image {\n    margin: 0 90px\n}\n  }\n\n.collaboration__content {\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.collaboration__content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: calc(50% - 157px)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration__content {\n    min-width: 240px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.collaboration__content {\n    min-width: calc(50% - 315px)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.collaboration__content {\n    min-width: calc(50% - 350px)\n}\n  }\n\n.collaboration__description {\n  margin-bottom: 20px;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.collaboration__description {\n    margin-bottom: 10px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.collaboration__description {\n    max-width: 269px;\n    margin: 0 auto 15px\n}\n  }\n\n.collaboration__ctas {\n  display: flex;\n  justify-content: center;\n}\n\n@media (min-width: 768px) {\n\n.collaboration__ctas {\n    flex-direction: column;\n    align-items: center\n}\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration__ctas {\n    flex-direction: row\n}\n  }\n\n.collaboration__link,\n.collaboration__button {\n  min-width: 1rem;\n  margin: 0 10px;\n}\n\n.collaboration__link.button--secondary, .collaboration__button.button--secondary {\n    padding-top: 0;\n  }\n\n@media (min-width: 768px) {\n\n.collaboration__link,\n.collaboration__button {\n    margin: 5px 10px\n}\n  }\n\n.collaboration__link .icon {\n    width: 7px;\n    height: 7px;\n    margin-left: 5px;\n  }\n\n@media (min-width: 1000px) {\n\n.collaboration__link .icon {\n      width: 8px;\n      height: 8px\n  }\n    }\n\n.coming-soon {\n  position: relative;\n  margin-bottom: 50px;\n  margin-top: -51px;\n}\n\n@media (min-width: 768px) {\n\n.coming-soon {\n    margin-top: -66px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.coming-soon {\n    margin-top: -71px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.coming-soon {\n    margin-top: -81px\n}\n  }\n\n.coming-soon__media-wrapper {\n  position: relative;\n  display: grid;\n  grid-template-rows: 1fr auto 1fr;\n  align-items: center;\n  width: 100%;\n  overflow: hidden;\n  aspect-ratio: 402 / 793;\n  max-height: none;\n}\n\n@media (min-width: 768px) {\n\n.coming-soon__media-wrapper {\n    aspect-ratio: 768 / 768\n}\n  }\n\n@media (min-width: 1000px) {\n\n.coming-soon__media-wrapper {\n    aspect-ratio: 1024 / 860\n}\n  }\n\n@media (min-width: 1440px) {\n\n.coming-soon__media-wrapper {\n    aspect-ratio: 1440 / 984\n}\n  }\n\n@media (min-width: 1600px) {\n\n.coming-soon__media-wrapper {\n    aspect-ratio: 1600 / 984\n}\n  }\n\n.coming-soon__media {\n  position: relative;\n  grid-row: 2;\n  width: 100%;\n  max-height: 100%;\n  aspect-ratio: var(--cs-ratio-s, 0.6);\n}\n\n@media (min-width: 768px) {\n\n.coming-soon__media {\n    aspect-ratio: var(--cs-ratio-m, 1)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.coming-soon__media {\n    aspect-ratio: 1024 / 860\n}\n  }\n\n@media (min-width: 1440px) {\n\n.coming-soon__media {\n    aspect-ratio: 1440 / 984\n}\n  }\n\n@media (min-width: 1600px) {\n\n.coming-soon__media {\n    aspect-ratio: 1600 / 984\n}\n  }\n\n@media (min-width: 1000px) {\n\n.coming-soon__media img {\n      object-fit: cover !important;\n      object-position: center !important\n  }\n    }\n\n.coming-soon__letterbox {\n  position: relative;\n  width: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.coming-soon__letterbox--top {\n    grid-row: 1;\n    align-self: stretch;\n  }\n\n.coming-soon__letterbox--bottom {\n    grid-row: 3;\n    align-self: stretch;\n  }\n\n.coming-soon__letterbox-img {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.coming-soon__video {\n  overflow: hidden;\n}\n\n.coming-soon__body {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  z-index: 2;\n  padding: calc(var(--h-header) + 57px) 20px 116px;\n}\n\n@media (min-width: 768px) {\n\n.coming-soon__body {\n    padding: calc(var(--h-header-tablet) + 80px) 30px 80px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.coming-soon__body {\n    padding: calc(var(--h-header-laptop) + 80px) 40px 80px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.coming-soon__body {\n    padding: calc(var(--h-header-desktop) + 100px) 50px 93px\n}\n  }\n\n.coming-soon__inner {\n  width: 100%;\n  text-align: center;\n  color: var(--white);\n}\n\n.coming-soon__inner--top {\n  max-width: 242px;\n  margin: 0 auto;\n}\n\n@media (min-width: 1000px) {\n\n.coming-soon__inner--top {\n    max-width: 360px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.coming-soon__inner--top {\n    max-width: 400px\n}\n  }\n\n.coming-soon__inner--bottom {\n  max-width: 300px;\n  margin: 0 auto;\n}\n\n@media (min-width: 1000px) {\n\n.coming-soon__inner--bottom {\n    max-width: 350px\n}\n  }\n\n.coming-soon__header {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto 10px;\n  grid-gap: 0;\n  gap: 0;\n}\n\n@media (min-width: 1000px) {\n\n.coming-soon__header {\n    grid-gap: 20px;\n    gap: 20px;\n    margin-bottom: 20px\n}\n  }\n\n.coming-soon__left-accent {\n  width: auto;\n  height: 70px;\n}\n\n@media (min-width: 1000px) {\n\n.coming-soon__left-accent {\n    height: 80px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.coming-soon__left-accent {\n    height: 95px\n}\n  }\n\n.coming-soon__right-accent {\n  width: auto;\n  height: 70px;\n}\n\n@media (min-width: 1000px) {\n\n.coming-soon__right-accent {\n    height: 80px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.coming-soon__right-accent {\n    height: 95px\n}\n  }\n\n.coming-soon__title {\n  max-width: 182px;\n}\n\n@media (min-width: 1000px) {\n\n.coming-soon__title {\n    max-width: 231px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.coming-soon__title {\n    max-width: 286px\n}\n  }\n\n.coming-soon__content {\n  margin: 0 auto 15px;\n  font-size: 13px;\n  line-height: 1.2;\n  font-family: var(--sans-serif);\n}\n\n@media (min-width: 1000px) {\n\n.coming-soon__content {\n    font-size: 15px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n\n    max-width: 350px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.coming-soon__content {\n    margin-bottom: 20px\n}\n  }\n\n.coming-soon__cta {\n  min-width: 1rem;\n  border: none !important;\n}\n\n.coming-soon__cta.button--secondary {\n    padding-top: 0;\n  }\n\n.coming-soon__cta--static {\n  cursor: default;\n  pointer-events: none;\n}\n\n.coming-soon__title-bottom {\n  margin: 0 0 10px;\n}\n\n.coming-soon__content-bottom {\n  margin: 0 0 20px;\n}\n\n.newsletter-form--coming-soon {\n  max-width: 300px;\n  margin: 0 auto;\n}\n\n.newsletter-form--coming-soon .newsletter__field {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n\n.newsletter-form--coming-soon input {\n    text-align: center;\n  }\n\n.newsletter-form--coming-soon .newsletter__button {\n    padding: 9px 30px;\n    margin: auto;\n    color: var(--white);\n    background-color: var(--red);\n    border-radius: 20px;\n    border: 0 !important;\n  }\n\n.newsletter-form--coming-soon .newsletter__button:not([disabled]):hover {\n      color: var(--white);\n      background-color: var(--red-1) !important;\n    }\n\n.newsletter-form--coming-soon .newsletter__button:not([disabled]):hover::after {\n        content: none;\n      }\n\n.contact-form__container {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n@media (min-width: 768px) {\n\n.contact-form__container {\n    padding-top: 50px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.contact-form__container {\n    padding-top: 60px;\n    padding-bottom: 60px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.contact-form__container {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.contact-form__container {\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n  }\n\n.contact-form__inner {\n  max-width: 488px;\n  margin: 0 auto;\n}\n\n@media (min-width: 1000px) {\n\n.contact-form__inner {\n    max-width: 624px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.contact-form__inner {\n    max-width: 700px\n}\n  }\n\n.contact-form__header {\n  max-width: 222px;\n  margin: 0 auto 32px;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.contact-form__header {\n    max-width: 312px;\n    margin-bottom: 48px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.contact-form__header {\n    max-width: 415px;\n    margin-bottom: 42px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.contact-form__header {\n    margin-bottom: 62px\n}\n  }\n\n.contact-form__title {\n  margin: 0 0 5px;\n}\n\n@media (min-width: 1000px) {\n\n.contact-form__title {\n    margin-bottom: 10px\n}\n  }\n\n.contact-form__el {\n  height: 100%;\n}\n\n.contact-form__success {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  visibility: hidden;\n  overflow-y: auto;\n  transition: opacity 0.2s var(--ease), visibility 0s var(--ease);\n  padding: 20px;\n  pointer-events: none;\n}\n\n.contact-form__success.is-active {\n    opacity: 1;\n    visibility: visible;\n    pointer-events: auto;\n  }\n\n.contact-form__success-container {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  width: 100%;\n  min-height: 100%;\n}\n\n.contact-form__success-inner {\n  position: relative;\n  max-width: 250px;\n  padding: 47px 33px;\n  background-color: var(--parchment);\n  text-align: center;\n}\n\n@media (min-width: 1000px) {\n\n.contact-form__success-inner {\n    max-width: 350px;\n    padding: 54px 43px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.contact-form__success-inner {\n    max-width: 400px;\n    padding: 76px 49px 77px\n}\n  }\n\n.contact-form__success-icon {\n  display: flex;\n  width: 33px;\n  height: 44px;\n  margin: 0 auto 15px;\n  color: var(--red);\n}\n\n@media (min-width: 1000px) {\n\n.contact-form__success-icon {\n    width: 42px;\n    height: 57px;\n    margin-bottom: 20px\n}\n  }\n\n.contact-form__success-title {\n  margin: 0 0 5px;\n}\n\n.contact-form__success-text {\n  margin: 0;\n}\n\n.contact-form__success-close {\n  position: absolute;\n  z-index: 2;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n}\n\n@media (min-width: 1240px) {\n\n.contact-form__success-close {\n    top: 10px;\n    right: 10px\n}\n  }\n\nbody.keyboard-active .contact-form__success-close:focus {\n      outline: 1px solid var(--black);\n    }\n\n.contact-form__success-close-icon {\n  display: block;\n  width: 25px;\n  height: 25px;\n}\n\n.contact-form__success-close-icon::before,\n  .contact-form__success-close-icon::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: inline-block;\n    width: 15px;\n    height: 1px;\n    background-color: var(--black);\n  }\n\n.contact-form__success-close-icon::before {\n    transform: translate(-50%, -50%) rotate(45deg);\n  }\n\n.contact-form__success-close-icon::after {\n    transform: translate(-50%, -50%) rotate(-45deg);\n  }\n\n@media (min-width: 768px) {\n\n.contact-form__fields {\n    flex-wrap: wrap;\n    justify-content: space-between;\n    display: flex\n}\n  }\n\n.contact-form__field {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 768px) {\n\n.contact-form__field {\n    width: calc(50% - 5px)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.contact-form__field {\n    width: calc(50% - 7.5px);\n    margin-bottom: 20px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.contact-form__field {\n    width: calc(50% - 10px)\n}\n  }\n\n.contact-form__field.has-error {\n    margin-bottom: 25px;\n  }\n\n@media (min-width: 1000px) {\n\n.contact-form__field.has-error {\n      margin-bottom: 30px\n  }\n    }\n\n.contact-form__field--textarea {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n@media (min-width: 1240px) {\n\n.contact-form__field--textarea {\n    margin-bottom: 25px\n}\n  }\n\n.contact-form__textarea {\n  border: 1px solid var(--black-o-20);\n  border-radius: 15px;\n  width: 100%;\n  height: 150px;\n  margin: 0;\n  padding: 10px 15px;\n  outline: none;\n  vertical-align: middle;\n  resize: none;\n}\n\n@media (min-width: 1000px) {\n\n.contact-form__textarea {\n    height: 200px;\n    padding: 15px 20px\n}\n  }\n\n.contact-form__textarea::-webkit-input-placeholder {\n    color: var(--black-o-50);\n  }\n\n.contact-form__textarea::placeholder {\n    color: var(--black-o-50);\n  }\n\n.is-active .contact-form__textarea {\n    border-color: var(--black);\n  }\n\nbody.keyboard-active .contact-form__textarea:focus {\n      border-color: var(--black-o-20);\n      outline: 1px solid var(--red);\n      outline-offset: 5px;\n    }\n\n.is-error .contact-form__textarea {\n    border-width: 2px;\n    border-color: var(--red);\n  }\n\n.button.button--secondary.contact-form__submit {\n  min-width: auto;\n}\n\n.button.button--secondary.contact-form__submit:disabled {\n    display: inline-flex;\n    opacity: 0.8;\n    cursor: not-allowed;\n  }\n\n.content-image__inner {\n  margin: 30px 0;\n}\n\n@media (min-width: 768px) {\n\n.content-image__inner {\n    display: flex;\n    margin: 40px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-image__inner {\n    margin: 60px 0\n}\n  }\n\n.content-image--marketing .content-image__inner {\n    margin: 30px 0 20px;\n  }\n\n@media (min-width: 768px) {\n\n.content-image--marketing .content-image__inner {\n      margin: 30px 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.content-image--marketing .content-image__inner {\n      margin: 40px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image--marketing .content-image__inner {\n      margin: 80px 0 60px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling .content-image__inner {\n      margin: 40px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling .content-image__inner {\n      margin: 60px 0\n  }\n    }\n\n.content-image--storytelling-landing .content-image__inner {\n    padding: 20px 0 40px;\n    margin: 0 auto !important;\n    max-width: 1480px;\n  }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling-landing .content-image__inner {\n      padding: 30px 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.content-image--storytelling-landing .content-image__inner {\n      padding: 40px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling-landing .content-image__inner {\n      padding: 50px 0\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.content-image--storytelling-landing .content-image__inner {\n      padding: 60px 0\n  }\n    }\n\n@media (min-width: 768px) {\n\n.content-image__inner--left {\n    flex-direction: row-reverse\n}\n  }\n\n.content-image--marketing .content-image__inner--left {\n    margin: 30px 0;\n  }\n\n@media (min-width: 1000px) {\n\n.content-image--marketing .content-image__inner--left {\n      margin: 40px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image--marketing .content-image__inner--left {\n      margin: 60px 0 66px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.content-image--marketing .content-image__inner--left {\n      margin: 60px 0\n  }\n    }\n\n@media (min-width: 768px) {\n\n.content-image__featured {\n    width: 49.29%\n}\n  }\n\n@media (min-width: 1000px) {\n\n.content-image__featured {\n    width: 49.15%\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-image__featured {\n    width: 49.47%;\n    max-height: 800px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.content-image__featured {\n    width: 49.05%\n}\n  }\n\n.content-image__featured::before {\n    padding-bottom: calc(338 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.content-image__featured::before {\n      padding-bottom: calc(422 / 349 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.content-image__featured::before {\n      padding-bottom: calc(560 / 464 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image__featured::before {\n      padding-bottom: calc(800 / 781 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.content-image__inner--right .content-image__featured {\n      width: 50%\n  }\n    }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling .content-image__inner--right .content-image__featured {\n        width: 50%\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling .content-image__inner--right .content-image__featured {\n        width: 49.478%\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.content-image--storytelling .content-image__inner--right .content-image__featured {\n        width: 50%\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--marketing .content-image__inner--left .content-image__featured {\n        width: 49.254%\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__featured {\n        width: 49.254%\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__featured {\n        width: 50%\n    }\n      }\n\n.content-image--storytelling .content-image__inner--left .content-image__featured::before,\n    .content-image--marketing .content-image__inner--left .content-image__featured::before {\n      padding-bottom: calc(340 / 280 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__featured::before,\n    .content-image--marketing .content-image__inner--left .content-image__featured::before {\n        padding-bottom: calc(422 / 349 * 100%)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__featured::before,\n    .content-image--marketing .content-image__inner--left .content-image__featured::before {\n        padding-bottom: calc(562 / 464 * 100%)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__featured::before,\n    .content-image--marketing .content-image__inner--left .content-image__featured::before {\n        padding-bottom: calc(800 / 660 * 100%)\n    }\n      }\n\n.content-image--storytelling-landing .content-image__featured:before {\n    padding-bottom: calc(439 / 362 * 100%);\n  }\n\n@media (min-width: 1000px) {\n\n.content-image--storytelling-landing .content-image__featured:before {\n      padding-bottom: calc(563 / 465 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling-landing .content-image__featured:before {\n      padding-bottom: calc(800 / 660 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.content-image--storytelling-landing .content-image__featured:before {\n      padding-bottom: calc(882 / 728 * 100%)\n  }\n    }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling-landing .content-image__featured {\n      flex: 1 1\n  }\n    }\n\n.content-image__wrapper {\n  padding: 30px 20px;\n}\n\n@media (min-width: 768px) {\n\n.content-image__wrapper {\n    align-items: center;\n    display: flex;\n    width: 50.71%;\n    padding-right: 50px;\n    padding-left: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.content-image__wrapper {\n    width: 50.85%;\n    padding-right: 80px;\n    padding-left: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-image__wrapper {\n    width: 50.53%;\n    padding-right: 120px;\n    padding-left: 50px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.content-image__wrapper {\n    width: 50.95%;\n    padding-right: 152px;\n    padding-left: 90px\n}\n  }\n\n.content-image__inner--right .content-image__wrapper {\n    padding: 30px 20px;\n  }\n\n@media (min-width: 768px) {\n\n.content-image__inner--right .content-image__wrapper {\n      padding: 50px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.content-image__inner--right .content-image__wrapper {\n      padding: 80px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image__inner--right .content-image__wrapper {\n      padding: 120px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.content-image__inner--right .content-image__wrapper {\n      padding: 152px;\n      width: 50%\n  }\n    }\n\n@media (max-width: 767px) {\n\n.content-image--marketing .content-image__inner--right .content-image__wrapper {\n        padding-bottom: 40px\n    }\n      }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling .content-image__inner--right .content-image__wrapper {\n        width: 50%;\n        padding: 30px 30px 32px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.content-image--storytelling .content-image__inner--right .content-image__wrapper {\n        padding: 83px 70px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling .content-image__inner--right .content-image__wrapper {\n        width: 50.522%;\n        padding: 120px\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.content-image--storytelling .content-image__inner--right .content-image__wrapper {\n        width: 50%;\n        padding: 152px\n    }\n      }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling-landing .content-image__inner--right .content-image__wrapper {\n        width: calc(372 / 708 * 100%);\n        padding: 30px 34px 32px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.content-image--storytelling-landing .content-image__inner--right .content-image__wrapper {\n        width: calc(451 / 944 * 100%);\n        padding: 40px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling-landing .content-image__inner--right .content-image__wrapper {\n        width: calc(487 / 1340 * 100%);\n        padding: 50px;\n        max-width: 487px\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.content-image--storytelling-landing .content-image__inner--right .content-image__wrapper {\n        width: calc(487 / 1480 * 100%);\n        padding: 100px;\n        max-width: 487px\n    }\n      }\n\n@media (min-width: 768px) {\n\n.content-image--marketing .content-image__inner--left .content-image__wrapper {\n        padding: 0 16px 0 0\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.content-image--marketing .content-image__inner--left .content-image__wrapper {\n        padding-right: 49px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--marketing .content-image__inner--left .content-image__wrapper {\n        width: 50.746%;\n        padding: 0 100px 0 50px\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.content-image--marketing .content-image__inner--left .content-image__wrapper {\n        padding: 0 140px 0 80px\n    }\n      }\n\n.content-image--storytelling .content-image__inner--left .content-image__wrapper {\n      padding: 20px 0 15px;\n    }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__wrapper {\n        padding: 0 22px 0 0\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__wrapper {\n        padding-right: 49px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__wrapper {\n        width: 50.746%;\n        padding: 0 100px 0 50px\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__wrapper {\n        width: 50%;\n        padding: 0 110px 0 100px\n    }\n      }\n\n@media (min-width: 768px) {\n\n.content-image--storytelling-landing .content-image__inner--left .content-image__wrapper {\n        width: calc(372 / 708 * 100%);\n        padding: 30px 34px 32px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.content-image--storytelling-landing .content-image__inner--left .content-image__wrapper {\n        width: calc(479 / 944 * 100%);\n        padding: 40px 68px 40px 40px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling-landing .content-image__inner--left .content-image__wrapper {\n        width: calc(680 / 1340 * 100%);\n        padding: 50px 143px 50px 50px;\n        max-width: 680px\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.content-image--storytelling-landing .content-image__inner--left .content-image__wrapper {\n        width: calc(752 / 1480 * 100%);\n        padding: 100px 165px 100px 100px;\n        max-width: 752px\n    }\n      }\n\n@media (max-width: 767px) {\n\n.content-image--storytelling-landing .content-image__wrapper {\n      padding: 20px 0 0\n  }\n    }\n\n.content-image__wrapper-inner {\n  width: 100%;\n}\n\n.content-image__content {\n  margin: 0;\n}\n\n.content-image__content p {\n    margin-bottom: 10px;\n    max-width: 438px;\n  }\n\n@media (min-width: 1000px) {\n\n.content-image__content p {\n      margin-bottom: 12px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image__content p {\n      margin-bottom: 22px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling-landing .content-image__content p {\n        max-width: none\n    }\n      }\n\n.content-image__content ol {\n    counter-reset: list;\n  }\n\n.content-image__content ol li {\n      position: relative;\n      margin-bottom: 10px;\n      padding-left: 20px;\n      counter-increment: list;\n    }\n\n@media (min-width: 1000px) {\n\n.content-image__content ol li {\n        margin-bottom: 14px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.content-image__content ol li {\n        margin-bottom: 19px\n    }\n      }\n\n.content-image__content ol li:last-child {\n        margin-bottom: 0;\n      }\n\n.content-image__content ol li::before {\n        font-size: 16px;\n        line-height: 1.2;\n        font-family: var(--sans-serif);\n\n        content: counter(list);\n        position: absolute;\n        top: -2px;\n        left: 0;\n        display: inline-block;\n        min-width: 10px;\n        text-align: center;\n        color: var(--red);\n      }\n\n@media (min-width: 1024px) {\n\n.content-image__content ol li::before {\n    font-size: 18px;\n      }\n  }\n\n@media (min-width: 1440px) {\n\n.content-image__content ol li::before {\n    font-size: 20px;\n    line-height: 1.1;\n      }\n  }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling .content-image__inner--left .content-image__content,\n    .content-image--marketing .content-image__inner--left .content-image__content {\n        max-width: 487px\n    }\n      }\n\n@media (max-width: 1023px) {\n\n.content-image--storytelling-landing .content-image__content p {\n    font-size: 13px;\n    }\n  }\n\n.content-image__title {\n  margin: 0 0 5px;\n}\n\n@media (min-width: 1240px) {\n\n.content-image__title {\n    margin-bottom: 10px\n}\n  }\n\n.content-image--marketing .content-image__inner--left .content-image__title {\n      max-width: 260px;\n    }\n\n@media (min-width: 768px) {\n\n.content-image--marketing .content-image__inner--left .content-image__title {\n        max-width: 294px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.content-image--marketing .content-image__inner--left .content-image__title {\n        max-width: none\n    }\n      }\n\n.content-image__subtitle {\n  margin: 0 0 10px;\n}\n\n@media (min-width: 1000px) {\n\n.content-image__subtitle {\n    margin-bottom: 15px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-image__subtitle {\n    margin-bottom: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.content-image--storytelling .content-image__subtitle {\n      margin-bottom: 10px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-image--storytelling .content-image__subtitle {\n      margin-bottom: 15px\n  }\n    }\n\n.content-image__big-content {\n  margin: 0 0 5px;\n}\n\n@media (min-width: 1000px) {\n\n.content-image__big-content {\n    margin-bottom: 10px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-image__big-content {\n    margin-bottom: 15px\n}\n  }\n\n.content-image__content + .content-image__button {\n    margin-top: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.content-image__content + .content-image__button {\n      margin-top: 15px\n  }\n    }\n\n.content-image__signature {\n  position: relative;\n  height: 40px;\n  margin-top: 15px;\n}\n\n@media (min-width: 768px) {\n\n.content-image__signature {\n    margin-top: 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.content-image__signature {\n    height: 50px;\n    margin-top: 15px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-image__signature {\n    height: 64px\n}\n  }\n\n.content-video {\n  margin: 30px 0;\n  padding: 20px 0 28px;\n  background-color: var(--ruby);\n}\n\n@media (min-width: 768px) {\n\n.content-video {\n    margin: 40px 0;\n    padding: 30px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.content-video {\n    padding: 40px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-video {\n    margin: 60px 0;\n    padding: 50px 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.content-video {\n    padding: 60px 0\n}\n  }\n\n@media (min-width: 768px) {\n\n.content-video__inner {\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center\n}\n  }\n\n.content-video__featured {\n  margin: 0 0 20px;\n}\n\n@media (min-width: 768px) {\n\n.content-video__featured {\n    width: 49.29%;\n    margin: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.content-video__featured {\n    width: 49.15%\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-video__featured {\n    width: 49.25%\n}\n  }\n\n@media (min-width: 1600px) {\n\n.content-video__featured {\n    width: 49.19%\n}\n  }\n\n.content-video__featured::before {\n    padding-bottom: calc(157 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.content-video__featured::before {\n      padding-bottom: calc(222 / 349 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.content-video__featured::before {\n      padding-bottom: calc(296 / 464 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.content-video__featured::before {\n      padding-bottom: calc(420 / 660 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.content-video__featured::before {\n      padding-bottom: calc(463 / 728 * 100%)\n  }\n    }\n\n.content-video__content {\n  text-align: center;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.content-video__content {\n    width: 50.71%;\n    padding-right: 39px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.content-video__content {\n    width: 50.85%;\n    padding-right: 55px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-video__content {\n    width: 50.75%;\n    padding-right: 19px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.content-video__content {\n    width: 50.81%;\n    padding-right: 27px\n}\n  }\n\n@media (min-width: 768px) {\n\n.content-video__content-inner {\n    max-width: 290px;\n    margin: 0 auto\n}\n  }\n\n@media (min-width: 1000px) {\n\n.content-video__content-inner {\n    max-width: 401px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-video__content-inner {\n    max-width: 473px\n}\n  }\n\n.content-video__title {\n  margin: 0 0 5px;\n}\n\n@media (min-width: 1000px) {\n\n.content-video__title {\n    margin-bottom: 15px\n}\n  }\n\n.content-video__button {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  z-index: 5;\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n  color: var(--red);\n\n  @meida (--s) {\n    right: 15px;\n    bottom: 15px;\n  }\n}\n\n@media (min-width: 1000px) {\n\n.content-video__button {\n    right: 20px;\n    bottom: 20px;\n    width: 30px;\n    height: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.content-video__button {\n    width: 40px;\n    height: 40px\n}\n  }\n\n.content-video__button .icon {\n    width: 100%;\n    height: 100%;\n  }\n\n.content-video__cta .icon {\n    width: 7px;\n    height: 7px;\n    margin-left: 5px;\n  }\n\n@media (min-width: 1000px) {\n\n.content-video__cta .icon {\n      width: 8px;\n      height: 8px\n  }\n    }\n\n.example {\n  color: red;\n}\n\n.faq {\n  margin: 30px 0 40px;\n}\n\n@media (min-width: 768px) {\n\n.faq {\n    margin-top: 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.faq {\n    margin: 60px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.faq {\n    margin: 80px 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.faq {\n    margin: 100px 0\n}\n  }\n\n.faq.faq--storytelling {\n    margin: 40px 0 30px;\n  }\n\n@media (min-width: 768px) {\n\n.faq.faq--storytelling {\n      margin-bottom: 40px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.faq.faq--storytelling {\n      margin: 60px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.faq.faq--storytelling {\n      margin: 80px 0\n  }\n    }\n\n.faq__inner {\n  max-width: 488px;\n  margin: 0 auto;\n}\n\n@media (min-width: 1000px) {\n\n.faq__inner {\n    max-width: 654px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.faq__inner {\n    max-width: 926px\n}\n  }\n\n.faq__wrapper {\n  position: relative;\n  margin-bottom: 40px;\n  padding: 20px;\n  background-color: var(--red);\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.faq__wrapper {\n    align-items: flex-start;\n    display: flex;\n    padding-right: 35px;\n    padding-bottom: 25px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.faq__wrapper {\n    margin-bottom: 50px;\n    padding: 25px 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.faq__wrapper {\n    margin-bottom: 80px;\n    padding: 25px 200px 30px 30px\n}\n  }\n\n.faq__media {\n  flex-shrink: 0;\n  width: 30px;\n  margin-bottom: 10px;\n}\n\n@media (min-width: 768px) {\n\n.faq__media {\n    margin-bottom: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.faq__media {\n    width: 43px;\n    margin-top: 5px\n}\n  }\n\n.faq__media::before {\n    padding-bottom: calc(40 / 30 * 100%);\n  }\n\n@media (min-width: 1000px) {\n\n.faq__media::before {\n      padding-bottom: calc(58 / 43 * 100%)\n  }\n    }\n\n@media (min-width: 768px) {\n\n.faq__content {\n    width: calc(100% - 30px);\n    padding-left: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.faq__content {\n    width: calc(100% - 43px)\n}\n  }\n\n.faq__title {\n  margin: 0 0 5px;\n}\n\n.faq__description {\n  max-width: 434px;\n  margin: 0 0 10px;\n}\n\n@media (min-width: 768px) {\n\n.faq__description {\n    margin-bottom: 5px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.faq__description {\n    margin-bottom: 10px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.faq__description {\n    margin-bottom: 0\n}\n  }\n\n.faq__button {\n  min-width: auto;\n}\n\n@media (min-width: 1240px) {\n\n.faq__cta {\n    position: absolute;\n    z-index: 5;\n    top: 50%;\n    right: 50px;\n    transform: translate3d(0, -50%, 0)\n}\n  }\n\n.faq__accordions:not(:last-child) {\n    margin-bottom: 40px;\n  }\n\n@media (min-width: 1000px) {\n\n.faq__accordions:not(:last-child) {\n      margin-bottom: 60px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.faq__accordions:not(:last-child) {\n      margin-bottom: 80px\n  }\n    }\n\n.faq__accordions--cta-bottom:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n@media (min-width: 1240px) {\n\n.faq__accordions--cta-bottom:not(:last-child) {\n    margin-bottom: 30px\n}\n  }\n\n.faq__accordions-title {\n  margin: 0 0 20px;\n}\n\n@media (min-width: 1240px) {\n\n.faq__accordions-title {\n    margin-bottom: 30px\n}\n  }\n\n.faq--storytelling .faq__accordions-title {\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n@media (min-width: 768px) {\n\n.faq--storytelling .faq__accordions-title {\n      max-width: none\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.faq--storytelling .faq__accordions-title {\n      margin-bottom: 40px\n  }\n    }\n\n.faq__wrapper--bottom {\n  margin-bottom: 0;\n}\n\n.faq__wrapper--bottom .faq__accordions-title {\n    margin-bottom: 40px;\n  }\n\n.featured-products {\n  overflow: hidden;\n  padding: 30px 0 40px;\n}\n\n@media (min-width: 768px) {\n\n.featured-products {\n    padding: 35px 0 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.featured-products {\n    padding: 45px 0 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.featured-products {\n    padding: 60px 0\n}\n  }\n\n.featured-products__inner {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.featured-products__title {\n  max-width: 204px;\n  margin: 0;\n}\n\n@media (min-width: 445px) {\n\n.featured-products__title {\n    max-width: none\n}\n  }\n\n@media (min-width: 768px) {\n\n.featured-products__title {\n    flex: 1 1 auto\n}\n  }\n\n.featured-products__buttons {\n  display: flex;\n  flex-direction: column-reverse;\n  order: 1;\n  align-items: flex-start;\n  margin-top: 17px;\n}\n\n@media (min-width: 768px) {\n\n.featured-products__buttons {\n    flex-direction: row;\n    order: 0;\n    flex: 1 1 auto;\n    justify-content: flex-end;\n    align-items: center;\n    margin: 0\n}\n  }\n\n.featured-products__button:not(:last-child) {\n    margin: 10px 0 0;\n  }\n\n@media (min-width: 768px) {\n\n.featured-products__button:not(:last-child) {\n      margin: 0 20px\n  }\n    }\n\n.featured-products__carousel.swiper {\n  overflow: visible;\n  width: 100%;\n  margin-top: 20px;\n}\n\n@media (min-width: 768px) {\n\n.featured-products__carousel.swiper {\n    margin-top: 25px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.featured-products__carousel.swiper {\n    margin-top: 31px\n}\n  }\n\n@media (min-width: 768px) {\n\n.featured-products__carousel.swiper .swiper-wrapper {\n      display: flex;\n      transform: none;\n      width: auto;\n      height: auto;\n      margin: 0 -5px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.featured-products__carousel.swiper .swiper-wrapper {\n      margin: 0 -7.5px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.featured-products__carousel.swiper .swiper-wrapper {\n      margin: 0 -10px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.featured-products__carousel.swiper .swiper-wrapper {\n      margin: 0 -12.5px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.featured-products__carousel.swiper .swiper-slide {\n      width: calc(100% / 3);\n      padding: 0 5px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.featured-products__carousel.swiper .swiper-slide {\n      padding: 0 7.5px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.featured-products__carousel.swiper .swiper-slide {\n      padding: 0 10px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.featured-products__carousel.swiper .swiper-slide {\n      padding: 0 12.5px\n  }\n    }\n\n.featured-recipe-hero {\n  margin: var(--gutter) 0 0;\n}\n\n@media (min-width: 768px) {\n\n.featured-recipe-hero {\n    margin-top: var(--gutter-tablet)\n}\n  }\n\n@media (min-width: 1024px) {\n\n.featured-recipe-hero {\n    margin-top: var(--gutter-laptop)\n}\n  }\n\n@media (min-width: 1440px) {\n\n.featured-recipe-hero {\n    margin-top: var(--gutter-desktop)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.featured-recipe-hero {\n    margin-top: var(--gutter-large-desktop)\n}\n  }\n\n.featured-recipe-hero__image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.featured-recipe-hero__image::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    background: linear-gradient(26.1deg, var(--black-o-50) 0%, transparent 50%);\n  }\n\n@media (min-width: 768px) {\n\n.featured-recipe-hero__image::after {\n      background: linear-gradient(78.66deg, var(--black-o-50) 0%, transparent 50%)\n  }\n    }\n\n.featured-recipe-hero__inner {\n  position: relative;\n  z-index: 5;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  flex-direction: column;\n  min-height: 400px;\n  padding: 20px 20px 25px;\n}\n\n@media (min-width: 768px) {\n\n.featured-recipe-hero__inner {\n    min-height: 316px\n}\n  }\n\n@media (min-width: 1024px) {\n\n.featured-recipe-hero__inner {\n    min-height: 422px;\n    padding: 40px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.featured-recipe-hero__inner {\n    min-height: 600px;\n    padding: 50px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.featured-recipe-hero__inner {\n    padding: 60px\n}\n  }\n\n.featured-recipe-hero__title {\n  margin: 0 0 2px;\n}\n\n@media (min-width: 1024px) {\n\n.featured-recipe-hero__title {\n    margin-bottom: 5px\n}\n  }\n\n.featured-recipe-hero__description {\n  max-width: 277px;\n  margin: 0;\n}\n\n@media (min-width: 1024px) {\n\n.featured-recipe-hero__description {\n    max-width: 390px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.featured-recipe-hero__description {\n    max-width: 433px\n}\n  }\n\n.featured-recipe-hero__cta {\n  margin-top: 5px;\n}\n\n.featured-recipe-hero__badge {\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  font-family: var(--sans-serif);\n\n  display: block;\n  margin-bottom: 10px;\n  padding: 3px 10px;\n  border-radius: 15px;\n  background: rgba(255, 255, 255, 0.2);\n  color: var(--white);\n  text-transform: uppercase;\n}\n\n@media (min-width: 1024px) {\n\n.featured-recipe-hero__badge {\n    font-size: 14px\n}\n  }\n\n@media (min-width: 1024px) {\n\n.featured-recipe-hero__badge {\n    margin-bottom: 15px;\n    padding: 6px 15px\n}\n  }\n\n.featured-recipe-hero--press {\n  margin-bottom: 20px;\n}\n\n.featured-recipe-hero--recipes-new .featured-recipe-hero__image {\n    background: transparent;\n  }\n\n.featured-recipe-hero--recipes-new .featured-recipe-hero__cta {\n    font-size: 15px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n\n    margin-top: 10px;\n    padding: 0;\n    text-transform: capitalize;\n  }\n\n@media (max-width: 1023px) {\n\n.featured-recipe-hero--recipes-new .featured-recipe-hero__cta {\n    font-size: 13px;\n  }\n  }\n\n.footer {\n  overflow: hidden;\n}\n\n.footer a {\n    text-decoration: none;\n    color: var(--white);\n  }\n\n.footer a::after {\n      background-color: var(--white);\n    }\n\n.footer__wrapper {\n  padding: 30px 0;\n}\n\n@media (min-width: 768px) {\n\n.footer__wrapper {\n    padding-bottom: 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.footer__wrapper {\n    padding: 50px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.footer__wrapper {\n    padding: 60px 0\n}\n  }\n\n@media (min-width: 768px) {\n\n.footer__grid {\n    margin: 0 -12px\n}\n  }\n\n@media (min-width: 768px) {\n\n.footer__column {\n    padding: 0 12px\n}\n  }\n\n.footer__column--logo {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n\n.footer__column--logo {\n    width: 41%;\n    margin-bottom: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.footer__column--logo {\n    width: 24%\n}\n  }\n\n.footer__column--menu {\n  order: 1;\n  display: flex;\n  width: 100%;\n  grid-column-gap: 14px;\n  column-gap: 14px;\n}\n\n@media (min-width: 768px) {\n\n.footer__column--menu {\n    order: 0;\n    width: 57%\n}\n  }\n\n@media (min-width: 1000px) {\n\n.footer__column--menu {\n    width: 33.5%\n}\n  }\n\n@media (min-width: 1240px) {\n\n.footer__column--menu {\n    width: 34%\n}\n  }\n\n@media (min-width: 1600px) {\n\n.footer__column--menu {\n    width: 34.3%\n}\n  }\n\n.footer__column--newsletter {\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n@media (min-width: 768px) {\n\n.footer__column--newsletter {\n    margin-top: 30px;\n    margin-bottom: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.footer__column--newsletter {\n    width: 42.5%;\n    margin-top: 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.footer__column--newsletter {\n    width: 42%\n}\n  }\n\n@media (min-width: 1600px) {\n\n.footer__column--newsletter {\n    width: 41.7%\n}\n  }\n\n.footer__column-inner {\n  flex: 1 1 50%;\n}\n\n.footer__logo {\n  width: 63px;\n}\n\n@media (min-width: 768px) {\n\n.footer__logo {\n    width: 110px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.footer__logo {\n    width: 145px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.footer__logo {\n    width: 150px\n}\n  }\n\n.footer__logo::before {\n    padding-bottom: calc(83 / 63 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.footer__logo::before {\n      padding-bottom: calc(145 / 110 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.footer__logo::before {\n      padding-bottom: calc(194 / 145 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.footer__logo::before {\n      padding-bottom: calc(201 / 150 * 100%)\n  }\n    }\n\n.footer__nav-item {\n  padding-bottom: 10px;\n}\n\n@media (min-width: 1000px) {\n\n.footer__nav-item {\n    padding-bottom: 15px\n}\n  }\n\n.footer__nav-item:last-child {\n    padding-bottom: 0;\n  }\n\n.footer__column-title {\n  margin-bottom: 9px;\n}\n\n@media (min-width: 1000px) {\n\n.footer__column-title {\n    margin-bottom: 14px\n}\n  }\n\n.footer__column--newsletter .footer__column-title {\n    margin-bottom: 4px;\n  }\n\n@media (min-width: 1000px) {\n\n.footer__column--newsletter .footer__column-title {\n      margin-bottom: 5px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.footer__column--newsletter .footer__column-title {\n      margin-bottom: 9px\n  }\n    }\n\n.footer__column-text {\n  margin: 0 0 15px;\n}\n\n@media (min-width: 1000px) {\n\n.footer__column-text {\n    max-width: 335px\n}\n  }\n\n.footer__column-text:last-child {\n    margin-top: 5px;\n  }\n\n@media (min-width: 1000px) {\n\n.footer__column-text:last-child {\n      max-width: none;\n      margin-top: 15px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.footer__column-text:last-child {\n      margin-top: 9px\n  }\n    }\n\n.footer-bottom {\n  border-top: 1px solid var(--white);\n  padding: 15px 0 20px;\n}\n\n@media (min-width: 768px) {\n\n.footer-bottom {\n    padding-bottom: 15px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.footer-bottom {\n    padding: 20px 0 25px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.footer-bottom {\n    padding: 25px 0\n}\n  }\n\n.footer--disabled .footer-bottom {\n    border-top: none;\n    padding: 12px 0;\n  }\n\n@media (min-width: 1000px) {\n\n.footer--disabled .footer-bottom {\n      padding: 14px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.footer--disabled .footer-bottom {\n      padding: 16px 0\n  }\n    }\n\n.footer-bottom__block {\n  margin: 0;\n}\n\n.footer-bottom__block--left {\n  order: 1;\n  width: 100%;\n  margin-top: 15px;\n}\n\n@media (min-width: 768px) {\n\n.footer-bottom__block--left {\n    order: 0;\n    flex-shrink: 0;\n    width: auto;\n    min-width: 150px;\n    margin-top: 0\n}\n  }\n\n.footer--disabled .footer-bottom__block--left {\n    order: 0;\n    width: auto;\n    margin-top: 0;\n  }\n\n.footer-bottom__block--center {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  margin-bottom: 10px;\n  grid-column-gap: 14px;\n  column-gap: 14px;\n}\n\n@media (min-width: 768px) {\n\n.footer-bottom__block--center {\n    width: auto;\n    margin-bottom: 0;\n    grid-column-gap: 15px;\n    column-gap: 15px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.footer-bottom__block--center {\n    grid-column-gap: 20px;\n    column-gap: 20px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.footer-bottom__block--center {\n    grid-column-gap: 30px;\n    column-gap: 30px\n}\n  }\n\n.footer-bottom__block--right {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  grid-column-gap: 14px;\n  column-gap: 14px;\n}\n\n@media (min-width: 768px) {\n\n.footer-bottom__block--right {\n    width: auto;\n    grid-column-gap: unset;\n    column-gap: unset\n}\n  }\n\n.footer--disabled .footer-bottom__block--right {\n    width: auto;\n  }\n\n@media (max-width: 767px) {\n\n.footer__copyright,\n.footer__copyright-site,\n.footer-bottom__link {\n    flex: 1 1 50%\n}\n  }\n\n.footer__dot {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.footer__dot {\n    display: block;\n    margin: 0 3px\n}\n  }\n\n.full-width-banner {\n  position: relative;\n  overflow: hidden;\n  color: var(--white);\n}\n\n.full-width-banner__media {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.full-width-banner__media .picture,\n  .full-width-banner__media picture,\n  .full-width-banner__media img {\n    width: 100%;\n    height: 100%;\n  }\n\n.full-width-banner__media .picture,\n  .full-width-banner__media img {\n    object-fit: cover;\n  }\n\n.full-width-banner__overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(102, 102, 102, 0) 100%);\n}\n\n.full-width-banner__content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  grid-gap: 30px;\n  gap: 30px;\n  padding: 80px 20px;\n  aspect-ratio: 402 / 643;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) {\n\n.full-width-banner__content {\n    grid-gap: 40px;\n    gap: 40px;\n    padding: 80px 30px;\n    aspect-ratio: 768 / 568;\n    justify-content: center\n}\n  }\n\n@media (min-width: 1000px) {\n\n.full-width-banner__content {\n    aspect-ratio: 1024 / 568\n}\n  }\n\n@media (min-width: 1240px) {\n\n.full-width-banner__content {\n    aspect-ratio: 1440 / 800\n}\n  }\n\n@media (min-width: 1440px) {\n\n.full-width-banner__content {\n    grid-gap: 60px;\n    gap: 60px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.full-width-banner__content {\n    aspect-ratio: 1600 / 800;\n    max-height: 800px\n}\n  }\n\n.full-width-banner__title-wrap {\n  position: relative;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  grid-gap: 10px;\n  gap: 10px;\n}\n\n.full-width-banner__title {\n  max-width: 154px;\n  text-align: center;\n  font-size: 21px;\n  line-height: 1.2;\n  font-weight: 300;\n  margin: 0;\n}\n\n@media (min-width: 1440px) {\n\n.full-width-banner__title {\n    max-width: 298px;\n    font-size: 32px\n}\n  }\n\n.full-width-banner__accent {\n  width: 27px;\n  height: 70px;\n}\n\n@media (min-width: 1440px) {\n\n.full-width-banner__accent {\n    width: 37px;\n    height: 95px\n}\n  }\n\n.full-width-banner__values {\n  display: flex;\n  flex-direction: column;\n  grid-gap: 30px;\n  gap: 30px;\n  width: 100%;\n  max-width: 254px;\n}\n\n@media (min-width: 768px) {\n\n.full-width-banner__values {\n    flex-direction: row;\n    justify-content: center;\n    align-items: flex-start;\n    grid-gap: 10px;\n    gap: 10px;\n    max-width: 707px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.full-width-banner__values {\n    grid-gap: 20px;\n    gap: 20px;\n    max-width: none\n}\n  }\n\n@media (min-width: 1440px) {\n\n.full-width-banner__values {\n    grid-gap: 40px;\n    gap: 40px;\n    max-width: 950px\n}\n  }\n\n.full-width-banner__value {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.full-width-banner__value {\n    flex: 1 1;\n    justify-content: space-between;\n    min-width: 0;\n    max-width: 229px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.full-width-banner__value {\n    max-width: 290px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.full-width-banner__value {\n    flex: none;\n    justify-content: flex-start;\n    min-height: 0\n}\n  }\n\n.full-width-banner__value-title {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.2;\n  font-weight: 400;\n  font-family: var(--sans-serif);\n}\n\n@media (min-width: 1440px) {\n\n.full-width-banner__value-title {\n    margin-bottom: 5px;\n    font-size: 20px;\n    line-height: 1.1\n}\n  }\n\n.full-width-banner__value-description {\n  margin: 5px 0 0;\n  font-size: 13px;\n  line-height: 1.2;\n  opacity: 0.6;\n}\n\n@media (min-width: 768px) {\n\n.full-width-banner__value-description {\n    margin-top: 8px;\n    width: 100%;\n    max-width: 229px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.full-width-banner__value-description {\n    max-width: none;\n    margin-top: 10px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.full-width-banner__value-description {\n    font-size: 15px;\n    margin-top: 5px\n}\n  }\n\n.full-width-cta {\n  margin: 30px 0 30px;\n}\n\n@media (min-width: 768px) {\n\n.full-width-cta {\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.full-width-cta {\n    margin-top: 60px;\n    margin-bottom: 50px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.full-width-cta {\n    margin-bottom: 60px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.full-width-cta {\n    margin-bottom: 50px\n}\n  }\n\n.full-width-cta.full-width-cta--gift-card {\n    margin-bottom: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.full-width-cta.full-width-cta--gift-card {\n      margin-bottom: 30px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.full-width-cta.full-width-cta--gift-card {\n      margin-bottom: 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.full-width-cta.full-width-cta--gift-card {\n      margin-bottom: 60px\n  }\n    }\n\n.full-width-cta__inner {\n  position: relative;\n  min-height: 300px;\n  padding: 0 20px;\n}\n\n@media (min-width: 768px) {\n\n.full-width-cta__inner {\n    align-items: center;\n    display: flex;\n    min-height: 212px;\n    padding: 0 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.full-width-cta__inner {\n    min-height: 282px;\n    padding: 0 50px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.full-width-cta__inner {\n    min-height: 400px;\n    padding: 0 80px\n}\n  }\n\n.full-width-cta__image {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.full-width-cta__content {\n  position: relative;\n  z-index: 5;\n  max-width: 250px;\n  padding: 20px 0;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.full-width-cta__content {\n    padding: 50px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.full-width-cta__content {\n    max-width: 370px;\n    padding: 84px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.full-width-cta__content {\n    padding: 140px 0\n}\n  }\n\n.full-width-cta__title {\n  margin: 0 0 5px;\n}\n\n.full-width-cta__description {\n  margin: 0 0 10px;\n}\n\n@media (min-width: 1000px) {\n\n.full-width-cta__description {\n    margin-bottom: 15px\n}\n  }\n\n.full-width-cta__button {\n  min-width: auto;\n}\n\n@media (min-width: 1000px) {\n\n.full-width-cta__button {\n    padding-bottom: 3px !important\n}\n  }\n\n.gift-card {\n  padding: 36px 0;\n}\n\n@media (min-width: 768px) {\n\n.gift-card {\n    padding: 120px 0\n}\n  }\n\n@media (--ml) {\n\n.gift-card {\n    padding: 144px 0\n}\n  }\n\n@media (min-width: 1440px) {\n\n.gift-card {\n    padding: 170px 0\n}\n  }\n\n.gift-card .gift-card__wrapper {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: center;\n  }\n\n@media (--ml) {\n\n.gift-card .gift-card__wrapper {\n      flex-direction: row;\n      justify-content: space-evenly\n  }\n\n      .gift-card .gift-card__wrapper .gift-card__button {\n        width: auto !important;\n      }\n    }\n\n.gift-card .gift-card__wrapper .gift-card__content {\n      background: transparent;\n      flex: 0 0 50%;\n      text-align: left;\n      max-width: 415px;\n    }\n\n.gift-card .gift-card__wrapper .gift-card__content .gift-card__title {\n        margin-bottom: 12px;\n      }\n\n.gift-card .gift-card__wrapper .gift-card__content #gift-card-amount {\n        font-size: 20px;\n      }\n\n.gift-card .gift-card__wrapper .gift-card__content #gift-card-code-inner {\n        margin-top: 12px;\n        padding: 8px 12px;\n        border: 1px solid var(--black-text);\n        border-radius: 3px;\n      }\n\n.gift-card .gift-card__wrapper .gift-card__content .gift-card__button {\n        margin-top: 24px;\n        min-width: auto;\n        text-align: center;\n        width: 100%;\n      }\n\n.gift-card .gift-card__wrapper .gift-card__background {\n      background: transparent;\n      padding-bottom: 64%;\n      position: relative;\n      flex: 0 0 50%;\n      max-width: 400px;\n      margin-bottom: 24px;\n      width: 100%;\n    }\n\n@media (min-width: 400px) {\n\n.gift-card .gift-card__wrapper .gift-card__background {\n        padding-bottom: initial;\n        min-height: 256px\n    }\n      }\n\n.gift-card .gift-card__wrapper .gift-card__background picture {\n        max-height: 256px;\n        max-width: 400px;\n      }\n\n.header {\n  /* critical:start */\n  background: var(--white);\n  border-bottom: 1px solid var(--black);\n  transition: background ease-in-out 0.2s;\n}\n\n/* critical:end */\n\n.is-transparent-header .header {\n    background: transparent;\n    border-bottom-color: var(--white);\n  }\n\n.header-sticky.is-scrolling .header {\n    background: var(--white);\n    border-bottom-color: var(--black);\n    transition: background ease-in-out 0.2s;\n  }\n\n/* critical:start */\n\n.header__content {\n  height: var(--h-header);\n}\n\n@media (min-width: 768px) {\n\n.header__content {\n    height: var(--h-header-tablet)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.header__content {\n    height: var(--h-header-laptop)\n}\n  }\n\n@media (min-width: 1240px) {\n\n.header__content {\n    height: var(--h-header-desktop)\n}\n  }\n\n.header__logo-wrapper {\n  justify-content: flex-start;\n  flex: 1 0 auto;\n}\n\n@media (min-width: 768px) {\n\n.header__logo-wrapper {\n    justify-content: center\n}\n  }\n\n@media (min-width: 768px) {\n\n.header__menu,\n.header__side {\n    width: calc(50% - 100px)\n}\n  }\n\n@media (max-width: 767px) {\n\n.header__menu {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    z-index: 20;\n    transform: translateX(-100%);\n    transition: transform var(--duration) var(--ease);\n    min-height: -webkit-fill-available\n}\n\n    .menu--active .header__menu {\n      transform: translateX(0);\n    }\n  }\n\n@media (min-width: 768px) {\n\n.header__menu {\n    position: relative;\n    display: block;\n    height: 100%\n}\n  }\n\n@media (max-width: 767px) {\n\n.header__menu-wrapper {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    max-width: 270px;\n    height: 100vh;\n    padding: 2rem 2rem 3rem;\n    background: var(--white);\n    z-index: 2;\n    overflow-y: auto\n}\n  }\n\n@media (min-width: 768px) {\n\n.header__menu-wrapper {\n    height: 100%\n}\n  }\n\n.header__trigger {\n  width: 16px;\n  height: 10px;\n}\n\n@media (min-width: 768px) {\n\n.header__trigger {\n    display: none\n}\n  }\n\n.header__logo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  display: block;\n  transform: translate3d(-50%, -50%, 0);\n}\n\n@media (min-width: 768px) {\n\n.header__logo {\n    position: relative;\n    left: auto;\n    top: auto;\n    transform: none\n}\n  }\n\n.header__logo img {\n    width: auto;\n    max-height: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.header__logo img {\n      max-height: 26px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.header__logo img {\n      max-height: 30px\n  }\n    }\n\n.is-transparent-header .header__logo {\n    display: none;\n  }\n\n.header-sticky.is-scrolling .header__logo {\n    display: block;\n  }\n\n.header__logo--transparent {\n  display: none;\n}\n\n.is-transparent-header:not(.is-scrolling) .header__logo--transparent {\n    display: block;\n  }\n\n.is-transparent-header:not(.is-scrolling) .header__logo--transparent:focus::before {\n      border-color: var(--white);\n    }\n\n.header-sticky.is-scrolling .header__logo--transparent {\n    display: none;\n  }\n\n.header__side-item {\n  margin-left: 6px;\n}\n\n@media (min-width: 768px) {\n\n.header__side-item {\n    margin-left: 8px\n}\n  }\n\n.header__side-item-link {\n  display: flex;\n  cursor: pointer;\n}\n\n.header__side-item-link--active {\n    padding: 0 6px;\n    width: auto;\n    border-radius: 3px;\n  }\n\n@media (min-width: 768px) {\n\n.header__side-item-link--active {\n      padding: 0 8px\n  }\n    }\n\n.header__trigger-button {\n  color: var(--black);\n}\n\n.header__trigger-button .icon {\n    width: 100%;\n  }\n\n.is-transparent-header .header__trigger-button {\n    color: var(--white);\n  }\n\n.header-sticky.is-scrolling .header__trigger-button {\n    color: var(--black);\n  }\n\n.header__side-item--account {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.header__side-item--account {\n    display: block\n}\n  }\n\n.header__side-item-icon {\n  display: flex;\n  width: 12px;\n}\n\n@media (min-width: 768px) {\n\n.header__side-item-icon {\n    width: 19px\n}\n  }\n\n.header__side-item-icon .icon {\n    width: 100%;\n  }\n\n.is-transparent-header .header__side-item-icon {\n    color: var(--white);\n  }\n\n.header-sticky.is-scrolling .header__side-item-icon {\n    color: var(--black);\n  }\n\n.header__side-item-icon--account {\n  width: 14px;\n}\n\n.header__side-item--button {\n  display: none;\n  transition: background-color var(--duration) var(--ease);\n  border: 1px solid var(--fire-opal);\n  border-radius: 30px;\n  padding: 7px 21px 6px;\n  cursor: pointer;\n}\n\n@media (min-width: 768px) {\n\n.header__side-item--button {\n    display: flex;\n    margin-right: 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.header__side-item--button {\n    margin-right: 20px\n}\n  }\n\n.header__side-item--button:last-child {\n    margin-right: 0;\n  }\n\n.header__side-item--button:hover {\n    border-color: var(--red);\n    background-color: var(--red);\n  }\n\n.is-transparent-header:not(.is-scrolling) .header__side-item--button {\n    border-color: var(--grey-25);\n  }\n\n.is-transparent-header:not(.is-scrolling) .header__side-item--button:hover {\n      background-color: var(--white);\n    }\n\n.header__side-item--button + .header__side-item {\n    margin-left: 0;\n  }\n\n.header__side-cta {\n  transition: color var(--duration) var(--ease);\n}\n\n.header__side-item--button:hover .header__side-cta {\n    color: var(--white);\n  }\n\n.header__side-item--button:hover .header__side-cta::after {\n      content: none;\n    }\n\n.is-transparent-header:not(.is-scrolling) .header__side-item--button:hover .header__side-cta {\n    color: var(--black);\n  }\n\n.header__side-button {\n  height: 35px;\n  padding: 0 25px;\n}\n\n@media (min-width: 768px) {\n\n.header__side-button {\n    min-width: 160px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.header__side-button {\n    min-width: 195px;\n    height: 40px\n}\n  }\n\n.template-product-berry .header__side-button,\n  .template-contact .header__side-button,\n  .header-sticky.is-scrolling .header__side-button {\n    background-color: var(--red);\n    color: var(--white);\n  }\n\n.template-product-berry .header__side-button:not([disabled]):hover, .template-contact .header__side-button:not([disabled]):hover, .header-sticky.is-scrolling .header__side-button:not([disabled]):hover {\n      background-color: var(--white);\n      color: var(--red);\n      border-color: var(--red);\n    }\n\n.header-sticky.is-scrolling.keyboard-active .header__side-button:focus {\n      outline: 1px solid var(--red);\n      background-color: var(--red);\n      color: var(--white);\n    }\n\n@media (min-width: 768px) {\n\n.header__menu-logo,\n.header__menu-close,\n.header__menu-button-mobile,\n.header__menu-account-mobile,\n.header__menu-hr {\n    display: none\n}\n  }\n\n.header__menu-account-mobile {\n  text-decoration: none;\n  margin-top: 2rem;\n}\n\n.header__menu-logo {\n  width: 64px;\n  height: 20px;\n}\n\n.header__menu-logo img {\n    width: 100%;\n    height: auto;\n  }\n\n.header__menu-account-mobile-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid var(--black);\n}\n\n.header__menu-account-mobile-icon .icon {\n    color: var(--black);\n  }\n\n.header__menu-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 11px;\n  height: 11px;\n  color: var(--black);\n}\n\n.header__menu-close .icon {\n    width: 100%;\n  }\n\n/* critical:end */\n\n@media (max-width: 767px) {\n\n.header__menu-overlay,\n.header__overlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    opacity: 0;\n    visibility: hidden;\n    background: transparent;\n    transition: visibility, opacity var(--duration) var(--ease)\n}\n\n    .menu--active .header__menu-overlay, .menu--active .header__overlay {\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n\n@media (max-width: 767px) {\n\n.header__overlay {\n    background: var(--black-o-20)\n}\n  }\n\n/* critical:start */\n\n@media (max-width: 767px) {\n\n.header__nav {\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid var(--black-o-10)\n}\n  }\n\n@media (min-width: 768px) {\n\n.header__nav {\n    height: 100%\n}\n  }\n\n.header__menu-account-mobile-text {\n  margin-top: 0;\n  padding-left: 12px;\n  color: var(--black);\n}\n\n.header__menu-hr {\n  border-color: var(--red);\n  margin-bottom: 0;\n}\n\n.header__submenu-addition-mobile {\n  margin-bottom: 50px;\n}\n\n@media (min-width: 768px) {\n\n.header__submenu-addition-mobile {\n    display: none\n}\n  }\n\n@media (max-width: 767px) {\n\n.header__menu-button-mobile {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--fire-opal);\n    border-radius: 30px;\n    padding: 11px\n}\n  }\n\n.header__menu-button-mobile-link {\n  color: var(--grey);\n}\n\n.header__menu-button-mobile-link:hover::after {\n    content: none;\n  }\n\n.template-cart .header__side-item--cart {\n    pointer-events: none;\n  }\n\n/* critical:end */\n\n.template-storytelling-landing.is-transparent-header .header, .template-coming-soon.is-transparent-header .header, .template-berries.is-transparent-header .header, .template-cart.template-cart--berries.is-transparent-header .header {\n    border-bottom-color: rgba(255, 255, 255, 0.2);\n  }\n\n.template-storytelling-landing .header__side-item--button, .template-coming-soon .header__side-item--button, .template-berries .header__side-item--button, .template-cart.template-cart--berries .header__side-item--button {\n    min-height: 40px;\n    min-width: 195px;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n\n.template-storytelling-landing.is-transparent-header:not(.is-scrolling) .header__side-item--button, .template-coming-soon.is-transparent-header:not(.is-scrolling) .header__side-item--button, .template-berries.is-transparent-header:not(.is-scrolling) .header__side-item--button, .template-cart.template-cart--berries.is-transparent-header:not(.is-scrolling) .header__side-item--button {\n      border-color: var(--red);\n  }\n\n.template-storytelling-landing.is-transparent-header:not(.is-scrolling) .header__side-item--button:hover, .template-coming-soon.is-transparent-header:not(.is-scrolling) .header__side-item--button:hover, .template-berries.is-transparent-header:not(.is-scrolling) .header__side-item--button:hover, .template-cart.template-cart--berries.is-transparent-header:not(.is-scrolling) .header__side-item--button:hover {\n      border-color: var(--red);\n      background-color: var(--red);\n      color: var(--white);\n    }\n\n.template-storytelling-landing.is-transparent-header:not(.is-scrolling) .header__side-item--button .nav-link, .template-coming-soon.is-transparent-header:not(.is-scrolling) .header__side-item--button .nav-link, .template-berries.is-transparent-header:not(.is-scrolling) .header__side-item--button .nav-link, .template-cart.template-cart--berries.is-transparent-header:not(.is-scrolling) .header__side-item--button .nav-link {\n      color: var(--white);\n    }\n\n.template-storytelling-landing.is-transparent-header .header {\n    border-bottom-color: var(--white);\n  }\n\n.template-cart.template-cart--berries.header-sticky.is-scrolling .header {\n    background: var(--berries-cart-bg, var(--pine));\n    border-bottom-color: color-mix(in srgb, var(--berries-cart-color, var(--white)) 20%, transparent);\n  }\n\n.template-cart.template-cart--berries.header-sticky.is-scrolling .header__logo {\n    display: none;\n  }\n\n.template-cart.template-cart--berries.header-sticky.is-scrolling .header__logo--transparent {\n    display: block;\n  }\n\n.template-cart.template-cart--berries.header-sticky.is-scrolling .header__trigger-button,\n  .template-cart.template-cart--berries.header-sticky.is-scrolling .header__side-item-icon {\n    color: var(--berries-cart-color, var(--white));\n  }\n\n@media (min-width: 768px) {\n    .template-cart.template-cart--berries.header-sticky.is-scrolling .nav-link {\n      color: var(--berries-cart-color, var(--white));\n    }\n\n      .template-cart.template-cart--berries.header-sticky.is-scrolling .nav-link::after {\n        background-color: var(--berries-cart-color, var(--white));\n      }\n  }\n\n.header-cart-icon {\n  position: relative;\n  display: block;\n  border: none;\n  cursor: pointer;\n}\n\n.header-cart-icon--active {\n    padding: 0 6px;\n    width: auto;\n    border-radius: 3px;\n  }\n\n@media (min-width: 1000px) {\n\n.header-cart-icon--active {\n      padding: 0 8px\n  }\n    }\n\n.is-transparent-header:not(.is-scrolling) .header-cart-icon:focus::before {\n      border-color: var(--white);\n    }\n\n.header-cart-icon__svg {\n  display: flex;\n  width: 18px;\n  height: 18px;\n  color: var(--black);\n}\n\n@media (min-width: 768px) {\n\n.header-cart-icon__svg {\n    width: 22px;\n    height: 22px\n}\n  }\n\n.header-cart-icon__svg svg {\n    width: 100%;\n  }\n\n.is-transparent-header .header-cart-icon__svg {\n    color: var(--white);\n  }\n\n.header-sticky.is-scrolling .header-cart-icon__svg {\n    color: var(--black);\n  }\n\n.header-cart-icon__count {\n  position: absolute;\n  top: -4px;\n  right: -5px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  border-radius: 50%;\n  width: 10px;\n  height: 10px;\n  padding-left: 1px;\n  background-color: var(--red);\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.header-cart-icon__count {\n    top: -5px;\n    right: -5px;\n    width: 11px;\n    height: 11px\n}\n  }\n\n.is-transparent-header .header-cart-icon__count {\n    background-color: var(--white);\n    color: var(--black);\n  }\n\n.header-sticky.is-scrolling .header-cart-icon__count {\n    background-color: var(--red);\n    color: var(--white);\n  }\n\n/* critical:start */\n\n.hero {\n  position: relative;\n}\n\n.hero.hero--index {\n    margin-top: -51px;\n  }\n\n@media (min-width: 768px) {\n\n.hero.hero--index {\n      margin-top: -66px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.hero.hero--index {\n      margin-top: -71px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.hero.hero--index {\n      margin-top: -81px\n  }\n    }\n\n.hero.hero--index .video__el {\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      transform: none;\n      object-fit: cover;\n    }\n\n.hero.hero--index .hero__video-wrapper::before {\n      padding-bottom: calc(768 / 432 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.hero.hero--index .hero__video-wrapper::before {\n        padding-bottom: calc(426 / 768 * 100%)\n    }\n      }\n\n@media (min-width: 1440px) {\n\n.hero.hero--index .hero__video-wrapper::before {\n        padding-bottom: calc(340 / 768 * 100%)\n    }\n      }\n\n.shopify-section:not(:first-child) .hero {\n    margin-top: 0;\n  }\n\n.hero__video-wrapper::before {\n    padding-bottom: calc(513 / 320 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.hero__video-wrapper::before {\n      padding-bottom: calc(426 / 768 * 100%)\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.hero__video-wrapper::before {\n      padding-bottom: calc(340 / 768 * 100%)\n  }\n    }\n\n@media (min-width: 768px) {\n\n.hero--index .hero__video-wrapper {\n      max-height: calc(100vh - 39px)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.hero--index .hero__video-wrapper {\n      max-height: calc(100vh - 41px)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.hero--index .hero__video-wrapper {\n      max-height: calc(100vh - 187px)\n  }\n    }\n\n.hero--marketing .hero__video-wrapper {\n    overflow: hidden;\n    max-height: 810px;\n  }\n\n@media (min-width: 768px) {\n\n.hero--marketing .hero__video-wrapper::before {\n        padding-bottom: calc(432 / 768 * 100%)\n    }\n      }\n\n.hero__video {\n  overflow: hidden;\n}\n\n.hero__body {\n  display: flex;\n  z-index: unset;\n}\n\n.hero--index .hero__body {\n    align-items: flex-start;\n    padding-top: var(--h-header);\n  }\n\n@media (min-width: 768px) {\n\n.hero--index .hero__body {\n      padding-top: var(--h-header-tablet)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.hero--index .hero__body {\n      padding-top: var(--h-header-laptop)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.hero--index .hero__body {\n      padding-top: var(--h-header-desktop)\n  }\n    }\n\n@media (min-width: 768px) {\n\n.hero--storytelling .hero__body {\n      align-items: center\n  }\n    }\n\n.hero__container {\n  z-index: 2;\n}\n\n.hero__inner {\n  padding: 20px 0;\n}\n\n@media (min-width: 768px) {\n\n.hero__inner {\n    padding: 30px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.hero__inner {\n    padding: 40px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.hero__inner {\n    padding: 60px 0\n}\n  }\n\n.template-boston .hero__inner,\n  .template-chicago .hero__inner {\n    padding: 40px 0;\n  }\n\n@media (min-width: 1000px) {\n\n.template-boston .hero__inner,\n  .template-chicago .hero__inner {\n      padding: 40px 0\n  }\n    }\n\n.hero--marketing .hero__inner {\n    padding: 30px 0;\n  }\n\n@media (min-width: 1000px) {\n\n.hero--marketing .hero__inner {\n      padding: 40px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.hero--marketing .hero__inner {\n      padding: 60px 0\n  }\n    }\n\n.hero__title {\n  max-width: 237px;\n  margin: 0 0 5px;\n  color: var(--white);\n}\n\n@media (min-width: 1000px) {\n\n.hero__title {\n    max-width: 320px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.hero__title {\n    max-width: 384px\n}\n  }\n\n.hero--marketing .hero__title {\n    max-width: 280px;\n  }\n\n@media (min-width: 1000px) {\n\n.hero--marketing .hero__title {\n      max-width: 453px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.hero--marketing .hero__title {\n      margin-bottom: 10px\n  }\n    }\n\n.hero__description {\n  max-width: 280px;\n  margin-bottom: 15px;\n  color: var(--white);\n}\n\n@media (min-width: 1000px) {\n\n.hero__description {\n    max-width: 305px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.hero__description {\n    max-width: 360px\n}\n  }\n\n.hero--marketing .hero__description {\n    max-width: 305px;\n    margin-bottom: 5px;\n  }\n\n@media (min-width: 768px) {\n\n.hero--marketing .hero__description {\n      margin-bottom: 10px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.hero--marketing .hero__description {\n      max-width: 416px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.hero--marketing .hero__description {\n      margin-bottom: 15px\n  }\n    }\n\n.hero__cta {\n  min-width: 1rem;\n}\n\n.hero--marketing .hero__cta {\n    min-width: auto;\n  }\n\n.hero__headline {\n  margin-bottom: 10px;\n}\n\n.hero--storytelling .hero__headline,\n  .hero--storytelling .hero__title {\n    width: 100%;\n    max-width: 280px;\n  }\n\n@media (min-width: 1000px) {\n\n.hero--storytelling .hero__headline,\n  .hero--storytelling .hero__title {\n      max-width: 336px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.hero--storytelling .hero__headline,\n  .hero--storytelling .hero__title {\n      max-width: 433px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.hero--storytelling .hero__description {\n      max-width: 419px\n  }\n    }\n\n.hero--storytelling .hero__video-wrapper {\n    max-height: 600px;\n    overflow: hidden;\n  }\n\n.hero--storytelling .hero__video-wrapper::before {\n      padding-bottom: calc(400 / 320 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.hero--storytelling .hero__video-wrapper::before {\n        padding-bottom: calc(322 / 768 * 100%)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.hero--storytelling .hero__video-wrapper::before {\n        padding-bottom: calc(428 / 1024 * 100%)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.hero--storytelling .hero__video-wrapper::before {\n        padding-bottom: calc(600 / 1440 * 100%)\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.hero--storytelling .hero__video-wrapper::before {\n        padding-bottom: calc(600 / 1600 * 100%)\n    }\n      }\n\n.hero__overlay {\n  background-color: var(--black);\n  z-index: 1;\n}\n\n.hero.hero--plp {\n  margin-top: var(--gutter);\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  width: calc(100% - var(--gutter) * 2);\n}\n\n@media (min-width: 768px) {\n\n.hero.hero--plp {\n    width: calc(100% - var(--gutter-tablet) * 2);\n    margin-top: var(--gutter-tablet)\n}\n  }\n\n@media (min-width: 1024px) {\n\n.hero.hero--plp {\n    width: calc(100% - var(--gutter-laptop) * 2);\n    margin-top: var(--gutter-laptop)\n}\n  }\n\n@media (min-width: 1440px) {\n\n.hero.hero--plp {\n    width: calc(100% - var(--gutter-desktop) * 2);\n    margin-top: var(--gutter-desktop)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.hero.hero--plp {\n    width: calc(100% - var(--gutter-large-desktop) * 2);\n    margin-top: var(--gutter-large-desktop)\n}\n  }\n\n.hero.hero--plp .video__el {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transform: none;\n    object-fit: cover;\n  }\n\n.hero.hero--plp .hero__body {\n    align-items: flex-end;\n    padding-top: var(--h-header);\n  }\n\n@media (min-width: 768px) {\n\n.hero.hero--plp .hero__body {\n      padding-top: var(--h-header-tablet)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.hero.hero--plp .hero__body {\n      padding-top: var(--h-header-laptop)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.hero.hero--plp .hero__body {\n      padding-top: var(--h-header-desktop)\n  }\n    }\n\n.hero.hero--plp .hero__title {\n    max-width: 433px;\n  }\n\n.hero.hero--plp .hero__description {\n    max-width: 419px;\n  }\n\n.hero.hero--plp .hero__video-wrapper::before {\n      padding-bottom: calc(400 / 320 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.hero.hero--plp .hero__video-wrapper::before {\n        padding-bottom: calc(560 / 768 * 100%)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.hero.hero--plp .hero__video-wrapper::before {\n        padding-bottom: calc(560 / 1024 * 100%)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.hero.hero--plp .hero__video-wrapper::before {\n        padding-bottom: calc(560 / 1440 * 100%)\n    }\n      }\n\n.hero.hero--plp.hero--content-center .hero__inner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n.hero.hero--plp.hero--content-right .hero__inner {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    text-align: right;\n  }\n\n/* critical:end */\n\n.hero-basic {\n  position: relative;\n  margin-top: -51px;\n}\n\n@media (min-width: 768px) {\n\n.hero-basic {\n    margin-top: -66px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.hero-basic {\n    margin-top: -71px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.hero-basic {\n    margin-top: -81px\n}\n  }\n\n.hero-basic__image {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.hero-basic__image::after {\n    content: '';\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    opacity: 0.15;\n    background-color: var(--black);\n  }\n\n.hero-basic__inner {\n  position: relative;\n  z-index: 5;\n  align-items: center;\n  display: flex;\n  height: 250px;\n  padding-top: 51px;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.hero-basic__inner {\n    height: 300px;\n    padding-top: 66px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.hero-basic__inner {\n    height: 320px;\n    padding-top: 71px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.hero-basic__inner {\n    height: 400px;\n    padding-top: 81px\n}\n  }\n\n.icon {\n  width: 1.35rem;\n}\n\n.icon svg {\n    width: 100%;\n    height: 100%;\n  }\n\n.icon--md {\n  width: 1.6rem;\n}\n\n.icon--lg {\n  width: 1.8rem;\n}\n\n.icon--xl {\n  width: 2.1rem;\n}\n\n.icon--xxl {\n  width: 3.4rem;\n}\n\n.icon--auto {\n  width: auto;\n}\n\n.icon-arrow-left,\n.icon-arrow-right {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border: solid var(--black);\n  border-width: 1px 1px 0 0;\n  transform: rotate(45deg);\n}\n\n.icon-arrow-left {\n  border-width: 1px 0 0 1px;\n  transform: rotate(-45deg);\n}\n\n.image-grid-gallery {\n  margin: 40px 0;\n}\n\n@media (min-width: 1240px) {\n\n.image-grid-gallery {\n    margin: 80px 0\n}\n  }\n\n.image-grid-gallery__list {\n  display: grid;\n  grid-template-rows: auto auto auto;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 10px;\n  grid-gap: 10px;\n  gap: 10px;\n}\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__list {\n    grid-template-rows: auto auto;\n    grid-template-columns: 49.295% 1fr 1fr;\n    grid-row-gap: 11px;\n    grid-gap: 11px 10px;\n    gap: 11px 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.image-grid-gallery__list {\n    grid-template-columns: 49.26% 1fr 1fr;\n    grid-gap: 17px 15px;\n    gap: 17px 15px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.image-grid-gallery__list {\n    grid-template-columns: 49.254% 1fr 1fr;\n    grid-gap: 20px;\n    gap: 20px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.image-grid-gallery__list {\n    grid-template-columns: 49.122% 1fr 1fr;\n    grid-gap: 20px 25px;\n    gap: 20px 25px\n}\n  }\n\n.image-grid-gallery__item:nth-child(1) {\n    grid-area: 1 / 1 / 2 / 3;\n  }\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__item:nth-child(1) {\n      grid-area: 1 / 1 / 3 / 2\n  }\n    }\n\n.image-grid-gallery__item:nth-child(2) {\n    grid-area: 2 / 1 / 3 / 3;\n  }\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__item:nth-child(2) {\n      grid-area: 1 / 2 / 2 / 4\n  }\n    }\n\n.image-grid-gallery__item:nth-child(3) {\n    grid-area: 3 / 1 / 4 / 2;\n  }\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__item:nth-child(3) {\n      grid-area: 2 / 2 / 3 / 3\n  }\n    }\n\n.image-grid-gallery__item:nth-child(4) {\n    grid-area: 3 / 2 / 4 / 3;\n  }\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__item:nth-child(4) {\n      grid-area: 2 / 3 / 3 / 4\n  }\n    }\n\n.image-grid-gallery__item--video {\n  cursor: pointer;\n}\n\n.image-grid-gallery__item-image {\n  overflow: hidden;\n  max-height: 390px;\n}\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__item-image {\n    height: 100%\n}\n  }\n\n.image-grid-gallery__item:nth-child(1) .image-grid-gallery__item-image {\n    max-height: 800px;\n  }\n\n.image-grid-gallery__item-image::before {\n  padding-bottom: calc(164 / 135 * 100%);\n}\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__item-image::before {\n    padding-bottom: calc(207 / 170 * 100%)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.image-grid-gallery__item-image::before {\n    padding-bottom: calc(273 / 224 * 100%)\n}\n  }\n\n@media (min-width: 1240px) {\n\n.image-grid-gallery__item-image::before {\n    padding-bottom: calc(390 / 320 * 100%)\n}\n  }\n\n.image-grid-gallery__item:nth-child(1) .image-grid-gallery__item-image::before {\n    padding-bottom: calc(340 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__item:nth-child(1) .image-grid-gallery__item-image::before {\n      padding-bottom: calc(424 / 349 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.image-grid-gallery__item:nth-child(1) .image-grid-gallery__item-image::before {\n      padding-bottom: calc(564 / 465 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.image-grid-gallery__item:nth-child(1) .image-grid-gallery__item-image::before {\n      padding-bottom: calc(800 / 660 * 100%)\n  }\n    }\n\n.image-grid-gallery__item:nth-child(2) .image-grid-gallery__item-image::before {\n    padding-bottom: calc(166 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.image-grid-gallery__item:nth-child(2) .image-grid-gallery__item-image::before {\n      padding-bottom: calc(206 / 349 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.image-grid-gallery__item:nth-child(2) .image-grid-gallery__item-image::before {\n      padding-bottom: calc(274 / 464 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.image-grid-gallery__item:nth-child(2) .image-grid-gallery__item-image::before {\n      padding-bottom: calc(390 / 660 * 100%)\n  }\n    }\n\n.image-pair {\n  margin-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n\n.image-pair {\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.image-pair {\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.image-pair {\n    margin-bottom: 50px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.image-pair {\n    margin-bottom: 60px\n}\n  }\n\n.image-pair--storytelling {\n    margin-bottom: 50px;\n  }\n\n@media (min-width: 768px) {\n\n.image-pair--storytelling {\n      margin-bottom: 40px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.image-pair--storytelling {\n      margin-bottom: 60px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.image-pair--storytelling {\n      margin-bottom: 80px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.image-pair__inner {\n    display: flex;\n    flex-wrap: wrap\n}\n  }\n\n.image-pair__col {\n  position: relative;\n  display: flex;\n}\n\n.image-pair__col::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: var(--black-o-20);\n    pointer-events: none;\n  }\n\n.image-pair__col::before {\n    content: '';\n    display: block;\n    position: relative;\n    padding-top: 100%;\n  }\n\n@media (min-width: 768px) {\n\n.image-pair__col {\n    width: 50%\n}\n  }\n\n@media (min-width: 768px) {\n\n.image-pair--3 .image-pair__col {\n      width: calc(1 / 3 * 100%)\n  }\n    }\n\n.image-pair--3 .image-pair__col::before {\n      padding-top: calc(533 / 446 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.image-pair--4 .image-pair__col {\n      width: calc(1 / 2 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.image-pair--4 .image-pair__col {\n      width: calc(1 / 4 * 100%)\n  }\n    }\n\n.image-pair--4 .image-pair__col::before {\n      padding-top: calc(400 / 335 * 100%);\n    }\n\n.image-pair__content {\n  position: relative;\n  z-index: 5;\n  flex-direction: column;\n  display: flex;\n  height: auto;\n  margin: 30px auto;\n  text-align: center;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.image-pair__content {\n    max-width: 240px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.image-pair__content {\n    max-width: 300px;\n    margin-top: 40px;\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.image-pair__content {\n    max-width: 375px;\n    margin-top: 60px;\n    margin-bottom: 60px\n}\n  }\n\n.image-pair__title {\n  margin: 0 0 5px;\n}\n\n.image-pair__description {\n  margin: 0 0 30px;\n}\n\n.image-pair__bottom {\n  margin-top: auto;\n}\n\n.image-pair__button {\n  min-width: auto;\n}\n\n.large-text-cta {\n  margin: 50px 0;\n}\n\n@media (min-width: 768px) {\n\n.large-text-cta {\n    margin: 40px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.large-text-cta {\n    margin: 60px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.large-text-cta {\n    margin: 80px 0\n}\n  }\n\n.large-text-cta__content {\n  margin: 0 auto;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.large-text-cta__content {\n    max-width: 588px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.large-text-cta__content {\n    max-width: 732px\n}\n  }\n\n.large-text-cta__content img {\n    position: relative;\n    top: -2px;\n    width: 35px;\n    margin: 0 5px;\n    vertical-align: middle;\n  }\n\n@media (min-width: 1000px) {\n\n.large-text-cta__content img {\n      width: 38px;\n      margin: 0 8px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.large-text-cta__content img {\n      top: -3px;\n      width: 57px\n  }\n    }\n\n.large-text-cta__content--brackets p {\n    padding: 0 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.large-text-cta__content--brackets p {\n      padding: 0 20px\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.large-text-cta__content--brackets p {\n      padding: 0 40px\n  }\n    }\n\n.large-text-cta__content--brackets svg {\n    width: 27px;\n    height: 70px;\n  }\n\n@media (min-width: 1000px) {\n\n.large-text-cta__content--brackets svg {\n      width: 31px;\n      height: 80px\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.large-text-cta__content--brackets svg {\n      width: 37px;\n      height: 95px\n  }\n    }\n\n.layered-cta {\n  margin: 30px 0;\n}\n\n@media (min-width: 768px) {\n\n.layered-cta {\n    margin: 40px 0 60px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.layered-cta {\n    margin: 80px 0\n}\n  }\n\n.layered-cta.layered-cta--storytelling-landing {\n    margin: 0;\n    padding: 80px 0;\n  }\n\n@media (min-width: 768px) {\n\n.layered-cta.layered-cta--storytelling-landing {\n      padding: 40px 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.layered-cta.layered-cta--storytelling-landing {\n      padding: 60px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.layered-cta.layered-cta--storytelling-landing {\n      padding: 80px 0\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.layered-cta.layered-cta--storytelling-landing {\n      padding: 100px 0\n  }\n    }\n\n.layered-cta__inner {\n  position: relative;\n  flex-direction: column;\n}\n\n@media (min-width: 768px) {\n\n.layered-cta__inner {\n    flex-direction: row\n}\n  }\n\n.layered-cta__image {\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n\n.layered-cta__image--left {\n    width: 49.29%\n}\n  }\n\n@media (min-width: 1000px) {\n\n.layered-cta__image--left {\n    width: 50%\n}\n  }\n\n@media (min-width: 1240px) {\n\n.layered-cta__image--left {\n    width: 50.22%\n}\n  }\n\n@media (min-width: 1600px) {\n\n.layered-cta__image--left {\n    width: 49.12%\n}\n  }\n\n.layered-cta__image--left::before {\n    padding-bottom: calc(332 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.layered-cta__image--left::before {\n      padding-bottom: calc(416 / 349 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.layered-cta__image--left::before {\n      padding-bottom: calc(562 / 472 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.layered-cta__image--left::before {\n      padding-bottom: calc(800 / 673 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.layered-cta__image--left::before {\n      padding-bottom: calc(800 / 727 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.layered-cta--storytelling-landing .layered-cta__image--left {\n      width: calc(727 / 1480 * 100%)\n  }\n\n      .layered-cta--storytelling-landing .layered-cta__image--left::before {\n        padding-bottom: calc(430 / 362 * 100%);\n      }\n    }\n\n@media (min-width: 1600px) and (min-width: 768px) {\n\n      .layered-cta--storytelling-landing .layered-cta__image--left::before {\n          padding-bottom: calc(415 / 349 * 100%)\n      }\n        }\n\n@media (min-width: 1600px) and (min-width: 1000px) {\n\n      .layered-cta--storytelling-landing .layered-cta__image--left::before {\n          padding-bottom: calc(561 / 472 * 100%)\n      }\n        }\n\n@media (min-width: 1600px) and (min-width: 1240px) {\n\n      .layered-cta--storytelling-landing .layered-cta__image--left::before {\n          padding-bottom: calc(800 / 673 * 100%)\n      }\n        }\n\n@media (min-width: 1600px) and (min-width: 1600px) {\n\n      .layered-cta--storytelling-landing .layered-cta__image--left::before {\n          padding-bottom: calc(800 / 727 * 100%)\n      }\n        }\n\n.layered-cta__image--right {\n  width: calc(100% - 20px);\n}\n\n@media (min-width: 768px) {\n\n.layered-cta__image--right {\n    width: 50.71%\n}\n  }\n\n@media (min-width: 1000px) {\n\n.layered-cta__image--right {\n    width: 50%\n}\n  }\n\n@media (min-width: 1240px) {\n\n.layered-cta__image--right {\n    width: 49.78%\n}\n  }\n\n@media (min-width: 1600px) {\n\n.layered-cta__image--right {\n    max-width: 50.88%\n}\n  }\n\n.layered-cta__image--right::before {\n    padding-bottom: calc(274 / 260 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.layered-cta__image--right::before {\n      padding-bottom: calc(378 / 359 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.layered-cta__image--right::before {\n      padding-bottom: calc(496 / 472 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.layered-cta__image--right::before {\n      padding-bottom: calc(700 / 667 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.layered-cta__image--right::before {\n      padding-bottom: calc(700 / 753 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.layered-cta--storytelling-landing .layered-cta__image--right {\n      width: calc(753 / 1480 * 100%)\n  }\n    }\n\n.layered-cta--storytelling-landing .layered-cta__image--right::before {\n      padding-bottom: calc(358 / 342 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.layered-cta--storytelling-landing .layered-cta__image--right::before {\n        padding-bottom: calc(377 / 359 * 100%)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.layered-cta--storytelling-landing .layered-cta__image--right::before {\n        padding-bottom: calc(496 / 472 * 100%)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.layered-cta--storytelling-landing .layered-cta__image--right::before {\n        padding-bottom: calc(700 / 667 * 100%)\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.layered-cta--storytelling-landing .layered-cta__image--right::before {\n        padding-bottom: calc(700 / 753 * 100%)\n    }\n      }\n\n.layered-cta__content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 220px;\n  transform: translate(-50%, -50%);\n  background-color: var(--parchment);\n}\n\n@media (min-width: 768px) {\n\n.layered-cta__content {\n    width: 250px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.layered-cta__content {\n    width: 320px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.layered-cta__content {\n    width: 474px\n}\n  }\n\n.layered-cta__content-inner {\n  padding: 40px 20px;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.layered-cta__content-inner {\n    padding: 45px 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.layered-cta__content-inner {\n    padding: 60px 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.layered-cta__content-inner {\n    padding: 160px 83px\n}\n  }\n\n.layered-cta--storytelling-landing .layered-cta__content-inner {\n    padding: 30px 20px;\n  }\n\n@media (min-width: 768px) {\n\n.layered-cta--storytelling-landing .layered-cta__content-inner {\n      padding: 28px 20px 29px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.layered-cta--storytelling-landing .layered-cta__content-inner {\n      padding: 54px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.layered-cta--storytelling-landing .layered-cta__content-inner {\n      padding: 143px 48px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.layered-cta--storytelling-landing .layered-cta__content-inner {\n      padding: 134px 83px\n  }\n    }\n\n.layered-cta__title {\n  margin-bottom: 5px;\n}\n\n@media (min-width: 1240px) {\n\n.layered-cta__title {\n    margin-bottom: 10px\n}\n  }\n\n.layered-cta--storytelling-landing .layered-cta__title {\n    font-size: 21px;\n  }\n\n@media (min-width: 1240px) {\n\n.layered-cta--storytelling-landing .layered-cta__title {\n      font-size: 26px\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.layered-cta--storytelling-landing .layered-cta__title {\n      font-size: 32px\n  }\n    }\n\n.layered-cta__button {\n  margin-top: 10px;\n}\n\n@media (min-width: 768px) {\n\n.layered-cta__button {\n    margin-top: 15px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.layered-cta__button {\n    margin-bottom: 20px\n}\n  }\n\n.layered-cta--storytelling-landing .layered-cta__button {\n    color: inherit;\n  }\n\n.layered-cta--storytelling-landing .layered-cta__button:not([disabled]):hover {\n      color: inherit;\n    }\n\n.layered-cta__text {\n  margin: 0;\n}\n\n.layered-cta--storytelling-landing .layered-cta__text {\n\n    opacity: 0.6;\n  }\n\n@media (max-width: 1023px) {\n\n.layered-cta--storytelling-landing .layered-cta__text {\n    font-size: 13px;\n  }\n  }\n\n.meet-farmers {\n  overflow: hidden;\n  margin: 30px 0;\n  padding: 55px 0 52px;\n  background-image: var(--meet-farmers-bg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n@media (max-width: 767px) {\n\n.meet-farmers {\n    background-image: var(--meet-farmers-bg-mobile, var(--meet-farmers-bg))\n}\n  }\n\n@media (min-width: 768px) and (max-width: 1023px) {\n\n.meet-farmers {\n    background-image: var(--meet-farmers-bg-768, var(--meet-farmers-bg))\n}\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers {\n    margin: 40px 0;\n    padding: 46px 0 45px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers {\n    padding: 67px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers {\n    margin: 60px 0;\n    padding: 121px 0\n}\n  }\n\n.meet-farmers.meet-farmers--storytelling-landing {\n    margin: 0;\n    padding: 80px 0;\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers.meet-farmers--storytelling-landing {\n      padding: 80px 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.meet-farmers.meet-farmers--storytelling-landing {\n      padding: 80px 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.meet-farmers.meet-farmers--storytelling-landing {\n      padding: 120px 0\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.meet-farmers.meet-farmers--storytelling-landing {\n      padding: 100px 0\n  }\n    }\n\n@media (min-width: 768px) {\n\n.meet-farmers__inner {\n    max-width: 530px;\n    margin: 0 auto\n}\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers__inner {\n    max-width: 702px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers__inner {\n    max-width: 1000px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.meet-farmers__inner {\n    max-width: 1106px\n}\n  }\n\n.meet-farmers__head {\n  margin: 0 auto 20px;\n  text-align: center;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.meet-farmers__head {\n    max-width: 522px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers__head {\n    max-width: 636px;\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers__head {\n    max-width: 638px\n}\n  }\n\n.meet-farmers--storytelling-landing .meet-farmers__head {\n    margin-bottom: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__head {\n      margin-bottom: 30px;\n      max-width: 430px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__head {\n      margin-bottom: 30px;\n      max-width: 430px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__head {\n      margin-bottom: 60px;\n      max-width: 746px\n  }\n    }\n\n.meet-farmers--stack-mobile .meet-farmers__head {\n    margin-bottom: 40px;\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers--stack-mobile .meet-farmers__head {\n      max-width: 362px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--stack-mobile .meet-farmers__head {\n      margin-bottom: 60px;\n      max-width: 638px\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.meet-farmers--stack-mobile .meet-farmers__head {\n      margin-bottom: 80px\n  }\n    }\n\n.meet-farmers__title {\n  margin: 0 0 5px;\n  font-size: 24px;\n}\n\n@media (min-width: 1240px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__title {\n      font-size: 32px\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__title {\n      font-size: 40px\n  }\n    }\n\n.meet-farmers--stack-mobile .meet-farmers__title {\n    font-size: 21px;\n    font-weight: 300;\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--stack-mobile .meet-farmers__title {\n      font-size: 32px\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.meet-farmers--stack-mobile .meet-farmers__title {\n      font-size: 40px\n  }\n    }\n\n.meet-farmers__description {\n  margin: 0;\n}\n\n.meet-farmers--storytelling-landing .meet-farmers__description {\n    font-size: 13px;\n    opacity: 0.6;\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__description {\n      font-size: 15px\n  }\n    }\n\n.meet-farmers__carousel.swiper {\n  overflow: visible;\n}\n\n.meet-farmers--stack-mobile .meet-farmers__carousel.swiper {\n    max-width: 242px;\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers--stack-mobile .meet-farmers__carousel.swiper {\n      max-width: none\n  }\n    }\n\n.meet-farmers__wrapper--center {\n  justify-content: center;\n}\n\n@media (min-width: 768px) {\n\n.meet-farmers__wrapper.swiper-wrapper {\n    display: flex;\n    justify-content: center;\n    transform: none;\n    width: auto;\n    height: auto;\n    margin: 0 -5px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers__wrapper.swiper-wrapper {\n    margin: 0 -7.5px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers__wrapper.swiper-wrapper {\n    margin: 0 -10px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.meet-farmers__wrapper.swiper-wrapper {\n    margin: 0 -12.5px\n}\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers--gap-wider .meet-farmers__wrapper.swiper-wrapper {\n    margin: 0 -32px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers--gap-wider .meet-farmers__wrapper.swiper-wrapper {\n    margin: 0 -32px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--gap-wider .meet-farmers__wrapper.swiper-wrapper {\n    margin: 0 -60px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.meet-farmers--gap-wider .meet-farmers__wrapper.swiper-wrapper {\n    margin: 0 -60px\n}\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers__slide.swiper-slide {\n    width: calc(100% / 3);\n    padding: 0 5px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers__slide.swiper-slide {\n    padding: 0 7.5px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers__slide.swiper-slide {\n    padding: 0 10px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.meet-farmers__slide.swiper-slide {\n    padding: 0 12.5px\n}\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers--gap-wider .meet-farmers__slide.swiper-slide {\n    padding: 0 32px;\n    width: 234px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers--gap-wider .meet-farmers__slide.swiper-slide {\n    padding: 0 32px;\n    width: 288px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--gap-wider .meet-farmers__slide.swiper-slide {\n    padding: 0 60px;\n    width: 440px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.meet-farmers--gap-wider .meet-farmers__slide.swiper-slide {\n    padding: 0 60px;\n    width: 472px\n}\n  }\n\n@media (max-width: 767px) {\n  .meet-farmers--stack-mobile .meet-farmers__carousel.swiper {\n    overflow: visible;\n  }\n\n  .meet-farmers--stack-mobile .meet-farmers__wrapper.swiper-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    height: auto;\n    margin: 0;\n    transform: none;\n    grid-gap: 20px;\n    gap: 20px;\n  }\n\n  .meet-farmers--stack-mobile.meet-farmers--gap-wider .meet-farmers__wrapper.swiper-wrapper {\n    grid-gap: 40px;\n    gap: 40px;\n  }\n\n  .meet-farmers--stack-mobile .meet-farmers__slide.swiper-slide {\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    margin: 0;\n  }\n}\n\n.meet-farmers__card-image {\n  margin: 0 0 10px;\n}\n\n@media (min-width: 768px) {\n\n.meet-farmers__card-image {\n    overflow: hidden;\n    max-height: 383px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers__card-image {\n    margin-bottom: 15px\n}\n  }\n\n.meet-farmers__card-image::before {\n    padding-bottom: calc(163 / 135 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.meet-farmers__card-image::before {\n      padding-bottom: calc(203 / 170 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.meet-farmers__card-image::before {\n      padding-bottom: calc(269 / 224 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.meet-farmers__card-image::before {\n      padding-bottom: calc(383 / 320 * 100%)\n  }\n    }\n\n.meet-farmers--storytelling-landing .meet-farmers__card-image {\n    margin: 0 0 10px;\n    max-height: none;\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__card-image {\n      margin-bottom: 10px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__card-image {\n      margin-bottom: 20px\n  }\n    }\n\n.meet-farmers--storytelling-landing .meet-farmers__card-image::before {\n      padding-bottom: calc(211 / 176 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__card-image::before {\n        padding-bottom: calc(204 / 170 * 100%)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__card-image::before {\n        padding-bottom: calc(269 / 224 * 100%)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__card-image::before {\n        padding-bottom: calc(383 / 320 * 100%)\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__card-image::before {\n        padding-bottom: calc(423 / 352 * 100%)\n    }\n      }\n\n.meet-farmers--stack-mobile .meet-farmers__card-image {\n    margin: 0 0 20px;\n    max-height: none;\n  }\n\n@media (min-width: 1000px) {\n\n.meet-farmers--stack-mobile .meet-farmers__card-image {\n      margin-bottom: 20px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--stack-mobile .meet-farmers__card-image {\n      margin-bottom: 20px\n  }\n    }\n\n.meet-farmers--stack-mobile .meet-farmers__card-image::before {\n      padding-bottom: calc(294 / 242 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.meet-farmers--stack-mobile .meet-farmers__card-image::before {\n        padding-bottom: calc(207 / 170 * 100%)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.meet-farmers--stack-mobile .meet-farmers__card-image::before {\n        padding-bottom: calc(272 / 224 * 100%)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--stack-mobile .meet-farmers__card-image::before {\n        padding-bottom: calc(400 / 320 * 100%)\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.meet-farmers--stack-mobile .meet-farmers__card-image::before {\n        padding-bottom: calc(440 / 352 * 100%)\n    }\n      }\n\n.meet-farmers__card-content {\n  text-align: center;\n  color: var(--white);\n}\n\n.meet-farmers__card-title {\n  margin: 0 0 5px;\n}\n\n.meet-farmers--storytelling-landing .meet-farmers__card-title {\n    font-size: 12px;\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__card-title {\n      font-size: 14px\n  }\n    }\n\n.meet-farmers__card-text {\n  margin: 0;\n}\n\n.meet-farmers--storytelling-landing .meet-farmers__card-text {\n    font-size: 13px;\n    opacity: 0.6;\n  }\n\n@media (min-width: 1240px) {\n\n.meet-farmers--storytelling-landing .meet-farmers__card-text {\n      font-size: 15px\n  }\n    }\n\n.mini-cart,\n.mini-cart-bg {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 998;\n  width: 100%;\n}\n\n.mini-cart {\n  top: 0;\n  bottom: 0;\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 352px;\n  background: var(--white);\n}\n\n@media (min-width: 1000px) {\n\n.mini-cart {\n    max-width: 400px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.mini-cart {\n    max-width: 450px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.mini-cart {\n    max-width: 537px\n}\n  }\n\n.mini-cart__header {\n  position: relative;\n  margin: 0;\n  padding: 20px 20px 15px;\n}\n\n@media (min-width: 768px) {\n\n.mini-cart__header {\n    padding: 30px 25px 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.mini-cart__header {\n    padding: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.mini-cart__header {\n    padding: 40px 40px 30px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.mini-cart__header {\n    padding: 50px 50px 30px\n}\n  }\n\n.mini-cart__header-title {\n  margin: 0;\n  color: var(--black);\n}\n\n.mini-cart__close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  color: var(--grey);\n}\n\n@media (min-width: 1000px) {\n\n.mini-cart__close {\n    top: 30px;\n    right: 30px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.mini-cart__close {\n    top: 40px;\n    right: 40px\n}\n  }\n\n.mini-cart-bg {\n  background-color: var(--black);\n  opacity: 0.3;\n  cursor: pointer;\n}\n\n.mini-cart__close button {\n  cursor: pointer;\n}\n\n.mini-cart__close button .icon {\n    width: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.mini-cart__close button .icon {\n      width: 15px\n  }\n    }\n\n.modal {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  overflow-y: auto;\n  transition: opacity 0.2s var(--ease), visibility 0s var(--ease);\n  padding: 20px;\n  pointer-events: none;\n}\n\n.modal--opened {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.modal__overlay {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1001;\n  background-color: var(--black-o-75);\n}\n\n@media (min-width: 768px) {\n\n.modal__overlay {\n    display: none\n}\n  }\n\n.modal--opened .modal__overlay {\n    display: block;\n  }\n\n.modal__container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 100%;\n}\n\n.modal__wrapper {\n  z-index: 1002;\n  width: 100%;\n}\n\n.modal--product-form .modal__wrapper {\n    padding: 30px 20px;\n    background-color: var(--white);\n  }\n\n@media (min-width: 1000px) {\n\n.modal--product-form .modal__wrapper {\n      padding: 50px 40px\n  }\n    }\n\n.modal--product-form .modal__wrapper a {\n      color: inherit;\n    }\n\n.modal__inner {\n  position: relative;\n  z-index: 2;\n}\n\n.modal__close {\n  top: -35px;\n  right: -9px;\n  z-index: 5;\n  cursor: pointer;\n}\n\n@media (min-width: 1000px) {\n\n.modal__close {\n    top: 0;\n    right: -45px\n}\n  }\n\n.modal--product-form .modal__close {\n    top: 0;\n    right: 0;\n  }\n\n@media (min-width: 1000px) {\n\n.modal--product-form .modal__close {\n      top: 10px;\n      right: 10px\n  }\n    }\n\n.modal__close-icon {\n  display: block;\n  width: 32px;\n  height: 32px;\n}\n\n.modal__close-icon::before,\n  .modal__close-icon::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: inline-block;\n    width: 20px;\n    height: 2px;\n    background-color: var(--white);\n  }\n\n.modal--product-form .modal__close-icon::before, .modal--product-form .modal__close-icon::after {\n      background-color: var(--black);\n    }\n\n.modal__close-icon::before {\n    transform: translate(-50%, -50%) rotate(45deg);\n  }\n\n.modal__close-icon::after {\n    transform: translate(-50%, -50%) rotate(-45deg);\n  }\n\n.modal__inner-footer {\n  margin-top: 10px;\n}\n\n.more__content {\n  display: none;\n}\n\n.more--show .more__content {\n    display: block;\n  }\n\n.nav {\n  position: relative;\n}\n\n.nav__list {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n@media (min-width: 768px) {\n\n.nav__list {\n    flex-direction: row;\n    align-items: center;\n    height: 100%\n}\n  }\n\n.nav__item {\n  position: relative;\n  width: 100%;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid var(--black-o-10);\n}\n\n@media (min-width: 768px) {\n\n.nav__item {\n    display: flex;\n    align-items: center;\n    width: auto;\n    height: 100%;\n    padding: 0;\n    border: none;\n    margin: 0 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.nav__item {\n    margin: 0 15px\n}\n  }\n\n.nav__item.is-active .icon {\n      transform: rotate(-180deg);\n    }\n\n.nav__item:first-child {\n    margin-left: 0;\n  }\n\n.nav__item-link {\n  justify-content: space-between;\n}\n\n.nav__item-link.is-active::after {\n      width: 100%;\n    }\n\n@media (max-width: 767px) {\n\n.nav__item-link::after {\n      content: none\n  }\n    }\n\n@media (min-width: 768px) {\n\n.nav__item-link--has-children .icon {\n        width: 9px;\n        margin-left: 5px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.nav__item-link--has-children .icon {\n        margin-left: 9px\n    }\n      }\n\n@media (min-width: 768px) {\n\n.nav__item--has-children.is-active .nav__item-link--has-children .icon {\n        transform: rotate(180deg)\n    }\n      }\n\n.nav__subnav {\n  display: none;\n  padding: 15px 0 0;\n  background-color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.nav__subnav {\n    display: block;\n    position: absolute;\n    top: calc(100% + 1px);\n    left: -25px;\n    border: 1px solid var(--black-o-10);\n    min-width: 160px;\n    padding: 20px 25px;\n    opacity: 0;\n    visibility: hidden\n}\n  }\n\n.nav__subnav-item {\n    margin-bottom: 15px;\n  }\n\n.nav__subnav-item:last-child {\n      margin-bottom: 0;\n    }\n\n.nav__subnav-link {\n    display: block;\n    border-bottom: none;\n  }\n\n@media (min-width: 768px) {\n\n.nav__subnav-link {\n      display: inline-block\n  }\n    }\n\n@media (max-width: 767px) {\n\n.nav__subnav-link::after {\n        content: none\n    }\n      }\n\n@media (min-width: 768px) {\n\n.nav__item--has-children.is-active .nav__subnav {\n      opacity: 1;\n      visibility: visible;\n      transition: all ease 0.3s\n  }\n    }\n\n.nav__item.is-active .nav__subnav {\n    display: block;\n  }\n\n.newsletter__form {\n  position: relative;\n  flex-wrap: wrap;\n  display: flex;\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n\n.newsletter__form {\n    justify-content: space-between\n}\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter__form {\n    justify-content: flex-start\n}\n  }\n\n@media (min-width: 1240px) {\n\n.newsletter__form {\n    justify-content: space-between\n}\n  }\n\n.newsletter-form--newsletter-signup-banner .newsletter__form,\n  .newsletter-form--newsletter-signup-banner-new .newsletter__form,\n  .newsletter-form--newsletter-modal .newsletter__form,\n  .newsletter-form--animated-hero .newsletter__form {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n\n.newsletter__field {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n@media (min-width: 768px) {\n\n.newsletter__field {\n    width: calc(50% - 38px);\n    margin-bottom: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter__field {\n    width: 100%;\n    margin-bottom: 10px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.newsletter__field {\n    width: calc(50% - 44px);\n    margin-bottom: 0\n}\n  }\n\n@media (min-width: 768px) {\n\n.newsletter-form--newsletter-signup-banner .newsletter__field,\n  .newsletter-form--newsletter-signup-banner-new .newsletter__field,\n  .newsletter-form--newsletter-modal .newsletter__field {\n      width: calc(50% - 5px)\n  }\n    }\n\n.newsletter-form--animated-hero .newsletter__field {\n    width: 100%;\n    margin-bottom: 0;\n  }\n\n@media (min-width: 768px) {\n\n.newsletter-form--newsletter-signup-banner-new .newsletter__field {\n      margin-bottom: 12px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.newsletter-form--newsletter-signup-banner-new .newsletter__field {\n      margin-bottom: 16px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.newsletter-form--newsletter-signup-banner-new .newsletter__field {\n      margin-bottom: 18px\n  }\n    }\n\n.newsletter__country-select {\n  position: absolute;\n  max-height: 40px;\n  top: 0;\n  right: auto;\n  bottom: 0;\n  left: 15px;\n  z-index: 1;\n  cursor: pointer;\n}\n\n@media (min-width: 1000px) {\n\n.newsletter__country-select {\n    left: 20px\n}\n  }\n\n.newsletter__country-select-text {\n  grid-gap: 5px;\n  gap: 5px;\n  height: 100%;\n}\n\n.newsletter__country-select-text svg {\n    width: 12px;\n    height: 12px;\n  }\n\n.newsletter__country-select-field {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  max-width: 100%;\n  opacity: 0;\n}\n\n.newsletter__text-input .text-input__el[name=\"phone_number\"] {\n    padding-left: 52px;\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter__text-input .text-input__el[name=\"phone_number\"] {\n      padding-left: 57px\n  }\n    }\n\n.newsletter__note {\n  align-self: center;\n  width: 100%;\n  margin-top: 15px;\n}\n\n@media (min-width: 768px) {\n\n.newsletter__note {\n    margin-top: 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter__note {\n    width: calc(100% - 120px);\n    margin-top: 0;\n    margin-left: auto;\n    padding-left: 10px;\n    text-align: right\n}\n  }\n\n@media (min-width: 1240px) {\n\n.newsletter__note {\n    width: 100%;\n    margin-top: 15px;\n    margin-left: 0;\n    padding-left: 0;\n    text-align: left\n}\n  }\n\n@media (min-width: 768px) {\n\n.newsletter-form--newsletter-signup-banner .newsletter__note {\n      width: auto;\n      margin-top: 0\n  }\n    }\n\n.newsletter-form--newsletter-signup-banner-new .newsletter__note {\n    font-size: 12px;\n\n    margin-top: 24px;\n  }\n\n@media (min-width: 1024px) {\n\n.newsletter-form--newsletter-signup-banner-new .newsletter__note {\n    font-size: 13px\n  }\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter-form--newsletter-signup-banner-new .newsletter__note {\n      width: 100%;\n      margin-top: 26px;\n      text-align: center\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.newsletter-form--newsletter-signup-banner-new .newsletter__note {\n      margin-top: 30px\n  }\n    }\n\n.newsletter__response {\n  position: relative;\n  z-index: 1;\n  margin-top: 5px;\n  padding: 0;\n}\n\n.newsletter__response.success {\n    position: relative;\n    margin-top: 19px;\n  }\n\n@media (min-width: 768px) {\n\n.newsletter__response.success {\n      margin-top: 24px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.newsletter-form--newsletter-signup-banner-new .newsletter__response.success {\n        margin-top: 30px\n    }\n      }\n\n.newsletter__response a {\n    color: inherit;\n  }\n\n.newsletter__success-text {\n  margin-bottom: 0;\n}\n\n.newsletter__success-sub-text {\n  margin-top: 9px;\n}\n\n.newsletter__button {\n  flex-shrink: 0;\n  align-self: center;\n}\n\n@media (min-width: 768px) {\n\n.newsletter-form--footer .newsletter__button {\n      align-self: flex-start;\n      margin-top: 3px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.newsletter-form--footer .newsletter__button {\n      align-self: center;\n      margin-top: 0\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.newsletter-form--footer .newsletter__button {\n      align-self: flex-start;\n      margin-top: 3px\n  }\n    }\n\n.newsletter-modal {\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  visibility: hidden;\n  overflow-y: auto;\n  transition: opacity 0.2s var(--ease), visibility 0s var(--ease);\n  padding: 20px;\n  pointer-events: none;\n}\n\n.newsletter-modal--is-active {\n  opacity: 1;\n  visibility: visible;\n  transition: opacity 0.2s var(--ease), visibility 0s var(--ease);\n  pointer-events: auto;\n}\n\n.newsletter-modal--is-active .newsletter-modal__overlay {\n    display: block;\n  }\n\n.newsletter-modal__overlay {\n  z-index: 1001;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: var(--black-o-20);\n}\n\n@media (min-width: 768px) {\n\n.newsletter-modal__overlay {\n    display: none\n}\n  }\n\n.newsletter-modal__container {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  width: 100%;\n  min-height: 100%;\n}\n\n.newsletter-modal__wrapper {\n  z-index: 1002;\n  min-height: 430px;\n  padding: 25px 20px;\n  background-color: var(--black);\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.newsletter-modal__wrapper {\n    width: 550px;\n    min-height: 550px;\n    padding: 40px 40px\n}\n  }\n\n.newsletter-modal__inner {\n  position: relative;\n  z-index: 2;\n}\n\n.newsletter-modal__close {\n  z-index: 5;\n  top: 12px;\n  right: 12px;\n  cursor: pointer;\n}\n\n.newsletter-modal__close-icon {\n  display: block;\n  width: 32px;\n  height: 32px;\n}\n\n.newsletter-modal__close-icon::before,\n  .newsletter-modal__close-icon::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    display: inline-block;\n    width: 15px;\n    height: 1px;\n    background-color: var(--white);\n  }\n\n.newsletter-modal__close-icon::before {\n    transform: translate(-50%, -50%) rotate(45deg);\n  }\n\n.newsletter-modal__close-icon::after {\n    transform: translate(-50%, -50%) rotate(-45deg);\n  }\n\n.newsletter-modal__header {\n  margin: 0 0 20px;\n}\n\n@media (min-width: 768px) {\n\n.newsletter-modal__header {\n    margin: 0 0 40px\n}\n  }\n\n.newsletter-modal__title {\n  margin: 0;\n}\n\n.newsletter-modal__description {\n  margin: 5px 0 0;\n}\n\n.newsletter-signup-banner {\n  min-height: 560px;\n  padding: 30px 0 212px;\n  background-repeat: no-repeat;\n  background-position: center bottom;\n  background-size: 100% auto;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.newsletter-signup-banner {\n    min-height: 319px;\n    padding: 30px 0 88px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner {\n    min-height: 427px;\n    padding: 40px 0 150px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.newsletter-signup-banner {\n    min-height: 600px;\n    padding: 60px 0 298px\n}\n  }\n\n@media (min-width: 768px) {\n\n.newsletter-signup-banner__inner {\n    max-width: 370px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner__inner {\n    max-width: 433px\n}\n  }\n\n.newsletter-signup-banner__title {\n  margin: 0 0 5px;\n}\n\n.newsletter-signup-banner__text {\n  margin: 0 0 15px;\n}\n\n.newsletter-signup-banner__bottom-text {\n  margin: 10px 0 0;\n}\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner__bottom-text {\n    margin-top: 15px\n}\n  }\n\n.newsletter-signup-banner-new {\n  margin-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n\n.newsletter-signup-banner-new {\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner-new {\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.newsletter-signup-banner-new {\n    margin-bottom: 50px\n}\n  }\n\n.newsletter-signup-banner-new__container {\n  max-height: 588px;\n}\n\n@media (min-width: 1240px) {\n\n.newsletter-signup-banner-new__container {\n    max-height: 432px\n}\n  }\n\n.newsletter-signup-banner-new__container::before {\n    padding-bottom: calc(588 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.newsletter-signup-banner-new__container::before {\n      padding-bottom: calc(326 / 708 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner-new__container::before {\n      padding-bottom: calc(389 / 944 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.newsletter-signup-banner-new__container::before {\n      padding-bottom: calc(432 / 1340 * 100%)\n  }\n    }\n\n.newsletter-signup-banner-new__logo {\n  width: 28px;\n  height: auto;\n}\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner-new__logo {\n    width: 41px\n}\n  }\n\n.newsletter-signup-banner-new__title {\n  margin: 10px 0 7px;\n}\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner-new__title {\n    margin: 12px 0 9px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.newsletter-signup-banner-new__title {\n    margin-top: 14px\n}\n  }\n\n.newsletter-signup-banner-new__description {\n  margin: 0 0 15px;\n}\n\n.newsletter-signup-banner-new__inner {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 50%;\n  width: calc(100% - 46px);\n  transform: translate3d(-50%, 0, 0);\n}\n\n@media (min-width: 768px) {\n\n.newsletter-signup-banner-new__inner {\n    width: 478px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner-new__inner {\n    width: 526px\n}\n  }\n\n.newsletter-signup-banner-new__disclaimer {\n  margin-top: 5px;\n}\n\n@media (min-width: 768px) {\n\n.newsletter-signup-banner-new__disclaimer {\n    max-width: 342px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.newsletter-signup-banner-new__disclaimer {\n    max-width: 500px;\n    margin-top: 9px\n}\n  }\n\n/* critical:start */\n\n.notification-banner {\n  position: relative;\n  display: none;\n  transition: margin-top var(--transition-default);\n  margin-top: 0;\n  padding: 11px 30px 12px;\n}\n\n@media (min-width: 768px) {\n\n.notification-banner {\n    padding-right: 45px;\n    padding-left: 45px\n}\n  }\n\n.notification-banner__content {\n  margin: 0;\n  text-align: center;\n}\n\n.notification-banner__content a {\n    border-bottom: 1px solid var(--white);\n    color: inherit;\n  }\n\n.notification-banner__content a::after {\n      background-color: var(--white);\n    }\n\n.notification-banner__content a:not([disabled]):hover {\n      border-color: transparent;\n    }\n\n.notification-banner__close {\n  position: absolute;\n  z-index: 5;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  width: 10px;\n  height: 10px;\n  cursor: pointer;\n}\n\n@media (min-width: 768px) {\n\n.notification-banner__close {\n    top: 50%;\n    right: 16px;\n    transform: translate3d(0, -50%, 0);\n    width: 12px;\n    height: 12px\n}\n  }\n\n/* critical:end */\n\n.our-story {\n  position: relative;\n  margin-bottom: 50px;\n}\n\n.our-story--plp {\n    margin-bottom: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.our-story--plp {\n      margin-bottom: 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.our-story--plp {\n      margin-bottom: 60px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.our-story--plp {\n      margin-bottom: 80px\n  }\n    }\n\n.our-story__video-wrapper {\n  overflow: hidden;\n  max-height: 800px;\n}\n\n.our-story__video-wrapper::before {\n    padding-bottom: calc(500 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.our-story__video-wrapper::before {\n      padding-bottom: calc(423 / 708 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.our-story__video-wrapper::before {\n      padding-bottom: calc(564 / 944 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.our-story__video-wrapper::before {\n      padding-bottom: calc(800 / 1340 * 100%)\n  }\n    }\n\n.our-story__video {\n  overflow: hidden;\n}\n\n.our-story__body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px;\n  z-index: 2;\n}\n\n@media (min-width: 768px) {\n\n.our-story__body {\n    padding: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.our-story__body {\n    padding: 40px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.our-story__body {\n    padding: 50px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.our-story__body {\n    padding: 80px\n}\n  }\n\n.our-story__body.our-story__body--h-left {\n    align-items: flex-start;\n  }\n\n.our-story__body.our-story__body--h-right {\n    align-items: flex-end;\n  }\n\n.our-story__body.our-story__body--v-left {\n    justify-content: flex-start;\n  }\n\n.our-story__body.our-story__body--v-right {\n    justify-content: flex-end;\n  }\n\n@media (max-width: 767px) {\n\n.our-story__body.our-story__body--v-center {\n      padding-bottom: 154px\n  }\n    }\n\n.our-story--plp .our-story__body {\n    padding: 41px 13px;\n  }\n\n@media (min-width: 768px) {\n\n.our-story--plp .our-story__body {\n      padding-right: 30px;\n      padding-left: 30px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.our-story--plp .our-story__body {\n      padding: 50px 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.our-story--plp .our-story__body {\n      padding: 70px 60px\n  }\n    }\n\n.our-story--plp .our-story__body.our-story__body--h-left {\n      align-items: center;\n    }\n\n@media (min-width: 768px) {\n\n.our-story--plp .our-story__body.our-story__body--h-left {\n        align-items: flex-start\n    }\n      }\n\n.our-story__inner {\n  text-align: center;\n}\n\n.our-story__header {\n  position: relative;\n  max-width: 228px;\n  margin: 0 auto;\n}\n\n@media (min-width: 1000px) {\n\n.our-story__header {\n    max-width: 284px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.our-story__header {\n    max-width: 380px\n}\n  }\n\n.our-story--plp .our-story__header {\n    max-width: 236px;\n  }\n\n@media (min-width: 1000px) {\n\n.our-story--plp .our-story__header {\n      max-width: 400px\n  }\n    }\n\n.our-story__left-accent {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: auto;\n  height: 70px;\n  transform: translate3d(0, -50%, 0);\n}\n\n@media (min-width: 1000px) {\n\n.our-story__left-accent {\n    height: 80px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.our-story__left-accent {\n    height: 95px\n}\n  }\n\n.our-story__right-accent {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: auto;\n  height: 70px;\n  transform: translate3d(0, -50%, 0);\n}\n\n@media (min-width: 1000px) {\n\n.our-story__right-accent {\n    height: 80px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.our-story__right-accent {\n    height: 95px\n}\n  }\n\n.our-story__title {\n  max-width: 154px;\n  margin: 0 auto 19px;\n  color: var(--white);\n}\n\n@media (min-width: 1000px) {\n\n.our-story__title {\n    max-width: 182px;\n    margin-bottom: 28px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.our-story__title {\n    max-width: 225px;\n    margin-bottom: 29px\n}\n  }\n\n.our-story--plp .our-story__title {\n\n    max-width: 162px;\n  }\n\n@media (min-width: 1024px) {\n\n.our-story--plp .our-story__title {\n    font-size: 32px\n  }\n  }\n\n@media (min-width: 1000px) {\n\n.our-story--plp .our-story__title {\n      max-width: 246px;\n      margin-bottom: 29px\n  }\n    }\n\n.our-story__content {\n  max-width: 226px;\n  margin: 0 auto 15px;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.our-story__content {\n    max-width: 350px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.our-story__content {\n    max-width: 385px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.our-story__content {\n    margin-bottom: 20px\n}\n  }\n\n@media (min-width: 768px) {\n\n.our-story--plp .our-story__content {\n      max-width: 254px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.our-story--plp .our-story__content {\n      max-width: 383px;\n      margin-bottom: 20px\n  }\n    }\n\n.our-story__cta {\n  min-width: 1rem;\n}\n\n.our-story__cta.button--secondary {\n    padding-top: 0;\n  }\n\n.page-404 {\n  padding: 120px 0 145px;\n}\n\n@media (min-width: 768px) {\n\n.page-404 {\n    padding: 135px 0 160px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.page-404 {\n    padding: 163px 0 186px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.page-404 {\n    padding: 275px 0 300px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.page-404 {\n    padding: 305px 0 337px\n}\n  }\n\n.page-404--video {\n  color: var(--white);\n}\n\n@media (min-width: 1440px) {\n\n.page-404--video {\n    padding: 215px 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.page-404--video {\n    padding: 305px 0 337px\n}\n  }\n\n.page-404__logo {\n  margin: 0 auto 22px;\n  max-width: 207px;\n}\n\n@media (min-width: 768px) {\n\n.page-404__logo {\n    max-width: 260px;\n    margin-bottom: 25px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.page-404__logo {\n    max-width: 326px;\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.page-404__logo {\n    max-width: 420px;\n    margin-bottom: 60px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.page-404__logo {\n    max-width: 500px;\n    margin-bottom: 50px\n}\n  }\n\n.page-404__description {\n  max-width: 280px;\n  margin: 0 auto;\n}\n\n@media (min-width: 1000px) {\n\n.page-404__description {\n    max-width: 100%\n}\n  }\n\n.page-404__icon::before {\n  content: '';\n  display: block;\n  padding-bottom: calc(221 / 500 * 100%);\n}\n\n.page-404__footer {\n  margin-top: 20px;\n}\n\n@media (min-width: 768px) {\n\n.page-404__footer {\n    margin-top: 15px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.page-404__footer {\n    margin-top: 20px\n}\n  }\n\n.page-404__button {\n  display: inline;\n}\n\n.page-404--video .page-404__button {\n    color: inherit;\n  }\n\n.page-404--video .page-404__button:hover {\n      color: var(--white) !important;\n    }\n\n.page-404__wrapper {\n  z-index: 1;\n}\n\n.pagination__page a,\n  .pagination__page span {\n    position: relative;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 9px;\n    padding: 0;\n    text-decoration: none;\n    border-bottom: 1px solid transparent;\n    color: var(--black);\n    border-radius: 100%;\n    vertical-align: middle;\n  }\n\n.pagination__page a::after, .pagination__page span::after {\n      content: none;\n    }\n\nbody.keyboard-active .pagination__page a:focus::before,\n    .pagination__page a::before,\n    body.keyboard-active .pagination__page span:focus::before,\n    .pagination__page span::before {\n      content: none;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 20px;\n      height: 20px;\n      background-color: var(--red);\n      border-radius: 100%;\n      z-index: -1;\n      transform: translate3d(-50%, -50%, 0);\n      box-sizing: border-box;\n    }\n\nbody.keyboard-active .pagination__page a:focus::before, body.keyboard-active .pagination__page span:focus::before {\n      content: '';\n      background-color: var(--white);\n    }\n\n.pagination__page a:hover, .pagination__page span:hover {\n      border-radius: 0;\n      border-color: var(--red);\n    }\n\n.pagination__page a.is-active, .pagination__page span.is-active {\n      color: var(--white);\n    }\n\nbody.keyboard-active .pagination__page a.is-active:focus::before,\n      .pagination__page a.is-active::before,\n      body.keyboard-active .pagination__page span.is-active:focus::before,\n      .pagination__page span.is-active::before {\n        content: '';\n        background-color: var(--red);\n        border: none;\n      }\n\n.pagination__arrow-next-prev {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  color: var(--red);\n  border: none;\n}\n\n.pagination__arrow-next-prev::after {\n    content: none;\n  }\n\n.pagination__arrow-next-prev.is-disabled {\n    opacity: 0.3;\n  }\n\n.pagination__arrow-next-prev.next {\n    margin-left: 15px;\n  }\n\n.pagination__arrow-next-prev.prev {\n    margin-right: 15px;\n  }\n\n.picture,\n.picture__img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.picture--width {\n  position: relative;\n}\n\n.picture__img {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.picture--cover .picture__img {\n    object-fit: cover;\n    /* stylelint-disable */\n    font-family: 'object-fit: cover;'; /* For polyfill */\n    /* stylelint-enable */\n  }\n\n.picture--contain .picture__img {\n    object-fit: contain;\n    /* stylelint-disable */\n    font-family: 'object-fit: contain;'; /* For polyfill */\n    /* stylelint-enable */\n  }\n\n.picture--width .picture__img {\n    position: relative;\n    bottom: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n.picture--fade-in .picture__img {\n    transition-duration: var(--duration-slow, 1.5s);\n    transition-property: opacity, visibility;\n    transition-timing-function: var(--ease, ease-in-out);\n  }\n\n.picture--is-loaded .picture__img,\n  .is-loaded .picture__img {\n    opacity: 1;\n    visibility: visible;\n  }\n\n.product-gallery__carousel-item .picture__img {\n    transform: none !important;\n    transition: none !important;\n  }\n\n.pos-left .picture__img {\n    object-position: left;\n  }\n\n.picture__loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background:\n    linear-gradient(\n      to right,\n      rgba(224,224,224, 0) 0%,\n      rgba(224,224,224, 0.75) 50%,\n      rgba(224,224,224, 0) 100%\n    );\n  animation-name: shimmer;\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n  transition-duration: var(--duration, 0.25s);\n  transition-property: opacity, visibility;\n  transition-timing-function: var(--ease, ease-in-out);\n}\n\n.picture--is-loaded .picture__loader,\n  .is-loaded .picture__loader {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n.content-card__image-pic .picture__img {\n    transform: translateY(20%);\n  }\n\n.content-card__image-pic.picture--fade-in .picture__img {\n    transition-property: opacity, visibility, transform;\n  }\n\n.content-card__image-pic.picture--is-loaded .picture__img {\n    transform: translateY(0);\n  }\n\n@keyframes shimmer {\n  from {\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n.plp {\n  overflow: hidden;\n}\n\n.plp__inner {\n  position: relative;\n  padding: 40px 0 30px;\n}\n\n@media (min-width: 768px) {\n\n.plp__inner {\n    padding: 40px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp__inner {\n    padding-top: 60px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.plp__inner {\n    padding: 80px 0 60px\n}\n  }\n\n.plp__inner.is-empty {\n  padding-top: 0;\n}\n\n.plp__inner.is-empty .plp__grid-wrap::before {\n  display: none;\n}\n\n.plp__sort-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (min-width: 768px) {\n\n.plp__sort-bar {\n    justify-content: space-between\n}\n  }\n\n.plp__hero--search {\n  padding-top: 40px;\n}\n\n@media (min-width: 1000px) {\n\n.plp__hero--search {\n    padding-top: 80px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.is-search .plp__sort-bar.is-empty {\n    padding-bottom: 0\n}\n  }\n\n.plp__sort-bar__right {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.plp__sort-bar__left {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n.plp__sort-bar__left {\n    display: block\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp__sort-bar-filter-trigger {\n    display: none\n}\n  }\n\n.plp-filters__header {\n    margin-bottom: 25px;\n  }\n\n@media (min-width: 1000px) {\n\n.plp-filters__header {\n      margin-bottom: 30px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.plp-filters__header {\n      margin-bottom: 40px\n  }\n    }\n\n.plp-filters__title {\n    margin-bottom: 5px;\n  }\n\n@media (min-width: 1240px) {\n\n.plp-filters__title {\n      margin-bottom: 10px\n  }\n    }\n\n.plp-filters__description {\n    display: inline-block;\n    max-width: 404px;\n    margin-top: 0;\n  }\n\n@media (min-width: 1000px) {\n\n.plp-filters__description {\n      max-width: 468px\n  }\n    }\n\n.plp__grid-wrap {\n  position: relative;\n  width: 100%;\n  padding-top: 40px;\n}\n\n@media (min-width: 768px) {\n\n.plp__grid-wrap {\n    padding-top: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp__grid-wrap {\n    padding-top: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.plp__grid-wrap {\n    padding-top: 60px\n}\n  }\n\n.plp__grid-wrap::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -50%;\n    width: 200%;\n    height: 1px;\n    background-color: var(--black-o-20);\n  }\n\n.plp__available-in {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 768px) {\n\n.plp__available-in {\n    margin-bottom: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp__available-in {\n    margin-bottom: 27px\n}\n  }\n\n.plp__grid {\n  grid-gap: 20px 0;\n}\n\n@media (min-width: 768px) {\n\n.plp__grid {\n    grid-gap: 15px 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp__grid {\n    grid-gap: 20px 15px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.plp__grid {\n    grid-gap: 20px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.plp__grid {\n    grid-gap: 25px\n}\n  }\n\n.plp__grid-first-row {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n@media (min-width: 1000px) {\n\n.plp__grid-first-row {\n    flex-wrap: nowrap\n}\n  }\n\n.plp__grid-item {\n  padding-bottom: 20px;\n}\n\n@media (min-width: 1240px) {\n\n.plp__grid-item {\n    padding-bottom: 40px\n}\n  }\n\n.plp__grid-item-group {\n  position: relative;\n  width: 100%;\n  align-content: space-between;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n@media (min-width: 1000px) {\n\n.plp__grid-item-group {\n    width: calc(33.32% - 20px);\n    margin: 0 10px\n}\n  }\n\n.plp__grid-item--normal {\n  width: 100%;\n  max-width: 340px;\n  margin: auto;\n  padding: 0 10px;\n}\n\n@media (min-width: 768px) {\n\n.plp__grid-item--normal {\n    max-width: 245px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp__grid-item--normal {\n    max-width: 340px\n}\n  }\n\n.plp__grid-item--featured {\n  width: 100%;\n}\n\n@media (min-width: 1000px) {\n\n.plp__grid-item--featured {\n    width: calc(66.65% - 20px)\n}\n  }\n\n.plp__grid-item--first-row-sm {\n  width: 100%;\n}\n\n@media (min-width: 320px) {\n\n.plp__grid-item--first-row-sm {\n    width: calc(50% - 20px)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp__grid-item--first-row-sm {\n    width: 100%;\n    margin: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp__grid-item--callout {\n    max-width: 320px;\n    padding: 0\n}\n  }\n\n.plp__button {\n  margin-top: 10px;\n}\n\n@media (min-width: 768px) {\n\n.plp__button {\n    margin-top: 35px\n}\n  }\n\n.plp__compact-view-btn {\n  margin: auto;\n}\n\n.plp-sidebar {\n  width: 100%;\n  display: block;\n}\n\n.plp-sidebar__list--collections {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin: 0 -5px 35px;\n  text-align: center;\n}\n\n@media (min-width: 1000px) {\n\n.plp-sidebar__list--collections {\n    margin: 0 -10px 50px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.plp-sidebar__list--collections {\n    margin-bottom: 60px\n}\n  }\n\n.plp-sidebar__list-group-title {\n  margin-bottom: 20px;\n}\n\n.plp-sidebar__list--filters {\n  width: 100vw;\n  max-width: 240px;\n  height: 100vh;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  position: fixed;\n  top: 0;\n  right: 0;\n  background: var(--white);\n  z-index: 999;\n  padding: 20px;\n  box-shadow: -3px 0 5px 0 rgba(0, 0, 0, 0.14);\n  transform: translateX(250px);\n  transition: transform 300ms ease-in-out;\n}\n\n@media (min-width: 1000px) {\n\n.is-search .plp-sidebar__list--filters {\n      border-top: none;\n      padding-top: 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.plp-sidebar__list--filters {\n    position: relative;\n    max-width: none;\n    width: auto;\n    height: auto;\n    padding: 30px 0 0;\n    box-shadow: none;\n    z-index: 1;\n    transition: none;\n    transform: none;\n    overflow-y: inherit;\n    background: transparent\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp--search .plp-sidebar__list--filters {\n      padding-top: 0;\n      border-top: 0\n  }\n    }\n\n.plp-sidebar__list--filters.is-active {\n  transform: translateX(0);\n}\n\n.plp-sidebar__list-group {\n  margin-bottom: 10px;\n  padding-bottom: 30px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.plp-sidebar__list-group:last-child {\n    border-bottom: none;\n  }\n\n.plp-sidebar__list--collections .plp-sidebar__list-group {\n    position: relative;\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n\n.plp-sidebar__list-group-inner--color {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.plp-sidebar__color-circle {\n  margin: 3px 5px;\n}\n\n.plp-sidebar__list--collections .plp-sidebar__list-group > ul {\n    overflow: auto;\n  }\n\n.plp-sidebar__list-group li.is-active {\n  padding: 2px 5px;\n}\n\n.plp-sidebar__list-group-item {\n  text-transform: capitalize;\n  cursor: pointer;\n  width: 50%;\n  padding: 5px;\n}\n\n@media (min-width: 768px) {\n\n.plp-sidebar__list-group-item {\n    width: 25%;\n    max-width: 160px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp-sidebar__list-group-item {\n    padding: 0 10px;\n    max-width: 200px\n}\n  }\n\n.plp-sidebar__list--collections .plp-sidebar__list-group-item {\n    display: inline-block;\n  }\n\n.plp-sidebar__list-group-item--filter {\n  display: flex;\n  align-items: center;\n}\n\n.plp-sidebar__list-group-item--filter + .plp-sidebar__list-group-item--filter {\n  margin: 7px 0 0;\n}\n\n.plp-sidebar__apply-filter {\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border-color);\n  margin-bottom: 20px;\n}\n\n@media (min-width: 1000px) {\n\n.plp-sidebar__apply-filter {\n    display: none\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp-sidebar__reset-filter {\n    display: none\n}\n  }\n\n.plp-sidebar__list-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 998;\n  background: rgba(255, 255, 255, 0.8);\n}\n\n.plp-sidebar__list-group-list {\n  margin-right: -20px;\n  padding: 6px 0;\n  overflow: auto;\n  white-space: nowrap;\n}\n\n@media (min-width: 768px) {\n\n.plp-sidebar__list-group-list {\n    margin-right: 0\n}\n  }\n\n.plp-sidebar__list-group-list::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    right: -20px;\n    width: 31px;\n    height: 35px;\n    background: linear-gradient(270deg, var(--white) 41.94%, rgba(var(--white), 0) 90.32%);\n  }\n\n@media (min-width: 768px) {\n\n.plp-sidebar__list-group-list::after {\n      height: 33px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.plp-sidebar__list-group-list::after {\n      height: 41px\n  }\n    }\n\n.plp-sidebar-link span {\n  position: relative;\n}\n\n.plp-sidebar-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 35px;\n  border: 1px solid var(--black-o-20);\n  background-color: var(--white);\n  border-radius: 70px;\n}\n\n@media (max-width: 767px) {\n\n.plp-sidebar-link {\n    font-size: 0;\n    text-indent: -9999px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.plp-sidebar-link {\n    height: 40px\n}\n  }\n\n.plp-sidebar-link.is-active,\n  .plp-sidebar-link:hover {\n    border-color: var(--red);\n  }\n\n.plp-sidebar-link::before {\n    font-size: 12px;\n    line-height: 1.25;\n    letter-spacing: 1px;\n    font-family: var(--sans-serif);\n\n    content: attr(data-title);\n    text-indent: 0;\n  }\n\n@media (min-width: 1024px) {\n\n.plp-sidebar-link::before {\n    font-size: 14px\n  }\n  }\n\n@media (min-width: 768px) {\n\n.plp-sidebar-link::before {\n      content: none\n  }\n    }\n\n.plp-sidebar-link::after {\n    content: none;\n  }\n\n.pre-order-note {\n  position: relative;\n  margin-bottom: 15px;\n}\n\n@media (min-width: 768px) {\n\n.pre-order-note {\n    margin-bottom: 20px\n}\n  }\n\n.cart-grid--default .pre-order-note {\n    display: none;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .pre-order-note {\n      display: block\n  }\n    }\n\n@media (max-width: 767px) {\n\n.product-main--reorder-header-mobile .pre-order-note {\n      margin: 10px 0 0;\n      order: 1\n  }\n    }\n\n.pre-order-note__inner {\n  padding: 15px;\n  background-color: var(--parchment);\n}\n\n@media (min-width: 1000px) {\n\n.pre-order-note__inner {\n    padding: 20px\n}\n  }\n\n.pre-order-note__text {\n  margin-top: 10px;\n}\n\n.pre-order-note__mini-cart {\n  margin-top: 17px;\n  margin-bottom: 0;\n}\n\n@media (min-width: 768px) {\n\n.pre-order-note__mini-cart {\n    margin-top: 25px\n}\n  }\n\n.cart-grid--default .pre-order-note__mini-cart {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.cart-grid--default .pre-order-note__mini-cart {\n      display: none\n  }\n    }\n\n.press-logos {\n  overflow: hidden;\n  padding: 21px 0;\n}\n\n@media (min-width: 1000px) {\n\n.press-logos {\n    padding: 31px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.press-logos {\n    padding: 51px 0\n}\n  }\n\n.press-logos__link {\n  border-bottom: none;\n}\n\n.press-logos__link::after {\n    content: none;\n  }\n\n.press-logos__grid {\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  margin: 0 -5.938vw;\n}\n\n@media (min-width: 445px) {\n\n.press-logos__grid {\n    justify-content: center;\n    margin: 0 -19px\n}\n  }\n\n@media (min-width: 768px) {\n\n.press-logos__grid {\n    justify-content: space-between\n}\n  }\n\n@media (min-width: 1000px) {\n\n.press-logos__grid {\n    margin: 0 -32px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.press-logos__grid {\n    justify-content: center;\n    margin: 0 -40px\n}\n  }\n\n@media (min-width: 445px) {\n\n.press-logos__grid.press-logos__grid--center {\n      justify-content: center\n  }\n    }\n\n.press-logos__item {\n  display: flex;\n  margin: 9px 0;\n  padding: 0 5.938vw;\n  text-align: center;\n}\n\n@media (min-width: 445px) {\n\n.press-logos__item {\n    padding: 0 19px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.press-logos__item {\n    padding: 0 32px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.press-logos__item {\n    padding: 0 40px\n}\n  }\n\n.press-logos__image {\n  height: auto;\n}\n\n.press-logos__image .picture__img {\n    width: auto;\n    max-width: 83px;\n    max-height: 15px;\n    object-fit: contain;\n  }\n\n@media (min-width: 768px) {\n\n.press-logos__image .picture__img {\n      max-width: 104px;\n      max-height: 19px;\n      margin: 0 auto\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.press-logos__image .picture__img {\n      max-width: 131px;\n      max-height: 25px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.press-logos__image .picture__img {\n      max-width: none;\n      max-height: 26px\n  }\n    }\n\n.product-bundle {\n  display: flex;\n  flex-direction: column;\n  grid-gap: 20px;\n  gap: 20px;\n  margin: 20px 0;\n}\n\n@media (min-width: 768px) {\n\n.product-bundle {\n    margin: 30px 0\n}\n  }\n\n.product-bundle__group {\n  display: flex;\n  flex-direction: column;\n  grid-gap: 15px;\n  gap: 15px;\n}\n\n.product-bundle__list {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 10px;\n  gap: 10px;\n}\n\n@media (min-width: 1240px) {\n\n.product-bundle__list {\n    grid-template-columns: repeat(4, 1fr)\n}\n  }\n\n.product-bundle__item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  grid-gap: 16px;\n  gap: 16px;\n  min-height: 64px;\n  margin: 0;\n  padding: 10px;\n  border: 1px solid var(--black-o-20);\n  cursor: pointer;\n}\n\n@media (min-width: 768px) {\n\n.product-bundle__item {\n    min-height: 86px\n}\n  }\n\n.product-bundle__item::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 1px solid transparent;\n    box-sizing: border-box;\n  }\n\n.product-bundle__item.is-active {\n    border-color: var(--red);\n  }\n\n.product-bundle__item.is-active::before {\n    border-color: var(--red);\n  }\n\n.product-bundle__item .picture,\n  .product-bundle__item .picture__img {\n    height: auto;\n  }\n\n.product-bundle__item.is-sold-out {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n.product-bundle__item-title {\n  margin-top: auto;\n}\n\n.product-bundle__badge {\n  position: absolute;\n  top: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  padding: 4px 8px;\n  border-radius: 2px;\n  background: var(--black);\n  color: var(--white);\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.product-bundle__selected {\n  margin-bottom: 10px;\n}\n\n@media (min-width: 768px) {\n\n.product-bundle__selected {\n    margin-bottom: 15px\n}\n  }\n\n.product-card:hover .media-secondary {\n      opacity: 1;\n      visibility: visible;\n    }\n\n.product-card__featured {\n  display: block;\n  overflow: hidden;\n  border: none;\n  max-height: 541px;\n  margin-bottom: 10px;\n}\n\n@media (min-width: 768px) {\n\n.product-card__featured {\n    margin-bottom: 15px\n}\n  }\n\n.product-card__featured::before {\n    padding-bottom: calc(259 / 208 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.product-card__featured::before {\n      padding-bottom: calc(273 / 229 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.product-card__featured::before {\n      padding-bottom: calc(381 / 305 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.product-card__featured::before {\n      padding-bottom: calc(541 / 433 * 100%)\n  }\n    }\n\n.product-card__featured::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0.1;\n    transform: none;\n    transition: opacity var(--transition-default);\n    width: 100%;\n    height: 100%;\n    background: var(--black);\n  }\n\n.product-card__featured:hover::after {\n    opacity: 0;\n  }\n\n.product-card--featured-products .product-card__featured {\n    pointer-events: none;\n  }\n\n.product-card__featured--has-media::after {\n      opacity: 0;\n    }\n\n.product-card__title {\n  margin: 0 0 5px;\n}\n\n@media (min-width: 768px) {\n\n.product-card__title {\n    margin-bottom: 4px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-card__title {\n    margin-bottom: 8px\n}\n  }\n\n.product-card__price {\n  margin: 0 0 10px;\n}\n\n@media (min-width: 1000px) {\n\n.product-card__price {\n    margin-bottom: 15px\n}\n  }\n\n.product-card__button--delivery:not(:only-child) {\n  order: 2;\n  margin-left: 15px;\n}\n\n.product-card__out-of-stock {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 3;\n  background: var(--parchment);\n  padding: 1rem 2rem;\n  font-size: 15px;\n  color: var(--red);\n  width: 100%;\n  text-align: center;\n}\n\n.media-secondary {\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transition: all 0.3s ease;\n  background: var(--black);\n}\n\n.media-secondary .video__el {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transform: none;\n  }\n\n.media-secondary video {\n    object-fit: cover;\n  }\n\n.product-description {\n  position: relative;\n  margin-top: 30px;\n}\n\n.product-description__accordions .accordion--is-open {\n    padding-bottom: 20px;\n  }\n\n@media (min-width: 1000px) {\n\n.product-description__accordions .accordion--is-open {\n      padding-bottom: 22px\n  }\n    }\n\n.product-form {\n  position: relative;\n}\n\n.product-form__out-of-stock {\n  display: none;\n  background: var(--parchment);\n  padding: 1rem 2rem;\n  font-size: 15px;\n  color: var(--red);\n  margin: 1.5rem 0 2rem;\n}\n\n@media (min-width: 768px) {\n\n.product-form__out-of-stock.is-active:not(.product-form__out-of-stock--mobile) {\n      display: block\n  }\n    }\n\n@media (max-width: 767px) {\n\n.product-form__out-of-stock.product-form__out-of-stock--mobile.is-active {\n      display: block;\n      margin: 10px 0 15px\n  }\n    }\n\n.product-form__variants {\n  display: grid;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 768px) {\n\n.product-form__variants {\n    margin-top: 15px;\n    grid-template-columns: 1fr 1fr;\n    grid-column-gap: 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-form__variants {\n    margin-top: 20px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.product-form__variants {\n    grid-column-gap: 15px\n}\n  }\n\n.product-form__variants.product-form__variants--gift-card {\n    display: block;\n  }\n\n.product-form__variants-delivery {\n  margin-top: 15px;\n}\n\n@media (min-width: 1440px) {\n\n.product-form__variants-delivery {\n    margin-top: 20px\n}\n  }\n\n.product-form__title {\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n\n@media (min-width: 1000px) {\n\n.product-form__title {\n    margin-top: 15px\n}\n  }\n\n@media (max-width: 767px) {\n\n.product-main--reorder-header-mobile .product-form__title {\n      margin-top: 0\n  }\n    }\n\n.product-form__price {\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n@media (min-width: 1000px) {\n\n.product-form__price {\n    margin-top: 15px\n}\n  }\n\n.product-form__price-line {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.product-form__variants--merch {\n  display: block;\n}\n\n.product-form__variants-item-disabled {\n  pointer-events: none;\n}\n\n.product-form__variants-item {\n  display: flex;\n  flex-wrap: wrap;\n  grid-gap: 10px;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.product-form__variant-item {\n  position: relative;\n  min-width: 50px;\n  min-height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--black-o-20);\n  padding: 10px;\n  cursor: pointer;\n}\n\n.product-form__variant-item.is-active {\n    border: 1px solid var(--red);\n  }\n\n/* stylelint-disable */\n\n.product-form__variant-item.is-out-of-stock {\n    cursor: no-drop;\n    background:\n      linear-gradient(to top left,\n      rgba(177, 177, 177, 0) 0%,\n      rgba(177, 177, 177, 0) calc(50% - 0.5px),\n      rgba(177, 177, 177, 1) 50%,\n      rgba(177, 177, 177, 0) calc(50% + 1px),\n      rgba(177, 177, 177, 0) 100%);\n  }\n\n.product-form__variant-checkbox {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.product-form__variants-heading {\n  margin-bottom: 10px;\n}\n\n.product-form__variant-value {\n  line-height: 1;\n}\n\n.product-form__variant-item.is-out-of-stock .product-form__variant-value {\n    opacity: 0.5;\n  }\n\n.product-form__add-to-cart {\n  display: flex;\n  flex-wrap: wrap;\n  grid-gap: 10px;\n  gap: 10px;\n}\n\n.product-form__add-to-cart .button {\n    width: 100%;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-radius: 20px;\n  }\n\n@media (min-width: 1000px) {\n\n.product-form__add-to-cart .button {\n      padding-top: 12px;\n      padding-bottom: 11px\n  }\n    }\n\n.product-form__buttons {\n  margin-top: 10px;\n}\n\n@media (min-width: 1000px) {\n\n.product-form__buttons {\n    margin-top: 20px\n}\n  }\n\n.product-gallery {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n}\n\n@media (min-width: 1000px) {\n\n.product-gallery {\n    flex-direction: row\n}\n  }\n\n.product-gallery__thumbnail {\n  width: 30px !important;\n  height: 37px !important;\n}\n\n@media (min-width: 1000px) {\n\n.product-gallery__thumbnail {\n    width: 40px !important;\n    height: 50px !important\n}\n  }\n\n@media (min-width: 1240px) {\n\n.product-gallery__thumbnail {\n    width: 50px !important;\n    height: 62px !important\n}\n  }\n\n.product-gallery__thumbnail::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: calc(100% - 2px);\n    height: calc(100% - 2px);\n    border: 1px solid transparent;\n    z-index: 1;\n  }\n\n.product-gallery__thumbnail:hover,\n  .product-gallery__thumbnail.active {\n    cursor: pointer;\n  }\n\n.product-gallery__thumbnail:hover::after, .product-gallery__thumbnail.active::after {\n      border-color: var(--black);\n    }\n\n.product-gallery__thumbnail--video .icon-play {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n.product-gallery__side {\n  display: none;\n  margin: 7px 7px 0 7px !important;\n}\n\n@media (min-width: 768px) {\n\n.product-gallery__side {\n    display: block;\n    position: absolute !important;\n    left: 0;\n    bottom: 20px;\n    width: calc(100% - 34px);\n    height: 47px;\n    z-index: 2 !important\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-gallery__side {\n    height: 60px;\n    bottom: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.product-gallery__side {\n    height: 72px\n}\n  }\n\n.product-gallery__side .product-gallery__list {\n    justify-content: flex-start;\n  }\n\n@media (min-width: 1240px) {\n\n.product-gallery__side .product-gallery__list {\n      justify-content: center\n  }\n    }\n\n.product-gallery__side .swiper-navigation {\n    position: absolute;\n    left: 20px;\n    top: 2px;\n    z-index: 999;\n    width: 22px;\n    height: 22px;\n    background: var(--white);\n    transform: rotate(90deg);\n    opacity: 0.8;\n  }\n\n@media (min-width: 1240px) {\n\n.product-gallery__side .swiper-navigation {\n      left: 23px\n  }\n    }\n\n.product-gallery__side .swiper-navigation::before {\n      content: '';\n      position: absolute;\n      width: 10px;\n      height: 10px;\n      left: 8px;\n      top: 5px;\n      border-top: 1px solid var(--black);\n      border-right: 1px solid var(--black);\n      transform: rotate(-135deg);\n    }\n\n.product-gallery__side .swiper-navigation.swiper-button-next {\n      top: auto;\n      bottom: 2px;\n      transform: rotate(-90deg);\n    }\n\n.product-gallery__side .swiper-navigation.swiper-button-disabled {\n      opacity: 0;\n    }\n\n.product-gallery__list {\n  align-items: center;\n}\n\n.product-gallery__main {\n  width: 100%;\n  max-height: 825px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n\n.product-gallery__main::before {\n    padding-bottom: calc(350 / 280 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.product-gallery__main::before {\n      padding-bottom: calc(436 / 349 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.product-gallery__main::before {\n      padding-bottom: calc(581 / 465 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.product-gallery__main::before {\n      padding-bottom: calc(825 / 660 * 100%)\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.product-gallery__main::before {\n      padding-bottom: calc(825 / 728 * 100%)\n  }\n    }\n\n.product-gallery__main .video,\n  .product-gallery__main .video-embed {\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n@media (min-width: 1000px) {\n\n.product-gallery__main .video,\n  .product-gallery__main .video-embed {\n      top: 0;\n      transform: none\n  }\n    }\n\n.product-gallery__main .video {\n    height: auto;\n  }\n\n.product-gallery__main .product-gallery__pagination {\n    position: absolute;\n    bottom: 20px !important;\n    z-index: 2;\n    text-align: center;\n  }\n\n@media (min-width: 768px) {\n\n.product-gallery__main .product-gallery__pagination {\n      display: none\n  }\n    }\n\n.product-gallery__main .swiper-pagination-bullet {\n    margin: 0 4px !important;\n    background: var(--white-o-50) !important;\n    opacity: 1 !important;\n  }\n\n.product-gallery__main .swiper-pagination-bullet-active {\n    background: var(--white) !important;\n  }\n\n@media (min-width: 1000px) {\n\n.product-gallery__image--normal {\n    display: none\n}\n  }\n\n.product-gallery__image--zoomable {\n  display: none;\n}\n\n@media (min-width: 1000px) {\n\n.product-gallery__image--zoomable {\n    display: block;\n    width: 100%;\n    height: 100%;\n    max-height: 100%;\n    cursor: zoom-in\n}\n  }\n\n@media (min-width: 1240px) {\n\n.product-gallery__image--zoomable {\n    margin: 0 auto\n}\n  }\n\n.product-gallery__image-wrapper .video__el {\n    width: 100%;\n    height: 100%;\n  }\n\n.product-gallery__lcp {\n  position: absolute;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  aspect-ratio: calc(280 / 350);\n}\n\n@media (min-width: 768px) {\n\n.product-gallery__lcp {\n    aspect-ratio: calc(349 / 436)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-gallery__lcp {\n    aspect-ratio: calc(465 / 581)\n}\n  }\n\n@media (min-width: 1240px) {\n\n.product-gallery__lcp {\n    aspect-ratio: calc(660 / 825)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.product-gallery__lcp {\n    aspect-ratio: calc(728 / 825)\n}\n  }\n\n.product-gallery__lcp.loaded {\n    display: none;\n  }\n\n.product-main-berries__gallery .product-gallery img {\n      object-fit: contain !important;\n    }\n\n.product-main {\n  position: relative;\n  padding: 20px 0 30px;\n  border-bottom: 1px solid var(--black-o-20);\n}\n\n@media (min-width: 768px) {\n\n.product-main {\n    padding: 30px 0 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main {\n    padding-top: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.product-main {\n    padding: 50px 0\n}\n  }\n\n.product-main.product-main--gift-card {\n    padding-bottom: 20px;\n  }\n\n@media (min-width: 768px) {\n\n.product-main.product-main--gift-card {\n      padding-bottom: 30px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.product-main.product-main--gift-card {\n      padding-bottom: 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.product-main.product-main--gift-card {\n      padding-bottom: 60px\n  }\n    }\n\n.product-main__container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n@media (max-width: 767px) {\n\n.product-main__container {\n    width: 100%\n}\n  }\n\n@media (min-width: 768px) {\n\n.product-main__container {\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: wrap\n}\n  }\n\n.product-main--gift-card .product-main__container {\n    justify-content: flex-start;\n  }\n\n.product-main__gallery {\n  width: calc(100% - 40px);\n}\n\n@media (min-width: 768px) {\n\n.product-main__gallery {\n    align-self: flex-start;\n    width: calc(349 / 708 * 100%);\n    margin: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main__gallery {\n    width: calc(465 / 944 * 100%)\n}\n  }\n\n@media (min-width: 1240px) {\n\n.product-main__gallery {\n    width: calc(660 / 1340 * 100%)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.product-main__gallery {\n    width: calc(728 / 1480 * 100%)\n}\n  }\n\n.product-main__form {\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  margin-top: 10px;\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n\n.product-main__form {\n    flex: 1 1;\n    margin-top: 24px;\n    padding-left: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main__form {\n    align-items: flex-start;\n    padding-left: 60px;\n    margin-top: 0;\n    padding-right: 19px;\n    padding-bottom: 0\n}\n  }\n\n@media (min-width: 1440px) {\n\n.product-main__form {\n    max-width: 470px;\n    margin-right: calc((100% - (660 / 1340 * 100%) - 520px) / 2);\n    margin-left: auto;\n    padding: 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.product-main__form {\n    margin-right: calc((100% - (728 / 1480 * 100%) - 530px) / 2)\n}\n  }\n\n@media (min-width: 1440px) {\n\n.bundle-builder .product-main__form {\n      margin-right: calc((100% - (660 / 1340 * 100%) - 620px) / 2);\n      max-width: 580px\n  }\n    }\n\n.product-main__upsell {\n  flex: 0 0 auto;\n  width: calc(100% - 40px);\n  margin-top: 25px;\n}\n\n@media (min-width: 768px) {\n\n.product-main__upsell {\n    width: 100%;\n    margin-top: 50px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main__upsell {\n    width: calc(100% - 440px)\n}\n  }\n\n@media (min-width: 1240px) {\n\n.product-main__upsell {\n    padding-left: 110px\n}\n  }\n\n.product-main__form .product-form,\n.product-main__form .product-description {\n  flex: 0 0 auto;\n  width: calc(100% - 40px);\n}\n\n@media (min-width: 768px) {\n\n.product-main__form .product-form,\n.product-main__form .product-description {\n    width: 100%\n}\n  }\n\n/* critical:start */\n\n.product-main-berries {\n  --product-main-berries-bg: var(--pine);\n  --product-main-berries-color: var(--white);\n  --product-main-berries-border: color-mix(in srgb, currentColor 20%, transparent);\n  --product-main-berries-muted: color-mix(in srgb, currentColor 85%, transparent);\n\n  background: var(--product-main-berries-bg, var(--pine));\n  color: var(--product-main-berries-color, var(--white));\n  padding: 81px 0 30px;\n  margin-top: -51px;\n}\n\n@media (min-width: 768px) {\n\n.product-main-berries {\n    padding: 96px 0 30px;\n    margin-top: -66px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries {\n    padding: 111px 0 40px;\n    margin-top: -71px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.product-main-berries {\n    padding: 131px 0 50px;\n    margin-top: -81px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.product-main-berries {\n    padding: 141px 0 60px\n}\n  }\n\n.product-main-berries__container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n@media (max-width: 767px) {\n\n.product-main-berries__container {\n    width: 100%\n}\n  }\n\n@media (min-width: 768px) {\n\n.product-main-berries__container {\n    justify-content: center;\n    align-items: start;\n    flex-direction: row;\n    flex-wrap: wrap\n}\n  }\n\n.product-main-berries__gallery {\n  order: 2;\n  width: calc(100% - 40px);\n  margin: 20px 0;\n}\n\n@media (min-width: 768px) {\n\n.product-main-berries__gallery {\n    order: 1;\n    align-self: flex-start;\n    width: calc(349 / 708 * 100%);\n    margin: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries__gallery {\n    width: calc(465 / 944 * 100%)\n}\n  }\n\n@media (min-width: 1440px) {\n\n.product-main-berries__gallery {\n    width: calc(660 / 1340 * 100%)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.product-main-berries__gallery {\n    width: calc(728 / 1480 * 100%)\n}\n  }\n\n.product-main-berries__gallery .product-gallery__thumbnail:hover::after,\n  .product-main-berries__gallery .product-gallery__thumbnail.active::after  {\n    border-color: var(--product-main-berries-color) !important;\n  }\n\n.product-main-berries__top {\n  order: 1;\n  margin-top: 0;\n  width: calc(100% - 40px);\n}\n\n@media (min-width: 768px) {\n\n.product-main-berries__top {\n    order: 2;\n    flex: 1 1;\n    margin-top: 24px;\n    padding-left: 30px;\n    width: 100%\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries__top {\n    padding-left: 60px;\n    margin-top: 0;\n    padding-right: 19px;\n    padding-bottom: 0\n}\n  }\n\n@media (min-width: 1440px) {\n\n.product-main-berries__top {\n    max-width: 470px;\n    padding: 0\n}\n  }\n\n.product-main-berries__top--desktop {\n  display: none;\n}\n\n.product-main-berries__top--mobile {\n  display: block;\n}\n\n.product-main-berries__content .product-main-berries__top {\n  width: 100%;\n  padding: 0;\n  margin-top: 0;\n}\n\n@media (min-width: 768px) {\n\n.product-main-berries__content .product-main-berries__top {\n    margin-bottom: 20px\n}\n  }\n\n.product-main-berries__content {\n  order: 3;\n  width: calc(100% - 40px);\n}\n\n@media (min-width: 768px) {\n\n.product-main-berries__content {\n    flex: 1 1;\n    width: 100%;\n    margin-top: 22px;\n    padding-left: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries__content {\n    padding-left: 60px;\n    padding-right: 19px;\n    margin-top: 28px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.product-main-berries__content {\n    max-width: 467px;\n    margin-right: calc((100% - (660 / 1340 * 100%) - 520px) / 2);\n    margin-left: auto;\n    padding: 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.product-main-berries__content {\n    max-width: 477px;\n    margin-right: calc((100% - (728 / 1480 * 100%) - 530px) / 2)\n}\n  }\n\n@media (min-width: 768px) {\n  .product-main-berries__top--mobile {\n    display: none;\n  }\n\n  .product-main-berries__top--desktop {\n    display: block;\n  }\n\n  .product-main-berries__content {\n    margin-top: 0;\n  }\n}\n\n.product-main-berries__title {\n  margin: 0;\n  font-family: var(--serif);\n  font-weight: 300;\n  font-size: 24px;\n  line-height: 1.2;\n}\n\n@media (min-width: 768px) {\n\n.product-main-berries__title {\n    font-size: 24px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries__title {\n    font-size: 32px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.product-main-berries__title {\n    font-size: 40px\n}\n  }\n\n.product-main-berries__price-row {\n  display: flex;\n  grid-gap: 8px;\n  gap: 8px;\n  align-items: center;\n  margin-top: 13px;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n  margin-top: 5px;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__price-row {\n    margin-top: 10px;\n    font-size: 15px\n}\n  }\n\n.product-main-berries__price-compare {\n  margin-right: 5px;\n  opacity: 0.6;\n  text-decoration: line-through;\n}\n\n.product-main-berries__flavor-label {\n  margin: 0;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n}\n\n@media (min-width: 768px) {\n\n.product-main-berries__flavor-label {\n    margin-top: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries__flavor-label {\n    font-size: 15px;\n    margin-top: 30px\n}\n  }\n\n.product-main-berries__trays {\n  display: flex;\n  grid-gap: 10px;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__trays {\n    margin-top: 15px;\n    grid-gap: 20px;\n    gap: 20px\n}\n  }\n\n.product-main-berries__tray {\n  border: 4px solid transparent;\n  background: var(--white);\n  color: var(--black);\n  width: 135px;\n  height: 135px;\n  aspect-ratio: 1 / 1;\n  box-sizing: border-box;\n  padding: 10px;\n  cursor: pointer;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__tray {\n    width: 142px;\n    height: 142px\n}\n  }\n\n.product-main-berries__tray.is-active {\n  border-color: var(--red);\n}\n\n.product-main-berries__tray.is-out-of-stock {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.product-main-berries__tray-image-wrap {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n\n.product-main-berries__tray-image {\n  display: block;\n  width: 70%;\n  aspect-ratio: 1;\n  height: auto;\n  object-fit: contain;\n}\n\n.product-main-berries__tray-text {\n  display: block;\n  text-align: center;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__tray-text {\n    font-size: 15px\n}\n  }\n\n.product-main-berries__zipcode {\n  margin-top: 30px;\n  display: flex;\n  flex-direction: column;\n  grid-gap: 10px;\n  gap: 10px;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__zipcode {\n    margin-top: 30px;\n    grid-gap: 15px;\n    gap: 15px\n}\n  }\n\n.product-main-berries__zipcode[hidden] {\n    display: none;\n  }\n\n.product-main-berries__zipcode-label {\n  font-family: var(--sans-serif);\n  font-size: 14px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.product-main-berries__zipcode-input {\n  height: 35px;\n  border-radius: 20px;\n  border: 1px solid var(--product-main-berries-border);\n  background: transparent;\n  color: inherit;\n  padding: 9px 15px;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n}\n\n.product-main-berries__zipcode-input:focus {\n    border-color: var(--product-main-berries-color);\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries__zipcode-input {\n    height: 40px\n}\n  }\n\n.product-main-berries__zipcode-input::-webkit-input-placeholder {\n  color: white;\n  opacity: 0.8;\n}\n\n.product-main-berries__zipcode-input::placeholder {\n  color: white;\n  opacity: 0.8;\n}\n\n.product-main-berries__zipcode-actions {\n  font-size: 14px;\n}\n\n.product-main-berries__zipcode-actions {\n  display: flex;\n  align-items: center;\n  grid-gap: 10px;\n  gap: 10px;\n}\n\n.product-main-berries__zipcode-cta {\n  display: inline-block !important;\n  background: transparent;\n  border: none;\n  padding: 0;\n  color: inherit;\n  font-family: var(--sans-serif);\n  font-size: 14px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  cursor: pointer;\n  padding-bottom: 5px;\n  border-bottom: 1px solid var(--red);\n}\n\n@media (max-width: 767px) {\n\n.product-main-berries__zipcode-cta {\n    font-size: 12px\n}\n  }\n\n.product-main-berries__zipcode-cta:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n.product-main-berries__zipcode-cta:disabled.is-loading {\n    cursor: wait;\n  }\n\n/* critical:end */\n\n.product-main-berries__zipcode-spinner {\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  color: currentColor;\n  border: 2px solid currentColor;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n.product-main-berries__zipcode-spinner[hidden] {\n    display: none;\n  }\n\n@keyframes rotation {\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n}\n\n.product-main-berries__zipcode-status {\n  margin: 0;\n  font-family: var(--sans-serif);\n  font-size: 12px;\n  line-height: 1.3;\n  color: var(--product-main-berries-muted);\n}\n\n.product-main-berries__zipcode-status[hidden] {\n    display: none;\n  }\n\n.product-main-berries__zipcode-status.is-error {\n    color: var(--red);\n  }\n\n.product-main-berries__zipcode-result,\n.product-main-berries__zipcode-unavailable {\n  margin-top: 5px;\n}\n\n.product-main-berries__zipcode-result[hidden], .product-main-berries__zipcode-unavailable[hidden] {\n    display: none;\n  }\n\n.product-main-berries__zipcode-delivery {\n  display: flex;\n  align-items: flex-start;\n  grid-gap: 12px;\n  gap: 12px;\n  padding: 20px;\n  border: 1px solid var(--product-main-berries-border);\n}\n\n.product-main-berries__zipcode-delivery-icon {\n  color: currentColor;\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n}\n\n.product-main-berries__zipcode-delivery-icon svg,\n  .product-main-berries__zipcode-delivery-icon .icon {\n    display: block;\n    width: 20px;\n    height: 20px;\n  }\n\n.product-main-berries__zipcode-delivery-copy {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.product-main-berries__zipcode-delivery-line {\n  margin: 0;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n.product-main-berries__zipcode-delivery-line + .product-main-berries__zipcode-delivery-line {\n    margin-top: 4px;\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries__zipcode-delivery-line {\n    font-size: 15px\n}\n  }\n\n.product-main-berries__zipcode-delivery-line.bold,\n  .product-main-berries__zipcode-delivery-line strong {\n    font-weight: 500;\n  }\n\n.product-main-berries__zipcode-delivery-line strong {\n    text-transform: capitalize;\n  }\n\n.product-main-berries__zipcode-delivery-badge {\n  flex: 0 0 auto;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.3;\n  font-weight: 500;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__zipcode-delivery-badge {\n    font-size: 15px\n}\n  }\n\n.product-main-berries__zipcode-delivery-badge.is-sold-out {\n    opacity: 0.55;\n  }\n\n.product-main-berries__zipcode-footnote {\n  margin: 10px 0 0;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n  letter-spacing: 0.5px;\n  color: var(--product-main-berries-muted);\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__zipcode-footnote {\n    font-size: 15px\n}\n  }\n\n.product-main-berries__zipcode-footnote span {\n    font-weight: 500;\n  }\n\n.product-main-berries__zipcode-waitlist {\n  margin: 12px 0 0;\n}\n\n.product-main-berries__zipcode-waitlist-link {\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.3;\n  color: inherit;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__zipcode-waitlist-link {\n    font-size: 15px\n}\n  }\n\n.product-main-berries__zipcode-waitlist-link a {\n    color: inherit;\n  }\n\n/* critical:start */\n\n.product-main-berries__availability {\n  margin-top: 20px;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__availability {\n    margin-top: 30px\n}\n  }\n\n.product-main-berries__add {\n  margin-top: 20px;\n  width: 100%;\n  border-radius: 20px;\n  border: 0;\n  padding: 10px 20px;\n  font-family: var(--sans-serif);\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  cursor: pointer;\n  background-color: #DA2924 !important;\n  color: var(--black) !important;\n}\n\n@media (min-width: 1000px) {\n\n.product-main-berries__add {\n    padding: 11px 30px;\n    font-size: 14px;\n    margin-top: 30px\n}\n  }\n\n.product-main-berries__add:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n.product-main-berries__add:not([disabled]):hover {\n    opacity: 0.7;\n  }\n\n.product-main-berries__add:after {\n    content: none;\n  }\n\n/* critical:end */\n\n.product-main-berries__add-error {\n  margin: 10px 0 0;\n  font-family: var(--sans-serif);\n  font-size: 12px;\n  line-height: 1.3;\n  color: var(--red);\n  text-align: center;\n}\n\n.product-main-berries__add-error[hidden] {\n    display: none;\n  }\n\n@media (min-width: 1000px) {\n\n.product-main-berries__add-error {\n    margin-top: 12px;\n    font-size: 14px\n}\n  }\n\n.product-main-berries .product-description {\n  margin-top: 30px;\n}\n\n.product-main-berries .accordion {\n  border-color: var(--product-main-berries-border);\n}\n\n.product-main-berries .accordion__button {\n  color: inherit;\n  padding: 15px 0;\n}\n\n.product-main-berries .accordion__content-wrapper {\n  color: inherit;\n}\n\n.product-main-berries .accordion__content-wrapper a {\n    color: inherit;\n  }\n\n.product-main-header--mobile {\n  display: none;\n}\n\n.product-main--show-header-mobile .product-main-header--mobile {\n    display: block;\n    margin: 0 auto 15px;\n    width: calc(100% - 40px);\n  }\n\n@media (min-width: 768px) {\n\n.product-main--show-header-mobile .product-main-header--mobile {\n      display: none\n  }\n    }\n\n.product-main-header--mobile.hidden {\n    display: none;\n  }\n\n.product-main--show-header-mobile .product-main-header--desktop {\n    display: none;\n  }\n\n@media (min-width: 768px) {\n\n.product-main--show-header-mobile .product-main-header--desktop {\n      display: block\n  }\n    }\n\n@media (max-width: 767px) {\n\n.product-main--reorder-header-mobile .product-main-header--desktop {\n      display: flex;\n      flex-direction: column\n  }\n    }\n\n.product-form__price-compare {\n  margin-right: 5px;\n  opacity: 0.6;\n  text-decoration: line-through;\n}\n\n.product-note {\n  margin-top: 25px;\n  padding: 15px;\n}\n\n@media (min-width: 768px) {\n\n.product-note {\n    padding: 15px 15px 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-note {\n    padding: 20px 20px 25px\n}\n  }\n\n.product-note--pickup {\n  margin-bottom: 10px;\n}\n\n@media (min-width: 1000px) {\n\n.product-note--pickup {\n    margin-bottom: 15px\n}\n  }\n\n.product-note__title {\n  margin: 0;\n}\n\n.product-note__text {\n  margin-top: 5px;\n}\n\n@media (min-width: 1000px) {\n\n.product-note__text {\n    margin-top: 10px\n}\n  }\n\n.product-note--gift-card {\n  width: calc(100% - 40px);\n  margin-top: 15px;\n}\n\n@media (min-width: 768px) {\n\n.product-note--gift-card {\n    width: 100%\n}\n  }\n\n@media (min-width: 1000px) {\n\n.product-note--gift-card {\n    margin-top: 20px\n}\n  }\n\n.product-zip {\n  margin-top: 15px;\n}\n\n@media (min-width: 1000px) {\n\n.product-zip {\n    margin-top: 10px\n}\n  }\n\n.product-zip__wrapper {\n  position: relative;\n}\n\n.product-zip__button {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n}\n\n@media (min-width: 1000px) {\n\n.product-zip__button {\n    right: 7px;\n    bottom: 7px\n}\n  }\n\n.product-zip__error {\n  margin-top: 15px;\n  color: var(--red);\n}\n\n@media (min-width: 768px) {\n\n.product-zip__error {\n    margin-top: 10px\n}\n  }\n\n.product-zip__error a {\n    color: inherit;\n  }\n\n.quantity-selector {\n  position: relative;\n  justify-content: space-between;\n  align-items: center;\n  display: inline-flex;\n  transition: opacity var(--duration) var(--ease);\n  border: 1px solid var(--black-o-20);\n  border-radius: 20px;\n  width: 100px;\n  height: 35px;\n  line-height: 35px;\n}\n\n.quantity-selector--mini-cart {\n    width: 85px;\n  }\n\n@media (min-width: 1000px) {\n\n.quantity-selector--mini-cart {\n      width: 90px;\n      height: 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.quantity-selector--mini-cart {\n      width: 122px\n  }\n    }\n\n.quantity-selector__field {\n  box-shadow: none;\n  width: 28px;\n  height: 35px;\n  padding: 0;\n  line-height: 35px;\n  text-align: center;\n  color: inherit;\n  -webkit-appearance: none;\n  -moz-appearance: textfield;\n}\n\n.quantity-selector__field:focus {\n    box-shadow: inset 0 0 0 1px var(--black);\n  }\n\n.quantity-selector--mini-cart .quantity-selector__field {\n    width: 20px;\n  }\n\n.quantity-selector__field::-webkit-inner-spin-button,\n.quantity-selector__field::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n          appearance: none;\n}\n\n.quantity-selector__action {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  width: 35px;\n  height: 35px;\n  cursor: pointer;\n  color: var(--red);\n}\n\n.quantity-selector__action:disabled {\n    opacity: 0.3;\n    cursor: default;\n  }\n\n.recipe-card {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.recipe-card__content {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.recipe-card__image {\n  overflow: hidden;\n  max-height: 541px;\n  margin-bottom: 10px;\n}\n\n@media (min-width: 1000px) {\n\n.recipe-card__image {\n    margin-bottom: 15px\n}\n  }\n\n.recipe-card__image::before {\n    padding-bottom: calc(259 / 208 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.recipe-card__image::before {\n      padding-bottom: calc(285 / 229 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.recipe-card__image::before {\n      padding-bottom: calc(381 / 305 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.recipe-card__image::before {\n      padding-bottom: calc(541 / 433 * 100%)\n  }\n    }\n\n.template-press .recipe-card__image {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0);\n    width: 100%;\n    max-width: calc(100% - 80px);\n    margin: 0 auto;\n  }\n\n@media (min-width: 768px) {\n\n.template-press .recipe-card__image {\n      max-width: calc(100% - 120px)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.template-press .recipe-card__image {\n      max-width: calc(100% - 160px)\n  }\n    }\n\n.template-press .recipe-card__image::before {\n      padding-bottom: 100%;\n    }\n\n.template-press .recipe-card__image--full-width {\n    top: 0;\n    left: 0;\n    transform: none;\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n  }\n\n.template-press .recipe-card__wrapper {\n    border: 1px solid var(--black-o-20);\n    margin-bottom: 25px;\n  }\n\n.template-press .recipe-card__wrapper::before {\n      padding-bottom: calc(396 / 477 * 100%);\n    }\n\n.template-recipes .recipe-card__wrapper::before, .template-event .recipe-card__wrapper::before {\n      content: none;\n    }\n\n.recipe-card__title {\n  margin: 0 0 2px;\n  border-bottom: none;\n}\n\n.template-press .recipe-card__title {\n    margin-bottom: 10px;\n  }\n\n@media (min-width: 768px) {\n\n.template-press .recipe-card__title {\n      width: calc(100% - 15px)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.template-press .recipe-card__title {\n      width: calc(100% - 35px);\n      margin-bottom: 30px\n  }\n    }\n\n.recipe-card__title::after {\n    content: none;\n  }\n\n.template-press a.recipe-card__title {\n    margin-bottom: 0;\n  }\n\n.recipe-card__text {\n  margin: 0;\n  margin-bottom: auto;\n}\n\n.recipe-card--grid .recipe-card__text {\n    opacity: 0.6;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-card--grid .recipe-card__text {\n      opacity: 1\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.recipe-card--grid .recipe-card__text {\n      opacity: 0.6\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.recipe-card--grid .recipe-card__text {\n      opacity: 1\n  }\n    }\n\n.recipe-filters--event .recipe-card__text {\n    color: var(--black-o-75);\n    opacity: 1;\n  }\n\n.recipe-card__button {\n  min-width: auto;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-top: 10px;\n  z-index: 3;\n}\n\n.template-press .recipe-card__button {\n    margin-top: auto;\n  }\n\n.recipe-card__date {\n  margin: 0;\n}\n\n.recipe-filters--event .recipe-card__date {\n    color: var(--black-o-75);\n  }\n\n.recipe-card__icon {\n  display: flex;\n  align-items: center;\n  width: 10px;\n  height: 10px;\n  margin-left: 2px;\n  padding-top: 2px;\n}\n\n.recipe-card__icon svg {\n    width: 100%;\n    height: 100%;\n  }\n\n.recipe-card__link {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  z-index: 2;\n}\n\n.recipe-card__link::after {\n    content: none;\n  }\n\n.recipe-card__tags {\n  display: flex;\n  align-items: center;\n  grid-gap: 10px;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 15px;\n}\n\n@media (min-width: 1000px) {\n\n.recipe-card__tags {\n    margin-bottom: 15px\n}\n  }\n\n.recipe-card__tag {\n  padding: 3px 10px;\n  border-radius: 15px;\n  text-transform: uppercase;\n  background: var(--sage);\n}\n\n@media (min-width: 1000px) {\n\n.recipe-card__tag {\n    padding: 6px 15px\n}\n  }\n\n.recipe-filters {\n  padding: 30px 0 40px;\n}\n\n@media (min-width: 768px) {\n\n.recipe-filters {\n    padding-top: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-filters {\n    padding-bottom: 60px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-filters {\n    padding: 30px 0 80px\n}\n  }\n\n.template-press .recipe-filters {\n    padding-top: 0;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-filters__head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center\n}\n  }\n\n.template-press .recipe-filters__head {\n    display: none;\n  }\n\n.recipe-filters__title {\n  margin: 0 0 15px;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.recipe-filters__title {\n    margin: 0;\n    text-align: left\n}\n  }\n\n.recipe-filters__select {\n  flex-shrink: 0;\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n\n.recipe-filters__select {\n    max-width: 280px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-filters__select {\n    max-width: 304px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-filters__select {\n    max-width: 434px\n}\n  }\n\n.recipe-filters--event {\n  padding-top: 60px;\n}\n\n.recipe-filters--event .recipe-filters__head {\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n  }\n\n.recipe-filters--event .recipe-filters__description {\n    margin: 10px auto 30px;\n  }\n\n.recipe-filters--event .recipe-filters__tags {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    grid-gap: 10px;\n    gap: 10px;\n    cursor: pointer;\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-filters--event .recipe-filters__tags {\n      grid-gap: 20px;\n      gap: 20px\n  }\n    }\n\n.recipe-filters--event .recipe-filters__tag {\n    min-width: 135px;\n    padding: 10px 25px;\n    border-radius: 20px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-filters--event .recipe-filters__tag {\n      min-width: 160px;\n      padding: 11px 40px;\n      border-radius: 70px\n  }\n    }\n\n.recipe-filters--event .recipe-filters__tag.is-active {\n      border-color: var(--red);\n    }\n\n.recipe-filters--event .recipe-filters__select {\n    margin: 20px auto 0;\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-filters--event .recipe-filters__select {\n      position: absolute;\n      top: 0;\n      right: 0;\n      max-width: 250px\n  }\n    }\n\n.recipe-filters--event-tagged {\n  padding-top: 22px;\n}\n\n.recipe-filters--event-tagged .recipe-filters__description {\n    margin-bottom: 0;\n  }\n\n.recipe-grid {\n  overflow: hidden;\n  padding: 30px 0 40px;\n}\n\n@media (min-width: 1000px) {\n\n.recipe-grid {\n    padding-top: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-grid {\n    padding: 60px 0\n}\n  }\n\n.recipe-grid--blog {\n    padding: 30px 0 0;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-grid--blog {\n      padding-top: 20px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.recipe-grid--blog {\n      padding-top: 30px\n  }\n    }\n\n.recipe-grid--pagination {\n    padding-bottom: 30px;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-grid--pagination {\n      padding-bottom: 40px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.recipe-grid--pagination {\n      padding-bottom: 50px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.recipe-grid--pagination {\n      padding-bottom: 60px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.recipe-grid--event {\n      padding-top: 60px\n  }\n    }\n\n.template-press .recipe-grid {\n    padding-top: 0;\n  }\n\n.recipe-grid__head {\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  margin-bottom: 15px;\n}\n\n@media (min-width: 768px) {\n\n.recipe-grid__head {\n    margin-bottom: 18px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-grid__head {\n    margin-bottom: 16px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-grid__head {\n    margin-bottom: 30px\n}\n  }\n\n.recipe-grid__title {\n  margin: 0;\n}\n\n.recipe-grid__button {\n  flex-shrink: 0;\n  min-width: auto;\n  margin-left: 10px;\n}\n\n.recipe-grid__carousel.swiper {\n  overflow: visible;\n}\n\n@media (min-width: 768px) {\n\n.recipe-grid__row,\n.recipe-grid__wrapper.swiper-wrapper {\n    display: flex;\n    transform: none;\n    width: auto;\n    height: auto;\n    margin: 0 -5px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-grid__row,\n.recipe-grid__wrapper.swiper-wrapper {\n    margin: 0 -7.5px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-grid__row,\n.recipe-grid__wrapper.swiper-wrapper {\n    margin: 0 -10px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.recipe-grid__row,\n.recipe-grid__wrapper.swiper-wrapper {\n    margin: 0 -12.5px\n}\n  }\n\n@media (min-width: 768px) {\n\n.recipe-grid__col,\n.recipe-grid__slide.swiper-slide {\n    width: calc(100% / 3);\n    padding: 0 5px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-grid__col,\n.recipe-grid__slide.swiper-slide {\n    padding: 0 7.5px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-grid__col,\n.recipe-grid__slide.swiper-slide {\n    padding: 0 10px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.recipe-grid__col,\n.recipe-grid__slide.swiper-slide {\n    padding: 0 12.5px\n}\n  }\n\n.recipe-grid__row {\n  flex-wrap: wrap;\n}\n\n.recipe-grid__col {\n  margin-bottom: 20px;\n}\n\n@media (min-width: 1000px) {\n\n.recipe-grid__col {\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-grid__col {\n    margin-bottom: 40px\n}\n  }\n\n.recipe-grid__tabs {\n  display: flex;\n  justify-content: center;\n  max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n  margin-bottom: 40px;\n}\n\n.recipe-grid__tab {\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  font-family: var(--sans-serif);\n\n  width: 50%;\n  text-align: center;\n  text-transform: uppercase;\n  padding: 0 60px 16px;\n  cursor: pointer;\n  border-bottom: 2px solid var(--black-o-20);\n}\n\n@media (min-width: 1024px) {\n\n.recipe-grid__tab {\n    font-size: 14px\n}\n  }\n\n.recipe-grid__tab.recipe-grid__tab--active {\n    border-bottom-color: var(--red);\n  }\n\n.recipe-grid__message {\n  margin: 0 auto;\n  text-align: center;\n}\n\n.recipe-hero {\n  position: relative;\n  padding: 20px 0 30px;\n  background-color: var(--parchment);\n}\n\n@media (min-width: 768px) {\n\n.recipe-hero {\n    padding: 30px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-hero {\n    padding: 40px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-hero {\n    padding: 50px 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.recipe-hero {\n    padding: 60px 0\n}\n  }\n\n.recipe-hero__container {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-hero__container {\n      flex-direction: row;\n      justify-content: space-between\n  }\n    }\n\n@media (min-width: 768px) {\n\n.recipe-hero__content {\n      width: 50%;\n      padding-right: var(--gutter-tablet)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.recipe-hero__content {\n      padding-right: var(--gutter-laptop)\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.recipe-hero__content {\n      padding-right: var(--gutter-large-desktop)\n  }\n    }\n\n.recipe-hero__featured {\n    width: 100%;\n    margin-bottom: 30px;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-hero__featured {\n      width: 50%;\n      max-width: 349px;\n      margin-bottom: 0\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.recipe-hero__featured {\n      max-width: 465px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.recipe-hero__featured {\n      max-width: 660px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.recipe-hero__featured {\n      max-width: 724px\n  }\n    }\n\n.recipe-hero__featured::before {\n      padding-bottom: calc(254 / 280 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.recipe-hero__featured::before {\n        padding-bottom: calc(316 / 349 * 100%)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.recipe-hero__featured::before {\n        padding-bottom: calc(422 / 465 * 100%)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.recipe-hero__featured::before {\n        padding-bottom: calc(600 / 660 * 100%)\n    }\n      }\n\n@media (min-width: 1600px) {\n\n.recipe-hero__featured::before {\n        padding-bottom: calc(658 / 724 * 100%)\n    }\n      }\n\n.recipe-hero__description,\n  .recipe-hero__title {\n    margin: 0;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-hero__description,\n  .recipe-hero__title {\n      max-width: 252px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.recipe-hero__description,\n  .recipe-hero__title {\n      max-width: 333px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.recipe-hero__description,\n  .recipe-hero__title {\n      max-width: 416px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.recipe-hero__description {\n      max-width: 305px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.recipe-hero__description {\n      max-width: 403px\n  }\n    }\n\n.recipe-hero__author {\n    margin-top: 5px;\n    margin-bottom: 12px;\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-hero__author {\n      margin-top: 10px;\n      margin-bottom: 17px\n  }\n    }\n\n.recipe-hero__author a {\n      display: inline-block;\n      margin-left: 3px;\n    }\n\n.recipe-hero__tag {\n  margin-bottom: 10px;\n}\n\n.recipe-hero--media {\n  padding: 0;\n}\n\n.recipe-hero--media .recipe-hero__container {\n    padding-top: 20px;\n    padding-bottom: 40px;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-hero--media .recipe-hero__container {\n      width: 100%;\n      padding: 0\n  }\n    }\n\n.recipe-hero--media .recipe-hero__featured {\n    width: 100%;\n    margin-bottom: 38px;\n  }\n\n@media (min-width: 768px) {\n\n.recipe-hero--media .recipe-hero__featured {\n      max-width: none;\n      width: 50%;\n      margin-bottom: 0\n  }\n    }\n\n@media (min-width: 768px) {\n\n.recipe-hero--media .recipe-hero__featured::before {\n        padding-bottom: calc(300 / 384 * 100%)\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.recipe-hero--media .recipe-hero__featured::before {\n        padding-bottom: calc(400 / 512 * 100%)\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.recipe-hero--media .recipe-hero__featured::before {\n        padding-bottom: calc(467 / 720 * 100%)\n    }\n      }\n\n@media (min-width: 768px) {\n\n.recipe-hero--media .recipe-hero__content {\n      padding: 0 20px\n  }\n    }\n\n.recipe-metadata__inner {\n  border-top: 1px solid var(--black-o-20);\n  margin: 0 auto;\n  padding: 20px 0 40px;\n  text-align: center;\n}\n\n@media (min-width: 768px) {\n\n.recipe-metadata__inner {\n    max-width: 488px;\n    padding-top: 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-metadata__inner {\n    max-width: 654px;\n    padding: 40px 0 60px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.recipe-metadata__inner {\n    max-width: 700px;\n    padding-bottom: 90px\n}\n  }\n\n.recipe-metadata__inner.recipe-metadata--blank {\n    border: none;\n  }\n\n.recipe-metadata__wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: 225px;\n  margin: 0 auto 11px;\n}\n\n@media (min-width: 768px) {\n\n.recipe-metadata__wrapper {\n    max-width: none;\n    margin-bottom: 12px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-metadata__wrapper {\n    margin-bottom: 19px\n}\n  }\n\n.recipe-metadata__post-on::after {\n    content: '•';\n    display: inline-block;\n    margin: 0 0.2em;\n  }\n\n.recipe-metadata--hidden-author .recipe-metadata__post-on::after {\n      content: none;\n    }\n\n.recipe-metadata--hidden-author .recipe-metadata__post-by {\n    display: none;\n  }\n\n.recipe-metadata__post-tags {\n  margin: 0 0 15px;\n  text-transform: capitalize;\n}\n\n@media (min-width: 1000px) {\n\n.recipe-metadata__post-tags {\n    margin-bottom: 20px\n}\n  }\n\n.recipe-metadata__social-links {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (min-width: 1000px) {\n\n.recipe-metadata--article-event .recipe-metadata__inner {\n      padding-bottom: 94px\n  }\n    }\n\n.recipe-metadata--article-event .recipe-metadata__wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    grid-gap: 15px;\n    gap: 15px;\n  }\n\n@media (min-width: 1000px) {\n\n.recipe-metadata--article-event .recipe-metadata__wrapper {\n      margin-bottom: 16px\n  }\n    }\n\n.recipe-metadata--article-event .recipe-metadata__post-on::after {\n    content: none;\n  }\n\n.related-products {\n  overflow: hidden;\n  border-top: 1px solid var(--black-o-20);\n  padding: 40px 0 30px;\n}\n\n@media (min-width: 768px) {\n\n.related-products {\n    padding: 30px 0 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.related-products {\n    padding-top: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.related-products {\n    padding: 60px 0\n}\n  }\n\n.related-products__title {\n  margin: 0 0 40px;\n}\n\n@media (min-width: 1000px) {\n\n.related-products__title {\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.related-products__title {\n    margin-bottom: 27px\n}\n  }\n\n.related-products__carousel.swiper {\n  overflow: visible;\n}\n\n@media (min-width: 768px) {\n\n.related-products__carousel.swiper .swiper-wrapper {\n      display: flex;\n      transform: none;\n      width: auto;\n      height: auto;\n      margin: 0 -5px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.related-products__carousel.swiper .swiper-wrapper {\n      margin: 0 -7.5px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.related-products__carousel.swiper .swiper-wrapper {\n      margin: 0 -10px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.related-products__carousel.swiper .swiper-wrapper {\n      margin: 0 -12.5px\n  }\n    }\n\n@media (min-width: 768px) {\n\n.related-products__carousel.swiper .swiper-slide {\n      width: calc(100% / 3);\n      padding: 0 5px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.related-products__carousel.swiper .swiper-slide {\n      padding: 0 7.5px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.related-products__carousel.swiper .swiper-slide {\n      padding: 0 10px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.related-products__carousel.swiper .swiper-slide {\n      padding: 0 12.5px\n  }\n    }\n\n.related-recipes {\n  position: relative;\n  padding: 40px 0 25px;\n  overflow: hidden;\n  border-top: 1px solid var(--black-o-20);\n}\n\n@media (min-width: 1240px) {\n\n.related-recipes {\n    padding: 60px 0 45px\n}\n  }\n\n@media (max-width: 767px) {\n\n.related-recipes__container {\n      width: 100%;\n      padding-left: 20px\n  }\n    }\n\n.related-recipes__title {\n    margin-bottom: 15px;\n  }\n\n@media (min-width: 768px) {\n\n.related-recipes__title {\n      margin-bottom: 18px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.related-recipes__title {\n      margin-bottom: 16px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.related-recipes__title {\n      margin-bottom: 30px\n  }\n    }\n\n.related-recipes__grid {\n    overflow: auto;\n    padding-bottom: 15px;\n  }\n\n@media (min-width: 768px) {\n\n.related-recipes__grid {\n      justify-content: center;\n      margin: 0 -5px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.related-recipes__grid {\n      margin: 0 -7px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.related-recipes__grid {\n      margin: 0 -10px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.related-recipes__grid {\n      margin: 0 -12px\n  }\n    }\n\n.related-recipes__grid::-webkit-scrollbar {\n      height: 3px;\n      background-color: transparent;\n    }\n\n.related-recipes__grid::-webkit-scrollbar-thumb {\n      background-color: var(--gray);\n    }\n\n.related-recipes__item {\n    flex: 0 0 208px;\n    padding: 0 10px 0 0;\n  }\n\n@media (min-width: 768px) {\n\n.related-recipes__item {\n      flex-grow: 0;\n      flex-shrink: 0;\n      flex-basis: calc(100% / 3);\n      padding: 0 5px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.related-recipes__item {\n      padding: 0 7px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.related-recipes__item {\n      padding: 0 10px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.related-recipes__item {\n      padding: 0 12px\n  }\n    }\n\n@media (max-width: 767px) {\n\n.related-recipes__item:last-child:not(:only-child) {\n        padding-right: 20px\n    }\n      }\n\n.review-card {\n  height: 100%;\n  padding: 20px;\n  background: var(--buff);\n}\n\n@media (min-width: 1240px) {\n\n.review-card {\n    padding: 30px\n}\n  }\n\n.review-card__logo {\n  position: relative;\n  height: 12px;\n}\n\n@media (min-width: 1000px) {\n\n.review-card__logo {\n    height: 16px\n}\n  }\n\n.review-card__logo .icon {\n    width: 14px;\n  }\n\n@media (min-width: 1000px) {\n\n.review-card__logo .icon {\n      width: 20px\n  }\n    }\n\n.review-card__contents {\n  margin-top: 54px;\n}\n\n@media (min-width: 768px) {\n\n.review-card__contents {\n    margin-top: 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.review-card__contents {\n    margin-top: 80px\n}\n  }\n\n@media (min-width: 1440px) {\n\n.review-card__contents {\n    margin-top: 170px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.review-card__contents {\n    margin-top: 190px\n}\n  }\n\n.review-card__content {\n  opacity: 0.7;\n}\n\n.review-card__title {\n  margin-bottom: 5px;\n}\n\n@media (min-width: 1000px) {\n\n.review-card__title {\n    margin-bottom: 10px\n}\n  }\n\n.review-card__author {\n  margin-top: 8px;\n}\n\n@media (min-width: 1000px) {\n\n.review-card__author {\n    margin-top: 12px\n}\n  }\n\n/* style for reviews */\n\n.reviews {\n  margin: 30px 0;\n}\n\n@media (min-width: 768px) {\n\n.reviews {\n    margin: 40px 0 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.reviews {\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.reviews {\n    margin: 80px 0\n}\n  }\n\n.reviews__title {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n@media (min-width: 1000px) {\n\n.reviews__title {\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.reviews__title {\n    margin-bottom: 40px\n}\n  }\n\n.reviews__swiper.swiper {\n  margin-right: calc(var(--gutter) * -1);\n  padding-right: var(--gutter);\n}\n\n@media (min-width: 768px) {\n\n.reviews__swiper-wrapper.swiper-wrapper {\n    flex-wrap: wrap;\n    justify-content: space-between\n}\n  }\n\n.reviews__slide.swiper-slide {\n  width: 208px;\n  height: auto;\n}\n\n@media (min-width: 768px) {\n\n.reviews__slide.swiper-slide {\n    width: calc((100% - 30px) / 4)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.reviews__slide.swiper-slide {\n    width: calc((100% - 45px) / 4)\n}\n  }\n\n@media (min-width: 1440px) {\n\n.reviews__slide.swiper-slide {\n    width: calc((100% - 60px) / 4)\n}\n  }\n\n.select-input {\n  position: relative;\n}\n\n.select-input__el {\n  display: block;\n  width: 100%;\n  height: 40px;\n  padding-left: 15px;\n  padding-right: 25px;\n  border: 1px solid var(--black-o-20);\n  font-size: inherit;\n  letter-spacing: inherit;\n  border-radius: var(--radius-default);\n}\n\n.select-input__el:not([disabled]) {\n    cursor: pointer;\n  }\n\nbody.keyboard-active .select-input__el:focus {\n      outline: 1px solid var(--red);\n      outline-offset: 5px;\n    }\n\n.select-input__el.is-empty {\n    color: var(--black-o-50);\n  }\n\n.select-input--contact-form .select-input__el {\n    margin: 0;\n  }\n\n@media (min-width: 1000px) {\n\n.select-input--contact-form .select-input__el {\n      padding-left: 20px;\n      padding-right: 30px\n  }\n    }\n\n.select-input--product-form .select-input__el {\n    margin-bottom: 0;\n    padding-right: 39px;\n  }\n\n.select-input--recipe-filters .select-input__el {\n    margin-bottom: 0;\n    height: 35px;\n  }\n\n@media (min-width: 1000px) {\n\n.select-input--recipe-filters .select-input__el {\n      height: 40px\n  }\n    }\n\n.select-input__label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.select-input--product-form .select-input__label,\n  .select-input--contact-form .select-input__label {\n    margin-bottom: 10px;\n  }\n\n.select-input--contact-form .select-input__wrapper {\n    position: relative;\n  }\n\n.select-input--product-form .select-input__wrapper {\n    position: relative;\n    margin-bottom: 10px;\n  }\n\n.select-input__icon {\n  position: absolute;\n  right: 18px;\n  top: 50%;\n  z-index: 0;\n  display: block;\n}\n\n.select-input--product-form .select-input__icon,\n  .select-input--gift-card .select-input__icon,\n  .select-input--recipe-filters .select-input__icon,\n  .select-input--contact-form .select-input__icon {\n    right: 15px;\n    display: flex;\n    transform: translate3d(0, -50%, 0);\n  }\n\n@media (min-width: 1000px) {\n\n.select-input--product-form .select-input__icon,\n  .select-input--gift-card .select-input__icon,\n  .select-input--recipe-filters .select-input__icon,\n  .select-input--contact-form .select-input__icon {\n      right: 20px\n  }\n    }\n\n.select-input__error {\n  position: absolute;\n  left: 0;\n  top: 100%;\n  margin-top: 5px;\n  color: var(--red);\n  transition: opacity 300ms;\n}\n\n.shop-the-recipe__product {\n    display: flex;\n    flex-wrap: wrap;\n    grid-gap: 15px 10px;\n    gap: 15px 10px;\n  }\n\n@media (min-width: 768px) {\n\n.shop-the-recipe__product {\n      grid-gap: 15px 20px;\n      gap: 15px 20px\n  }\n    }\n\n.shop-the-recipe__product-image {\n    width: 100px;\n  }\n\n@media (min-width: 768px) {\n\n.shop-the-recipe__product-image {\n      width: 133px\n  }\n    }\n\n.shop-the-recipe__product-image::before {\n      content: '';\n      display: block;\n      padding-bottom: calc(125 / 100 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.shop-the-recipe__product-image::before {\n        padding-bottom: calc(166 / 133 * 100%)\n    }\n      }\n\n.shop-the-recipe__product-content {\n    width: calc(100% - 110px);\n  }\n\n@media (min-width: 768px) {\n\n.shop-the-recipe__product-content {\n      width: calc(100% - 153px)\n  }\n    }\n\n.shop-the-recipe__cta {\n    display: flex !important;\n    width: 100%;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-radius: 20px;\n    border-bottom: none !important;\n  }\n\n.shop-the-recipe__cta:hover {\n      background: var(--red-1) !important;\n    }\n\n.shop-the-recipe__cta--mobile {\n    height: 35px;\n  }\n\n@media (min-width: 445px) {\n\n.shop-the-recipe__cta--mobile {\n      display: none !important\n  }\n    }\n\n.shop-the-recipe__cta--desktop {\n    display: none !important;\n    height: 40px;\n  }\n\n@media (min-width: 445px) {\n\n.shop-the-recipe__cta--desktop {\n      display: flex !important;\n      width: -webkit-fit-content;\n      width: -moz-fit-content;\n      width: fit-content\n  }\n    }\n\n.social-image-gallery {\n  position: relative;\n  margin-bottom: 30px;\n}\n\n@media (min-width: 1000px) {\n\n.social-image-gallery {\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.social-image-gallery {\n    margin-bottom: 60px\n}\n  }\n\n.social-image-gallery__container {\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n@media (min-width: 768px) {\n\n.social-image-gallery__container {\n    flex-direction: row;\n    justify-content: space-between\n}\n  }\n\n.social-image-gallery__title {\n  margin: 14px 0 10px;\n}\n\n@media (min-width: 768px) {\n\n.social-image-gallery__title {\n    max-width: 236px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.social-image-gallery__title {\n    max-width: 306px;\n    margin-top: 20px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.social-image-gallery__title {\n    max-width: 366px;\n    margin-bottom: 20px\n}\n  }\n\n.social-image-gallery__socials {\n  margin-top: 10px;\n  padding: 47px 22px;\n}\n\n@media (min-width: 768px) {\n\n.social-image-gallery__socials {\n    width: calc(50% - 5px);\n    margin-top: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.social-image-gallery__socials {\n    width: calc(50% - 7px)\n}\n  }\n\n@media (min-width: 1240px) {\n\n.social-image-gallery__socials {\n    width: calc(50% - 10px)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.social-image-gallery__socials {\n    width: calc(50% - 12px)\n}\n  }\n\n.social-image-gallery__logo {\n  width: 51px;\n}\n\n@media (min-width: 1000px) {\n\n.social-image-gallery__logo {\n    width: 75px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.social-image-gallery__logo {\n    width: 101px\n}\n  }\n\n.social-image-gallery__logo::before {\n    padding-bottom: calc(65 / 51 * 100%);\n  }\n\n.social-image-gallery__social {\n  grid-gap: 10px;\n}\n\n@media (min-width: 768px) {\n\n.social-image-gallery__social {\n    grid-gap: 15px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.social-image-gallery__social {\n    grid-gap: 20px\n}\n  }\n\n.social-image-gallery__social-item .icon {\n    width: 12px;\n    height: 12px;\n    margin-right: 6px;\n  }\n\n@media (min-width: 1000px) {\n\n.social-image-gallery__social-item .icon {\n      width: 14px;\n      height: 14px\n  }\n    }\n\n.social-image-gallery__social-item .button {\n    text-transform: none;\n  }\n\n.social-image-gallery__images {\n  grid-gap: 10px;\n}\n\n@media (min-width: 768px) {\n\n.social-image-gallery__images {\n    width: calc(50% - 5px)\n}\n  }\n\n@media (min-width: 1000px) {\n\n.social-image-gallery__images {\n    width: calc(50% - 7px);\n    grid-gap: 15px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.social-image-gallery__images {\n    width: calc(50% - 10px);\n    grid-gap: 20px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.social-image-gallery__images {\n    width: calc(50% - 12px);\n    grid-gap: 25px\n}\n  }\n\n.social-links {\n  display: flex;\n  white-space: nowrap;\n}\n\n.social-links__icon {\n  display: inline-block;\n  transition: opacity var(--transition-default);\n  width: 16px;\n  margin-right: 20px;\n  color: var(--red)\n}\n\n.social-links__icon:hover {\n    opacity: 0.7;\n  }\n\n.social-links__icon.icon-tiktok {\n    width: 13px;\n  }\n\n.social-links--footer .social-links__icon {\n  border-color: transparent;\n  color: var(--white)\n  }\n\n.social-links--footer .social-links__icon::after {\n    background: var(--white);\n  }\n\n@media (min-width: 1000px) {\n\n  .social-links--footer .social-links__icon {\n      margin-right: 22px\n  }\n    }\n\n.social-links--footer .social-links__icon svg {\n      vertical-align: middle;\n    }\n\n.social-links--header {\n  margin-top: auto;\n}\n\n@media (min-width: 768px) {\n\n.social-links--header {\n    display: none\n}\n  }\n\n.social-share__icon {\n  display: flex;\n  align-items: center;\n  transition: opacity var(--duration) var(--ease);\n  margin: 0 6px;\n}\n\n@media (min-width: 1000px) {\n\n.social-share__icon {\n    margin: 0 8px\n}\n  }\n\n.social-share__icon:first-child {\n    margin-left: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.social-share__icon:first-child {\n      margin-left: 15px\n  }\n    }\n\n.social-share__icon:last-child {\n    margin-right: 0;\n  }\n\n.social-share__icon:hover {\n    opacity: 0.7;\n  }\n\n.social-share__icon--facebook {\n  width: 7px;\n}\n\n@media (min-width: 1000px) {\n\n.social-share__icon--facebook {\n    width: 8px\n}\n  }\n\n.social-share__icon--twitter {\n  width: 11px;\n}\n\n@media (min-width: 1000px) {\n\n.social-share__icon--twitter {\n    width: 15px\n}\n  }\n\n.social-share__icon--email {\n  width: 13px;\n}\n\n@media (min-width: 1000px) {\n\n.social-share__icon--email {\n    width: 17px\n}\n  }\n\n.social-share__link {\n  border-bottom: none;\n  line-height: 0;\n  color: var(--red);\n}\n\n.social-share__link::after {\n    content: none;\n  }\n\n.social-share__link .icon {\n    width: auto;\n  }\n\n/* critical:start */\n\n.shopify-section--sticky-promo-banner {\n  position: -webkit-sticky;\n  position: sticky;\n  top: calc(var(--h-header) + 21px);\n  z-index: 10;\n  margin: 0 20px;\n}\n\n@media (min-width: 768px) {\n\n.shopify-section--sticky-promo-banner {\n    top: calc(var(--h-header-tablet) + 21px);\n    margin: 0 30px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.shopify-section--sticky-promo-banner {\n    margin: 0 40px;\n    top: calc(var(--h-header-laptop) + 21px)\n}\n  }\n\n@media (min-width: 1240px) {\n\n.shopify-section--sticky-promo-banner {\n    margin: 0 50px;\n    top: calc(var(--h-header-desktop) + 31px)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.shopify-section--sticky-promo-banner {\n    margin: 0 60px\n}\n  }\n\n.sticky-promo-banner__bar {\n  background-color: var(--parchment);\n  border-bottom: 1px solid var(--border-color-grey);\n}\n\n@media (min-width: 1024px) {\n\n.sticky-promo-banner__bar {\n    border-bottom-color: var(--black-o-20)\n}\n  }\n\n.sticky-promo-banner__inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  grid-gap: 8px;\n  gap: 8px;\n  padding: 8px 10px;\n  text-align: center;\n  min-height: 95px;\n}\n\n.sticky-promo-banner__inner[\\:has\\(\\%3E\\%20.sticky-promo-banner__action\\:only-child\\)] {\n    justify-content: center;\n  }\n\n.sticky-promo-banner__inner:has(> .sticky-promo-banner__action:only-child) {\n    justify-content: center;\n  }\n\n@media (min-width: 768px) {\n\n.sticky-promo-banner__inner {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    grid-gap: 24px;\n    gap: 24px;\n    padding: 2px 10px;\n    min-height: 32px;\n    text-align: left\n}\n\n    .sticky-promo-banner__inner[\\:has\\(\\%3E\\%20.sticky-promo-banner__action\\:only-child\\)] {\n      justify-content: center;\n    }\n\n    .sticky-promo-banner__inner:has(> .sticky-promo-banner__action:only-child) {\n      justify-content: center;\n    }\n  }\n\n@media (min-width: 1000px) {\n\n.sticky-promo-banner__inner {\n    padding: 5px 20px;\n    min-height: 40px\n}\n  }\n\n.sticky-promo-banner__copy {\n  width: 100%;\n}\n\n@media (min-width: 1024px) {\n\n.sticky-promo-banner__copy {\n    flex: 1 1 auto;\n    min-width: 0\n}\n  }\n\n.sticky-promo-banner__heading {\n  margin: 0;\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.2;\n  color: var(--black);\n}\n\n@media (min-width: 1240px) {\n\n.sticky-promo-banner__heading {\n    font-size: 15px\n}\n  }\n\n.sticky-promo-banner__title {\n  display: block;\n  max-width: 178px;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) {\n\n.sticky-promo-banner__title {\n    display: inline;\n    max-width: none\n}\n  }\n\n.sticky-promo-banner__sub {\n  display: block;\n  opacity: 0.6;\n}\n\n@media (min-width: 768px) {\n\n.sticky-promo-banner__sub {\n    display: inline;\n    margin-left: 4px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.sticky-promo-banner__sub {\n    margin-left: 10px\n}\n  }\n\n.sticky-promo-banner__action {\n  flex-shrink: 0;\n}\n\n.sticky-promo-banner__cta {\n  padding-top: 0 !important;\n}\n\n/* critical:end */\n\n.container.store-locator-tabs-container {\n  max-width: none;\n}\n\n.store-locator-tabs {\n  padding-bottom: 40px;\n}\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs {\n    padding-bottom: 60px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.store-locator-tabs {\n    padding-bottom: 80px\n}\n  }\n\n.store-locator-tabs__tabs {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  width: 100%;\n  max-width: 431px;\n  padding: 6px;\n  margin: 0 auto 24px;\n  background-color: var(--parchment);\n  border-radius: 60px;\n}\n\n.store-locator-tabs__tabs::after {\n    content: '';\n    position: absolute;\n    top: auto;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: none;\n    height: 1px;\n    background-color: var(--black-o-20);\n  }\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__tabs {\n    padding: 0;\n    margin: 0 auto 32px;\n    background-color: transparent;\n    border-radius: 0\n}\n\n    .store-locator-tabs__tabs::after {\n      display: block;\n    }\n  }\n\n.store-locator-tabs__tab {\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  font-family: var(--sans-serif);\n\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50%;\n  padding: 10px 16px;\n  border-radius: 40px;\n  white-space: nowrap;\n  transition: background-color var(--transition-default);\n}\n\n@media (min-width: 1024px) {\n\n.store-locator-tabs__tab {\n    font-size: 14px\n}\n  }\n\n.store-locator-tabs__tab[aria-selected] {\n    background-color: var(--white);\n  }\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__tab[aria-selected] {\n      background-color: transparent\n  }\n    }\n\nbody.keyboard-active .store-locator-tabs__tab:focus {\n    outline: none;\n    background-color: transparent;\n    color: var(--black);\n  }\n\nbody.keyboard-active .store-locator-tabs__tab:focus::before {\n      content: '';\n      position: absolute;\n      bottom: -5px;\n      left: -8px;\n      width: calc(100% + 16px);\n      height: calc(100% + 10px);\n      border: 1px solid var(--red);\n      border-radius: inherit;\n    }\n\n.store-locator-tabs__tab::after {\n    content: '';\n    position: absolute;\n    top: auto;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: none;\n    height: 2px;\n    background-color: var(--red);\n    transform: scaleX(0);\n    transition: transform var(--transition-default);\n  }\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__tab {\n    padding: 0 60px 16px;\n    border-radius: 0\n}\n\n    .store-locator-tabs__tab::after {\n      display: block;\n    }\n\n    .store-locator-tabs__tab[aria-selected] {\n      background-color: transparent;\n    }\n\n      .store-locator-tabs__tab[aria-selected]::after {\n        transform: scaleX(1);\n      }\n  }\n\n.store-locator-tabs__online-stores {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  grid-gap: 16px;\n  gap: 16px;\n  max-width: 1114px;\n  margin: 0 auto;\n}\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__online-stores {\n    grid-gap: 24px;\n    gap: 24px\n}\n  }\n\n.store-locator-tabs__online-store {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  grid-gap: 15px;\n  gap: 15px;\n  width: 100%;\n  min-height: 190px;\n  padding: 32px 24px 24px;\n  border: 1px solid var(--black-o-20);\n}\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__online-store {\n    flex-direction: row;\n    align-items: center;\n    grid-gap: 52px;\n    gap: 52px;\n    min-height: 144px;\n    padding: 41px 64px\n}\n  }\n\n.store-locator-tabs__online-store-logo {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__online-store-logo {\n    align-items: center;\n    justify-content: center;\n    width: 222px;\n    min-width: 222px\n}\n  }\n\n.store-locator-tabs__online-store-logo > img {\n    max-width: min(100%, 198px);\n    object-fit: contain;\n  }\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__online-store-logo > img {\n      max-width: 222px;\n      max-height: 72px\n  }\n    }\n\n.store-locator-tabs__online-store-description {\n  font-family: var(--sans-serif);\n  font-size: 13px;\n}\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__online-store-description {\n    max-width: 432px;\n    font-size: 15px;\n    line-height: 1.2\n}\n  }\n\n.store-locator-tabs__online-store-description ul {\n    padding-left: 1.5ch;\n    list-style-type: disc;\n    list-style-position: outside;\n  }\n\n.store-locator-tabs__online-store-description ul li:not(:last-child) {\n        margin-bottom: 8px;\n      }\n\n.store-locator-tabs__online-store-description ul li::marker {\n        color: var(--red);\n      }\n\n.store-locator-tabs__online-store-cta {\n  margin-top: auto;\n  white-space: nowrap;\n}\n\n@media (min-width: 1000px) {\n\n.store-locator-tabs__online-store-cta {\n    margin-top: unset;\n    margin-left: auto\n}\n  }\n\n.style-guide hr {\n\n    margin: 20px 0;\n  }\n\n.style-guide .header-side__item {\n    display: inline-block;\n  }\n\n.style-guide__wrapper {\n  flex-wrap: wrap;\n}\n\n.style-guide__block--left,\n.style-guide__block--right {\n  width: 100%;\n}\n\n@media (min-width: 1024px) {\n\n.style-guide__block--left,\n.style-guide__block--right {\n    width: 50%\n}\n  }\n\n@media (min-width: 1024px) {\n\n.style-guide__block--left {\n    padding-right: 100px\n}\n  }\n\n.style-guide__section {\n  margin-top: 50px;\n}\n\n.style-guide__section-title {\n  margin-bottom: 20px;\n}\n\n.style-guide__label {\n  margin: 20px 0;\n}\n\n.style-guide__box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 30px;\n  border: 1px solid var(--border-color);\n}\n\n.style-guide__color-grid {\n  margin: 0 -10px;\n}\n\n.style-guide__color-item {\n  width: 50%;\n  padding: 10px;\n}\n\n@media (min-width: 768px) {\n\n.style-guide__color-item {\n    width: 25%\n}\n  }\n\n.style-guide__color-box {\n  position: relative;\n}\n\n.style-guide__color-box::before {\n    content: '';\n    display: block;\n    padding-bottom: 100%;\n  }\n\n.style-guide__color-code {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.testimonial-card {\n  height: 100%;\n}\n\n.testimonial-card__container {\n  flex-direction: column;\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n@media (min-width: 768px) {\n\n.testimonial-card__container {\n    flex-direction: row\n}\n  }\n\n.testimonial-card__featured {\n  overflow: hidden;\n  margin-top: 70px;\n}\n\n@media (min-width: 768px) {\n\n.testimonial-card__featured {\n    width: 289px;\n    margin-top: 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.testimonial-card__featured {\n    width: 305px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.testimonial-card__featured {\n    width: 436px\n}\n  }\n\n.testimonial-card__featured--ratio {\n  height: 422px;\n}\n\n@media (min-width: 768px) {\n\n.testimonial-card__featured--ratio {\n    height: auto\n}\n  }\n\n.testimonial-card__featured--ratio::before {\n    padding-bottom: calc(650 / 436 * 100%);\n  }\n\n.testimonial-card__inner {\n  margin-bottom: auto;\n}\n\n@media (min-width: 768px) {\n\n.testimonial-card__inner {\n    width: calc(100% - 289px);\n    margin-bottom: 0;\n    padding: 9px 60px 50px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.testimonial-card__inner {\n    width: calc(100% - 305px);\n    padding-top: 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.testimonial-card__inner {\n    width: calc(100% - 436px);\n    padding-top: 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.testimonial-card__content {\n    max-width: 544px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.testimonial-card__content {\n    max-width: 673px\n}\n  }\n\n.testimonial-card__title {\n  margin: 0 0 10px;\n}\n\n@media (min-width: 1000px) {\n\n.testimonial-card__title {\n    margin-bottom: 20px\n}\n  }\n\n.testimonial-card__author {\n  margin: 0 0 5px;\n}\n\n.testimonial-card__position {\n  margin: 0;\n}\n\n.testimonials {\n  padding: 30px 0 20px;\n}\n\n@media (min-width: 768px) {\n\n.testimonials {\n    padding: 30px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.testimonials {\n    padding: 40px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.testimonials {\n    padding: 50px 0\n}\n  }\n\n.testimonials .swiper-slide {\n    height: auto;\n  }\n\n.testimonials__navigation {\n  z-index: 10;\n  bottom: 442px;\n  left: 0;\n}\n\n@media (min-width: 768px) {\n\n.testimonials__navigation {\n    bottom: 0\n}\n  }\n\n.testimonials__navigation .swiper-button-prev,\n  .testimonials__navigation .swiper-button-next {\n    cursor: pointer;\n  }\n\n.testimonials__navigation .swiper-button-next {\n    margin-left: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.testimonials__navigation .swiper-button-next {\n      margin-left: 15px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.testimonials__navigation .swiper-button-next {\n      margin-left: 20px\n  }\n    }\n\n.testimonials__navigation .swiper-button-disabled {\n    opacity: 0.3;\n    pointer-events: none;\n  }\n\n.text-input {\n  position: relative;\n}\n\n.text-input__el {\n  width: 100%;\n  height: 40px;\n  padding: 0 15px;\n  margin: 0;\n  border: 1px solid var(--black-o-20);\n  border-radius: var(--radius-default);\n}\n\n@media (min-width: 1000px) {\n\n.text-input__el {\n    padding: 0 20px\n}\n  }\n\n.has-error .text-input__el {\n    border-width: 2px;\n    border-color: var(--red);\n  }\n\n.is-active:not(.has-error) .text-input__el {\n    border-color: var(--black);\n  }\n\n.text-input--floating .text-input__el {\n    height: 45px;\n    border-radius: 70px;\n  }\n\n.text-input--floating.is-active .text-input__el,\n  .text-input--floating.has-value .text-input__el {\n    padding-top: 8px;\n  }\n\n.text-input--footer .text-input__el,\n  .text-input--zip .text-input__el {\n    height: 35px;\n  }\n\n@media (min-width: 1000px) {\n\n.text-input--footer .text-input__el,\n  .text-input--zip .text-input__el {\n      height: 40px\n  }\n    }\n\n.product-zip--error .text-input__el {\n    border-width: 2px;\n    border-color: var(--red);\n  }\n\nbody.keyboard-active .text-input__el:focus {\n      border-color: var(--black-o-20);\n      outline: 1px solid var(--red);\n      outline-offset: 5px;\n    }\n\n.text-input__el::-webkit-input-placeholder {\n    color: var(--black);\n    opacity: 0.5;\n  }\n\n.text-input__el::placeholder {\n    color: var(--black);\n    opacity: 0.5;\n  }\n\n.text-input__el::-webkit-outer-spin-button,\n  .text-input__el::-webkit-inner-spin-button {\n    margin: 0;\n    -webkit-appearance: none;\n  }\n\n.text-input__el[type=\"number\"] {\n    -moz-appearance: textfield;\n  }\n\n.text-input--reverse:not(.text-input--newsletter-signup-banner-new) .text-input__el {\n    border-color: var(--white-o-50);\n  }\n\n.is-active .text-input--reverse:not(.text-input--newsletter-signup-banner-new) .text-input__el {\n      border-color: var(--white);\n      color: var(--white);\n    }\n\nbody.keyboard-active .text-input--reverse:not(.text-input--newsletter-signup-banner-new) .text-input__el:focus {\n        border-color: var(--white-o-50);\n        outline: 1px solid var(--white);\n        outline-offset: 5px;\n      }\n\n.text-input--reverse:not(.text-input--newsletter-signup-banner-new) .text-input__el::-webkit-input-placeholder {\n      color: var(--white);\n      opacity: 0.8;\n    }\n\n.text-input--reverse:not(.text-input--newsletter-signup-banner-new) .text-input__el::placeholder {\n      color: var(--white);\n      opacity: 0.8;\n    }\n\n.text-input--reverse:not(.text-input--newsletter-signup-banner-new).is-active .text-input__el {\n    color: var(--white);\n    border-color: var(--white);\n  }\n\n.text-input--reverse:not(.text-input--newsletter-signup-banner-new).has-error .text-input__el {\n    border-width: 2px;\n    border-color: var(--white);\n  }\n\n.text-input--newsletter-signup-banner .text-input__el,\n  .text-input--newsletter-signup-banner-new .text-input__el {\n    height: 35px;\n  }\n\n@media (min-width: 1000px) {\n\n.text-input--newsletter-signup-banner .text-input__el,\n  .text-input--newsletter-signup-banner-new .text-input__el {\n      height: 40px\n  }\n    }\n\n@media (max-width: 1023px) {\n\n.text-input--newsletter-signup-banner-new .text-input__el {\n    font-size: 13px;\n  }\n  }\n\n.text-input__label {\n  display: block;\n  margin-bottom: 10px;\n  pointer-events: none;\n}\n\n.text-input__label.sr-only {\n    margin: 0;\n  }\n\n.text-input__label + .text-input__el {\n    margin-top: 0;\n  }\n\n.is-required:not(.text-input--floating) .text-input__label::after {\n      content: '*';\n    }\n\n.text-input--floating .text-input__label {\n    position: absolute;\n    top: 50%;\n    left: 15px;\n    opacity: 0.5;\n    transform: translate3d(0, -50%, 0);\n    transition: top var(--transition-default);\n    width: calc(100% - 30px);\n    margin: 0;\n    pointer-events: none;\n  }\n\n@media (min-width: 1000px) {\n\n.text-input--floating .text-input__label {\n      left: 20px;\n      width: calc(100% - 40px)\n  }\n    }\n\n.text-input--floating.is-active .text-input__label,\n  .text-input--floating.has-value .text-input__label {\n    top: 11px;\n    opacity: 0.6;\n    text-transform: capitalize;\n  }\n\n@media (min-width: 1000px) {\n\n.text-input--floating.is-active .text-input__label,\n  .text-input--floating.has-value .text-input__label {\n      font-size: 12px\n  }\n    }\n\n@media (min-width: 1000px) and (min-width: 1024px) {\n\n.text-input--floating.is-active .text-input__label,\n  .text-input--floating.has-value .text-input__label {\n    font-size: 13px\n  }\n  }\n\n.text-input--reverse:not(.text-input--newsletter-signup-banner-new).text-input--floating .text-input__label {\n    opacity: 0.8;\n  }\n\n.text-input--reverse:not(.text-input--newsletter-signup-banner-new).text-input--floating.is-active .text-input__label,\n  .text-input--reverse:not(.text-input--newsletter-signup-banner-new).text-input--floating.has-value .text-input__label {\n    opacity: 0.7;\n  }\n\n.text-input__error {\n  position: absolute;\n  left: 0;\n  top: 100%;\n  margin-top: 5px;\n  color: var(--red);\n  transition: opacity 300ms;\n}\n\n.text-input--reverse:not(.text-input--newsletter-signup-banner-new).has-error .text-input__error {\n    position: relative;\n    top: auto;\n    color: var(--white);\n  }\n\n.text-input--newsletter-signup-banner.has-error .text-input__error,\n  .text-input--newsletter-signup-banner-new.has-error .text-input__error,\n  .text-input--newsletter-modal.has-error .text-input__error {\n    color: var(--red);\n  }\n\n.text-input--newsletter-signup-banner-new.has-error .text-input__error {\n    position: static;\n  }\n\n.text-input--floating .text-input__wrapper {\n    position: relative;\n  }\n\n.tiktok-card {\n  overflow: hidden;\n  max-height: 650px;\n}\n\n.tiktok-card::before {\n    padding-bottom: calc(312 / 207 * 100%);\n  }\n\n@media (min-width: 768px) {\n\n.tiktok-card::before {\n      padding-bottom: calc(346 / 230 * 100%)\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.tiktok-card::before {\n      padding-bottom: calc(458 / 304 * 100%)\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.tiktok-card::before {\n      padding-bottom: calc(650 / 432 * 100%)\n  }\n    }\n\n.tiktok-carousel {\n  overflow: hidden;\n  padding: 30px 0 20px;\n  background-color: var(--ruby);\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.tiktok-carousel {\n    padding: 30px 0\n}\n  }\n\n@media (min-width: 1000px) {\n\n.tiktok-carousel {\n    padding: 40px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.tiktok-carousel {\n    padding: 50px 0\n}\n  }\n\n@media (min-width: 768px) {\n\n.tiktok-carousel__container {\n    display: flex\n}\n  }\n\n.tiktok-carousel__content {\n  position: relative;\n  z-index: 10;\n  margin-bottom: 20px;\n  padding-bottom: 103px;\n}\n\n@media (min-width: 768px) {\n\n.tiktok-carousel__content {\n    width: 33.757%;\n    margin-bottom: 0;\n    padding-right: 21px;\n    padding-bottom: 50px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.tiktok-carousel__content {\n    width: 33.9%;\n    padding-right: 23px\n}\n  }\n\n.tiktok-carousel__inner {\n  position: relative;\n  z-index: 15;\n}\n\n@media (min-width: 768px) {\n\n.tiktok-carousel__inner {\n    width: 66.243%\n}\n  }\n\n@media (min-width: 1000px) {\n\n.tiktok-carousel__inner {\n    width: 66.1%\n}\n  }\n\n.tiktok-carousel__list.swiper {\n  margin-right: calc(var(--gutter) * -1);\n  padding-right: var(--gutter);\n}\n\n@media (min-width: 768px) {\n\n.tiktok-carousel__list.swiper {\n    margin-right: calc(var(--gutter-tablet) * -1);\n    padding-right: var(--gutter-tablet)\n}\n  }\n\n@media (min-width: 1024px) {\n\n.tiktok-carousel__list.swiper {\n    margin-right: calc(var(--gutter-laptop) * -1);\n    padding-right: var(--gutter-laptop)\n}\n  }\n\n@media (min-width: 1440px) {\n\n.tiktok-carousel__list.swiper {\n    margin-right: calc(var(--gutter-desktop) * -1);\n    padding-right: var(--gutter-desktop)\n}\n  }\n\n@media (min-width: 1600px) {\n\n.tiktok-carousel__list.swiper {\n    margin-right: calc(var(--gutter-large-desktop) * -1);\n    padding-right: var(--gutter-large-desktop)\n}\n  }\n\n.tiktok-carousel__list.swiper .swiper-wrapper {\n    -webkit-transform-style: preserve-3d;\n  }\n\n.tiktok-carousel__list.swiper .swiper-slide {\n    -webkit-transform: translate3d(0, 0, 0);\n    -webkit-backface-visibility: hidden;\n    height: auto;\n  }\n\n.tiktok-carousel__navigation {\n  z-index: 10;\n  right: 23px;\n  bottom: 0;\n  left: 0;\n}\n\n.tiktok-carousel__navigation .swiper-button-prev,\n  .tiktok-carousel__navigation .swiper-button-next {\n    cursor: pointer;\n  }\n\n.tiktok-carousel__navigation .swiper-button-next {\n    margin-left: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.tiktok-carousel__navigation .swiper-button-next {\n      margin-left: 15px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.tiktok-carousel__navigation .swiper-button-next {\n      margin-left: 20px\n  }\n    }\n\n.tiktok-carousel__navigation .swiper-button-disabled {\n    opacity: 0.3;\n    pointer-events: none;\n  }\n\n.tiktok-carousel__label {\n  margin: 0 0 10px;\n}\n\n@media (min-width: 1000px) {\n\n.tiktok-carousel__label {\n    margin-bottom: 15px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.tiktok-carousel__label {\n    margin-bottom: 20px\n}\n  }\n\n.tiktok-carousel__title {\n  max-width: 387px;\n  margin: 0;\n}\n\n.value-props {\n  position: relative;\n  margin: 40px 0;\n}\n\n@media (min-width: 1000px) {\n\n.value-props {\n    margin-bottom: 60px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.value-props {\n    margin: 80px 0\n}\n  }\n\n.value-props__accent {\n  width: 27px;\n}\n\n@media (min-width: 1000px) {\n\n.value-props__accent {\n    width: 31px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.value-props__accent {\n    width: 39px\n}\n  }\n\n.value-props__accent::before {\n    padding-bottom: calc(97 / 39 * 100%);\n  }\n\n.value-props__header {\n  margin-bottom: 30px;\n}\n\n@media (min-width: 768px) {\n\n.value-props__header {\n    margin-bottom: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.value-props__header {\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.value-props__header {\n    margin-bottom: 60px\n}\n  }\n\n.value-props__title {\n  max-width: 182px;\n}\n\n@media (min-width: 1000px) {\n\n.value-props__title {\n    margin: 0 20px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.value-props__title {\n    max-width: 298px;\n    margin: 0 30px\n}\n  }\n\n.value-props__grid {\n  grid-gap: 30px;\n}\n\n@media (min-width: 768px) {\n\n.value-props__grid {\n    max-width: 914px;\n    grid-column-gap: 20px;\n    column-gap: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.value-props__grid {\n    grid-row-gap: 40px;\n    row-gap: 40px;\n    grid-column-gap: 22px;\n    column-gap: 22px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.value-props__grid {\n    max-width: 950px;\n    grid-gap: 60px 40px\n}\n  }\n\n.value-props__value-title {\n  margin-bottom: 5px;\n}\n\n.value-props__value-content {\n  margin: 0;\n  opacity: 0.6;\n}\n\n@media (min-width: 768px) {\n\n.value-props__value-content {\n    max-width: 210px;\n    margin-right: auto;\n    margin-left: auto\n}\n  }\n\n@media (min-width: 1000px) {\n\n.value-props__value-content {\n    max-width: none\n}\n  }\n\n.vertical-split-hero {\n  padding: 20px 0 30px;\n}\n\n@media (min-width: 768px) {\n\n.vertical-split-hero {\n    padding: 30px 0 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.vertical-split-hero {\n    padding-top: 40px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.vertical-split-hero {\n    padding: 50px 0 60px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.vertical-split-hero {\n    padding-top: 60px\n}\n  }\n\n.vertical-split-hero__featured {\n  position: relative;\n  height: 300px;\n  margin-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n\n.vertical-split-hero__featured {\n    height: 264px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.vertical-split-hero__featured {\n    height: 352px;\n    margin-bottom: 30px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.vertical-split-hero__featured {\n    height: 500px;\n    margin-bottom: 40px\n}\n  }\n\n@media (min-width: 768px) {\n\n.vertical-split-hero__inner {\n    display: flex\n}\n  }\n\n.vertical-split-hero__head {\n  margin-bottom: 5px;\n}\n\n@media (min-width: 768px) {\n\n.vertical-split-hero__head {\n    width: 50.8%;\n    margin-bottom: 0;\n    padding-right: 20px\n}\n  }\n\n@media (min-width: 768px) {\n\n.vertical-split-hero__content {\n    width: 49.2%\n}\n  }\n\n.vertical-split-hero__text {\n  margin: 0;\n}\n\n@media (min-width: 768px) {\n\n.vertical-split-hero__text {\n    margin-bottom: 10px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.vertical-split-hero__text {\n    max-width: 581px;\n    margin-bottom: 15px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.vertical-split-hero__text {\n    max-width: none\n}\n  }\n\n.vertical-split-hero__text p {\n    margin-bottom: 10px;\n  }\n\n.vertical-split-hero__buttons {\n  flex-direction: column;\n  align-items: flex-start;\n  display: flex;\n}\n\n@media (min-width: 768px) {\n\n.vertical-split-hero__buttons {\n    flex-direction: row;\n    align-items: center\n}\n  }\n\n.vertical-split-hero__button {\n  min-width: auto;\n  margin-top: 5px;\n}\n\n@media (min-width: 768px) {\n\n.vertical-split-hero__button {\n    margin-top: 0;\n    margin-right: 20px\n}\n  }\n\n.video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.video--testimonials {\n  position: relative;\n  height: auto;\n}\n\n.video__el {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  height: auto;\n  width: auto;\n  transform: translate(-50%, -50%);\n  transition: opacity var(--speed) var(--ease);\n  z-index: 1;\n}\n\n.video__el--is-vue {\n    opacity: 0;\n  }\n\n.video__el.is-loaded {\n    opacity: 1;\n  }\n\n.video--testimonials .video__el {\n    position: static;\n    width: 100%;\n    height: auto;\n    transform: none;\n  }\n\n.tiktok-carousel .video__el {\n    width: 100%;\n    height: 100%;\n    min-height: 440px;\n  }\n\n@media (min-width: 768px) {\n\n.tiktok-carousel .video__el {\n      min-height: 405px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.tiktok-carousel .video__el {\n      min-height: 540px\n  }\n    }\n\n@media (min-width: 1440px) {\n\n.tiktok-carousel .video__el {\n      min-height: 765px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.tiktok-carousel .video__el {\n      min-height: 855px\n  }\n    }\n\n@media (min-width: 1920px) {\n\n.tiktok-carousel .video__el {\n      min-height: 1040px\n  }\n    }\n\n.video--tiktok .video__el {\n    z-index: -1;\n  }\n\n.video__play-pause {\n  position: absolute;\n  right: 15px;\n  bottom: 15px;\n  z-index: 2;\n  display: none;\n  width: 20px;\n  height: 20px;\n  margin: 0;\n  background-color: transparent;\n  text-transform: uppercase;\n  color: var(--red);\n  cursor: pointer;\n}\n\n@media (min-width: 768px) {\n\n.video__play-pause {\n    right: 20px;\n    bottom: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.video__play-pause {\n    width: 30px;\n    height: 30px\n}\n  }\n\n.video__play-pause:not([disabled]):focus {\n    outline: 0.5px solid var(--black);\n    outline-offset: 3px;\n\n    outline-color: var(--white);\n  }\n\n.video__play-pause:not([disabled]):focus::before {\n      content: none;\n    }\n\nbody.user-is-tabbing .video__play-pause {\n    position: absolute;\n  }\n\n.video__play-pause .icon {\n    width: 100%;\n  }\n\n.video__play-pause .icon--play {\n    display: none;\n  }\n\n.video__play-pause .icon--pause {\n    display: block;\n  }\n\n.video__play-pause[data-playing=\"false\"] .icon--play {\n      display: block;\n    }\n\n.video__play-pause[data-playing=\"false\"] .icon--pause {\n      display: none;\n    }\n\n.video--hero .video__play-pause,\n  .video--content-image .video__play-pause,\n  .video--tiktok .video__play-pause,\n  .video--testimonials .video__play-pause {\n    display: block;\n  }\n\n.product-gallery__main .video__play-pause {\n    display: block;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    bottom: auto;\n    right: auto;\n  }\n\n.video--tiktok .video__play-pause {\n    right: 10px;\n    bottom: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.video--tiktok .video__play-pause {\n      right: 20px;\n      bottom: 20px;\n      width: 25px;\n      height: 25px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.video--tiktok .video__play-pause {\n      width: 30px;\n      height: 30px\n  }\n    }\n\n.video--content-image .video__play-pause {\n    right: 20px;\n    bottom: 20px;\n    width: 25px;\n    height: 25px;\n  }\n\n@media (min-width: 1000px) {\n\n.video--content-image .video__play-pause {\n      right: 30px;\n      bottom: 30px;\n      width: 35px;\n      height: 35px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.video--content-image .video__play-pause {\n      right: 40px;\n      bottom: 40px;\n      width: 40px;\n      height: 40px\n  }\n    }\n\n.video--hero .video__play-pause {\n    right: 20px;\n    bottom: 20px;\n    width: 25px;\n    height: 25px;\n  }\n\n@media (min-width: 768px) {\n\n.video--hero .video__play-pause {\n      right: 30px;\n      bottom: 30px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.video--hero .video__play-pause {\n      right: 40px;\n      bottom: 40px;\n      width: 35px;\n      height: 35px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.video--hero .video__play-pause {\n      right: 50px;\n      bottom: 50px;\n      width: 40px;\n      height: 40px\n  }\n    }\n\n@media (min-width: 1600px) {\n\n.video--hero .video__play-pause {\n      right: 60px;\n      bottom: 60px\n  }\n    }\n\n.video__el.is-loaded ~ .video__fallback-image {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n.video__mute {\n  position: absolute;\n  bottom: 15px;\n  left: 15px;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  margin: 0;\n  background-color: var(--red);\n  cursor: pointer;\n  text-transform: uppercase;\n  color: var(--white);\n}\n\n@media (min-width: 768px) {\n\n.video__mute {\n    bottom: 20px;\n    left: 20px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.video__mute {\n    width: 30px;\n    height: 30px\n}\n  }\n\n.video__mute svg {\n    width: 14px;\n    height: 14px;\n  }\n\n@media (min-width: 1000px) {\n\n.video__mute svg {\n      width: 18px;\n      height: 18px\n  }\n    }\n\n.video--tiktok .video__mute {\n    left: 10px;\n    bottom: 10px;\n  }\n\n@media (min-width: 1000px) {\n\n.video--tiktok .video__mute {\n      left: 20px;\n      bottom: 20px;\n      width: 25px;\n      height: 25px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.video--tiktok .video__mute {\n      width: 30px;\n      height: 30px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.video--tiktok .video__mute svg {\n        width: 15px;\n        height: 15px\n    }\n      }\n\n@media (min-width: 1240px) {\n\n.video--tiktok .video__mute svg {\n        width: 18px;\n        height: 18px\n    }\n      }\n\n.video--content-image .video__el {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n.video-embed {\n  position: relative;\n  width: 100%;\n  background-color: var(--black);\n}\n\n.featured-video .video-embed {\n    border-radius: 3px;\n    overflow: hidden;\n  }\n\n.featured-video .video-embed::before {\n      padding-bottom: calc(360 / 280 * 100%);\n    }\n\n@media (min-width: 768px) {\n\n.featured-video .video-embed::before {\n        padding-bottom: calc(627 / 1280 * 100%)\n    }\n      }\n\n.video-embed__content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.video--is-loaded .video-embed__content {\n    opacity: 1;\n    visibility: visible;\n  }\n\n.video-embed__placeholder {\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  transition-duration: var(--duration, 0.25s);\n  transition-property: opacity, visibility;\n  transition-timing-function: var(--ease, ease-in-out);\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.video-embed--has-played .video-embed__placeholder {\n    opacity: 0;\n    visibility: hidden;\n    pointer-events: none;\n  }\n\n.video-embed__play-button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  width: 56px;\n  height: 56px;\n  border-radius: 100%;\n  transform: translate3d(-50%, -50%, 0);\n  background-color: var(--white);\n  cursor: pointer;\n}\n\n@media (min-width: 768px) {\n\n.video-embed__play-button {\n    width: 43px;\n    height: 43px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.video-embed__play-button {\n    width: 59px;\n    height: 59px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.video-embed__play-button {\n    width: 80px;\n    height: 80px\n}\n  }\n\n.video-embed__play-button:not([disabled]):focus {\n    outline-color: var(--black);\n  }\n\n.video-embed__play-button::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    background-color: transparent;\n    border-top: 8px solid transparent;\n    border-right: 0;\n    border-bottom: 8px solid transparent;\n    border-left: 12px solid var(--red-wine);\n    transform: translate(-50%, -50%);\n    border-radius: 2px;\n  }\n\n@media (min-width: 1240px) {\n\n.video-embed__play-button::before {\n      border-top-width: 10px;\n      border-bottom-width: 10px;\n      border-left-width: 17px\n  }\n    }\n\n.video__loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  animation-name: shimmer;\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n  transition-duration: var(--duration, 0.25s);\n  transition-property: opacity, visibility;\n  transition-timing-function: var(--ease, ease-in-out);\n}\n\n.video--is-loaded .video__loader {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n.video-embed__iframe,\n.video-embed__iframe iframe {\n  width: 100%;\n  height: 100%;\n}\n\n/**\n  * Scoped as many editors will not support adding\n  * class names to tags. All typographic styles\n  * should be maintained in the typography css lib.\n  **/\n\n.wysiwyg h1 {\n    font-size: 24px;\n    line-height: 1.2;\n    font-family: var(--serif);\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg h1 {\n    font-size: 32px;\n  }\n  }\n\n@media (min-width: 1440px) {\n\n.wysiwyg h1 {\n    font-size: 40px;\n  }\n  }\n\n.wysiwyg h2 {\n    font-size: 21px;\n    line-height: 1.2;\n    font-family: var(--serif);\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg h2 {\n    font-size: 26px;\n  }\n  }\n\n@media (min-width: 1440px) {\n\n.wysiwyg h2 {\n    font-size: 32px;\n  }\n  }\n\n.wysiwyg h3 {\n    font-size: 18px;\n    line-height: 1.2;\n    font-family: var(--serif);\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg h3 {\n    font-size: 20px;\n  }\n  }\n\n@media (min-width: 1440px) {\n\n.wysiwyg h3 {\n    font-size: 24px;\n  }\n  }\n\n.wysiwyg h4,\n  .wysiwyg h5,\n  .wysiwyg h6 {\n    font-size: 16px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg h4,\n  .wysiwyg h5,\n  .wysiwyg h6 {\n    font-size: 18px;\n  }\n  }\n\n@media (min-width: 1440px) {\n\n.wysiwyg h4,\n  .wysiwyg h5,\n  .wysiwyg h6 {\n    font-size: 20px;\n    line-height: 1.1;\n  }\n  }\n\n.wysiwyg h1,\n  .wysiwyg h2,\n  .wysiwyg h3,\n  .wysiwyg h4,\n  .wysiwyg h5,\n  .wysiwyg h6 {\n    margin-bottom: 10px;\n  }\n\n.wysiwyg h1:not(:first-child), .wysiwyg h2:not(:first-child), .wysiwyg h3:not(:first-child), .wysiwyg h4:not(:first-child), .wysiwyg h5:not(:first-child), .wysiwyg h6:not(:first-child) {\n      margin-top: 30px;\n    }\n\n@media (min-width: 1000px) {\n\n.wysiwyg h1:not(:first-child), .wysiwyg h2:not(:first-child), .wysiwyg h3:not(:first-child), .wysiwyg h4:not(:first-child), .wysiwyg h5:not(:first-child), .wysiwyg h6:not(:first-child) {\n        margin-top: 40px\n    }\n      }\n\n.wysiwyg p {\n    font-size: 14px;\n    line-height: 1.3;\n    font-family: var(--sans-serif);\n\n    margin-bottom: 15px;\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg p {\n    font-size: 17px\n  }\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg p {\n      margin-bottom: 20px\n  }\n    }\n\n.wysiwyg ol {\n    font-size: 14px;\n    line-height: 1.3;\n    font-family: var(--sans-serif);\n\n    list-style: decimal inside;\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg ol {\n    font-size: 17px;\n  }\n  }\n\n.wysiwyg ul {\n    font-size: 14px;\n    line-height: 1.3;\n    font-family: var(--sans-serif);\n\n    list-style: none;\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg ul {\n    font-size: 17px\n  }\n  }\n\n.wysiwyg ul li::before {\n        content: '•';\n        margin-right: 0.25em;\n      }\n\n.wysiwyg ol,\n  .wysiwyg ul {\n    margin: 0 0 30px;\n  }\n\n@media (min-width: 1240px) {\n\n.wysiwyg ol,\n  .wysiwyg ul {\n      margin-bottom: 40px\n  }\n    }\n\n.wysiwyg blockquote {\n    position: relative;\n    margin: 30px 0;\n    padding: 26px 0 0;\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg blockquote {\n      margin: 40px 0;\n      padding-top: 45px\n  }\n    }\n\n.wysiwyg blockquote::before {\n      content: '';\n      position: absolute;\n      z-index: 1;\n      top: 0;\n      left: 50%;\n      transform: translate3d(-50%, 0, 0);\n      width: 16px;\n      height: 11px;\n      background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='15' fill='none'%3E%3Cpath d='M14.048 7.023c.277-2.864 2.353-4.91 5.952-5.455V0c-6.02.545-9.273 4.364-9.273 9.34 0 3.274 1.66 5.66 4.636 5.66 2.422 0 4.36-1.636 4.36-4.16 0-2.18-1.453-3.476-3.183-3.817h-2.492Zm-10.726 0c.277-2.864 2.353-4.91 5.951-5.455V0C3.253.545 0 4.364 0 9.34 0 12.615 1.66 15 4.637 15c2.422 0 4.36-1.636 4.36-4.16 0-2.18-1.454-3.476-3.184-3.817H3.322Z' fill='%23DA2924'/%3E%3C/svg%3E\") no-repeat center / contain;\n    }\n\n@media (min-width: 1000px) {\n\n.wysiwyg blockquote::before {\n        width: 20px;\n        height: 15px\n    }\n      }\n\n.wysiwyg blockquote > * {\n      margin-bottom: 5px;\n    }\n\n@media (min-width: 768px) {\n\n.wysiwyg blockquote > * {\n        margin-bottom: 10px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.wysiwyg blockquote > * {\n        margin-bottom: 15px\n    }\n      }\n\n.wysiwyg blockquote > *:last-child:not(:first-child) {\n        color: var(--black-o-50);\n      }\n\n.wysiwyg img {\n    max-width: 100%;\n    vertical-align: middle;\n  }\n\n.wysiwyg hr {\n    border-color: var(--border-color-grey);\n\n    margin: 25px 0 20px;\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg hr {\n      margin: 30px 0\n  }\n    }\n\n.wysiwyg a {\n    position: relative;\n    display: inline-block;\n    color: var(--black);\n    text-decoration: none;\n    cursor: pointer;\n    border-bottom: 1px solid var(--red);\n  }\n\n.wysiwyg a::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    transform: scaleX(0);\n    transform-origin: 0 0;\n    background: var(--red);\n  }\n\n.wysiwyg a:hover {\n    border-color: transparent;\n  }\n\n.wysiwyg a:hover::after {\n      transition: all 0.7s 0.1s ease;\n      transform: scaleX(1);\n    }\n\n.wysiwyg a.logo,\n  .wysiwyg a.icon {\n    border-bottom: none;\n  }\n\n.wysiwyg a.logo::after, .wysiwyg a.icon::after {\n      content: none;\n    }\n\n.wysiwyg a[disabled] {\n    display: none;\n  }\n\n.wysiwyg i,\n  .wysiwyg em {\n    font-style: italic;\n  }\n\n.wysiwyg b,\n  .wysiwyg strong {\n    font-weight: 700;\n  }\n\n.wysiwyg .label {\n    font-size: 12px;\n    line-height: 1.25;\n    letter-spacing: 1px;\n    font-family: var(--sans-serif);\n\n    text-transform: uppercase;\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg .label {\n    font-size: 14px;\n  }\n  }\n\n.wysiwyg__inner > *:first-child {\n  margin-top: 0;\n}\n\n.wysiwyg__inner > *:last-child {\n  margin-bottom: 0;\n}\n\n.wysiwyg--basic {\n  padding: 30px 0 40px;\n}\n\n@media (min-width: 768px) {\n\n.wysiwyg--basic {\n    padding-top: 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--basic {\n    padding: 60px 0\n}\n  }\n\n@media (min-width: 1240px) {\n\n.wysiwyg--basic {\n    padding: 80px 0\n}\n  }\n\n@media (min-width: 1600px) {\n\n.wysiwyg--basic {\n    padding: 100px 0\n}\n  }\n\n.wysiwyg--basic .wysiwyg__inner {\n    margin: 0 auto;\n  }\n\n@media (min-width: 768px) {\n\n.wysiwyg--basic .wysiwyg__inner {\n      max-width: 588px;\n      padding: 0 50px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--basic .wysiwyg__inner {\n      max-width: 784px;\n      padding: 0 65px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.wysiwyg--basic .wysiwyg__inner {\n      max-width: 886px;\n      padding: 0 93px\n  }\n    }\n\n.wysiwyg--basic .wysiwyg__image-wrapper {\n    margin: 30px 0;\n    text-align: center;\n  }\n\n@media (min-width: 768px) {\n\n.wysiwyg--basic .wysiwyg__image-wrapper {\n      margin-right: -50px;\n      margin-left: -50px\n  }\n    }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--basic .wysiwyg__image-wrapper {\n      margin: 40px -65px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.wysiwyg--basic .wysiwyg__image-wrapper {\n      margin-right: -93px;\n      margin-left: -93px\n  }\n    }\n\n.wysiwyg--basic .img-caption {\n    margin-bottom: 30px;\n    color: var(--black-o-50);\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--basic .img-caption {\n      margin-bottom: 40px\n  }\n    }\n\n.wysiwyg--basic .img-caption .wysiwyg__image-wrapper {\n      margin-bottom: 10px;\n    }\n\n@media (min-width: 1240px) {\n\n.wysiwyg--basic .img-caption .wysiwyg__image-wrapper {\n        margin-bottom: 20px\n    }\n      }\n\n.wysiwyg--basic .img-caption br {\n      display: none;\n    }\n\n.wysiwyg--basic .button {\n    min-width: auto;\n  }\n\n.wysiwyg--basic table tr {\n    border-top: 0;\n  }\n\n.wysiwyg--basic table tr th,\n    .wysiwyg--basic table tr td {\n      display: table-cell;\n      text-align: left;\n    }\n\n@media (max-width: 767px) {\n\n.wysiwyg--basic table tr th,\n    .wysiwyg--basic table tr td {\n        padding: 16px 11px\n    }\n      }\n\n@media (max-width: 767px) {\n\n.wysiwyg--basic table tr th:first-child,\n    .wysiwyg--basic table tr td:first-child {\n        max-width: 80px;\n        word-wrap: break-word\n    }\n      }\n\n@media (max-width: 767px) {\n\n.wysiwyg--basic table tr th:last-child,\n    .wysiwyg--basic table tr td:last-child {\n        max-width: 58px;\n        word-wrap: break-word;\n        padding: 16px 6px\n    }\n      }\n\n.wysiwyg--store-locator {\n  padding: 30px 0 32px;\n}\n\n@media (min-width: 1000px) {\n\n.wysiwyg--store-locator {\n    padding-top: 40px;\n    padding-bottom: 42px\n}\n  }\n\n@media (min-width: 1240px) {\n\n.wysiwyg--store-locator {\n    padding-top: 60px;\n    padding-bottom: 64px\n}\n  }\n\n@media (min-width: 1600px) {\n\n.wysiwyg--store-locator {\n    padding-top: 80px\n}\n  }\n\n.wysiwyg--store-locator h1 {\n    margin-bottom: 0;\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--store-locator h1 {\n      margin-bottom: 5px\n  }\n    }\n\n.wysiwyg--store-locator p {\n    font-size: 15px;\n    line-height: 1.2;\n    font-family: var(--sans-serif);\n\n    max-width: 404px;\n    margin: 0 auto 20px;\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--store-locator p {\n      max-width: 468px\n  }\n    }\n\n@media (min-width: 1240px) {\n\n.wysiwyg--store-locator p {\n      margin-bottom: 40px\n  }\n    }\n\n.wysiwyg--store-locator .wysiwyg__container {\n    max-width: none;\n  }\n\n.wysiwyg--article {\n  padding-bottom: 30px;\n}\n\n@media (min-width: 768px) {\n\n.wysiwyg--article {\n    padding-top: 40px\n}\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--article {\n    padding: 80px 0 40px\n}\n  }\n\n.wysiwyg--article .shop-the-recipe {\n    margin: 30px 0;\n    padding: 20px;\n    background-color: var(--sage);\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--article .shop-the-recipe {\n      margin: 40px 0;\n      padding: 30px\n  }\n    }\n\n.wysiwyg--article .shop-the-recipe::after {\n      content: '';\n      display: block;\n      clear: both;\n    }\n\n.wysiwyg--article .shop-the-recipe h4 {\n\n      margin: 0 0 5px;\n    }\n\n@media (min-width: 1024px) {\n\n.wysiwyg--article .shop-the-recipe h4 {\n    font-size: 20px;\n    line-height: 1.1\n    }\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--article .shop-the-recipe h4 {\n        margin-bottom: 8px\n    }\n      }\n\n.wysiwyg--article .shop-the-recipe p {\n      margin: 0 0 15px;\n    }\n\n@media (min-width: 768px) {\n\n.wysiwyg--article .shop-the-recipe p {\n        margin-bottom: 10px\n    }\n      }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--article .shop-the-recipe p {\n        margin-bottom: 15px\n    }\n      }\n\n.wysiwyg--article .shop-the-recipe p:not(.label) {\n      font-size: 15px;\n      line-height: 1.2;\n      font-family: var(--sans-serif);\n    }\n\n.wysiwyg--article .shop-the-recipe p:last-of-type::after {\n      content: '';\n      display: block;\n      clear: both;\n    }\n\n@media (min-width: 445px) {\n\n.wysiwyg--article .shop-the-recipe p:last-of-type::after {\n        content: none\n    }\n      }\n\n.wysiwyg--article .shop-the-recipe hr {\n      margin: 15px 0;\n      background-color: var(--black);\n    }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--article .shop-the-recipe hr {\n        margin-bottom: 20px\n    }\n      }\n\n.wysiwyg--article .shop-the-recipe .wysiwyg__image-wrapper {\n      float: left;\n      max-width: 100px;\n      margin: 0 10px 0 0;\n      text-align: left;\n      width: 100%;\n      height: 100%;\n    }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--article .shop-the-recipe .wysiwyg__image-wrapper {\n        max-width: 133px;\n        margin-right: 20px\n    }\n      }\n\n.wysiwyg--article .wysiwyg__image-caption {\n    font-size: 14px;\n    line-height: 1.3;\n    font-family: var(--sans-serif);\n\n    display: block;\n    margin-top: 10px;\n    text-align: center;\n    opacity: 0.5;\n  }\n\n@media (min-width: 1024px) {\n\n.wysiwyg--article .wysiwyg__image-caption {\n    font-size: 17px\n  }\n  }\n\n@media (min-width: 1000px) {\n\n.wysiwyg--article .wysiwyg__image-caption {\n      margin-top: 20px\n  }\n    }\n\n.wysiwyg--article-event blockquote p {\n      font-size: 21px;\n      line-height: 1.2;\n      font-family: var(--serif);\n\n      text-align: center;\n    }\n\n@media (min-width: 1024px) {\n\n.wysiwyg--article-event blockquote p {\n    font-size: 26px;\n    }\n  }\n\n@media (min-width: 1440px) {\n\n.wysiwyg--article-event blockquote p {\n    font-size: 32px;\n    }\n  }\n\n.wysiwyg--article-event blockquote p + p {\n      font-size: 14px;\n      line-height: 1.3;\n      font-family: var(--sans-serif);\n\n      opacity: 0.5;\n    }\n\n@media (min-width: 1024px) {\n\n.wysiwyg--article-event blockquote p + p {\n    font-size: 17px;\n    }\n  }\n\n.wysiwyg--article-event .wysiwyg__image-wrapper {\n    position: relative;\n    aspect-ratio: 886/664;\n  }\n\n.zoom-on-hover {\n  overflow: visible !important;\n  text-align: center;\n}\n\n.product-gallery__main .zoom-on-hover .normal {\n    width: auto !important;\n    max-width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n@media (min-width: 1440px) {\n\n.product-gallery__main .zoom-on-hover .normal {\n      width: 100% !important\n  }\n    }\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./src/modules/availability-callout/availability-callout.css":
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./src/modules/availability-callout/availability-callout.css ***!
  \*****************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.i, "\n\n.availability-callout {\n  background: var(--availability-callout-bg, var(--celadon));\n  color: var(--availability-callout-color, var(--pine));\n  padding: 20px;\n}\n\n.availability-callout__title {\n  margin: 0 0 10px;\n  font-family: var(--sans-serif);\n  font-size: 14px;\n  line-height: 1.25;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: inherit;\n}\n\n@media (--s-max) {\n\n.availability-callout__title {\n    font-size: 12px !important\n}\n  }\n\n.availability-callout__text {\n  font-family: var(--sans-serif);\n  font-size: 13px;\n  line-height: 1.2;\n  color: inherit;\n}\n\n.availability-callout__text p {\n    margin: 0;\n    color: inherit;\n  }\n\n.availability-callout__text a {\n    color: inherit;\n  }\n\n@media (--m) {\n\n.availability-callout__text {\n    font-size: 15px !important\n}\n  }\n\n.cart-grid__availability-callout--sidebar {\n  display: none;\n}\n\n@media (--s) {\n\n.cart-grid--default .cart-grid__availability-callout--sidebar {\n      display: block !important;\n      margin-bottom: 30px !important\n  }\n    }\n\n@media (--m) {\n\n.cart-grid--default .cart-grid__availability-callout--sidebar {\n      margin-bottom: 40px !important\n  }\n    }\n\n.cart-grid--default .cart-grid__availability-callout--items {\n    display: block;\n    margin: 30px 0;\n  }\n\n@media (--s) {\n\n.cart-grid--default .cart-grid__availability-callout--items {\n      display: none !important\n  }\n    }\n\n.cart-grid--mini-cart .cart-grid__availability-callout--items {\n    flex-shrink: 0;\n    margin: 20px 0;\n  }\n\n@media (--m) {\n\n.cart-grid--mini-cart .cart-grid__availability-callout--items {\n      margin: 30px 0 !important\n  }\n    }\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/runtime/api.js":
/*!*****************************************************!*\
  !*** ./node_modules/css-loader/dist/runtime/api.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names

module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join("");
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === "string") {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, ""]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ "./node_modules/dom-event/index.js":
/*!*****************************************!*\
  !*** ./node_modules/dom-event/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = on;
module.exports.on = on;
module.exports.off = off;

function on(element, event, callback, capture) {
  !element.addEventListener && (event = 'on' + event);
  (element.addEventListener || element.attachEvent).call(element, event, callback, capture);
  return callback;
}

function off(element, event, callback, capture) {
  !element.removeEventListener && (event = 'on' + event);
  (element.removeEventListener || element.detachEvent).call(element, event, callback, capture);
  return callback;
}

/***/ }),

/***/ "./node_modules/dom7/dom7.esm.js":
/*!***************************************!*\
  !*** ./node_modules/dom7/dom7.esm.js ***!
  \***************************************/
/*! exports provided: default, $, add, addClass, animate, animationEnd, append, appendTo, attr, blur, change, children, click, closest, css, data, dataset, detach, each, empty, eq, filter, find, focus, focusin, focusout, hasClass, height, hide, html, index, insertAfter, insertBefore, is, keydown, keypress, keyup, mousedown, mouseenter, mouseleave, mousemove, mouseout, mouseover, mouseup, next, nextAll, off, offset, on, once, outerHeight, outerWidth, parent, parents, prepend, prependTo, prev, prevAll, prop, remove, removeAttr, removeClass, removeData, resize, scroll, scrollLeft, scrollTo, scrollTop, show, siblings, stop, styles, submit, text, toggleClass, touchend, touchmove, touchstart, transform, transition, transitionEnd, trigger, val, value, width */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$", function() { return $; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "add", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addClass", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animate", function() { return animate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animationEnd", function() { return animationEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "append", function() { return append; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendTo", function() { return appendTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attr", function() { return attr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blur", function() { return blur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "change", function() { return change; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "children", function() { return children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "click", function() { return click; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closest", function() { return closest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "data", function() { return data; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dataset", function() { return dataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detach", function() { return detach; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "each", function() { return each; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eq", function() { return eq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focus", function() { return focus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focusin", function() { return focusin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focusout", function() { return focusout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasClass", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "height", function() { return height; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hide", function() { return hide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "html", function() { return html; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "index", function() { return index; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insertAfter", function() { return insertAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insertBefore", function() { return insertBefore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keydown", function() { return keydown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keypress", function() { return keypress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyup", function() { return keyup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mousedown", function() { return mousedown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouseenter", function() { return mouseenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouseleave", function() { return mouseleave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mousemove", function() { return mousemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouseout", function() { return mouseout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouseover", function() { return mouseover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouseup", function() { return mouseup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "next", function() { return next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextAll", function() { return nextAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offset", function() { return offset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "once", function() { return once; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "outerHeight", function() { return outerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "outerWidth", function() { return outerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parent", function() { return parent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parents", function() { return parents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepend", function() { return prepend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prependTo", function() { return prependTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prev", function() { return prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevAll", function() { return prevAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prop", function() { return prop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeAttr", function() { return removeAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeClass", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeData", function() { return removeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resize", function() { return resize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scroll", function() { return scroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollLeft", function() { return scrollLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollTo", function() { return scrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollTop", function() { return scrollTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "show", function() { return show; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "siblings", function() { return siblings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stop", function() { return stop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "styles", function() { return styles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submit", function() { return submit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleClass", function() { return toggleClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "touchend", function() { return touchend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "touchmove", function() { return touchmove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "touchstart", function() { return touchstart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transform", function() { return transform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transitionEnd", function() { return transitionEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trigger", function() { return trigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "val", function() { return val; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "value", function() { return value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "width", function() { return width; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/**
 * Dom7 4.0.4
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2022, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: January 11, 2022
 */

/* eslint-disable no-proto */

function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get() {
      return proto;
    },

    set(value) {
      proto.__proto__ = value;
    }

  });
}

class Dom7 extends Array {
  constructor(items) {
    if (typeof items === 'number') {
      super(items);
    } else {
      super(...(items || []));
      makeReactive(this);
    }
  }

}

function arrayFlat(arr = []) {
  var res = [];
  arr.forEach(el => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}

function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}

function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}

function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, (match, group) => group.toUpperCase());
} // eslint-disable-next-line


function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var _html = selector.trim();

    if (_html.indexOf('<') >= 0 && _html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (_html.indexOf('<li') === 0) toCreate = 'ul';
      if (_html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (_html.indexOf('<td') === 0 || _html.indexOf('<th') === 0) toCreate = 'tr';
      if (_html.indexOf('<tbody') === 0) toCreate = 'table';
      if (_html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = _html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype; // eslint-disable-next-line

function addClass(...classes) {
  var classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.add(...classNames);
  });
  return this;
}

function removeClass(...classes) {
  var classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.remove(...classNames);
  });
  return this;
}

function toggleClass(...classes) {
  var classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    classNames.forEach(className => {
      el.classList.toggle(className);
    });
  });
}

function hasClass(...classes) {
  var classNames = arrayFlat(classes.map(c => c.split(' ')));
  return arrayFilter(this, el => {
    return classNames.filter(className => el.classList.contains(className)).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (var propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  var el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    var dataKey = el.getAttribute("data-".concat(key));

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (var i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  var el = this[0];
  if (!el) return undefined;
  var dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (var dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (var i = 0; i < el.attributes.length; i += 1) {
      var _attr = el.attributes[i];

      if (_attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
      }
    }
  }

  for (var key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    var el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      var values = [];

      for (var i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (var _i = 0; _i < this.length; _i += 1) {
    var _el = this[_i];

    if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
      for (var j = 0; j < _el.options.length; j += 1) {
        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
      }
    } else {
      _el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? "".concat(duration, "ms") : duration;
  }

  return this;
}

function on(...args) {
  var [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off(...args) {
  var [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once(...args) {
  var dom = this;
  var [eventName, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventName, listener, capture] = args;
    targetSelector = undefined;
  }

  function onceHandler(...eventArgs) {
    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function trigger(...args) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
    var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;

    var _scrollTop = el === window ? window.scrollY : el.scrollTop;

    var _scrollLeft = el === window ? window.scrollX : el.scrollLeft;

    return {
      top: box.top + _scrollTop - clientTop,
      left: box.left + _scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function styles() {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach((el, index) => {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append(...els) {
  var newChild;
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();

  for (var k = 0; k < els.length; k += 1) {
    newChild = els[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  $(parent).append(this);
  return this;
}

function prepend(newChild) {
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  var before = $(selector);

  for (var i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (var j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  var after = $(selector);

  for (var i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (var j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add(...els) {
  var dom = this;
  var i;
  var j;

  for (i = 0; i < els.length; i += 1) {
    var toAdd = $(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.nodeType === 1) {
      for (var j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
} // eslint-disable-next-line


function scrollTo(...args) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var [left, top, duration, easing, callback] = args;

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    [left, top, duration, callback, easing] = args;
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    var el = this;
    var currentTop;
    var currentLeft;
    var maxTop;
    var maxLeft;
    var newTop;
    var newLeft;
    var scrollTop; // eslint-disable-line

    var scrollLeft; // eslint-disable-line

    var animateTop = top > 0 || top === 0;
    var animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    var startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time = new Date().getTime()) {
      if (startTime === null) {
        startTime = time;
      }

      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      var done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop(...args) {
  var [top, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [top, duration, callback, easing] = args;
  }

  var dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft(...args) {
  var [left, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [left, duration, callback, easing] = args;
  }

  var dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
} // eslint-disable-next-line


function animate(initialProps, initialParams) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var els = this;
  var a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],

    easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },

    stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(el => {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },

    done(complete) {
      a.animating = false;
      a.elements.each(el => {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        var que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },

    animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      var elements = []; // Define & Cache Initials & Units

      a.elements.each((el, index) => {
        var initialFullValue;
        var initialValue;
        var unit;
        var finalValue;
        var finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(prop => {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue,
            initialValue,
            unit,
            finalValue,
            finalFullValue,
            currentValue: initialValue
          };
        });
      });
      var startTime = null;
      var time;
      var elementsDone = 0;
      var propsDone = 0;
      var done;
      var began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        var progress;
        var easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(element => {
          var el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(prop => {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            var {
              initialValue,
              finalValue,
              unit
            } = el[prop];
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            var currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }

  };

  if (a.elements.length === 0) {
    return els;
  }

  var animateInstance;

  for (var i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  var els = this;

  for (var i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

var noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler(...args) {
    if (typeof args[0] === 'undefined') {
      for (var i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            $(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on(name, ...args);
  }

  return eventHandler;
}

var click = shortcut('click');
var blur = shortcut('blur');
var focus = shortcut('focus');
var focusin = shortcut('focusin');
var focusout = shortcut('focusout');
var keyup = shortcut('keyup');
var keydown = shortcut('keydown');
var keypress = shortcut('keypress');
var submit = shortcut('submit');
var change = shortcut('change');
var mousedown = shortcut('mousedown');
var mousemove = shortcut('mousemove');
var mouseup = shortcut('mouseup');
var mouseenter = shortcut('mouseenter');
var mouseleave = shortcut('mouseleave');
var mouseout = shortcut('mouseout');
var mouseover = shortcut('mouseover');
var touchstart = shortcut('touchstart');
var touchend = shortcut('touchend');
var touchmove = shortcut('touchmove');
var resize = shortcut('resize');
var scroll = shortcut('scroll');
/* harmony default export */ __webpack_exports__["default"] = ($);


/***/ }),

/***/ "./node_modules/enquire.js/src/MediaQuery.js":
/*!***************************************************!*\
  !*** ./node_modules/enquire.js/src/MediaQuery.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(/*! ./QueryHandler */ "./node_modules/enquire.js/src/QueryHandler.js");

var each = __webpack_require__(/*! ./Util */ "./node_modules/enquire.js/src/Util.js").each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */


function MediaQuery(query, isUnconditional) {
  this.query = query;
  this.isUnconditional = isUnconditional;
  this.handlers = [];
  this.mql = window.matchMedia(query);
  var self = this;

  this.listener = function (mql) {
    // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
    self.mql = mql.currentTarget || mql;
    self.assess();
  };

  this.mql.addListener(this.listener);
}

MediaQuery.prototype = {
  constuctor: MediaQuery,

  /**
   * add a handler for this query, triggering if already active
   *
   * @param {object} handler
   * @param {function} handler.match callback for when query is activated
   * @param {function} [handler.unmatch] callback for when query is deactivated
   * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
   * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
   */
  addHandler: function (handler) {
    var qh = new QueryHandler(handler);
    this.handlers.push(qh);
    this.matches() && qh.on();
  },

  /**
   * removes the given handler from the collection, and calls it's destroy methods
   *
   * @param {object || function} handler the handler to remove
   */
  removeHandler: function (handler) {
    var handlers = this.handlers;
    each(handlers, function (h, i) {
      if (h.equals(handler)) {
        h.destroy();
        return !handlers.splice(i, 1); //remove from array and exit each early
      }
    });
  },

  /**
   * Determine whether the media query should be considered a match
   *
   * @return {Boolean} true if media query can be considered a match, false otherwise
   */
  matches: function () {
    return this.mql.matches || this.isUnconditional;
  },

  /**
   * Clears all handlers and unbinds events
   */
  clear: function () {
    each(this.handlers, function (handler) {
      handler.destroy();
    });
    this.mql.removeListener(this.listener);
    this.handlers.length = 0; //clear array
  },

  /*
      * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
      */
  assess: function () {
    var action = this.matches() ? 'on' : 'off';
    each(this.handlers, function (handler) {
      handler[action]();
    });
  }
};
module.exports = MediaQuery;

/***/ }),

/***/ "./node_modules/enquire.js/src/MediaQueryDispatch.js":
/*!***********************************************************!*\
  !*** ./node_modules/enquire.js/src/MediaQueryDispatch.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(/*! ./MediaQuery */ "./node_modules/enquire.js/src/MediaQuery.js");

var Util = __webpack_require__(/*! ./Util */ "./node_modules/enquire.js/src/Util.js");

var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */

function MediaQueryDispatch() {
  if (!window.matchMedia) {
    throw new Error('matchMedia not present, legacy browsers require a polyfill');
  }

  this.queries = {};
  this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {
  constructor: MediaQueryDispatch,

  /**
   * Registers a handler for the given media query
   *
   * @param {string} q the media query
   * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
   * @param {function} options.match fired when query matched
   * @param {function} [options.unmatch] fired when a query is no longer matched
   * @param {function} [options.setup] fired when handler first triggered
   * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
   * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
   */
  register: function (q, options, shouldDegrade) {
    var queries = this.queries,
        isUnconditional = shouldDegrade && this.browserIsIncapable;

    if (!queries[q]) {
      queries[q] = new MediaQuery(q, isUnconditional);
    } //normalise to object in an array


    if (isFunction(options)) {
      options = {
        match: options
      };
    }

    if (!isArray(options)) {
      options = [options];
    }

    each(options, function (handler) {
      if (isFunction(handler)) {
        handler = {
          match: handler
        };
      }

      queries[q].addHandler(handler);
    });
    return this;
  },

  /**
   * unregisters a query and all it's handlers, or a specific handler for a query
   *
   * @param {string} q the media query to target
   * @param {object || function} [handler] specific handler to unregister
   */
  unregister: function (q, handler) {
    var query = this.queries[q];

    if (query) {
      if (handler) {
        query.removeHandler(handler);
      } else {
        query.clear();
        delete this.queries[q];
      }
    }

    return this;
  }
};
module.exports = MediaQueryDispatch;

/***/ }),

/***/ "./node_modules/enquire.js/src/QueryHandler.js":
/*!*****************************************************!*\
  !*** ./node_modules/enquire.js/src/QueryHandler.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
  this.options = options;
  !options.deferSetup && this.setup();
}

QueryHandler.prototype = {
  constructor: QueryHandler,

  /**
   * coordinates setup of the handler
   *
   * @function
   */
  setup: function () {
    if (this.options.setup) {
      this.options.setup();
    }

    this.initialised = true;
  },

  /**
   * coordinates setup and triggering of the handler
   *
   * @function
   */
  on: function () {
    !this.initialised && this.setup();
    this.options.match && this.options.match();
  },

  /**
   * coordinates the unmatch event for the handler
   *
   * @function
   */
  off: function () {
    this.options.unmatch && this.options.unmatch();
  },

  /**
   * called when a handler is to be destroyed.
   * delegates to the destroy or unmatch callbacks, depending on availability.
   *
   * @function
   */
  destroy: function () {
    this.options.destroy ? this.options.destroy() : this.off();
  },

  /**
   * determines equality by reference.
   * if object is supplied compare options, if function, compare match callback
   *
   * @function
   * @param {object || function} [target] the target for comparison
   */
  equals: function (target) {
    return this.options === target || this.options.match === target;
  }
};
module.exports = QueryHandler;

/***/ }),

/***/ "./node_modules/enquire.js/src/Util.js":
/*!*********************************************!*\
  !*** ./node_modules/enquire.js/src/Util.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
  var i = 0,
      length = collection.length,
      cont;

  for (i; i < length; i++) {
    cont = fn(collection[i], i);

    if (cont === false) {
      break; //allow early exit
    }
  }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */


function isArray(target) {
  return Object.prototype.toString.apply(target) === '[object Array]';
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */


function isFunction(target) {
  return typeof target === 'function';
}

module.exports = {
  isFunction: isFunction,
  isArray: isArray,
  each: each
};

/***/ }),

/***/ "./node_modules/enquire.js/src/index.js":
/*!**********************************************!*\
  !*** ./node_modules/enquire.js/src/index.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(/*! ./MediaQueryDispatch */ "./node_modules/enquire.js/src/MediaQueryDispatch.js");

module.exports = new MediaQueryDispatch();

/***/ }),

/***/ "./node_modules/in-viewport/in-viewport.js":
/*!*************************************************!*\
  !*** ./node_modules/in-viewport/in-viewport.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = inViewport;
var instances = [];
var supportsMutationObserver = typeof global.MutationObserver === 'function';

function inViewport(elt, params, cb) {
  var opts = {
    container: global.document.body,
    offset: 0,
    debounce: 15,
    failsafe: 150
  };

  if (params === undefined || typeof params === 'function') {
    cb = params;
    params = {};
  }

  var container = opts.container = params.container || opts.container;
  var offset = opts.offset = params.offset || opts.offset;
  var debounceValue = opts.debounce = params.debounce || opts.debounce;
  var failsafe = opts.failsafe = params.failsafe || opts.failsafe; // ensure backward compatibility with failsafe as boolean

  if (failsafe === true) {
    failsafe = 150;
  } else if (failsafe === false) {
    failsafe = 0;
  } // failsafe check always needs to be higher than debounceValue


  if (failsafe > 0 && failsafe < debounceValue) {
    failsafe = debounceValue + 50;
  }

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].container === container && instances[i]._debounce === debounceValue && instances[i]._failsafe === failsafe) {
      return instances[i].isInViewport(elt, offset, cb);
    }
  }

  return instances[instances.push(createInViewport(container, debounceValue, failsafe)) - 1].isInViewport(elt, offset, cb);
}

function addEvent(el, type, fn) {
  if (el.attachEvent) {
    el.attachEvent('on' + type, fn);
  } else {
    el.addEventListener(type, fn, false);
  }
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);

    function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }
  };
} // https://github.com/jquery/sizzle/blob/3136f48b90e3edc84cbaaa6f6f7734ef03775a07/sizzle.js#L708


var contains = function () {
  if (!global.document) {
    return true;
  }

  return global.document.documentElement.compareDocumentPosition ? function (a, b) {
    return !!(a.compareDocumentPosition(b) & 16);
  } : global.document.documentElement.contains ? function (a, b) {
    return a !== b && (a.contains ? a.contains(b) : false);
  } : function (a, b) {
    while (b = b.parentNode) {
      if (b === a) {
        return true;
      }
    }

    return false;
  };
};

function createInViewport(container, debounceValue, failsafe) {
  var watches = createWatches();
  var scrollContainer = container === global.document.body ? global : container;
  var debouncedCheck = debounce(watches.checkAll(watchInViewport), debounceValue);
  addEvent(scrollContainer, 'scroll', debouncedCheck);

  if (scrollContainer === global) {
    addEvent(global, 'resize', debouncedCheck);
  }

  if (supportsMutationObserver) {
    observeDOM(watches, container, debouncedCheck);
  } // failsafe check, every X we check for visible images
  // usecase: a hidden parent containing eleements
  // when the parent becomes visible, we have no event that the children
  // became visible


  if (failsafe > 0) {
    setInterval(debouncedCheck, failsafe);
  }

  function isInViewport(elt, offset, cb) {
    if (!cb) {
      return isVisible(elt, offset);
    }

    var remote = createRemote(elt, offset, cb);
    remote.watch();
    return remote;
  }

  function createRemote(elt, offset, cb) {
    function watch() {
      watches.add(elt, offset, cb);
    }

    function dispose() {
      watches.remove(elt);
    }

    return {
      watch: watch,
      dispose: dispose
    };
  }

  function watchInViewport(elt, offset, cb) {
    if (isVisible(elt, offset)) {
      watches.remove(elt);
      cb(elt);
    }
  }

  function isVisible(elt, offset) {
    if (!elt) {
      return false;
    }

    if (!contains(global.document.documentElement, elt) || !contains(global.document.documentElement, container)) {
      return false;
    } // Check if the element is visible
    // https://github.com/jquery/jquery/blob/740e190223d19a114d5373758127285d14d6b71e/src/css/hiddenVisibleSelectors.js


    if (!elt.offsetWidth || !elt.offsetHeight) {
      return false;
    }

    var eltRect = elt.getBoundingClientRect();
    var viewport = {};

    if (container === global.document.body) {
      viewport = {
        top: -offset,
        left: -offset,
        right: global.document.documentElement.clientWidth + offset,
        bottom: global.document.documentElement.clientHeight + offset
      };
    } else {
      var containerRect = container.getBoundingClientRect();
      viewport = {
        top: containerRect.top - offset,
        left: containerRect.left - offset,
        right: containerRect.right + offset,
        bottom: containerRect.bottom + offset
      };
    } // The element must overlap with the visible part of the viewport


    var visible = eltRect.right >= viewport.left && eltRect.left <= viewport.right && eltRect.bottom >= viewport.top && eltRect.top <= viewport.bottom;
    return visible;
  }

  return {
    container: container,
    isInViewport: isInViewport,
    _debounce: debounceValue,
    _failsafe: failsafe
  };
}

function createWatches() {
  var watches = [];

  function add(elt, offset, cb) {
    if (!isWatched(elt)) {
      watches.push([elt, offset, cb]);
    }
  }

  function remove(elt) {
    var pos = indexOf(elt);

    if (pos !== -1) {
      watches.splice(pos, 1);
    }
  }

  function indexOf(elt) {
    for (var i = watches.length - 1; i >= 0; i--) {
      if (watches[i][0] === elt) {
        return i;
      }
    }

    return -1;
  }

  function isWatched(elt) {
    return indexOf(elt) !== -1;
  }

  function checkAll(cb) {
    return function () {
      for (var i = watches.length - 1; i >= 0; i--) {
        cb.apply(this, watches[i]);
      }
    };
  }

  return {
    add: add,
    remove: remove,
    isWatched: isWatched,
    checkAll: checkAll
  };
}

function observeDOM(watches, container, cb) {
  var observer = new MutationObserver(watch);
  var filter = Array.prototype.filter;
  var concat = Array.prototype.concat;
  observer.observe(container, {
    childList: true,
    subtree: true,
    // changes like style/width/height/display will be catched
    attributes: true
  });

  function watch(mutations) {
    // some new DOM nodes where previously watched
    // we should check their positions
    if (mutations.some(knownNodes) === true) {
      setTimeout(cb, 0);
    }
  }

  function knownNodes(mutation) {
    var nodes = concat.call([], Array.prototype.slice.call(mutation.addedNodes), mutation.target);
    return filter.call(nodes, watches.isWatched).length > 0;
  }
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/intersection-observer/intersection-observer.js":
/*!*********************************************************************!*\
  !*** ./node_modules/intersection-observer/intersection-observer.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function () {
  'use strict'; // Exit early if we're not running in a browser.

  if (typeof window !== 'object') {
    return;
  } // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.


  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function () {
          return this.intersectionRatio > 0;
        }
      });
    }

    return;
  }
  /**
   * Returns the embedding frame element, if any.
   * @param {!Document} doc
   * @return {!Element}
   */


  function getFrameElement(doc) {
    try {
      return doc.defaultView && doc.defaultView.frameElement || null;
    } catch (e) {
      // Ignore the error.
      return null;
    }
  }
  /**
   * A local reference to the root document.
   */


  var document = function (startDoc) {
    var doc = startDoc;
    var frame = getFrameElement(doc);

    while (frame) {
      doc = frame.ownerDocument;
      frame = getFrameElement(doc);
    }

    return doc;
  }(window.document);
  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observing a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */


  var registry = [];
  /**
   * The signal updater for cross-origin intersection. When not null, it means
   * that the polyfill is configured to work in a cross-origin mode.
   * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */

  var crossOriginUpdater = null;
  /**
   * The current cross-origin intersection. Only used in the cross-origin mode.
   * @type {DOMRect|ClientRect}
   */

  var crossOriginRect = null;
  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */

  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = ensureDOMRect(entry.rootBounds);
    this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
    this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
    this.isIntersecting = !!entry.intersectionRect; // Calculates the intersection ratio.

    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height; // Sets intersection ratio.

    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }
  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */


  function IntersectionObserver(callback, opt_options) {
    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) {
      throw new Error('root must be a Document or Element');
    } // Binds and throttles `this._checkForIntersections`.


    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT); // Private properties.

    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin); // Public properties.

    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
    /** @private @const {!Array<!Document>} */

    this._monitoringDocuments = [];
    /** @private @const {!Array<function()>} */

    this._monitoringUnsubscribes = [];
  }
  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */


  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */

  IntersectionObserver.prototype.POLL_INTERVAL = null;
  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */

  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
  /**
   * Sets up the polyfill in the cross-origin mode. The result is the
   * updater function that accepts two arguments: `boundingClientRect` and
   * `intersectionRect` - just as these fields would be available to the
   * parent via `IntersectionObserverEntry`. This function should be called
   * each time the iframe receives intersection information from the parent
   * window, e.g. via messaging.
   * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */

  IntersectionObserver._setupCrossOriginUpdater = function () {
    if (!crossOriginUpdater) {
      /**
       * @param {DOMRect|ClientRect} boundingClientRect
       * @param {DOMRect|ClientRect} intersectionRect
       */
      crossOriginUpdater = function (boundingClientRect, intersectionRect) {
        if (!boundingClientRect || !intersectionRect) {
          crossOriginRect = getEmptyRect();
        } else {
          crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
        }

        registry.forEach(function (observer) {
          observer._checkForIntersections();
        });
      };
    }

    return crossOriginUpdater;
  };
  /**
   * Resets the cross-origin mode.
   */


  IntersectionObserver._resetCrossOriginUpdater = function () {
    crossOriginUpdater = null;
    crossOriginRect = null;
  };
  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();

    this._observationTargets.push({
      element: target,
      entry: null
    });

    this._monitorIntersections(target.ownerDocument);

    this._checkForIntersections();
  };
  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });

    this._unmonitorIntersections(target.ownerDocument);

    if (this._observationTargets.length == 0) {
      this._unregisterInstance();
    }
  };
  /**
   * Stops observing all target elements for intersection changes.
   */


  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];

    this._unmonitorAllIntersections();

    this._unregisterInstance();
  };
  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */


  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();

    this._queuedEntries = [];
    return records;
  };
  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */


  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];
    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }

      return t !== a[i - 1];
    });
  };
  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */


  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);

      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }

      return {
        value: parseFloat(parts[1]),
        unit: parts[2]
      };
    }); // Handles shorthand.

    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };
  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._monitorIntersections = function (doc) {
    var win = doc.defaultView;

    if (!win) {
      // Already destroyed.
      return;
    }

    if (this._monitoringDocuments.indexOf(doc) != -1) {
      // Already monitoring.
      return;
    } // Private state for monitoring.


    var callback = this._checkForIntersections;
    var monitoringInterval = null;
    var domObserver = null; // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.

    if (this.POLL_INTERVAL) {
      monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
    } else {
      addEvent(win, 'resize', callback, true);
      addEvent(doc, 'scroll', callback, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
        domObserver = new win.MutationObserver(callback);
        domObserver.observe(doc, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    this._monitoringDocuments.push(doc);

    this._monitoringUnsubscribes.push(function () {
      // Get the window object again. When a friendly iframe is destroyed, it
      // will be null.
      var win = doc.defaultView;

      if (win) {
        if (monitoringInterval) {
          win.clearInterval(monitoringInterval);
        }

        removeEvent(win, 'resize', callback, true);
      }

      removeEvent(doc, 'scroll', callback, true);

      if (domObserver) {
        domObserver.disconnect();
      }
    }); // Also monitor the parent.


    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;

    if (doc != rootDoc) {
      var frame = getFrameElement(doc);

      if (frame) {
        this._monitorIntersections(frame.ownerDocument);
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
    var index = this._monitoringDocuments.indexOf(doc);

    if (index == -1) {
      return;
    }

    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document; // Check if any dependent targets are still remaining.

    var hasDependentTargets = this._observationTargets.some(function (item) {
      var itemDoc = item.element.ownerDocument; // Target is in this context.

      if (itemDoc == doc) {
        return true;
      } // Target is nested in this context.


      while (itemDoc && itemDoc != rootDoc) {
        var frame = getFrameElement(itemDoc);
        itemDoc = frame && frame.ownerDocument;

        if (itemDoc == doc) {
          return true;
        }
      }

      return false;
    });

    if (hasDependentTargets) {
      return;
    } // Unsubscribe.


    var unsubscribe = this._monitoringUnsubscribes[index];

    this._monitoringDocuments.splice(index, 1);

    this._monitoringUnsubscribes.splice(index, 1);

    unsubscribe(); // Also unmonitor the parent.

    if (doc != rootDoc) {
      var frame = getFrameElement(doc);

      if (frame) {
        this._unmonitorIntersections(frame.ownerDocument);
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._unmonitorAllIntersections = function () {
    var unsubscribes = this._monitoringUnsubscribes.slice(0);

    this._monitoringDocuments.length = 0;
    this._monitoringUnsubscribes.length = 0;

    for (var i = 0; i < unsubscribes.length; i++) {
      unsubscribes[i]();
    }
  };
  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */


  IntersectionObserver.prototype._checkForIntersections = function () {
    if (!this.root && crossOriginUpdater && !crossOriginRect) {
      // Cross origin monitoring, but no initial data available yet.
      return;
    }

    var rootIsInDom = this._rootIsInDom();

    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);

      var rootContainsTarget = this._rootContainsTarget(target);

      var oldEntry = item.entry;

      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);

      var rootBounds = null;

      if (!this._rootContainsTarget(target)) {
        rootBounds = getEmptyRect();
      } else if (!crossOriginUpdater || this.root) {
        rootBounds = rootRect;
      }

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootBounds,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };
  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} targetRect The bounding rect of the target.
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */


  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot && parent) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {}; // If the parent isn't displayed, an intersection can't happen.

      if (parentComputedStyle.display == 'none') return null;

      if (parent == this.root || parent.nodeType ==
      /* DOCUMENT */
      9) {
        atRoot = true;

        if (parent == this.root || parent == document) {
          if (crossOriginUpdater && !this.root) {
            if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
              // A 0-size cross-origin intersection means no-intersection.
              parent = null;
              parentRect = null;
              intersectionRect = null;
            } else {
              parentRect = crossOriginRect;
            }
          } else {
            parentRect = rootRect;
          }
        } else {
          // Check if there's a frame that can be navigated to.
          var frame = getParentNode(parent);
          var frameRect = frame && getBoundingClientRect(frame);

          var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);

          if (frameRect && frameIntersect) {
            parent = frame;
            parentRect = convertFromParentRect(frameRect, frameIntersect);
          } else {
            parent = null;
            intersectionRect = null;
          }
        }
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        var doc = parent.ownerDocument;

        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      } // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.


      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
      }

      if (!intersectionRect) break;
      parent = parent && getParentNode(parent);
    }

    return intersectionRect;
  };
  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {ClientRect} The expanded root rect.
   * @private
   */


  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;

    if (this.root && !isDoc(this.root)) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var doc = isDoc(this.root) ? this.root : document;
      var html = doc.documentElement;
      var body = doc.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }

    return this._expandRectByRootMargin(rootRect);
  };
  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {DOMRect|ClientRect} rect The rect object to expand.
   * @return {ClientRect} The expanded rect.
   * @private
   */


  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });

    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };
  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */


  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1; // Ignore unchanged ratios

    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i]; // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.

      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };
  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */


  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };
  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */


  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
    return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
  };
  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */


  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };
  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */


  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };
  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */


  function now() {
    return window.performance && performance.now && performance.now();
  }
  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */


  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }
  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */


  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }
  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */


  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }
  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object|?ClientRect} The intersection rect or undefined if no
   *     intersection is found.
   */


  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    } || null;
  }
  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
   */


  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {// Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect(); // Older IE

    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }

    return rect;
  }
  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {ClientRect} The empty rect.
   */


  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  /**
   * Ensure that the result has all of the necessary fields of the DOMRect.
   * Specifically this ensures that `x` and `y` fields are set.
   *
   * @param {?DOMRect|?ClientRect} rect
   * @return {?DOMRect}
   */


  function ensureDOMRect(rect) {
    // A `DOMRect` object has `x` and `y` fields.
    if (!rect || 'x' in rect) {
      return rect;
    } // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
    // for internally calculated Rect objects. For the purposes of
    // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
    // for these fields.


    return {
      top: rect.top,
      y: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      x: rect.left,
      right: rect.right,
      width: rect.width,
      height: rect.height
    };
  }
  /**
   * Inverts the intersection and bounding rect from the parent (frame) BCR to
   * the local BCR space.
   * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
   * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
   * @return {ClientRect} The local root bounding rect for the parent's children.
   */


  function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
    var top = parentIntersectionRect.top - parentBoundingRect.top;
    var left = parentIntersectionRect.left - parentBoundingRect.left;
    return {
      top: top,
      left: left,
      height: parentIntersectionRect.height,
      width: parentIntersectionRect.width,
      bottom: top + parentIntersectionRect.height,
      right: left + parentIntersectionRect.width
    };
  }
  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */


  function containsDeep(parent, child) {
    var node = child;

    while (node) {
      if (node == parent) return true;
      node = getParentNode(node);
    }

    return false;
  }
  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */


  function getParentNode(node) {
    var parent = node.parentNode;

    if (node.nodeType ==
    /* DOCUMENT */
    9 && node != document) {
      // If this node is a document node, look for the embedding frame.
      return getFrameElement(node);
    } // If the parent has element that is assigned through shadow root slot


    if (parent && parent.assignedSlot) {
      parent = parent.assignedSlot.parentNode;
    }

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    return parent;
  }
  /**
   * Returns true if `node` is a Document.
   * @param {!Node} node
   * @returns {boolean}
   */


  function isDoc(node) {
    return node && node.nodeType === 9;
  } // Exposes the constructors globally.


  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

/***/ }),

/***/ "./node_modules/lodash/_DataView.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_DataView.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");
/* Built-in method references that are verified to be native. */


var DataView = getNative(root, 'DataView');
module.exports = DataView;

/***/ }),

/***/ "./node_modules/lodash/_Map.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/_Map.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");
/* Built-in method references that are verified to be native. */


var Map = getNative(root, 'Map');
module.exports = Map;

/***/ }),

/***/ "./node_modules/lodash/_Promise.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_Promise.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");
/* Built-in method references that are verified to be native. */


var Promise = getNative(root, 'Promise');
module.exports = Promise;

/***/ }),

/***/ "./node_modules/lodash/_Set.js":
/*!*************************************!*\
  !*** ./node_modules/lodash/_Set.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");
/* Built-in method references that are verified to be native. */


var Set = getNative(root, 'Set');
module.exports = Set;

/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/_Symbol.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");
/** Built-in value references. */


var Symbol = root.Symbol;
module.exports = Symbol;

/***/ }),

/***/ "./node_modules/lodash/_WeakMap.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_WeakMap.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(/*! ./_getNative */ "./node_modules/lodash/_getNative.js"),
    root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");
/* Built-in method references that are verified to be native. */


var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseGetTag.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__(/*! ./_getRawTag */ "./node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__(/*! ./_objectToString */ "./node_modules/lodash/_objectToString.js");
/** `Object#toString` result references. */


var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),

/***/ "./node_modules/lodash/_baseIsArguments.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseIsArguments.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");
/** `Object#toString` result references. */


var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),

/***/ "./node_modules/lodash/_baseIsNative.js":
/*!**********************************************!*\
  !*** ./node_modules/lodash/_baseIsNative.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(/*! ./isFunction */ "./node_modules/lodash/isFunction.js"),
    isMasked = __webpack_require__(/*! ./_isMasked */ "./node_modules/lodash/_isMasked.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    toSource = __webpack_require__(/*! ./_toSource */ "./node_modules/lodash/_toSource.js");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */


var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),

/***/ "./node_modules/lodash/_baseIsTypedArray.js":
/*!**************************************************!*\
  !*** ./node_modules/lodash/_baseIsTypedArray.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isLength = __webpack_require__(/*! ./isLength */ "./node_modules/lodash/isLength.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");
/** `Object#toString` result references. */


var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),

/***/ "./node_modules/lodash/_baseKeys.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseKeys.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(/*! ./_isPrototype */ "./node_modules/lodash/_isPrototype.js"),
    nativeKeys = __webpack_require__(/*! ./_nativeKeys */ "./node_modules/lodash/_nativeKeys.js");
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

module.exports = baseKeys;

/***/ }),

/***/ "./node_modules/lodash/_baseRange.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseRange.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */

function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }

  return result;
}

module.exports = baseRange;

/***/ }),

/***/ "./node_modules/lodash/_baseTrim.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseTrim.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(/*! ./_trimmedEndIndex */ "./node_modules/lodash/_trimmedEndIndex.js");
/** Used to match leading whitespace. */


var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

module.exports = baseTrim;

/***/ }),

/***/ "./node_modules/lodash/_baseUnary.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseUnary.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),

/***/ "./node_modules/lodash/_coreJsData.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_coreJsData.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");
/** Used to detect overreaching core-js shims. */


var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

/***/ }),

/***/ "./node_modules/lodash/_createRange.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_createRange.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(/*! ./_baseRange */ "./node_modules/lodash/_baseRange.js"),
    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ "./node_modules/lodash/_isIterateeCall.js"),
    toFinite = __webpack_require__(/*! ./toFinite */ "./node_modules/lodash/toFinite.js");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */


function createRange(fromRight) {
  return function (start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    } // Ensure the sign of `-0` is preserved.


    start = toFinite(start);

    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }

    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;

/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_freeGlobal.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_getNative.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_getNative.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(/*! ./_baseIsNative */ "./node_modules/lodash/_baseIsNative.js"),
    getValue = __webpack_require__(/*! ./_getValue */ "./node_modules/lodash/_getValue.js");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/_getRawTag.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(/*! ./_Symbol */ "./node_modules/lodash/_Symbol.js");
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

module.exports = getRawTag;

/***/ }),

/***/ "./node_modules/lodash/_getTag.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/_getTag.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(/*! ./_DataView */ "./node_modules/lodash/_DataView.js"),
    Map = __webpack_require__(/*! ./_Map */ "./node_modules/lodash/_Map.js"),
    Promise = __webpack_require__(/*! ./_Promise */ "./node_modules/lodash/_Promise.js"),
    Set = __webpack_require__(/*! ./_Set */ "./node_modules/lodash/_Set.js"),
    WeakMap = __webpack_require__(/*! ./_WeakMap */ "./node_modules/lodash/_WeakMap.js"),
    baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    toSource = __webpack_require__(/*! ./_toSource */ "./node_modules/lodash/_toSource.js");
/** `Object#toString` result references. */


var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function (value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;

        case mapCtorString:
          return mapTag;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag;

        case weakMapCtorString:
          return weakMapTag;
      }
    }

    return result;
  };
}

module.exports = getTag;

/***/ }),

/***/ "./node_modules/lodash/_getValue.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_getValue.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),

/***/ "./node_modules/lodash/_isIndex.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_isIndex.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),

/***/ "./node_modules/lodash/_isIterateeCall.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_isIterateeCall.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js"),
    isIndex = __webpack_require__(/*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */


function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }

  var type = typeof index;

  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }

  return false;
}

module.exports = isIterateeCall;

/***/ }),

/***/ "./node_modules/lodash/_isMasked.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_isMasked.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(/*! ./_coreJsData */ "./node_modules/lodash/_coreJsData.js");
/** Used to detect methods masquerading as native. */


var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),

/***/ "./node_modules/lodash/_isPrototype.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/_isPrototype.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
  return value === proto;
}

module.exports = isPrototype;

/***/ }),

/***/ "./node_modules/lodash/_nativeKeys.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/_nativeKeys.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(/*! ./_overArg */ "./node_modules/lodash/_overArg.js");
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

/***/ }),

/***/ "./node_modules/lodash/_nodeUtil.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_nodeUtil.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ "./node_modules/lodash/_freeGlobal.js");
/** Detect free variable `exports`. */


var freeExports =  true && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/*!************************************************!*\
  !*** ./node_modules/lodash/_objectToString.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),

/***/ "./node_modules/lodash/_overArg.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/_overArg.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),

/***/ "./node_modules/lodash/_root.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/_root.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(/*! ./_freeGlobal */ "./node_modules/lodash/_freeGlobal.js");
/** Detect free variable `self`. */


var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

/***/ }),

/***/ "./node_modules/lodash/_toSource.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/_toSource.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

module.exports = toSource;

/***/ }),

/***/ "./node_modules/lodash/_trimmedEndIndex.js":
/*!*************************************************!*\
  !*** ./node_modules/lodash/_trimmedEndIndex.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */

function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}

  return index;
}

module.exports = trimmedEndIndex;

/***/ }),

/***/ "./node_modules/lodash/debounce.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/debounce.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    now = __webpack_require__(/*! ./now */ "./node_modules/lodash/now.js"),
    toNumber = __webpack_require__(/*! ./toNumber */ "./node_modules/lodash/toNumber.js");
/** Error message constants. */


var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max,
    nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */

function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  wait = toNumber(wait) || 0;

  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

/***/ }),

/***/ "./node_modules/lodash/eq.js":
/*!***********************************!*\
  !*** ./node_modules/lodash/eq.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),

/***/ "./node_modules/lodash/isArguments.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/isArguments.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(/*! ./_baseIsArguments */ "./node_modules/lodash/_baseIsArguments.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

/***/ }),

/***/ "./node_modules/lodash/isArray.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/isArray.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
module.exports = isArray;

/***/ }),

/***/ "./node_modules/lodash/isArrayLike.js":
/*!********************************************!*\
  !*** ./node_modules/lodash/isArrayLike.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(/*! ./isFunction */ "./node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__(/*! ./isLength */ "./node_modules/lodash/isLength.js");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */


function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),

/***/ "./node_modules/lodash/isBuffer.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isBuffer.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js"),
    stubFalse = __webpack_require__(/*! ./stubFalse */ "./node_modules/lodash/stubFalse.js");
/** Detect free variable `exports`. */


var freeExports =  true && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/isEmpty.js":
/*!****************************************!*\
  !*** ./node_modules/lodash/isEmpty.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(/*! ./_baseKeys */ "./node_modules/lodash/_baseKeys.js"),
    getTag = __webpack_require__(/*! ./_getTag */ "./node_modules/lodash/_getTag.js"),
    isArguments = __webpack_require__(/*! ./isArguments */ "./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__(/*! ./isArray */ "./node_modules/lodash/isArray.js"),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js"),
    isBuffer = __webpack_require__(/*! ./isBuffer */ "./node_modules/lodash/isBuffer.js"),
    isPrototype = __webpack_require__(/*! ./_isPrototype */ "./node_modules/lodash/_isPrototype.js"),
    isTypedArray = __webpack_require__(/*! ./isTypedArray */ "./node_modules/lodash/isTypedArray.js");
/** `Object#toString` result references. */


var mapTag = '[object Map]',
    setTag = '[object Set]';
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */

function isEmpty(value) {
  if (value == null) {
    return true;
  }

  if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }

  var tag = getTag(value);

  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }

  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }

  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }

  return true;
}

module.exports = isEmpty;

/***/ }),

/***/ "./node_modules/lodash/isFunction.js":
/*!*******************************************!*\
  !*** ./node_modules/lodash/isFunction.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js");
/** `Object#toString` result references. */


var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),

/***/ "./node_modules/lodash/isLength.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isLength.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isObject.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/isObjectLike.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/isSymbol.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(/*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__(/*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js");
/** `Object#toString` result references. */


var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),

/***/ "./node_modules/lodash/isTypedArray.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash/isTypedArray.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(/*! ./_baseIsTypedArray */ "./node_modules/lodash/_baseIsTypedArray.js"),
    baseUnary = __webpack_require__(/*! ./_baseUnary */ "./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__(/*! ./_nodeUtil */ "./node_modules/lodash/_nodeUtil.js");
/* Node.js helper references. */


var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

/***/ }),

/***/ "./node_modules/lodash/now.js":
/*!************************************!*\
  !*** ./node_modules/lodash/now.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ "./node_modules/lodash/_root.js");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */


var now = function () {
  return root.Date.now();
};

module.exports = now;

/***/ }),

/***/ "./node_modules/lodash/range.js":
/*!**************************************!*\
  !*** ./node_modules/lodash/range.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(/*! ./_createRange */ "./node_modules/lodash/_createRange.js");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */


var range = createRange();
module.exports = range;

/***/ }),

/***/ "./node_modules/lodash/stubFalse.js":
/*!******************************************!*\
  !*** ./node_modules/lodash/stubFalse.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),

/***/ "./node_modules/lodash/toFinite.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/toFinite.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(/*! ./toNumber */ "./node_modules/lodash/toNumber.js");
/** Used as references for various `Number` constants. */


var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */

function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }

  value = toNumber(value);

  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }

  return value === value ? value : 0;
}

module.exports = toFinite;

/***/ }),

/***/ "./node_modules/lodash/toNumber.js":
/*!*****************************************!*\
  !*** ./node_modules/lodash/toNumber.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(/*! ./_baseTrim */ "./node_modules/lodash/_baseTrim.js"),
    isObject = __webpack_require__(/*! ./isObject */ "./node_modules/lodash/isObject.js"),
    isSymbol = __webpack_require__(/*! ./isSymbol */ "./node_modules/lodash/isSymbol.js");
/** Used as references for various `Number` constants. */


var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol(value)) {
    return NAN;
  }

  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),

/***/ "./node_modules/nanoajax/index.js":
/*!****************************************!*\
  !*** ./node_modules/nanoajax/index.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Best place to find information on XHR features is:
// https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
var reqfields = ['responseType', 'withCredentials', 'timeout', 'onprogress']; // Simple and small ajax function
// Takes a parameters object and a callback function
// Parameters:
//  - url: string, required
//  - headers: object of `{header_name: header_value, ...}`
//  - body:
//      + string (sets content type to 'application/x-www-form-urlencoded' if not set in headers)
//      + FormData (doesn't set content type so that browser will set as appropriate)
//  - method: 'GET', 'POST', etc. Defaults to 'GET' or 'POST' based on body
//  - cors: If your using cross-origin, you will need this true for IE8-9
//
// The following parameters are passed onto the xhr object.
// IMPORTANT NOTE: The caller is responsible for compatibility checking.
//  - responseType: string, various compatability, see xhr docs for enum options
//  - withCredentials: boolean, IE10+, CORS only
//  - timeout: long, ms timeout, IE8+
//  - onprogress: callback, IE10+
//
// Callback function prototype:
//  - statusCode from request
//  - response
//    + if responseType set and supported by browser, this is an object of some type (see docs)
//    + otherwise if request completed, this is the string text of the response
//    + if request is aborted, this is "Abort"
//    + if request times out, this is "Timeout"
//    + if request errors before completing (probably a CORS issue), this is "Error"
//  - request object
//
// Returns the request object. So you can call .abort() or other methods
//
// DEPRECATIONS:
//  - Passing a string instead of the params object has been removed!
//

exports.ajax = function (params, callback) {
  // Any variable used more than once is var'd here because
  // minification will munge the variables whereas it can't munge
  // the object access.
  var headers = params.headers || {},
      body = params.body,
      method = params.method || (body ? 'POST' : 'GET'),
      called = false;
  var req = getRequest(params.cors);

  function cb(statusCode, responseText) {
    return function () {
      if (!called) {
        callback(req.status === undefined ? statusCode : req.status, req.status === 0 ? "Error" : req.response || req.responseText || responseText, req);
        called = true;
      }
    };
  }

  req.open(method, params.url, true);
  var success = req.onload = cb(200);

  req.onreadystatechange = function () {
    if (req.readyState === 4) success();
  };

  req.onerror = cb(null, 'Error');
  req.ontimeout = cb(null, 'Timeout');
  req.onabort = cb(null, 'Abort');

  if (body) {
    setDefault(headers, 'X-Requested-With', 'XMLHttpRequest');

    if (!global.FormData || !(body instanceof global.FormData)) {
      setDefault(headers, 'Content-Type', 'application/x-www-form-urlencoded');
    }
  }

  for (var i = 0, len = reqfields.length, field; i < len; i++) {
    field = reqfields[i];
    if (params[field] !== undefined) req[field] = params[field];
  }

  for (var field in headers) {
    req.setRequestHeader(field, headers[field]);
  }

  req.send(body);
  return req;
};

function getRequest(cors) {
  // XDomainRequest is only way to do CORS in IE 8 and 9
  // But XDomainRequest isn't standards-compatible
  // Notably, it doesn't allow cookies to be sent or set by servers
  // IE 10+ is standards-compatible in its XMLHttpRequest
  // but IE 10 can still have an XDomainRequest object, so we don't want to use it
  if (cors && global.XDomainRequest && !/MSIE 1/.test(navigator.userAgent)) return new XDomainRequest();
  if (global.XMLHttpRequest) return new XMLHttpRequest();
}

function setDefault(obj, key, value) {
  obj[key] = obj[key] || value;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/object-assign/index.js":
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/***/ }),

/***/ "./node_modules/object-fit-images/dist/ofi.common-js.js":
/*!**************************************************************!*\
  !*** ./node_modules/object-fit-images/dist/ofi.common-js.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.4 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {
  style: {
    'object-position': 1
  }
} : new Image();
var supportsObjectFit = ('object-fit' in testImg.style);
var supportsObjectPosition = ('object-position' in testImg.style);
var supportsOFI = ('background-size' in testImg.style);
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}

function polyfillCurrentSrc(el) {
  if (el.srcset && !supportsCurrentSrc && window.picturefill) {
    var pf = window.picturefill._; // parse srcset with picturefill where currentSrc isn't available

    if (!el[pf.ns] || !el[pf.ns].evaled) {
      // force synchronous srcset parsing
      pf.fillImg(el, {
        reselect: true
      });
    }

    if (!el[pf.ns].curSrc) {
      // force picturefill to parse srcset
      el[pf.ns].supported = false;
      pf.fillImg(el, {
        reselect: true
      });
    } // retrieve parsed currentSrc, if any


    el.currentSrc = el[pf.ns].curSrc || el.src;
  }
}

function getStyle(el) {
  var style = getComputedStyle(el).fontFamily;
  var parsed;
  var props = {};

  while ((parsed = propRegex.exec(style)) !== null) {
    props[parsed[1]] = parsed[2];
  }

  return props;
}

function setPlaceholder(img, width, height) {
  // Default: fill width, no height
  var placeholder = createPlaceholder(width || 1, height || 0); // Only set placeholder if it's different

  if (nativeGetAttribute.call(img, 'src') !== placeholder) {
    nativeSetAttribute.call(img, 'src', placeholder);
  }
}

function onImageReady(img, callback) {
  // naturalWidth is only available when the image headers are loaded,
  // this loop will poll it every 100ms.
  if (img.naturalWidth) {
    callback(img);
  } else {
    setTimeout(onImageReady, 100, img, callback);
  }
}

function fixOne(el) {
  var style = getStyle(el);
  var ofi = el[OFI];
  style['object-fit'] = style['object-fit'] || 'fill'; // default value
  // Avoid running where unnecessary, unless OFI had already done its deed

  if (!ofi.img) {
    // fill is the default behavior so no action is necessary
    if (style['object-fit'] === 'fill') {
      return;
    } // Where object-fit is supported and object-position isn't (Safari < 10)


    if (!ofi.skipTest && // unless user wants to apply regardless of browser support
    supportsObjectFit && // if browser already supports object-fit
    !style['object-position'] // unless object-position is used
    ) {
        return;
      }
  } // keep a clone in memory while resetting the original to a blank


  if (!ofi.img) {
    ofi.img = new Image(el.width, el.height);
    ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
    ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src; // preserve for any future cloneNode calls
    // https://github.com/bfred-it/object-fit-images/issues/53

    nativeSetAttribute.call(el, "data-ofi-src", el.src);

    if (el.srcset) {
      nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
    }

    setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height); // remove srcset because it overrides src

    if (el.srcset) {
      el.srcset = '';
    }

    try {
      keepSrcUsable(el);
    } catch (err) {
      if (window.console) {
        console.warn('https://bit.ly/ofi-old-browser');
      }
    }
  }

  polyfillCurrentSrc(ofi.img);
  el.style.backgroundImage = "url(\"" + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + "\")";
  el.style.backgroundPosition = style['object-position'] || 'center';
  el.style.backgroundRepeat = 'no-repeat';
  el.style.backgroundOrigin = 'content-box';

  if (/scale-down/.test(style['object-fit'])) {
    onImageReady(ofi.img, function () {
      if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
        el.style.backgroundSize = 'contain';
      } else {
        el.style.backgroundSize = 'auto';
      }
    });
  } else {
    el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
  }

  onImageReady(ofi.img, function (img) {
    setPlaceholder(el, img.naturalWidth, img.naturalHeight);
  });
}

function keepSrcUsable(el) {
  var descriptors = {
    get: function get(prop) {
      return el[OFI].img[prop ? prop : 'src'];
    },
    set: function set(value, prop) {
      el[OFI].img[prop ? prop : 'src'] = value;
      nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode

      fixOne(el);
      return value;
    }
  };
  Object.defineProperty(el, 'src', descriptors);
  Object.defineProperty(el, 'currentSrc', {
    get: function () {
      return descriptors.get('currentSrc');
    }
  });
  Object.defineProperty(el, 'srcset', {
    get: function () {
      return descriptors.get('srcset');
    },
    set: function (ss) {
      return descriptors.set(ss, 'srcset');
    }
  });
}

function hijackAttributes() {
  function getOfiImageMaybe(el, name) {
    return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
  }

  if (!supportsObjectPosition) {
    HTMLImageElement.prototype.getAttribute = function (name) {
      return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
    };

    HTMLImageElement.prototype.setAttribute = function (name, value) {
      return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
    };
  }
}

function fix(imgs, opts) {
  var startAutoMode = !autoModeEnabled && !imgs;
  opts = opts || {};
  imgs = imgs || 'img';

  if (supportsObjectPosition && !opts.skipTest || !supportsOFI) {
    return false;
  } // use imgs as a selector or just select all images


  if (imgs === 'img') {
    imgs = document.getElementsByTagName('img');
  } else if (typeof imgs === 'string') {
    imgs = document.querySelectorAll(imgs);
  } else if (!('length' in imgs)) {
    imgs = [imgs];
  } // apply fix to all


  for (var i = 0; i < imgs.length; i++) {
    imgs[i][OFI] = imgs[i][OFI] || {
      skipTest: opts.skipTest
    };
    fixOne(imgs[i]);
  }

  if (startAutoMode) {
    document.body.addEventListener('load', function (e) {
      if (e.target.tagName === 'IMG') {
        fix(e.target, {
          skipTest: opts.skipTest
        });
      }
    }, true);
    autoModeEnabled = true;
    imgs = 'img'; // reset to a generic selector for watchMQ
  } // if requested, watch media queries for object-fit change


  if (opts.watchMQ) {
    window.addEventListener('resize', fix.bind(null, imgs, {
      skipTest: opts.skipTest
    }));
  }
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;
hijackAttributes();
module.exports = fix;

/***/ }),

/***/ "./node_modules/phone/dist/data/country_phone_data.js":
/*!************************************************************!*\
  !*** ./node_modules/phone/dist/data/country_phone_data.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  alpha2: 'US',
  alpha3: 'USA',
  country_code: '1',
  country_name: 'United States',
  mobile_begin_with: ['201', '202', '203', '205', '206', '207', '208', '209', '210', '212', '213', '214', '215', '216', '217', '218', '219', '220', '223', '224', '225', '227', '228', '229', '231', '234', '239', '240', '248', '251', '252', '253', '254', '256', '260', '262', '267', '269', '270', '272', '274', '276', '278', '281', '283', '301', '302', '303', '304', '305', '307', '308', '309', '310', '312', '313', '314', '315', '316', '317', '318', '319', '320', '321', '323', '325', '327', '330', '331', '332', '334', '336', '337', '339', '341', '346', '347', '351', '352', '360', '361', '364', '369', '380', '385', '386', '401', '402', '404', '405', '406', '407', '408', '409', '410', '412', '413', '414', '415', '417', '419', '423', '424', '425', '430', '432', '434', '435', '440', '441', '442', '443', '445', '447', '458', '463', '464', '469', '470', '475', '478', '479', '480', '484', '501', '502', '503', '504', '505', '507', '508', '509', '510', '512', '513', '515', '516', '517', '518', '520', '530', '531', '534', '539', '540', '541', '551', '557', '559', '561', '562', '563', '564', '567', '570', '571', '572', '573', '574', '575', '580', '582', '585', '586', '601', '602', '603', '605', '606', '607', '608', '609', '610', '612', '614', '615', '616', '617', '618', '619', '620', '623', '626', '627', '628', '629', '630', '631', '636', '640', '641', '646', '650', '651', '657', '659', '660', '661', '662', '667', '669', '678', '679', '680', '681', '682', '689', '701', '702', '703', '704', '706', '707', '708', '712', '713', '714', '715', '716', '717', '718', '719', '720', '724', '725', '726', '727', '730', '731', '732', '734', '737', '740', '743', '747', '752', '754', '757', '760', '762', '763', '764', '765', '769', '770', '772', '773', '774', '775', '779', '781', '785', '786', '787', '801', '802', '803', '804', '805', '806', '808', '810', '812', '813', '814', '815', '816', '817', '818', '820', '828', '830', '831', '832', '835', '838', '840', '843', '845', '847', '848', '850', '854', '856', '857', '858', '859', '860', '862', '863', '864', '865', '870', '872', '878', '901', '903', '904', '906', '907', '908', '909', '910', '912', '913', '914', '915', '916', '917', '918', '919', '920', '925', '927', '928', '929', '931', '934', '935', '936', '937', '938', '939', '940', '941', '945', '947', '949', '951', '952', '954', '956', '957', '959', '970', '971', '972', '973', '975', '978', '979', '980', '984', '985', '986', '989', '888', '800', '833', '844', '855', '866', '877', '279'],
  phone_number_lengths: [10]
}, {
  alpha2: 'AW',
  alpha3: 'ABW',
  country_code: '297',
  country_name: 'Aruba',
  mobile_begin_with: ['5', '6', '7', '9'],
  phone_number_lengths: [7]
}, {
  alpha2: 'AF',
  alpha3: 'AFG',
  country_code: '93',
  country_name: 'Afghanistan',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'AO',
  alpha3: 'AGO',
  country_code: '244',
  country_name: 'Angola',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'AI',
  alpha3: 'AIA',
  country_code: '1',
  country_name: 'Anguilla',
  mobile_begin_with: ['2645', '2647'],
  phone_number_lengths: [10]
}, {
  alpha2: 'AX',
  alpha3: 'ALA',
  country_code: '358',
  country_name: 'Åland Islands',
  mobile_begin_with: ['18'],
  phone_number_lengths: [6, 7, 8]
}, {
  alpha2: 'AL',
  alpha3: 'ALB',
  country_code: '355',
  country_name: 'Albania',
  mobile_begin_with: ['6'],
  phone_number_lengths: [9]
}, {
  alpha2: 'AD',
  alpha3: 'AND',
  country_code: '376',
  country_name: 'Andorra',
  mobile_begin_with: ['3', '4', '6'],
  phone_number_lengths: [6]
}, // {alpha2: "AN", alpha3: "ANT", country_code: "599", country_name: "Netherlands Antilles", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'AE',
  alpha3: 'ARE',
  country_code: '971',
  country_name: 'United Arab Emirates',
  mobile_begin_with: ['5'],
  phone_number_lengths: [9]
}, {
  alpha2: 'AR',
  alpha3: 'ARG',
  country_code: '54',
  country_name: 'Argentina',
  mobile_begin_with: ['1', '2', '3'],
  phone_number_lengths: [8, 9, 10, 11, 12]
}, {
  alpha2: 'AM',
  alpha3: 'ARM',
  country_code: '374',
  country_name: 'Armenia',
  mobile_begin_with: ['3', '4', '5', '7', '9'],
  phone_number_lengths: [8]
}, // http://www.howtocallabroad.com/results.php?callfrom=united_states&callto=american_samoa
{
  alpha2: 'AS',
  alpha3: 'ASM',
  country_code: '1',
  country_name: 'American Samoa',
  mobile_begin_with: ['684733', '684258'],
  phone_number_lengths: [10]
}, // {alpha2: "AQ", alpha3: "ATA", country_code: "672", country_name: "Antarctica", mobile_begin_with: [], phone_number_lengths: []},
// {alpha2: "TF", alpha3: "ATF", country_code: "", country_name: "French Southern Territories", mobile_begin_with: [], phone_number_lengths: []},
// http://www.howtocallabroad.com/results.php?callfrom=united_states&callto=antigua_barbuda
{
  alpha2: 'AG',
  alpha3: 'ATG',
  country_code: '1',
  country_name: 'Antigua and Barbuda',
  mobile_begin_with: ['2687'],
  phone_number_lengths: [10]
}, {
  alpha2: 'AU',
  alpha3: 'AUS',
  country_code: '61',
  country_name: 'Australia',
  mobile_begin_with: ['4'],
  phone_number_lengths: [9]
}, {
  alpha2: 'AT',
  alpha3: 'AUT',
  country_code: '43',
  country_name: 'Austria',
  mobile_begin_with: ['6'],
  phone_number_lengths: [10, 11, 12, 13, 14]
}, {
  alpha2: 'AZ',
  alpha3: 'AZE',
  country_code: '994',
  country_name: 'Azerbaijan',
  mobile_begin_with: ['4', '5', '6', '7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'BI',
  alpha3: 'BDI',
  country_code: '257',
  country_name: 'Burundi',
  mobile_begin_with: ['7', '29'],
  phone_number_lengths: [8]
}, {
  alpha2: 'BE',
  alpha3: 'BEL',
  country_code: '32',
  country_name: 'Belgium',
  mobile_begin_with: ['4', '3'],
  phone_number_lengths: [9, 8]
}, {
  alpha2: 'BJ',
  alpha3: 'BEN',
  country_code: '229',
  country_name: 'Benin',
  mobile_begin_with: ['4', '6', '9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'BF',
  alpha3: 'BFA',
  country_code: '226',
  country_name: 'Burkina Faso',
  mobile_begin_with: ['6', '7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'BD',
  alpha3: 'BGD',
  country_code: '880',
  country_name: 'Bangladesh',
  mobile_begin_with: ['1'],
  phone_number_lengths: [8, 9, 10]
}, {
  alpha2: 'BG',
  alpha3: 'BGR',
  country_code: '359',
  country_name: 'Bulgaria',
  mobile_begin_with: ['87', '88', '89', '98', '99', '43'],
  phone_number_lengths: [8, 9]
}, {
  alpha2: 'BH',
  alpha3: 'BHR',
  country_code: '973',
  country_name: 'Bahrain',
  mobile_begin_with: ['3'],
  phone_number_lengths: [8]
}, {
  alpha2: 'BS',
  alpha3: 'BHS',
  country_code: '1',
  country_name: 'Bahamas',
  mobile_begin_with: ['242'],
  phone_number_lengths: [10]
}, {
  alpha2: 'BA',
  alpha3: 'BIH',
  country_code: '387',
  country_name: 'Bosnia and Herzegovina',
  mobile_begin_with: ['6'],
  phone_number_lengths: [8]
}, // {alpha2: "BL", alpha3: "BLM", country_code: "590", country_name: "Saint Barthélemy", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'BY',
  alpha3: 'BLR',
  country_code: '375',
  country_name: 'Belarus',
  mobile_begin_with: ['25', '29', '33', '44'],
  phone_number_lengths: [9]
}, {
  alpha2: 'BZ',
  alpha3: 'BLZ',
  country_code: '501',
  country_name: 'Belize',
  mobile_begin_with: ['6'],
  phone_number_lengths: [7]
}, // http://www.howtocallabroad.com/results.php?callfrom=united_states&callto=bermuda
{
  alpha2: 'BM',
  alpha3: 'BMU',
  country_code: '1',
  country_name: 'Bermuda',
  mobile_begin_with: ['4413', '4415', '4417'],
  phone_number_lengths: [10]
}, {
  alpha2: 'BO',
  alpha3: 'BOL',
  country_code: '591',
  country_name: 'Bolivia',
  mobile_begin_with: ['6', '7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'BR',
  alpha3: 'BRA',
  country_code: '55',
  country_name: 'Brazil',
  mobile_begin_with: ['119', '129', '139', '149', '159', '169', '179', '189', '199', '219', '229', '249', '279', '289', '319', '329', '339', '349', '359', '379', '389', '419', '429', '439', '449', '459', '469', '479', '489', '499', '519', '539', '549', '559', '619', '629', '639', '649', '659', '669', '679', '689', '699', '719', '739', '749', '759', '779', '799', '819', '829', '839', '849', '859', '869', '879', '889', '899', '919', '929', '939', '949', '959', '969', '979', '989', '999'],
  phone_number_lengths: [10, 11]
}, {
  alpha2: 'BB',
  alpha3: 'BRB',
  country_code: '1',
  country_name: 'Barbados',
  mobile_begin_with: ['246'],
  phone_number_lengths: [10]
}, {
  alpha2: 'BN',
  alpha3: 'BRN',
  country_code: '673',
  country_name: 'Brunei Darussalam',
  mobile_begin_with: ['7', '8'],
  phone_number_lengths: [7]
}, {
  alpha2: 'BT',
  alpha3: 'BTN',
  country_code: '975',
  country_name: 'Bhutan',
  mobile_begin_with: ['17'],
  phone_number_lengths: [8]
}, // {alpha2: "BV", alpha3: "BVT", country_code: "", country_name: "Bouvet Island", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'BW',
  alpha3: 'BWA',
  country_code: '267',
  country_name: 'Botswana',
  mobile_begin_with: ['71', '72', '73', '74', '75', '76'],
  phone_number_lengths: [8]
}, {
  alpha2: 'CF',
  alpha3: 'CAF',
  country_code: '236',
  country_name: 'Central African Republic',
  mobile_begin_with: ['7'],
  phone_number_lengths: [8]
}, // http://www.howtocallabroad.com/canada/
// http://areacode.org/
// http://countrycode.org/canada
{
  alpha2: 'CA',
  alpha3: 'CAN',
  country_code: '1',
  country_name: 'Canada',
  mobile_begin_with: ['204', '226', '236', '249', '250', '289', '306', '343', '365', '367', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '600', '604', '613', '639', '647', '672', '705', '709', '778', '780', '807', '819', '825', '867', '873', '902', '905'],
  phone_number_lengths: [10]
}, // {alpha2: "CC", alpha3: "CCK", country_code: "61", country_name: "Cocos (Keeling) Islands", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'CH',
  alpha3: 'CHE',
  country_code: '41',
  country_name: 'Switzerland',
  mobile_begin_with: ['74', '75', '76', '77', '78', '79'],
  phone_number_lengths: [9]
}, {
  alpha2: 'CL',
  alpha3: 'CHL',
  country_code: '56',
  country_name: 'Chile',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'CN',
  alpha3: 'CHN',
  country_code: '86',
  country_name: 'China',
  mobile_begin_with: ['13', '14', '15', '17', '18', '19', '16'],
  phone_number_lengths: [11]
}, {
  alpha2: 'CI',
  alpha3: 'CIV',
  country_code: '225',
  country_name: "Côte D'Ivoire",
  mobile_begin_with: ['0', '4', '5', '6', '7', '8'],
  phone_number_lengths: [10]
}, {
  alpha2: 'CM',
  alpha3: 'CMR',
  country_code: '237',
  country_name: 'Cameroon',
  mobile_begin_with: ['6'],
  phone_number_lengths: [9]
}, {
  alpha2: 'CD',
  alpha3: 'COD',
  country_code: '243',
  country_name: 'Congo, The Democratic Republic Of The',
  mobile_begin_with: ['8', '9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'CG',
  alpha3: 'COG',
  country_code: '242',
  country_name: 'Congo',
  mobile_begin_with: ['0'],
  phone_number_lengths: [9]
}, {
  alpha2: 'CK',
  alpha3: 'COK',
  country_code: '682',
  country_name: 'Cook Islands',
  mobile_begin_with: ['5', '7'],
  phone_number_lengths: [5]
}, {
  alpha2: 'CO',
  alpha3: 'COL',
  country_code: '57',
  country_name: 'Colombia',
  mobile_begin_with: ['3'],
  phone_number_lengths: [10]
}, {
  alpha2: 'CW',
  alpha3: 'CUW',
  country_code: '5999',
  country_name: 'Curaçao',
  mobile_begin_with: ['5', '6'],
  phone_number_lengths: [7]
}, {
  alpha2: 'KM',
  alpha3: 'COM',
  country_code: '269',
  country_name: 'Comoros',
  mobile_begin_with: ['3', '76'],
  phone_number_lengths: [7]
}, {
  alpha2: 'CV',
  alpha3: 'CPV',
  country_code: '238',
  country_name: 'Cape Verde',
  mobile_begin_with: ['5', '9'],
  phone_number_lengths: [7]
}, {
  alpha2: 'CR',
  alpha3: 'CRI',
  country_code: '506',
  country_name: 'Costa Rica',
  mobile_begin_with: ['5', '6', '7', '8'],
  phone_number_lengths: [8]
}, {
  alpha2: 'CU',
  alpha3: 'CUB',
  country_code: '53',
  country_name: 'Cuba',
  mobile_begin_with: ['5'],
  phone_number_lengths: [8]
}, // {alpha2: "CX", alpha3: "CXR", country_code: "61", country_name: "Christmas Island", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'KY',
  alpha3: 'CYM',
  country_code: '1',
  country_name: 'Cayman Islands',
  mobile_begin_with: ['345'],
  phone_number_lengths: [10]
}, {
  alpha2: 'CY',
  alpha3: 'CYP',
  country_code: '357',
  country_name: 'Cyprus',
  mobile_begin_with: ['9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'CZ',
  alpha3: 'CZE',
  country_code: '420',
  country_name: 'Czech Republic',
  mobile_begin_with: ['6', '7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'DE',
  alpha3: 'DEU',
  country_code: '49',
  country_name: 'Germany',
  mobile_begin_with: ['15', '16', '17'],
  phone_number_lengths: [10, 11]
}, {
  alpha2: 'DJ',
  alpha3: 'DJI',
  country_code: '253',
  country_name: 'Djibouti',
  mobile_begin_with: ['77'],
  phone_number_lengths: [8]
}, {
  alpha2: 'DM',
  alpha3: 'DMA',
  country_code: '1',
  country_name: 'Dominica',
  mobile_begin_with: ['767'],
  phone_number_lengths: [10]
}, {
  alpha2: 'DK',
  alpha3: 'DNK',
  country_code: '45',
  country_name: 'Denmark',
  mobile_begin_with: ['2', '30', '31', '40', '41', '42', '50', '51', '52', '53', '60', '61', '71', '81', '91', '92', '93'],
  phone_number_lengths: [8]
}, {
  alpha2: 'DO',
  alpha3: 'DOM',
  country_code: '1',
  country_name: 'Dominican Republic',
  mobile_begin_with: ['809', '829', '849'],
  phone_number_lengths: [10]
}, {
  alpha2: 'DZ',
  alpha3: 'DZA',
  country_code: '213',
  country_name: 'Algeria',
  mobile_begin_with: ['5', '6', '7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'EC',
  alpha3: 'ECU',
  country_code: '593',
  country_name: 'Ecuador',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'EG',
  alpha3: 'EGY',
  country_code: '20',
  country_name: 'Egypt',
  mobile_begin_with: ['1'],
  phone_number_lengths: [10, 8]
}, {
  alpha2: 'ER',
  alpha3: 'ERI',
  country_code: '291',
  country_name: 'Eritrea',
  mobile_begin_with: ['1', '7', '8'],
  phone_number_lengths: [7]
}, // {alpha2: "EH", alpha3: "ESH", country_code: "212", country_name: "Western Sahara", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'ES',
  alpha3: 'ESP',
  country_code: '34',
  country_name: 'Spain',
  mobile_begin_with: ['6', '7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'EE',
  alpha3: 'EST',
  country_code: '372',
  country_name: 'Estonia',
  mobile_begin_with: ['5', '81', '82', '83'],
  phone_number_lengths: [7, 8]
}, {
  alpha2: 'ET',
  alpha3: 'ETH',
  country_code: '251',
  country_name: 'Ethiopia',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'FI',
  alpha3: 'FIN',
  country_code: '358',
  country_name: 'Finland',
  mobile_begin_with: ['4', '5'],
  phone_number_lengths: [9, 10]
}, {
  alpha2: 'FJ',
  alpha3: 'FJI',
  country_code: '679',
  country_name: 'Fiji',
  mobile_begin_with: ['2', '7', '8', '9'],
  phone_number_lengths: [7]
}, {
  alpha2: 'FK',
  alpha3: 'FLK',
  country_code: '500',
  country_name: 'Falkland Islands (Malvinas)',
  mobile_begin_with: ['5', '6'],
  phone_number_lengths: [5]
}, {
  alpha2: 'FR',
  alpha3: 'FRA',
  country_code: '33',
  country_name: 'France',
  mobile_begin_with: ['6', '7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'FO',
  alpha3: 'FRO',
  country_code: '298',
  country_name: 'Faroe Islands',
  mobile_begin_with: [],
  phone_number_lengths: [6]
}, {
  alpha2: 'FM',
  alpha3: 'FSM',
  country_code: '691',
  country_name: 'Micronesia, Federated States Of',
  mobile_begin_with: [],
  phone_number_lengths: [7]
}, {
  alpha2: 'GA',
  alpha3: 'GAB',
  country_code: '241',
  country_name: 'Gabon',
  mobile_begin_with: ['2', '3', '4', '5', '6', '7'],
  phone_number_lengths: [7]
}, {
  alpha2: 'GB',
  alpha3: 'GBR',
  country_code: '44',
  country_name: 'United Kingdom',
  mobile_begin_with: ['7'],
  phone_number_lengths: [10]
}, {
  alpha2: 'GE',
  alpha3: 'GEO',
  country_code: '995',
  country_name: 'Georgia',
  mobile_begin_with: ['5', '7'],
  phone_number_lengths: [9]
}, // {alpha2: "GG", alpha3: "GGY", country_code: "44", country_name: "Guernsey", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'GH',
  alpha3: 'GHA',
  country_code: '233',
  country_name: 'Ghana',
  mobile_begin_with: ['2', '5'],
  phone_number_lengths: [9]
}, {
  alpha2: 'GI',
  alpha3: 'GIB',
  country_code: '350',
  country_name: 'Gibraltar',
  mobile_begin_with: ['5'],
  phone_number_lengths: [8]
}, {
  alpha2: 'GN',
  alpha3: 'GIN',
  country_code: '224',
  country_name: 'Guinea',
  mobile_begin_with: ['6'],
  phone_number_lengths: [9]
}, {
  alpha2: 'GP',
  alpha3: 'GLP',
  country_code: '590',
  country_name: 'Guadeloupe',
  mobile_begin_with: ['690'],
  phone_number_lengths: [9]
}, {
  alpha2: 'GM',
  alpha3: 'GMB',
  country_code: '220',
  country_name: 'Gambia',
  mobile_begin_with: ['7', '9'],
  phone_number_lengths: [7]
}, {
  alpha2: 'GW',
  alpha3: 'GNB',
  country_code: '245',
  country_name: 'Guinea-Bissau',
  mobile_begin_with: ['5', '6', '7'],
  phone_number_lengths: [7]
}, {
  alpha2: 'GQ',
  alpha3: 'GNQ',
  country_code: '240',
  country_name: 'Equatorial Guinea',
  mobile_begin_with: ['222', '551'],
  phone_number_lengths: [9]
}, {
  alpha2: 'GR',
  alpha3: 'GRC',
  country_code: '30',
  country_name: 'Greece',
  mobile_begin_with: ['6'],
  phone_number_lengths: [10]
}, {
  alpha2: 'GD',
  alpha3: 'GRD',
  country_code: '1',
  country_name: 'Grenada',
  mobile_begin_with: ['473'],
  phone_number_lengths: [10]
}, {
  alpha2: 'GL',
  alpha3: 'GRL',
  country_code: '299',
  country_name: 'Greenland',
  mobile_begin_with: ['2', '4', '5'],
  phone_number_lengths: [6]
}, {
  alpha2: 'GT',
  alpha3: 'GTM',
  country_code: '502',
  country_name: 'Guatemala',
  mobile_begin_with: ['3', '4', '5'],
  phone_number_lengths: [8]
}, {
  alpha2: 'GF',
  alpha3: 'GUF',
  country_code: '594',
  country_name: 'French Guiana',
  mobile_begin_with: ['694'],
  phone_number_lengths: [9]
}, {
  alpha2: 'GU',
  alpha3: 'GUM',
  country_code: '1',
  country_name: 'Guam',
  mobile_begin_with: ['671'],
  phone_number_lengths: [10]
}, {
  alpha2: 'GY',
  alpha3: 'GUY',
  country_code: '592',
  country_name: 'Guyana',
  mobile_begin_with: ['6'],
  phone_number_lengths: [7]
}, {
  alpha2: 'HK',
  alpha3: 'HKG',
  country_code: '852',
  country_name: 'Hong Kong',
  mobile_begin_with: ['4', '5', '6', '70', '71', '72', '73', '81', '82', '83', '84', '85', '86', '87', '88', '89', '9'],
  phone_number_lengths: [8]
}, // {alpha2: "HM", alpha3: "HMD", country_code: "", country_name: "Heard and McDonald Islands", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'HN',
  alpha3: 'HND',
  country_code: '504',
  country_name: 'Honduras',
  mobile_begin_with: ['3', '7', '8', '9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'HR',
  alpha3: 'HRV',
  country_code: '385',
  country_name: 'Croatia',
  mobile_begin_with: ['9'],
  phone_number_lengths: [8, 9]
}, {
  alpha2: 'HT',
  alpha3: 'HTI',
  country_code: '509',
  country_name: 'Haiti',
  mobile_begin_with: ['3', '4'],
  phone_number_lengths: [8]
}, {
  alpha2: 'HU',
  alpha3: 'HUN',
  country_code: '36',
  country_name: 'Hungary',
  mobile_begin_with: ['20', '30', '31', '50', '70'],
  phone_number_lengths: [9]
}, {
  alpha2: 'ID',
  alpha3: 'IDN',
  country_code: '62',
  country_name: 'Indonesia',
  mobile_begin_with: ['8'],
  phone_number_lengths: [9, 10, 11, 12]
}, // {alpha2: "IM", alpha3: "IMN", country_code: "44", country_name: "Isle of Man", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'IN',
  alpha3: 'IND',
  country_code: '91',
  country_name: 'India',
  mobile_begin_with: ['6', '7', '8', '9'],
  phone_number_lengths: [10]
}, // {alpha2: "IO", alpha3: "IOT", country_code: "246", country_name: "British Indian Ocean Territory", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'IE',
  alpha3: 'IRL',
  country_code: '353',
  country_name: 'Ireland',
  mobile_begin_with: ['82', '83', '84', '85', '86', '87', '88', '89'],
  phone_number_lengths: [9]
}, {
  alpha2: 'IR',
  alpha3: 'IRN',
  country_code: '98',
  country_name: 'Iran, Islamic Republic Of',
  mobile_begin_with: ['9'],
  phone_number_lengths: [10]
}, {
  alpha2: 'IQ',
  alpha3: 'IRQ',
  country_code: '964',
  country_name: 'Iraq',
  mobile_begin_with: ['7'],
  phone_number_lengths: [10]
}, {
  alpha2: 'IS',
  alpha3: 'ISL',
  country_code: '354',
  country_name: 'Iceland',
  mobile_begin_with: ['6', '7', '8'],
  phone_number_lengths: [7]
}, {
  alpha2: 'IL',
  alpha3: 'ISR',
  country_code: '972',
  country_name: 'Israel',
  mobile_begin_with: ['5'],
  phone_number_lengths: [9]
}, {
  alpha2: 'IT',
  alpha3: 'ITA',
  country_code: '39',
  country_name: 'Italy',
  mobile_begin_with: ['3'],
  phone_number_lengths: [9, 10]
}, {
  alpha2: 'JM',
  alpha3: 'JAM',
  country_code: '1',
  country_name: 'Jamaica',
  mobile_begin_with: ['876'],
  phone_number_lengths: [10]
}, // {alpha2: "JE", alpha3: "JEY", country_code: "44", country_name: "Jersey", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'JO',
  alpha3: 'JOR',
  country_code: '962',
  country_name: 'Jordan',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'JP',
  alpha3: 'JPN',
  country_code: '81',
  country_name: 'Japan',
  mobile_begin_with: ['70', '80', '90'],
  phone_number_lengths: [10]
}, {
  alpha2: 'KZ',
  alpha3: 'KAZ',
  country_code: '7',
  country_name: 'Kazakhstan',
  mobile_begin_with: ['70', '74', '77'],
  phone_number_lengths: [10]
}, {
  alpha2: 'KE',
  alpha3: 'KEN',
  country_code: '254',
  country_name: 'Kenya',
  mobile_begin_with: ['7', '1'],
  phone_number_lengths: [9]
}, {
  alpha2: 'KG',
  alpha3: 'KGZ',
  country_code: '996',
  country_name: 'Kyrgyzstan',
  mobile_begin_with: ['5', '7', '8', '9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'KH',
  alpha3: 'KHM',
  country_code: '855',
  country_name: 'Cambodia',
  mobile_begin_with: ['1', '6', '7', '8', '9'],
  phone_number_lengths: [8, 9]
}, {
  alpha2: 'KI',
  alpha3: 'KIR',
  country_code: '686',
  country_name: 'Kiribati',
  mobile_begin_with: ['9', '30'],
  phone_number_lengths: [5]
}, {
  alpha2: 'KN',
  alpha3: 'KNA',
  country_code: '1',
  country_name: 'Saint Kitts And Nevis',
  mobile_begin_with: ['869'],
  phone_number_lengths: [10]
}, {
  alpha2: 'KR',
  alpha3: 'KOR',
  country_code: '82',
  country_name: 'Korea, Republic of',
  mobile_begin_with: ['1'],
  phone_number_lengths: [9, 10]
}, {
  alpha2: 'KW',
  alpha3: 'KWT',
  country_code: '965',
  country_name: 'Kuwait',
  mobile_begin_with: ['5', '6', '9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'LA',
  alpha3: 'LAO',
  country_code: '856',
  country_name: "Lao People's Democratic Republic",
  mobile_begin_with: ['20'],
  phone_number_lengths: [10]
}, {
  alpha2: 'LB',
  alpha3: 'LBN',
  country_code: '961',
  country_name: 'Lebanon',
  mobile_begin_with: ['3', '7', '8'],
  phone_number_lengths: [7, 8]
}, {
  alpha2: 'LR',
  alpha3: 'LBR',
  country_code: '231',
  country_name: 'Liberia',
  mobile_begin_with: ['4', '5', '6', '7'],
  phone_number_lengths: [7, 8]
}, {
  alpha2: 'LY',
  alpha3: 'LBY',
  country_code: '218',
  country_name: 'Libyan Arab Jamahiriya',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'LC',
  alpha3: 'LCA',
  country_code: '1',
  country_name: 'Saint Lucia',
  mobile_begin_with: ['758'],
  phone_number_lengths: [10]
}, {
  alpha2: 'LI',
  alpha3: 'LIE',
  country_code: '423',
  country_name: 'Liechtenstein',
  mobile_begin_with: ['7'],
  phone_number_lengths: [7]
}, {
  alpha2: 'LK',
  alpha3: 'LKA',
  country_code: '94',
  country_name: 'Sri Lanka',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'LS',
  alpha3: 'LSO',
  country_code: '266',
  country_name: 'Lesotho',
  mobile_begin_with: ['5', '6'],
  phone_number_lengths: [8]
}, {
  alpha2: 'LT',
  alpha3: 'LTU',
  country_code: '370',
  country_name: 'Lithuania',
  mobile_begin_with: ['6'],
  phone_number_lengths: [8]
}, {
  alpha2: 'LU',
  alpha3: 'LUX',
  country_code: '352',
  country_name: 'Luxembourg',
  mobile_begin_with: ['6'],
  phone_number_lengths: [9]
}, {
  alpha2: 'LV',
  alpha3: 'LVA',
  country_code: '371',
  country_name: 'Latvia',
  mobile_begin_with: ['2'],
  phone_number_lengths: [8]
}, {
  alpha2: 'MO',
  alpha3: 'MAC',
  country_code: '853',
  country_name: 'Macao',
  mobile_begin_with: ['6'],
  phone_number_lengths: [8]
}, // {alpha2: "MF", alpha3: "MAF", country_code: "590", country_name: "Saint Martin", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'MA',
  alpha3: 'MAR',
  country_code: '212',
  country_name: 'Morocco',
  mobile_begin_with: ['6', '7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'MC',
  alpha3: 'MCO',
  country_code: '377',
  country_name: 'Monaco',
  mobile_begin_with: ['4', '6'],
  phone_number_lengths: [8, 9]
}, {
  alpha2: 'MD',
  alpha3: 'MDA',
  country_code: '373',
  country_name: 'Moldova, Republic of',
  mobile_begin_with: ['6', '7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'MG',
  alpha3: 'MDG',
  country_code: '261',
  country_name: 'Madagascar',
  mobile_begin_with: ['3'],
  phone_number_lengths: [9]
}, {
  alpha2: 'MV',
  alpha3: 'MDV',
  country_code: '960',
  country_name: 'Maldives',
  mobile_begin_with: ['7', '9'],
  phone_number_lengths: [7]
}, {
  alpha2: 'MX',
  alpha3: 'MEX',
  country_code: '52',
  country_name: 'Mexico',
  mobile_begin_with: [''],
  phone_number_lengths: [10, 11]
}, {
  alpha2: 'MH',
  alpha3: 'MHL',
  country_code: '692',
  country_name: 'Marshall Islands',
  mobile_begin_with: [],
  phone_number_lengths: [7]
}, {
  alpha2: 'MK',
  alpha3: 'MKD',
  country_code: '389',
  country_name: 'Macedonia, the Former Yugoslav Republic Of',
  mobile_begin_with: ['7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'ML',
  alpha3: 'MLI',
  country_code: '223',
  country_name: 'Mali',
  mobile_begin_with: ['6', '7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'MT',
  alpha3: 'MLT',
  country_code: '356',
  country_name: 'Malta',
  mobile_begin_with: ['7', '9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'MM',
  alpha3: 'MMR',
  country_code: '95',
  country_name: 'Myanmar',
  mobile_begin_with: ['9'],
  phone_number_lengths: [8, 9, 10]
}, {
  alpha2: 'ME',
  alpha3: 'MNE',
  country_code: '382',
  country_name: 'Montenegro',
  mobile_begin_with: ['6'],
  phone_number_lengths: [8]
}, {
  alpha2: 'MN',
  alpha3: 'MNG',
  country_code: '976',
  country_name: 'Mongolia',
  mobile_begin_with: ['5', '8', '9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'MP',
  alpha3: 'MNP',
  country_code: '1',
  country_name: 'Northern Mariana Islands',
  mobile_begin_with: ['670'],
  phone_number_lengths: [10]
}, {
  alpha2: 'MZ',
  alpha3: 'MOZ',
  country_code: '258',
  country_name: 'Mozambique',
  mobile_begin_with: ['8'],
  phone_number_lengths: [9]
}, {
  alpha2: 'MR',
  alpha3: 'MRT',
  country_code: '222',
  country_name: 'Mauritania',
  mobile_begin_with: [],
  phone_number_lengths: [8]
}, {
  alpha2: 'MS',
  alpha3: 'MSR',
  country_code: '1',
  country_name: 'Montserrat',
  mobile_begin_with: ['664'],
  phone_number_lengths: [10]
}, {
  alpha2: 'MQ',
  alpha3: 'MTQ',
  country_code: '596',
  country_name: 'Martinique',
  mobile_begin_with: ['696'],
  phone_number_lengths: [9]
}, {
  alpha2: 'MU',
  alpha3: 'MUS',
  country_code: '230',
  country_name: 'Mauritius',
  mobile_begin_with: ['5'],
  phone_number_lengths: [8]
}, {
  alpha2: 'MW',
  alpha3: 'MWI',
  country_code: '265',
  country_name: 'Malawi',
  mobile_begin_with: ['77', '88', '99'],
  phone_number_lengths: [9]
}, {
  alpha2: 'MY',
  alpha3: 'MYS',
  country_code: '60',
  country_name: 'Malaysia',
  mobile_begin_with: ['1', '6'],
  phone_number_lengths: [9, 10, 8]
}, {
  alpha2: 'YT',
  alpha3: 'MYT',
  country_code: '262',
  country_name: 'Mayotte',
  mobile_begin_with: ['639'],
  phone_number_lengths: [9]
}, {
  alpha2: 'NA',
  alpha3: 'NAM',
  country_code: '264',
  country_name: 'Namibia',
  mobile_begin_with: ['60', '81', '82', '85'],
  phone_number_lengths: [9]
}, {
  alpha2: 'NC',
  alpha3: 'NCL',
  country_code: '687',
  country_name: 'New Caledonia',
  mobile_begin_with: ['7', '8', '9'],
  phone_number_lengths: [6]
}, {
  alpha2: 'NE',
  alpha3: 'NER',
  country_code: '227',
  country_name: 'Niger',
  mobile_begin_with: ['9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'NF',
  alpha3: 'NFK',
  country_code: '672',
  country_name: 'Norfolk Island',
  mobile_begin_with: ['5', '8'],
  phone_number_lengths: [5]
}, {
  alpha2: 'NG',
  alpha3: 'NGA',
  country_code: '234',
  country_name: 'Nigeria',
  mobile_begin_with: ['70', '80', '81', '90', '91'],
  phone_number_lengths: [10]
}, {
  alpha2: 'NI',
  alpha3: 'NIC',
  country_code: '505',
  country_name: 'Nicaragua',
  mobile_begin_with: ['8'],
  phone_number_lengths: [8]
}, {
  alpha2: 'NU',
  alpha3: 'NIU',
  country_code: '683',
  country_name: 'Niue',
  mobile_begin_with: [],
  phone_number_lengths: [4]
}, {
  alpha2: 'NL',
  alpha3: 'NLD',
  country_code: '31',
  country_name: 'Netherlands',
  mobile_begin_with: ['6'],
  phone_number_lengths: [9]
}, {
  alpha2: 'NO',
  alpha3: 'NOR',
  country_code: '47',
  country_name: 'Norway',
  mobile_begin_with: ['4', '9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'NP',
  alpha3: 'NPL',
  country_code: '977',
  country_name: 'Nepal',
  mobile_begin_with: ['97', '98'],
  phone_number_lengths: [10]
}, {
  alpha2: 'NR',
  alpha3: 'NRU',
  country_code: '674',
  country_name: 'Nauru',
  mobile_begin_with: ['555'],
  phone_number_lengths: [7]
}, {
  alpha2: 'NZ',
  alpha3: 'NZL',
  country_code: '64',
  country_name: 'New Zealand',
  mobile_begin_with: ['2'],
  phone_number_lengths: [8, 9, 10]
}, {
  alpha2: 'OM',
  alpha3: 'OMN',
  country_code: '968',
  country_name: 'Oman',
  mobile_begin_with: ['9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'PK',
  alpha3: 'PAK',
  country_code: '92',
  country_name: 'Pakistan',
  mobile_begin_with: ['3'],
  phone_number_lengths: [10]
}, {
  alpha2: 'PA',
  alpha3: 'PAN',
  country_code: '507',
  country_name: 'Panama',
  mobile_begin_with: ['6'],
  phone_number_lengths: [8]
}, // {alpha2: "PN", alpha3: "PCN", country_code: "", country_name: "Pitcairn", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'PE',
  alpha3: 'PER',
  country_code: '51',
  country_name: 'Peru',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'PH',
  alpha3: 'PHL',
  country_code: '63',
  country_name: 'Philippines',
  mobile_begin_with: ['9'],
  phone_number_lengths: [10]
}, {
  alpha2: 'PW',
  alpha3: 'PLW',
  country_code: '680',
  country_name: 'Palau',
  mobile_begin_with: [],
  phone_number_lengths: [7]
}, {
  alpha2: 'PG',
  alpha3: 'PNG',
  country_code: '675',
  country_name: 'Papua New Guinea',
  mobile_begin_with: ['7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'PL',
  alpha3: 'POL',
  country_code: '48',
  country_name: 'Poland',
  mobile_begin_with: ['4', '5', '6', '7', '8'],
  phone_number_lengths: [9]
}, {
  alpha2: 'PR',
  alpha3: 'PRI',
  country_code: '1',
  country_name: 'Puerto Rico',
  mobile_begin_with: ['787', '939'],
  phone_number_lengths: [10]
}, // {alpha2: "KP", alpha3: "PRK", country_code: "850", country_name: "Korea, Democratic People's Republic Of", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'PT',
  alpha3: 'PRT',
  country_code: '351',
  country_name: 'Portugal',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'PY',
  alpha3: 'PRY',
  country_code: '595',
  country_name: 'Paraguay',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'PS',
  alpha3: 'PSE',
  country_code: '970',
  country_name: 'Palestinian Territory, Occupied',
  mobile_begin_with: ['5'],
  phone_number_lengths: [9]
}, {
  alpha2: 'PF',
  alpha3: 'PYF',
  country_code: '689',
  country_name: 'French Polynesia',
  mobile_begin_with: ['8'],
  phone_number_lengths: [8]
}, {
  alpha2: 'QA',
  alpha3: 'QAT',
  country_code: '974',
  country_name: 'Qatar',
  mobile_begin_with: ['3', '5', '6', '7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'RE',
  alpha3: 'REU',
  country_code: '262',
  country_name: 'Réunion',
  mobile_begin_with: ['692', '693'],
  phone_number_lengths: [9]
}, {
  alpha2: 'RO',
  alpha3: 'ROU',
  country_code: '40',
  country_name: 'Romania',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'RU',
  alpha3: 'RUS',
  country_code: '7',
  country_name: 'Russian Federation',
  mobile_begin_with: ['9', '495', '498', '499'],
  phone_number_lengths: [10]
}, {
  alpha2: 'RW',
  alpha3: 'RWA',
  country_code: '250',
  country_name: 'Rwanda',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'SA',
  alpha3: 'SAU',
  country_code: '966',
  country_name: 'Saudi Arabia',
  mobile_begin_with: ['5'],
  phone_number_lengths: [9]
}, {
  alpha2: 'SD',
  alpha3: 'SDN',
  country_code: '249',
  country_name: 'Sudan',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'SS',
  alpha3: 'SSD',
  country_code: '211',
  country_name: 'South Sudan',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'SN',
  alpha3: 'SEN',
  country_code: '221',
  country_name: 'Senegal',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'SG',
  alpha3: 'SGP',
  country_code: '65',
  country_name: 'Singapore',
  mobile_begin_with: ['8', '9'],
  phone_number_lengths: [8]
}, // {alpha2: "GS", alpha3: "SGS", country_code: "500", country_name: "South Georgia and the South Sandwich Islands", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'SH',
  alpha3: 'SHN',
  country_code: '290',
  country_name: 'Saint Helena',
  mobile_begin_with: [],
  phone_number_lengths: [4]
}, {
  alpha2: 'SJ',
  alpha3: 'SJM',
  country_code: '47',
  country_name: 'Svalbard And Jan Mayen',
  mobile_begin_with: ['79'],
  phone_number_lengths: [8]
}, {
  alpha2: 'SB',
  alpha3: 'SLB',
  country_code: '677',
  country_name: 'Solomon Islands',
  mobile_begin_with: ['7', '8'],
  phone_number_lengths: [7]
}, {
  alpha2: 'SL',
  alpha3: 'SLE',
  country_code: '232',
  country_name: 'Sierra Leone',
  mobile_begin_with: ['21', '25', '30', '33', '34', '40', '44', '50', '55', '76', '77', '78', '79', '88'],
  phone_number_lengths: [8]
}, {
  alpha2: 'SV',
  alpha3: 'SLV',
  country_code: '503',
  country_name: 'El Salvador',
  mobile_begin_with: ['7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'SM',
  alpha3: 'SMR',
  country_code: '378',
  country_name: 'San Marino',
  mobile_begin_with: ['3', '6'],
  phone_number_lengths: [10]
}, {
  alpha2: 'SO',
  alpha3: 'SOM',
  country_code: '252',
  country_name: 'Somalia',
  mobile_begin_with: ['61', '62', '63', '65', '66', '68', '69', '71', '90'],
  phone_number_lengths: [9]
}, {
  alpha2: 'SX',
  alpha3: 'SXM',
  country_code: '1',
  country_name: 'Sint Maarten',
  mobile_begin_with: ['721'],
  phone_number_lengths: [10]
}, {
  alpha2: 'PM',
  alpha3: 'SPM',
  country_code: '508',
  country_name: 'Saint Pierre And Miquelon',
  mobile_begin_with: ['55', '41'],
  phone_number_lengths: [6]
}, {
  alpha2: 'RS',
  alpha3: 'SRB',
  country_code: '381',
  country_name: 'Serbia',
  mobile_begin_with: ['6'],
  phone_number_lengths: [8, 9]
}, {
  alpha2: 'ST',
  alpha3: 'STP',
  country_code: '239',
  country_name: 'Sao Tome and Principe',
  mobile_begin_with: ['98', '99'],
  phone_number_lengths: [7]
}, {
  alpha2: 'SR',
  alpha3: 'SUR',
  country_code: '597',
  country_name: 'Suriname',
  mobile_begin_with: ['6', '7', '8'],
  phone_number_lengths: [7]
}, {
  alpha2: 'SK',
  alpha3: 'SVK',
  country_code: '421',
  country_name: 'Slovakia',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'SI',
  alpha3: 'SVN',
  country_code: '386',
  country_name: 'Slovenia',
  mobile_begin_with: ['3', '4', '5', '6', '7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'SE',
  alpha3: 'SWE',
  country_code: '46',
  country_name: 'Sweden',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, // {alpha2: "SZ", alpha3: "SWZ", country_code: "268", country_name: "Swaziland", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'SC',
  alpha3: 'SYC',
  country_code: '248',
  country_name: 'Seychelles',
  mobile_begin_with: ['2'],
  phone_number_lengths: [7]
}, {
  alpha2: 'SY',
  alpha3: 'SYR',
  country_code: '963',
  country_name: 'Syrian Arab Republic',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, // http://www.howtocallabroad.com/turks-caicos/
{
  alpha2: 'TC',
  alpha3: 'TCA',
  country_code: '1',
  country_name: 'Turks and Caicos Islands',
  mobile_begin_with: ['6492', '6493', '6494'],
  phone_number_lengths: [10]
}, {
  alpha2: 'TD',
  alpha3: 'TCD',
  country_code: '235',
  country_name: 'Chad',
  mobile_begin_with: ['6', '7', '9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'TG',
  alpha3: 'TGO',
  country_code: '228',
  country_name: 'Togo',
  mobile_begin_with: ['9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'TH',
  alpha3: 'THA',
  country_code: '66',
  country_name: 'Thailand',
  mobile_begin_with: ['6', '8', '9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'TJ',
  alpha3: 'TJK',
  country_code: '992',
  country_name: 'Tajikistan',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'TK',
  alpha3: 'TKL',
  country_code: '690',
  country_name: 'Tokelau',
  mobile_begin_with: [],
  phone_number_lengths: [4]
}, {
  alpha2: 'TM',
  alpha3: 'TKM',
  country_code: '993',
  country_name: 'Turkmenistan',
  mobile_begin_with: ['6'],
  phone_number_lengths: [8]
}, {
  alpha2: 'TL',
  alpha3: 'TLS',
  country_code: '670',
  country_name: 'Timor-Leste',
  mobile_begin_with: ['7'],
  phone_number_lengths: [8]
}, {
  alpha2: 'TO',
  alpha3: 'TON',
  country_code: '676',
  country_name: 'Tonga',
  mobile_begin_with: [],
  phone_number_lengths: [5]
}, {
  alpha2: 'TT',
  alpha3: 'TTO',
  country_code: '1',
  country_name: 'Trinidad and Tobago',
  mobile_begin_with: ['868'],
  phone_number_lengths: [10]
}, {
  alpha2: 'TN',
  alpha3: 'TUN',
  country_code: '216',
  country_name: 'Tunisia',
  mobile_begin_with: ['2', '4', '5', '9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'TR',
  alpha3: 'TUR',
  country_code: '90',
  country_name: 'Turkey',
  mobile_begin_with: ['5'],
  phone_number_lengths: [10]
}, {
  alpha2: 'TV',
  alpha3: 'TUV',
  country_code: '688',
  country_name: 'Tuvalu',
  mobile_begin_with: [],
  phone_number_lengths: [5]
}, {
  alpha2: 'TW',
  alpha3: 'TWN',
  country_code: '886',
  country_name: 'Taiwan',
  mobile_begin_with: ['9'],
  phone_number_lengths: [9]
}, {
  alpha2: 'TZ',
  alpha3: 'TZA',
  country_code: '255',
  country_name: 'Tanzania, United Republic of',
  mobile_begin_with: ['7', '6'],
  phone_number_lengths: [9]
}, {
  alpha2: 'UG',
  alpha3: 'UGA',
  country_code: '256',
  country_name: 'Uganda',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'UA',
  alpha3: 'UKR',
  country_code: '380',
  country_name: 'Ukraine',
  mobile_begin_with: ['39', '50', '63', '66', '67', '68', '73', '9'],
  phone_number_lengths: [9]
}, // {alpha2: "UM", alpha3: "UMI", country_code: "", country_name: "United States Minor Outlying Islands", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'UY',
  alpha3: 'URY',
  country_code: '598',
  country_name: 'Uruguay',
  mobile_begin_with: ['9'],
  phone_number_lengths: [8]
}, {
  alpha2: 'UZ',
  alpha3: 'UZB',
  country_code: '998',
  country_name: 'Uzbekistan',
  mobile_begin_with: ['9', '88', '33'],
  phone_number_lengths: [9]
}, // {alpha2: "VA", alpha3: "VAT", country_code: "39", country_name: "Holy See (Vatican City State)", mobile_begin_with: [], phone_number_lengths: []},
{
  alpha2: 'VC',
  alpha3: 'VCT',
  country_code: '1',
  country_name: 'Saint Vincent And The Grenedines',
  mobile_begin_with: ['784'],
  phone_number_lengths: [10]
}, {
  alpha2: 'VE',
  alpha3: 'VEN',
  country_code: '58',
  country_name: 'Venezuela, Bolivarian Republic of',
  mobile_begin_with: ['4'],
  phone_number_lengths: [10]
}, {
  alpha2: 'VG',
  alpha3: 'VGB',
  country_code: '1',
  country_name: 'Virgin Islands, British',
  mobile_begin_with: ['284'],
  phone_number_lengths: [10]
}, {
  alpha2: 'VI',
  alpha3: 'VIR',
  country_code: '1',
  country_name: 'Virgin Islands, U.S.',
  mobile_begin_with: ['340'],
  phone_number_lengths: [10]
}, {
  alpha2: 'VN',
  alpha3: 'VNM',
  country_code: '84',
  country_name: 'Viet Nam',
  mobile_begin_with: ['8', '9', '3', '7', '5'],
  phone_number_lengths: [9]
}, {
  alpha2: 'VU',
  alpha3: 'VUT',
  country_code: '678',
  country_name: 'Vanuatu',
  mobile_begin_with: ['5', '7'],
  phone_number_lengths: [7]
}, {
  alpha2: 'WF',
  alpha3: 'WLF',
  country_code: '681',
  country_name: 'Wallis and Futuna',
  mobile_begin_with: [],
  phone_number_lengths: [6]
}, {
  alpha2: 'WS',
  alpha3: 'WSM',
  country_code: '685',
  country_name: 'Samoa',
  mobile_begin_with: ['7'],
  phone_number_lengths: [7]
}, {
  alpha2: 'YE',
  alpha3: 'YEM',
  country_code: '967',
  country_name: 'Yemen',
  mobile_begin_with: ['7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'ZA',
  alpha3: 'ZAF',
  country_code: '27',
  country_name: 'South Africa',
  mobile_begin_with: ['1', '2', '3', '4', '5', '6', '7', '8'],
  phone_number_lengths: [9]
}, {
  alpha2: 'ZM',
  alpha3: 'ZMB',
  country_code: '260',
  country_name: 'Zambia',
  mobile_begin_with: ['9', '7'],
  phone_number_lengths: [9]
}, {
  alpha2: 'ZW',
  alpha3: 'ZWE',
  country_code: '263',
  country_name: 'Zimbabwe',
  mobile_begin_with: ['71', '73', '77'],
  phone_number_lengths: [9]
}];

/***/ }),

/***/ "./node_modules/phone/dist/index.js":
/*!******************************************!*\
  !*** ./node_modules/phone/dist/index.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryPhoneData = exports.phone = void 0;

var country_phone_data_1 = __importDefault(__webpack_require__(/*! ./data/country_phone_data */ "./node_modules/phone/dist/data/country_phone_data.js"));

exports.countryPhoneData = country_phone_data_1.default;

var utility_1 = __webpack_require__(/*! ./lib/utility */ "./node_modules/phone/dist/lib/utility.js");
/**
 * @typedef {Object} Option
 * @property {string=} country - country code in ISO3166 alpha 2 or 3
 * @property {boolean=} validateMobilePrefix - true to validate phone number prefix
 * @property {boolean=} strictDetection - true to disable remove truck code and detection logic
 *
 * @param {string} phoneNumber - phone number
 * @param {Option} option
 * @returns {{phoneNumber: string|null, countryIso2: string|null, countryIso3: string|null}}
 */


function phone(phoneNumber, {
  country = '',
  validateMobilePrefix = true,
  strictDetection = false
} = {}) {
  var invalidResult = {
    isValid: false,
    phoneNumber: null,
    countryIso2: null,
    countryIso3: null,
    countryCode: null
  };
  var processedPhoneNumber = typeof phoneNumber !== 'string' ? '' : phoneNumber.trim();
  var processedCountry = typeof country !== 'string' ? '' : country.trim();
  var hasPlusSign = Boolean(processedPhoneNumber.match(/^\+/)); // remove any non-digit character, included the +

  processedPhoneNumber = processedPhoneNumber.replace(/\D/g, '');
  var foundCountryPhoneData = (0, utility_1.findCountryPhoneDataByCountry)(processedCountry);

  if (!foundCountryPhoneData) {
    return invalidResult;
  }

  var defaultCountry = false; // if country provided, only reformat the phone number

  if (processedCountry) {
    // remove leading 0s for all countries except 'CIV', 'COG'
    if (!['CIV', 'COG'].includes(foundCountryPhoneData.alpha3)) {
      processedPhoneNumber = processedPhoneNumber.replace(/^0+/, '');
    } // if input 89234567890, RUS, remove the 8


    if (foundCountryPhoneData.alpha3 === 'RUS' && processedPhoneNumber.length === 11 && processedPhoneNumber.match(/^89/) !== null) {
      processedPhoneNumber = processedPhoneNumber.replace(/^8+/, '');
    } // if there's no plus sign and the phone number length is one of the valid length under country phone data
    // then assume there's no country code, hence add back the country code


    if (!hasPlusSign && foundCountryPhoneData.phone_number_lengths.includes(processedPhoneNumber.length)) {
      processedPhoneNumber = "".concat(foundCountryPhoneData.country_code).concat(processedPhoneNumber);
    }
  } else if (hasPlusSign) {
    // if there is a plus sign but no country provided
    // try to find the country phone data by the phone number
    var {
      exactCountryPhoneData,
      possibleCountryPhoneData
    } = (0, utility_1.findCountryPhoneDataByPhoneNumber)(processedPhoneNumber, validateMobilePrefix);

    if (exactCountryPhoneData) {
      foundCountryPhoneData = exactCountryPhoneData;
    } else if (possibleCountryPhoneData && !strictDetection) {
      // for some countries, the phone number usually includes one trunk prefix for local use
      // The UK mobile phone number ‘07911 123456’ in international format is ‘+44 7911 123456’, so without the first zero.
      // 8 (AAA) BBB-BB-BB, 0AA-BBBBBBB
      // the numbers should be omitted in international calls
      foundCountryPhoneData = possibleCountryPhoneData;
      processedPhoneNumber = foundCountryPhoneData.country_code + processedPhoneNumber.replace(new RegExp("^".concat(foundCountryPhoneData.country_code, "\\d")), '');
    } else {
      foundCountryPhoneData = null;
    }
  } else if (foundCountryPhoneData.phone_number_lengths.indexOf(processedPhoneNumber.length) !== -1) {
    // B: no country, no plus sign --> treat it as USA
    // 1. check length if == 11, or 10, if 10, add +1, then go go D
    // no plus sign, no country is given. then it must be USA
    // iso3166 = iso3166_data[0]; already assign by the default value
    processedPhoneNumber = "1".concat(processedPhoneNumber);
    defaultCountry = true;
  }

  if (!foundCountryPhoneData) {
    return invalidResult;
  }

  var validateResult = (0, utility_1.validatePhoneISO3166)(processedPhoneNumber, foundCountryPhoneData, validateMobilePrefix, hasPlusSign);

  if (validateResult) {
    return {
      isValid: true,
      phoneNumber: "+".concat(processedPhoneNumber),
      countryIso2: foundCountryPhoneData.alpha2,
      countryIso3: foundCountryPhoneData.alpha3,
      countryCode: "+".concat(foundCountryPhoneData.country_code)
    };
  }

  if (defaultCountry) {
    // also try to validate against CAN for default country, as CAN is also start with +1
    foundCountryPhoneData = (0, utility_1.findCountryPhoneDataByCountry)('CAN');
    validateResult = (0, utility_1.validatePhoneISO3166)(processedPhoneNumber, foundCountryPhoneData, validateMobilePrefix, hasPlusSign);

    if (validateResult) {
      return {
        isValid: true,
        phoneNumber: "+".concat(processedPhoneNumber),
        countryIso2: foundCountryPhoneData.alpha2,
        countryIso3: foundCountryPhoneData.alpha3,
        countryCode: "+".concat(foundCountryPhoneData.country_code)
      };
    }
  }

  return invalidResult;
}

exports.default = phone;
exports.phone = phone;
;

/***/ }),

/***/ "./node_modules/phone/dist/lib/utility.js":
/*!************************************************!*\
  !*** ./node_modules/phone/dist/lib/utility.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePhoneISO3166 = exports.findCountryPhoneDataByPhoneNumber = exports.findPossibleCountryPhoneData = exports.findExactCountryPhoneData = exports.findCountryPhoneDataByCountry = void 0;

var country_phone_data_1 = __importDefault(__webpack_require__(/*! ../data/country_phone_data */ "./node_modules/phone/dist/data/country_phone_data.js"));
/**
 * @param {string=} country - country code alpha 2 or 3
 * @returns {{country_code: string, alpha2: string, country_name: string, alpha3: string, mobile_begin_with, phone_number_lengths: [number]}|{country_code: string, alpha2: string, country_name: string, alpha3: string, mobile_begin_with: [string, string, string, string], phone_number_lengths: [number]}|{country_code: string, alpha2: string, country_name: string, alpha3: string, mobile_begin_with: [string], phone_number_lengths: [number]}|{country_code: string, alpha2: string, country_name: string, alpha3: string, mobile_begin_with: [string], phone_number_lengths: [number]}|{country_code: string, alpha2: string, country_name: string, alpha3: string, mobile_begin_with: [string, string], phone_number_lengths: [number]}|null}
 */


function findCountryPhoneDataByCountry(country) {
  // if no country provided, assume it's USA
  if (!country) {
    return country_phone_data_1.default.find(countryPhoneDatum => countryPhoneDatum.alpha3 === 'USA') || null;
  }

  if (country.length === 2) {
    return country_phone_data_1.default.find(countryPhoneDatum => country.toUpperCase() === countryPhoneDatum.alpha2) || null;
  }

  if (country.length === 3) {
    return country_phone_data_1.default.find(countryPhoneDatum => country.toUpperCase() === countryPhoneDatum.alpha3) || null;
  }

  return country_phone_data_1.default.find(countryPhoneDatum => country.toUpperCase() === countryPhoneDatum.country_name.toUpperCase()) || null;
}

exports.findCountryPhoneDataByCountry = findCountryPhoneDataByCountry;

function findExactCountryPhoneData(phoneNumber, validateMobilePrefix, countryPhoneDatum) {
  // check if the phone number length match any one of the length config
  var phoneNumberLengthMatched = countryPhoneDatum.phone_number_lengths.some(length => {
    // as the phone number must include the country code,
    // but countryPhoneDatum.phone_number_lengths is the length without country code
    // therefore need to add back countryPhoneDatum.country_code.length to length
    return countryPhoneDatum.country_code.length + length === phoneNumber.length;
  });

  if (!phoneNumberLengthMatched) {
    return null;
  } // if no need to validate mobile prefix or the country data does not have mobile begin with
  // pick the current one as the answer directly


  if (!countryPhoneDatum.mobile_begin_with.length || !validateMobilePrefix) {
    return countryPhoneDatum;
  } // if the mobile begin with is correct, pick as the correct answer


  if (countryPhoneDatum.mobile_begin_with.some(beginWith => {
    return phoneNumber.match(new RegExp('^' + countryPhoneDatum.country_code + beginWith));
  })) {
    return countryPhoneDatum;
  }

  return null;
}

exports.findExactCountryPhoneData = findExactCountryPhoneData;

function findPossibleCountryPhoneData(phoneNumber, validateMobilePrefix, countryPhoneDatum) {
  // check if the phone number length match any one of the length config
  var phoneNumberLengthMatched = countryPhoneDatum.phone_number_lengths.some(length => {
    // the phone number must include the country code
    // countryPhoneDatum.phone_number_lengths is the length without country code
    // + 1 is assuming there is an unwanted trunk code prepended to the phone number
    return countryPhoneDatum.country_code.length + length + 1 === phoneNumber.length;
  });

  if (!phoneNumberLengthMatched) {
    return null;
  } // if no need to validate mobile prefix or the country data does not have mobile begin with
  // pick the current one as the answer directly


  if (!countryPhoneDatum.mobile_begin_with.length || !validateMobilePrefix) {
    return countryPhoneDatum;
  } // if the mobile begin with is correct, pick as the correct answer
  // match another \d for the unwanted trunk code prepended to the phone number


  if (countryPhoneDatum.mobile_begin_with.some(beginWith => {
    return phoneNumber.match(new RegExp('^' + countryPhoneDatum.country_code + '\\d?' + beginWith));
  })) {
    return countryPhoneDatum;
  }
}

exports.findPossibleCountryPhoneData = findPossibleCountryPhoneData;
/**
 * get country phone data by phone number
 * the phone number must include country code as the complete phone number includes the plus sign
 * @param phoneNumber
 * @param validateMobilePrefix
 * @returns {{exactCountryPhoneData: (*), possibleCountryPhoneData: (*)}}
 */

function findCountryPhoneDataByPhoneNumber(phoneNumber, validateMobilePrefix) {
  var exactCountryPhoneData;
  var possibleCountryPhoneData;

  for (var countryPhoneDatum of country_phone_data_1.default) {
    // if the country code is wrong, skip directly
    if (!phoneNumber.match(new RegExp('^' + countryPhoneDatum.country_code))) {
      continue;
    } // process only if exact match not found yet


    if (!exactCountryPhoneData) {
      exactCountryPhoneData = findExactCountryPhoneData(phoneNumber, validateMobilePrefix, countryPhoneDatum);
    }

    if (!possibleCountryPhoneData) {
      possibleCountryPhoneData = findPossibleCountryPhoneData(phoneNumber, validateMobilePrefix, countryPhoneDatum);
    }
  }

  return {
    exactCountryPhoneData,
    possibleCountryPhoneData
  };
}

exports.findCountryPhoneDataByPhoneNumber = findCountryPhoneDataByPhoneNumber;
/**
 *
 * @param {string} phone - phone number without plus sign, with or without country calling code
 * @param {Object} countryPhoneDatum - iso 3166 data
 * @param {String} countryPhoneDatum.country_code - country calling codes
 * @param {Array} countryPhoneDatum.phone_number_lengths - all available phone number lengths for this country
 * @param {Array} countryPhoneDatum.mobile_begin_with - mobile begin with number
 * @param {boolean} validateMobilePrefix - true if we skip mobile begin with checking
 * @param {boolean} plusSign - true if the input contains a plus sign
 * @returns {*|boolean}
 */

function validatePhoneISO3166(phone, countryPhoneDatum, validateMobilePrefix, plusSign) {
  if (!countryPhoneDatum.phone_number_lengths) {
    return false;
  } // remove country calling code from the phone number


  var phoneWithoutCountry = phone.replace(new RegExp('^' + countryPhoneDatum.country_code), ''); // if the phone number have +, countryPhoneDatum detected,
  // but the phone number does not have country calling code
  // then should consider the phone number as invalid

  if (plusSign && countryPhoneDatum && phoneWithoutCountry.length === phone.length) {
    return false;
  }

  var phone_number_lengths = countryPhoneDatum.phone_number_lengths;
  var mobile_begin_with = countryPhoneDatum.mobile_begin_with;
  var isLengthValid = phone_number_lengths.some(length => phoneWithoutCountry.length === length); // some country doesn't have mobile_begin_with

  var isBeginWithValid = mobile_begin_with.length ? mobile_begin_with.some(beginWith => phoneWithoutCountry.match(new RegExp('^' + beginWith))) : true;
  return isLengthValid && (!validateMobilePrefix || isBeginWithValid);
}

exports.validatePhoneISO3166 = validatePhoneISO3166;

/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}

function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}

(function () {
  try {
    if (typeof setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }

  try {
    if (typeof clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();

function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  } // if setTimeout wasn't available but was latter defined


  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}

function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  } // if clearTimeout wasn't available but was latter defined


  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}

var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }

  draining = false;

  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }

  if (queue.length) {
    drainQueue();
  }
}

function drainQueue() {
  if (draining) {
    return;
  }

  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;

  while (len) {
    currentQueue = queue;
    queue = [];

    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }

    queueIndex = -1;
    len = queue.length;
  }

  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}

process.nextTick = function (fun) {
  var args = new Array(arguments.length - 1);

  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }

  queue.push(new Item(fun, args));

  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
}; // v8 likes predictible objects


function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}

Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues

process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
  return [];
};

process.binding = function (name) {
  throw new Error('process.binding is not supported');
};

process.cwd = function () {
  return '/';
};

process.chdir = function (dir) {
  throw new Error('process.chdir is not supported');
};

process.umask = function () {
  return 0;
};

/***/ }),

/***/ "./node_modules/query-string/index.js":
/*!********************************************!*\
  !*** ./node_modules/query-string/index.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strictUriEncode = __webpack_require__(/*! strict-uri-encode */ "./node_modules/strict-uri-encode/index.js");

var objectAssign = __webpack_require__(/*! object-assign */ "./node_modules/object-assign/index.js");

function encoderForArrayFormat(opts) {
  switch (opts.arrayFormat) {
    case 'index':
      return function (key, value, index) {
        return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
      };

    case 'bracket':
      return function (key, value) {
        return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
      };

    default:
      return function (key, value) {
        return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
      };
  }
}

function parserForArrayFormat(opts) {
  var result;

  switch (opts.arrayFormat) {
    case 'index':
      return function (key, value, accumulator) {
        result = /\[(\d*)\]$/.exec(key);
        key = key.replace(/\[\d*\]$/, '');

        if (!result) {
          accumulator[key] = value;
          return;
        }

        if (accumulator[key] === undefined) {
          accumulator[key] = {};
        }

        accumulator[key][result[1]] = value;
      };

    case 'bracket':
      return function (key, value, accumulator) {
        result = /(\[\])$/.exec(key);
        key = key.replace(/\[\]$/, '');

        if (!result) {
          accumulator[key] = value;
          return;
        } else if (accumulator[key] === undefined) {
          accumulator[key] = [value];
          return;
        }

        accumulator[key] = [].concat(accumulator[key], value);
      };

    default:
      return function (key, value, accumulator) {
        if (accumulator[key] === undefined) {
          accumulator[key] = value;
          return;
        }

        accumulator[key] = [].concat(accumulator[key], value);
      };
  }
}

function encode(value, opts) {
  if (opts.encode) {
    return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
  }

  return value;
}

function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  } else if (typeof input === 'object') {
    return keysSorter(Object.keys(input)).sort(function (a, b) {
      return Number(a) - Number(b);
    }).map(function (key) {
      return input[key];
    });
  }

  return input;
}

exports.extract = function (str) {
  return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
  opts = objectAssign({
    arrayFormat: 'none'
  }, opts);
  var formatter = parserForArrayFormat(opts); // Create an object with no prototype
  // https://github.com/sindresorhus/query-string/issues/47

  var ret = Object.create(null);

  if (typeof str !== 'string') {
    return ret;
  }

  str = str.trim().replace(/^(\?|#|&)/, '');

  if (!str) {
    return ret;
  }

  str.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('='); // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37

    var key = parts.shift();
    var val = parts.length > 0 ? parts.join('=') : undefined; // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters

    val = val === undefined ? null : decodeURIComponent(val);
    formatter(decodeURIComponent(key), val, ret);
  });
  return Object.keys(ret).sort().reduce(function (result, key) {
    var val = ret[key];

    if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
      // Sort object keys, not values
      result[key] = keysSorter(val);
    } else {
      result[key] = val;
    }

    return result;
  }, Object.create(null));
};

exports.stringify = function (obj, opts) {
  var defaults = {
    encode: true,
    strict: true,
    arrayFormat: 'none'
  };
  opts = objectAssign(defaults, opts);
  var formatter = encoderForArrayFormat(opts);
  return obj ? Object.keys(obj).sort().map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return '';
    }

    if (val === null) {
      return encode(key, opts);
    }

    if (Array.isArray(val)) {
      var result = [];
      val.slice().forEach(function (val2) {
        if (val2 === undefined) {
          return;
        }

        result.push(formatter(key, val2, result.length));
      });
      return result.join('&');
    }

    return encode(key, opts) + '=' + encode(val, opts);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : '';
};

/***/ }),

/***/ "./node_modules/scroll-lock/dist/scroll-lock.js":
/*!******************************************************!*\
  !*** ./node_modules/scroll-lock/dist/scroll-lock.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
  if (true) module.exports = factory();else {}
})(this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 0);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__); // CONCATENATED MODULE: ./src/tools.js


      var argumentAsArray = function argumentAsArray(argument) {
        return Array.isArray(argument) ? argument : [argument];
      };

      var isElement = function isElement(target) {
        return target instanceof Node;
      };

      var isElementList = function isElementList(nodeList) {
        return nodeList instanceof NodeList;
      };

      var eachNode = function eachNode(nodeList, callback) {
        if (nodeList && callback) {
          nodeList = isElementList(nodeList) ? nodeList : [nodeList];

          for (var i = 0; i < nodeList.length; i++) {
            if (callback(nodeList[i], i, nodeList.length) === true) {
              break;
            }
          }
        }
      };

      var throwError = function throwError(message) {
        return console.error("[scroll-lock] ".concat(message));
      };

      var arrayAsSelector = function arrayAsSelector(array) {
        if (Array.isArray(array)) {
          var selector = array.join(', ');
          return selector;
        }
      };

      var nodeListAsArray = function nodeListAsArray(nodeList) {
        var nodes = [];
        eachNode(nodeList, function (node) {
          return nodes.push(node);
        });
        return nodes;
      };

      var findParentBySelector = function findParentBySelector($el, selector) {
        var self = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var $root = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;

        if (self && nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) !== -1) {
          return $el;
        }

        while (($el = $el.parentElement) && nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) === -1) {
          ;
        }

        return $el;
      };

      var elementHasSelector = function elementHasSelector($el, selector) {
        var $root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
        var has = nodeListAsArray($root.querySelectorAll(selector)).indexOf($el) !== -1;
        return has;
      };

      var elementHasOverflowHidden = function elementHasOverflowHidden($el) {
        if ($el) {
          var computedStyle = getComputedStyle($el);
          var overflowIsHidden = computedStyle.overflow === 'hidden';
          return overflowIsHidden;
        }
      };

      var elementScrollTopOnStart = function elementScrollTopOnStart($el) {
        if ($el) {
          if (elementHasOverflowHidden($el)) {
            return true;
          }

          var scrollTop = $el.scrollTop;
          return scrollTop <= 0;
        }
      };

      var elementScrollTopOnEnd = function elementScrollTopOnEnd($el) {
        if ($el) {
          if (elementHasOverflowHidden($el)) {
            return true;
          }

          var scrollTop = $el.scrollTop;
          var scrollHeight = $el.scrollHeight;
          var scrollTopWithHeight = scrollTop + $el.offsetHeight;
          return scrollTopWithHeight >= scrollHeight;
        }
      };

      var elementScrollLeftOnStart = function elementScrollLeftOnStart($el) {
        if ($el) {
          if (elementHasOverflowHidden($el)) {
            return true;
          }

          var scrollLeft = $el.scrollLeft;
          return scrollLeft <= 0;
        }
      };

      var elementScrollLeftOnEnd = function elementScrollLeftOnEnd($el) {
        if ($el) {
          if (elementHasOverflowHidden($el)) {
            return true;
          }

          var scrollLeft = $el.scrollLeft;
          var scrollWidth = $el.scrollWidth;
          var scrollLeftWithWidth = scrollLeft + $el.offsetWidth;
          return scrollLeftWithWidth >= scrollWidth;
        }
      };

      var elementIsScrollableField = function elementIsScrollableField($el) {
        var selector = 'textarea, [contenteditable="true"]';
        return elementHasSelector($el, selector);
      };

      var elementIsInputRange = function elementIsInputRange($el) {
        var selector = 'input[type="range"]';
        return elementHasSelector($el, selector);
      }; // CONCATENATED MODULE: ./src/scroll-lock.js

      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "disablePageScroll", function () {
        return disablePageScroll;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "enablePageScroll", function () {
        return enablePageScroll;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "getScrollState", function () {
        return getScrollState;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "clearQueueScrollLocks", function () {
        return clearQueueScrollLocks;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "getTargetScrollBarWidth", function () {
        return scroll_lock_getTargetScrollBarWidth;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "getCurrentTargetScrollBarWidth", function () {
        return scroll_lock_getCurrentTargetScrollBarWidth;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "getPageScrollBarWidth", function () {
        return getPageScrollBarWidth;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "getCurrentPageScrollBarWidth", function () {
        return getCurrentPageScrollBarWidth;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "addScrollableTarget", function () {
        return scroll_lock_addScrollableTarget;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "removeScrollableTarget", function () {
        return scroll_lock_removeScrollableTarget;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "addScrollableSelector", function () {
        return scroll_lock_addScrollableSelector;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "removeScrollableSelector", function () {
        return scroll_lock_removeScrollableSelector;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "addLockableTarget", function () {
        return scroll_lock_addLockableTarget;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "addLockableSelector", function () {
        return scroll_lock_addLockableSelector;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "setFillGapMethod", function () {
        return scroll_lock_setFillGapMethod;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "addFillGapTarget", function () {
        return scroll_lock_addFillGapTarget;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "removeFillGapTarget", function () {
        return scroll_lock_removeFillGapTarget;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "addFillGapSelector", function () {
        return scroll_lock_addFillGapSelector;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "removeFillGapSelector", function () {
        return scroll_lock_removeFillGapSelector;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "refillGaps", function () {
        return refillGaps;
      });

      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          var ownKeys = Object.keys(source);

          if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
              return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
          }

          ownKeys.forEach(function (key) {
            _defineProperty(target, key, source[key]);
          });
        }

        return target;
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      var FILL_GAP_AVAILABLE_METHODS = ['padding', 'margin', 'width', 'max-width', 'none'];
      var TOUCH_DIRECTION_DETECT_OFFSET = 3;
      var state = {
        scroll: true,
        queue: 0,
        scrollableSelectors: ['[data-scroll-lock-scrollable]'],
        lockableSelectors: ['body', '[data-scroll-lock-lockable]'],
        fillGapSelectors: ['body', '[data-scroll-lock-fill-gap]', '[data-scroll-lock-lockable]'],
        fillGapMethod: FILL_GAP_AVAILABLE_METHODS[0],
        //
        startTouchY: 0,
        startTouchX: 0
      };

      var disablePageScroll = function disablePageScroll(target) {
        if (state.queue <= 0) {
          state.scroll = false;
          scroll_lock_hideLockableOverflow();
          fillGaps();
        }

        scroll_lock_addScrollableTarget(target);
        state.queue++;
      };

      var enablePageScroll = function enablePageScroll(target) {
        state.queue > 0 && state.queue--;

        if (state.queue <= 0) {
          state.scroll = true;
          scroll_lock_showLockableOverflow();
          unfillGaps();
        }

        scroll_lock_removeScrollableTarget(target);
      };

      var getScrollState = function getScrollState() {
        return state.scroll;
      };

      var clearQueueScrollLocks = function clearQueueScrollLocks() {
        state.queue = 0;
      };

      var scroll_lock_getTargetScrollBarWidth = function getTargetScrollBarWidth($target) {
        var onlyExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (isElement($target)) {
          var currentOverflowYProperty = $target.style.overflowY;

          if (onlyExists) {
            if (!getScrollState()) {
              $target.style.overflowY = $target.getAttribute('data-scroll-lock-saved-overflow-y-property');
            }
          } else {
            $target.style.overflowY = 'scroll';
          }

          var width = scroll_lock_getCurrentTargetScrollBarWidth($target);
          $target.style.overflowY = currentOverflowYProperty;
          return width;
        } else {
          return 0;
        }
      };

      var scroll_lock_getCurrentTargetScrollBarWidth = function getCurrentTargetScrollBarWidth($target) {
        if (isElement($target)) {
          if ($target === document.body) {
            var documentWidth = document.documentElement.clientWidth;
            var windowWidth = window.innerWidth;
            var currentWidth = windowWidth - documentWidth;
            return currentWidth;
          } else {
            var borderLeftWidthCurrentProperty = $target.style.borderLeftWidth;
            var borderRightWidthCurrentProperty = $target.style.borderRightWidth;
            $target.style.borderLeftWidth = '0px';
            $target.style.borderRightWidth = '0px';

            var _currentWidth = $target.offsetWidth - $target.clientWidth;

            $target.style.borderLeftWidth = borderLeftWidthCurrentProperty;
            $target.style.borderRightWidth = borderRightWidthCurrentProperty;
            return _currentWidth;
          }
        } else {
          return 0;
        }
      };

      var getPageScrollBarWidth = function getPageScrollBarWidth() {
        var onlyExists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return scroll_lock_getTargetScrollBarWidth(document.body, onlyExists);
      };

      var getCurrentPageScrollBarWidth = function getCurrentPageScrollBarWidth() {
        return scroll_lock_getCurrentTargetScrollBarWidth(document.body);
      };

      var scroll_lock_addScrollableTarget = function addScrollableTarget(target) {
        if (target) {
          var targets = argumentAsArray(target);
          targets.map(function ($targets) {
            eachNode($targets, function ($target) {
              if (isElement($target)) {
                $target.setAttribute('data-scroll-lock-scrollable', '');
              } else {
                throwError("\"".concat($target, "\" is not a Element."));
              }
            });
          });
        }
      };

      var scroll_lock_removeScrollableTarget = function removeScrollableTarget(target) {
        if (target) {
          var targets = argumentAsArray(target);
          targets.map(function ($targets) {
            eachNode($targets, function ($target) {
              if (isElement($target)) {
                $target.removeAttribute('data-scroll-lock-scrollable');
              } else {
                throwError("\"".concat($target, "\" is not a Element."));
              }
            });
          });
        }
      };

      var scroll_lock_addScrollableSelector = function addScrollableSelector(selector) {
        if (selector) {
          var selectors = argumentAsArray(selector);
          selectors.map(function (selector) {
            state.scrollableSelectors.push(selector);
          });
        }
      };

      var scroll_lock_removeScrollableSelector = function removeScrollableSelector(selector) {
        if (selector) {
          var selectors = argumentAsArray(selector);
          selectors.map(function (selector) {
            state.scrollableSelectors = state.scrollableSelectors.filter(function (sSelector) {
              return sSelector !== selector;
            });
          });
        }
      };

      var scroll_lock_addLockableTarget = function addLockableTarget(target) {
        if (target) {
          var targets = argumentAsArray(target);
          targets.map(function ($targets) {
            eachNode($targets, function ($target) {
              if (isElement($target)) {
                $target.setAttribute('data-scroll-lock-lockable', '');
              } else {
                throwError("\"".concat($target, "\" is not a Element."));
              }
            });
          });

          if (!getScrollState()) {
            scroll_lock_hideLockableOverflow();
          }
        }
      };

      var scroll_lock_addLockableSelector = function addLockableSelector(selector) {
        if (selector) {
          var selectors = argumentAsArray(selector);
          selectors.map(function (selector) {
            state.lockableSelectors.push(selector);
          });

          if (!getScrollState()) {
            scroll_lock_hideLockableOverflow();
          }

          scroll_lock_addFillGapSelector(selector);
        }
      };

      var scroll_lock_setFillGapMethod = function setFillGapMethod(method) {
        if (method) {
          if (FILL_GAP_AVAILABLE_METHODS.indexOf(method) !== -1) {
            state.fillGapMethod = method;
            refillGaps();
          } else {
            var methods = FILL_GAP_AVAILABLE_METHODS.join(', ');
            throwError("\"".concat(method, "\" method is not available!\nAvailable fill gap methods: ").concat(methods, "."));
          }
        }
      };

      var scroll_lock_addFillGapTarget = function addFillGapTarget(target) {
        if (target) {
          var targets = argumentAsArray(target);
          targets.map(function ($targets) {
            eachNode($targets, function ($target) {
              if (isElement($target)) {
                $target.setAttribute('data-scroll-lock-fill-gap', '');

                if (!state.scroll) {
                  scroll_lock_fillGapTarget($target);
                }
              } else {
                throwError("\"".concat($target, "\" is not a Element."));
              }
            });
          });
        }
      };

      var scroll_lock_removeFillGapTarget = function removeFillGapTarget(target) {
        if (target) {
          var targets = argumentAsArray(target);
          targets.map(function ($targets) {
            eachNode($targets, function ($target) {
              if (isElement($target)) {
                $target.removeAttribute('data-scroll-lock-fill-gap');

                if (!state.scroll) {
                  scroll_lock_unfillGapTarget($target);
                }
              } else {
                throwError("\"".concat($target, "\" is not a Element."));
              }
            });
          });
        }
      };

      var scroll_lock_addFillGapSelector = function addFillGapSelector(selector) {
        if (selector) {
          var selectors = argumentAsArray(selector);
          selectors.map(function (selector) {
            if (state.fillGapSelectors.indexOf(selector) === -1) {
              state.fillGapSelectors.push(selector);

              if (!state.scroll) {
                scroll_lock_fillGapSelector(selector);
              }
            }
          });
        }
      };

      var scroll_lock_removeFillGapSelector = function removeFillGapSelector(selector) {
        if (selector) {
          var selectors = argumentAsArray(selector);
          selectors.map(function (selector) {
            state.fillGapSelectors = state.fillGapSelectors.filter(function (fSelector) {
              return fSelector !== selector;
            });

            if (!state.scroll) {
              scroll_lock_unfillGapSelector(selector);
            }
          });
        }
      };

      var refillGaps = function refillGaps() {
        if (!state.scroll) {
          fillGaps();
        }
      };

      var scroll_lock_hideLockableOverflow = function hideLockableOverflow() {
        var selector = arrayAsSelector(state.lockableSelectors);
        scroll_lock_hideLockableOverflowSelector(selector);
      };

      var scroll_lock_showLockableOverflow = function showLockableOverflow() {
        var selector = arrayAsSelector(state.lockableSelectors);
        scroll_lock_showLockableOverflowSelector(selector);
      };

      var scroll_lock_hideLockableOverflowSelector = function hideLockableOverflowSelector(selector) {
        var $targets = document.querySelectorAll(selector);
        eachNode($targets, function ($target) {
          scroll_lock_hideLockableOverflowTarget($target);
        });
      };

      var scroll_lock_showLockableOverflowSelector = function showLockableOverflowSelector(selector) {
        var $targets = document.querySelectorAll(selector);
        eachNode($targets, function ($target) {
          scroll_lock_showLockableOverflowTarget($target);
        });
      };

      var scroll_lock_hideLockableOverflowTarget = function hideLockableOverflowTarget($target) {
        if (isElement($target) && $target.getAttribute('data-scroll-lock-locked') !== 'true') {
          var computedStyle = window.getComputedStyle($target);
          $target.setAttribute('data-scroll-lock-saved-overflow-y-property', computedStyle.overflowY);
          $target.setAttribute('data-scroll-lock-saved-inline-overflow-property', $target.style.overflow);
          $target.setAttribute('data-scroll-lock-saved-inline-overflow-y-property', $target.style.overflowY);
          $target.style.overflow = 'hidden';
          $target.setAttribute('data-scroll-lock-locked', 'true');
        }
      };

      var scroll_lock_showLockableOverflowTarget = function showLockableOverflowTarget($target) {
        if (isElement($target) && $target.getAttribute('data-scroll-lock-locked') === 'true') {
          $target.style.overflow = $target.getAttribute('data-scroll-lock-saved-inline-overflow-property');
          $target.style.overflowY = $target.getAttribute('data-scroll-lock-saved-inline-overflow-y-property');
          $target.removeAttribute('data-scroll-lock-saved-overflow-property');
          $target.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
          $target.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
          $target.removeAttribute('data-scroll-lock-locked');
        }
      };

      var fillGaps = function fillGaps() {
        state.fillGapSelectors.map(function (selector) {
          scroll_lock_fillGapSelector(selector);
        });
      };

      var unfillGaps = function unfillGaps() {
        state.fillGapSelectors.map(function (selector) {
          scroll_lock_unfillGapSelector(selector);
        });
      };

      var scroll_lock_fillGapSelector = function fillGapSelector(selector) {
        var $targets = document.querySelectorAll(selector);
        var isLockable = state.lockableSelectors.indexOf(selector) !== -1;
        eachNode($targets, function ($target) {
          scroll_lock_fillGapTarget($target, isLockable);
        });
      };

      var scroll_lock_fillGapTarget = function fillGapTarget($target) {
        var isLockable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (isElement($target)) {
          var scrollBarWidth;

          if ($target.getAttribute('data-scroll-lock-lockable') === '' || isLockable) {
            scrollBarWidth = scroll_lock_getTargetScrollBarWidth($target, true);
          } else {
            var $lockableParent = findParentBySelector($target, arrayAsSelector(state.lockableSelectors));
            scrollBarWidth = scroll_lock_getTargetScrollBarWidth($lockableParent, true);
          }

          if ($target.getAttribute('data-scroll-lock-filled-gap') === 'true') {
            scroll_lock_unfillGapTarget($target);
          }

          var computedStyle = window.getComputedStyle($target);
          $target.setAttribute('data-scroll-lock-filled-gap', 'true');
          $target.setAttribute('data-scroll-lock-current-fill-gap-method', state.fillGapMethod);

          if (state.fillGapMethod === 'margin') {
            var currentMargin = parseFloat(computedStyle.marginRight);
            $target.style.marginRight = "".concat(currentMargin + scrollBarWidth, "px");
          } else if (state.fillGapMethod === 'width') {
            $target.style.width = "calc(100% - ".concat(scrollBarWidth, "px)");
          } else if (state.fillGapMethod === 'max-width') {
            $target.style.maxWidth = "calc(100% - ".concat(scrollBarWidth, "px)");
          } else if (state.fillGapMethod === 'padding') {
            var currentPadding = parseFloat(computedStyle.paddingRight);
            $target.style.paddingRight = "".concat(currentPadding + scrollBarWidth, "px");
          }
        }
      };

      var scroll_lock_unfillGapSelector = function unfillGapSelector(selector) {
        var $targets = document.querySelectorAll(selector);
        eachNode($targets, function ($target) {
          scroll_lock_unfillGapTarget($target);
        });
      };

      var scroll_lock_unfillGapTarget = function unfillGapTarget($target) {
        if (isElement($target)) {
          if ($target.getAttribute('data-scroll-lock-filled-gap') === 'true') {
            var currentFillGapMethod = $target.getAttribute('data-scroll-lock-current-fill-gap-method');
            $target.removeAttribute('data-scroll-lock-filled-gap');
            $target.removeAttribute('data-scroll-lock-current-fill-gap-method');

            if (currentFillGapMethod === 'margin') {
              $target.style.marginRight = "";
            } else if (currentFillGapMethod === 'width') {
              $target.style.width = "";
            } else if (currentFillGapMethod === 'max-width') {
              $target.style.maxWidth = "";
            } else if (currentFillGapMethod === 'padding') {
              $target.style.paddingRight = "";
            }
          }
        }
      };

      var onResize = function onResize(e) {
        refillGaps();
      };

      var onTouchStart = function onTouchStart(e) {
        if (!state.scroll) {
          state.startTouchY = e.touches[0].clientY;
          state.startTouchX = e.touches[0].clientX;
        }
      };

      var scroll_lock_onTouchMove = function onTouchMove(e) {
        if (!state.scroll) {
          var startTouchY = state.startTouchY,
              startTouchX = state.startTouchX;
          var currentClientY = e.touches[0].clientY;
          var currentClientX = e.touches[0].clientX;

          if (e.touches.length < 2) {
            var selector = arrayAsSelector(state.scrollableSelectors);
            var direction = {
              up: startTouchY < currentClientY,
              down: startTouchY > currentClientY,
              left: startTouchX < currentClientX,
              right: startTouchX > currentClientX
            };
            var directionWithOffset = {
              up: startTouchY + TOUCH_DIRECTION_DETECT_OFFSET < currentClientY,
              down: startTouchY - TOUCH_DIRECTION_DETECT_OFFSET > currentClientY,
              left: startTouchX + TOUCH_DIRECTION_DETECT_OFFSET < currentClientX,
              right: startTouchX - TOUCH_DIRECTION_DETECT_OFFSET > currentClientX
            };

            var handle = function handle($el) {
              var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

              if ($el) {
                var parentScrollableEl = findParentBySelector($el, selector, false);

                if (elementIsInputRange($el)) {
                  return false;
                }

                if (skip || elementIsScrollableField($el) && findParentBySelector($el, selector) || elementHasSelector($el, selector)) {
                  var prevent = false;

                  if (elementScrollLeftOnStart($el) && elementScrollLeftOnEnd($el)) {
                    if (direction.up && elementScrollTopOnStart($el) || direction.down && elementScrollTopOnEnd($el)) {
                      prevent = true;
                    }
                  } else if (elementScrollTopOnStart($el) && elementScrollTopOnEnd($el)) {
                    if (direction.left && elementScrollLeftOnStart($el) || direction.right && elementScrollLeftOnEnd($el)) {
                      prevent = true;
                    }
                  } else if (directionWithOffset.up && elementScrollTopOnStart($el) || directionWithOffset.down && elementScrollTopOnEnd($el) || directionWithOffset.left && elementScrollLeftOnStart($el) || directionWithOffset.right && elementScrollLeftOnEnd($el)) {
                    prevent = true;
                  }

                  if (prevent) {
                    if (parentScrollableEl) {
                      handle(parentScrollableEl, true);
                    } else {
                      if (e.cancelable) {
                        e.preventDefault();
                      }
                    }
                  }
                } else {
                  handle(parentScrollableEl);
                }
              } else {
                if (e.cancelable) {
                  e.preventDefault();
                }
              }
            };

            handle(e.target);
          }
        }
      };

      var onTouchEnd = function onTouchEnd(e) {
        if (!state.scroll) {
          state.startTouchY = 0;
          state.startTouchX = 0;
        }
      };

      if (typeof window !== 'undefined') {
        window.addEventListener('resize', onResize);
      }

      if (typeof document !== 'undefined') {
        document.addEventListener('touchstart', onTouchStart);
        document.addEventListener('touchmove', scroll_lock_onTouchMove, {
          passive: false
        });
        document.addEventListener('touchend', onTouchEnd);
      }

      var deprecatedMethods = {
        hide: function hide(target) {
          throwError('"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget');
          disablePageScroll(target);
        },
        show: function show(target) {
          throwError('"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget');
          enablePageScroll(target);
        },
        toggle: function toggle(target) {
          throwError('"toggle" is deprecated! Do not use it.');

          if (getScrollState()) {
            disablePageScroll();
          } else {
            enablePageScroll(target);
          }
        },
        getState: function getState() {
          throwError('"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate');
          return getScrollState();
        },
        getWidth: function getWidth() {
          throwError('"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth');
          return getPageScrollBarWidth();
        },
        getCurrentWidth: function getCurrentWidth() {
          throwError('"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth');
          return getCurrentPageScrollBarWidth();
        },
        setScrollableTargets: function setScrollableTargets(target) {
          throwError('"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget');
          scroll_lock_addScrollableTarget(target);
        },
        setFillGapSelectors: function setFillGapSelectors(selector) {
          throwError('"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector');
          scroll_lock_addFillGapSelector(selector);
        },
        setFillGapTargets: function setFillGapTargets(target) {
          throwError('"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget');
          scroll_lock_addFillGapTarget(target);
        },
        clearQueue: function clearQueue() {
          throwError('"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks');
          clearQueueScrollLocks();
        }
      };

      var scrollLock = _objectSpread({
        disablePageScroll: disablePageScroll,
        enablePageScroll: enablePageScroll,
        getScrollState: getScrollState,
        clearQueueScrollLocks: clearQueueScrollLocks,
        getTargetScrollBarWidth: scroll_lock_getTargetScrollBarWidth,
        getCurrentTargetScrollBarWidth: scroll_lock_getCurrentTargetScrollBarWidth,
        getPageScrollBarWidth: getPageScrollBarWidth,
        getCurrentPageScrollBarWidth: getCurrentPageScrollBarWidth,
        addScrollableSelector: scroll_lock_addScrollableSelector,
        removeScrollableSelector: scroll_lock_removeScrollableSelector,
        addScrollableTarget: scroll_lock_addScrollableTarget,
        removeScrollableTarget: scroll_lock_removeScrollableTarget,
        addLockableSelector: scroll_lock_addLockableSelector,
        addLockableTarget: scroll_lock_addLockableTarget,
        addFillGapSelector: scroll_lock_addFillGapSelector,
        removeFillGapSelector: scroll_lock_removeFillGapSelector,
        addFillGapTarget: scroll_lock_addFillGapTarget,
        removeFillGapTarget: scroll_lock_removeFillGapTarget,
        setFillGapMethod: scroll_lock_setFillGapMethod,
        refillGaps: refillGaps,
        _state: state
      }, deprecatedMethods);
      /* harmony default export */


      var scroll_lock = __webpack_exports__["default"] = scrollLock;
      /***/
    }
    /******/
    ])["default"]
  );
});

/***/ }),

/***/ "./node_modules/select-dom/index.js":
/*!******************************************!*\
  !*** ./node_modules/select-dom/index.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// Type predicate for TypeScript
function isQueryable(object) {
  return typeof object.querySelectorAll === 'function';
}

function select(selectors, baseElement) {
  var _a; // Shortcut with specified-but-null baseElement


  if (arguments.length === 2 && !baseElement) {
    return;
  }

  return (_a = (baseElement !== null && baseElement !== void 0 ? baseElement : document).querySelector(String(selectors))) !== null && _a !== void 0 ? _a : undefined;
}

function selectLast(selectors, baseElement) {
  // Shortcut with specified-but-null baseElement
  if (arguments.length === 2 && !baseElement) {
    return undefined;
  }

  var all = (baseElement !== null && baseElement !== void 0 ? baseElement : document).querySelectorAll(String(selectors));
  return all[all.length - 1];
}
/**
 * @param selectors      One or more CSS selectors separated by commas
 * @param [baseElement]  The element to look inside of
 * @return               Whether it's been found
 */


function selectExists(selectors, baseElement) {
  // Shortcut with specified-but-null baseElement
  if (arguments.length === 2 && !baseElement) {
    return false;
  }

  return Boolean((baseElement !== null && baseElement !== void 0 ? baseElement : document).querySelector(String(selectors)));
}

function selectAll(selectors, baseElements) {
  // Shortcut with specified-but-null baseElements
  if (arguments.length === 2 && !baseElements) {
    return [];
  } // Can be: select.all('selectors') or select.all('selectors', singleElementOrDocument)


  if (!baseElements || isQueryable(baseElements)) {
    var elements = (baseElements !== null && baseElements !== void 0 ? baseElements : document).querySelectorAll(String(selectors));
    return [...elements];
  }

  var queried = new Set();

  for (var baseElement of baseElements) {
    for (var element of baseElement.querySelectorAll(String(selectors))) {
      queried.add(element);
    }
  }

  return [...queried]; // Convert to array
}

select.last = selectLast;
select.exists = selectExists;
select.all = selectAll;
/* harmony default export */ __webpack_exports__["default"] = (select);

/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/*!***************************************************!*\
  !*** ./node_modules/setimmediate/setImmediate.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
  "use strict";

  if (global.setImmediate) {
    return;
  }

  var nextHandle = 1; // Spec says greater than zero

  var tasksByHandle = {};
  var currentlyRunningATask = false;
  var doc = global.document;
  var registerImmediate;

  function setImmediate(callback) {
    // Callback can either be a function or a string
    if (typeof callback !== "function") {
      callback = new Function("" + callback);
    } // Copy function arguments


    var args = new Array(arguments.length - 1);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i + 1];
    } // Store and register the task


    var task = {
      callback: callback,
      args: args
    };
    tasksByHandle[nextHandle] = task;
    registerImmediate(nextHandle);
    return nextHandle++;
  }

  function clearImmediate(handle) {
    delete tasksByHandle[handle];
  }

  function run(task) {
    var callback = task.callback;
    var args = task.args;

    switch (args.length) {
      case 0:
        callback();
        break;

      case 1:
        callback(args[0]);
        break;

      case 2:
        callback(args[0], args[1]);
        break;

      case 3:
        callback(args[0], args[1], args[2]);
        break;

      default:
        callback.apply(undefined, args);
        break;
    }
  }

  function runIfPresent(handle) {
    // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
    // So if we're currently running a task, we'll need to delay this invocation.
    if (currentlyRunningATask) {
      // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
      // "too much recursion" error.
      setTimeout(runIfPresent, 0, handle);
    } else {
      var task = tasksByHandle[handle];

      if (task) {
        currentlyRunningATask = true;

        try {
          run(task);
        } finally {
          clearImmediate(handle);
          currentlyRunningATask = false;
        }
      }
    }
  }

  function installNextTickImplementation() {
    registerImmediate = function (handle) {
      process.nextTick(function () {
        runIfPresent(handle);
      });
    };
  }

  function canUsePostMessage() {
    // The test against `importScripts` prevents this implementation from being installed inside a web worker,
    // where `global.postMessage` means something completely different and can't be used for this purpose.
    if (global.postMessage && !global.importScripts) {
      var postMessageIsAsynchronous = true;
      var oldOnMessage = global.onmessage;

      global.onmessage = function () {
        postMessageIsAsynchronous = false;
      };

      global.postMessage("", "*");
      global.onmessage = oldOnMessage;
      return postMessageIsAsynchronous;
    }
  }

  function installPostMessageImplementation() {
    // Installs an event handler on `global` for the `message` event: see
    // * https://developer.mozilla.org/en/DOM/window.postMessage
    // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
    var messagePrefix = "setImmediate$" + Math.random() + "$";

    var onGlobalMessage = function (event) {
      if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
        runIfPresent(+event.data.slice(messagePrefix.length));
      }
    };

    if (global.addEventListener) {
      global.addEventListener("message", onGlobalMessage, false);
    } else {
      global.attachEvent("onmessage", onGlobalMessage);
    }

    registerImmediate = function (handle) {
      global.postMessage(messagePrefix + handle, "*");
    };
  }

  function installMessageChannelImplementation() {
    var channel = new MessageChannel();

    channel.port1.onmessage = function (event) {
      var handle = event.data;
      runIfPresent(handle);
    };

    registerImmediate = function (handle) {
      channel.port2.postMessage(handle);
    };
  }

  function installReadyStateChangeImplementation() {
    var html = doc.documentElement;

    registerImmediate = function (handle) {
      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var script = doc.createElement("script");

      script.onreadystatechange = function () {
        runIfPresent(handle);
        script.onreadystatechange = null;
        html.removeChild(script);
        script = null;
      };

      html.appendChild(script);
    };
  }

  function installSetTimeoutImplementation() {
    registerImmediate = function (handle) {
      setTimeout(runIfPresent, 0, handle);
    };
  } // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.


  var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
  attachTo = attachTo && attachTo.setTimeout ? attachTo : global; // Don't get fooled by e.g. browserify environments.

  if ({}.toString.call(global.process) === "[object process]") {
    // For Node.js before 0.9
    installNextTickImplementation();
  } else if (canUsePostMessage()) {
    // For non-IE10 modern browsers
    installPostMessageImplementation();
  } else if (global.MessageChannel) {
    // For web workers, where supported
    installMessageChannelImplementation();
  } else if (doc && "onreadystatechange" in doc.createElement("script")) {
    // For IE 6–8
    installReadyStateChangeImplementation();
  } else {
    // For older browsers
    installSetTimeoutImplementation();
  }

  attachTo.setImmediate = setImmediate;
  attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/ssr-window/ssr-window.esm.js":
/*!***************************************************!*\
  !*** ./node_modules/ssr-window/ssr-window.esm.js ***!
  \***************************************************/
/*! exports provided: extend, getDocument, getWindow, ssrDocument, ssrWindow */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocument", function() { return getDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWindow", function() { return getWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ssrDocument", function() { return ssrDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ssrWindow", function() { return ssrWindow; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */

/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend(target = {}, src = {}) {
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}

var ssrDocument = {
  body: {},

  addEventListener() {},

  removeEventListener() {},

  activeElement: {
    blur() {},

    nodeName: ''
  },

  querySelector() {
    return null;
  },

  querySelectorAll() {
    return [];
  },

  getElementById() {
    return null;
  },

  createEvent() {
    return {
      initEvent() {}

    };
  },

  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},

      setAttribute() {},

      getElementsByTagName() {
        return [];
      }

    };
  },

  createElementNS() {
    return {};
  },

  importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  var doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}

var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},

    pushState() {},

    go() {},

    back() {}

  },
  CustomEvent: function CustomEvent() {
    return this;
  },

  addEventListener() {},

  removeEventListener() {},

  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }

    };
  },

  Image() {},

  Date() {},

  screen: {},

  setTimeout() {},

  clearTimeout() {},

  matchMedia() {
    return {};
  },

  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },

  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }

};

function getWindow() {
  var win = typeof window !== 'undefined' ? window : {};
  extend(win, ssrWindow);
  return win;
}



/***/ }),

/***/ "./node_modules/strict-uri-encode/index.js":
/*!*************************************************!*\
  !*** ./node_modules/strict-uri-encode/index.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
};

/***/ }),

/***/ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
/*!****************************************************************************!*\
  !*** ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ "./node_modules/swiper/core/breakpoints/getBreakpoint.js":
/*!***************************************************************!*\
  !*** ./node_modules/swiper/core/breakpoints/getBreakpoint.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return getBreakpoint; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }

    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

  for (var i = 0; i < points.length; i += 1) {
    var {
      point,
      value
    } = points[i];

    if (base === 'window') {
      if (window.matchMedia("(min-width: ".concat(value, "px)")).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

/***/ }),

/***/ "./node_modules/swiper/core/breakpoints/index.js":
/*!*******************************************************!*\
  !*** ./node_modules/swiper/core/breakpoints/index.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _setBreakpoint_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setBreakpoint.js */ "./node_modules/swiper/core/breakpoints/setBreakpoint.js");
/* harmony import */ var _getBreakpoint_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getBreakpoint.js */ "./node_modules/swiper/core/breakpoints/getBreakpoint.js");


/* harmony default export */ __webpack_exports__["default"] = ({
  setBreakpoint: _setBreakpoint_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  getBreakpoint: _getBreakpoint_js__WEBPACK_IMPORTED_MODULE_1__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/breakpoints/setBreakpoint.js":
/*!***************************************************************!*\
  !*** ./node_modules/swiper/core/breakpoints/setBreakpoint.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return setBreakpoint; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");


var isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  var swiper = this;
  var {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = isGridEnabled(swiper, params);
  var isMultiRow = isGridEnabled(swiper, breakpointParams);
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass("".concat(params.containerModifierClass, "grid ").concat(params.containerModifierClass, "grid-column"));
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass("".concat(params.containerModifierClass, "grid"));

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass("".concat(params.containerModifierClass, "grid-column"));
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["extend"])(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

/***/ }),

/***/ "./node_modules/swiper/core/check-overflow/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/swiper/core/check-overflow/index.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function checkOverflow() {
  var swiper = this;
  var {
    isLocked: wasLocked,
    params
  } = swiper;
  var {
    slidesOffsetBefore
  } = params;

  if (slidesOffsetBefore) {
    var lastSlideIndex = swiper.slides.length - 1;
    var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  checkOverflow
});

/***/ }),

/***/ "./node_modules/swiper/core/classes/addClasses.js":
/*!********************************************************!*\
  !*** ./node_modules/swiper/core/classes/addClasses.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addClasses; });
function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var {
    classNames,
    params,
    rtl,
    $el,
    device,
    support
  } = swiper; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}

/***/ }),

/***/ "./node_modules/swiper/core/classes/index.js":
/*!***************************************************!*\
  !*** ./node_modules/swiper/core/classes/index.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _addClasses_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./addClasses.js */ "./node_modules/swiper/core/classes/addClasses.js");
/* harmony import */ var _removeClasses_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./removeClasses.js */ "./node_modules/swiper/core/classes/removeClasses.js");


/* harmony default export */ __webpack_exports__["default"] = ({
  addClasses: _addClasses_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  removeClasses: _removeClasses_js__WEBPACK_IMPORTED_MODULE_1__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/classes/removeClasses.js":
/*!***********************************************************!*\
  !*** ./node_modules/swiper/core/classes/removeClasses.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return removeClasses; });
function removeClasses() {
  var swiper = this;
  var {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

/***/ }),

/***/ "./node_modules/swiper/core/core.js":
/*!******************************************!*\
  !*** ./node_modules/swiper/core/core.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/utils.js */ "./node_modules/swiper/shared/utils.js");
/* harmony import */ var _shared_get_support_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/get-support.js */ "./node_modules/swiper/shared/get-support.js");
/* harmony import */ var _shared_get_device_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/get-device.js */ "./node_modules/swiper/shared/get-device.js");
/* harmony import */ var _shared_get_browser_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../shared/get-browser.js */ "./node_modules/swiper/shared/get-browser.js");
/* harmony import */ var _modules_resize_resize_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/resize/resize.js */ "./node_modules/swiper/core/modules/resize/resize.js");
/* harmony import */ var _modules_observer_observer_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/observer/observer.js */ "./node_modules/swiper/core/modules/observer/observer.js");
/* harmony import */ var _events_emitter_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./events-emitter.js */ "./node_modules/swiper/core/events-emitter.js");
/* harmony import */ var _update_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./update/index.js */ "./node_modules/swiper/core/update/index.js");
/* harmony import */ var _translate_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./translate/index.js */ "./node_modules/swiper/core/translate/index.js");
/* harmony import */ var _transition_index_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./transition/index.js */ "./node_modules/swiper/core/transition/index.js");
/* harmony import */ var _slide_index_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./slide/index.js */ "./node_modules/swiper/core/slide/index.js");
/* harmony import */ var _loop_index_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./loop/index.js */ "./node_modules/swiper/core/loop/index.js");
/* harmony import */ var _grab_cursor_index_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./grab-cursor/index.js */ "./node_modules/swiper/core/grab-cursor/index.js");
/* harmony import */ var _events_index_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./events/index.js */ "./node_modules/swiper/core/events/index.js");
/* harmony import */ var _breakpoints_index_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./breakpoints/index.js */ "./node_modules/swiper/core/breakpoints/index.js");
/* harmony import */ var _classes_index_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./classes/index.js */ "./node_modules/swiper/core/classes/index.js");
/* harmony import */ var _images_index_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./images/index.js */ "./node_modules/swiper/core/images/index.js");
/* harmony import */ var _check_overflow_index_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./check-overflow/index.js */ "./node_modules/swiper/core/check-overflow/index.js");
/* harmony import */ var _defaults_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./defaults.js */ "./node_modules/swiper/core/defaults.js");
/* harmony import */ var _moduleExtendParams_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./moduleExtendParams.js */ "./node_modules/swiper/core/moduleExtendParams.js");
/* eslint no-param-reassign: "off" */






















var prototypes = {
  eventsEmitter: _events_emitter_js__WEBPACK_IMPORTED_MODULE_8__["default"],
  update: _update_index_js__WEBPACK_IMPORTED_MODULE_9__["default"],
  translate: _translate_index_js__WEBPACK_IMPORTED_MODULE_10__["default"],
  transition: _transition_index_js__WEBPACK_IMPORTED_MODULE_11__["default"],
  slide: _slide_index_js__WEBPACK_IMPORTED_MODULE_12__["default"],
  loop: _loop_index_js__WEBPACK_IMPORTED_MODULE_13__["default"],
  grabCursor: _grab_cursor_index_js__WEBPACK_IMPORTED_MODULE_14__["default"],
  events: _events_index_js__WEBPACK_IMPORTED_MODULE_15__["default"],
  breakpoints: _breakpoints_index_js__WEBPACK_IMPORTED_MODULE_16__["default"],
  checkOverflow: _check_overflow_index_js__WEBPACK_IMPORTED_MODULE_19__["default"],
  classes: _classes_index_js__WEBPACK_IMPORTED_MODULE_17__["default"],
  images: _images_index_js__WEBPACK_IMPORTED_MODULE_18__["default"]
};
var extendedDefaults = {};

class Swiper {
  constructor(...args) {
    var el;
    var params;

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }

    if (!params) params = {};
    params = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["extend"])({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.el).length > 1) {
      var swipers = [];
      Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.el).each(containerEl => {
        var newParams = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["extend"])({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = Object(_shared_get_support_js__WEBPACK_IMPORTED_MODULE_3__["getSupport"])();
    swiper.device = Object(_shared_get_device_js__WEBPACK_IMPORTED_MODULE_4__["getDevice"])({
      userAgent: params.userAgent
    });
    swiper.browser = Object(_shared_get_browser_js__WEBPACK_IMPORTED_MODULE_5__["getBrowser"])();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];

    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }

    var allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        swiper,
        extendParams: Object(_moduleExtendParams_js__WEBPACK_IMPORTED_MODULE_21__["default"])(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    var swiperParams = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["extend"])({}, _defaults_js__WEBPACK_IMPORTED_MODULE_20__["default"], allModulesParams); // Extend defaults with passed params

    swiper.params = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["extend"])({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["extend"])({}, swiper.params);
    swiper.passedParams = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["extend"])({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"]; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },

      isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["now"])(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  }

  disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  }

  setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }

  getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }

  emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(slideEl => {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }

  slidesPerViewDynamic(view = 'current', exact = false) {
    var swiper = this;
    var {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
          var slideInView = exact ? slidesGrid[_i2] + slidesSizesGrid[_i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (var _i3 = activeIndex - 1; _i3 >= 0; _i3 -= 1) {
          var _slideInView = slidesGrid[activeIndex] - slidesGrid[_i3] < swiperSize;

          if (_slideInView) {
            spv += 1;
          }
        }
      }
    }

    return spv;
  }

  update() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var {
      snapGrid,
      params
    } = swiper; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate = true) {
    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }

  mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = () => {
      return ".".concat((swiper.params.wrapperClass || '').trim().split(' ').join('.'));
    };

    var getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = options => $el.children(options);

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
      var wrapper = document.createElement('div');
      $wrapperEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(".".concat(swiper.params.slideClass)).each(slideEl => {
        $wrapperEl.append(slideEl);
      });
    }

    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  }

  init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }

  destroy(deleteInstance = true, cleanStyles = true) {
    var swiper = this;
    var {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["deleteProps"])(swiper);
    }

    swiper.destroyed = true;
    return null;
  }

  static extendDefaults(newDefaults) {
    Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["extend"])(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return _defaults_js__WEBPACK_IMPORTED_MODULE_20__["default"];
  }

  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    var modules = Swiper.prototype.__modules__;

    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }

  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  }

}

Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([_modules_resize_resize_js__WEBPACK_IMPORTED_MODULE_6__["default"], _modules_observer_observer_js__WEBPACK_IMPORTED_MODULE_7__["default"]]);
/* harmony default export */ __webpack_exports__["default"] = (Swiper);

/***/ }),

/***/ "./node_modules/swiper/core/defaults.js":
/*!**********************************************!*\
  !*** ./node_modules/swiper/core/defaults.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});

/***/ }),

/***/ "./node_modules/swiper/core/events-emitter.js":
/*!****************************************************!*\
  !*** ./node_modules/swiper/core/events-emitter.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* eslint-disable no-underscore-dangle */
/* harmony default export */ __webpack_exports__["default"] = ({
  on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },

  once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler(...args) {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },

  onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },

  offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },

  off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },

  emit(...args) {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

});

/***/ }),

/***/ "./node_modules/swiper/core/events/index.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/core/events/index.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _onTouchStart_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./onTouchStart.js */ "./node_modules/swiper/core/events/onTouchStart.js");
/* harmony import */ var _onTouchMove_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./onTouchMove.js */ "./node_modules/swiper/core/events/onTouchMove.js");
/* harmony import */ var _onTouchEnd_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./onTouchEnd.js */ "./node_modules/swiper/core/events/onTouchEnd.js");
/* harmony import */ var _onResize_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./onResize.js */ "./node_modules/swiper/core/events/onResize.js");
/* harmony import */ var _onClick_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./onClick.js */ "./node_modules/swiper/core/events/onClick.js");
/* harmony import */ var _onScroll_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./onScroll.js */ "./node_modules/swiper/core/events/onScroll.js");







var dummyEventAttached = false;

function dummyEventListener() {}

var events = (swiper, method) => {
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support
  } = swiper;
  var capture = !!params.nested;
  var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  var swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', _onResize_js__WEBPACK_IMPORTED_MODULE_4__["default"], true);
  } else {
    swiper[swiperMethod]('observerUpdate', _onResize_js__WEBPACK_IMPORTED_MODULE_4__["default"], true);
  }
};

function attachEvents() {
  var swiper = this;
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var {
    params,
    support
  } = swiper;
  swiper.onTouchStart = _onTouchStart_js__WEBPACK_IMPORTED_MODULE_1__["default"].bind(swiper);
  swiper.onTouchMove = _onTouchMove_js__WEBPACK_IMPORTED_MODULE_2__["default"].bind(swiper);
  swiper.onTouchEnd = _onTouchEnd_js__WEBPACK_IMPORTED_MODULE_3__["default"].bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = _onScroll_js__WEBPACK_IMPORTED_MODULE_6__["default"].bind(swiper);
  }

  swiper.onClick = _onClick_js__WEBPACK_IMPORTED_MODULE_5__["default"].bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events(swiper, 'on');
}

function detachEvents() {
  var swiper = this;
  events(swiper, 'off');
}

/* harmony default export */ __webpack_exports__["default"] = ({
  attachEvents,
  detachEvents
});

/***/ }),

/***/ "./node_modules/swiper/core/events/onClick.js":
/*!****************************************************!*\
  !*** ./node_modules/swiper/core/events/onClick.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return onClick; });
function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/events/onResize.js":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/core/events/onResize.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return onResize; });
function onResize() {
  var swiper = this;
  var {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/events/onScroll.js":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/core/events/onScroll.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return onScroll; });
function onScroll() {
  var swiper = this;
  var {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

/***/ }),

/***/ "./node_modules/swiper/core/events/onTouchEnd.js":
/*!*******************************************************!*\
  !*** ./node_modules/swiper/core/events/onTouchEnd.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return onTouchEnd; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["now"])();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    var pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["now"])();
  Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["nextTick"])(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/events/onTouchMove.js":
/*!********************************************************!*\
  !*** ./node_modules/swiper/core/events/onTouchMove.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return onTouchMove; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");



function onTouchMove(event) {
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var swiper = this;
  var data = swiper.touchEventsData;
  var {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["now"])();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

/***/ }),

/***/ "./node_modules/swiper/core/events/onTouchStart.js":
/*!*********************************************************!*\
  !*** ./node_modules/swiper/core/events/onTouchStart.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return onTouchStart; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])() || el === Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var data = swiper.touchEventsData;
  var {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["now"])();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}

/***/ }),

/***/ "./node_modules/swiper/core/grab-cursor/index.js":
/*!*******************************************************!*\
  !*** ./node_modules/swiper/core/grab-cursor/index.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _setGrabCursor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setGrabCursor.js */ "./node_modules/swiper/core/grab-cursor/setGrabCursor.js");
/* harmony import */ var _unsetGrabCursor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./unsetGrabCursor.js */ "./node_modules/swiper/core/grab-cursor/unsetGrabCursor.js");


/* harmony default export */ __webpack_exports__["default"] = ({
  setGrabCursor: _setGrabCursor_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  unsetGrabCursor: _unsetGrabCursor_js__WEBPACK_IMPORTED_MODULE_1__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/grab-cursor/setGrabCursor.js":
/*!***************************************************************!*\
  !*** ./node_modules/swiper/core/grab-cursor/setGrabCursor.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return setGrabCursor; });
function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

/***/ }),

/***/ "./node_modules/swiper/core/grab-cursor/unsetGrabCursor.js":
/*!*****************************************************************!*\
  !*** ./node_modules/swiper/core/grab-cursor/unsetGrabCursor.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return unsetGrabCursor; });
function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}

/***/ }),

/***/ "./node_modules/swiper/core/images/index.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/core/images/index.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _loadImage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./loadImage.js */ "./node_modules/swiper/core/images/loadImage.js");
/* harmony import */ var _preloadImages_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./preloadImages.js */ "./node_modules/swiper/core/images/preloadImages.js");


/* harmony default export */ __webpack_exports__["default"] = ({
  loadImage: _loadImage_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  preloadImages: _preloadImages_js__WEBPACK_IMPORTED_MODULE_1__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/images/loadImage.js":
/*!******************************************************!*\
  !*** ./node_modules/swiper/core/images/loadImage.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return loadImage; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/images/preloadImages.js":
/*!**********************************************************!*\
  !*** ./node_modules/swiper/core/images/preloadImages.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return preloadImages; });
function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/loop/index.js":
/*!************************************************!*\
  !*** ./node_modules/swiper/core/loop/index.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _loopCreate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./loopCreate.js */ "./node_modules/swiper/core/loop/loopCreate.js");
/* harmony import */ var _loopFix_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./loopFix.js */ "./node_modules/swiper/core/loop/loopFix.js");
/* harmony import */ var _loopDestroy_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./loopDestroy.js */ "./node_modules/swiper/core/loop/loopDestroy.js");



/* harmony default export */ __webpack_exports__["default"] = ({
  loopCreate: _loopCreate_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  loopFix: _loopFix_js__WEBPACK_IMPORTED_MODULE_1__["default"],
  loopDestroy: _loopDestroy_js__WEBPACK_IMPORTED_MODULE_2__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/loop/loopCreate.js":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/core/loop/loopCreate.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return loopCreate; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");


function loopCreate() {
  var swiper = this;
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var {
    params,
    $wrapperEl
  } = swiper; // Remove duplicated slides

  var $selector = $wrapperEl.children().length > 0 ? Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
  var slides = $selector.children(".".concat(params.slideClass));

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(document.createElement('div')).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
        $selector.append(blankNode);
      }

      slides = $selector.children(".".concat(params.slideClass));
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each((el, index) => {
    var slide = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $selector.append(Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $selector.prepend(Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/loop/loopDestroy.js":
/*!******************************************************!*\
  !*** ./node_modules/swiper/core/loop/loopDestroy.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return loopDestroy; });
function loopDestroy() {
  var swiper = this;
  var {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
  slides.removeAttr('data-swiper-slide-index');
}

/***/ }),

/***/ "./node_modules/swiper/core/loop/loopFix.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/core/loop/loopFix.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return loopFix; });
function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

/***/ }),

/***/ "./node_modules/swiper/core/moduleExtendParams.js":
/*!********************************************************!*\
  !*** ./node_modules/swiper/core/moduleExtendParams.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return moduleExtendParams; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.js */ "./node_modules/swiper/shared/utils.js");

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    var moduleParamName = Object.keys(obj)[0];
    var moduleParams = obj[moduleParamName];

    if (typeof moduleParams !== 'object' || moduleParams === null) {
      Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["extend"])(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["extend"])(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["extend"])(allModulesParams, obj);
  };
}

/***/ }),

/***/ "./node_modules/swiper/core/modules/observer/observer.js":
/*!***************************************************************!*\
  !*** ./node_modules/swiper/core/modules/observer/observer.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Observer; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  var observers = [];
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();

  var attach = (target, options = {}) => {
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  var init = () => {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  var destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/***/ }),

/***/ "./node_modules/swiper/core/modules/resize/resize.js":
/*!***********************************************************!*\
  !*** ./node_modules/swiper/core/modules/resize/resize.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Resize; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");

function Resize({
  swiper,
  on,
  emit
}) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var observer = null;

  var resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  var createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      var {
        width,
        height
      } = swiper;
      var newWidth = width;
      var newHeight = height;
      entries.forEach(({
        contentBoxSize,
        contentRect,
        target
      }) => {
        if (target && target !== swiper.el) return;
        newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
        newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
      });

      if (newWidth !== width || newHeight !== height) {
        resizeHandler();
      }
    });
    observer.observe(swiper.el);
  };

  var removeObserver = () => {
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  var orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

/***/ }),

/***/ "./node_modules/swiper/core/slide/index.js":
/*!*************************************************!*\
  !*** ./node_modules/swiper/core/slide/index.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _slideTo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./slideTo.js */ "./node_modules/swiper/core/slide/slideTo.js");
/* harmony import */ var _slideToLoop_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./slideToLoop.js */ "./node_modules/swiper/core/slide/slideToLoop.js");
/* harmony import */ var _slideNext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./slideNext.js */ "./node_modules/swiper/core/slide/slideNext.js");
/* harmony import */ var _slidePrev_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./slidePrev.js */ "./node_modules/swiper/core/slide/slidePrev.js");
/* harmony import */ var _slideReset_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./slideReset.js */ "./node_modules/swiper/core/slide/slideReset.js");
/* harmony import */ var _slideToClosest_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./slideToClosest.js */ "./node_modules/swiper/core/slide/slideToClosest.js");
/* harmony import */ var _slideToClickedSlide_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./slideToClickedSlide.js */ "./node_modules/swiper/core/slide/slideToClickedSlide.js");







/* harmony default export */ __webpack_exports__["default"] = ({
  slideTo: _slideTo_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  slideToLoop: _slideToLoop_js__WEBPACK_IMPORTED_MODULE_1__["default"],
  slideNext: _slideNext_js__WEBPACK_IMPORTED_MODULE_2__["default"],
  slidePrev: _slidePrev_js__WEBPACK_IMPORTED_MODULE_3__["default"],
  slideReset: _slideReset_js__WEBPACK_IMPORTED_MODULE_4__["default"],
  slideToClosest: _slideToClosest_js__WEBPACK_IMPORTED_MODULE_5__["default"],
  slideToClickedSlide: _slideToClickedSlide_js__WEBPACK_IMPORTED_MODULE_6__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/slide/slideNext.js":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/core/slide/slideNext.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return slideNext; });
/* eslint no-unused-vars: "off" */
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  var swiper = this;
  var {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  var perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/***/ }),

/***/ "./node_modules/swiper/core/slide/slidePrev.js":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/core/slide/slidePrev.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return slidePrev; });
/* eslint no-unused-vars: "off" */
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  var swiper = this;
  var {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(val => normalize(val));
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    var prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  var prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    return swiper.slideTo(swiper.slides.length - 1, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/***/ }),

/***/ "./node_modules/swiper/core/slide/slideReset.js":
/*!******************************************************!*\
  !*** ./node_modules/swiper/core/slide/slideReset.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return slideReset; });
/* eslint no-unused-vars: "off" */
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/***/ }),

/***/ "./node_modules/swiper/core/slide/slideTo.js":
/*!***************************************************!*\
  !*** ./node_modules/swiper/core/slide/slideTo.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return slideTo; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");

function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [".concat(typeof index, "] given."));
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(index, "] given."));
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGrid = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = rtl ? translate : -translate;

    if (speed === 0) {
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["animateCSSModeScroll"])({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}

/***/ }),

/***/ "./node_modules/swiper/core/slide/slideToClickedSlide.js":
/*!***************************************************************!*\
  !*** ./node_modules/swiper/core/slide/slideToClickedSlide.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return slideToClickedSlide; });
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");


function slideToClickedSlide() {
  var swiper = this;
  var {
    params,
    $wrapperEl
  } = swiper;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
        Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_1__["nextTick"])(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
      Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_1__["nextTick"])(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/slide/slideToClosest.js":
/*!**********************************************************!*\
  !*** ./node_modules/swiper/core/slide/slideToClosest.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return slideToClosest; });
/* eslint no-unused-vars: "off" */
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

/***/ }),

/***/ "./node_modules/swiper/core/slide/slideToLoop.js":
/*!*******************************************************!*\
  !*** ./node_modules/swiper/core/slide/slideToLoop.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return slideToLoop; });
function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/***/ }),

/***/ "./node_modules/swiper/core/transition/index.js":
/*!******************************************************!*\
  !*** ./node_modules/swiper/core/transition/index.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _setTransition_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setTransition.js */ "./node_modules/swiper/core/transition/setTransition.js");
/* harmony import */ var _transitionStart_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transitionStart.js */ "./node_modules/swiper/core/transition/transitionStart.js");
/* harmony import */ var _transitionEnd_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./transitionEnd.js */ "./node_modules/swiper/core/transition/transitionEnd.js");



/* harmony default export */ __webpack_exports__["default"] = ({
  setTransition: _setTransition_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  transitionStart: _transitionStart_js__WEBPACK_IMPORTED_MODULE_1__["default"],
  transitionEnd: _transitionEnd_js__WEBPACK_IMPORTED_MODULE_2__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/transition/setTransition.js":
/*!**************************************************************!*\
  !*** ./node_modules/swiper/core/transition/setTransition.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return setTransition; });
function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

/***/ }),

/***/ "./node_modules/swiper/core/transition/transitionEmit.js":
/*!***************************************************************!*\
  !*** ./node_modules/swiper/core/transition/transitionEmit.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return transitionEmit; });
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  var {
    activeIndex,
    previousIndex
  } = swiper;
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit("transition".concat(step));

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit("slideResetTransition".concat(step));
      return;
    }

    swiper.emit("slideChangeTransition".concat(step));

    if (dir === 'next') {
      swiper.emit("slideNextTransition".concat(step));
    } else {
      swiper.emit("slidePrevTransition".concat(step));
    }
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/transition/transitionEnd.js":
/*!**************************************************************!*\
  !*** ./node_modules/swiper/core/transition/transitionEnd.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return transitionEnd; });
/* harmony import */ var _transitionEmit_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./transitionEmit.js */ "./node_modules/swiper/core/transition/transitionEmit.js");

function transitionEnd(runCallbacks = true, direction) {
  var swiper = this;
  var {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  Object(_transitionEmit_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}

/***/ }),

/***/ "./node_modules/swiper/core/transition/transitionStart.js":
/*!****************************************************************!*\
  !*** ./node_modules/swiper/core/transition/transitionStart.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return transitionStart; });
/* harmony import */ var _transitionEmit_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./transitionEmit.js */ "./node_modules/swiper/core/transition/transitionEmit.js");

function transitionStart(runCallbacks = true, direction) {
  var swiper = this;
  var {
    params
  } = swiper;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  Object(_transitionEmit_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}

/***/ }),

/***/ "./node_modules/swiper/core/translate/getTranslate.js":
/*!************************************************************!*\
  !*** ./node_modules/swiper/core/translate/getTranslate.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return getSwiperTranslate; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  var swiper = this;
  var {
    params,
    rtlTranslate: rtl,
    translate,
    $wrapperEl
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["getTranslate"])($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

/***/ }),

/***/ "./node_modules/swiper/core/translate/index.js":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/core/translate/index.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _getTranslate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getTranslate.js */ "./node_modules/swiper/core/translate/getTranslate.js");
/* harmony import */ var _setTranslate_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./setTranslate.js */ "./node_modules/swiper/core/translate/setTranslate.js");
/* harmony import */ var _minTranslate_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./minTranslate.js */ "./node_modules/swiper/core/translate/minTranslate.js");
/* harmony import */ var _maxTranslate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./maxTranslate.js */ "./node_modules/swiper/core/translate/maxTranslate.js");
/* harmony import */ var _translateTo_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./translateTo.js */ "./node_modules/swiper/core/translate/translateTo.js");





/* harmony default export */ __webpack_exports__["default"] = ({
  getTranslate: _getTranslate_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  setTranslate: _setTranslate_js__WEBPACK_IMPORTED_MODULE_1__["default"],
  minTranslate: _minTranslate_js__WEBPACK_IMPORTED_MODULE_2__["default"],
  maxTranslate: _maxTranslate_js__WEBPACK_IMPORTED_MODULE_3__["default"],
  translateTo: _translateTo_js__WEBPACK_IMPORTED_MODULE_4__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/translate/maxTranslate.js":
/*!************************************************************!*\
  !*** ./node_modules/swiper/core/translate/maxTranslate.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return maxTranslate; });
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

/***/ }),

/***/ "./node_modules/swiper/core/translate/minTranslate.js":
/*!************************************************************!*\
  !*** ./node_modules/swiper/core/translate/minTranslate.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return minTranslate; });
function minTranslate() {
  return -this.snapGrid[0];
}

/***/ }),

/***/ "./node_modules/swiper/core/translate/setTranslate.js":
/*!************************************************************!*\
  !*** ./node_modules/swiper/core/translate/setTranslate.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return setTranslate; });
function setTranslate(translate, byController) {
  var swiper = this;
  var {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

/***/ }),

/***/ "./node_modules/swiper/core/translate/translateTo.js":
/*!***********************************************************!*\
  !*** ./node_modules/swiper/core/translate/translateTo.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return translateTo; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  var swiper = this;
  var {
    params,
    wrapperEl
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["animateCSSModeScroll"])({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

/***/ }),

/***/ "./node_modules/swiper/core/update/index.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/core/update/index.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _updateSize_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./updateSize.js */ "./node_modules/swiper/core/update/updateSize.js");
/* harmony import */ var _updateSlides_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./updateSlides.js */ "./node_modules/swiper/core/update/updateSlides.js");
/* harmony import */ var _updateAutoHeight_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./updateAutoHeight.js */ "./node_modules/swiper/core/update/updateAutoHeight.js");
/* harmony import */ var _updateSlidesOffset_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./updateSlidesOffset.js */ "./node_modules/swiper/core/update/updateSlidesOffset.js");
/* harmony import */ var _updateSlidesProgress_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./updateSlidesProgress.js */ "./node_modules/swiper/core/update/updateSlidesProgress.js");
/* harmony import */ var _updateProgress_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./updateProgress.js */ "./node_modules/swiper/core/update/updateProgress.js");
/* harmony import */ var _updateSlidesClasses_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./updateSlidesClasses.js */ "./node_modules/swiper/core/update/updateSlidesClasses.js");
/* harmony import */ var _updateActiveIndex_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./updateActiveIndex.js */ "./node_modules/swiper/core/update/updateActiveIndex.js");
/* harmony import */ var _updateClickedSlide_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./updateClickedSlide.js */ "./node_modules/swiper/core/update/updateClickedSlide.js");









/* harmony default export */ __webpack_exports__["default"] = ({
  updateSize: _updateSize_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  updateSlides: _updateSlides_js__WEBPACK_IMPORTED_MODULE_1__["default"],
  updateAutoHeight: _updateAutoHeight_js__WEBPACK_IMPORTED_MODULE_2__["default"],
  updateSlidesOffset: _updateSlidesOffset_js__WEBPACK_IMPORTED_MODULE_3__["default"],
  updateSlidesProgress: _updateSlidesProgress_js__WEBPACK_IMPORTED_MODULE_4__["default"],
  updateProgress: _updateProgress_js__WEBPACK_IMPORTED_MODULE_5__["default"],
  updateSlidesClasses: _updateSlidesClasses_js__WEBPACK_IMPORTED_MODULE_6__["default"],
  updateActiveIndex: _updateActiveIndex_js__WEBPACK_IMPORTED_MODULE_7__["default"],
  updateClickedSlide: _updateClickedSlide_js__WEBPACK_IMPORTED_MODULE_8__["default"]
});

/***/ }),

/***/ "./node_modules/swiper/core/update/updateActiveIndex.js":
/*!**************************************************************!*\
  !*** ./node_modules/swiper/core/update/updateActiveIndex.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateActiveIndex; });
function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/update/updateAutoHeight.js":
/*!*************************************************************!*\
  !*** ./node_modules/swiper/core/update/updateAutoHeight.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateAutoHeight; });
function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', "".concat(newHeight, "px"));
}

/***/ }),

/***/ "./node_modules/swiper/core/update/updateClickedSlide.js":
/*!***************************************************************!*\
  !*** ./node_modules/swiper/core/update/updateClickedSlide.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateClickedSlide; });
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(e).closest(".".concat(params.slideClass))[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/update/updateProgress.js":
/*!***********************************************************!*\
  !*** ./node_modules/swiper/core/update/updateProgress.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateProgress; });
function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

/***/ }),

/***/ "./node_modules/swiper/core/update/updateSize.js":
/*!*******************************************************!*\
  !*** ./node_modules/swiper/core/update/updateSize.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateSize; });
function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}

/***/ }),

/***/ "./node_modules/swiper/core/update/updateSlides.js":
/*!*********************************************************!*\
  !*** ./node_modules/swiper/core/update/updateSlides.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateSlides; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["setCSSProperty"])(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["setCSSProperty"])(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  var slideSize;
  var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = "";
      }

      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var {
            clientWidth,
            offsetWidth
          } = slide[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = "".concat(slideSize, "px");
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel('width')]: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    var newSlidesGrid = [];

    for (var _i = 0; _i < snapGrid.length; _i += 1) {
      var slidesGridItem = snapGrid[_i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[_i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css({
      [key]: "".concat(spaceBetween, "px")
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["setCSSProperty"])(swiper.wrapperEl, '--swiper-centered-offset-before', "".concat(-snapGrid[0], "px"));
    Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["setCSSProperty"])(swiper.wrapperEl, '--swiper-centered-offset-after', "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
    var addToSnapGrid = -swiper.snapGrid[0];
    var addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/update/updateSlidesClasses.js":
/*!****************************************************************!*\
  !*** ./node_modules/swiper/core/update/updateSlidesClasses.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateSlidesClasses; });
function updateSlidesClasses() {
  var swiper = this;
  var {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(activeIndex, "\"]"));
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

/***/ }),

/***/ "./node_modules/swiper/core/update/updateSlidesOffset.js":
/*!***************************************************************!*\
  !*** ./node_modules/swiper/core/update/updateSlidesOffset.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateSlidesOffset; });
function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

/***/ }),

/***/ "./node_modules/swiper/core/update/updateSlidesProgress.js":
/*!*****************************************************************!*\
  !*** ./node_modules/swiper/core/update/updateSlidesProgress.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return updateSlidesProgress; });
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");

function updateSlidesProgress(translate = this && this.translate || 0) {
  var swiper = this;
  var params = swiper.params;
  var {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    var slideBefore = -(offsetCenter - slideOffset);
    var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(swiper.visibleSlides);
}

/***/ }),

/***/ "./node_modules/swiper/modules/a11y/a11y.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/modules/a11y/a11y.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return A11y; });
/* harmony import */ var _shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/classes-to-selector.js */ "./node_modules/swiper/shared/classes-to-selector.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");


function A11y({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group'
    }
  });
  var liveRegion = null;

  function notify(message) {
    var notification = liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  }

  function getRandomNumber(size = 16) {
    var randomChar = () => Math.round(16 * Math.random()).toString(16);

    return 'x'.repeat(size).replace(/x/g, randomChar);
  }

  function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
  }

  function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
  }

  function addElRole($el, role) {
    $el.attr('role', role);
  }

  function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
  }

  function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
  }

  function addElLabel($el, label) {
    $el.attr('aria-label', label);
  }

  function addElId($el, id) {
    $el.attr('id', id);
  }

  function addElLive($el, live) {
    $el.attr('aria-live', live);
  }

  function disableEl($el) {
    $el.attr('aria-disabled', true);
  }

  function enableEl($el) {
    $el.attr('aria-disabled', false);
  }

  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    var params = swiper.params.a11y;
    var $targetEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_0__["default"])(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  }

  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    var {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        disableEl($prevEl);
        makeElNotFocusable($prevEl);
      } else {
        enableEl($prevEl);
        makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        disableEl($nextEl);
        makeElNotFocusable($nextEl);
      } else {
        enableEl($nextEl);
        makeElFocusable($nextEl);
      }
    }
  }

  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }

  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }

  function updatePagination() {
    var params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.each(bulletEl => {
      var $bulletEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(bulletEl);

      if (swiper.params.pagination.clickable) {
        makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          addElRole($bulletEl, 'button');
          addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      }

      if ($bulletEl.is(".".concat(swiper.params.pagination.bulletActiveClass))) {
        $bulletEl.attr('aria-current', 'true');
      } else {
        $bulletEl.removeAttr('aria-current');
      }
    });
  }

  var initNavEl = ($el, wrapperId, message) => {
    makeElFocusable($el);

    if ($el[0].tagName !== 'BUTTON') {
      addElRole($el, 'button');
      $el.on('keydown', onEnterOrSpaceKey);
    }

    addElLabel($el, message);
    addElControls($el, wrapperId);
  };

  function init() {
    var params = swiper.params.a11y;
    swiper.$el.append(liveRegion); // Container

    var $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    var $wrapperEl = swiper.$wrapperEl;
    var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-".concat(getRandomNumber(16));
    var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId($wrapperEl, wrapperId);
    addElLive($wrapperEl, live); // Slide

    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(swiper.slides), params.itemRoleDescriptionMessage);
    }

    addElRole(Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(swiper.slides), params.slideRole);
    var slidesLength = swiper.params.loop ? swiper.slides.filter(el => !el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
    swiper.slides.each((slideEl, index) => {
      var $slideEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(slideEl);
      var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
      var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
      addElLabel($slideEl, ariaLabelMessage);
    }); // Navigation

    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      initNavEl($nextEl, wrapperId, params.nextSlideMessage);
    }

    if ($prevEl && $prevEl.length) {
      initNavEl($prevEl, wrapperId, params.prevSlideMessage);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.on('keydown', Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_0__["default"])(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    }
  }

  function destroy() {
    if (liveRegion && liveRegion.length > 0) liveRegion.remove();
    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', onEnterOrSpaceKey);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.off('keydown', Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_0__["default"])(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    }
  }

  on('beforeInit', () => {
    liveRegion = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])("<span class=\"".concat(swiper.params.a11y.notificationClass, "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>"));
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
    updateNavigation();
  });
  on('toEdge', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('fromEdge', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/autoplay/autoplay.js":
/*!**********************************************************!*\
  !*** ./node_modules/swiper/modules/autoplay/autoplay.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Autoplay; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");
/* eslint no-underscore-dangle: "off" */

/* eslint no-use-before-define: "off" */


function Autoplay({
  swiper,
  extendParams,
  on,
  emit
}) {
  var timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });

  function run() {
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(timeout);
    timeout = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_1__["nextTick"])(() => {
      var autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit('autoplay');
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit('autoplay');
      } else {
        stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }

  function start() {
    if (typeof timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    emit('autoplayStart');
    run();
    return true;
  }

  function stop() {
    if (!swiper.autoplay.running) return false;
    if (typeof timeout === 'undefined') return false;

    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }

    swiper.autoplay.running = false;
    emit('autoplayStop');
    return true;
  }

  function pause(speed) {
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (timeout) clearTimeout(timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }

  function onVisibilityChange() {
    var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }

  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }

  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }

  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    run();
  }

  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', onMouseEnter);
      swiper.$el.on('mouseleave', onMouseLeave);
    }
  }

  function detachMouseEvents() {
    swiper.$el.off('mouseenter', onMouseEnter);
    swiper.$el.off('mouseleave', onMouseLeave);
  }

  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      start();
      var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
      document.addEventListener('visibilitychange', onVisibilityChange);
      attachMouseEvents();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on('touchEnd', () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on('destroy', () => {
    detachMouseEvents();

    if (swiper.autoplay.running) {
      stop();
    }

    var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/controller/controller.js":
/*!**************************************************************!*\
  !*** ./node_modules/swiper/modules/controller/controller.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Controller; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

function Controller({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  });
  swiper.controller = {
    control: undefined
  };

  function LinearSpline(x, y) {
    var binarySearch = function search() {
      var maxIndex;
      var minIndex;
      var guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    var i1;
    var i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  } // xxx: for now i will just save one spline function to to


  function getInterpolateFunction(c) {
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  }

  function setTranslate(_t, byController) {
    var controlled = swiper.controller.control;
    var multiplier;
    var controlledTranslate;
    var Swiper = swiper.constructor;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (var i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }

  function setTransition(duration, byController) {
    var Swiper = swiper.constructor;
    var controlled = swiper.controller.control;
    var i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["nextTick"])(() => {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(() => {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }

  function removeSpline() {
    if (!swiper.controller.control) return;

    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }

  on('beforeInit', () => {
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/effect-cards/effect-cards.js":
/*!******************************************************************!*\
  !*** ./node_modules/swiper/modules/effect-cards/effect-cards.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EffectCards; });
/* harmony import */ var _shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/create-shadow.js */ "./node_modules/swiper/shared/create-shadow.js");
/* harmony import */ var _shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/effect-init.js */ "./node_modules/swiper/shared/effect-init.js");
/* harmony import */ var _shared_effect_target_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/effect-target.js */ "./node_modules/swiper/shared/effect-target.js");
/* harmony import */ var _shared_effect_virtual_transition_end_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../shared/effect-virtual-transition-end.js */ "./node_modules/swiper/shared/effect-virtual-transition-end.js");




function EffectCards({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cardsEffect: {
      slideShadows: true,
      transformEl: null
    }
  });

  var setTranslate = () => {
    var {
      slides,
      activeIndex
    } = swiper;
    var params = swiper.params.cardsEffect;
    var {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    var currentTranslate = swiper.translate;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideProgress = $slideEl[0].progress;
      var progress = Math.min(Math.max(slideProgress, -4), 4);
      var offset = $slideEl[0].swiperSlideOffset;

      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.$wrapperEl.transform("translateX(".concat(swiper.minTranslate(), "px)"));
      }

      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }

      var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      var tY = 0;
      var tZ = -100 * Math.abs(progress);
      var scale = 1;
      var rotate = -2 * progress;
      var tXAdd = 8 - Math.abs(progress) * 0.75;
      var isSwipeToNext = (i === activeIndex || i === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      var isSwipeToPrev = (i === activeIndex || i === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;

      if (isSwipeToNext || isSwipeToPrev) {
        var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = "".concat(-25 * subProgress * Math.abs(progress), "%");
      }

      if (progress < 0) {
        // next
        tX = "calc(".concat(tX, "px + (").concat(tXAdd * Math.abs(progress), "%))");
      } else if (progress > 0) {
        // prev
        tX = "calc(".concat(tX, "px + (-").concat(tXAdd * Math.abs(progress), "%))");
      } else {
        tX = "".concat(tX, "px");
      }

      if (!swiper.isHorizontal()) {
        var prevY = tY;
        tY = tX;
        tX = prevY;
      }

      var scaleString = progress < 0 ? "".concat(1 + (1 - scale) * progress) : "".concat(1 - (1 - scale) * progress);
      var transform = "\n        translate3d(".concat(tX, ", ").concat(tY, ", ").concat(tZ, "px)\n        rotateZ(").concat(rotate, "deg)\n        scale(").concat(scaleString, ")\n      ");

      if (params.slideShadows) {
        // Set shadows
        var $shadowEl = $slideEl.find('.swiper-slide-shadow');

        if ($shadowEl.length === 0) {
          $shadowEl = Object(_shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, $slideEl);
        }

        if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      var $targetEl = Object(_shared_effect_target_js__WEBPACK_IMPORTED_MODULE_2__["default"])(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  var setTransition = duration => {
    var {
      transformEl
    } = swiper.params.cardsEffect;
    var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    Object(_shared_effect_virtual_transition_end_js__WEBPACK_IMPORTED_MODULE_3__["default"])({
      swiper,
      duration,
      transformEl
    });
  };

  Object(_shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/effect-coverflow/effect-coverflow.js":
/*!**************************************************************************!*\
  !*** ./node_modules/swiper/modules/effect-coverflow/effect-coverflow.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EffectCoverflow; });
/* harmony import */ var _shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/create-shadow.js */ "./node_modules/swiper/shared/create-shadow.js");
/* harmony import */ var _shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/effect-init.js */ "./node_modules/swiper/shared/effect-init.js");
/* harmony import */ var _shared_effect_target_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/effect-target.js */ "./node_modules/swiper/shared/effect-target.js");



function EffectCoverflow({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true,
      transformEl: null
    }
  });

  var setTranslate = () => {
    var {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    var params = swiper.params.coverflowEffect;
    var isHorizontal = swiper.isHorizontal();
    var transform = swiper.translate;
    var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    var rotate = isHorizontal ? params.rotate : -params.rotate;
    var translate = params.depth; // Each slide offset from center

    for (var i = 0, length = slides.length; i < length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideSize = slidesSizesGrid[i];
      var slideOffset = $slideEl[0].swiperSlideOffset;
      var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

      var translateZ = -translate * Math.abs(offsetMultiplier);
      var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }

      var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
      var $targetEl = Object(_shared_effect_target_js__WEBPACK_IMPORTED_MODULE_2__["default"])(params, $slideEl);
      $targetEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

      if (params.slideShadows) {
        // Set shadows
        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = Object(_shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, $slideEl, isHorizontal ? 'left' : 'top');
        }

        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = Object(_shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, $slideEl, isHorizontal ? 'right' : 'bottom');
        }

        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };

  var setTransition = duration => {
    var {
      transformEl
    } = swiper.params.coverflowEffect;
    var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  };

  Object(_shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/effect-creative/effect-creative.js":
/*!************************************************************************!*\
  !*** ./node_modules/swiper/modules/effect-creative/effect-creative.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EffectCreative; });
/* harmony import */ var _shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/create-shadow.js */ "./node_modules/swiper/shared/create-shadow.js");
/* harmony import */ var _shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/effect-init.js */ "./node_modules/swiper/shared/effect-init.js");
/* harmony import */ var _shared_effect_target_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/effect-target.js */ "./node_modules/swiper/shared/effect-target.js");
/* harmony import */ var _shared_effect_virtual_transition_end_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../shared/effect-virtual-transition-end.js */ "./node_modules/swiper/shared/effect-virtual-transition-end.js");




function EffectCreative({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    creativeEffect: {
      transformEl: null,
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });

  var getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return "".concat(value, "px");
  };

  var setTranslate = () => {
    var {
      slides,
      $wrapperEl,
      slidesSizesGrid
    } = swiper;
    var params = swiper.params.creativeEffect;
    var {
      progressMultiplier: multiplier
    } = params;
    var isCenteredSlides = swiper.params.centeredSlides;

    if (isCenteredSlides) {
      var margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      $wrapperEl.transform("translateX(calc(50% - ".concat(margin, "px))"));
    }

    var _loop = function (i) {
      var $slideEl = slides.eq(i);
      var slideProgress = $slideEl[0].progress;
      var progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
      var originalProgress = progress;

      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
      }

      var offset = $slideEl[0].swiperSlideOffset;
      var t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      var r = [0, 0, 0];
      var custom = false;

      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }

      var data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };

      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      } // set translate


      t.forEach((value, index) => {
        t[index] = "calc(".concat(value, "px + (").concat(getTranslateValue(data.translate[index]), " * ").concat(Math.abs(progress * multiplier), "))");
      }); // set rotates

      r.forEach((value, index) => {
        r[index] = data.rotate[index] * Math.abs(progress * multiplier);
      });
      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      var translateString = t.join(', ');
      var rotateString = "rotateX(".concat(r[0], "deg) rotateY(").concat(r[1], "deg) rotateZ(").concat(r[2], "deg)");
      var scaleString = originalProgress < 0 ? "scale(".concat(1 + (1 - data.scale) * originalProgress * multiplier, ")") : "scale(".concat(1 - (1 - data.scale) * originalProgress * multiplier, ")");
      var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      var transform = "translate3d(".concat(translateString, ") ").concat(rotateString, " ").concat(scaleString); // Set shadows

      if (custom && data.shadow || !custom) {
        var $shadowEl = $slideEl.children('.swiper-slide-shadow');

        if ($shadowEl.length === 0 && data.shadow) {
          $shadowEl = Object(_shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, $slideEl);
        }

        if ($shadowEl.length) {
          var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }

      var $targetEl = Object(_shared_effect_target_js__WEBPACK_IMPORTED_MODULE_2__["default"])(params, $slideEl);
      $targetEl.transform(transform).css({
        opacity: opacityString
      });

      if (data.origin) {
        $targetEl.css('transform-origin', data.origin);
      }
    };

    for (var i = 0; i < slides.length; i += 1) {
      _loop(i);
    }
  };

  var setTransition = duration => {
    var {
      transformEl
    } = swiper.params.creativeEffect;
    var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    Object(_shared_effect_virtual_transition_end_js__WEBPACK_IMPORTED_MODULE_3__["default"])({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  Object(_shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/effect-cube/effect-cube.js":
/*!****************************************************************!*\
  !*** ./node_modules/swiper/modules/effect-cube/effect-cube.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EffectCube; });
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/effect-init.js */ "./node_modules/swiper/shared/effect-init.js");


function EffectCube({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });

  var setTranslate = () => {
    var {
      $el,
      $wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    var params = swiper.params.cubeEffect;
    var isHorizontal = swiper.isHorizontal();
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var wrapperRotate = 0;
    var $cubeShadowEl;

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }

        $cubeShadowEl.css({
          height: "".concat(swiperWidth, "px")
        });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideIndex = i;

      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }

      var slideAngle = slideIndex * 90;
      var round = Math.floor(slideAngle / 360);

      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }

      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      var tx = 0;
      var ty = 0;
      var tz = 0;

      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }

      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      var transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");

      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }

      $slideEl.transform(transform);

      if (params.slideShadows) {
        // Set shadows
        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if (shadowBefore.length === 0) {
          shadowBefore = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'left' : 'top', "\"></div>"));
          $slideEl.append(shadowBefore);
        }

        if (shadowAfter.length === 0) {
          shadowAfter = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])("<div class=\"swiper-slide-shadow-".concat(isHorizontal ? 'right' : 'bottom', "\"></div>"));
          $slideEl.append(shadowAfter);
        }

        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
    }

    $wrapperEl.css({
      '-webkit-transform-origin': "50% 50% -".concat(swiperSize / 2, "px"),
      'transform-origin': "50% 50% -".concat(swiperSize / 2, "px")
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform("translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")"));
      } else {
        var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        var scale1 = params.shadowScale;
        var scale2 = params.shadowScale / multiplier;
        var offset = params.shadowOffset;
        $cubeShadowEl.transform("scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)"));
      }
    }

    var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform("translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)"));
  };

  var setTransition = duration => {
    var {
      $el,
      slides
    } = swiper;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  };

  Object(_shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/effect-fade/effect-fade.js":
/*!****************************************************************!*\
  !*** ./node_modules/swiper/modules/effect-fade/effect-fade.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EffectFade; });
/* harmony import */ var _shared_effect_init_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/effect-init.js */ "./node_modules/swiper/shared/effect-init.js");
/* harmony import */ var _shared_effect_target_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/effect-target.js */ "./node_modules/swiper/shared/effect-target.js");
/* harmony import */ var _shared_effect_virtual_transition_end_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/effect-virtual-transition-end.js */ "./node_modules/swiper/shared/effect-virtual-transition-end.js");



function EffectFade({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    fadeEffect: {
      crossFade: false,
      transformEl: null
    }
  });

  var setTranslate = () => {
    var {
      slides
    } = swiper;
    var params = swiper.params.fadeEffect;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var offset = $slideEl[0].swiperSlideOffset;
      var tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }

      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      var $targetEl = Object(_shared_effect_target_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params, $slideEl);
      $targetEl.css({
        opacity: slideOpacity
      }).transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)"));
    }
  };

  var setTransition = duration => {
    var {
      transformEl
    } = swiper.params.fadeEffect;
    var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration);
    Object(_shared_effect_virtual_transition_end_js__WEBPACK_IMPORTED_MODULE_2__["default"])({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  Object(_shared_effect_init_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
    effect: 'fade',
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/effect-fade/effect-fade.min.css":
/*!*********************************************************************!*\
  !*** ./node_modules/swiper/modules/effect-fade/effect-fade.min.css ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(/*! ../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__(/*! !../../../css-loader/dist/cjs.js?importLoaders!../../../postcss-loader/dist/cjs.js!./effect-fade.min.css */ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/effect-fade/effect-fade.min.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./node_modules/swiper/modules/effect-flip/effect-flip.js":
/*!****************************************************************!*\
  !*** ./node_modules/swiper/modules/effect-flip/effect-flip.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EffectFlip; });
/* harmony import */ var _shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/create-shadow.js */ "./node_modules/swiper/shared/create-shadow.js");
/* harmony import */ var _shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/effect-init.js */ "./node_modules/swiper/shared/effect-init.js");
/* harmony import */ var _shared_effect_target_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/effect-target.js */ "./node_modules/swiper/shared/effect-target.js");
/* harmony import */ var _shared_effect_virtual_transition_end_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../shared/effect-virtual-transition-end.js */ "./node_modules/swiper/shared/effect-virtual-transition-end.js");




function EffectFlip({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true,
      transformEl: null
    }
  });

  var setTranslate = () => {
    var {
      slides,
      rtlTranslate: rtl
    } = swiper;
    var params = swiper.params.flipEffect;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }

      var offset = $slideEl[0].swiperSlideOffset;
      var rotate = -180 * progress;
      var rotateY = rotate;
      var rotateX = 0;
      var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (params.slideShadows) {
        // Set shadows
        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if (shadowBefore.length === 0) {
          shadowBefore = Object(_shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
        }

        if (shadowAfter.length === 0) {
          shadowAfter = Object(_shared_create_shadow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        }

        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }

      var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)");
      var $targetEl = Object(_shared_effect_target_js__WEBPACK_IMPORTED_MODULE_2__["default"])(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  var setTransition = duration => {
    var {
      transformEl
    } = swiper.params.flipEffect;
    var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    Object(_shared_effect_virtual_transition_end_js__WEBPACK_IMPORTED_MODULE_3__["default"])({
      swiper,
      duration,
      transformEl
    });
  };

  Object(_shared_effect_init_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/free-mode/free-mode.js":
/*!************************************************************!*\
  !*** ./node_modules/swiper/modules/free-mode/free-mode.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return freeMode; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");

function freeMode({
  swiper,
  extendParams,
  emit,
  once
}) {
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });

  function onTouchMove() {
    var {
      touchEventsData: data,
      touches
    } = swiper; // Velocity

    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["now"])()
    });
  }

  function onTouchEnd({
    currentPos
  }) {
    var {
      params,
      $wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper; // Time diff

    var touchEndTime = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["now"])();
    var timeDiff = touchEndTime - data.touchStartTime;

    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["now"])() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeMode.momentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(() => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(() => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }

  Object.assign(swiper, {
    freeMode: {
      onTouchMove,
      onTouchEnd
    }
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/free-mode/free-mode.min.css":
/*!*****************************************************************!*\
  !*** ./node_modules/swiper/modules/free-mode/free-mode.min.css ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(/*! ../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__(/*! !../../../css-loader/dist/cjs.js?importLoaders!../../../postcss-loader/dist/cjs.js!./free-mode.min.css */ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/free-mode/free-mode.min.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./node_modules/swiper/modules/grid/grid.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/modules/grid/grid.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Grid; });
function Grid({
  swiper,
  extendParams
}) {
  extendParams({
    grid: {
      rows: 1,
      fill: 'column'
    }
  });
  var slidesNumberEvenToRows;
  var slidesPerRow;
  var numFullColumns;

  var initSlides = slidesLength => {
    var {
      slidesPerView
    } = swiper.params;
    var {
      rows,
      fill
    } = swiper.params.grid;
    slidesPerRow = slidesNumberEvenToRows / rows;
    numFullColumns = Math.floor(slidesLength / rows);

    if (Math.floor(slidesLength / rows) === slidesLength / rows) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
    }

    if (slidesPerView !== 'auto' && fill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    }
  };

  var updateSlide = (i, slide, slidesLength, getDirectionLabel) => {
    var {
      slidesPerGroup,
      spaceBetween
    } = swiper.params;
    var {
      rows,
      fill
    } = swiper.params.grid; // Set slides order

    var newSlideOrderIndex;
    var column;
    var row;

    if (fill === 'row' && slidesPerGroup > 1) {
      var groupIndex = Math.floor(i / (slidesPerGroup * rows));
      var slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
      var columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
      row = Math.floor(slideIndexInGroup / columnsInGroup);
      column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
      newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
      slide.css({
        '-webkit-order': newSlideOrderIndex,
        order: newSlideOrderIndex
      });
    } else if (fill === 'column') {
      column = Math.floor(i / rows);
      row = i - column * rows;

      if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
        row += 1;

        if (row >= rows) {
          row = 0;
          column += 1;
        }
      }
    } else {
      row = Math.floor(i / slidesPerRow);
      column = i - row * slidesPerRow;
    }

    slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && "".concat(spaceBetween, "px") : '');
  };

  var updateWrapperSize = (slideSize, snapGrid, getDirectionLabel) => {
    var {
      spaceBetween,
      centeredSlides,
      roundLengths
    } = swiper.params;
    var {
      rows
    } = swiper.params.grid;
    swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
    swiper.$wrapperEl.css({
      [getDirectionLabel('width')]: "".concat(swiper.virtualSize + spaceBetween, "px")
    });

    if (centeredSlides) {
      snapGrid.splice(0, snapGrid.length);
      var newSlidesGrid = [];

      for (var i = 0; i < snapGrid.length; i += 1) {
        var slidesGridItem = snapGrid[i];
        if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid.push(...newSlidesGrid);
    }
  };

  swiper.grid = {
    initSlides,
    updateSlide,
    updateWrapperSize
  };
}

/***/ }),

/***/ "./node_modules/swiper/modules/hash-navigation/hash-navigation.js":
/*!************************************************************************!*\
  !*** ./node_modules/swiper/modules/hash-navigation/hash-navigation.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HashNavigation; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");


function HashNavigation({
  swiper,
  extendParams,
  emit,
  on
}) {
  var initialized = false;
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  });

  var onHashChange = () => {
    emit('hashChange');
    var newHash = document.location.hash.replace('#', '');
    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

    if (newHash !== activeSlideHash) {
      var newIndex = swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, "[data-hash=\"").concat(newHash, "\"]")).index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  };

  var setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;

    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, "#".concat(swiper.slides.eq(swiper.activeIndex).attr('data-hash')) || false);
      emit('hashSet');
    } else {
      var slide = swiper.slides.eq(swiper.activeIndex);
      var hash = slide.attr('data-hash') || slide.attr('data-history');
      document.location.hash = hash || '';
      emit('hashSet');
    }
  };

  var init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    var hash = document.location.hash.replace('#', '');

    if (hash) {
      var speed = 0;

      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var slide = swiper.slides.eq(i);
        var slideHash = slide.attr('data-hash') || slide.attr('data-history');

        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          var index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }

    if (swiper.params.hashNavigation.watchState) {
      Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(window).on('hashchange', onHashChange);
    }
  };

  var destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(window).off('hashchange', onHashChange);
    }
  };

  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/history/history.js":
/*!********************************************************!*\
  !*** ./node_modules/swiper/modules/history/history.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return History; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");

function History({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides'
    }
  });
  var initialized = false;
  var paths = {};

  var slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };

  var getPathValues = urlOverride => {
    var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
    var location;

    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }

    var pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    var total = pathArray.length;
    var key = pathArray[total - 2];
    var value = pathArray[total - 1];
    return {
      key,
      value
    };
  };

  var setHistory = (key, index) => {
    var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
    if (!initialized || !swiper.params.history.enabled) return;
    var location;

    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }

    var slide = swiper.slides.eq(index);
    var value = slugify(slide.attr('data-history'));

    if (swiper.params.history.root.length > 0) {
      var root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = "".concat(root, "/").concat(key, "/").concat(value);
    } else if (!location.pathname.includes(key)) {
      value = "".concat(key, "/").concat(value);
    }

    var currentState = window.history.state;

    if (currentState && currentState.value === value) {
      return;
    }

    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };

  var scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var slide = swiper.slides.eq(i);
        var slideHistory = slugify(slide.attr('data-history'));

        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          var index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };

  var setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, swiper.paths.value, false);
  };

  var init = () => {
    var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
    if (!swiper.params.history) return;

    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }

    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) return;
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);

    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };

  var destroy = () => {
    var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();

    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };

  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/keyboard/keyboard.js":
/*!**********************************************************!*\
  !*** ./node_modules/swiper/modules/keyboard/keyboard.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Keyboard; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* eslint-disable consistent-return */


function Keyboard({
  swiper,
  extendParams,
  on,
  emit
}) {
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });

  function handle(event) {
    if (!swiper.enabled) return;
    var {
      rtlTranslate: rtl
    } = swiper;
    var e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    var kc = e.keyCode || e.charCode;
    var pageUpDown = swiper.params.keyboard.pageUpDown;
    var isPageUp = pageUpDown && kc === 33;
    var isPageDown = pageUpDown && kc === 34;
    var isArrowLeft = kc === 37;
    var isArrowRight = kc === 39;
    var isArrowUp = kc === 38;
    var isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      var inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents(".".concat(swiper.params.slideClass)).length > 0 && swiper.$el.parents(".".concat(swiper.params.slideActiveClass)).length === 0) {
        return undefined;
      }

      var $el = swiper.$el;
      var swiperWidth = $el[0].clientWidth;
      var swiperHeight = $el[0].clientHeight;
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];

      for (var i = 0; i < swiperCoord.length; i += 1) {
        var point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    emit('keyPress', kc);
    return undefined;
  }

  function enable() {
    if (swiper.keyboard.enabled) return;
    Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(document).on('keydown', handle);
    swiper.keyboard.enabled = true;
  }

  function disable() {
    if (!swiper.keyboard.enabled) return;
    Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(document).off('keydown', handle);
    swiper.keyboard.enabled = false;
  }

  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/lazy/lazy.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/modules/lazy/lazy.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Lazy; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");


function Lazy({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    lazy: {
      checkInView: false,
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      scrollingElement: '',
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  });
  swiper.lazy = {};
  var scrollHandlerAttached = false;
  var initialImageLoaded = false;

  function loadInSlide(index, loadInDuplicate = true) {
    var params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var $slideEl = isVirtual ? swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, "[data-swiper-slide-index=\"").concat(index, "\"]")) : swiper.slides.eq(index);
    var $images = $slideEl.find(".".concat(params.elementClass, ":not(.").concat(params.loadedClass, "):not(.").concat(params.loadingClass, ")"));

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images.push($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(imageEl => {
      var $imageEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(imageEl);
      $imageEl.addClass(params.loadingClass);
      var background = $imageEl.attr('data-background');
      var src = $imageEl.attr('data-src');
      var srcset = $imageEl.attr('data-srcset');
      var sizes = $imageEl.attr('data-sizes');
      var $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, () => {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', "url(\"".concat(background, "\")"));
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(sourceEl => {
              var $source = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(".".concat(params.preloaderClass)).remove();

        if (swiper.params.loop && loadInDuplicate) {
          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"".concat(slideOriginalIndex, "\"]:not(.").concat(swiper.params.slideDuplicateClass, ")"));
            loadInSlide(originalSlide.index(), false);
          } else {
            var duplicatedSlide = swiper.$wrapperEl.children(".".concat(swiper.params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(slideOriginalIndex, "\"]"));
            loadInSlide(duplicatedSlide.index(), false);
          }
        }

        emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  }

  function load() {
    var {
      $wrapperEl,
      params: swiperParams,
      slides,
      activeIndex
    } = swiper;
    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    var params = swiperParams.lazy;
    var slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(".".concat(swiperParams.slideClass, "[data-swiper-slide-index=\"").concat(index, "\"]")).length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(slideEl).attr('data-swiper-slide-index');
      }

      return Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(slideEl).index();
    }

    if (!initialImageLoaded) initialImageLoaded = true;

    if (swiper.params.watchSlidesProgress) {
      $wrapperEl.children(".".concat(swiperParams.slideVisibleClass)).each(slideEl => {
        var index = isVirtual ? Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(slideEl).attr('data-swiper-slide-index') : Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(slideEl).index();
        loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) loadInSlide(i);
      }
    } else {
      loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        var amount = params.loadPrevNextAmount;
        var spv = slidesPerView;
        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (var _i = activeIndex + slidesPerView; _i < maxIndex; _i += 1) {
          if (slideExist(_i)) loadInSlide(_i);
        } // Prev Slides


        for (var _i2 = minIndex; _i2 < activeIndex; _i2 += 1) {
          if (slideExist(_i2)) loadInSlide(_i2);
        }
      } else {
        var nextSlide = $wrapperEl.children(".".concat(swiperParams.slideNextClass));
        if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
        var prevSlide = $wrapperEl.children(".".concat(swiperParams.slidePrevClass));
        if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
      }
    }
  }

  function checkInViewOnLoad() {
    var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
    if (!swiper || swiper.destroyed) return;
    var $scrollElement = swiper.params.lazy.scrollingElement ? Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(swiper.params.lazy.scrollingElement) : Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(window);
    var isWindow = $scrollElement[0] === window;
    var scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
    var scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
    var swiperOffset = swiper.$el.offset();
    var {
      rtlTranslate: rtl
    } = swiper;
    var inView = false;
    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
    var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

    for (var i = 0; i < swiperCoord.length; i += 1) {
      var point = swiperCoord[i];

      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

        inView = true;
      }
    }

    var passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (inView) {
      load();
      $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
    } else if (!scrollHandlerAttached) {
      scrollHandlerAttached = true;
      $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
    }
  }

  on('beforeInit', () => {
    if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
      swiper.params.preloadImages = false;
    }
  });
  on('init', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('scroll', () => {
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) {
      load();
    }
  });
  on('scrollbarDragMove resize _freeModeNoMomentumRelease', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('transitionStart', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    }
  });
  on('transitionEnd', () => {
    if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('slideChange', () => {
    var {
      lazy,
      cssMode,
      watchSlidesProgress,
      touchReleaseOnEdges,
      resistanceRatio
    } = swiper.params;

    if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) {
      load();
    }
  });
  Object.assign(swiper.lazy, {
    load,
    loadInSlide
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/manipulation/manipulation.js":
/*!******************************************************************!*\
  !*** ./node_modules/swiper/modules/manipulation/manipulation.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Manipulation; });
/* harmony import */ var _methods_appendSlide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./methods/appendSlide.js */ "./node_modules/swiper/modules/manipulation/methods/appendSlide.js");
/* harmony import */ var _methods_prependSlide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./methods/prependSlide.js */ "./node_modules/swiper/modules/manipulation/methods/prependSlide.js");
/* harmony import */ var _methods_addSlide_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./methods/addSlide.js */ "./node_modules/swiper/modules/manipulation/methods/addSlide.js");
/* harmony import */ var _methods_removeSlide_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./methods/removeSlide.js */ "./node_modules/swiper/modules/manipulation/methods/removeSlide.js");
/* harmony import */ var _methods_removeAllSlides_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./methods/removeAllSlides.js */ "./node_modules/swiper/modules/manipulation/methods/removeAllSlides.js");





function Manipulation({
  swiper
}) {
  Object.assign(swiper, {
    appendSlide: _methods_appendSlide_js__WEBPACK_IMPORTED_MODULE_0__["default"].bind(swiper),
    prependSlide: _methods_prependSlide_js__WEBPACK_IMPORTED_MODULE_1__["default"].bind(swiper),
    addSlide: _methods_addSlide_js__WEBPACK_IMPORTED_MODULE_2__["default"].bind(swiper),
    removeSlide: _methods_removeSlide_js__WEBPACK_IMPORTED_MODULE_3__["default"].bind(swiper),
    removeAllSlides: _methods_removeAllSlides_js__WEBPACK_IMPORTED_MODULE_4__["default"].bind(swiper)
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/manipulation/methods/addSlide.js":
/*!**********************************************************************!*\
  !*** ./node_modules/swiper/modules/manipulation/methods/addSlide.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addSlide; });
function addSlide(index, slides) {
  var swiper = this;
  var {
    $wrapperEl,
    params,
    activeIndex
  } = swiper;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!params.observer) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

/***/ }),

/***/ "./node_modules/swiper/modules/manipulation/methods/appendSlide.js":
/*!*************************************************************************!*\
  !*** ./node_modules/swiper/modules/manipulation/methods/appendSlide.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return appendSlide; });
function appendSlide(slides) {
  var swiper = this;
  var {
    $wrapperEl,
    params
  } = swiper;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!params.observer) {
    swiper.update();
  }
}

/***/ }),

/***/ "./node_modules/swiper/modules/manipulation/methods/prependSlide.js":
/*!**************************************************************************!*\
  !*** ./node_modules/swiper/modules/manipulation/methods/prependSlide.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return prependSlide; });
function prependSlide(slides) {
  var swiper = this;
  var {
    params,
    $wrapperEl,
    activeIndex
  } = swiper;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!params.observer) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}

/***/ }),

/***/ "./node_modules/swiper/modules/manipulation/methods/removeAllSlides.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/swiper/modules/manipulation/methods/removeAllSlides.js ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return removeAllSlides; });
function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}

/***/ }),

/***/ "./node_modules/swiper/modules/manipulation/methods/removeSlide.js":
/*!*************************************************************************!*\
  !*** ./node_modules/swiper/modules/manipulation/methods/removeSlide.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return removeSlide; });
function removeSlide(slidesIndexes) {
  var swiper = this;
  var {
    params,
    $wrapperEl,
    activeIndex
  } = swiper;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!params.observer) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

/***/ }),

/***/ "./node_modules/swiper/modules/mousewheel/mousewheel.js":
/*!**************************************************************!*\
  !*** ./node_modules/swiper/modules/mousewheel/mousewheel.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Mousewheel; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");
/* eslint-disable consistent-return */



function Mousewheel({
  swiper,
  extendParams,
  on,
  emit
}) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  var timeout;
  var lastScrollTime = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["now"])();
  var lastEventBeforeSnap;
  var recentWheelEvents = [];

  function normalize(e) {
    // Reasonable defaults
    var PIXEL_STEP = 10;
    var LINE_HEIGHT = 40;
    var PAGE_HEIGHT = 800;
    var sX = 0;
    var sY = 0; // spinX, spinY

    var pX = 0;
    var pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }

  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }

  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }

  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }

    if (swiper.params.mousewheel.thresholdTime && Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["now"])() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    } // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).


    if (newEvent.delta >= 6 && Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["now"])() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    lastScrollTime = new window.Date().getTime(); // Return false as a default

    return false;
  }

  function releaseScroll(newEvent) {
    var params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  }

  function handle(event) {
    var e = event;
    var disableParentSwiper = true;
    if (!swiper.enabled) return;
    var params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    var target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(swiper.params.mousewheel.eventsTarget);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    var delta = 0;
    var rtlFactor = swiper.rtlTranslate ? -1 : 1;
    var data = normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta; // Get the scroll positions

    var positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.

    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();

    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      var newEvent = {
        time: Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["now"])(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      var _newEvent = {
        time: Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["now"])(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      var ignoreWheelEvents = lastEventBeforeSnap && _newEvent.time < lastEventBeforeSnap.time + 500 && _newEvent.delta <= lastEventBeforeSnap.delta && _newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        var position = swiper.getTranslate() + delta * params.sensitivity;
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;

          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          var _prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;

          var firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(_newEvent);

          if (_prevEvent && (_newEvent.delta > _prevEvent.delta || _newEvent.direction !== _prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && _newEvent.time - firstEvent.time < 500 && firstEvent.delta - _newEvent.delta >= 1 && _newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            var snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = _newEvent;
            recentWheelEvents.splice(0);
            timeout = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["nextTick"])(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["nextTick"])(() => {
              var snapToThreshold = 0.5;
              lastEventBeforeSnap = _newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }

  function events(method) {
    var target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(swiper.params.mousewheel.eventsTarget);
    }

    target[method]('mouseenter', handleMouseEnter);
    target[method]('mouseleave', handleMouseLeave);
    target[method]('wheel', handle);
  }

  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }

    if (swiper.mousewheel.enabled) return false;
    events('on');
    swiper.mousewheel.enabled = true;
    return true;
  }

  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }

    if (!swiper.mousewheel.enabled) return false;
    events('off');
    swiper.mousewheel.enabled = false;
    return true;
  }

  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }

    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }

    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/navigation/navigation.js":
/*!**************************************************************!*\
  !*** ./node_modules/swiper/modules/navigation/navigation.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Navigation; });
/* harmony import */ var _shared_create_element_if_not_defined_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/create-element-if-not-defined.js */ "./node_modules/swiper/shared/create-element-if-not-defined.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");


function Navigation({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  });
  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };

  function getEl(el) {
    var $el;

    if (el) {
      $el = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(el);

      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
        $el = swiper.$el.find(el);
      }
    }

    return $el;
  }

  function toggleEl($el, disabled) {
    var params = swiper.params.navigation;

    if ($el && $el.length > 0) {
      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;

      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  }

  function update() {
    // Update Navigation Buttons
    if (swiper.params.loop) return;
    var {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }

  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
  }

  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
  }

  function init() {
    var params = swiper.params.navigation;
    swiper.params.navigation = Object(_shared_create_element_if_not_defined_js__WEBPACK_IMPORTED_MODULE_0__["default"])(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl = getEl(params.nextEl);
    var $prevEl = getEl(params.prevEl);

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', onPrevClick);
    }

    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  }

  function destroy() {
    var {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }

  on('init', () => {
    init();
    update();
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    var {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl) {
      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }

    if ($prevEl) {
      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
  });
  on('click', (_s, e) => {
    var {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    var targetEl = e.target;

    if (swiper.params.navigation.hideOnClick && !Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(targetEl).is($prevEl) && !Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      var isHidden;

      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }

      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }

      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }

      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });
  Object.assign(swiper.navigation, {
    update,
    init,
    destroy
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/pagination/pagination.js":
/*!**************************************************************!*\
  !*** ./node_modules/swiper/modules/pagination/pagination.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Pagination; });
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/classes-to-selector.js */ "./node_modules/swiper/shared/classes-to-selector.js");
/* harmony import */ var _shared_create_element_if_not_defined_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/create-element-if-not-defined.js */ "./node_modules/swiper/shared/create-element-if-not-defined.js");



function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  var pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: "".concat(pfx, "-bullet"),
      bulletActiveClass: "".concat(pfx, "-bullet-active"),
      modifierClass: "".concat(pfx, "-"),
      currentClass: "".concat(pfx, "-current"),
      totalClass: "".concat(pfx, "-total"),
      hiddenClass: "".concat(pfx, "-hidden"),
      progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
      progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
      clickableClass: "".concat(pfx, "-clickable"),
      lockClass: "".concat(pfx, "-lock"),
      horizontalClass: "".concat(pfx, "-horizontal"),
      verticalClass: "".concat(pfx, "-vertical")
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  var bulletSize;
  var dynamicBulletIndex = 0;

  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }

  function setSideBullets($bulletEl, position) {
    var {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass("".concat(bulletActiveClass, "-").concat(position))[position]().addClass("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
  }

  function update() {
    // Render || Update Pagination bullets/items
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', "".concat(bulletSize * (params.dynamicMainBullets + 4), "px"));

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }

        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => "".concat(params.bulletActiveClass).concat(suffix)).join(' '));

      if ($el.length > 1) {
        bullets.each(bullet => {
          var $bullet = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass("".concat(params.bulletActiveClass, "-main"));
            }

            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }

            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass("".concat(params.bulletActiveClass, "-main"));
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass("".concat(params.bulletActiveClass, "-main"));
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass("".concat(params.bulletActiveClass, "-prev"));
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', "".concat(bulletsOffset, "px"));
      }
    }

    if (params.type === 'fraction') {
      $el.find(Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")")).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }

  function render() {
    // Render Container
    var params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<".concat(params.bulletElement, " class=\"").concat(params.bulletClass, "\"></").concat(params.bulletElement, ">");
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"".concat(params.currentClass, "\"></span>") + ' / ' + "<span class=\"".concat(params.totalClass, "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"".concat(params.progressbarFillClass, "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }

  function init() {
    swiper.params.pagination = Object(_shared_create_element_if_not_defined_js__WEBPACK_IMPORTED_MODULE_2__["default"])(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(el => {
          if (Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);
    $el.addClass(params.modifierClass + swiper.params.direction);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("".concat(params.modifierClass).concat(params.type, "-dynamic"));
      dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }

  function destroy() {
    var params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(params.modifierClass + swiper.params.direction);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', Object(_shared_classes_to_selector_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.bulletClass));
    }
  }

  on('init', () => {
    init();
    render();
    update();
  });
  on('activeIndexChange', () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    var {
      $el
    } = swiper.pagination;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    var targetEl = e.target;
    var {
      $el
    } = swiper.pagination;

    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el.length > 0 && !Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      var isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }

      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });
  Object.assign(swiper.pagination, {
    render,
    update,
    init,
    destroy
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/pagination/pagination.min.css":
/*!*******************************************************************!*\
  !*** ./node_modules/swiper/modules/pagination/pagination.min.css ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(/*! ../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__(/*! !../../../css-loader/dist/cjs.js?importLoaders!../../../postcss-loader/dist/cjs.js!./pagination.min.css */ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/modules/pagination/pagination.min.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./node_modules/swiper/modules/parallax/parallax.js":
/*!**********************************************************!*\
  !*** ./node_modules/swiper/modules/parallax/parallax.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Parallax; });
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");

function Parallax({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    parallax: {
      enabled: false
    }
  });

  var setTransform = (el, progress) => {
    var {
      rtl
    } = swiper;
    var $el = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(el);
    var rtlFactor = rtl ? -1 : 1;
    var p = $el.attr('data-swiper-parallax') || '0';
    var x = $el.attr('data-swiper-parallax-x');
    var y = $el.attr('data-swiper-parallax-y');
    var scale = $el.attr('data-swiper-parallax-scale');
    var opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
    } else {
      x = "".concat(x * progress * rtlFactor, "px");
    }

    if (y.indexOf('%') >= 0) {
      y = "".concat(parseInt(y, 10) * progress, "%");
    } else {
      y = "".concat(y * progress, "px");
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px)"));
    } else {
      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px) scale(").concat(currentScale, ")"));
    }
  };

  var setTranslate = () => {
    var {
      $el,
      slides,
      progress,
      snapGrid
    } = swiper;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
      setTransform(el, progress);
    });
    slides.each((slideEl, slideIndex) => {
      var slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
        setTransform(el, slideProgress);
      });
    });
  };

  var setTransition = (duration = swiper.params.speed) => {
    var {
      $el
    } = swiper;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(parallaxEl => {
      var $parallaxEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(parallaxEl);
      var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  };

  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/scrollbar/scrollbar.js":
/*!************************************************************!*\
  !*** ./node_modules/swiper/modules/scrollbar/scrollbar.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Scrollbar; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");
/* harmony import */ var _shared_create_element_if_not_defined_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../shared/create-element-if-not-defined.js */ "./node_modules/swiper/shared/create-element-if-not-defined.js");




function Scrollbar({
  swiper,
  extendParams,
  on,
  emit
}) {
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  var isTouched = false;
  var timeout = null;
  var dragTimeout = null;
  var dragStartPos;
  var dragSize;
  var trackSize;
  var divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };

  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var {
      scrollbar,
      rtlTranslate: rtl,
      progress
    } = swiper;
    var {
      $dragEl,
      $el
    } = scrollbar;
    var params = swiper.params.scrollbar;
    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform("translate3d(".concat(newPos, "px, 0, 0)"));
      $dragEl[0].style.width = "".concat(newSize, "px");
    } else {
      $dragEl.transform("translate3d(0px, ".concat(newPos, "px, 0)"));
      $dragEl[0].style.height = "".concat(newSize, "px");
    }

    if (params.hide) {
      clearTimeout(timeout);
      $el[0].style.opacity = 1;
      timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  }

  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  }

  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var {
      scrollbar
    } = swiper;
    var {
      $dragEl,
      $el
    } = scrollbar;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = "".concat(dragSize, "px");
    } else {
      $dragEl[0].style.height = "".concat(dragSize, "px");
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function getPointerPosition(e) {
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  }

  function setDragPosition(e) {
    var {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    var {
      $el
    } = scrollbar;
    var positionRatio;
    positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  function onDragStart(e) {
    var params = swiper.params.scrollbar;
    var {
      scrollbar,
      $wrapperEl
    } = swiper;
    var {
      $el,
      $dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    setDragPosition(e);
    clearTimeout(dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    emit('scrollbarDragStart', e);
  }

  function onDragMove(e) {
    var {
      scrollbar,
      $wrapperEl
    } = swiper;
    var {
      $el,
      $dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    emit('scrollbarDragMove', e);
  }

  function onDragEnd(e) {
    var params = swiper.params.scrollbar;
    var {
      scrollbar,
      $wrapperEl
    } = swiper;
    var {
      $el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["nextTick"])(() => {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }

  function events(method) {
    var {
      scrollbar,
      touchEventsTouch,
      touchEventsDesktop,
      params,
      support
    } = swiper;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    var eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';

    if (!support.touch) {
      target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
      document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
      document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
    } else {
      target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
      target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
      target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
    }
  }

  function enableDraggable() {
    if (!swiper.params.scrollbar.el) return;
    events('on');
  }

  function disableDraggable() {
    if (!swiper.params.scrollbar.el) return;
    events('off');
  }

  function init() {
    var {
      scrollbar,
      $el: $swiperEl
    } = swiper;
    swiper.params.scrollbar = Object(_shared_create_element_if_not_defined_js__WEBPACK_IMPORTED_MODULE_3__["default"])(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    var params = swiper.params.scrollbar;
    if (!params.el) return;
    var $el = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find(".".concat(swiper.params.scrollbar.dragClass));

    if ($dragEl.length === 0) {
      $dragEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])("<div class=\"".concat(swiper.params.scrollbar.dragClass, "\"></div>"));
      $el.append($dragEl);
    }

    Object.assign(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function destroy() {
    disableDraggable();
  }

  on('init', () => {
    init();
    updateSize();
    setTranslate();
  });
  on('update resize observerUpdate lock unlock', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    var {
      $el
    } = swiper.scrollbar;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  });
  on('destroy', () => {
    destroy();
  });
  Object.assign(swiper.scrollbar, {
    updateSize,
    setTranslate,
    init,
    destroy
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/thumbs/thumbs.js":
/*!******************************************************!*\
  !*** ./node_modules/swiper/modules/thumbs/thumbs.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Thumb; });
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");


function Thumb({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  var initialized = false;
  var swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };

  function onThumbClick() {
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var clickedIndex = thumbsSwiper.clickedIndex;
    var clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    var slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      var currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"".concat(slideToIndex, "\"]")).eq(0).index();
      var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"".concat(slideToIndex, "\"]")).eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  }

  function init() {
    var {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    var SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_0__["isObject"])(thumbsParams.swiper)) {
      var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    return true;
  }

  function update(initial) {
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      var currentThumbsIndex = thumbsSwiper.activeIndex;
      var newThumbsIndex;
      var direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"".concat(swiper.realIndex, "\"]")).eq(0).index();
        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"".concat(swiper.realIndex, "\"]")).eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    } // Activate thumbs


    var thumbsToActivate = 1;
    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (var i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"".concat(swiper.realIndex + i, "\"]")).addClass(thumbActiveClass);
      }
    } else {
      for (var _i = 0; _i < thumbsToActivate; _i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
      }
    }
  }

  on('beforeInit', () => {
    var {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    init();
    update(true);
  });
  on('slideChange update resize observerUpdate', () => {
    if (!swiper.thumbs.swiper) return;
    update();
  });
  on('setTransition', (_s, duration) => {
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;

    if (swiperCreated && thumbsSwiper) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/virtual/virtual.js":
/*!********************************************************!*\
  !*** ./node_modules/swiper/modules/virtual/virtual.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Virtual; });
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");


function Virtual({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  var cssModeTimeout;
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };

  function renderSlide(slide, index) {
    var params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    var $slideEl = params.renderSlide ? Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params.renderSlide.call(swiper, slide, index)) : Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])("<div class=\"".concat(swiper.params.slideClass, "\" data-swiper-slide-index=\"").concat(index, "\">").concat(slide, "</div>"));
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  }

  function update(force) {
    var {
      slidesPerView,
      slidesPerGroup,
      centeredSlides
    } = swiper.params;
    var {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    var {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;

    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }

    var activeIndex = swiper.activeIndex || 0;
    var offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    var slidesAfter;
    var slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, "".concat(offset, "px"));
      }

      swiper.updateProgress();
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          var slidesToRender = [];

          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      }

      return;
    }

    var prependIndexes = [];
    var appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find(".".concat(swiper.params.slideClass)).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(".".concat(swiper.params.slideClass, "[data-swiper-slide-index=\"").concat(i, "\"]")).remove();
        }
      }
    }

    for (var _i = 0; _i < slides.length; _i += 1) {
      if (_i >= from && _i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(_i);
        } else {
          if (_i > previousTo) appendIndexes.push(_i);
          if (_i < previousFrom) prependIndexes.push(_i);
        }
      }
    }

    appendIndexes.forEach(index => {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort((a, b) => b - a).forEach(index => {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, "".concat(offset, "px"));
    onRendered();
  }

  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    update(true);
  }

  function prependSlide(slides) {
    var activeIndex = swiper.activeIndex;
    var newActiveIndex = activeIndex + 1;
    var numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      var cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        var $cachedEl = cache[cachedIndex];
        var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }

  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    var activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    update(true);
    swiper.slideTo(activeIndex, 0);
  }

  function removeAllSlides() {
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    update(true);
    swiper.slideTo(0, 0);
  }

  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    swiper.virtual.slides = swiper.params.virtual.slides;
    swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;

    if (!swiper.params.initialSlide) {
      update();
    }
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode) {
      Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_1__["setCSSProperty"])(swiper.wrapperEl, '--swiper-virtual-size', "".concat(swiper.virtualSize, "px"));
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}

/***/ }),

/***/ "./node_modules/swiper/modules/zoom/zoom.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/modules/zoom/zoom.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Zoom; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _shared_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/dom.js */ "./node_modules/swiper/shared/dom.js");
/* harmony import */ var _shared_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/utils.js */ "./node_modules/swiper/shared/utils.js");



function Zoom({
  swiper,
  extendParams,
  on,
  emit
}) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  extendParams({
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  var currentScale = 1;
  var isScaling = false;
  var gesturesEnabled;
  var fakeGestureTouched;
  var fakeGestureMoved;
  var gesture = {
    $slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    $imageEl: undefined,
    $imageWrapEl: undefined,
    maxRatio: 3
  };
  var image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  var velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  var scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },

    set(value) {
      if (scale !== value) {
        var imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
        var slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
        emit('zoomChange', value, imageEl, slideEl);
      }

      scale = value;
    }

  });

  function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    var x1 = e.targetTouches[0].pageX;
    var y1 = e.targetTouches[0].pageY;
    var x2 = e.targetTouches[1].pageX;
    var y2 = e.targetTouches[1].pageY;
    var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    return distance;
  } // Events


  function onGestureStart(e) {
    var support = swiper.support;
    var params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;

    if (!support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureTouched = true;
      gesture.scaleStart = getDistanceBetweenTouches(e);
    }

    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(e.target).closest(".".concat(swiper.params.slideClass));
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }

    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }

    isScaling = true;
  }

  function onGestureChange(e) {
    var support = swiper.support;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;

    if (!support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureMoved = true;
      gesture.scaleMove = getDistanceBetweenTouches(e);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
      if (e.type === 'gesturechange') onGestureStart(e);
      return;
    }

    if (support.gestures) {
      zoom.scale = e.scale * currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    }

    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
    }

    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
    }

    gesture.$imageEl.transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
  }

  function onGestureEnd(e) {
    var device = swiper.device;
    var support = swiper.support;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;

    if (!support.gestures) {
      if (!fakeGestureTouched || !fakeGestureMoved) {
        return;
      }

      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
        return;
      }

      fakeGestureTouched = false;
      fakeGestureMoved = false;
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  }

  function onTouchStart(e) {
    var device = swiper.device;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  }

  function onTouchMove(e) {
    var zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["getTranslate"])(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = Object(_shared_utils_js__WEBPACK_IMPORTED_MODULE_2__["getTranslate"])(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
    } // Define if we need image drag


    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }

      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }

    if (e.cancelable) {
      e.preventDefault();
    }

    e.stopPropagation();
    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
    }

    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
    }

    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
    } // Velocity


    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.$imageWrapEl.transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
  }

  function onTouchEnd() {
    var zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }

    image.isTouched = false;
    image.isMoved = false;
    var momentumDurationX = 300;
    var momentumDurationY = 300;
    var momentumDistanceX = velocity.x * momentumDurationX;
    var newPositionX = image.currentX + momentumDistanceX;
    var momentumDistanceY = velocity.y * momentumDurationY;
    var newPositionY = image.currentY + momentumDistanceY; // Fix duration

    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY; // Define if we need image drag

    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
  }

  function onTransitionEnd() {
    var zoom = swiper.zoom;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }

      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      currentScale = 1;
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  }

  function zoomIn(e) {
    var zoom = swiper.zoom;
    var params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (e && e.target) {
        gesture.$slideEl = Object(_shared_dom_js__WEBPACK_IMPORTED_MODULE_1__["default"])(e.target).closest(".".concat(swiper.params.slideClass));
      }

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
      }

      gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }

    gesture.$slideEl.addClass("".concat(params.zoomedSlideClass));
    var touchX;
    var touchY;
    var offsetX;
    var offsetY;
    var diffX;
    var diffY;
    var translateX;
    var translateY;
    var imageWidth;
    var imageHeight;
    var scaledWidth;
    var scaledHeight;
    var translateMinX;
    var translateMinY;
    var translateMaxX;
    var translateMaxY;
    var slideWidth;
    var slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left + window.scrollX;
      offsetY = gesture.$slideEl.offset().top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }

      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }

      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }

    gesture.$imageWrapEl.transition(300).transform("translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)"));
    gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
  }

  function zoomOut() {
    var zoom = swiper.zoom;
    var params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }

    zoom.scale = 1;
    currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass("".concat(params.zoomedSlideClass));
    gesture.$slideEl = undefined;
  } // Toggle Zoom


  function zoomToggle(e) {
    var zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }

  function getListeners() {
    var support = swiper.support;
    var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    var activeListenerWithCapture = support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  function getSlideSelector() {
    return ".".concat(swiper.params.slideClass);
  }

  function toggleGestures(method) {
    var {
      passiveListener
    } = getListeners();
    var slideSelector = getSlideSelector();
    swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
    swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
    swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
  }

  function enableGestures() {
    if (gesturesEnabled) return;
    gesturesEnabled = true;
    toggleGestures('on');
  }

  function disableGestures() {
    if (!gesturesEnabled) return;
    gesturesEnabled = false;
    toggleGestures('off');
  } // Attach/Detach Events


  function enable() {
    var zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    var support = swiper.support;
    var {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    var slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.on(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), onTouchMove, activeListenerWithCapture);
  }

  function disable() {
    var zoom = swiper.zoom;
    if (!zoom.enabled) return;
    var support = swiper.support;
    zoom.enabled = false;
    var {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    var slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.off(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), onTouchMove, activeListenerWithCapture);
  }

  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd(e);
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}

/***/ }),

/***/ "./node_modules/swiper/shared/classes-to-selector.js":
/*!***********************************************************!*\
  !*** ./node_modules/swiper/shared/classes-to-selector.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return classesToSelector; });
function classesToSelector(classes = '') {
  return ".".concat(classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.'));
}

/***/ }),

/***/ "./node_modules/swiper/shared/create-element-if-not-defined.js":
/*!*********************************************************************!*\
  !*** ./node_modules/swiper/shared/create-element-if-not-defined.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return createElementIfNotDefined; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");

function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();

  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        var element = swiper.$el.children(".".concat(checkProps[key]))[0];

        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }

        params[key] = element;
        originalParams[key] = element;
      }
    });
  }

  return params;
}

/***/ }),

/***/ "./node_modules/swiper/shared/create-shadow.js":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/shared/create-shadow.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return createShadow; });
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dom.js */ "./node_modules/swiper/shared/dom.js");

function createShadow(params, $slideEl, side) {
  var shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : '');
  var $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
  var $shadowEl = $shadowContainer.children(".".concat(shadowClass));

  if (!$shadowEl.length) {
    $shadowEl = Object(_dom_js__WEBPACK_IMPORTED_MODULE_0__["default"])("<div class=\"swiper-slide-shadow".concat(side ? "-".concat(side) : '', "\"></div>"));
    $shadowContainer.append($shadowEl);
  }

  return $shadowEl;
}

/***/ }),

/***/ "./node_modules/swiper/shared/dom.js":
/*!*******************************************!*\
  !*** ./node_modules/swiper/shared/dom.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var dom7__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! dom7 */ "./node_modules/dom7/dom7.esm.js");

var Methods = {
  addClass: dom7__WEBPACK_IMPORTED_MODULE_0__["addClass"],
  removeClass: dom7__WEBPACK_IMPORTED_MODULE_0__["removeClass"],
  hasClass: dom7__WEBPACK_IMPORTED_MODULE_0__["hasClass"],
  toggleClass: dom7__WEBPACK_IMPORTED_MODULE_0__["toggleClass"],
  attr: dom7__WEBPACK_IMPORTED_MODULE_0__["attr"],
  removeAttr: dom7__WEBPACK_IMPORTED_MODULE_0__["removeAttr"],
  transform: dom7__WEBPACK_IMPORTED_MODULE_0__["transform"],
  transition: dom7__WEBPACK_IMPORTED_MODULE_0__["transition"],
  on: dom7__WEBPACK_IMPORTED_MODULE_0__["on"],
  off: dom7__WEBPACK_IMPORTED_MODULE_0__["off"],
  trigger: dom7__WEBPACK_IMPORTED_MODULE_0__["trigger"],
  transitionEnd: dom7__WEBPACK_IMPORTED_MODULE_0__["transitionEnd"],
  outerWidth: dom7__WEBPACK_IMPORTED_MODULE_0__["outerWidth"],
  outerHeight: dom7__WEBPACK_IMPORTED_MODULE_0__["outerHeight"],
  styles: dom7__WEBPACK_IMPORTED_MODULE_0__["styles"],
  offset: dom7__WEBPACK_IMPORTED_MODULE_0__["offset"],
  css: dom7__WEBPACK_IMPORTED_MODULE_0__["css"],
  each: dom7__WEBPACK_IMPORTED_MODULE_0__["each"],
  html: dom7__WEBPACK_IMPORTED_MODULE_0__["html"],
  text: dom7__WEBPACK_IMPORTED_MODULE_0__["text"],
  is: dom7__WEBPACK_IMPORTED_MODULE_0__["is"],
  index: dom7__WEBPACK_IMPORTED_MODULE_0__["index"],
  eq: dom7__WEBPACK_IMPORTED_MODULE_0__["eq"],
  append: dom7__WEBPACK_IMPORTED_MODULE_0__["append"],
  prepend: dom7__WEBPACK_IMPORTED_MODULE_0__["prepend"],
  next: dom7__WEBPACK_IMPORTED_MODULE_0__["next"],
  nextAll: dom7__WEBPACK_IMPORTED_MODULE_0__["nextAll"],
  prev: dom7__WEBPACK_IMPORTED_MODULE_0__["prev"],
  prevAll: dom7__WEBPACK_IMPORTED_MODULE_0__["prevAll"],
  parent: dom7__WEBPACK_IMPORTED_MODULE_0__["parent"],
  parents: dom7__WEBPACK_IMPORTED_MODULE_0__["parents"],
  closest: dom7__WEBPACK_IMPORTED_MODULE_0__["closest"],
  find: dom7__WEBPACK_IMPORTED_MODULE_0__["find"],
  children: dom7__WEBPACK_IMPORTED_MODULE_0__["children"],
  filter: dom7__WEBPACK_IMPORTED_MODULE_0__["filter"],
  remove: dom7__WEBPACK_IMPORTED_MODULE_0__["remove"]
};
Object.keys(Methods).forEach(methodName => {
  Object.defineProperty(dom7__WEBPACK_IMPORTED_MODULE_0__["$"].fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ __webpack_exports__["default"] = (dom7__WEBPACK_IMPORTED_MODULE_0__["$"]);

/***/ }),

/***/ "./node_modules/swiper/shared/effect-init.js":
/*!***************************************************!*\
  !*** ./node_modules/swiper/shared/effect-init.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return effectInit; });
function effectInit(params) {
  var {
    effect,
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams,
    perspective
  } = params;
  on('beforeInit', () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push("".concat(swiper.params.containerModifierClass).concat(effect));

    if (perspective && perspective()) {
      swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
    }

    var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on('setTranslate', () => {
    if (swiper.params.effect !== effect) return;
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition(duration);
  });
}

/***/ }),

/***/ "./node_modules/swiper/shared/effect-target.js":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/shared/effect-target.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return effectTarget; });
function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      'backface-visibility': 'hidden',
      '-webkit-backface-visibility': 'hidden'
    });
  }

  return $slideEl;
}

/***/ }),

/***/ "./node_modules/swiper/shared/effect-virtual-transition-end.js":
/*!*********************************************************************!*\
  !*** ./node_modules/swiper/shared/effect-virtual-transition-end.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return effectVirtualTransitionEnd; });
function effectVirtualTransitionEnd({
  swiper,
  duration,
  transformEl,
  allSlides
}) {
  var {
    slides,
    activeIndex,
    $wrapperEl
  } = swiper;

  if (swiper.params.virtualTranslate && duration !== 0) {
    var eventTriggered = false;
    var $transitionEndTarget;

    if (allSlides) {
      $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
    } else {
      $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
    }

    $transitionEndTarget.transitionEnd(() => {
      if (eventTriggered) return;
      if (!swiper || swiper.destroyed) return;
      eventTriggered = true;
      swiper.animating = false;
      var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

      for (var i = 0; i < triggerEvents.length; i += 1) {
        $wrapperEl.trigger(triggerEvents[i]);
      }
    });
  }
}

/***/ }),

/***/ "./node_modules/swiper/shared/get-browser.js":
/*!***************************************************!*\
  !*** ./node_modules/swiper/shared/get-browser.js ***!
  \***************************************************/
/*! exports provided: getBrowser */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBrowser", function() { return getBrowser; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");

var browser;

function calcBrowser() {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}



/***/ }),

/***/ "./node_modules/swiper/shared/get-device.js":
/*!**************************************************!*\
  !*** ./node_modules/swiper/shared/get-device.js ***!
  \**************************************************/
/*! exports provided: getDevice */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDevice", function() { return getDevice; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");
/* harmony import */ var _get_support_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./get-support.js */ "./node_modules/swiper/shared/get-support.js");


var deviceCached;

function calcDevice({
  userAgent
} = {}) {
  var support = Object(_get_support_js__WEBPACK_IMPORTED_MODULE_1__["getSupport"])();
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}



/***/ }),

/***/ "./node_modules/swiper/shared/get-support.js":
/*!***************************************************!*\
  !*** ./node_modules/swiper/shared/get-support.js ***!
  \***************************************************/
/*! exports provided: getSupport */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSupport", function() { return getSupport; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");

var support;

function calcSupport() {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var document = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getDocument"])();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }

        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}



/***/ }),

/***/ "./node_modules/swiper/shared/utils.js":
/*!*********************************************!*\
  !*** ./node_modules/swiper/shared/utils.js ***!
  \*********************************************/
/*! exports provided: animateCSSModeScroll, deleteProps, nextTick, now, getTranslate, isObject, extend, getComputedStyle, setCSSProperty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateCSSModeScroll", function() { return animateCSSModeScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProps", function() { return deleteProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextTick", function() { return nextTick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return now; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTranslate", function() { return getTranslate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getComputedStyle", function() { return getComputedStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCSSProperty", function() { return setCSSProperty; });
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ssr-window */ "./node_modules/ssr-window/ssr-window.esm.js");


function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function getComputedStyle(el) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis = 'x') {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend(...args) {
  var to = Object(args[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < args.length; i += 1) {
    var nextSource = args[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  var window = Object(ssr_window__WEBPACK_IMPORTED_MODULE_0__["getWindow"])();
  var startPosition = -swiper.translate;
  var startTime = null;
  var time;
  var duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  var dir = targetPosition > startPosition ? 'next' : 'prev';

  var isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  var animate = () => {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}



/***/ }),

/***/ "./node_modules/swiper/swiper.esm.js":
/*!*******************************************!*\
  !*** ./node_modules/swiper/swiper.esm.js ***!
  \*******************************************/
/*! exports provided: Swiper, default, Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Lazy, Controller, A11y, History, HashNavigation, Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _core_core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core/core.js */ "./node_modules/swiper/core/core.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Swiper", function() { return _core_core_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _core_core_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _modules_virtual_virtual_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/virtual/virtual.js */ "./node_modules/swiper/modules/virtual/virtual.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Virtual", function() { return _modules_virtual_virtual_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _modules_keyboard_keyboard_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/keyboard/keyboard.js */ "./node_modules/swiper/modules/keyboard/keyboard.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Keyboard", function() { return _modules_keyboard_keyboard_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _modules_mousewheel_mousewheel_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/mousewheel/mousewheel.js */ "./node_modules/swiper/modules/mousewheel/mousewheel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mousewheel", function() { return _modules_mousewheel_mousewheel_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _modules_navigation_navigation_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/navigation/navigation.js */ "./node_modules/swiper/modules/navigation/navigation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Navigation", function() { return _modules_navigation_navigation_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _modules_pagination_pagination_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/pagination/pagination.js */ "./node_modules/swiper/modules/pagination/pagination.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return _modules_pagination_pagination_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _modules_scrollbar_scrollbar_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/scrollbar/scrollbar.js */ "./node_modules/swiper/modules/scrollbar/scrollbar.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scrollbar", function() { return _modules_scrollbar_scrollbar_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _modules_parallax_parallax_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/parallax/parallax.js */ "./node_modules/swiper/modules/parallax/parallax.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Parallax", function() { return _modules_parallax_parallax_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _modules_zoom_zoom_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/zoom/zoom.js */ "./node_modules/swiper/modules/zoom/zoom.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Zoom", function() { return _modules_zoom_zoom_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _modules_lazy_lazy_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/lazy/lazy.js */ "./node_modules/swiper/modules/lazy/lazy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Lazy", function() { return _modules_lazy_lazy_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _modules_controller_controller_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/controller/controller.js */ "./node_modules/swiper/modules/controller/controller.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Controller", function() { return _modules_controller_controller_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _modules_a11y_a11y_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/a11y/a11y.js */ "./node_modules/swiper/modules/a11y/a11y.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "A11y", function() { return _modules_a11y_a11y_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _modules_history_history_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/history/history.js */ "./node_modules/swiper/modules/history/history.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "History", function() { return _modules_history_history_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _modules_hash_navigation_hash_navigation_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/hash-navigation/hash-navigation.js */ "./node_modules/swiper/modules/hash-navigation/hash-navigation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HashNavigation", function() { return _modules_hash_navigation_hash_navigation_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _modules_autoplay_autoplay_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/autoplay/autoplay.js */ "./node_modules/swiper/modules/autoplay/autoplay.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Autoplay", function() { return _modules_autoplay_autoplay_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _modules_thumbs_thumbs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./modules/thumbs/thumbs.js */ "./node_modules/swiper/modules/thumbs/thumbs.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Thumbs", function() { return _modules_thumbs_thumbs_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _modules_free_mode_free_mode_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./modules/free-mode/free-mode.js */ "./node_modules/swiper/modules/free-mode/free-mode.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FreeMode", function() { return _modules_free_mode_free_mode_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _modules_grid_grid_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/grid/grid.js */ "./node_modules/swiper/modules/grid/grid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return _modules_grid_grid_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _modules_manipulation_manipulation_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/manipulation/manipulation.js */ "./node_modules/swiper/modules/manipulation/manipulation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Manipulation", function() { return _modules_manipulation_manipulation_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _modules_effect_fade_effect_fade_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./modules/effect-fade/effect-fade.js */ "./node_modules/swiper/modules/effect-fade/effect-fade.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffectFade", function() { return _modules_effect_fade_effect_fade_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _modules_effect_cube_effect_cube_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./modules/effect-cube/effect-cube.js */ "./node_modules/swiper/modules/effect-cube/effect-cube.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffectCube", function() { return _modules_effect_cube_effect_cube_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _modules_effect_flip_effect_flip_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./modules/effect-flip/effect-flip.js */ "./node_modules/swiper/modules/effect-flip/effect-flip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffectFlip", function() { return _modules_effect_flip_effect_flip_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _modules_effect_coverflow_effect_coverflow_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./modules/effect-coverflow/effect-coverflow.js */ "./node_modules/swiper/modules/effect-coverflow/effect-coverflow.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffectCoverflow", function() { return _modules_effect_coverflow_effect_coverflow_js__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _modules_effect_creative_effect_creative_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./modules/effect-creative/effect-creative.js */ "./node_modules/swiper/modules/effect-creative/effect-creative.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffectCreative", function() { return _modules_effect_creative_effect_creative_js__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _modules_effect_cards_effect_cards_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./modules/effect-cards/effect-cards.js */ "./node_modules/swiper/modules/effect-cards/effect-cards.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EffectCards", function() { return _modules_effect_cards_effect_cards_js__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/**
 * Swiper 7.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 24, 2021
 */


























/***/ }),

/***/ "./node_modules/swiper/swiper.min.css":
/*!********************************************!*\
  !*** ./node_modules/swiper/swiper.min.css ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(/*! ../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__(/*! !../css-loader/dist/cjs.js?importLoaders!../postcss-loader/dist/cjs.js!./swiper.min.css */ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./node_modules/swiper/swiper.min.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./node_modules/timers-browserify/main.js":
/*!************************************************!*\
  !*** ./node_modules/timers-browserify/main.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply; // DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};

exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};

exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}

Timeout.prototype.unref = Timeout.prototype.ref = function () {};

Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
}; // Does not start the time, just sets up the members needed.


exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);
  var msecs = item._idleTimeout;

  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
}; // setimmediate attaches itself to the global object


__webpack_require__(/*! setimmediate */ "./node_modules/setimmediate/setImmediate.js"); // On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.


exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/tweezer.js/dist/tweezer.module.js":
/*!********************************************************!*\
  !*** ./node_modules/tweezer.js/dist/tweezer.module.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SingleTweener = function () {
  function SingleTweener() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SingleTweener);

    this.start = opts.start;
    this.end = opts.end;
    this.decimal = opts.decimal;
  }

  _createClass(SingleTweener, [{
    key: "getIntermediateValue",
    value: function getIntermediateValue(tick) {
      if (this.decimal) {
        return tick;
      } else {
        return Math.round(tick);
      }
    }
  }, {
    key: "getFinalValue",
    value: function getFinalValue() {
      return this.end;
    }
  }]);

  return SingleTweener;
}();

var _createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Tweezer = function () {
  function Tweezer() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$1(this, Tweezer);

    this.duration = opts.duration || 1000;
    this.ease = opts.easing || this._defaultEase;
    this.tweener = opts.tweener || new SingleTweener(opts);
    this.start = this.tweener.start;
    this.end = this.tweener.end;
    this.frame = null;
    this.next = null;
    this.isRunning = false;
    this.events = {};
    this.direction = this.start < this.end ? 'up' : 'down';
  }

  _createClass$1(Tweezer, [{
    key: 'begin',
    value: function begin() {
      if (!this.isRunning && this.next !== this.end) {
        this.frame = window.requestAnimationFrame(this._tick.bind(this));
      }

      return this;
    }
  }, {
    key: 'stop',
    value: function stop() {
      window.cancelAnimationFrame(this.frame);
      this.isRunning = false;
      this.frame = null;
      this.timeStart = null;
      this.next = null;
      return this;
    }
  }, {
    key: 'on',
    value: function on(name, handler) {
      this.events[name] = this.events[name] || [];
      this.events[name].push(handler);
      return this;
    }
  }, {
    key: '_emit',
    value: function _emit(name, val) {
      var _this = this;

      var e = this.events[name];
      e && e.forEach(function (handler) {
        return handler.call(_this, val);
      });
    }
  }, {
    key: '_tick',
    value: function _tick(currentTime) {
      this.isRunning = true;
      var lastTick = this.next || this.start;
      if (!this.timeStart) this.timeStart = currentTime;
      this.timeElapsed = currentTime - this.timeStart;
      this.next = this.ease(this.timeElapsed, this.start, this.end - this.start, this.duration);

      if (this._shouldTick(lastTick)) {
        this._emit('tick', this.tweener.getIntermediateValue(this.next));

        this.frame = window.requestAnimationFrame(this._tick.bind(this));
      } else {
        this._emit('tick', this.tweener.getFinalValue());

        this._emit('done', null);
      }
    }
  }, {
    key: '_shouldTick',
    value: function _shouldTick(lastTick) {
      return {
        up: this.next < this.end && lastTick <= this.next,
        down: this.next > this.end && lastTick >= this.next
      }[this.direction];
    }
  }, {
    key: '_defaultEase',
    value: function _defaultEase(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b;
      return -c / 2 * (--t * (t - 2) - 1) + b;
    }
  }]);

  return Tweezer;
}();

/* harmony default export */ __webpack_exports__["default"] = (Tweezer);

/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/accordions/Accordion.vue?vue&type=template&id=433a9225&":
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/accordions/Accordion.vue?vue&type=template&id=433a9225& ***!
  \***********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion", class: { "accordion--is-open": _vm.isOpen } },
    [
      _c("h2", [
        _c(
          "button",
          {
            staticClass: "accordion__button h4",
            attrs: {
              type: "button",
              name: _vm.title,
              "aria-expanded": _vm.isOpen,
            },
            on: {
              click: function ($event) {
                return _vm.toggle()
              },
            },
          },
          [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n\n      "),
            _c("div", { staticClass: "accordion__icon" }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { ref: "content", staticClass: "accordion__content" }, [
        _c(
          "div",
          { ref: "contentWrapper", staticClass: "accordion__content-wrapper" },
          [_vm._t("default")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/accordions/Accordions.vue?vue&type=template&id=27c3539e&":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/accordions/Accordions.vue?vue&type=template&id=27c3539e& ***!
  \************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "accordionsContent", staticClass: "accordions" },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=template&id=5b9eba7e&":
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=template&id=5b9eba7e& ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bundle-builder-form__inner" },
    [
      _vm._t("default", null, null, {
        submitButtonText: _vm.submitButtonText,
        addToCart: _vm.addToCart,
        cantAddTocart: _vm.cantAddTocart,
        formattedPrice: _vm.formattedPrice,
        bundleGroup: _vm.bundleGroup,
        onBundleComplete: _vm.onBundleComplete,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=template&id=79f70110&":
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=template&id=79f70110& ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-main-header" },
    [
      _vm._t("default", null, null, {
        formattedPrice: _vm.formattedPrice,
        isPreOrder: _vm.isPreOrder,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/button/Button.vue?vue&type=template&id=10867284&":
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/button/Button.vue?vue&type=template&id=10867284& ***!
  \****************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "link"
    ? _c(
        "a",
        _vm._b(
          {
            staticClass: "button",
            class: _vm.combinedClass,
            attrs: { href: _vm.href, disabled: _vm.disabled },
          },
          "a",
          _vm.attrs,
          false
        ),
        [
          _vm._t("default", function () {
            return [_vm._v("Link")]
          }),
          _vm._v(" "),
          _vm._t("icon"),
        ],
        2
      )
    : _c(
        "button",
        _vm._b(
          {
            staticClass: "button",
            class: _vm.combinedClass,
            attrs: { type: _vm.type, name: _vm.name, disabled: _vm.disabled },
            on: { click: _vm.onClick },
          },
          "button",
          _vm.attrs,
          false
        ),
        [
          _vm._t("default", function () {
            return [_vm._v("Button")]
          }),
          _vm._v(" "),
          _vm._t("icon"),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-grid/CartGrid.vue?vue&type=template&id=04df6483&":
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/cart-grid/CartGrid.vue?vue&type=template&id=04df6483& ***!
  \*********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "cartMain", staticClass: "cart-grid__inner" }, [
    !_vm.isMiniCart
      ? _c("div", { staticClass: "cart-grid__header" }, [
          _c("div", { staticClass: "container" }, [
            _c("h1", { staticClass: "h1" }, [
              _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "cart-grid__content" }, [
      _c(
        "div",
        { class: ["cart-grid__container", { container: !_vm.isMiniCart }] },
        [
          !_vm.isEmpty
            ? _c("div", { staticClass: "cart-grid__container-inner" }, [
                _c(
                  "form",
                  {
                    ref: "cartForm",
                    staticClass: "cart-grid__form",
                    attrs: { action: "/cart", method: "post", novalidate: "" },
                  },
                  [
                    _c("div", { staticClass: "cart__inner" }, [
                      _c(
                        "div",
                        {
                          ref: "cart",
                          staticClass: "cart-grid__items",
                          class: { "is-loading": _vm.loading },
                        },
                        [
                          !_vm.isMiniCart
                            ? _c("div", { staticClass: "cart__header label" }, [
                                _c(
                                  "div",
                                  { staticClass: "cart__header__item" },
                                  [_vm._v("Item")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "cart__header__item align-l" },
                                  [_vm._v("Price")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "cart__header__item align-l" },
                                  [_vm._v("Quantity")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "cart__header__item align-r" },
                                  [_vm._v("Total")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cart__body w1" },
                            [
                              _vm._l(_vm.groupedCartItems, function (item) {
                                return [
                                  item.isBundle &&
                                  item.items &&
                                  item.items.length
                                    ? [
                                        _c("CartItemBundle", {
                                          key: item.id,
                                          attrs: { bundle: item },
                                        }),
                                      ]
                                    : [
                                        _c("CartItem", {
                                          key: item.id,
                                          attrs: {
                                            item: item,
                                            "is-mini-cart": _vm.isMiniCart,
                                            index: item.index,
                                          },
                                        }),
                                      ],
                                ]
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.preorderTitle && _vm.preorderNote
                            ? _c("pre-order-note", {
                                attrs: {
                                  "is-show": _vm.showPreOrder,
                                  title: _vm.preorderTitle,
                                  note: _vm.preorderNote,
                                  "class-name": "pre-order-note__mini-cart",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMiniCart && _vm.showAvailabilityCallout
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "availability-callout cart-grid__availability-callout cart-grid__availability-callout--items",
                                  style: _vm.availabilityCalloutStyle,
                                },
                                [
                                  _vm.availabilityCallout.title
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "availability-callout__title",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.availabilityCallout.title
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "availability-callout__text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.availabilityCallout.text
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isMiniCart
                        ? _c("div", { staticClass: "cart__update" }, [
                            _c(
                              "button",
                              {
                                staticClass: "f aic cart__update-btn",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.getCart.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("icon-refresh"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "button button--primary" },
                                  [_vm._v(_vm._s(_vm.textUpdate))]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    !_vm.isMiniCart && _vm.showAvailabilityCallout
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "availability-callout cart-grid__availability-callout cart-grid__availability-callout--items",
                            style: _vm.availabilityCalloutStyle,
                          },
                          [
                            _vm.availabilityCallout.title
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "availability-callout__title",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.availabilityCallout.title) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "availability-callout__text",
                              domProps: {
                                innerHTML: _vm._s(_vm.availabilityCallout.text),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isMiniCart
                      ? _c(
                          "div",
                          { staticClass: "f cart__footer-wrapper" },
                          [
                            _vm.showAvailabilityCallout
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "availability-callout cart-grid__availability-callout cart-grid__availability-callout--sidebar",
                                    style: _vm.availabilityCalloutStyle,
                                  },
                                  [
                                    _vm.availabilityCallout.title
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "availability-callout__title",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.availabilityCallout.title
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "availability-callout__text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.availabilityCallout.text
                                        ),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.preorderTitle && _vm.preorderNote
                              ? _c("pre-order-note", {
                                  attrs: {
                                    "is-show": _vm.showPreOrder,
                                    title: _vm.preorderTitle,
                                    note: _vm.preorderNote,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "cart__footer" }, [
                              _c(
                                "div",
                                { staticClass: "cart__footer-bottom" },
                                [
                                  _c(
                                    "h3",
                                    { staticClass: "f aic jcb cart__subtotal" },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v(_vm._s(_vm.textSubtotal)),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "h3",
                                        domProps: {
                                          innerHTML: _vm._s(_vm.totalPrice),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "p2 cart__footer-bottom-text",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.textShipping) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showZapietWidget
                                    ? _c("div", {
                                        ref: "zapietMount",
                                        staticClass:
                                          "cart__ctas cart-grid__zapiet",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "f aic fdc cart__footer-button-group",
                                    },
                                    [
                                      _c(
                                        "v-button",
                                        {
                                          attrs: {
                                            type: "submit",
                                            modifier:
                                              "checkout cart__footer-button button--red button--full-width",
                                            name: "checkout",
                                            disabled: _vm.isCheckoutDisabled,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.textButton) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-button",
                                        {
                                          attrs: {
                                            type: "link",
                                            href: "/collections/all",
                                            modifier:
                                              "primary cart__footer-button",
                                            name: "keepShopping",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.textKeepShopping) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isCheckoutBtndisabled
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "p2 color-errors cart__footer-bottom-error",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.cartOrderMinimumInfo) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isMiniCart
                      ? _c("div", { staticClass: "cart__footer-wrapper" }, [
                          _c("div", { staticClass: "cart__footer" }, [
                            _c(
                              "div",
                              { staticClass: "cart__footer-bottom" },
                              [
                                _c(
                                  "h3",
                                  { staticClass: "f aic jcb cart__subtotal" },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v(_vm._s(_vm.textSubtotal)),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "h3",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.totalPrice),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.showZapietWidget
                                  ? _c("div", {
                                      ref: "zapietMount",
                                      staticClass:
                                        "cart__ctas cart-grid__zapiet",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      modifier:
                                        "checkout cart__footer-button button--red button--full-width",
                                      name: "checkout",
                                      disabled: _vm.isCheckoutDisabled,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.textButton) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isCheckoutBtndisabled
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "p2 color-errors cart__footer-bottom-error",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.cartOrderMinimumInfo) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "p2 cart__footer-bottom-text align-c",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.textShipping) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isEmpty
            ? _c("div", { staticClass: "cart-grid__empty" }, [
                _c(
                  "div",
                  { staticClass: "cart-grid__empty-icon" },
                  [_c("icon-logo")],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "h4 align-c cart-grid__empty-title" }, [
                  _vm._v("\n          " + _vm._s(_vm.textEmpty) + "\n        "),
                ]),
                _vm._v(" "),
                _vm.textShopLink && _vm.textShopText
                  ? _c(
                      "p",
                      { staticClass: "align-c" },
                      [
                        _c(
                          "v-button",
                          {
                            attrs: {
                              type: "link",
                              href: _vm.textShopLink,
                              modifier: "primary",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.textShopText) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=template&id=23e38678&":
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=template&id=23e38678& ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart-item cart-item-bundle",
      class: { "cart-item-bundle--removing": _vm.isRemoving },
    },
    [
      _c(
        "div",
        { staticClass: "cart-item-bundle__cell cart-item-bundle__cell--info" },
        [
          _c("div", { staticClass: "cart-item-bundle__header" }, [
            _c("p", {
              staticClass: "h4 cart-item-bundle__title",
              domProps: {
                textContent: _vm._s(
                  this.items[0].properties._bundle_product_name
                ),
              },
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "p2 cart-item-bundle__price",
              domProps: { textContent: _vm._s(_vm.bundleDisplayPrice) },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cart-item-bundle__items" },
            _vm._l(_vm.groupedItems, function (item) {
              return _c("div", { staticClass: "cart-item-bundle__item" }, [
                _c("div", { staticClass: "cart-item-bundle__item-image" }, [
                  _c("img", {
                    attrs: {
                      src: item.properties._bundle_featured_image || item.image,
                      alt: item.title,
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cart-item-bundle__item-info" }, [
                  _c("p", { staticClass: "cart-item-bundle__item-name p2" }, [
                    _c("span", {
                      staticClass: "cart-item-bundle__item-text",
                      domProps: {
                        textContent: _vm._s(
                          item.properties._bundle_group_title + ": "
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: { textContent: _vm._s(item.product_title) },
                    }),
                  ]),
                ]),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cart-item-bundle__actions" }, [
            _vm.bundleProductHandle
              ? _c(
                  "button",
                  {
                    staticClass: "button button--primary cart-item__remove",
                    attrs: { type: "button", disabled: _vm.isRemoving },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.edit.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Edit")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button button--primary cart-item__remove",
                attrs: { type: "button", disabled: _vm.isRemoving },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.remove.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Remove")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "cart-item-bundle__cell cart-item-bundle__cell--price",
        domProps: { textContent: _vm._s(_vm.formattedTotalPrice) },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "cart-item-bundle__cell cart-item-bundle__cell--quantity",
        },
        [_vm._v("1")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "cart-item-bundle__cell cart-item-bundle__cell--total-price",
        domProps: { textContent: _vm._s(_vm.formattedTotalPrice) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-item/CartItem.vue?vue&type=template&id=25ef8b23&":
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/cart-item/CartItem.vue?vue&type=template&id=25ef8b23& ***!
  \*********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart-item",
      class: { "cart-item--disabled": _vm.disabled },
    },
    [
      _c("div", { staticClass: "cart-item__info relative" }, [
        _c("div", { staticClass: "cart-item__featured" }, [
          _c(
            "a",
            {
              staticClass: "relative cart-item__featured-inner",
              attrs: { href: _vm.item.url },
            },
            [
              _c("v-picture", {
                attrs: {
                  sources: _vm.imageSrc,
                  alt: _vm.item.title,
                  "object-fit": "contain",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cart-item__details" }, [
          _c("h3", { staticClass: "cart-item__details-title" }, [
            _c(
              "a",
              {
                staticClass: "h4 cart-item__details-link",
                attrs: { href: _vm.item.url },
              },
              [_vm._v(_vm._s(_vm.item.product_title))]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "cart-item__details-price cart-item__details-price--mobile",
            },
            [
              _vm.formattedCompareAtPrice
                ? _c("del", {
                    staticClass: "p2 cart-item__compare-price",
                    domProps: {
                      innerHTML: _vm._s(_vm.formattedCompareAtPrice),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "p2",
                  class: { red: _vm.formattedCompareAtPrice },
                },
                [_vm._v(_vm._s(_vm.formattedPrice))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p2 cart-item__details-content" },
            [
              _vm.item.options_with_values
                ? [
                    _vm._l(_vm.item.options_with_values, function (option) {
                      return [
                        option.value !== "Default Title"
                          ? _c(
                              "p",
                              [
                                _vm.isDeliveryOnly
                                  ? [_vm._v(_vm._s(option.value))]
                                  : [
                                      _vm._v(
                                        _vm._s(option.name) +
                                          ": " +
                                          _vm._s(option.value)
                                      ),
                                    ],
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.cartInfo.preOrder
                ? _c(
                    "p",
                    { staticClass: "cart-item__details-content-pre-order" },
                    [_vm._v(_vm._s(_vm.cartInfo.preOrder))]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cart-item__quantity cart-item__quantity--mobile" },
          [
            _c(
              "div",
              { staticClass: "cart-item__details-quantity" },
              [
                _c("QuantitySelector", {
                  class: _vm.isMiniCart
                    ? "quantity-selector--mini-cart"
                    : "quantity-selector--cart",
                  attrs: {
                    item: _vm.item,
                    initial: _vm.item.quantity,
                    max: _vm.maxQuantity,
                    "update-value": _vm.item.quantity,
                  },
                  on: { change: _vm.updateQuantity, blur: _vm.flushQuantity },
                  scopedSlots: _vm._u([
                    {
                      key: "decrease",
                      fn: function () {
                        return [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "10",
                                height: "2",
                                viewBox: "0 0 10 2",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M9.8.776H.2",
                                  stroke: "currentColor",
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "increase",
                      fn: function () {
                        return [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "10",
                                height: "10",
                                viewBox: "0 0 10 10",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M5 0v9.552M9.8 4.776H.2",
                                  stroke: "currentColor",
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button button--primary cart-item__remove",
                attrs: { "aria-label": "Remove " + _vm.item.title },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.remove.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n        Remove\n      ")]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "cart-item__details-price cart-item__details-price--desktop align-m align-l",
        },
        [
          _vm.formattedCompareAtPrice
            ? _c("del", {
                staticClass: "cart-item__compare-price",
                domProps: { innerHTML: _vm._s(_vm.formattedCompareAtPrice) },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "p2", class: { red: _vm.formattedCompareAtPrice } },
            [_vm._v(_vm._s(_vm.formattedPrice))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "cart-item__quantity cart-item__quantity--desktop align-m align-l",
        },
        [
          _c(
            "div",
            { staticClass: "cart-item__details-quantity" },
            [
              _c("QuantitySelector", {
                class: _vm.isMiniCart
                  ? "quantity-selector--mini-cart"
                  : "quantity-selector--cart",
                attrs: {
                  item: _vm.item,
                  initial: _vm.item.quantity,
                  max: _vm.maxQuantity,
                  "update-value": _vm.item.quantity,
                },
                on: { change: _vm.updateQuantity, blur: _vm.flushQuantity },
                scopedSlots: _vm._u([
                  {
                    key: "decrease",
                    fn: function () {
                      return [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "10",
                              height: "2",
                              viewBox: "0 0 10 2",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9.8.776H.2",
                                stroke: "currentColor",
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "increase",
                    fn: function () {
                      return [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "10",
                              height: "10",
                              viewBox: "0 0 10 10",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M5 0v9.552M9.8 4.776H.2",
                                stroke: "currentColor",
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button button--primary cart-item__remove",
              attrs: { "aria-label": "Remove " + _vm.item.title },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.remove.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n      Remove\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isMiniCart
        ? _c("div", { staticClass: "cart-item__total" }, [
            _c("p", { staticClass: "p2 cart-item__total-inner align-r" }, [
              _vm._v(_vm._s(_vm.totalFormattedPrice)),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/checkbox/Checkbox.vue?vue&type=template&id=1f6e331e&":
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/checkbox/Checkbox.vue?vue&type=template&id=1f6e331e& ***!
  \********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      class: [
        "checkbox",
        { "is-active": _vm.isChecked, "has-error": !_vm.isValid },
      ],
    },
    [
      _c("span", { staticClass: "checkbox__icon" }, [
        _c("input", {
          staticClass: "checkbox__icon-el",
          attrs: { type: "checkbox", name: _vm.name },
          domProps: { value: _vm.value, checked: _vm.isChecked },
          on: { change: _vm.onChange },
        }),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "checkbox__icon-tick",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 9 7",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M1 4L3 6L8 1",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.label
        ? _c("span", {
            staticClass: "p1 checkbox__text",
            domProps: { innerHTML: _vm._s(_vm.label) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/contact-form/ContactForm.vue?vue&type=template&id=134ab687&":
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/contact-form/ContactForm.vue?vue&type=template&id=134ab687& ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "contactForm",
      attrs: {
        method: "post",
        action: "/contact#contact_form",
        id: "contact_form",
        "accept-charset": "UTF-8",
        novalidate: "novalidate",
      },
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "form_type", value: "contact" },
      }),
      _vm._v(" "),
      _c("input", { attrs: { type: "hidden", name: "utf8", value: "✓" } }),
      _vm._v(" "),
      _c("div", { staticClass: "contact-form__el relative" }, [
        _vm.postedSuccessfully
          ? _c(
              "div",
              {
                staticClass: "contact-form__success",
                class: { "is-active": _vm.isSuccess },
                attrs: { role: "dialog", "aria-label": _vm.postSuccess },
              },
              [
                _c("div", { staticClass: "contact-form__success-container" }, [
                  _c(
                    "div",
                    {
                      ref: "contactFormSuccess",
                      staticClass: "contact-form__success-inner",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "contact-form__success-close",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.closeSuccessModal.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(_vm.postSuccessClose)),
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "contact-form__success-close-icon",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "contact-form__success-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 592.1 787",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d: "M296 787c-72-.3-135.1-24.4-190.1-70.4-33.5-28-60.8-60.8-79.4-100.6-11-23.6-18.4-48.2-22.5-74C.6 520.4-.7 498.8.3 477 2.7 422.5 19.4 372.7 50 327.4c36.8-54.3 85.2-94.2 146.2-118.4 21.4-8.5 43.6-14.1 66.5-16.9 17.9-2.2 35.9-2.6 53.9-1.3 46.7 3.6 89.9 18.3 129.4 43.1 64.9 40.6 109.5 97.6 133.5 170.4 6.3 19.2 9.9 39 11.5 59.1 1.5 19 1.5 38-.2 56.9-6.4 72.2-36.3 133-89.2 182.5-36.2 33.9-77.3 59.3-125.3 72.9-16.5 4.7-33.3 8-50.4 9.3-9.9.9-19.9 1.4-29.9 2zm215.1-299.1c-.8-13-1.4-25.9-2.5-38.9-1.6-20.5-5.4-40.7-11.1-60.5-12.9-45.4-34.7-85.8-66.9-120.4-31.7-33.9-70.1-54.8-116.9-59.2-18.9-1.8-37.6-.9-56.1 2.9-28.8 6-54.3 18.8-76.8 37.6-25.1 21-44.6 46.6-60.5 75.1-25.9 46.4-37.7 96.6-39.5 149.3-.6 18.5-.1 37 1.8 55.4 2.3 21.6 6.3 42.8 12.6 63.5 13 42.5 33.8 80.7 63.7 113.6 32.1 35.4 71.3 57.3 119.5 61.6 18.5 1.6 36.9.8 55.2-3 32.5-6.7 60.5-22 84.7-44.5 32.6-30.4 55.5-67.2 71.1-108.8 15.2-39.7 21.1-81.2 21.7-123.7zM284.5 125.2c-.5-5.3-.8-10.5-1.6-15.5-2.8-17.1-9.9-32.5-18.8-47.2-4.9-8-7.4-16.6-7-26.1.7-17 11.9-31.2 28.6-35 15.6-3.6 29.9-.7 40.6 12s11.3 27.3 5.3 42.2c-1.7 4.2-4.3 8.1-6.5 12.1-7.4 13.4-13.4 27.3-15.9 42.6-.8 4.9-1.1 9.8-1.6 15.2 3.2-.2 5.7-.3 8.3-.5 17-1.4 33.3-5.3 48-14.4 12.2-7.6 21.6-17.7 25.4-31.8 2-7.4 2.6-15.1 4.4-22.5 1.3-5.2 3-10.4 5.3-15.2 4.8-9.6 13.5-13.9 23.8-15 6.6-.7 13.1-.6 19.3 2.2 9.1 4.1 13.7 11.3 14.7 21 1 10.8-2.4 20.5-8.2 29.5-7.8 12.2-18.3 21.8-30.2 29.8-23 15.6-48.5 24.7-75.6 29.8-20.1 3.8-40.3 5-60.7 3.9-38.8-2.1-75.6-11.5-108.3-33.4-11.7-7.9-22.1-17.2-29.9-29.1-6-9-9.5-18.8-9-29.8.7-12.9 10.5-23 23.4-24 6.1-.5 12.1-.1 18 1.6 8.1 2.4 13.7 7.5 17.4 15 3.8 7.7 5.1 16 6.5 24.2 1.2 7.4 2.4 14.7 6 21.5 4.5 8.3 10.9 14.9 18.6 20.3 17.8 12.1 41.5 16.3 59.7 16.6z",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.postSuccessTitle
                        ? _c(
                            "p",
                            { staticClass: "h3 contact-form__success-title" },
                            [_vm._v(_vm._s(_vm.postSuccessTitle))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.postSuccessText
                        ? _c(
                            "p",
                            { staticClass: "p2 contact-form__success-text" },
                            [_vm._v(_vm._s(_vm.postSuccessText))]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contact-form__fields" },
          [
            _c("TextInput", {
              attrs: {
                placeholder: "Enter full name",
                modifier: "contact-form contact-form__field",
                name: "contact[name]",
                type: "text",
                initialValue: _vm.valueName,
                label: _vm.labelName,
                "aria-label": _vm.labelName,
                error: _vm.errorMessageName,
                required: "",
              },
              on: { change: _vm.onInputChange },
            }),
            _vm._v(" "),
            _c("TextInput", {
              attrs: {
                placeholder: "Enter email address",
                modifier: "contact-form contact-form__field",
                name: "contact[email]",
                type: "email",
                initialValue: _vm.valueEmail,
                label: _vm.labelEmail,
                "aria-label": _vm.labelEmail,
                error: _vm.errorMessageEmail,
                "validate-method": _vm.isValidEmail,
                required: "",
              },
              on: { change: _vm.onInputChange },
            }),
            _vm._v(" "),
            _c("TextInput", {
              attrs: {
                placeholder: "Enter zipcode",
                modifier: "contact-form contact-form__field",
                name: "contact[zipcode]",
                type: "number",
                label: _vm.labelZipcode,
                "aria-label": _vm.labelZipcode,
              },
              on: { change: _vm.onInputChange },
            }),
            _vm._v(" "),
            _vm.options.length
              ? [
                  _c("SelectInput", {
                    attrs: {
                      placeholder: "Select a subject",
                      modifier: "contact-form contact-form__field",
                      name: "contact[subject]",
                      label: _vm.labelSubject,
                      "aria-label": _vm.labelSubject,
                      error: _vm.errorMessageName,
                      options: _vm.options,
                    },
                    on: { change: _vm.onSelectChange },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "text-input text-input--contact-form contact-form__field contact-form__field--textarea",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text-input__wrapper",
                    class: { "is-active": _vm.isActive, "is-error": _vm.error },
                  },
                  [
                    _vm.labelMessage
                      ? _c(
                          "label",
                          { staticClass: "text-input__label label" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.labelMessage) +
                                "*\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactMessage,
                          expression: "contactMessage",
                        },
                      ],
                      staticClass: "contact-form__textarea p1",
                      attrs: {
                        "aria-label": _vm.labelMessage,
                        name: "contact[message]",
                        rows: "5",
                        placeholder: "Include a message here",
                      },
                      domProps: { value: _vm.contactMessage },
                      on: {
                        click: _vm.activeField,
                        focus: _vm.activeField,
                        blur: _vm.deactiveField,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.contactMessage = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _vm.error
                  ? _c("p", { staticClass: "text-input__error p2" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.errorMessageName) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "align-c" }, [
          _c(
            "button",
            {
              staticClass: "button button--secondary contact-form__submit",
              attrs: { type: "submit", disabled: _vm.isSubmitting },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleSubmit.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.labelSubmit) + "\n      ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/example/Example.vue?vue&type=template&id=73656258&":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/example/Example.vue?vue&type=template&id=73656258& ***!
  \******************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "example" }, [
    _vm._v("\n  Example Vue single file component\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=template&id=33111d1e&":
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=template&id=33111d1e& ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "header-cart-icon logo",
      attrs: { href: "/cart", "aria-label": "header cart icon" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.toggleMiniCart.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "span",
        { staticClass: "header-cart-icon__svg" },
        [_c("icon-shopping-bag")],
        1
      ),
      _vm._v(" "),
      _vm.itemCount > 0
        ? _c("span", {
            staticClass: "label label--small header-cart-icon__count",
            domProps: { textContent: _vm._s(_vm.itemCount) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconFacebook.vue?vue&type=template&id=79c1f375&":
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconFacebook.vue?vue&type=template&id=79c1f375& ***!
  \*********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 15",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M15 7.531C15 3.39 11.625 0 7.5 0A7.498 7.498 0 0 0 0 7.531C0 11.297 2.75 14.435 6.313 15V9.728H4.438V7.531h1.875V5.837c0-1.883 1.125-2.95 2.812-2.95.875.063 1.688.188 1.688.188v1.883h-.938c-.938 0-1.25.565-1.25 1.193v1.38h2.063l-.313 2.197h-1.75V15C12.25 14.372 15 11.297 15 7.531Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconInstagram.vue?vue&type=template&id=4a4f3b13&":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconInstagram.vue?vue&type=template&id=4a4f3b13& ***!
  \**********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 15",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7.5 0C5.437 0 5.187 0 4.437.063c-.812 0-1.375.124-1.875.312a4.01 4.01 0 0 0-1.312.875c-.438.438-.688.813-.875 1.313-.188.5-.313 1.062-.313 1.874C0 5.188 0 5.438 0 7.5s0 2.313.063 3.063c.062.812.187 1.312.374 1.812.126.5.376.938.813 1.375.438.438.813.688 1.313.875.5.188 1 .313 1.812.375H7.5c2.063 0 2.313 0 3.063-.063.812-.062 1.312-.187 1.812-.374.5-.188.938-.438 1.313-.876.437-.437.687-.812.874-1.312.188-.5.313-1 .376-1.813.062-.75.062-1 .062-3.062 0-2.063 0-2.313-.063-3.063-.062-.812-.187-1.312-.374-1.812-.126-.5-.376-.938-.813-1.375-.438-.438-.813-.688-1.313-.875-.5-.188-1-.313-1.812-.375H7.5Zm0 1.375c2 0 2.25 0 3.063.063.75.062 1.124.125 1.374.25.376.125.626.312.876.562.25.25.437.5.562.875.125.25.25.688.25 1.375.063.813.063 1 .063 3s0 2.25-.063 3.063c-.063.75-.188 1.124-.25 1.374-.125.376-.313.626-.563.876-.25.25-.5.437-.874.562-.25.125-.688.25-1.376.25-.812.063-1 .063-3.062.063-2 0-2.25 0-3.063-.063-.75-.063-1.125-.188-1.375-.25-.374-.125-.624-.313-.874-.563-.25-.25-.438-.5-.563-.874-.125-.25-.25-.688-.25-1.376 0-.812-.063-1-.063-3s0-2.25.063-3.062c0-.75.125-1.188.25-1.438.125-.374.313-.624.563-.874.25-.25.5-.438.874-.563.25-.125.688-.25 1.376-.25.812-.063 1-.063 3.062 0 0-.063 0 0 0 0Zm0 2.25c-2.125 0-3.875 1.75-3.875 3.875s1.75 3.875 3.875 3.875 3.875-1.75 3.875-3.875S9.625 3.625 7.5 3.625ZM7.5 10A2.507 2.507 0 0 1 5 7.5C5 6.125 6.125 5 7.5 5S10 6.125 10 7.5 8.875 10 7.5 10Zm4.875-6.5c0 .5-.375.875-.875.875a.854.854 0 0 1-.875-.875c0-.5.375-.875.875-.875s.875.375.875.875Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconLogo.vue?vue&type=template&id=eeb1714c&":
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconLogo.vue?vue&type=template&id=eeb1714c& ***!
  \*****************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 592.13 787.03",
      },
    },
    [
      _c("path", {
        attrs: {
          fill: "currentColor",
          d: "M296 787c-72-.3-135.1-24.4-190.1-70.4-33.5-28-60.8-60.8-79.4-100.6A276.72 276.72 0 0 1 4 542a321.63 321.63 0 0 1-3.7-65C2.7 422.5 19.4 372.7 50 327.4c36.8-54.3 85.2-94.2 146.2-118.4a267.36 267.36 0 0 1 66.5-16.9 277.39 277.39 0 0 1 53.9-1.3c46.7 3.6 89.9 18.3 129.4 43.1 64.9 40.6 109.5 97.6 133.5 170.4a253.41 253.41 0 0 1 11.5 59.1 337.82 337.82 0 0 1-.2 56.9c-6.4 72.2-36.3 133-89.2 182.5-36.2 33.9-77.3 59.3-125.3 72.9a254.25 254.25 0 0 1-50.4 9.3c-9.9.93-19.9 1.43-29.9 2Zm215.1-299.1c-.8-13-1.4-25.9-2.5-38.9a304 304 0 0 0-11.1-60.5c-12.9-45.4-34.7-85.8-66.9-120.4-31.7-33.9-70.1-54.8-116.9-59.2a188.45 188.45 0 0 0-56.1 2.9c-28.8 6-54.3 18.8-76.8 37.6-25.1 21-44.6 46.6-60.5 75.1-25.9 46.4-37.7 96.6-39.5 149.3a409.81 409.81 0 0 0 1.8 55.4 341.61 341.61 0 0 0 12.6 63.5c13 42.5 33.8 80.7 63.7 113.6 32.1 35.4 71.3 57.3 119.5 61.6a189.56 189.56 0 0 0 55.2-3c32.5-6.7 60.5-22 84.7-44.5 32.6-30.4 55.5-67.2 71.1-108.8 15.23-39.67 21.13-81.17 21.73-123.67ZM284.53 125.23c-.5-5.3-.8-10.5-1.6-15.5-2.8-17.1-9.9-32.5-18.8-47.2a45.23 45.23 0 0 1-7-26.1c.7-17 11.9-31.2 28.6-35 15.6-3.6 29.9-.7 40.6 12s11.3 27.3 5.3 42.2c-1.7 4.2-4.3 8.1-6.5 12.1-7.4 13.4-13.4 27.3-15.9 42.6-.8 4.9-1.1 9.8-1.6 15.2 3.2-.2 5.7-.3 8.3-.5 17-1.4 33.3-5.3 48-14.4 12.2-7.6 21.6-17.7 25.4-31.8 2-7.4 2.6-15.1 4.4-22.5a80.48 80.48 0 0 1 5.3-15.2c4.8-9.6 13.5-13.9 23.8-15 6.6-.7 13.1-.6 19.3 2.2 9.1 4.1 13.7 11.3 14.7 21 1 10.8-2.4 20.5-8.2 29.5-7.8 12.2-18.3 21.8-30.2 29.8-23 15.6-48.5 24.7-75.6 29.8a252.13 252.13 0 0 1-60.7 3.9c-38.8-2.1-75.6-11.5-108.3-33.4-11.7-7.9-22.1-17.2-29.9-29.1-6-9-9.5-18.8-9-29.8a25.17 25.17 0 0 1 23.4-24 49.69 49.69 0 0 1 18 1.6c8.1 2.4 13.7 7.5 17.4 15 3.8 7.7 5.1 16 6.5 24.2 1.2 7.4 2.4 14.7 6 21.5a59.32 59.32 0 0 0 18.6 20.3c17.8 12.1 41.5 16.3 59.7 16.6Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconMute.vue?vue&type=template&id=438fecc8&":
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconMute.vue?vue&type=template&id=438fecc8& ***!
  \*****************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      },
    },
    [
      _c("polygon", { attrs: { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" } }),
      _vm._v(" "),
      _c("line", { attrs: { x1: "23", y1: "9", x2: "17", y2: "15" } }),
      _vm._v(" "),
      _c("line", { attrs: { x1: "17", y1: "9", x2: "23", y2: "15" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconPause.vue?vue&type=template&id=1d53e3d7&":
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconPause.vue?vue&type=template&id=1d53e3d7& ***!
  \******************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        "xml:space": "preserve",
      },
    },
    [
      _c("circle", {
        attrs: { fill: "currentColor", cx: "20", cy: "20", r: "20" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "#FFF",
          d: "M17 27c-.6 0-1-.4-1-1V14c0-.6.4-1 1-1s1 .4 1 1v12c0 .6-.4 1-1 1zM24 27c-.6 0-1-.4-1-1V14c0-.6.4-1 1-1s1 .4 1 1v12c0 .6-.4 1-1 1z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconPinterest.vue?vue&type=template&id=0fc7920a&":
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconPinterest.vue?vue&type=template&id=0fc7920a& ***!
  \**********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 496 512" } },
    [
      _c("path", {
        attrs: {
          fill: "currentColor",
          d: "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconPlay.vue?vue&type=template&id=7fc92063&":
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconPlay.vue?vue&type=template&id=7fc92063& ***!
  \*****************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        "xml:space": "preserve",
      },
    },
    [
      _c("circle", {
        attrs: { fill: "currentColor", cx: "20", cy: "20", r: "20" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          fill: "#FFF",
          d: "m26.3 20.7-9.1 5.9V15.1l9.1 5.6z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconRefresh.vue?vue&type=template&id=6fcee7fc&":
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconRefresh.vue?vue&type=template&id=6fcee7fc& ***!
  \********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M15 2.167V6.25a.56.56 0 0 1-.173.41.56.56 0 0 1-.41.173h-4.084c-.255 0-.434-.121-.537-.364-.104-.237-.061-.447.127-.63l1.258-1.257c-.9-.832-1.96-1.249-3.181-1.249-.632 0-1.235.123-1.81.37A4.702 4.702 0 0 0 4.7 4.7c-.419.419-.751.916-.998 1.49A4.546 4.546 0 0 0 3.333 8c0 .632.123 1.235.37 1.81.246.573.578 1.07.998 1.49.419.419.916.751 1.49.997.574.247 1.177.37 1.809.37.723 0 1.407-.158 2.05-.474a4.576 4.576 0 0 0 1.632-1.34c.043-.06.113-.097.21-.11.091 0 .167.028.228.082l1.248 1.258c.055.049.084.111.087.187a.3.3 0 0 1-.068.205 6.843 6.843 0 0 1-2.407 1.864C10.04 14.78 9.045 15 8 15a6.81 6.81 0 0 1-2.716-.556 7.062 7.062 0 0 1-2.233-1.495 7.062 7.062 0 0 1-1.495-2.233A6.81 6.81 0 0 1 1 8c0-.948.185-1.853.556-2.716A7.062 7.062 0 0 1 3.051 3.05a7.062 7.062 0 0 1 2.233-1.495A6.81 6.81 0 0 1 8 1c.893 0 1.758.169 2.593.506a7.075 7.075 0 0 1 2.229 1.426l1.185-1.175c.176-.189.388-.231.638-.128a.545.545 0 0 1 .355.538Z",
          fill: "currentColor",
          stroke: "#fff",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconShoppingBag.vue?vue&type=template&id=f4dff0be&":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconShoppingBag.vue?vue&type=template&id=f4dff0be& ***!
  \************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 239.6 239.6",
      },
    },
    [
      _c("path", {
        attrs: {
          fill: "currentColor",
          d: "M66.8 136.9c.9 5.9 1.4 11.2 2.6 16.3.2 1 3.1 2 4.8 2 23 .1 46 .1 69 .1h30.5c3.8 0 7.2.5 7.6 5.2.3 3.8-2.3 5.7-7.6 5.7H67.8c-6 0-7.7-1.4-8.6-7.3-5.4-35.1-10.9-70.1-16-105.2-.6-3.9-1.8-5.4-5.9-5.2-6.1.3-12.3.1-18.5.1-3.7 0-6.3-1.7-6.3-5.5 0-3.5 2.5-5.3 6-5.3 9.2 0 18.3-.1 27.5 0 3.5 0 5.7 1.6 6.2 5.2.4 2.8 1.3 5.6 1.3 8.4 0 4.9 2.5 5.8 6.9 5.8 42.8-.2 85.6-.1 128.4-.1 8.7 0 10 1.5 8.8 10-3 20.8-6 41.5-9.1 62.3-1 6.5-2.2 7.6-8.7 7.6h-107c-1.7-.1-3.4-.1-6-.1zm-10.7-69c2.9 19 5.7 37.4 8.8 55.8.2 1.1 2.9 2.4 4.4 2.5 34.8 0 69.6 0 104.5.1 3.4 0 4.7-1.1 5.1-4.5 1.1-9.1 2.6-18.1 3.9-27.2 1.3-8.8 2.5-17.6 3.8-26.8-43.6.1-86.5.1-130.5.1zM92.1 191.5c0 6.7-5.3 12.2-11.9 12.2s-12.1-5.4-12.1-12c0-6.9 5.2-12.2 11.9-12.2 6.8 0 12.1 5.2 12.1 12zM180.9 191.5c0 6.6-5.5 12.1-12.1 12.2-6.6.1-12.1-5.4-12.1-12.1s5.4-12.1 12-12.1c6.7 0 12.2 5.4 12.2 12z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconTiktok.vue?vue&type=template&id=3ad7a969&":
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconTiktok.vue?vue&type=template&id=3ad7a969& ***!
  \*******************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 13 15",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M6.842 0h2.426c.062.937.373 1.936 1.12 2.623.684.687 1.679 1 2.612 1.125v2.498c-.87-.062-1.804-.25-2.612-.625a14.227 14.227 0 0 1-.996-.562v5.497c-.062.874-.31 1.749-.87 2.436-.81 1.186-2.24 1.998-3.67 1.998-.871.063-1.804-.187-2.55-.624-1.245-.75-2.115-2.124-2.302-3.56v-.937a4.797 4.797 0 0 1 1.617-3.123c1.058-.875 2.488-1.312 3.794-1.062v2.748c-.622-.187-1.368-.125-1.866.25-.373.25-.684.625-.87 1.124-.125.313-.125.687-.063 1 .125.999 1.12 1.874 2.177 1.811.685 0 1.369-.437 1.742-1 .125-.187.249-.437.249-.686.062-1.125.062-2.249.062-3.373V0Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconUnmute.vue?vue&type=template&id=215388a1&":
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/icons/IconUnmute.vue?vue&type=template&id=215388a1& ***!
  \*******************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      },
    },
    [
      _c("polygon", { attrs: { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" } }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=template&id=5c5d7a72&":
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=template&id=5c5d7a72& ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-grid-gallery__item",
      class: { "image-grid-gallery__item--video": _vm.video.id },
    },
    [
      _c(
        "div",
        {
          staticClass: "image-grid-gallery__item-image ratio",
          on: { click: _vm.openModal },
        },
        [
          _vm.image
            ? _c("v-picture", {
                attrs: {
                  sources: _vm.image,
                  fadeIn: false,
                  "object-fit": "cover",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.video.id
        ? _c(
            "modal",
            {
              on: { "on-close": _vm.stopAllVideo },
              model: {
                value: _vm.isShowModal,
                callback: function ($$v) {
                  _vm.isShowModal = $$v
                },
                expression: "isShowModal",
              },
            },
            [
              _c("video-embed", {
                ref: "externalVideos",
                attrs: {
                  "show-control-button": false,
                  autoplay: true,
                  uid: "external-video-" + _vm.video.id,
                  "you-tube-video-id":
                    _vm.video.provider === "youtube" ? "" + _vm.video.id : null,
                  "vimeo-video-url":
                    _vm.video.provider === "vimeo"
                      ? "https://vimeo.com/" + _vm.video.id
                      : null,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/modal/Modal.vue?vue&type=template&id=c28e334c&":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/modal/Modal.vue?vue&type=template&id=c28e334c& ***!
  \**************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fixed modal",
      class: { "modal--opened": _vm.isModalOpen },
      attrs: { role: "dialog" },
    },
    [
      _c("div", {
        staticClass: "fixed modal__overlay",
        on: { click: _vm.close },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container container--s modal__container" }, [
        _c(
          "div",
          {
            ref: "modalWrapper",
            staticClass: "relative modal__wrapper",
            attrs: { tabindex: "-1" },
          },
          [
            _c(
              "button",
              {
                staticClass: "absolute modal__close",
                attrs: { "aria-label": "Close modal" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "relative modal__close-icon",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal__inner" },
              [
                _vm._t("default"),
                _vm._v(" "),
                _vm.buttonText
                  ? _c("div", { staticClass: "align-c modal__inner-footer" }, [
                      _c("button", {
                        staticClass: "button button--secondary modal__btn",
                        domProps: { textContent: _vm._s(_vm.buttonText) },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.close.apply(null, arguments)
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/more/More.vue?vue&type=template&id=31b3c944&":
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/more/More.vue?vue&type=template&id=31b3c944& ***!
  \************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "more", class: { "more--show": _vm.show } }, [
    _vm.excerpt && _vm.content
      ? _c("div", { staticClass: "more__wrapper" }, [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.excerpt) } }),
          _vm._v(" "),
          !_vm.show
            ? _c(
                "a",
                {
                  ref: "viewMore",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.viewMore.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Learn More")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "more__content",
            domProps: { innerHTML: _vm._s(_vm.content) },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/newsletter-form/NewsletterForm.vue?vue&type=template&id=1c63a516&":
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/newsletter-form/NewsletterForm.vue?vue&type=template&id=1c63a516& ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newsletter-form" }, [
    _c(
      "div",
      { staticClass: "newsletter__wrapper" },
      [
        !_vm.isSuccess
          ? _c(
              "form",
              {
                staticClass: "newsletter__form",
                attrs: {
                  action: _vm.klaviyoUrl,
                  method: "post",
                  novalidate: "",
                },
                on: { submit: _vm.submit },
              },
              [
                _c(
                  "div",
                  { staticClass: "newsletter__field" },
                  [
                    _c("TextInput", {
                      ref: "inputEmail",
                      class: _vm.inputClass,
                      attrs: {
                        name: "email",
                        type: "email",
                        modifier: "reverse",
                        label: _vm.emailLabel,
                        "aria-label": _vm.emailAriaLabel || _vm.emailLabel,
                        "floating-label": _vm.emailFloatingLabel,
                        placeholder: _vm.emailPlaceholder,
                        error: _vm.emailErrorText,
                        "validate-method": _vm.isValidEmail,
                        required: "",
                      },
                      on: { change: _vm.onInputChange },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.emailOnly
                  ? _c(
                      "div",
                      { staticClass: "newsletter__field" },
                      [
                        _c("TextInput", {
                          ref: "inputPhone",
                          staticClass: "newsletter__text-input",
                          class: _vm.inputClass,
                          attrs: {
                            name: _vm.optionName,
                            type: "phone",
                            modifier: "reverse",
                            label: _vm.optionLabel,
                            "aria-label":
                              _vm.optionAriaLabel || _vm.optionLabel,
                            "floating-label": _vm.optionFloatingLabel,
                            placeholder: _vm.optionPlaceholder,
                            error: _vm.phoneErrorText,
                            "validate-method": _vm.isValidOption,
                          },
                          on: { change: _vm.onInputChange },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "beforeInput",
                                fn: function () {
                                  return [
                                    _vm.optionName == "phone_number"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "newsletter__country-select",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "f aic newsletter__country-select-text",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.selectedCountry.flag
                                                    ) +
                                                    "\n                "
                                                ),
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                      fill: "none",
                                                      viewBox: "0 0 12 7",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        stroke: "currentColor",
                                                        d: "M11 1 5.86 5.5 1 1",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.selectedCountryCode,
                                                    expression:
                                                      "selectedCountryCode",
                                                  },
                                                ],
                                                staticClass:
                                                  "newsletter__country-select-field",
                                                attrs: { name: "country_code" },
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.selectedCountryCode =
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                _vm.countryList,
                                                function (country) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: country.code,
                                                      domProps: {
                                                        value: country.code,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.getCountryText(
                                                              country
                                                            )
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3849023645
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "Button",
                  {
                    staticClass:
                      "button--secondary white button--newsletter newsletter__button",
                    attrs: { type: "submit" },
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.buttonText) },
                    }),
                  ]
                ),
                _vm._v(" "),
                _vm.note
                  ? _c("p", {
                      staticClass: "newsletter__note p2 p2--small-lg-max",
                      domProps: { innerHTML: _vm._s(_vm.note) },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.response
            ? _c(
                "div",
                {
                  staticClass: "newsletter__response",
                  class: { success: _vm.isSuccess },
                },
                [
                  _vm.isSuccess || !_vm.klaviyoErrorsOnFields
                    ? _c("p", {
                        staticClass: "newsletter__success-text",
                        class: [_vm.isSuccess ? "h3" : "p2 text-error"],
                        domProps: { innerHTML: _vm._s(_vm.responseText) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSuccess &&
                  _vm.successSubText &&
                  _vm.successSubText.length
                    ? _c("p", {
                        staticClass:
                          "newsletter__success-sub-text p2 p2--small-lg-max",
                        domProps: { innerHTML: _vm._s(_vm.successSubText) },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/pagination/Pagination.vue?vue&type=template&id=50664f84&":
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/pagination/Pagination.vue?vue&type=template&id=50664f84& ***!
  \************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pagination" }, [
    _c("div", { staticClass: "pagination__inner" }, [
      _c(
        "ul",
        { staticClass: "f aic jcc" },
        [
          _c("li", { staticClass: "pagination__arrow" }, [
            _c(
              "a",
              {
                staticClass: "pagination__arrow-next-prev prev label",
                class: [_vm.isShowPrev ? "" : "is-disabled"],
                attrs: { href: "!#", title: "Prev" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleClickPrev.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n          Prev\n        ")]
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.pages, function (page, index) {
            return _c("li", { key: index, staticClass: "pagination__page" }, [
              _c("a", {
                staticClass: "label pagination__page-link",
                class: { "is-active": page == _vm.currentPage },
                attrs: { href: "!#" },
                domProps: { textContent: _vm._s(page) },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleClickPage(page, $event)
                  },
                },
              }),
            ])
          }),
          _vm._v(" "),
          _c("li", { staticClass: "pagination__arrow" }, [
            _c(
              "a",
              {
                staticClass: "pagination__arrow-next-prev next label",
                class: [_vm.isShowNext ? "" : "is-disabled"],
                attrs: { href: "!#", title: "Next" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleClickNext.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n          Next\n        ")]
            ),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/picture/Picture.vue?vue&type=template&id=18d33dfc&scoped=true&":
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/picture/Picture.vue?vue&type=template&id=18d33dfc&scoped=true& ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "picture",
    {
      staticClass: "picture",
      class: [
        "picture--" + _vm.objectFit,
        { "picture--fade-in": _vm.fadeIn },
        { "picture--is-loaded": _vm.isLoaded },
      ],
    },
    [
      _vm._l(_vm.srcsets, function (srcset, i) {
        return _c("source", {
          key: i,
          ref: "source",
          refInFor: true,
          attrs: {
            media: _vm.sourceBreakpointsArr[i],
            "data-srcset": srcset,
            sizes: _vm.sizesStr,
          },
        })
      }),
      _vm._v(" "),
      _c("img", {
        ref: "img",
        staticClass: "picture__img",
        attrs: {
          "data-src": _vm.sourcesArrFiltered[_vm.sourcesArr.length - 1],
          alt: _vm.alt,
          width: _vm.explicitWidth || "",
          height: _vm.explicitHeight || "",
          loading: _vm.isLazy ? "lazy" : "eager",
        },
      }),
      _vm._v(" "),
      _vm.loader ? _c("div", { staticClass: "picture__loader" }) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/pre-order-note/PreOrderNote.vue?vue&type=template&id=2c4f4ee0&":
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/pre-order-note/PreOrderNote.vue?vue&type=template&id=2c4f4ee0& ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { class: ["pre-order-note", _vm.className] }, [
        _c("div", { staticClass: "pre-order-note__inner" }, [
          _vm.title
            ? _c("h3", { staticClass: "label pre-order-note__title" }, [
                _vm._v(_vm._s(_vm.title)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.note
            ? _c("p", { staticClass: "pre-order-note__text" }, [
                _vm._v(_vm._s(_vm.note)),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-bundle/ProductBundle.vue?vue&type=template&id=81b9013a&":
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-bundle/ProductBundle.vue?vue&type=template&id=81b9013a& ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasBundle
    ? _c(
        "div",
        { staticClass: "product-bundle" },
        _vm._l(_vm.activeGroups, function (group) {
          return group.products.length
            ? _c(
                "div",
                { key: group.group_id, staticClass: "product-bundle__group" },
                [
                  group.title
                    ? _c("h2", { staticClass: "label product-bundle__title" }, [
                        _vm._v("\n      " + _vm._s(group.title) + "\n    "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "product-bundle__list" },
                    _vm._l(group.products, function (item) {
                      return _c(
                        "button",
                        {
                          key: item.id,
                          staticClass:
                            "product-bundle__item p2 p2--small-2-lg-max",
                          class: {
                            "is-active":
                              _vm.selectedByGroup[group.group_id] === item.id,
                            "is-sold-out": !item.available,
                          },
                          attrs: { type: "button", disabled: !item.available },
                          on: {
                            click: function ($event) {
                              return _vm.handleClick(group, item)
                            },
                          },
                        },
                        [
                          !item.available
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "product-bundle__badge product-bundle__sold-out-copy",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.soldOutText) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : item.isNew
                            ? _c(
                                "span",
                                { staticClass: "product-bundle__badge" },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.newTagText) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-picture", {
                            attrs: {
                              sources: item.featuredImage,
                              alt: item.title,
                              "object-fit": "width",
                              "is-lazy": true,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "product-bundle__item-title" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(item.title) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e()
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-card/ProductCard.vue?vue&type=template&id=6a2bc502&":
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-card/ProductCard.vue?vue&type=template&id=6a2bc502& ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-card" }, [
    _c(
      "a",
      {
        staticClass: "product-card__featured ratio",
        class: { "product-card__featured--has-media": !!_vm.productImage },
        attrs: { href: _vm.product.url },
        on: {
          click: function ($event) {
            return _vm.handleClick()
          },
        },
      },
      [
        !_vm.product.available &&
        typeof _vm.product.available1 !== "undefined" &&
        !_vm.product.available1
          ? _c("div", { staticClass: "product-card__out-of-stock" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.product.productVendorType) +
                  " & " +
                  _vm._s(
                    _vm.product.productVendorType === "Pick Up"
                      ? "Delivery"
                      : "Pickup"
                  ) +
                  " is out of stock.\n    "
              ),
            ])
          : _vm.product.available &&
            typeof _vm.product.available1 !== "undefined" &&
            !_vm.product.available1
          ? _c("div", { staticClass: "product-card__out-of-stock" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.product.productVendorType === "Pick Up"
                      ? "Delivery"
                      : "Pickup"
                  ) +
                  " is out of stock.\n    "
              ),
            ])
          : !_vm.product.available
          ? _c("div", { staticClass: "product-card__out-of-stock" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.product.productVendorType) +
                  " is out of stock.\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.productImage
          ? _c("v-picture", {
              attrs: {
                sources: _vm.productImage.src,
                alt: _vm.productImage.alt,
                "explicit-width": _vm.productImage.width,
                "explicit-height": _vm.productImage.height,
                fadeIn: false,
                "object-fit": "cover",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.hoverImage &&
        _vm.productImageSecond &&
        _vm.productImageSecond.media_type === "image"
          ? _c(
              "div",
              { staticClass: "media-secondary" },
              [
                _c("v-picture", {
                  attrs: {
                    sources: _vm.productImageSecond.src,
                    alt: _vm.productImageSecond.alt,
                    "explicit-width": _vm.productImageSecond.width,
                    "explicit-height": _vm.productImageSecond.height,
                    fadeIn: false,
                    "object-fit": "cover",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hoverImage &&
        _vm.productImageSecond &&
        _vm.productImageSecond.media_type === "video"
          ? _c(
              "div",
              { staticClass: "media-secondary" },
              [
                _vm.productImageSecond.media_type === "video"
                  ? _c("v-video", {
                      key: "video-" + _vm.position,
                      ref: "videos",
                      attrs: {
                        sources: _vm.productImageSecond.sources[0].url,
                        "fade-in": true,
                        autoplay: true,
                        controls: false,
                        loader: true,
                        muted: true,
                        poster: _vm.productImageSecond.preview_image.src,
                        css: "ratio ratio--16x9",
                        "threshold-group": _vm.videoThresholdGroupd,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hoverImage &&
        _vm.productImageSecond &&
        _vm.productImageSecond.media_type === "external_video"
          ? _c(
              "div",
              { staticClass: "media-secondary" },
              [
                _vm.productImageSecond.media_type === "external_video"
                  ? _c("video-embed", {
                      key: "external-video-" + _vm.position,
                      ref: "externalVideos",
                      attrs: {
                        uid: "external-video-" + _vm.position,
                        "you-tube-video-id":
                          _vm.productImageSecond.host === "youtube"
                            ? "" + _vm.productImageSecond.external_id
                            : null,
                        "vimeo-video-url":
                          _vm.productImageSecond.host === "vimeo"
                            ? "https://vimeo.com/" +
                              _vm.productImageSecond.external_id
                            : null,
                        "fade-in": "",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.product.title
      ? _c("h3", {
          staticClass: "h4 h4--large product-card__title",
          domProps: { innerHTML: _vm._s(_vm.product.title) },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.showShortDescription
      ? _c("p", {
          staticClass: "p2 product-card__description",
          domProps: { innerHTML: _vm._s(_vm.product.shortDescription) },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("p", {
      staticClass: "p2 product-card__price",
      domProps: { innerHTML: _vm._s(_vm.price) },
    }),
    _vm._v(" "),
    _vm.showButtons
      ? _c("div", { staticClass: "product-card__group-btn f" }, [
          _vm.product.productVendorType && _vm.product.handle
            ? _c("a", {
                staticClass: "button button--product-card__button",
                class: {
                  "product-card__button--delivery":
                    _vm.product.productVendorType === "Delivery",
                },
                attrs: { href: _vm.product.url },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.product.productVendorType === "Pick Up"
                      ? "Pick Up"
                      : _vm.product.productVendorType
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClick()
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.product.productVendorType1 && _vm.product.handle1
            ? _c("a", {
                staticClass: "button button--product-card__button",
                class: {
                  "product-card__button--delivery":
                    _vm.product.productVendorType1 === "Delivery",
                },
                attrs: { href: _vm.product.url1 },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.product.productVendorType1 === "Pick Up"
                      ? "Pick Up"
                      : _vm.product.productVendorType1
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClick()
                  },
                },
              })
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showAddToCart
      ? _c(
          "form",
          {
            staticClass: "product-card__form",
            attrs: {
              action: "/cart/add",
              "data-productid": _vm.product.id,
              method: "post",
              enctype: "multipart/form-data",
            },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.addToCart.apply(null, arguments)
              },
            },
          },
          [
            _c("div", {}, [
              _c(
                "button",
                {
                  staticClass: "button button--red button--red-custom",
                  attrs: { disabled: _vm.cantAddTocart },
                },
                [_c("span", [_vm._v("Add to Cart")])]
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-form/ProductForm.vue?vue&type=template&id=98594232&":
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-form/ProductForm.vue?vue&type=template&id=98594232& ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-form__inner" },
    [
      _vm._t("default", null, null, {
        activeVariant: _vm.activeVariant,
        firstAvailableVariant: _vm.firstAvailableVariant,
        submitButtonText: _vm.submitButtonText,
        addToCart: _vm.addToCart,
        cantAddTocart: _vm.cantAddTocart,
        formattedPrice: _vm.formattedPrice,
        formattedPriceCompareAt: _vm.formattedPriceCompareAt,
        onSelectChange: _vm.onSelectChange,
        onSelectChangeStore: _vm.onSelectChangeStore,
        generateOptionArray: _vm.generateOptionArray,
        generateOptionStore: _vm.generateOptionStore,
        generateOptionDate: _vm.generateOptionDate,
        noteTitle: _vm.noteTitle,
        noteText: _vm.noteText,
        deliveryNote: _vm.deliveryNote,
        locationZips: _vm.locationZips,
        checkZipCode: _vm.checkZipCode,
        showDelivery: _vm.showDelivery,
        enableDatePickStore: _vm.enableDatePickStore,
        isShowModal: _vm.isShowModal,
        updateSelectedOption: _vm.updateSelectedOption,
        closeMessageModal: _vm.closeMessageModal,
        selectedOptions: _vm.selectedOptions,
        isPriceCompareAt: _vm.isPriceCompareAt,
        isPreOrder: _vm.isPreOrder,
        setLabel: _vm.setLabel,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-main-header/ProductMainHeader.vue?vue&type=template&id=4509bc10&":
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-main-header/ProductMainHeader.vue?vue&type=template&id=4509bc10& ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-main-header" },
    [
      _vm._t("default", null, null, {
        formattedPrice: _vm.formattedPrice,
        formattedPriceCompareAt: _vm.formattedPriceCompareAt,
        activeVariant: _vm.activeVariant,
        isPriceCompareAt: _vm.isPriceCompareAt,
        isPreOrder: _vm.isPreOrder,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-note/ProductNote.vue?vue&type=template&id=36b94243&":
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-note/ProductNote.vue?vue&type=template&id=36b94243& ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.title && _vm.text
    ? _c("div", { staticClass: "product-note bg-sage" }, [
        _c("h4", {
          staticClass: "label product-note__title",
          domProps: { innerHTML: _vm._s(_vm.title) },
        }),
        _vm._v(" "),
        _c("p", {
          staticClass: "p2 product-note__text",
          domProps: { innerHTML: _vm._s(_vm.text) },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-zip/ProductZip.vue?vue&type=template&id=6dcd56bf&":
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/product-zip/ProductZip.vue?vue&type=template&id=6dcd56bf& ***!
  \*************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-zip", class: { "product-zip--error": _vm.error } },
    [
      _c(
        "div",
        { staticClass: "product-zip__wrapper" },
        [
          _c("TextInput", {
            staticClass: "text-input--zip",
            attrs: {
              placeholder: "Enter zip code",
              name: "product_zipcode",
              type: "number",
              initialValue: _vm.initialValue,
              label: "Zip Code",
            },
            on: { change: _vm.onInputChange },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "button button--zip product-zip__button  js-button-zip",
              attrs: { disabled: !_vm.nameValue },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handle.apply(null, arguments)
                },
              },
            },
            [_vm._v("Submit")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.error
          ? _c("p", {
              staticClass: "product-zip__error p2",
              domProps: { innerHTML: _vm._s(_vm.errorHtml) },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/quantity-selector/QuantitySelector.vue?vue&type=template&id=35ae8739&":
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/quantity-selector/QuantitySelector.vue?vue&type=template&id=35ae8739& ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quantity-selector" }, [
    _c(
      "button",
      {
        staticClass: "quantity-selector__action",
        attrs: {
          disabled: !_vm.decreasable || _vm.disabled,
          type: "button",
          "aria-label": "Reduce product quantity by one",
        },
        on: { click: _vm.decrease },
      },
      [_vm._t("decrease")],
      2
    ),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      staticClass: "quantity-selector__field",
      attrs: {
        type: "number",
        min: _vm.min,
        max: _vm.max,
        disabled: _vm.disabled || (!_vm.decreasable && !_vm.increasable),
        "aria-label": "Quantity",
        "aria-live": "polite",
      },
      domProps: { value: _vm.value },
      on: {
        change: _vm.onInputChange,
        blur: _vm.onBlur,
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.onEnter.apply(null, arguments)
        },
      },
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "quantity-selector__action quantity-selector__action--plus",
        attrs: {
          type: "button",
          disabled: !_vm.increasable || _vm.disabled,
          "aria-label": "Increase product quantity by one",
        },
        on: { click: _vm.increase },
      },
      [_vm._t("increase")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-card/RecipeCard.vue?vue&type=template&id=40ae529f&":
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/recipe-card/RecipeCard.vue?vue&type=template&id=40ae529f& ***!
  \*************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "recipe-card relative" }, [
    _c("div", { staticClass: "recipe-card__wrapper ratio" }, [
      _c(
        "div",
        {
          staticClass: "recipe-card__image ratio",
          class: { "recipe-card__image--full-width": _vm.largeImage },
        },
        [
          _vm.imageSrc
            ? _c("v-picture", {
                attrs: {
                  sources: _vm.imageSrc,
                  alt: _vm.imageAltText,
                  fadeIn: false,
                  "object-fit": "cover",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.event
        ? _c("a", {
            staticClass: "recipe-card__link",
            attrs: {
              href: _vm.link,
              target: _vm.externalLink && "_blank",
              "aria-label": "Article Link",
            },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "recipe-card__content" },
      [
        _vm.event && _vm.eventTag
          ? _c(
              "div",
              { staticClass: "recipe-card__tags" },
              _vm._l(_vm.eventTag, function (tag, index) {
                return _c("span", {
                  key: index,
                  staticClass: "label recipe-card__tag",
                  domProps: {
                    innerHTML: _vm._s(tag.replace("_", " ").replace("-", " ")),
                  },
                })
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.title
          ? _c("p", { staticClass: "h3 recipe-card__title" }, [
              _vm.event || _vm.showTitle
                ? _c("a", {
                    staticClass: "h3 recipe-card__title",
                    attrs: {
                      href: _vm.link,
                      target: _vm.externalLink && "_blank",
                    },
                    domProps: { innerHTML: _vm._s(_vm.title) },
                  })
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.event
          ? _c("p", {
              staticClass: "p2 recipe-card__date",
              domProps: { innerHTML: _vm._s(_vm.eventDateText) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.excerptAcf && _vm.event
          ? _c("p", {
              staticClass: "p2 recipe-card__text",
              domProps: { innerHTML: _vm._s(_vm.excerptAcf) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.excerpt && !_vm.event
          ? _c("p", {
              staticClass: "p2 recipe-card__text",
              domProps: { innerHTML: _vm._s(_vm.excerpt) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.link && _vm.buttonText && !_vm.hideButton
          ? _c(
              "v-button",
              {
                attrs: {
                  href: _vm.link,
                  target: _vm.externalLink && "_blank",
                  modifier: "primary recipe-card__button",
                  type: "link",
                },
              },
              [
                _vm._v("\n      " + _vm._s(_vm.buttonText) + "\n      "),
                _c("template", { slot: "icon" }, [
                  _vm.event && _vm.externalLink
                    ? _c("span", { staticClass: "recipe-card__icon" }, [
                        _c(
                          "svg",
                          { attrs: { fill: "none", viewBox: "0 0 10 10" } },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#000",
                                "fill-rule": "evenodd",
                                d: "M0 2.941A2.941 2.941 0 0 1 2.941 0h1.47a.588.588 0 1 1 0 1.176h-1.47c-.974 0-1.765.79-1.765 1.765V7.06c0 .974.79 1.765 1.765 1.765H7.06c.974 0 1.765-.79 1.765-1.765V5.59a.588.588 0 1 1 1.176 0v1.47A2.941 2.941 0 0 1 7.059 10H2.94A2.941 2.941 0 0 1 0 7.059V2.94ZM6.176.588c0-.325.264-.588.589-.588h2.353c.487 0 .882.395.882.882v2.353a.588.588 0 1 1-1.176 0V2.008L5.416 5.416a.588.588 0 0 1-.832-.832l3.408-3.408H6.765a.588.588 0 0 1-.589-.588Z",
                                "clip-rule": "evenodd",
                              },
                            }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ],
              2
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=template&id=31b6dfa4&":
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=template&id=31b6dfa4& ***!
  \********************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.articles.length > 0
    ? _c("section", { staticClass: "recipe-grid recipe-grid-tab" }, [
        _c(
          "div",
          { staticClass: "recipe-grid__tabs", attrs: { role: "tablist" } },
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "button",
              {
                key: tab.value,
                staticClass: "recipe-grid__tab",
                class: {
                  "recipe-grid__tab--active": _vm.activeTab === tab.value,
                },
                attrs: {
                  "aria-selected": _vm.activeTab === tab.value,
                  role: "tab",
                  tabindex: _vm.activeTab === tab.value ? 0 : -1,
                },
                on: {
                  click: function ($event) {
                    _vm.activeTab = tab.value
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.tabs.find(function (tab) {
          return tab.value === _vm.activeTab
        }).articles.length > 0
          ? _c(
              "div",
              { staticClass: "recipe-grid__row" },
              _vm._l(
                _vm.tabs.find(function (tab) {
                  return tab.value === _vm.activeTab
                }).articles,
                function (article) {
                  return _c(
                    "article",
                    { key: article.id, staticClass: "recipe-grid__col" },
                    [
                      _c("recipe-card", {
                        staticClass: "recipe-card--grid",
                        class: { "recipe-card--event": _vm.event },
                        attrs: {
                          image: article.image,
                          "image-alt": article.imageAlt,
                          "large-image": article.largeImage,
                          "large-image-alt": article.largeImageAlt,
                          title: article.title,
                          excerpt: article.excerpt,
                          "button-url": article.url,
                          "external-link": article.externalLink,
                          "button-text": article.ctaText,
                          "hide-button": article.hideCta === "true",
                          event: _vm.event,
                          "event-start-date": article.eventStartDate,
                          "has-populate-start-date":
                            article.hasPopulateStartDate,
                          "has-populate-end-date": article.hasPopulateEndDate,
                          "event-date": article.eventDate,
                          "published-at": article.publishedAt,
                          "event-tag": article.eventTags,
                          "excerpt-acf": article.excerptAcf,
                          location: article.location,
                          "show-title": _vm.showTitle,
                        },
                      }),
                    ],
                    1
                  )
                }
              ),
              0
            )
          : _c("div", { staticClass: "recipe-grid__row" }, [
              _c("p", { staticClass: "recipe-grid__message" }, [
                _vm._v("\n      No articles found.\n    "),
              ]),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-grid/RecipeGrid.vue?vue&type=template&id=7afbd642&":
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/recipe-grid/RecipeGrid.vue?vue&type=template&id=7afbd642& ***!
  \*************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.articles.length > 0
    ? _c("div", { staticClass: "recipe-grid" }, [
        _c(
          "div",
          { staticClass: "recipe-grid__row" },
          _vm._l(_vm.sortedArticles, function (article) {
            return _c(
              "div",
              { key: article.id, staticClass: "recipe-grid__col" },
              [
                _c("recipe-card", {
                  staticClass: "recipe-card--grid",
                  class: { "recipe-card--event": _vm.event },
                  attrs: {
                    image: article.image,
                    "image-alt": article.imageAlt,
                    "large-image": article.largeImage,
                    "large-image-alt": article.largeImageAlt,
                    title: article.title,
                    excerpt: article.excerpt,
                    "button-url": article.url,
                    "external-link": article.externalLink,
                    "button-text": article.ctaText,
                    "hide-button": article.hideCta === "true",
                    event: _vm.event,
                    "event-start-date": article.eventStartDate,
                    "has-populate-start-date": article.hasPopulateStartDate,
                    "has-populate-end-date": article.hasPopulateEndDate,
                    "event-date": article.eventDate,
                    "published-at": article.publishedAt,
                    "event-tag": article.eventTags,
                    "excerpt-acf": article.excerptAcf,
                    location: article.location,
                    "show-title": _vm.showTitle,
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/select-input/SelectInput.vue?vue&type=template&id=b9a41bce&":
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/select-input/SelectInput.vue?vue&type=template&id=b9a41bce& ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "select-input",
      class: [
        "select-input--" + _vm.modifier,
        { "is-active": _vm.isActive },
        { "is-focus": _vm.isFocus },
        { "has-error": !_vm.isValid },
        { "is-required": _vm.required },
        { "is-disabled": _vm.disabled },
      ],
    },
    [
      _vm.label
        ? _c("label", { staticClass: "select-input__label label" }, [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "select-input__wrapper" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue",
              },
            ],
            ref: "selectEl",
            staticClass: "select-input__el p1",
            class: { "is-empty": _vm.inputValue === "" },
            attrs: {
              id: _vm.randomID,
              name: _vm.name,
              "aria-label": _vm.ariaLabel || null,
              "aria-labelledby": _vm.ariaLabelledBy || null,
              "aria-describedby": !_vm.isValid ? "error-" + _vm.randomID : null,
              disabled: _vm.disabled,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event.target.value)
              },
              focus: function ($event) {
                _vm.isFocus = true
              },
              blur: _vm.unsetActive,
              click: function ($event) {
                _vm.isFocus = true
              },
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.inputValue = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _vm.inputOptions.length
              ? [
                  _vm.placeholder
                    ? _c(
                        "option",
                        {
                          attrs: { value: "", disabled: "" },
                          domProps: { selected: !_vm.inputValue.length },
                        },
                        [_vm._v(_vm._s(_vm.placeholder))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.inputOptions, function (option, index) {
                    return _c(
                      "option",
                      {
                        key: index,
                        domProps: {
                          value: option.value,
                          selected: _vm.inputValue === option.value,
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(option.label) + "\n        "
                        ),
                      ]
                    )
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c("i", { staticClass: "select-input__icon" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "10",
                height: "6",
                viewBox: "0 0 10 6",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: { d: "M9.5 0.5L4.87422 4.5L0.5 0.5", stroke: "#000" },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.isValid
          ? _c(
              "p",
              {
                staticClass: "select-input__error p2",
                attrs: { id: "error-" + _vm.randomID },
              },
              [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/social-links/SocialLinks.vue?vue&type=template&id=cbda2e52&":
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/social-links/SocialLinks.vue?vue&type=template&id=cbda2e52& ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "social-links", class: _vm.css }, [
    _vm.urlInstagram
      ? _c("li", [
          _c(
            "a",
            {
              staticClass: "icon social-links__icon icon-instagram",
              attrs: {
                target: "_blank",
                href: _vm.urlInstagram,
                title: _vm.title + " on Instagram",
              },
            },
            [_c("icon-instagram")],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.urlFacebook
      ? _c("li", [
          _c(
            "a",
            {
              staticClass: "icon social-links__icon icon-facebook",
              attrs: {
                target: "_blank",
                href: _vm.urlFacebook,
                title: _vm.title + " on Facebook",
              },
            },
            [_c("icon-facebook")],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.urlTiktok
      ? _c("li", [
          _c(
            "a",
            {
              staticClass: "icon social-links__icon icon-tiktok",
              attrs: {
                target: "_blank",
                href: _vm.urlTiktok,
                title: _vm.title + " on Tiktok",
              },
            },
            [_c("icon-tiktok")],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.urlPinterest
      ? _c("li", [
          _c(
            "a",
            {
              staticClass: "icon social-links__icon icon-pinterest",
              attrs: {
                target: "_blank",
                href: _vm.urlPinterest,
                title: _vm.title + " on Pinterest",
              },
            },
            [_c("icon-pinterest")],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=template&id=9c52a820&":
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=template&id=9c52a820& ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "store-locator-tabs" },
    [
      _c(
        "div",
        {
          staticClass: "store-locator-tabs__tabs",
          attrs: { role: "tablist", "aria-label": "Store Locator Tabs" },
        },
        _vm._l(_vm.DEFAULT_TABS, function (tab, index) {
          return _c(
            "button",
            {
              key: tab.id,
              ref: "tabs",
              refInFor: true,
              staticClass: "store-locator-tabs__tab",
              attrs: {
                id: "tab-" + tab.id,
                type: "button",
                role: "tab",
                tabindex: _vm.activeTab === tab.id ? 0 : -1,
                "aria-selected": _vm.activeTab === tab.id,
                "aria-controls": "tabpanel-" + tab.id,
              },
              on: {
                click: function ($event) {
                  return _vm.setActiveTab(index)
                },
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "arrow-left",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    return _vm.navigateToPreviousTab(index)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "arrow-right",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    return _vm.navigateToNextTab(index)
                  },
                ],
              },
            },
            [_c("span", [_vm._v(_vm._s(tab.label))])]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.DEFAULT_TABS, function (tab) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === tab.id,
                expression: "activeTab === tab.id",
              },
            ],
            key: "tabpanel-" + tab.id,
            staticClass: "store-locator-tabs__tabpanel",
            attrs: {
              id: "tabpanel-" + tab.id,
              role: "tabpanel",
              tabindex: "0",
              "aria-labelledby": "tab-" + tab.id,
            },
          },
          [
            tab.id === "stockList"
              ? _c("div", { attrs: { "data-stockist-widget-tag": "u12653" } }, [
                  _vm._v("\n      Loading store locator from\n      "),
                  _c("a", { attrs: { href: "https://stockist.co" } }, [
                    _vm._v("Stockist store locator"),
                  ]),
                  _vm._v("...\n    "),
                ])
              : _c(
                  "div",
                  { staticClass: "store-locator-tabs__online-stores" },
                  [
                    _vm.onlineStores.length
                      ? _vm._l(_vm.onlineStores, function (store, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "store-locator-tabs__online-store",
                              attrs: {
                                role: "region",
                                tabindex: "0",
                                "aria-label": store.name + " online store",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "store-locator-tabs__online-store-logo",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: store.logo,
                                      alt: "Logo of " + store.name,
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "store-locator-tabs__online-store-description",
                                domProps: {
                                  innerHTML: _vm._s(store.description),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "button store-locator-tabs__online-store-cta",
                                  attrs: {
                                    href: store.ctaUrl,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(store.ctaText) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        })
                      : _c("p", [_vm._v("No online stores available.")]),
                  ],
                  2
                ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/testimonial-card/TestimonialCard.vue?vue&type=template&id=d829fa02&":
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/testimonial-card/TestimonialCard.vue?vue&type=template&id=d829fa02& ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "testimonial-card" }, [
    _c("div", { staticClass: "testimonial-card__container" }, [
      _c("div", { staticClass: "testimonial-card__inner" }, [
        _c("div", { staticClass: "testimonial-card__content" }, [
          _vm.title
            ? _c("h2", {
                staticClass: "h1 testimonial-card__title",
                domProps: { innerHTML: _vm._s(_vm.title) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.author
            ? _c("p", {
                staticClass: "label testimonial-card__author",
                domProps: { innerHTML: _vm._s(_vm.author) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.position
            ? _c("p", {
                staticClass: "p2 testimonial-card__position",
                domProps: { innerHTML: _vm._s(_vm.position) },
              })
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "testimonial-card__featured",
          class: { "ratio testimonial-card__featured--ratio": !_vm.video },
        },
        [
          _vm.video
            ? _c("v-video", {
                key: "video-" + _vm.index,
                ref: "videoEl",
                staticClass: "video--testimonials",
                attrs: {
                  sources: _vm.video,
                  poster: _vm.image,
                  "fade-in": false,
                  autoplay: false,
                  controls: false,
                  muteControl: true,
                  thresholdGroup: _vm.thresholdGroup,
                },
              })
            : _vm.image
            ? _c("v-picture", {
                key: "image-" + _vm.index,
                attrs: {
                  sources: _vm.image,
                  fadeIn: false,
                  "object-fit": "cover",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/text-input/TextInput.vue?vue&type=template&id=bc79848e&":
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/text-input/TextInput.vue?vue&type=template&id=bc79848e& ***!
  \***********************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-input",
      class: [
        "text-input--" + _vm.modifier,
        { "is-active": _vm.isActive },
        { "has-error": !_vm.isValid },
        { "is-required": _vm.required },
        { "has-value": _vm.inputValue.length > 0 },
        { "text-input--floating": _vm.floatingLabel },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "text-input__wrapper" },
        [
          _vm.label
            ? _c(
                "label",
                {
                  staticClass: "text-input__label",
                  class: {
                    "sr-only": _vm.srOnly,
                    label: !_vm.floatingLabel,
                    p2: _vm.floatingLabel,
                  },
                  attrs: { id: "label-" + _vm.randomID, for: _vm.randomID },
                },
                [_vm._v(_vm._s(_vm.inputLabel))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("beforeInput"),
          _vm._v(" "),
          _vm.type === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputValue,
                    expression: "inputValue",
                  },
                ],
                ref: "inputEl",
                staticClass: "text-input__el p2",
                attrs: {
                  id: _vm.randomID,
                  name: _vm.name,
                  "aria-label": _vm.ariaLabel || null,
                  "aria-labelledby": _vm.ariaLabelledBy || null,
                  "aria-describedby": !_vm.isValid
                    ? "error-" + _vm.randomID
                    : null,
                  placeholder: !_vm.floatingLabel ? _vm.placeholder : "",
                  autocomplete: "off",
                  type: "checkbox",
                },
                domProps: {
                  checked: Array.isArray(_vm.inputValue)
                    ? _vm._i(_vm.inputValue, null) > -1
                    : _vm.inputValue,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("input", $event.target.value)
                  },
                  focus: _vm.setActive,
                  blur: _vm.onBlur,
                  change: function ($event) {
                    var $$a = _vm.inputValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.inputValue = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.inputValue = $$c
                    }
                  },
                },
              })
            : _vm.type === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputValue,
                    expression: "inputValue",
                  },
                ],
                ref: "inputEl",
                staticClass: "text-input__el p2",
                attrs: {
                  id: _vm.randomID,
                  name: _vm.name,
                  "aria-label": _vm.ariaLabel || null,
                  "aria-labelledby": _vm.ariaLabelledBy || null,
                  "aria-describedby": !_vm.isValid
                    ? "error-" + _vm.randomID
                    : null,
                  placeholder: !_vm.floatingLabel ? _vm.placeholder : "",
                  autocomplete: "off",
                  type: "radio",
                },
                domProps: { checked: _vm._q(_vm.inputValue, null) },
                on: {
                  input: function ($event) {
                    return _vm.$emit("input", $event.target.value)
                  },
                  focus: _vm.setActive,
                  blur: _vm.onBlur,
                  change: function ($event) {
                    _vm.inputValue = null
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputValue,
                    expression: "inputValue",
                  },
                ],
                ref: "inputEl",
                staticClass: "text-input__el p2",
                attrs: {
                  id: _vm.randomID,
                  name: _vm.name,
                  "aria-label": _vm.ariaLabel || null,
                  "aria-labelledby": _vm.ariaLabelledBy || null,
                  "aria-describedby": !_vm.isValid
                    ? "error-" + _vm.randomID
                    : null,
                  placeholder: !_vm.floatingLabel ? _vm.placeholder : "",
                  autocomplete: "off",
                  type: _vm.type,
                },
                domProps: { value: _vm.inputValue },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inputValue = $event.target.value
                    },
                    function ($event) {
                      return _vm.$emit("input", $event.target.value)
                    },
                  ],
                  focus: _vm.setActive,
                  blur: _vm.onBlur,
                },
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.isValid
          ? _c(
              "p",
              {
                staticClass: "text-input__error p2",
                attrs: { id: "error-" + _vm.randomID },
              },
              [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/tiktok-card/TiktokCard.vue?vue&type=template&id=5e4c2112&":
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/tiktok-card/TiktokCard.vue?vue&type=template&id=5e4c2112& ***!
  \*************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tiktok-card ratio" },
    [
      _vm.video
        ? _c("v-video", {
            key: "video-" + _vm.index,
            ref: "videoEl",
            staticClass: "video--tiktok",
            attrs: {
              sources: _vm.video,
              "fade-in": false,
              autoplay: false,
              controls: false,
              muteControl: true,
              threshold: 0.1,
              thresholdGroup: "tiktok-carousel-" + _vm.index,
            },
          })
        : _vm.image
        ? _c("v-picture", {
            key: "image-" + _vm.index,
            attrs: { sources: _vm.image, fadeIn: false, "object-fit": "cover" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/video-embed/VideoEmbed.vue?vue&type=template&id=32ef7c32&":
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/video-embed/VideoEmbed.vue?vue&type=template&id=32ef7c32& ***!
  \*************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video-embed ratio ratio--16x9",
      class: {
        "video-embed--fade-in": _vm.fadeIn,
        "video-embed--is-loaded": _vm.isLoaded,
        "video-embed--has-played": _vm.hasPlayed,
      },
    },
    [
      _vm.image || _vm.youTubeVideoId || _vm.vimeoVideoUrl
        ? _c("div", { staticClass: "video-embed__content" }, [
            _c("div", {
              staticClass: "video-embed__iframe",
              attrs: { id: _vm.uid },
            }),
            _vm._v(" "),
            _vm.showControlButton
              ? _c(
                  "button",
                  {
                    ref: "playButton",
                    staticClass: "video-embed__placeholder js-video-embed-play",
                    attrs: { "data-uid": _vm.uid },
                  },
                  [
                    _c("v-picture", { attrs: { sources: _vm.image, alt: "" } }),
                    _vm._v(" "),
                    _vm.youTubeVideoId || _vm.vimeoVideoUrl
                      ? _c("div", { staticClass: "video-embed__play-button" })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loader ? _c("div", { staticClass: "video-embed__loader" }) : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/video/Video.vue?vue&type=template&id=27d01976&":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/video/Video.vue?vue&type=template&id=27d01976& ***!
  \**************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video",
      class: [
        {
          "video--fade-in": _vm.fadeIn,
          "video--is-loaded": _vm.isLoaded,
          "video--is-playing": _vm.isPlaying,
          "video--hide-controls": !_vm.controls,
        },
        _vm.css,
      ],
    },
    [
      _c(
        "video",
        _vm._g(
          {
            ref: "videoEl",
            staticClass: "video__el",
            attrs: {
              poster: _vm.poster,
              autoplay: _vm.autoplay,
              loop: _vm.loop,
              playsinline: _vm.playsinline,
              controls: _vm.controls,
            },
            domProps: { muted: _vm.internalMuted },
            on: {
              canplay: function ($event) {
                _vm.isLoaded = true
              },
              playing: function ($event) {
                _vm.isPlaying = true
              },
              pause: function ($event) {
                _vm.isPlaying = false
              },
            },
          },
          _vm.$listeners
        ),
        _vm._l(_vm.sourcesArrFiltered, function (source, i) {
          return _c("source", {
            key: i,
            ref: "source",
            refInFor: true,
            attrs: { "data-src": source },
          })
        }),
        0
      ),
      _vm._v(" "),
      _vm.muteControl
        ? _c(
            "button",
            {
              ref: "muteButton",
              staticClass: "video__mute",
              attrs: {
                "aria-label": _vm.internalMuted ? "Unmute Video" : "Mute Video",
              },
              on: { click: _vm.muteButtonClickHandler },
            },
            [
              _vm.internalMuted ? _c("icon-mute") : _vm._e(),
              _vm._v(" "),
              !_vm.internalMuted ? _c("icon-unmute") : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          ref: "controlButton",
          staticClass: "video__play-pause",
          attrs: { "aria-label": _vm.isPlaying ? "Pause Video" : "Play Video" },
          on: { click: _vm.controlButtonClickHandler },
        },
        [
          !_vm.isPlaying ? _c("icon-play") : _vm._e(),
          _vm._v(" "),
          _vm.isPlaying ? _c("icon-pause") : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loader ? _c("div", { staticClass: "video__loader" }) : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/video/video.vue?vue&type=template&id=9f440cd4&":
/*!**************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/video/video.vue?vue&type=template&id=9f440cd4& ***!
  \**************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video",
      class: [
        {
          "video--fade-in": _vm.fadeIn,
          "video--is-loaded": _vm.isLoaded,
          "video--is-playing": _vm.isPlaying,
          "video--hide-controls": !_vm.controls,
        },
        _vm.css,
      ],
    },
    [
      _c(
        "video",
        _vm._g(
          {
            ref: "videoEl",
            staticClass: "video__el",
            attrs: {
              poster: _vm.poster,
              autoplay: _vm.autoplay,
              loop: _vm.loop,
              playsinline: _vm.playsinline,
              controls: _vm.controls,
            },
            domProps: { muted: _vm.internalMuted },
            on: {
              canplay: function ($event) {
                _vm.isLoaded = true
              },
              playing: function ($event) {
                _vm.isPlaying = true
              },
              pause: function ($event) {
                _vm.isPlaying = false
              },
            },
          },
          _vm.$listeners
        ),
        _vm._l(_vm.sourcesArrFiltered, function (source, i) {
          return _c("source", {
            key: i,
            ref: "source",
            refInFor: true,
            attrs: { "data-src": source },
          })
        }),
        0
      ),
      _vm._v(" "),
      _vm.muteControl
        ? _c(
            "button",
            {
              ref: "muteButton",
              staticClass: "video__mute",
              attrs: {
                "aria-label": _vm.internalMuted ? "Unmute Video" : "Mute Video",
              },
              on: { click: _vm.muteButtonClickHandler },
            },
            [
              _vm.internalMuted ? _c("icon-mute") : _vm._e(),
              _vm._v(" "),
              !_vm.internalMuted ? _c("icon-unmute") : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          ref: "controlButton",
          staticClass: "video__play-pause",
          attrs: { "aria-label": _vm.isPlaying ? "Pause Video" : "Play Video" },
          on: { click: _vm.controlButtonClickHandler },
        },
        [
          !_vm.isPlaying ? _c("icon-play") : _vm._e(),
          _vm._v(" "),
          _vm.isPlaying ? _c("icon-pause") : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loader ? _c("div", { staticClass: "video__loader" }) : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/zoomable-image/ZoomableImage.vue?vue&type=template&id=3bec6f9b&":
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/zoomable-image/ZoomableImage.vue?vue&type=template&id=3bec6f9b& ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zoomable-image" },
    [
      _c("zoom-on-hover", {
        ref: "main",
        staticClass: "fill",
        attrs: {
          "img-normal": _vm.srcNormal,
          "img-zoom": _vm.srcZoom,
          scale: 1.5,
        },
        on: { loaded: _vm.loaded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js":
/*!********************************************************************!*\
  !*** ./node_modules/vue-loader/lib/runtime/componentNormalizer.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "./node_modules/vue-scrollto/vue-scrollto.js":
/*!***************************************************!*\
  !*** ./node_modules/vue-scrollto/vue-scrollto.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*!
  * vue-scrollto v2.20.0
  * (c) 2019 Randjelovic Igor
  * @license MIT
  */
(function (global, factory) {
   true ? module.exports = factory() : undefined;
})(this, function () {
  'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }
  /**
   * https://github.com/gre/bezier-easing
   * BezierEasing - use bezier curve for transition easing function
   * by Gaëtan Renaudeau 2014 - 2015 – MIT License
   */
  // These values are established by empiricism with tests (tradeoff: performance VS precision)


  var NEWTON_ITERATIONS = 4;
  var NEWTON_MIN_SLOPE = 0.001;
  var SUBDIVISION_PRECISION = 0.0000001;
  var SUBDIVISION_MAX_ITERATIONS = 10;
  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
  var float32ArraySupported = typeof Float32Array === 'function';

  function A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
  }

  function B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
  }

  function C(aA1) {
    return 3.0 * aA1;
  } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


  function getSlope(aT, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
  }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX,
        currentT,
        i = 0;

    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;

      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);

      if (currentSlope === 0.0) {
        return aGuessT;
      }

      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }

    return aGuessT;
  }

  function LinearEasing(x) {
    return x;
  }

  var src = function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
      throw new Error('bezier x values must be in [0, 1] range');
    }

    if (mX1 === mY1 && mX2 === mY2) {
      return LinearEasing;
    } // Precompute samples table


    var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }

    function getTForX(aX) {
      var intervalStart = 0.0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }

      --currentSample; // Interpolate to provide an initial guess for t

      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;
      var initialSlope = getSlope(guessForT, mX1, mX2);

      if (initialSlope >= NEWTON_MIN_SLOPE) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0.0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    }

    return function BezierEasing(x) {
      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
      if (x === 0) {
        return 0;
      }

      if (x === 1) {
        return 1;
      }

      return calcBezier(getTForX(x), mY1, mY2);
    };
  };

  var easings = {
    ease: [0.25, 0.1, 0.25, 1.0],
    linear: [0.0, 0.0, 1.0, 1.0],
    'ease-in': [0.42, 0.0, 1.0, 1.0],
    'ease-out': [0.0, 0.0, 0.58, 1.0],
    'ease-in-out': [0.42, 0.0, 0.58, 1.0]
  }; // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection

  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}

  var _ = {
    $: function $(selector) {
      if (typeof selector !== 'string') {
        return selector;
      }

      return document.querySelector(selector);
    },
    on: function on(element, events, handler) {
      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        passive: false
      };

      if (!(events instanceof Array)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        element.addEventListener(events[i], handler, supportsPassive ? opts : false);
      }
    },
    off: function off(element, events, handler) {
      if (!(events instanceof Array)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        element.removeEventListener(events[i], handler);
      }
    },
    cumulativeOffset: function cumulativeOffset(element) {
      var top = 0;
      var left = 0;

      do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
      } while (element);

      return {
        top: top,
        left: left
      };
    }
  };
  var abortEvents = ['mousedown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'keyup', 'touchmove'];
  var defaults = {
    container: 'body',
    duration: 500,
    lazy: true,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
  };

  function setDefaults(options) {
    defaults = _extends({}, defaults, options);
  }

  var scroller = function scroller() {
    var element; // element to scroll to

    var container; // container to scroll

    var duration; // duration of the scrolling

    var easing; // easing to be used when scrolling

    var lazy; // checks the target position at each step

    var offset; // offset to be added (subtracted)

    var force; // force scroll, even if element is visible

    var cancelable; // indicates if user can cancel the scroll or not.

    var onStart; // callback when scrolling is started

    var onDone; // callback when scrolling is done

    var onCancel; // callback when scrolling is canceled / aborted

    var x; // scroll on x axis

    var y; // scroll on y axis

    var initialX; // initial X of container

    var targetX; // target X of container

    var initialY; // initial Y of container

    var targetY; // target Y of container

    var diffX; // difference

    var diffY; // difference

    var abort; // is scrolling aborted

    var cumulativeOffsetContainer;
    var cumulativeOffsetElement;
    var abortEv; // event that aborted scrolling

    var abortFn = function abortFn(e) {
      if (!cancelable) return;
      abortEv = e;
      abort = true;
    };

    var easingFn;
    var timeStart; // time when scrolling started

    var timeElapsed; // time elapsed since scrolling started

    var progress; // progress

    function scrollTop(container) {
      var scrollTop = container.scrollTop;

      if (container.tagName.toLowerCase() === 'body') {
        // in firefox body.scrollTop always returns 0
        // thus if we are trying to get scrollTop on a body tag
        // we need to get it from the documentElement
        scrollTop = scrollTop || document.documentElement.scrollTop;
      }

      return scrollTop;
    }

    function scrollLeft(container) {
      var scrollLeft = container.scrollLeft;

      if (container.tagName.toLowerCase() === 'body') {
        // in firefox body.scrollLeft always returns 0
        // thus if we are trying to get scrollLeft on a body tag
        // we need to get it from the documentElement
        scrollLeft = scrollLeft || document.documentElement.scrollLeft;
      }

      return scrollLeft;
    }

    function recalculateTargets() {
      cumulativeOffsetContainer = _.cumulativeOffset(container);
      cumulativeOffsetElement = _.cumulativeOffset(element);

      if (x) {
        targetX = cumulativeOffsetElement.left - cumulativeOffsetContainer.left + offset;
        diffX = targetX - initialX;
      }

      if (y) {
        targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top + offset;
        diffY = targetY - initialY;
      }
    }

    function step(timestamp) {
      if (abort) return done();
      if (!timeStart) timeStart = timestamp; // When a site has a lot of media that can be loaded asynchronously,
      // the targetY/targetX may end up in the wrong place during scrolling.
      // So we will check this at each step

      if (!lazy) {
        recalculateTargets();
      }

      timeElapsed = timestamp - timeStart;
      progress = Math.min(timeElapsed / duration, 1);
      progress = easingFn(progress);
      topLeft(container, initialY + diffY * progress, initialX + diffX * progress);
      timeElapsed < duration ? window.requestAnimationFrame(step) : done();
    }

    function done() {
      if (!abort) topLeft(container, targetY, targetX);
      timeStart = false;

      _.off(container, abortEvents, abortFn);

      if (abort && onCancel) onCancel(abortEv, element);
      if (!abort && onDone) onDone(element);
    }

    function topLeft(element, top, left) {
      if (y) element.scrollTop = top;
      if (x) element.scrollLeft = left;

      if (element.tagName.toLowerCase() === 'body') {
        // in firefox body.scrollTop doesn't scroll the page
        // thus if we are trying to scrollTop on a body tag
        // we need to scroll on the documentElement
        if (y) document.documentElement.scrollTop = top;
        if (x) document.documentElement.scrollLeft = left;
      }
    }

    function scrollTo(target, _duration) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (_typeof(_duration) === 'object') {
        options = _duration;
      } else if (typeof _duration === 'number') {
        options.duration = _duration;
      }

      element = _.$(target);

      if (!element) {
        return console.warn('[vue-scrollto warn]: Trying to scroll to an element that is not on the page: ' + target);
      }

      container = _.$(options.container || defaults.container);
      duration = options.hasOwnProperty('duration') ? options.duration : defaults.duration;
      lazy = options.hasOwnProperty('lazy') ? options.lazy : defaults.lazy;
      easing = options.easing || defaults.easing;
      offset = options.hasOwnProperty('offset') ? options.offset : defaults.offset;
      force = options.hasOwnProperty('force') ? options.force !== false : defaults.force;
      cancelable = options.hasOwnProperty('cancelable') ? options.cancelable !== false : defaults.cancelable;
      onStart = options.onStart || defaults.onStart;
      onDone = options.onDone || defaults.onDone;
      onCancel = options.onCancel || defaults.onCancel;
      x = options.x === undefined ? defaults.x : options.x;
      y = options.y === undefined ? defaults.y : options.y;

      if (typeof offset === 'function') {
        offset = offset(element, container);
      }

      initialX = scrollLeft(container);
      initialY = scrollTop(container); // calculates cumulative offsets and targetX/Y + diffX/Y

      recalculateTargets();
      abort = false;

      if (!force) {
        // When the container is the default (body) we need to use the viewport
        // height, not the entire body height
        var containerHeight = container.tagName.toLowerCase() === 'body' ? document.documentElement.clientHeight || window.innerHeight : container.offsetHeight;
        var containerTop = initialY;
        var containerBottom = containerTop + containerHeight;
        var elementTop = targetY - offset;
        var elementBottom = elementTop + element.offsetHeight;

        if (elementTop >= containerTop && elementBottom <= containerBottom) {
          // make sure to call the onDone callback even if there is no need to
          // scroll the container. Fixes #111 (ref #118)
          if (onDone) onDone(element);
          return;
        }
      }

      if (onStart) onStart(element);

      if (!diffY && !diffX) {
        if (onDone) onDone(element);
        return;
      }

      if (typeof easing === 'string') {
        easing = easings[easing] || easings['ease'];
      }

      easingFn = src.apply(src, easing);

      _.on(container, abortEvents, abortFn, {
        passive: true
      });

      window.requestAnimationFrame(step);
      return function () {
        abortEv = null;
        abort = true;
      };
    }

    return scrollTo;
  };

  var _scroller = scroller();

  var bindings = []; // store binding data

  function deleteBinding(el) {
    for (var i = 0; i < bindings.length; ++i) {
      if (bindings[i].el === el) {
        bindings.splice(i, 1);
        return true;
      }
    }

    return false;
  }

  function findBinding(el) {
    for (var i = 0; i < bindings.length; ++i) {
      if (bindings[i].el === el) {
        return bindings[i];
      }
    }
  }

  function getBinding(el) {
    var binding = findBinding(el);

    if (binding) {
      return binding;
    }

    bindings.push(binding = {
      el: el,
      binding: {}
    });
    return binding;
  }

  function handleClick(e) {
    var ctx = getBinding(this).binding;
    if (!ctx.value) return;
    e.preventDefault();

    if (typeof ctx.value === 'string') {
      return _scroller(ctx.value);
    }

    _scroller(ctx.value.el || ctx.value.element, ctx.value);
  }

  var directiveHooks = {
    bind: function bind(el, binding) {
      getBinding(el).binding = binding;

      _.on(el, 'click', handleClick);
    },
    unbind: function unbind(el) {
      deleteBinding(el);

      _.off(el, 'click', handleClick);
    },
    update: function update(el, binding) {
      getBinding(el).binding = binding;
    }
  };
  var VueScrollTo = {
    bind: directiveHooks.bind,
    unbind: directiveHooks.unbind,
    update: directiveHooks.update,
    beforeMount: directiveHooks.bind,
    unmounted: directiveHooks.unbind,
    updated: directiveHooks.update,
    scrollTo: _scroller,
    bindings: bindings
  };

  var install = function install(Vue, options) {
    if (options) setDefaults(options);
    Vue.directive('scroll-to', VueScrollTo);
    var properties = Vue.config.globalProperties || Vue.prototype;
    properties.$scrollTo = VueScrollTo.scrollTo;
  };

  if (typeof window !== 'undefined' && window.Vue) {
    window.VueScrollTo = VueScrollTo;
    window.VueScrollTo.setDefaults = setDefaults;
    window.VueScrollTo.scroller = scroller;
    if (window.Vue.use) window.Vue.use(install);
  }

  VueScrollTo.install = install;
  return VueScrollTo;
});

/***/ }),

/***/ "./node_modules/vue-zoom-on-hover/dist/index.js":
/*!******************************************************!*\
  !*** ./node_modules/vue-zoom-on-hover/dist/index.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * vue-zoom-on-hover v1.0.4
 * (c) Ivan Alexandrov
 * Released under the GPL-3.0 License.
 */
 //
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  props: ["imgNormal", "imgZoom", "scale", "disabled", "altText"],
  data: function data() {
    return {
      scaleFactor: 1,
      resizeCheckInterval: null,
      zoomed: false
    };
  },
  methods: {
    pageOffset: function pageOffset(el) {
      // -> {x: number, y: number}
      // get the left and top offset of a dom block element
      var rect = el.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
        y: rect.top + scrollTop,
        x: rect.left + scrollLeft
      };
    },
    touchzoom: function touchzoom(event) {
      if (this.disabled) return;
      this.zoomed = event.type === "pointerover";
      this.move(event);
    },
    zoom: function zoom() {
      if (this.disabled) return;
      this.zoomed = true;
    },
    unzoom: function unzoom() {
      if (this.disabled) return;
      this.zoomed = false;
    },
    move: function move(event) {
      var zoom = this.$refs.zoom;
      var normal = this.$refs.normal;
      if (this.disabled || !this.zoomed || !zoom || !normal) return;
      var offset = this.pageOffset(this.$el);
      var relativeX = event.clientX - offset.x + window.pageXOffset;
      var relativeY = event.clientY - offset.y + window.pageYOffset;
      var normalFactorX = relativeX / normal.offsetWidth;
      var normalFactorY = relativeY / normal.offsetHeight;
      var x = normalFactorX * (zoom.offsetWidth * this.scaleFactor - normal.offsetWidth);
      var y = normalFactorY * (zoom.offsetHeight * this.scaleFactor - normal.offsetHeight);
      zoom.style.left = -x + "px";
      zoom.style.top = -y + "px";
    },
    initEventLoaded: function initEventLoaded() {
      // emit the "loaded" event if all images have been loaded
      var promises = [this.$refs.zoom, this.$refs.normal].map(function (image) {
        return new Promise(function (resolve, reject) {
          image.addEventListener("load", resolve);
          image.addEventListener("error", reject);
        });
      });
      var component = this;
      Promise.all(promises).then(function () {
        component.$emit("loaded");
      });
    },
    initEventResized: function initEventResized() {
      var normal = this.$refs.normal;
      var previousWidth = normal.offsetWidth;
      var previousHeight = normal.offsetHeight;
      var component = this;
      this.resizeCheckInterval = setInterval(function () {
        if (previousWidth != normal.offsetWidth || previousHeight != normal.offsetHeight) {
          previousWidth = normal.offsetWidth;
          previousHeight = normal.offsetHeight;
          component.$emit("resized", {
            width: normal.width,
            height: normal.height,
            fullWidth: normal.naturalWidth,
            fullHeight: normal.naturalHeight
          });
        }
      }, 1000);
    }
  },
  mounted: function mounted() {
    if (this.$props.scale) {
      this.scaleFactor = parseInt(this.$props.scale);
      this.$refs.zoom.style.transform = "scale(" + this.scaleFactor + ")";
    }

    this.initEventLoaded();
    this.initEventResized();
  },
  updated: function updated() {
    this.initEventLoaded();
  },
  beforeDestroy: function beforeDestroy() {
    this.resizeCheckInterval && clearInterval(this.resizeCheckInterval);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;
/* script */

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "zoom-on-hover",
    "class": {
      zoomed: _vm.zoomed
    },
    on: {
      "pointerover": _vm.touchzoom,
      "pointerout": _vm.touchzoom,
      "pointermove": _vm.move,
      "pointerenter": _vm.zoom,
      "pointerleave": _vm.unzoom
    }
  }, [_c('img', {
    ref: "normal",
    staticClass: "normal",
    attrs: {
      "src": _vm.imgNormal,
      "alt": _vm.altText
    }
  }), _vm._v(" "), _c('img', {
    ref: "zoom",
    staticClass: "zoom",
    attrs: {
      "src": _vm.imgZoom || _vm.imgNormal,
      "alt": _vm.altText
    }
  })]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-0ff054f9_0", {
    source: ".zoom-on-hover[data-v-0ff054f9]{position:relative;overflow:hidden}.zoom-on-hover .normal[data-v-0ff054f9]{width:100%}.zoom-on-hover .zoom[data-v-0ff054f9]{position:absolute;opacity:0;transform-origin:top left}.zoom-on-hover.zoomed .zoom[data-v-0ff054f9]{opacity:1}.zoom-on-hover.zoomed .normal[data-v-0ff054f9]{opacity:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = "data-v-0ff054f9";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, browser, undefined, undefined);

var index = {
  install: function install(Vue, options) {
    Vue.component("zoom-on-hover", __vue_component__);
  }
};
module.exports = index;

/***/ }),

/***/ "./node_modules/vue/dist/vue.js":
/*!**************************************!*\
  !*** ./node_modules/vue/dist/vue.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
(function (global, factory) {
   true ? module.exports = factory() : undefined;
})(this, function () {
  'use strict';
  /*  */

  var emptyObject = Object.freeze({}); // These helpers produce better VM code in JS engines due to their
  // explicitness and function inlining.

  function isUndef(v) {
    return v === undefined || v === null;
  }

  function isDef(v) {
    return v !== undefined && v !== null;
  }

  function isTrue(v) {
    return v === true;
  }

  function isFalse(v) {
    return v === false;
  }
  /**
   * Check if value is primitive.
   */


  function isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || // $flow-disable-line
    typeof value === 'symbol' || typeof value === 'boolean';
  }
  /**
   * Quick object check - this is primarily used to tell
   * Objects from primitive values when we know the value
   * is a JSON-compliant type.
   */


  function isObject(obj) {
    return obj !== null && typeof obj === 'object';
  }
  /**
   * Get the raw type string of a value, e.g., [object Object].
   */


  var _toString = Object.prototype.toString;

  function toRawType(value) {
    return _toString.call(value).slice(8, -1);
  }
  /**
   * Strict object type check. Only returns true
   * for plain JavaScript objects.
   */


  function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
  }

  function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
  }
  /**
   * Check if val is a valid array index.
   */


  function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
  }

  function isPromise(val) {
    return isDef(val) && typeof val.then === 'function' && typeof val.catch === 'function';
  }
  /**
   * Convert a value to a string that is actually rendered.
   */


  function toString(val) {
    return val == null ? '' : Array.isArray(val) || isPlainObject(val) && val.toString === _toString ? JSON.stringify(val, null, 2) : String(val);
  }
  /**
   * Convert an input value to a number for persistence.
   * If the conversion fails, return original string.
   */


  function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
  }
  /**
   * Make a map and return a function for checking if a key
   * is in that map.
   */


  function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');

    for (var i = 0; i < list.length; i++) {
      map[list[i]] = true;
    }

    return expectsLowerCase ? function (val) {
      return map[val.toLowerCase()];
    } : function (val) {
      return map[val];
    };
  }
  /**
   * Check if a tag is a built-in tag.
   */


  var isBuiltInTag = makeMap('slot,component', true);
  /**
   * Check if an attribute is a reserved attribute.
   */

  var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
  /**
   * Remove an item from an array.
   */

  function remove(arr, item) {
    if (arr.length) {
      var index = arr.indexOf(item);

      if (index > -1) {
        return arr.splice(index, 1);
      }
    }
  }
  /**
   * Check whether an object has the property.
   */


  var hasOwnProperty = Object.prototype.hasOwnProperty;

  function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
  }
  /**
   * Create a cached version of a pure function.
   */


  function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
      var hit = cache[str];
      return hit || (cache[str] = fn(str));
    };
  }
  /**
   * Camelize a hyphen-delimited string.
   */


  var camelizeRE = /-(\w)/g;
  var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) {
      return c ? c.toUpperCase() : '';
    });
  });
  /**
   * Capitalize a string.
   */

  var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  });
  /**
   * Hyphenate a camelCase string.
   */

  var hyphenateRE = /\B([A-Z])/g;
  var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
  });
  /**
   * Simple bind polyfill for environments that do not support it,
   * e.g., PhantomJS 1.x. Technically, we don't need this anymore
   * since native bind is now performant enough in most browsers.
   * But removing it would mean breaking code that was able to run in
   * PhantomJS 1.x, so this must be kept for backward compatibility.
   */

  /* istanbul ignore next */

  function polyfillBind(fn, ctx) {
    function boundFn(a) {
      var l = arguments.length;
      return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
    }

    boundFn._length = fn.length;
    return boundFn;
  }

  function nativeBind(fn, ctx) {
    return fn.bind(ctx);
  }

  var bind = Function.prototype.bind ? nativeBind : polyfillBind;
  /**
   * Convert an Array-like object to a real Array.
   */

  function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);

    while (i--) {
      ret[i] = list[i + start];
    }

    return ret;
  }
  /**
   * Mix properties into target object.
   */


  function extend(to, _from) {
    for (var key in _from) {
      to[key] = _from[key];
    }

    return to;
  }
  /**
   * Merge an Array of Objects into a single Object.
   */


  function toObject(arr) {
    var res = {};

    for (var i = 0; i < arr.length; i++) {
      if (arr[i]) {
        extend(res, arr[i]);
      }
    }

    return res;
  }
  /* eslint-disable no-unused-vars */

  /**
   * Perform no operation.
   * Stubbing args to make Flow happy without leaving useless transpiled code
   * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
   */


  function noop(a, b, c) {}
  /**
   * Always return false.
   */


  var no = function (a, b, c) {
    return false;
  };
  /* eslint-enable no-unused-vars */

  /**
   * Return the same value.
   */


  var identity = function (_) {
    return _;
  };
  /**
   * Generate a string containing static keys from compiler modules.
   */


  function genStaticKeys(modules) {
    return modules.reduce(function (keys, m) {
      return keys.concat(m.staticKeys || []);
    }, []).join(',');
  }
  /**
   * Check if two values are loosely equal - that is,
   * if they are plain objects, do they have the same shape?
   */


  function looseEqual(a, b) {
    if (a === b) {
      return true;
    }

    var isObjectA = isObject(a);
    var isObjectB = isObject(b);

    if (isObjectA && isObjectB) {
      try {
        var isArrayA = Array.isArray(a);
        var isArrayB = Array.isArray(b);

        if (isArrayA && isArrayB) {
          return a.length === b.length && a.every(function (e, i) {
            return looseEqual(e, b[i]);
          });
        } else if (a instanceof Date && b instanceof Date) {
          return a.getTime() === b.getTime();
        } else if (!isArrayA && !isArrayB) {
          var keysA = Object.keys(a);
          var keysB = Object.keys(b);
          return keysA.length === keysB.length && keysA.every(function (key) {
            return looseEqual(a[key], b[key]);
          });
        } else {
          /* istanbul ignore next */
          return false;
        }
      } catch (e) {
        /* istanbul ignore next */
        return false;
      }
    } else if (!isObjectA && !isObjectB) {
      return String(a) === String(b);
    } else {
      return false;
    }
  }
  /**
   * Return the first index at which a loosely equal value can be
   * found in the array (if value is a plain object, the array must
   * contain an object of the same shape), or -1 if it is not present.
   */


  function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
      if (looseEqual(arr[i], val)) {
        return i;
      }
    }

    return -1;
  }
  /**
   * Ensure a function is called only once.
   */


  function once(fn) {
    var called = false;
    return function () {
      if (!called) {
        called = true;
        fn.apply(this, arguments);
      }
    };
  }

  var SSR_ATTR = 'data-server-rendered';
  var ASSET_TYPES = ['component', 'directive', 'filter'];
  var LIFECYCLE_HOOKS = ['beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed', 'activated', 'deactivated', 'errorCaptured', 'serverPrefetch'];
  /*  */

  var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),

    /**
     * Whether to suppress warnings.
     */
    silent: false,

    /**
     * Show production mode tip message on boot?
     */
    productionTip: "development" !== 'production',

    /**
     * Whether to enable devtools
     */
    devtools: "development" !== 'production',

    /**
     * Whether to record perf
     */
    performance: false,

    /**
     * Error handler for watcher errors
     */
    errorHandler: null,

    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,

    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],

    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),

    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,

    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,

    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,

    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,

    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,

    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,

    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,

    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
  };
  /*  */

  /**
   * unicode letters used for parsing html tags, component names and property paths.
   * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
   * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
   */

  var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
  /**
   * Check if a string starts with $ or _
   */

  function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5F;
  }
  /**
   * Define a property.
   */


  function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
      value: val,
      enumerable: !!enumerable,
      writable: true,
      configurable: true
    });
  }
  /**
   * Parse simple path.
   */


  var bailRE = new RegExp("[^" + unicodeRegExp.source + ".$_\\d]");

  function parsePath(path) {
    if (bailRE.test(path)) {
      return;
    }

    var segments = path.split('.');
    return function (obj) {
      for (var i = 0; i < segments.length; i++) {
        if (!obj) {
          return;
        }

        obj = obj[segments[i]];
      }

      return obj;
    };
  }
  /*  */
  // can we use __proto__?


  var hasProto = ('__proto__' in {}); // Browser environment sniffing

  var inBrowser = typeof window !== 'undefined';
  var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
  var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
  var UA = inBrowser && window.navigator.userAgent.toLowerCase();
  var isIE = UA && /msie|trident/.test(UA);
  var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
  var isEdge = UA && UA.indexOf('edge/') > 0;
  var isAndroid = UA && UA.indexOf('android') > 0 || weexPlatform === 'android';
  var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA) || weexPlatform === 'ios';
  var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
  var isPhantomJS = UA && /phantomjs/.test(UA);
  var isFF = UA && UA.match(/firefox\/(\d+)/); // Firefox has a "watch" function on Object.prototype...

  var nativeWatch = {}.watch;
  var supportsPassive = false;

  if (inBrowser) {
    try {
      var opts = {};
      Object.defineProperty(opts, 'passive', {
        get: function get() {
          /* istanbul ignore next */
          supportsPassive = true;
        }
      }); // https://github.com/facebook/flow/issues/285

      window.addEventListener('test-passive', null, opts);
    } catch (e) {}
  } // this needs to be lazy-evaled because vue may be required before
  // vue-server-renderer can set VUE_ENV


  var _isServer;

  var isServerRendering = function () {
    if (_isServer === undefined) {
      /* istanbul ignore if */
      if (!inBrowser && !inWeex && typeof global !== 'undefined') {
        // detect presence of vue-server-renderer and avoid
        // Webpack shimming the process
        _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
      } else {
        _isServer = false;
      }
    }

    return _isServer;
  }; // detect devtools


  var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
  /* istanbul ignore next */

  function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
  }

  var hasSymbol = typeof Symbol !== 'undefined' && isNative(Symbol) && typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

  var _Set;
  /* istanbul ignore if */
  // $flow-disable-line


  if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
  } else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /*@__PURE__*/function () {
      function Set() {
        this.set = Object.create(null);
      }

      Set.prototype.has = function has(key) {
        return this.set[key] === true;
      };

      Set.prototype.add = function add(key) {
        this.set[key] = true;
      };

      Set.prototype.clear = function clear() {
        this.set = Object.create(null);
      };

      return Set;
    }();
  }
  /*  */


  var warn = noop;
  var tip = noop;
  var generateComponentTrace = noop; // work around flow check

  var formatComponentName = noop;
  {
    var hasConsole = typeof console !== 'undefined';
    var classifyRE = /(?:^|[-_])(\w)/g;

    var classify = function (str) {
      return str.replace(classifyRE, function (c) {
        return c.toUpperCase();
      }).replace(/[-_]/g, '');
    };

    warn = function (msg, vm) {
      var trace = vm ? generateComponentTrace(vm) : '';

      if (config.warnHandler) {
        config.warnHandler.call(null, msg, vm, trace);
      } else if (hasConsole && !config.silent) {
        console.error("[Vue warn]: " + msg + trace);
      }
    };

    tip = function (msg, vm) {
      if (hasConsole && !config.silent) {
        console.warn("[Vue tip]: " + msg + (vm ? generateComponentTrace(vm) : ''));
      }
    };

    formatComponentName = function (vm, includeFile) {
      if (vm.$root === vm) {
        return '<Root>';
      }

      var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm;
      var name = options.name || options._componentTag;
      var file = options.__file;

      if (!name && file) {
        var match = file.match(/([^/\\]+)\.vue$/);
        name = match && match[1];
      }

      return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : '');
    };

    var repeat = function (str, n) {
      var res = '';

      while (n) {
        if (n % 2 === 1) {
          res += str;
        }

        if (n > 1) {
          str += str;
        }

        n >>= 1;
      }

      return res;
    };

    generateComponentTrace = function (vm) {
      if (vm._isVue && vm.$parent) {
        var tree = [];
        var currentRecursiveSequence = 0;

        while (vm) {
          if (tree.length > 0) {
            var last = tree[tree.length - 1];

            if (last.constructor === vm.constructor) {
              currentRecursiveSequence++;
              vm = vm.$parent;
              continue;
            } else if (currentRecursiveSequence > 0) {
              tree[tree.length - 1] = [last, currentRecursiveSequence];
              currentRecursiveSequence = 0;
            }
          }

          tree.push(vm);
          vm = vm.$parent;
        }

        return '\n\nfound in\n\n' + tree.map(function (vm, i) {
          return "" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm) ? formatComponentName(vm[0]) + "... (" + vm[1] + " recursive calls)" : formatComponentName(vm));
        }).join('\n');
      } else {
        return "\n\n(found in " + formatComponentName(vm) + ")";
      }
    };
  }
  /*  */

  var uid = 0;
  /**
   * A dep is an observable that can have multiple
   * directives subscribing to it.
   */

  var Dep = function Dep() {
    this.id = uid++;
    this.subs = [];
  };

  Dep.prototype.addSub = function addSub(sub) {
    this.subs.push(sub);
  };

  Dep.prototype.removeSub = function removeSub(sub) {
    remove(this.subs, sub);
  };

  Dep.prototype.depend = function depend() {
    if (Dep.target) {
      Dep.target.addDep(this);
    }
  };

  Dep.prototype.notify = function notify() {
    // stabilize the subscriber list first
    var subs = this.subs.slice();

    if (!config.async) {
      // subs aren't sorted in scheduler if not running async
      // we need to sort them now to make sure they fire in correct
      // order
      subs.sort(function (a, b) {
        return a.id - b.id;
      });
    }

    for (var i = 0, l = subs.length; i < l; i++) {
      subs[i].update();
    }
  }; // The current target watcher being evaluated.
  // This is globally unique because only one watcher
  // can be evaluated at a time.


  Dep.target = null;
  var targetStack = [];

  function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
  }

  function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
  }
  /*  */


  var VNode = function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
    this.tag = tag;
    this.data = data;
    this.children = children;
    this.text = text;
    this.elm = elm;
    this.ns = undefined;
    this.context = context;
    this.fnContext = undefined;
    this.fnOptions = undefined;
    this.fnScopeId = undefined;
    this.key = data && data.key;
    this.componentOptions = componentOptions;
    this.componentInstance = undefined;
    this.parent = undefined;
    this.raw = false;
    this.isStatic = false;
    this.isRootInsert = true;
    this.isComment = false;
    this.isCloned = false;
    this.isOnce = false;
    this.asyncFactory = asyncFactory;
    this.asyncMeta = undefined;
    this.isAsyncPlaceholder = false;
  };

  var prototypeAccessors = {
    child: {
      configurable: true
    }
  }; // DEPRECATED: alias for componentInstance for backwards compat.

  /* istanbul ignore next */

  prototypeAccessors.child.get = function () {
    return this.componentInstance;
  };

  Object.defineProperties(VNode.prototype, prototypeAccessors);

  var createEmptyVNode = function (text) {
    if (text === void 0) text = '';
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
  };

  function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
  } // optimized shallow clone
  // used for static nodes and slot nodes because they may be reused across
  // multiple renders, cloning them avoids errors when DOM manipulations rely
  // on their elm reference.


  function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data, // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
  }
  /*
   * not type checking this file because flow doesn't play well with
   * dynamically accessing methods on Array prototype
   */


  var arrayProto = Array.prototype;
  var arrayMethods = Object.create(arrayProto);
  var methodsToPatch = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'];
  /**
   * Intercept mutating methods and emit events
   */

  methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
      var args = [],
          len = arguments.length;

      while (len--) {
        args[len] = arguments[len];
      }

      var result = original.apply(this, args);
      var ob = this.__ob__;
      var inserted;

      switch (method) {
        case 'push':
        case 'unshift':
          inserted = args;
          break;

        case 'splice':
          inserted = args.slice(2);
          break;
      }

      if (inserted) {
        ob.observeArray(inserted);
      } // notify change


      ob.dep.notify();
      return result;
    });
  });
  /*  */

  var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
  /**
   * In some cases we may want to disable observation inside a component's
   * update computation.
   */

  var shouldObserve = true;

  function toggleObserving(value) {
    shouldObserve = value;
  }
  /**
   * Observer class that is attached to each observed
   * object. Once attached, the observer converts the target
   * object's property keys into getter/setters that
   * collect dependencies and dispatch updates.
   */


  var Observer = function Observer(value) {
    this.value = value;
    this.dep = new Dep();
    this.vmCount = 0;
    def(value, '__ob__', this);

    if (Array.isArray(value)) {
      if (hasProto) {
        protoAugment(value, arrayMethods);
      } else {
        copyAugment(value, arrayMethods, arrayKeys);
      }

      this.observeArray(value);
    } else {
      this.walk(value);
    }
  };
  /**
   * Walk through all properties and convert them into
   * getter/setters. This method should only be called when
   * value type is Object.
   */


  Observer.prototype.walk = function walk(obj) {
    var keys = Object.keys(obj);

    for (var i = 0; i < keys.length; i++) {
      defineReactive$$1(obj, keys[i]);
    }
  };
  /**
   * Observe a list of Array items.
   */


  Observer.prototype.observeArray = function observeArray(items) {
    for (var i = 0, l = items.length; i < l; i++) {
      observe(items[i]);
    }
  }; // helpers

  /**
   * Augment a target Object or Array by intercepting
   * the prototype chain using __proto__
   */


  function protoAugment(target, src) {
    /* eslint-disable no-proto */
    target.__proto__ = src;
    /* eslint-enable no-proto */
  }
  /**
   * Augment a target Object or Array by defining
   * hidden properties.
   */

  /* istanbul ignore next */


  function copyAugment(target, src, keys) {
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      def(target, key, src[key]);
    }
  }
  /**
   * Attempt to create an observer instance for a value,
   * returns the new observer if successfully observed,
   * or the existing observer if the value already has one.
   */


  function observe(value, asRootData) {
    if (!isObject(value) || value instanceof VNode) {
      return;
    }

    var ob;

    if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
      ob = value.__ob__;
    } else if (shouldObserve && !isServerRendering() && (Array.isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
      ob = new Observer(value);
    }

    if (asRootData && ob) {
      ob.vmCount++;
    }

    return ob;
  }
  /**
   * Define a reactive property on an Object.
   */


  function defineReactive$$1(obj, key, val, customSetter, shallow) {
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);

    if (property && property.configurable === false) {
      return;
    } // cater for pre-defined getter/setters


    var getter = property && property.get;
    var setter = property && property.set;

    if ((!getter || setter) && arguments.length === 2) {
      val = obj[key];
    }

    var childOb = !shallow && observe(val);
    Object.defineProperty(obj, key, {
      enumerable: true,
      configurable: true,
      get: function reactiveGetter() {
        var value = getter ? getter.call(obj) : val;

        if (Dep.target) {
          dep.depend();

          if (childOb) {
            childOb.dep.depend();

            if (Array.isArray(value)) {
              dependArray(value);
            }
          }
        }

        return value;
      },
      set: function reactiveSetter(newVal) {
        var value = getter ? getter.call(obj) : val;
        /* eslint-disable no-self-compare */

        if (newVal === value || newVal !== newVal && value !== value) {
          return;
        }
        /* eslint-enable no-self-compare */


        if (customSetter) {
          customSetter();
        } // #7981: for accessor properties without setter


        if (getter && !setter) {
          return;
        }

        if (setter) {
          setter.call(obj, newVal);
        } else {
          val = newVal;
        }

        childOb = !shallow && observe(newVal);
        dep.notify();
      }
    });
  }
  /**
   * Set a property on an object. Adds the new property and
   * triggers change notification if the property doesn't
   * already exist.
   */


  function set(target, key, val) {
    if (isUndef(target) || isPrimitive(target)) {
      warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
    }

    if (Array.isArray(target) && isValidArrayIndex(key)) {
      target.length = Math.max(target.length, key);
      target.splice(key, 1, val);
      return val;
    }

    if (key in target && !(key in Object.prototype)) {
      target[key] = val;
      return val;
    }

    var ob = target.__ob__;

    if (target._isVue || ob && ob.vmCount) {
      warn('Avoid adding reactive properties to a Vue instance or its root $data ' + 'at runtime - declare it upfront in the data option.');
      return val;
    }

    if (!ob) {
      target[key] = val;
      return val;
    }

    defineReactive$$1(ob.value, key, val);
    ob.dep.notify();
    return val;
  }
  /**
   * Delete a property and trigger change if necessary.
   */


  function del(target, key) {
    if (isUndef(target) || isPrimitive(target)) {
      warn("Cannot delete reactive property on undefined, null, or primitive value: " + target);
    }

    if (Array.isArray(target) && isValidArrayIndex(key)) {
      target.splice(key, 1);
      return;
    }

    var ob = target.__ob__;

    if (target._isVue || ob && ob.vmCount) {
      warn('Avoid deleting properties on a Vue instance or its root $data ' + '- just set it to null.');
      return;
    }

    if (!hasOwn(target, key)) {
      return;
    }

    delete target[key];

    if (!ob) {
      return;
    }

    ob.dep.notify();
  }
  /**
   * Collect dependencies on array elements when the array is touched, since
   * we cannot intercept array element access like property getters.
   */


  function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
      e = value[i];
      e && e.__ob__ && e.__ob__.dep.depend();

      if (Array.isArray(e)) {
        dependArray(e);
      }
    }
  }
  /*  */

  /**
   * Option overwriting strategies are functions that handle
   * how to merge a parent option value and a child option
   * value into the final value.
   */


  var strats = config.optionMergeStrategies;
  /**
   * Options with restrictions
   */

  {
    strats.el = strats.propsData = function (parent, child, vm, key) {
      if (!vm) {
        warn("option \"" + key + "\" can only be used during instance " + 'creation with the `new` keyword.');
      }

      return defaultStrat(parent, child);
    };
  }
  /**
   * Helper that recursively merges two data objects together.
   */

  function mergeData(to, from) {
    if (!from) {
      return to;
    }

    var key, toVal, fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);

    for (var i = 0; i < keys.length; i++) {
      key = keys[i]; // in case the object is already observed...

      if (key === '__ob__') {
        continue;
      }

      toVal = to[key];
      fromVal = from[key];

      if (!hasOwn(to, key)) {
        set(to, key, fromVal);
      } else if (toVal !== fromVal && isPlainObject(toVal) && isPlainObject(fromVal)) {
        mergeData(toVal, fromVal);
      }
    }

    return to;
  }
  /**
   * Data
   */


  function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
      // in a Vue.extend merge, both should be functions
      if (!childVal) {
        return parentVal;
      }

      if (!parentVal) {
        return childVal;
      } // when parentVal & childVal are both present,
      // we need to return a function that returns the
      // merged result of both functions... no need to
      // check if parentVal is a function here because
      // it has to be a function to pass previous merges.


      return function mergedDataFn() {
        return mergeData(typeof childVal === 'function' ? childVal.call(this, this) : childVal, typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal);
      };
    } else {
      return function mergedInstanceDataFn() {
        // instance merge
        var instanceData = typeof childVal === 'function' ? childVal.call(vm, vm) : childVal;
        var defaultData = typeof parentVal === 'function' ? parentVal.call(vm, vm) : parentVal;

        if (instanceData) {
          return mergeData(instanceData, defaultData);
        } else {
          return defaultData;
        }
      };
    }
  }

  strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
      if (childVal && typeof childVal !== 'function') {
        warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
        return parentVal;
      }

      return mergeDataOrFn(parentVal, childVal);
    }

    return mergeDataOrFn(parentVal, childVal, vm);
  };
  /**
   * Hooks and props are merged as arrays.
   */


  function mergeHook(parentVal, childVal) {
    var res = childVal ? parentVal ? parentVal.concat(childVal) : Array.isArray(childVal) ? childVal : [childVal] : parentVal;
    return res ? dedupeHooks(res) : res;
  }

  function dedupeHooks(hooks) {
    var res = [];

    for (var i = 0; i < hooks.length; i++) {
      if (res.indexOf(hooks[i]) === -1) {
        res.push(hooks[i]);
      }
    }

    return res;
  }

  LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeHook;
  });
  /**
   * Assets
   *
   * When a vm is present (instance creation), we need to do
   * a three-way merge between constructor options, instance
   * options and parent options.
   */

  function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);

    if (childVal) {
      assertObjectType(key, childVal, vm);
      return extend(res, childVal);
    } else {
      return res;
    }
  }

  ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
  });
  /**
   * Watchers.
   *
   * Watchers hashes should not overwrite one
   * another, so we merge them as arrays.
   */

  strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    if (parentVal === nativeWatch) {
      parentVal = undefined;
    }

    if (childVal === nativeWatch) {
      childVal = undefined;
    }
    /* istanbul ignore if */


    if (!childVal) {
      return Object.create(parentVal || null);
    }

    {
      assertObjectType(key, childVal, vm);
    }

    if (!parentVal) {
      return childVal;
    }

    var ret = {};
    extend(ret, parentVal);

    for (var key$1 in childVal) {
      var parent = ret[key$1];
      var child = childVal[key$1];

      if (parent && !Array.isArray(parent)) {
        parent = [parent];
      }

      ret[key$1] = parent ? parent.concat(child) : Array.isArray(child) ? child : [child];
    }

    return ret;
  };
  /**
   * Other object hashes.
   */


  strats.props = strats.methods = strats.inject = strats.computed = function (parentVal, childVal, vm, key) {
    if (childVal && "development" !== 'production') {
      assertObjectType(key, childVal, vm);
    }

    if (!parentVal) {
      return childVal;
    }

    var ret = Object.create(null);
    extend(ret, parentVal);

    if (childVal) {
      extend(ret, childVal);
    }

    return ret;
  };

  strats.provide = mergeDataOrFn;
  /**
   * Default strategy.
   */

  var defaultStrat = function (parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
  };
  /**
   * Validate component names
   */


  function checkComponents(options) {
    for (var key in options.components) {
      validateComponentName(key);
    }
  }

  function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_" + unicodeRegExp.source + "]*$").test(name)) {
      warn('Invalid component name: "' + name + '". Component names ' + 'should conform to valid custom element name in html5 specification.');
    }

    if (isBuiltInTag(name) || config.isReservedTag(name)) {
      warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + name);
    }
  }
  /**
   * Ensure all props option syntax are normalized into the
   * Object-based format.
   */


  function normalizeProps(options, vm) {
    var props = options.props;

    if (!props) {
      return;
    }

    var res = {};
    var i, val, name;

    if (Array.isArray(props)) {
      i = props.length;

      while (i--) {
        val = props[i];

        if (typeof val === 'string') {
          name = camelize(val);
          res[name] = {
            type: null
          };
        } else {
          warn('props must be strings when using array syntax.');
        }
      }
    } else if (isPlainObject(props)) {
      for (var key in props) {
        val = props[key];
        name = camelize(key);
        res[name] = isPlainObject(val) ? val : {
          type: val
        };
      }
    } else {
      warn("Invalid value for option \"props\": expected an Array or an Object, " + "but got " + toRawType(props) + ".", vm);
    }

    options.props = res;
  }
  /**
   * Normalize all injections into Object-based format
   */


  function normalizeInject(options, vm) {
    var inject = options.inject;

    if (!inject) {
      return;
    }

    var normalized = options.inject = {};

    if (Array.isArray(inject)) {
      for (var i = 0; i < inject.length; i++) {
        normalized[inject[i]] = {
          from: inject[i]
        };
      }
    } else if (isPlainObject(inject)) {
      for (var key in inject) {
        var val = inject[key];
        normalized[key] = isPlainObject(val) ? extend({
          from: key
        }, val) : {
          from: val
        };
      }
    } else {
      warn("Invalid value for option \"inject\": expected an Array or an Object, " + "but got " + toRawType(inject) + ".", vm);
    }
  }
  /**
   * Normalize raw function directives into object format.
   */


  function normalizeDirectives(options) {
    var dirs = options.directives;

    if (dirs) {
      for (var key in dirs) {
        var def$$1 = dirs[key];

        if (typeof def$$1 === 'function') {
          dirs[key] = {
            bind: def$$1,
            update: def$$1
          };
        }
      }
    }
  }

  function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
      warn("Invalid value for option \"" + name + "\": expected an Object, " + "but got " + toRawType(value) + ".", vm);
    }
  }
  /**
   * Merge two option objects into a new one.
   * Core utility used in both instantiation and inheritance.
   */


  function mergeOptions(parent, child, vm) {
    {
      checkComponents(child);
    }

    if (typeof child === 'function') {
      child = child.options;
    }

    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives(child); // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.

    if (!child._base) {
      if (child.extends) {
        parent = mergeOptions(parent, child.extends, vm);
      }

      if (child.mixins) {
        for (var i = 0, l = child.mixins.length; i < l; i++) {
          parent = mergeOptions(parent, child.mixins[i], vm);
        }
      }
    }

    var options = {};
    var key;

    for (key in parent) {
      mergeField(key);
    }

    for (key in child) {
      if (!hasOwn(parent, key)) {
        mergeField(key);
      }
    }

    function mergeField(key) {
      var strat = strats[key] || defaultStrat;
      options[key] = strat(parent[key], child[key], vm, key);
    }

    return options;
  }
  /**
   * Resolve an asset.
   * This function is used because child instances need access
   * to assets defined in its ancestor chain.
   */


  function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
      return;
    }

    var assets = options[type]; // check local registration variations first

    if (hasOwn(assets, id)) {
      return assets[id];
    }

    var camelizedId = camelize(id);

    if (hasOwn(assets, camelizedId)) {
      return assets[camelizedId];
    }

    var PascalCaseId = capitalize(camelizedId);

    if (hasOwn(assets, PascalCaseId)) {
      return assets[PascalCaseId];
    } // fallback to prototype chain


    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];

    if (warnMissing && !res) {
      warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
    }

    return res;
  }
  /*  */


  function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key]; // boolean casting

    var booleanIndex = getTypeIndex(Boolean, prop.type);

    if (booleanIndex > -1) {
      if (absent && !hasOwn(prop, 'default')) {
        value = false;
      } else if (value === '' || value === hyphenate(key)) {
        // only cast empty string / same name to boolean if
        // boolean has higher priority
        var stringIndex = getTypeIndex(String, prop.type);

        if (stringIndex < 0 || booleanIndex < stringIndex) {
          value = true;
        }
      }
    } // check default value


    if (value === undefined) {
      value = getPropDefaultValue(vm, prop, key); // since the default value is a fresh copy,
      // make sure to observe it.

      var prevShouldObserve = shouldObserve;
      toggleObserving(true);
      observe(value);
      toggleObserving(prevShouldObserve);
    }

    {
      assertProp(prop, key, value, vm, absent);
    }
    return value;
  }
  /**
   * Get the default value of a prop.
   */


  function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
      return undefined;
    }

    var def = prop.default; // warn against non-factory defaults for Object & Array

    if (isObject(def)) {
      warn('Invalid default value for prop "' + key + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
    } // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger


    if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) {
      return vm._props[key];
    } // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context


    return typeof def === 'function' && getType(prop.type) !== 'Function' ? def.call(vm) : def;
  }
  /**
   * Assert whether a prop is valid.
   */


  function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
      warn('Missing required prop: "' + name + '"', vm);
      return;
    }

    if (value == null && !prop.required) {
      return;
    }

    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];

    if (type) {
      if (!Array.isArray(type)) {
        type = [type];
      }

      for (var i = 0; i < type.length && !valid; i++) {
        var assertedType = assertType(value, type[i], vm);
        expectedTypes.push(assertedType.expectedType || '');
        valid = assertedType.valid;
      }
    }

    var haveExpectedTypes = expectedTypes.some(function (t) {
      return t;
    });

    if (!valid && haveExpectedTypes) {
      warn(getInvalidTypeMessage(name, value, expectedTypes), vm);
      return;
    }

    var validator = prop.validator;

    if (validator) {
      if (!validator(value)) {
        warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
      }
    }
  }

  var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

  function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);

    if (simpleCheckRE.test(expectedType)) {
      var t = typeof value;
      valid = t === expectedType.toLowerCase(); // for primitive wrapper objects

      if (!valid && t === 'object') {
        valid = value instanceof type;
      }
    } else if (expectedType === 'Object') {
      valid = isPlainObject(value);
    } else if (expectedType === 'Array') {
      valid = Array.isArray(value);
    } else {
      try {
        valid = value instanceof type;
      } catch (e) {
        warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
        valid = false;
      }
    }

    return {
      valid: valid,
      expectedType: expectedType
    };
  }

  var functionTypeCheckRE = /^\s*function (\w+)/;
  /**
   * Use function string name to check built-in types,
   * because a simple equality check will fail when running
   * across different vms / iframes.
   */

  function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
  }

  function isSameType(a, b) {
    return getType(a) === getType(b);
  }

  function getTypeIndex(type, expectedTypes) {
    if (!Array.isArray(expectedTypes)) {
      return isSameType(expectedTypes, type) ? 0 : -1;
    }

    for (var i = 0, len = expectedTypes.length; i < len; i++) {
      if (isSameType(expectedTypes[i], type)) {
        return i;
      }
    }

    return -1;
  }

  function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"" + name + "\"." + " Expected " + expectedTypes.map(capitalize).join(', ');
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value); // check if we need to specify expected value

    if (expectedTypes.length === 1 && isExplicable(expectedType) && isExplicable(typeof value) && !isBoolean(expectedType, receivedType)) {
      message += " with value " + styleValue(value, expectedType);
    }

    message += ", got " + receivedType + " "; // check if we need to specify received value

    if (isExplicable(receivedType)) {
      message += "with value " + styleValue(value, receivedType) + ".";
    }

    return message;
  }

  function styleValue(value, type) {
    if (type === 'String') {
      return "\"" + value + "\"";
    } else if (type === 'Number') {
      return "" + Number(value);
    } else {
      return "" + value;
    }
  }

  var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];

  function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) {
      return value.toLowerCase() === elem;
    });
  }

  function isBoolean() {
    var args = [],
        len = arguments.length;

    while (len--) {
      args[len] = arguments[len];
    }

    return args.some(function (elem) {
      return elem.toLowerCase() === 'boolean';
    });
  }
  /*  */


  function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();

    try {
      if (vm) {
        var cur = vm;

        while (cur = cur.$parent) {
          var hooks = cur.$options.errorCaptured;

          if (hooks) {
            for (var i = 0; i < hooks.length; i++) {
              try {
                var capture = hooks[i].call(cur, err, vm, info) === false;

                if (capture) {
                  return;
                }
              } catch (e) {
                globalHandleError(e, cur, 'errorCaptured hook');
              }
            }
          }
        }
      }

      globalHandleError(err, vm, info);
    } finally {
      popTarget();
    }
  }

  function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;

    try {
      res = args ? handler.apply(context, args) : handler.call(context);

      if (res && !res._isVue && isPromise(res) && !res._handled) {
        res.catch(function (e) {
          return handleError(e, vm, info + " (Promise/async)");
        }); // issue #9511
        // avoid catch triggering multiple times when nested calls

        res._handled = true;
      }
    } catch (e) {
      handleError(e, vm, info);
    }

    return res;
  }

  function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
      try {
        return config.errorHandler.call(null, err, vm, info);
      } catch (e) {
        // if the user intentionally throws the original error in the handler,
        // do not log it twice
        if (e !== err) {
          logError(e, null, 'config.errorHandler');
        }
      }
    }

    logError(err, vm, info);
  }

  function logError(err, vm, info) {
    {
      warn("Error in " + info + ": \"" + err.toString() + "\"", vm);
    }
    /* istanbul ignore else */

    if ((inBrowser || inWeex) && typeof console !== 'undefined') {
      console.error(err);
    } else {
      throw err;
    }
  }
  /*  */


  var isUsingMicroTask = false;
  var callbacks = [];
  var pending = false;

  function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;

    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  } // Here we have async deferring wrappers using microtasks.
  // In 2.5 we used (macro) tasks (in combination with microtasks).
  // However, it has subtle problems when state is changed right before repaint
  // (e.g. #6813, out-in transitions).
  // Also, using (macro) tasks in event handler would cause some weird behaviors
  // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
  // So we now use microtasks everywhere, again.
  // A major drawback of this tradeoff is that there are some scenarios
  // where microtasks have too high a priority and fire in between supposedly
  // sequential events (e.g. #4521, #6690, which have workarounds)
  // or even between bubbling of the same event (#6566).


  var timerFunc; // The nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:

  /* istanbul ignore next, $flow-disable-line */

  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();

    timerFunc = function () {
      p.then(flushCallbacks); // In problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.

      if (isIOS) {
        setTimeout(noop);
      }
    };

    isUsingMicroTask = true;
  } else if (!isIE && typeof MutationObserver !== 'undefined' && (isNative(MutationObserver) || // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });

    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };

    isUsingMicroTask = true;
  } else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function () {
      setImmediate(flushCallbacks);
    };
  } else {
    // Fallback to setTimeout.
    timerFunc = function () {
      setTimeout(flushCallbacks, 0);
    };
  }

  function nextTick(cb, ctx) {
    var _resolve;

    callbacks.push(function () {
      if (cb) {
        try {
          cb.call(ctx);
        } catch (e) {
          handleError(e, ctx, 'nextTick');
        }
      } else if (_resolve) {
        _resolve(ctx);
      }
    });

    if (!pending) {
      pending = true;
      timerFunc();
    } // $flow-disable-line


    if (!cb && typeof Promise !== 'undefined') {
      return new Promise(function (resolve) {
        _resolve = resolve;
      });
    }
  }
  /*  */


  var mark;
  var measure;
  {
    var perf = inBrowser && window.performance;
    /* istanbul ignore if */

    if (perf && perf.mark && perf.measure && perf.clearMarks && perf.clearMeasures) {
      mark = function (tag) {
        return perf.mark(tag);
      };

      measure = function (name, startTag, endTag) {
        perf.measure(name, startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag); // perf.clearMeasures(name)
      };
    }
  }
  /* not type checking this file because flow doesn't play well with Proxy */

  var initProxy;
  {
    var allowedGlobals = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' + 'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' + 'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' + 'require' // for Webpack/Browserify
    );

    var warnNonPresent = function (target, key) {
      warn("Property or method \"" + key + "\" is not defined on the instance but " + 'referenced during render. Make sure that this property is reactive, ' + 'either in the data option, or for class-based components, by ' + 'initializing the property. ' + 'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };

    var warnReservedPrefix = function (target, key) {
      warn("Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " + 'properties starting with "$" or "_" are not proxied in the Vue instance to ' + 'prevent conflicts with Vue internals. ' + 'See: https://vuejs.org/v2/api/#data', target);
    };

    var hasProxy = typeof Proxy !== 'undefined' && isNative(Proxy);

    if (hasProxy) {
      var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
      config.keyCodes = new Proxy(config.keyCodes, {
        set: function set(target, key, value) {
          if (isBuiltInModifier(key)) {
            warn("Avoid overwriting built-in modifier in config.keyCodes: ." + key);
            return false;
          } else {
            target[key] = value;
            return true;
          }
        }
      });
    }

    var hasHandler = {
      has: function has(target, key) {
        var has = (key in target);
        var isAllowed = allowedGlobals(key) || typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data);

        if (!has && !isAllowed) {
          if (key in target.$data) {
            warnReservedPrefix(target, key);
          } else {
            warnNonPresent(target, key);
          }
        }

        return has || !isAllowed;
      }
    };
    var getHandler = {
      get: function get(target, key) {
        if (typeof key === 'string' && !(key in target)) {
          if (key in target.$data) {
            warnReservedPrefix(target, key);
          } else {
            warnNonPresent(target, key);
          }
        }

        return target[key];
      }
    };

    initProxy = function initProxy(vm) {
      if (hasProxy) {
        // determine which proxy handler to use
        var options = vm.$options;
        var handlers = options.render && options.render._withStripped ? getHandler : hasHandler;
        vm._renderProxy = new Proxy(vm, handlers);
      } else {
        vm._renderProxy = vm;
      }
    };
  }
  /*  */

  var seenObjects = new _Set();
  /**
   * Recursively traverse an object to evoke all converted
   * getters, so that every nested property inside the object
   * is collected as a "deep" dependency.
   */

  function traverse(val) {
    _traverse(val, seenObjects);

    seenObjects.clear();
  }

  function _traverse(val, seen) {
    var i, keys;
    var isA = Array.isArray(val);

    if (!isA && !isObject(val) || Object.isFrozen(val) || val instanceof VNode) {
      return;
    }

    if (val.__ob__) {
      var depId = val.__ob__.dep.id;

      if (seen.has(depId)) {
        return;
      }

      seen.add(depId);
    }

    if (isA) {
      i = val.length;

      while (i--) {
        _traverse(val[i], seen);
      }
    } else {
      keys = Object.keys(val);
      i = keys.length;

      while (i--) {
        _traverse(val[keys[i]], seen);
      }
    }
  }
  /*  */


  var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first

    name = once$$1 ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
      name: name,
      once: once$$1,
      capture: capture,
      passive: passive
    };
  });

  function createFnInvoker(fns, vm) {
    function invoker() {
      var arguments$1 = arguments;
      var fns = invoker.fns;

      if (Array.isArray(fns)) {
        var cloned = fns.slice();

        for (var i = 0; i < cloned.length; i++) {
          invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
        }
      } else {
        // return handler return value for single handlers
        return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
      }
    }

    invoker.fns = fns;
    return invoker;
  }

  function updateListeners(on, oldOn, add, remove$$1, createOnceHandler, vm) {
    var name, def$$1, cur, old, event;

    for (name in on) {
      def$$1 = cur = on[name];
      old = oldOn[name];
      event = normalizeEvent(name);

      if (isUndef(cur)) {
        warn("Invalid handler for event \"" + event.name + "\": got " + String(cur), vm);
      } else if (isUndef(old)) {
        if (isUndef(cur.fns)) {
          cur = on[name] = createFnInvoker(cur, vm);
        }

        if (isTrue(event.once)) {
          cur = on[name] = createOnceHandler(event.name, cur, event.capture);
        }

        add(event.name, cur, event.capture, event.passive, event.params);
      } else if (cur !== old) {
        old.fns = cur;
        on[name] = old;
      }
    }

    for (name in oldOn) {
      if (isUndef(on[name])) {
        event = normalizeEvent(name);
        remove$$1(event.name, oldOn[name], event.capture);
      }
    }
  }
  /*  */


  function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
      def = def.data.hook || (def.data.hook = {});
    }

    var invoker;
    var oldHook = def[hookKey];

    function wrappedHook() {
      hook.apply(this, arguments); // important: remove merged hook to ensure it's called only once
      // and prevent memory leak

      remove(invoker.fns, wrappedHook);
    }

    if (isUndef(oldHook)) {
      // no existing hook
      invoker = createFnInvoker([wrappedHook]);
    } else {
      /* istanbul ignore if */
      if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
        // already a merged invoker
        invoker = oldHook;
        invoker.fns.push(wrappedHook);
      } else {
        // existing plain hook
        invoker = createFnInvoker([oldHook, wrappedHook]);
      }
    }

    invoker.merged = true;
    def[hookKey] = invoker;
  }
  /*  */


  function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;

    if (isUndef(propOptions)) {
      return;
    }

    var res = {};
    var attrs = data.attrs;
    var props = data.props;

    if (isDef(attrs) || isDef(props)) {
      for (var key in propOptions) {
        var altKey = hyphenate(key);
        {
          var keyInLowerCase = key.toLowerCase();

          if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
            tip("Prop \"" + keyInLowerCase + "\" is passed to component " + formatComponentName(tag || Ctor) + ", but the declared prop name is" + " \"" + key + "\". " + "Note that HTML attributes are case-insensitive and camelCased " + "props need to use their kebab-case equivalents when using in-DOM " + "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\".");
          }
        }
        checkProp(res, props, key, altKey, true) || checkProp(res, attrs, key, altKey, false);
      }
    }

    return res;
  }

  function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
      if (hasOwn(hash, key)) {
        res[key] = hash[key];

        if (!preserve) {
          delete hash[key];
        }

        return true;
      } else if (hasOwn(hash, altKey)) {
        res[key] = hash[altKey];

        if (!preserve) {
          delete hash[altKey];
        }

        return true;
      }
    }

    return false;
  }
  /*  */
  // The template compiler attempts to minimize the need for normalization by
  // statically analyzing the template at compile time.
  //
  // For plain HTML markup, normalization can be completely skipped because the
  // generated render function is guaranteed to return Array<VNode>. There are
  // two cases where extra normalization is needed:
  // 1. When the children contains components - because a functional component
  // may return an Array instead of a single root. In this case, just a simple
  // normalization is needed - if any child is an Array, we flatten the whole
  // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
  // because functional components already normalize their own children.


  function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
      if (Array.isArray(children[i])) {
        return Array.prototype.concat.apply([], children);
      }
    }

    return children;
  } // 2. When the children contains constructs that always generated nested Arrays,
  // e.g. <template>, <slot>, v-for, or when the children is provided by user
  // with hand-written render functions / JSX. In such cases a full normalization
  // is needed to cater to all possible types of children values.


  function normalizeChildren(children) {
    return isPrimitive(children) ? [createTextVNode(children)] : Array.isArray(children) ? normalizeArrayChildren(children) : undefined;
  }

  function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
  }

  function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;

    for (i = 0; i < children.length; i++) {
      c = children[i];

      if (isUndef(c) || typeof c === 'boolean') {
        continue;
      }

      lastIndex = res.length - 1;
      last = res[lastIndex]; //  nested

      if (Array.isArray(c)) {
        if (c.length > 0) {
          c = normalizeArrayChildren(c, (nestedIndex || '') + "_" + i); // merge adjacent text nodes

          if (isTextNode(c[0]) && isTextNode(last)) {
            res[lastIndex] = createTextVNode(last.text + c[0].text);
            c.shift();
          }

          res.push.apply(res, c);
        }
      } else if (isPrimitive(c)) {
        if (isTextNode(last)) {
          // merge adjacent text nodes
          // this is necessary for SSR hydration because text nodes are
          // essentially merged when rendered to HTML strings
          res[lastIndex] = createTextVNode(last.text + c);
        } else if (c !== '') {
          // convert primitive to vnode
          res.push(createTextVNode(c));
        }
      } else {
        if (isTextNode(c) && isTextNode(last)) {
          // merge adjacent text nodes
          res[lastIndex] = createTextVNode(last.text + c.text);
        } else {
          // default key for nested array children (likely generated by v-for)
          if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
            c.key = "__vlist" + nestedIndex + "_" + i + "__";
          }

          res.push(c);
        }
      }
    }

    return res;
  }
  /*  */


  function initProvide(vm) {
    var provide = vm.$options.provide;

    if (provide) {
      vm._provided = typeof provide === 'function' ? provide.call(vm) : provide;
    }
  }

  function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);

    if (result) {
      toggleObserving(false);
      Object.keys(result).forEach(function (key) {
        /* istanbul ignore else */
        {
          defineReactive$$1(vm, key, result[key], function () {
            warn("Avoid mutating an injected value directly since the changes will be " + "overwritten whenever the provided component re-renders. " + "injection being mutated: \"" + key + "\"", vm);
          });
        }
      });
      toggleObserving(true);
    }
  }

  function resolveInject(inject, vm) {
    if (inject) {
      // inject is :any because flow is not smart enough to figure out cached
      var result = Object.create(null);
      var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i]; // #6574 in case the inject object is observed...

        if (key === '__ob__') {
          continue;
        }

        var provideKey = inject[key].from;
        var source = vm;

        while (source) {
          if (source._provided && hasOwn(source._provided, provideKey)) {
            result[key] = source._provided[provideKey];
            break;
          }

          source = source.$parent;
        }

        if (!source) {
          if ('default' in inject[key]) {
            var provideDefault = inject[key].default;
            result[key] = typeof provideDefault === 'function' ? provideDefault.call(vm) : provideDefault;
          } else {
            warn("Injection \"" + key + "\" not found", vm);
          }
        }
      }

      return result;
    }
  }
  /*  */

  /**
   * Runtime helper for resolving raw children VNodes into a slot object.
   */


  function resolveSlots(children, context) {
    if (!children || !children.length) {
      return {};
    }

    var slots = {};

    for (var i = 0, l = children.length; i < l; i++) {
      var child = children[i];
      var data = child.data; // remove slot attribute if the node is resolved as a Vue slot node

      if (data && data.attrs && data.attrs.slot) {
        delete data.attrs.slot;
      } // named slots should only be respected if the vnode was rendered in the
      // same context.


      if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
        var name = data.slot;
        var slot = slots[name] || (slots[name] = []);

        if (child.tag === 'template') {
          slot.push.apply(slot, child.children || []);
        } else {
          slot.push(child);
        }
      } else {
        (slots.default || (slots.default = [])).push(child);
      }
    } // ignore slots that contains only whitespace


    for (var name$1 in slots) {
      if (slots[name$1].every(isWhitespace)) {
        delete slots[name$1];
      }
    }

    return slots;
  }

  function isWhitespace(node) {
    return node.isComment && !node.asyncFactory || node.text === ' ';
  }
  /*  */


  function isAsyncPlaceholder(node) {
    return node.isComment && node.asyncFactory;
  }
  /*  */


  function normalizeScopedSlots(slots, normalSlots, prevSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = slots ? !!slots.$stable : !hasNormalSlots;
    var key = slots && slots.$key;

    if (!slots) {
      res = {};
    } else if (slots._normalized) {
      // fast path 1: child component re-render only, parent did not change
      return slots._normalized;
    } else if (isStable && prevSlots && prevSlots !== emptyObject && key === prevSlots.$key && !hasNormalSlots && !prevSlots.$hasNormal) {
      // fast path 2: stable scoped slots w/ no normal slots to proxy,
      // only need to normalize once
      return prevSlots;
    } else {
      res = {};

      for (var key$1 in slots) {
        if (slots[key$1] && key$1[0] !== '$') {
          res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
        }
      }
    } // expose normal slots on scopedSlots


    for (var key$2 in normalSlots) {
      if (!(key$2 in res)) {
        res[key$2] = proxyNormalSlot(normalSlots, key$2);
      }
    } // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error


    if (slots && Object.isExtensible(slots)) {
      slots._normalized = res;
    }

    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
  }

  function normalizeScopedSlot(normalSlots, key, fn) {
    var normalized = function () {
      var res = arguments.length ? fn.apply(null, arguments) : fn({});
      res = res && typeof res === 'object' && !Array.isArray(res) ? [res] // single vnode
      : normalizeChildren(res);
      var vnode = res && res[0];
      return res && (!vnode || res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode) // #9658, #10391
      ) ? undefined : res;
    }; // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.


    if (fn.proxy) {
      Object.defineProperty(normalSlots, key, {
        get: normalized,
        enumerable: true,
        configurable: true
      });
    }

    return normalized;
  }

  function proxyNormalSlot(slots, key) {
    return function () {
      return slots[key];
    };
  }
  /*  */

  /**
   * Runtime helper for rendering v-for lists.
   */


  function renderList(val, render) {
    var ret, i, l, keys, key;

    if (Array.isArray(val) || typeof val === 'string') {
      ret = new Array(val.length);

      for (i = 0, l = val.length; i < l; i++) {
        ret[i] = render(val[i], i);
      }
    } else if (typeof val === 'number') {
      ret = new Array(val);

      for (i = 0; i < val; i++) {
        ret[i] = render(i + 1, i);
      }
    } else if (isObject(val)) {
      if (hasSymbol && val[Symbol.iterator]) {
        ret = [];
        var iterator = val[Symbol.iterator]();
        var result = iterator.next();

        while (!result.done) {
          ret.push(render(result.value, ret.length));
          result = iterator.next();
        }
      } else {
        keys = Object.keys(val);
        ret = new Array(keys.length);

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          ret[i] = render(val[key], key, i);
        }
      }
    }

    if (!isDef(ret)) {
      ret = [];
    }

    ret._isVList = true;
    return ret;
  }
  /*  */

  /**
   * Runtime helper for rendering <slot>
   */


  function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;

    if (scopedSlotFn) {
      // scoped slot
      props = props || {};

      if (bindObject) {
        if (!isObject(bindObject)) {
          warn('slot v-bind without argument expects an Object', this);
        }

        props = extend(extend({}, bindObject), props);
      }

      nodes = scopedSlotFn(props) || (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
    } else {
      nodes = this.$slots[name] || (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
    }

    var target = props && props.slot;

    if (target) {
      return this.$createElement('template', {
        slot: target
      }, nodes);
    } else {
      return nodes;
    }
  }
  /*  */

  /**
   * Runtime helper for resolving filters
   */


  function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
  }
  /*  */


  function isKeyNotMatch(expect, actual) {
    if (Array.isArray(expect)) {
      return expect.indexOf(actual) === -1;
    } else {
      return expect !== actual;
    }
  }
  /**
   * Runtime helper for checking keyCodes from config.
   * exposed as Vue.prototype._k
   * passing in eventKeyName as last argument separately for backwards compat
   */


  function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;

    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
      return isKeyNotMatch(builtInKeyName, eventKeyName);
    } else if (mappedKeyCode) {
      return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    } else if (eventKeyName) {
      return hyphenate(eventKeyName) !== key;
    }

    return eventKeyCode === undefined;
  }
  /*  */

  /**
   * Runtime helper for merging v-bind="object" into a VNode's data.
   */


  function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
      if (!isObject(value)) {
        warn('v-bind without argument expects an Object or Array value', this);
      } else {
        if (Array.isArray(value)) {
          value = toObject(value);
        }

        var hash;

        var loop = function (key) {
          if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
            hash = data;
          } else {
            var type = data.attrs && data.attrs.type;
            hash = asProp || config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
          }

          var camelizedKey = camelize(key);
          var hyphenatedKey = hyphenate(key);

          if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
            hash[key] = value[key];

            if (isSync) {
              var on = data.on || (data.on = {});

              on["update:" + key] = function ($event) {
                value[key] = $event;
              };
            }
          }
        };

        for (var key in value) {
          loop(key);
        }
      }
    }

    return data;
  }
  /*  */

  /**
   * Runtime helper for rendering static trees.
   */


  function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index]; // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.

    if (tree && !isInFor) {
      return tree;
    } // otherwise, render a fresh tree.


    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, null, this // for render fns generated for functional component templates
    );
    markStatic(tree, "__static__" + index, false);
    return tree;
  }
  /**
   * Runtime helper for v-once.
   * Effectively it means marking the node as static with a unique key.
   */


  function markOnce(tree, index, key) {
    markStatic(tree, "__once__" + index + (key ? "_" + key : ""), true);
    return tree;
  }

  function markStatic(tree, key, isOnce) {
    if (Array.isArray(tree)) {
      for (var i = 0; i < tree.length; i++) {
        if (tree[i] && typeof tree[i] !== 'string') {
          markStaticNode(tree[i], key + "_" + i, isOnce);
        }
      }
    } else {
      markStaticNode(tree, key, isOnce);
    }
  }

  function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
  }
  /*  */


  function bindObjectListeners(data, value) {
    if (value) {
      if (!isPlainObject(value)) {
        warn('v-on without argument expects an Object value', this);
      } else {
        var on = data.on = data.on ? extend({}, data.on) : {};

        for (var key in value) {
          var existing = on[key];
          var ours = value[key];
          on[key] = existing ? [].concat(existing, ours) : ours;
        }
      }
    }

    return data;
  }
  /*  */


  function resolveScopedSlots(fns, // see flow/vnode
  res, // the following are added in 2.6
  hasDynamicKeys, contentHashKey) {
    res = res || {
      $stable: !hasDynamicKeys
    };

    for (var i = 0; i < fns.length; i++) {
      var slot = fns[i];

      if (Array.isArray(slot)) {
        resolveScopedSlots(slot, res, hasDynamicKeys);
      } else if (slot) {
        // marker for reverse proxying v-slot without scope on this.$slots
        if (slot.proxy) {
          slot.fn.proxy = true;
        }

        res[slot.key] = slot.fn;
      }
    }

    if (contentHashKey) {
      res.$key = contentHashKey;
    }

    return res;
  }
  /*  */


  function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
      var key = values[i];

      if (typeof key === 'string' && key) {
        baseObj[values[i]] = values[i + 1];
      } else if (key !== '' && key !== null) {
        // null is a special value for explicitly removing a binding
        warn("Invalid value for dynamic directive argument (expected string or null): " + key, this);
      }
    }

    return baseObj;
  } // helper to dynamically append modifier runtime markers to event names.
  // ensure only append when value is already string, otherwise it will be cast
  // to string and cause the type check to miss.


  function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
  }
  /*  */


  function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
  }
  /*  */


  function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var this$1 = this;
    var options = Ctor.options; // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check

    var contextVm;

    if (hasOwn(parent, '_uid')) {
      contextVm = Object.create(parent); // $flow-disable-line

      contextVm._original = parent;
    } else {
      // the context vm passed in is a functional context as well.
      // in this case we want to make sure we are able to get a hold to the
      // real context instance.
      contextVm = parent; // $flow-disable-line

      parent = parent._original;
    }

    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);

    this.slots = function () {
      if (!this$1.$slots) {
        normalizeScopedSlots(data.scopedSlots, this$1.$slots = resolveSlots(children, parent));
      }

      return this$1.$slots;
    };

    Object.defineProperty(this, 'scopedSlots', {
      enumerable: true,
      get: function get() {
        return normalizeScopedSlots(data.scopedSlots, this.slots());
      }
    }); // support for compiled functional template

    if (isCompiled) {
      // exposing $options for renderStatic()
      this.$options = options; // pre-resolve slots for renderSlot()

      this.$slots = this.slots();
      this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
    }

    if (options._scopeId) {
      this._c = function (a, b, c, d) {
        var vnode = createElement(contextVm, a, b, c, d, needNormalization);

        if (vnode && !Array.isArray(vnode)) {
          vnode.fnScopeId = options._scopeId;
          vnode.fnContext = parent;
        }

        return vnode;
      };
    } else {
      this._c = function (a, b, c, d) {
        return createElement(contextVm, a, b, c, d, needNormalization);
      };
    }
  }

  installRenderHelpers(FunctionalRenderContext.prototype);

  function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;

    if (isDef(propOptions)) {
      for (var key in propOptions) {
        props[key] = validateProp(key, propOptions, propsData || emptyObject);
      }
    } else {
      if (isDef(data.attrs)) {
        mergeProps(props, data.attrs);
      }

      if (isDef(data.props)) {
        mergeProps(props, data.props);
      }
    }

    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);

    if (vnode instanceof VNode) {
      return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    } else if (Array.isArray(vnode)) {
      var vnodes = normalizeChildren(vnode) || [];
      var res = new Array(vnodes.length);

      for (var i = 0; i < vnodes.length; i++) {
        res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
      }

      return res;
    }
  }

  function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    {
      (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
    }

    if (data.slot) {
      (clone.data || (clone.data = {})).slot = data.slot;
    }

    return clone;
  }

  function mergeProps(to, from) {
    for (var key in from) {
      to[camelize(key)] = from[key];
    }
  }
  /*  */

  /*  */

  /*  */

  /*  */
  // inline hooks to be invoked on component VNodes during patch


  var componentVNodeHooks = {
    init: function init(vnode, hydrating) {
      if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
        // kept-alive components, treat as a patch
        var mountedNode = vnode; // work around flow

        componentVNodeHooks.prepatch(mountedNode, mountedNode);
      } else {
        var child = vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance);
        child.$mount(hydrating ? vnode.elm : undefined, hydrating);
      }
    },
    prepatch: function prepatch(oldVnode, vnode) {
      var options = vnode.componentOptions;
      var child = vnode.componentInstance = oldVnode.componentInstance;
      updateChildComponent(child, options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
      );
    },
    insert: function insert(vnode) {
      var context = vnode.context;
      var componentInstance = vnode.componentInstance;

      if (!componentInstance._isMounted) {
        componentInstance._isMounted = true;
        callHook(componentInstance, 'mounted');
      }

      if (vnode.data.keepAlive) {
        if (context._isMounted) {
          // vue-router#1212
          // During updates, a kept-alive component's child components may
          // change, so directly walking the tree here may call activated hooks
          // on incorrect children. Instead we push them into a queue which will
          // be processed after the whole patch process ended.
          queueActivatedComponent(componentInstance);
        } else {
          activateChildComponent(componentInstance, true
          /* direct */
          );
        }
      }
    },
    destroy: function destroy(vnode) {
      var componentInstance = vnode.componentInstance;

      if (!componentInstance._isDestroyed) {
        if (!vnode.data.keepAlive) {
          componentInstance.$destroy();
        } else {
          deactivateChildComponent(componentInstance, true
          /* direct */
          );
        }
      }
    }
  };
  var hooksToMerge = Object.keys(componentVNodeHooks);

  function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
      return;
    }

    var baseCtor = context.$options._base; // plain options object: turn it into a constructor

    if (isObject(Ctor)) {
      Ctor = baseCtor.extend(Ctor);
    } // if at this stage it's not a constructor or an async component factory,
    // reject.


    if (typeof Ctor !== 'function') {
      {
        warn("Invalid Component definition: " + String(Ctor), context);
      }
      return;
    } // async component


    var asyncFactory;

    if (isUndef(Ctor.cid)) {
      asyncFactory = Ctor;
      Ctor = resolveAsyncComponent(asyncFactory, baseCtor);

      if (Ctor === undefined) {
        // return a placeholder node for async component, which is rendered
        // as a comment node but preserves all the raw information for the node.
        // the information will be used for async server-rendering and hydration.
        return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
      }
    }

    data = data || {}; // resolve constructor options in case global mixins are applied after
    // component constructor creation

    resolveConstructorOptions(Ctor); // transform component v-model data into props & events

    if (isDef(data.model)) {
      transformModel(Ctor.options, data);
    } // extract props


    var propsData = extractPropsFromVNodeData(data, Ctor, tag); // functional component

    if (isTrue(Ctor.options.functional)) {
      return createFunctionalComponent(Ctor, propsData, data, context, children);
    } // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners


    var listeners = data.on; // replace with listeners with .native modifier
    // so it gets processed during parent component patch.

    data.on = data.nativeOn;

    if (isTrue(Ctor.options.abstract)) {
      // abstract components do not keep anything
      // other than props & listeners & slot
      // work around flow
      var slot = data.slot;
      data = {};

      if (slot) {
        data.slot = slot;
      }
    } // install component management hooks onto the placeholder node


    installComponentHooks(data); // return a placeholder vnode

    var name = Ctor.options.name || tag;
    var vnode = new VNode("vue-component-" + Ctor.cid + (name ? "-" + name : ''), data, undefined, undefined, undefined, context, {
      Ctor: Ctor,
      propsData: propsData,
      listeners: listeners,
      tag: tag,
      children: children
    }, asyncFactory);
    return vnode;
  }

  function createComponentInstanceForVnode( // we know it's MountedComponentVNode but flow doesn't
  vnode, // activeInstance in lifecycle state
  parent) {
    var options = {
      _isComponent: true,
      _parentVnode: vnode,
      parent: parent
    }; // check inline-template render functions

    var inlineTemplate = vnode.data.inlineTemplate;

    if (isDef(inlineTemplate)) {
      options.render = inlineTemplate.render;
      options.staticRenderFns = inlineTemplate.staticRenderFns;
    }

    return new vnode.componentOptions.Ctor(options);
  }

  function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});

    for (var i = 0; i < hooksToMerge.length; i++) {
      var key = hooksToMerge[i];
      var existing = hooks[key];
      var toMerge = componentVNodeHooks[key];

      if (existing !== toMerge && !(existing && existing._merged)) {
        hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
      }
    }
  }

  function mergeHook$1(f1, f2) {
    var merged = function (a, b) {
      // flow complains about extra args which is why we use any
      f1(a, b);
      f2(a, b);
    };

    merged._merged = true;
    return merged;
  } // transform component v-model info (value and callback) into
  // prop and event handler respectively.


  function transformModel(options, data) {
    var prop = options.model && options.model.prop || 'value';
    var event = options.model && options.model.event || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;

    if (isDef(existing)) {
      if (Array.isArray(existing) ? existing.indexOf(callback) === -1 : existing !== callback) {
        on[event] = [callback].concat(existing);
      }
    } else {
      on[event] = callback;
    }
  }
  /*  */


  var SIMPLE_NORMALIZE = 1;
  var ALWAYS_NORMALIZE = 2; // wrapper function for providing a more flexible interface
  // without getting yelled at by flow

  function createElement(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (Array.isArray(data) || isPrimitive(data)) {
      normalizationType = children;
      children = data;
      data = undefined;
    }

    if (isTrue(alwaysNormalize)) {
      normalizationType = ALWAYS_NORMALIZE;
    }

    return _createElement(context, tag, data, children, normalizationType);
  }

  function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
      warn("Avoid using observed data object as vnode data: " + JSON.stringify(data) + "\n" + 'Always create fresh vnode data objects in each render!', context);
      return createEmptyVNode();
    } // object syntax in v-bind


    if (isDef(data) && isDef(data.is)) {
      tag = data.is;
    }

    if (!tag) {
      // in case of component :is set to falsy value
      return createEmptyVNode();
    } // warn against non-primitive key


    if (isDef(data) && isDef(data.key) && !isPrimitive(data.key)) {
      {
        warn('Avoid using non-primitive value as key, ' + 'use string/number value instead.', context);
      }
    } // support single function children as default scoped slot


    if (Array.isArray(children) && typeof children[0] === 'function') {
      data = data || {};
      data.scopedSlots = {
        default: children[0]
      };
      children.length = 0;
    }

    if (normalizationType === ALWAYS_NORMALIZE) {
      children = normalizeChildren(children);
    } else if (normalizationType === SIMPLE_NORMALIZE) {
      children = simpleNormalizeChildren(children);
    }

    var vnode, ns;

    if (typeof tag === 'string') {
      var Ctor;
      ns = context.$vnode && context.$vnode.ns || config.getTagNamespace(tag);

      if (config.isReservedTag(tag)) {
        // platform built-in elements
        if (isDef(data) && isDef(data.nativeOn) && data.tag !== 'component') {
          warn("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">.", context);
        }

        vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
      } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
        // component
        vnode = createComponent(Ctor, data, context, children, tag);
      } else {
        // unknown or unlisted namespaced elements
        // check at runtime because it may get assigned a namespace when its
        // parent normalizes children
        vnode = new VNode(tag, data, children, undefined, undefined, context);
      }
    } else {
      // direct component options / constructor
      vnode = createComponent(tag, data, context, children);
    }

    if (Array.isArray(vnode)) {
      return vnode;
    } else if (isDef(vnode)) {
      if (isDef(ns)) {
        applyNS(vnode, ns);
      }

      if (isDef(data)) {
        registerDeepBindings(data);
      }

      return vnode;
    } else {
      return createEmptyVNode();
    }
  }

  function applyNS(vnode, ns, force) {
    vnode.ns = ns;

    if (vnode.tag === 'foreignObject') {
      // use default namespace inside foreignObject
      ns = undefined;
      force = true;
    }

    if (isDef(vnode.children)) {
      for (var i = 0, l = vnode.children.length; i < l; i++) {
        var child = vnode.children[i];

        if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== 'svg')) {
          applyNS(child, ns, force);
        }
      }
    }
  } // ref #5318
  // necessary to ensure parent re-render when deep bindings like :style and
  // :class are used on slot nodes


  function registerDeepBindings(data) {
    if (isObject(data.style)) {
      traverse(data.style);
    }

    if (isObject(data.class)) {
      traverse(data.class);
    }
  }
  /*  */


  function initRender(vm) {
    vm._vnode = null; // the root of the child tree

    vm._staticTrees = null; // v-once cached trees

    var options = vm.$options;
    var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree

    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = emptyObject; // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates

    vm._c = function (a, b, c, d) {
      return createElement(vm, a, b, c, d, false);
    }; // normalization is always applied for the public version, used in
    // user-written render functions.


    vm.$createElement = function (a, b, c, d) {
      return createElement(vm, a, b, c, d, true);
    }; // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated


    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */

    {
      defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
        !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
      }, true);
      defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
        !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
      }, true);
    }
  }

  var currentRenderingInstance = null;

  function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);

    Vue.prototype.$nextTick = function (fn) {
      return nextTick(fn, this);
    };

    Vue.prototype._render = function () {
      var vm = this;
      var ref = vm.$options;
      var render = ref.render;
      var _parentVnode = ref._parentVnode;

      if (_parentVnode) {
        vm.$scopedSlots = normalizeScopedSlots(_parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
      } // set parent vnode. this allows render functions to have access
      // to the data on the placeholder node.


      vm.$vnode = _parentVnode; // render self

      var vnode;

      try {
        // There's no need to maintain a stack because all render fns are called
        // separately from one another. Nested component's render fns are called
        // when parent component is patched.
        currentRenderingInstance = vm;
        vnode = render.call(vm._renderProxy, vm.$createElement);
      } catch (e) {
        handleError(e, vm, "render"); // return error render result,
        // or previous vnode to prevent render error causing blank component

        /* istanbul ignore else */

        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } finally {
        currentRenderingInstance = null;
      } // if the returned array contains only a single node, allow it


      if (Array.isArray(vnode) && vnode.length === 1) {
        vnode = vnode[0];
      } // return empty vnode in case the render function errored out


      if (!(vnode instanceof VNode)) {
        if (Array.isArray(vnode)) {
          warn('Multiple root nodes returned from render function. Render function ' + 'should return a single root node.', vm);
        }

        vnode = createEmptyVNode();
      } // set parent


      vnode.parent = _parentVnode;
      return vnode;
    };
  }
  /*  */


  function ensureCtor(comp, base) {
    if (comp.__esModule || hasSymbol && comp[Symbol.toStringTag] === 'Module') {
      comp = comp.default;
    }

    return isObject(comp) ? base.extend(comp) : comp;
  }

  function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = {
      data: data,
      context: context,
      children: children,
      tag: tag
    };
    return node;
  }

  function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
      return factory.errorComp;
    }

    if (isDef(factory.resolved)) {
      return factory.resolved;
    }

    var owner = currentRenderingInstance;

    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
      // already pending
      factory.owners.push(owner);
    }

    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
      return factory.loadingComp;
    }

    if (owner && !isDef(factory.owners)) {
      var owners = factory.owners = [owner];
      var sync = true;
      var timerLoading = null;
      var timerTimeout = null;
      owner.$on('hook:destroyed', function () {
        return remove(owners, owner);
      });

      var forceRender = function (renderCompleted) {
        for (var i = 0, l = owners.length; i < l; i++) {
          owners[i].$forceUpdate();
        }

        if (renderCompleted) {
          owners.length = 0;

          if (timerLoading !== null) {
            clearTimeout(timerLoading);
            timerLoading = null;
          }

          if (timerTimeout !== null) {
            clearTimeout(timerTimeout);
            timerTimeout = null;
          }
        }
      };

      var resolve = once(function (res) {
        // cache resolved
        factory.resolved = ensureCtor(res, baseCtor); // invoke callbacks only if this is not a synchronous resolve
        // (async resolves are shimmed as synchronous during SSR)

        if (!sync) {
          forceRender(true);
        } else {
          owners.length = 0;
        }
      });
      var reject = once(function (reason) {
        warn("Failed to resolve async component: " + String(factory) + (reason ? "\nReason: " + reason : ''));

        if (isDef(factory.errorComp)) {
          factory.error = true;
          forceRender(true);
        }
      });
      var res = factory(resolve, reject);

      if (isObject(res)) {
        if (isPromise(res)) {
          // () => Promise
          if (isUndef(factory.resolved)) {
            res.then(resolve, reject);
          }
        } else if (isPromise(res.component)) {
          res.component.then(resolve, reject);

          if (isDef(res.error)) {
            factory.errorComp = ensureCtor(res.error, baseCtor);
          }

          if (isDef(res.loading)) {
            factory.loadingComp = ensureCtor(res.loading, baseCtor);

            if (res.delay === 0) {
              factory.loading = true;
            } else {
              timerLoading = setTimeout(function () {
                timerLoading = null;

                if (isUndef(factory.resolved) && isUndef(factory.error)) {
                  factory.loading = true;
                  forceRender(false);
                }
              }, res.delay || 200);
            }
          }

          if (isDef(res.timeout)) {
            timerTimeout = setTimeout(function () {
              timerTimeout = null;

              if (isUndef(factory.resolved)) {
                reject("timeout (" + res.timeout + "ms)");
              }
            }, res.timeout);
          }
        }
      }

      sync = false; // return in case resolved synchronously

      return factory.loading ? factory.loadingComp : factory.resolved;
    }
  }
  /*  */


  function getFirstComponentChild(children) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; i++) {
        var c = children[i];

        if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
          return c;
        }
      }
    }
  }
  /*  */

  /*  */


  function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false; // init parent attached events

    var listeners = vm.$options._parentListeners;

    if (listeners) {
      updateComponentListeners(vm, listeners);
    }
  }

  var target;

  function add(event, fn) {
    target.$on(event, fn);
  }

  function remove$1(event, fn) {
    target.$off(event, fn);
  }

  function createOnceHandler(event, fn) {
    var _target = target;
    return function onceHandler() {
      var res = fn.apply(null, arguments);

      if (res !== null) {
        _target.$off(event, onceHandler);
      }
    };
  }

  function updateComponentListeners(vm, listeners, oldListeners) {
    target = vm;
    updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
    target = undefined;
  }

  function eventsMixin(Vue) {
    var hookRE = /^hook:/;

    Vue.prototype.$on = function (event, fn) {
      var vm = this;

      if (Array.isArray(event)) {
        for (var i = 0, l = event.length; i < l; i++) {
          vm.$on(event[i], fn);
        }
      } else {
        (vm._events[event] || (vm._events[event] = [])).push(fn); // optimize hook:event cost by using a boolean flag marked at registration
        // instead of a hash lookup

        if (hookRE.test(event)) {
          vm._hasHookEvent = true;
        }
      }

      return vm;
    };

    Vue.prototype.$once = function (event, fn) {
      var vm = this;

      function on() {
        vm.$off(event, on);
        fn.apply(vm, arguments);
      }

      on.fn = fn;
      vm.$on(event, on);
      return vm;
    };

    Vue.prototype.$off = function (event, fn) {
      var vm = this; // all

      if (!arguments.length) {
        vm._events = Object.create(null);
        return vm;
      } // array of events


      if (Array.isArray(event)) {
        for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
          vm.$off(event[i$1], fn);
        }

        return vm;
      } // specific event


      var cbs = vm._events[event];

      if (!cbs) {
        return vm;
      }

      if (!fn) {
        vm._events[event] = null;
        return vm;
      } // specific handler


      var cb;
      var i = cbs.length;

      while (i--) {
        cb = cbs[i];

        if (cb === fn || cb.fn === fn) {
          cbs.splice(i, 1);
          break;
        }
      }

      return vm;
    };

    Vue.prototype.$emit = function (event) {
      var vm = this;
      {
        var lowerCaseEvent = event.toLowerCase();

        if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
          tip("Event \"" + lowerCaseEvent + "\" is emitted in component " + formatComponentName(vm) + " but the handler is registered for \"" + event + "\". " + "Note that HTML attributes are case-insensitive and you cannot use " + "v-on to listen to camelCase events when using in-DOM templates. " + "You should probably use \"" + hyphenate(event) + "\" instead of \"" + event + "\".");
        }
      }
      var cbs = vm._events[event];

      if (cbs) {
        cbs = cbs.length > 1 ? toArray(cbs) : cbs;
        var args = toArray(arguments, 1);
        var info = "event handler for \"" + event + "\"";

        for (var i = 0, l = cbs.length; i < l; i++) {
          invokeWithErrorHandling(cbs[i], vm, args, vm, info);
        }
      }

      return vm;
    };
  }
  /*  */


  var activeInstance = null;
  var isUpdatingChildComponent = false;

  function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
      activeInstance = prevActiveInstance;
    };
  }

  function initLifecycle(vm) {
    var options = vm.$options; // locate first non-abstract parent

    var parent = options.parent;

    if (parent && !options.abstract) {
      while (parent.$options.abstract && parent.$parent) {
        parent = parent.$parent;
      }

      parent.$children.push(vm);
    }

    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
  }

  function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
      var vm = this;
      var prevEl = vm.$el;
      var prevVnode = vm._vnode;
      var restoreActiveInstance = setActiveInstance(vm);
      vm._vnode = vnode; // Vue.prototype.__patch__ is injected in entry points
      // based on the rendering backend used.

      if (!prevVnode) {
        // initial render
        vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false
        /* removeOnly */
        );
      } else {
        // updates
        vm.$el = vm.__patch__(prevVnode, vnode);
      }

      restoreActiveInstance(); // update __vue__ reference

      if (prevEl) {
        prevEl.__vue__ = null;
      }

      if (vm.$el) {
        vm.$el.__vue__ = vm;
      } // if parent is an HOC, update its $el as well


      if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
        vm.$parent.$el = vm.$el;
      } // updated hook is called by the scheduler to ensure that children are
      // updated in a parent's updated hook.

    };

    Vue.prototype.$forceUpdate = function () {
      var vm = this;

      if (vm._watcher) {
        vm._watcher.update();
      }
    };

    Vue.prototype.$destroy = function () {
      var vm = this;

      if (vm._isBeingDestroyed) {
        return;
      }

      callHook(vm, 'beforeDestroy');
      vm._isBeingDestroyed = true; // remove self from parent

      var parent = vm.$parent;

      if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
        remove(parent.$children, vm);
      } // teardown watchers


      if (vm._watcher) {
        vm._watcher.teardown();
      }

      var i = vm._watchers.length;

      while (i--) {
        vm._watchers[i].teardown();
      } // remove reference from data ob
      // frozen object may not have observer.


      if (vm._data.__ob__) {
        vm._data.__ob__.vmCount--;
      } // call the last hook...


      vm._isDestroyed = true; // invoke destroy hooks on current rendered tree

      vm.__patch__(vm._vnode, null); // fire destroyed hook


      callHook(vm, 'destroyed'); // turn off all instance listeners.

      vm.$off(); // remove __vue__ reference

      if (vm.$el) {
        vm.$el.__vue__ = null;
      } // release circular reference (#6759)


      if (vm.$vnode) {
        vm.$vnode.parent = null;
      }
    };
  }

  function mountComponent(vm, el, hydrating) {
    vm.$el = el;

    if (!vm.$options.render) {
      vm.$options.render = createEmptyVNode;
      {
        /* istanbul ignore if */
        if (vm.$options.template && vm.$options.template.charAt(0) !== '#' || vm.$options.el || el) {
          warn('You are using the runtime-only build of Vue where the template ' + 'compiler is not available. Either pre-compile the templates into ' + 'render functions, or use the compiler-included build.', vm);
        } else {
          warn('Failed to mount component: template or render function not defined.', vm);
        }
      }
    }

    callHook(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */

    if (config.performance && mark) {
      updateComponent = function () {
        var name = vm._name;
        var id = vm._uid;
        var startTag = "vue-perf-start:" + id;
        var endTag = "vue-perf-end:" + id;
        mark(startTag);

        var vnode = vm._render();

        mark(endTag);
        measure("vue " + name + " render", startTag, endTag);
        mark(startTag);

        vm._update(vnode, hydrating);

        mark(endTag);
        measure("vue " + name + " patch", startTag, endTag);
      };
    } else {
      updateComponent = function () {
        vm._update(vm._render(), hydrating);
      };
    } // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined


    new Watcher(vm, updateComponent, noop, {
      before: function before() {
        if (vm._isMounted && !vm._isDestroyed) {
          callHook(vm, 'beforeUpdate');
        }
      }
    }, true
    /* isRenderWatcher */
    );
    hydrating = false; // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook

    if (vm.$vnode == null) {
      vm._isMounted = true;
      callHook(vm, 'mounted');
    }

    return vm;
  }

  function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    {
      isUpdatingChildComponent = true;
    } // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.

    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!(newScopedSlots && !newScopedSlots.$stable || oldScopedSlots !== emptyObject && !oldScopedSlots.$stable || newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key || !newScopedSlots && vm.$scopedSlots.$key); // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.

    var needsForceUpdate = !!(renderChildren || // has new static slots
    vm.$options._renderChildren || // has old static slots
    hasDynamicScopedSlot);
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render

    if (vm._vnode) {
      // update child tree's parent
      vm._vnode.parent = parentVnode;
    }

    vm.$options._renderChildren = renderChildren; // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render

    vm.$attrs = parentVnode.data.attrs || emptyObject;
    vm.$listeners = listeners || emptyObject; // update props

    if (propsData && vm.$options.props) {
      toggleObserving(false);
      var props = vm._props;
      var propKeys = vm.$options._propKeys || [];

      for (var i = 0; i < propKeys.length; i++) {
        var key = propKeys[i];
        var propOptions = vm.$options.props; // wtf flow?

        props[key] = validateProp(key, propOptions, propsData, vm);
      }

      toggleObserving(true); // keep a copy of raw propsData

      vm.$options.propsData = propsData;
    } // update listeners


    listeners = listeners || emptyObject;
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners); // resolve slots + force update if has children

    if (needsForceUpdate) {
      vm.$slots = resolveSlots(renderChildren, parentVnode.context);
      vm.$forceUpdate();
    }

    {
      isUpdatingChildComponent = false;
    }
  }

  function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
      if (vm._inactive) {
        return true;
      }
    }

    return false;
  }

  function activateChildComponent(vm, direct) {
    if (direct) {
      vm._directInactive = false;

      if (isInInactiveTree(vm)) {
        return;
      }
    } else if (vm._directInactive) {
      return;
    }

    if (vm._inactive || vm._inactive === null) {
      vm._inactive = false;

      for (var i = 0; i < vm.$children.length; i++) {
        activateChildComponent(vm.$children[i]);
      }

      callHook(vm, 'activated');
    }
  }

  function deactivateChildComponent(vm, direct) {
    if (direct) {
      vm._directInactive = true;

      if (isInInactiveTree(vm)) {
        return;
      }
    }

    if (!vm._inactive) {
      vm._inactive = true;

      for (var i = 0; i < vm.$children.length; i++) {
        deactivateChildComponent(vm.$children[i]);
      }

      callHook(vm, 'deactivated');
    }
  }

  function callHook(vm, hook) {
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var handlers = vm.$options[hook];
    var info = hook + " hook";

    if (handlers) {
      for (var i = 0, j = handlers.length; i < j; i++) {
        invokeWithErrorHandling(handlers[i], vm, null, vm, info);
      }
    }

    if (vm._hasHookEvent) {
      vm.$emit('hook:' + hook);
    }

    popTarget();
  }
  /*  */


  var MAX_UPDATE_COUNT = 100;
  var queue = [];
  var activatedChildren = [];
  var has = {};
  var circular = {};
  var waiting = false;
  var flushing = false;
  var index = 0;
  /**
   * Reset the scheduler's state.
   */

  function resetSchedulerState() {
    index = queue.length = activatedChildren.length = 0;
    has = {};
    {
      circular = {};
    }
    waiting = flushing = false;
  } // Async edge case #6566 requires saving the timestamp when event listeners are
  // attached. However, calling performance.now() has a perf overhead especially
  // if the page has thousands of event listeners. Instead, we take a timestamp
  // every time the scheduler flushes and use that for all event listeners
  // attached during that flush.


  var currentFlushTimestamp = 0; // Async edge case fix requires storing an event listener's attach timestamp.

  var getNow = Date.now; // Determine what event timestamp the browser is using. Annoyingly, the
  // timestamp can either be hi-res (relative to page load) or low-res
  // (relative to UNIX epoch), so in order to compare time we have to use the
  // same timestamp type when saving the flush timestamp.
  // All IE versions use low-res event timestamps, and have problematic clock
  // implementations (#9632)

  if (inBrowser && !isIE) {
    var performance = window.performance;

    if (performance && typeof performance.now === 'function' && getNow() > document.createEvent('Event').timeStamp) {
      // if the event timestamp, although evaluated AFTER the Date.now(), is
      // smaller than it, it means the event is using a hi-res timestamp,
      // and we need to use the hi-res version for event listener timestamps as
      // well.
      getNow = function () {
        return performance.now();
      };
    }
  }
  /**
   * Flush both queues and run the watchers.
   */


  function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id; // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.

    queue.sort(function (a, b) {
      return a.id - b.id;
    }); // do not cache length because more watchers might be pushed
    // as we run existing watchers

    for (index = 0; index < queue.length; index++) {
      watcher = queue[index];

      if (watcher.before) {
        watcher.before();
      }

      id = watcher.id;
      has[id] = null;
      watcher.run(); // in dev build, check and stop circular updates.

      if (has[id] != null) {
        circular[id] = (circular[id] || 0) + 1;

        if (circular[id] > MAX_UPDATE_COUNT) {
          warn('You may have an infinite update loop ' + (watcher.user ? "in watcher with expression \"" + watcher.expression + "\"" : "in a component render function."), watcher.vm);
          break;
        }
      }
    } // keep copies of post queues before resetting state


    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState(); // call component updated and activated hooks

    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue); // devtool hook

    /* istanbul ignore if */

    if (devtools && config.devtools) {
      devtools.emit('flush');
    }
  }

  function callUpdatedHooks(queue) {
    var i = queue.length;

    while (i--) {
      var watcher = queue[i];
      var vm = watcher.vm;

      if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'updated');
      }
    }
  }
  /**
   * Queue a kept-alive component that was activated during patch.
   * The queue will be processed after the entire tree has been patched.
   */


  function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
  }

  function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
      queue[i]._inactive = true;
      activateChildComponent(queue[i], true
      /* true */
      );
    }
  }
  /**
   * Push a watcher into the watcher queue.
   * Jobs with duplicate IDs will be skipped unless it's
   * pushed when the queue is being flushed.
   */


  function queueWatcher(watcher) {
    var id = watcher.id;

    if (has[id] == null) {
      has[id] = true;

      if (!flushing) {
        queue.push(watcher);
      } else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;

        while (i > index && queue[i].id > watcher.id) {
          i--;
        }

        queue.splice(i + 1, 0, watcher);
      } // queue the flush


      if (!waiting) {
        waiting = true;

        if (!config.async) {
          flushSchedulerQueue();
          return;
        }

        nextTick(flushSchedulerQueue);
      }
    }
  }
  /*  */


  var uid$2 = 0;
  /**
   * A watcher parses an expression, collects dependencies,
   * and fires callback when the expression value changes.
   * This is used for both the $watch() api and directives.
   */

  var Watcher = function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
    this.vm = vm;

    if (isRenderWatcher) {
      vm._watcher = this;
    }

    vm._watchers.push(this); // options


    if (options) {
      this.deep = !!options.deep;
      this.user = !!options.user;
      this.lazy = !!options.lazy;
      this.sync = !!options.sync;
      this.before = options.before;
    } else {
      this.deep = this.user = this.lazy = this.sync = false;
    }

    this.cb = cb;
    this.id = ++uid$2; // uid for batching

    this.active = true;
    this.dirty = this.lazy; // for lazy watchers

    this.deps = [];
    this.newDeps = [];
    this.depIds = new _Set();
    this.newDepIds = new _Set();
    this.expression = expOrFn.toString(); // parse expression for getter

    if (typeof expOrFn === 'function') {
      this.getter = expOrFn;
    } else {
      this.getter = parsePath(expOrFn);

      if (!this.getter) {
        this.getter = noop;
        warn("Failed watching path: \"" + expOrFn + "\" " + 'Watcher only accepts simple dot-delimited paths. ' + 'For full control, use a function instead.', vm);
      }
    }

    this.value = this.lazy ? undefined : this.get();
  };
  /**
   * Evaluate the getter, and re-collect dependencies.
   */


  Watcher.prototype.get = function get() {
    pushTarget(this);
    var value;
    var vm = this.vm;

    try {
      value = this.getter.call(vm, vm);
    } catch (e) {
      if (this.user) {
        handleError(e, vm, "getter for watcher \"" + this.expression + "\"");
      } else {
        throw e;
      }
    } finally {
      // "touch" every property so they are all tracked as
      // dependencies for deep watching
      if (this.deep) {
        traverse(value);
      }

      popTarget();
      this.cleanupDeps();
    }

    return value;
  };
  /**
   * Add a dependency to this directive.
   */


  Watcher.prototype.addDep = function addDep(dep) {
    var id = dep.id;

    if (!this.newDepIds.has(id)) {
      this.newDepIds.add(id);
      this.newDeps.push(dep);

      if (!this.depIds.has(id)) {
        dep.addSub(this);
      }
    }
  };
  /**
   * Clean up for dependency collection.
   */


  Watcher.prototype.cleanupDeps = function cleanupDeps() {
    var i = this.deps.length;

    while (i--) {
      var dep = this.deps[i];

      if (!this.newDepIds.has(dep.id)) {
        dep.removeSub(this);
      }
    }

    var tmp = this.depIds;
    this.depIds = this.newDepIds;
    this.newDepIds = tmp;
    this.newDepIds.clear();
    tmp = this.deps;
    this.deps = this.newDeps;
    this.newDeps = tmp;
    this.newDeps.length = 0;
  };
  /**
   * Subscriber interface.
   * Will be called when a dependency changes.
   */


  Watcher.prototype.update = function update() {
    /* istanbul ignore else */
    if (this.lazy) {
      this.dirty = true;
    } else if (this.sync) {
      this.run();
    } else {
      queueWatcher(this);
    }
  };
  /**
   * Scheduler job interface.
   * Will be called by the scheduler.
   */


  Watcher.prototype.run = function run() {
    if (this.active) {
      var value = this.get();

      if (value !== this.value || // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) || this.deep) {
        // set new value
        var oldValue = this.value;
        this.value = value;

        if (this.user) {
          var info = "callback for watcher \"" + this.expression + "\"";
          invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
        } else {
          this.cb.call(this.vm, value, oldValue);
        }
      }
    }
  };
  /**
   * Evaluate the value of the watcher.
   * This only gets called for lazy watchers.
   */


  Watcher.prototype.evaluate = function evaluate() {
    this.value = this.get();
    this.dirty = false;
  };
  /**
   * Depend on all deps collected by this watcher.
   */


  Watcher.prototype.depend = function depend() {
    var i = this.deps.length;

    while (i--) {
      this.deps[i].depend();
    }
  };
  /**
   * Remove self from all dependencies' subscriber list.
   */


  Watcher.prototype.teardown = function teardown() {
    if (this.active) {
      // remove self from vm's watcher list
      // this is a somewhat expensive operation so we skip it
      // if the vm is being destroyed.
      if (!this.vm._isBeingDestroyed) {
        remove(this.vm._watchers, this);
      }

      var i = this.deps.length;

      while (i--) {
        this.deps[i].removeSub(this);
      }

      this.active = false;
    }
  };
  /*  */


  var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
  };

  function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
      return this[sourceKey][key];
    };

    sharedPropertyDefinition.set = function proxySetter(val) {
      this[sourceKey][key] = val;
    };

    Object.defineProperty(target, key, sharedPropertyDefinition);
  }

  function initState(vm) {
    vm._watchers = [];
    var opts = vm.$options;

    if (opts.props) {
      initProps(vm, opts.props);
    }

    if (opts.methods) {
      initMethods(vm, opts.methods);
    }

    if (opts.data) {
      initData(vm);
    } else {
      observe(vm._data = {}, true
      /* asRootData */
      );
    }

    if (opts.computed) {
      initComputed(vm, opts.computed);
    }

    if (opts.watch && opts.watch !== nativeWatch) {
      initWatch(vm, opts.watch);
    }
  }

  function initProps(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = vm._props = {}; // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.

    var keys = vm.$options._propKeys = [];
    var isRoot = !vm.$parent; // root instance props should be converted

    if (!isRoot) {
      toggleObserving(false);
    }

    var loop = function (key) {
      keys.push(key);
      var value = validateProp(key, propsOptions, propsData, vm);
      /* istanbul ignore else */

      {
        var hyphenatedKey = hyphenate(key);

        if (isReservedAttribute(hyphenatedKey) || config.isReservedAttr(hyphenatedKey)) {
          warn("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop.", vm);
        }

        defineReactive$$1(props, key, value, function () {
          if (!isRoot && !isUpdatingChildComponent) {
            warn("Avoid mutating a prop directly since the value will be " + "overwritten whenever the parent component re-renders. " + "Instead, use a data or computed property based on the prop's " + "value. Prop being mutated: \"" + key + "\"", vm);
          }
        });
      } // static props are already proxied on the component's prototype
      // during Vue.extend(). We only need to proxy props defined at
      // instantiation here.

      if (!(key in vm)) {
        proxy(vm, "_props", key);
      }
    };

    for (var key in propsOptions) {
      loop(key);
    }

    toggleObserving(true);
  }

  function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = typeof data === 'function' ? getData(data, vm) : data || {};

    if (!isPlainObject(data)) {
      data = {};
      warn('data functions should return an object:\n' + 'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    } // proxy data on instance


    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;

    while (i--) {
      var key = keys[i];
      {
        if (methods && hasOwn(methods, key)) {
          warn("Method \"" + key + "\" has already been defined as a data property.", vm);
        }
      }

      if (props && hasOwn(props, key)) {
        warn("The data property \"" + key + "\" is already declared as a prop. " + "Use prop default value instead.", vm);
      } else if (!isReserved(key)) {
        proxy(vm, "_data", key);
      }
    } // observe data


    observe(data, true
    /* asRootData */
    );
  }

  function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();

    try {
      return data.call(vm, vm);
    } catch (e) {
      handleError(e, vm, "data()");
      return {};
    } finally {
      popTarget();
    }
  }

  var computedWatcherOptions = {
    lazy: true
  };

  function initComputed(vm, computed) {
    // $flow-disable-line
    var watchers = vm._computedWatchers = Object.create(null); // computed properties are just getters during SSR

    var isSSR = isServerRendering();

    for (var key in computed) {
      var userDef = computed[key];
      var getter = typeof userDef === 'function' ? userDef : userDef.get;

      if (getter == null) {
        warn("Getter is missing for computed property \"" + key + "\".", vm);
      }

      if (!isSSR) {
        // create internal watcher for the computed property.
        watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
      } // component-defined computed properties are already defined on the
      // component prototype. We only need to define computed properties defined
      // at instantiation here.


      if (!(key in vm)) {
        defineComputed(vm, key, userDef);
      } else {
        if (key in vm.$data) {
          warn("The computed property \"" + key + "\" is already defined in data.", vm);
        } else if (vm.$options.props && key in vm.$options.props) {
          warn("The computed property \"" + key + "\" is already defined as a prop.", vm);
        } else if (vm.$options.methods && key in vm.$options.methods) {
          warn("The computed property \"" + key + "\" is already defined as a method.", vm);
        }
      }
    }
  }

  function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();

    if (typeof userDef === 'function') {
      sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : createGetterInvoker(userDef);
      sharedPropertyDefinition.set = noop;
    } else {
      sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : createGetterInvoker(userDef.get) : noop;
      sharedPropertyDefinition.set = userDef.set || noop;
    }

    if (sharedPropertyDefinition.set === noop) {
      sharedPropertyDefinition.set = function () {
        warn("Computed property \"" + key + "\" was assigned to but it has no setter.", this);
      };
    }

    Object.defineProperty(target, key, sharedPropertyDefinition);
  }

  function createComputedGetter(key) {
    return function computedGetter() {
      var watcher = this._computedWatchers && this._computedWatchers[key];

      if (watcher) {
        if (watcher.dirty) {
          watcher.evaluate();
        }

        if (Dep.target) {
          watcher.depend();
        }

        return watcher.value;
      }
    };
  }

  function createGetterInvoker(fn) {
    return function computedGetter() {
      return fn.call(this, this);
    };
  }

  function initMethods(vm, methods) {
    var props = vm.$options.props;

    for (var key in methods) {
      {
        if (typeof methods[key] !== 'function') {
          warn("Method \"" + key + "\" has type \"" + typeof methods[key] + "\" in the component definition. " + "Did you reference the function correctly?", vm);
        }

        if (props && hasOwn(props, key)) {
          warn("Method \"" + key + "\" has already been defined as a prop.", vm);
        }

        if (key in vm && isReserved(key)) {
          warn("Method \"" + key + "\" conflicts with an existing Vue instance method. " + "Avoid defining component methods that start with _ or $.");
        }
      }
      vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
    }
  }

  function initWatch(vm, watch) {
    for (var key in watch) {
      var handler = watch[key];

      if (Array.isArray(handler)) {
        for (var i = 0; i < handler.length; i++) {
          createWatcher(vm, key, handler[i]);
        }
      } else {
        createWatcher(vm, key, handler);
      }
    }
  }

  function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
      options = handler;
      handler = handler.handler;
    }

    if (typeof handler === 'string') {
      handler = vm[handler];
    }

    return vm.$watch(expOrFn, handler, options);
  }

  function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};

    dataDef.get = function () {
      return this._data;
    };

    var propsDef = {};

    propsDef.get = function () {
      return this._props;
    };

    {
      dataDef.set = function () {
        warn('Avoid replacing instance root $data. ' + 'Use nested data properties instead.', this);
      };

      propsDef.set = function () {
        warn("$props is readonly.", this);
      };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;

    Vue.prototype.$watch = function (expOrFn, cb, options) {
      var vm = this;

      if (isPlainObject(cb)) {
        return createWatcher(vm, expOrFn, cb, options);
      }

      options = options || {};
      options.user = true;
      var watcher = new Watcher(vm, expOrFn, cb, options);

      if (options.immediate) {
        var info = "callback for immediate watcher \"" + watcher.expression + "\"";
        pushTarget();
        invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
        popTarget();
      }

      return function unwatchFn() {
        watcher.teardown();
      };
    };
  }
  /*  */


  var uid$3 = 0;

  function initMixin(Vue) {
    Vue.prototype._init = function (options) {
      var vm = this; // a uid

      vm._uid = uid$3++;
      var startTag, endTag;
      /* istanbul ignore if */

      if (config.performance && mark) {
        startTag = "vue-perf-start:" + vm._uid;
        endTag = "vue-perf-end:" + vm._uid;
        mark(startTag);
      } // a flag to avoid this being observed


      vm._isVue = true; // merge options

      if (options && options._isComponent) {
        // optimize internal component instantiation
        // since dynamic options merging is pretty slow, and none of the
        // internal component options needs special treatment.
        initInternalComponent(vm, options);
      } else {
        vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
      }
      /* istanbul ignore else */


      {
        initProxy(vm);
      } // expose real self

      vm._self = vm;
      initLifecycle(vm);
      initEvents(vm);
      initRender(vm);
      callHook(vm, 'beforeCreate');
      initInjections(vm); // resolve injections before data/props

      initState(vm);
      initProvide(vm); // resolve provide after data/props

      callHook(vm, 'created');
      /* istanbul ignore if */

      if (config.performance && mark) {
        vm._name = formatComponentName(vm, false);
        mark(endTag);
        measure("vue " + vm._name + " init", startTag, endTag);
      }

      if (vm.$options.el) {
        vm.$mount(vm.$options.el);
      }
    };
  }

  function initInternalComponent(vm, options) {
    var opts = vm.$options = Object.create(vm.constructor.options); // doing this because it's faster than dynamic enumeration.

    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;

    if (options.render) {
      opts.render = options.render;
      opts.staticRenderFns = options.staticRenderFns;
    }
  }

  function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;

    if (Ctor.super) {
      var superOptions = resolveConstructorOptions(Ctor.super);
      var cachedSuperOptions = Ctor.superOptions;

      if (superOptions !== cachedSuperOptions) {
        // super option changed,
        // need to resolve new options.
        Ctor.superOptions = superOptions; // check if there are any late-modified/attached options (#4976)

        var modifiedOptions = resolveModifiedOptions(Ctor); // update base extend options

        if (modifiedOptions) {
          extend(Ctor.extendOptions, modifiedOptions);
        }

        options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);

        if (options.name) {
          options.components[options.name] = Ctor;
        }
      }
    }

    return options;
  }

  function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;

    for (var key in latest) {
      if (latest[key] !== sealed[key]) {
        if (!modified) {
          modified = {};
        }

        modified[key] = latest[key];
      }
    }

    return modified;
  }

  function Vue(options) {
    if (!(this instanceof Vue)) {
      warn('Vue is a constructor and should be called with the `new` keyword');
    }

    this._init(options);
  }

  initMixin(Vue);
  stateMixin(Vue);
  eventsMixin(Vue);
  lifecycleMixin(Vue);
  renderMixin(Vue);
  /*  */

  function initUse(Vue) {
    Vue.use = function (plugin) {
      var installedPlugins = this._installedPlugins || (this._installedPlugins = []);

      if (installedPlugins.indexOf(plugin) > -1) {
        return this;
      } // additional parameters


      var args = toArray(arguments, 1);
      args.unshift(this);

      if (typeof plugin.install === 'function') {
        plugin.install.apply(plugin, args);
      } else if (typeof plugin === 'function') {
        plugin.apply(null, args);
      }

      installedPlugins.push(plugin);
      return this;
    };
  }
  /*  */


  function initMixin$1(Vue) {
    Vue.mixin = function (mixin) {
      this.options = mergeOptions(this.options, mixin);
      return this;
    };
  }
  /*  */


  function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */

    Vue.extend = function (extendOptions) {
      extendOptions = extendOptions || {};
      var Super = this;
      var SuperId = Super.cid;
      var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});

      if (cachedCtors[SuperId]) {
        return cachedCtors[SuperId];
      }

      var name = extendOptions.name || Super.options.name;

      if (name) {
        validateComponentName(name);
      }

      var Sub = function VueComponent(options) {
        this._init(options);
      };

      Sub.prototype = Object.create(Super.prototype);
      Sub.prototype.constructor = Sub;
      Sub.cid = cid++;
      Sub.options = mergeOptions(Super.options, extendOptions);
      Sub['super'] = Super; // For props and computed properties, we define the proxy getters on
      // the Vue instances at extension time, on the extended prototype. This
      // avoids Object.defineProperty calls for each instance created.

      if (Sub.options.props) {
        initProps$1(Sub);
      }

      if (Sub.options.computed) {
        initComputed$1(Sub);
      } // allow further extension/mixin/plugin usage


      Sub.extend = Super.extend;
      Sub.mixin = Super.mixin;
      Sub.use = Super.use; // create asset registers, so extended classes
      // can have their private assets too.

      ASSET_TYPES.forEach(function (type) {
        Sub[type] = Super[type];
      }); // enable recursive self-lookup

      if (name) {
        Sub.options.components[name] = Sub;
      } // keep a reference to the super options at extension time.
      // later at instantiation we can check if Super's options have
      // been updated.


      Sub.superOptions = Super.options;
      Sub.extendOptions = extendOptions;
      Sub.sealedOptions = extend({}, Sub.options); // cache constructor

      cachedCtors[SuperId] = Sub;
      return Sub;
    };
  }

  function initProps$1(Comp) {
    var props = Comp.options.props;

    for (var key in props) {
      proxy(Comp.prototype, "_props", key);
    }
  }

  function initComputed$1(Comp) {
    var computed = Comp.options.computed;

    for (var key in computed) {
      defineComputed(Comp.prototype, key, computed[key]);
    }
  }
  /*  */


  function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
      Vue[type] = function (id, definition) {
        if (!definition) {
          return this.options[type + 's'][id];
        } else {
          /* istanbul ignore if */
          if (type === 'component') {
            validateComponentName(id);
          }

          if (type === 'component' && isPlainObject(definition)) {
            definition.name = definition.name || id;
            definition = this.options._base.extend(definition);
          }

          if (type === 'directive' && typeof definition === 'function') {
            definition = {
              bind: definition,
              update: definition
            };
          }

          this.options[type + 's'][id] = definition;
          return definition;
        }
      };
    });
  }
  /*  */


  function getComponentName(opts) {
    return opts && (opts.Ctor.options.name || opts.tag);
  }

  function matches(pattern, name) {
    if (Array.isArray(pattern)) {
      return pattern.indexOf(name) > -1;
    } else if (typeof pattern === 'string') {
      return pattern.split(',').indexOf(name) > -1;
    } else if (isRegExp(pattern)) {
      return pattern.test(name);
    }
    /* istanbul ignore next */


    return false;
  }

  function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache;
    var keys = keepAliveInstance.keys;
    var _vnode = keepAliveInstance._vnode;

    for (var key in cache) {
      var entry = cache[key];

      if (entry) {
        var name = entry.name;

        if (name && !filter(name)) {
          pruneCacheEntry(cache, key, keys, _vnode);
        }
      }
    }
  }

  function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];

    if (entry && (!current || entry.tag !== current.tag)) {
      entry.componentInstance.$destroy();
    }

    cache[key] = null;
    remove(keys, key);
  }

  var patternTypes = [String, RegExp, Array];
  var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
      include: patternTypes,
      exclude: patternTypes,
      max: [String, Number]
    },
    methods: {
      cacheVNode: function cacheVNode() {
        var ref = this;
        var cache = ref.cache;
        var keys = ref.keys;
        var vnodeToCache = ref.vnodeToCache;
        var keyToCache = ref.keyToCache;

        if (vnodeToCache) {
          var tag = vnodeToCache.tag;
          var componentInstance = vnodeToCache.componentInstance;
          var componentOptions = vnodeToCache.componentOptions;
          cache[keyToCache] = {
            name: getComponentName(componentOptions),
            tag: tag,
            componentInstance: componentInstance
          };
          keys.push(keyToCache); // prune oldest entry

          if (this.max && keys.length > parseInt(this.max)) {
            pruneCacheEntry(cache, keys[0], keys, this._vnode);
          }

          this.vnodeToCache = null;
        }
      }
    },
    created: function created() {
      this.cache = Object.create(null);
      this.keys = [];
    },
    destroyed: function destroyed() {
      for (var key in this.cache) {
        pruneCacheEntry(this.cache, key, this.keys);
      }
    },
    mounted: function mounted() {
      var this$1 = this;
      this.cacheVNode();
      this.$watch('include', function (val) {
        pruneCache(this$1, function (name) {
          return matches(val, name);
        });
      });
      this.$watch('exclude', function (val) {
        pruneCache(this$1, function (name) {
          return !matches(val, name);
        });
      });
    },
    updated: function updated() {
      this.cacheVNode();
    },
    render: function render() {
      var slot = this.$slots.default;
      var vnode = getFirstComponentChild(slot);
      var componentOptions = vnode && vnode.componentOptions;

      if (componentOptions) {
        // check pattern
        var name = getComponentName(componentOptions);
        var ref = this;
        var include = ref.include;
        var exclude = ref.exclude;

        if ( // not included
        include && (!name || !matches(include, name)) || // excluded
        exclude && name && matches(exclude, name)) {
          return vnode;
        }

        var ref$1 = this;
        var cache = ref$1.cache;
        var keys = ref$1.keys;
        var key = vnode.key == null // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? "::" + componentOptions.tag : '') : vnode.key;

        if (cache[key]) {
          vnode.componentInstance = cache[key].componentInstance; // make current key freshest

          remove(keys, key);
          keys.push(key);
        } else {
          // delay setting the cache until update
          this.vnodeToCache = vnode;
          this.keyToCache = key;
        }

        vnode.data.keepAlive = true;
      }

      return vnode || slot && slot[0];
    }
  };
  var builtInComponents = {
    KeepAlive: KeepAlive
  };
  /*  */

  function initGlobalAPI(Vue) {
    // config
    var configDef = {};

    configDef.get = function () {
      return config;
    };

    {
      configDef.set = function () {
        warn('Do not replace the Vue.config object, set individual fields instead.');
      };
    }
    Object.defineProperty(Vue, 'config', configDef); // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.

    Vue.util = {
      warn: warn,
      extend: extend,
      mergeOptions: mergeOptions,
      defineReactive: defineReactive$$1
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick; // 2.6 explicit observable API

    Vue.observable = function (obj) {
      observe(obj);
      return obj;
    };

    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
      Vue.options[type + 's'] = Object.create(null);
    }); // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.

    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin$1(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
  }

  initGlobalAPI(Vue);
  Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
  });
  Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function get() {
      /* istanbul ignore next */
      return this.$vnode && this.$vnode.ssrContext;
    }
  }); // expose FunctionalRenderContext for ssr runtime helper installation

  Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
  });
  Vue.version = '2.6.14';
  /*  */
  // these are reserved for web because they are directly compiled away
  // during template compilation

  var isReservedAttr = makeMap('style,class'); // attributes that should be using props for binding

  var acceptValue = makeMap('input,textarea,option,select,progress');

  var mustUseProp = function (tag, type, attr) {
    return attr === 'value' && acceptValue(tag) && type !== 'button' || attr === 'selected' && tag === 'option' || attr === 'checked' && tag === 'input' || attr === 'muted' && tag === 'video';
  };

  var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
  var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

  var convertEnumeratedValue = function (key, value) {
    return isFalsyAttrValue(value) || value === 'false' ? 'false' // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value) ? value : 'true';
  };

  var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' + 'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' + 'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' + 'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' + 'required,reversed,scoped,seamless,selected,sortable,' + 'truespeed,typemustmatch,visible');
  var xlinkNS = 'http://www.w3.org/1999/xlink';

  var isXlink = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
  };

  var getXlinkProp = function (name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
  };

  var isFalsyAttrValue = function (val) {
    return val == null || val === false;
  };
  /*  */


  function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;

    while (isDef(childNode.componentInstance)) {
      childNode = childNode.componentInstance._vnode;

      if (childNode && childNode.data) {
        data = mergeClassData(childNode.data, data);
      }
    }

    while (isDef(parentNode = parentNode.parent)) {
      if (parentNode && parentNode.data) {
        data = mergeClassData(data, parentNode.data);
      }
    }

    return renderClass(data.staticClass, data.class);
  }

  function mergeClassData(child, parent) {
    return {
      staticClass: concat(child.staticClass, parent.staticClass),
      class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
  }

  function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
      return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */


    return '';
  }

  function concat(a, b) {
    return a ? b ? a + ' ' + b : a : b || '';
  }

  function stringifyClass(value) {
    if (Array.isArray(value)) {
      return stringifyArray(value);
    }

    if (isObject(value)) {
      return stringifyObject(value);
    }

    if (typeof value === 'string') {
      return value;
    }
    /* istanbul ignore next */


    return '';
  }

  function stringifyArray(value) {
    var res = '';
    var stringified;

    for (var i = 0, l = value.length; i < l; i++) {
      if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
        if (res) {
          res += ' ';
        }

        res += stringified;
      }
    }

    return res;
  }

  function stringifyObject(value) {
    var res = '';

    for (var key in value) {
      if (value[key]) {
        if (res) {
          res += ' ';
        }

        res += key;
      }
    }

    return res;
  }
  /*  */


  var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
  };
  var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' + 'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' + 'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' + 'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' + 's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' + 'embed,object,param,source,canvas,script,noscript,del,ins,' + 'caption,col,colgroup,table,thead,tbody,td,th,tr,' + 'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' + 'output,progress,select,textarea,' + 'details,dialog,menu,menuitem,summary,' + 'content,element,shadow,template,blockquote,iframe,tfoot'); // this map is intentionally selective, only covering SVG elements that may
  // contain child elements.

  var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' + 'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' + 'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);

  var isPreTag = function (tag) {
    return tag === 'pre';
  };

  var isReservedTag = function (tag) {
    return isHTMLTag(tag) || isSVG(tag);
  };

  function getTagNamespace(tag) {
    if (isSVG(tag)) {
      return 'svg';
    } // basic support for MathML
    // note it doesn't support other MathML elements being component roots


    if (tag === 'math') {
      return 'math';
    }
  }

  var unknownElementCache = Object.create(null);

  function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
      return true;
    }

    if (isReservedTag(tag)) {
      return false;
    }

    tag = tag.toLowerCase();
    /* istanbul ignore if */

    if (unknownElementCache[tag] != null) {
      return unknownElementCache[tag];
    }

    var el = document.createElement(tag);

    if (tag.indexOf('-') > -1) {
      // http://stackoverflow.com/a/28210364/1070244
      return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    } else {
      return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
    }
  }

  var isTextInputType = makeMap('text,number,password,search,email,tel,url');
  /*  */

  /**
   * Query an element selector if it's not an element already.
   */

  function query(el) {
    if (typeof el === 'string') {
      var selected = document.querySelector(el);

      if (!selected) {
        warn('Cannot find element: ' + el);
        return document.createElement('div');
      }

      return selected;
    } else {
      return el;
    }
  }
  /*  */


  function createElement$1(tagName, vnode) {
    var elm = document.createElement(tagName);

    if (tagName !== 'select') {
      return elm;
    } // false or null will remove the attribute but undefined will not


    if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
      elm.setAttribute('multiple', 'multiple');
    }

    return elm;
  }

  function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
  }

  function createTextNode(text) {
    return document.createTextNode(text);
  }

  function createComment(text) {
    return document.createComment(text);
  }

  function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
  }

  function removeChild(node, child) {
    node.removeChild(child);
  }

  function appendChild(node, child) {
    node.appendChild(child);
  }

  function parentNode(node) {
    return node.parentNode;
  }

  function nextSibling(node) {
    return node.nextSibling;
  }

  function tagName(node) {
    return node.tagName;
  }

  function setTextContent(node, text) {
    node.textContent = text;
  }

  function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
  }

  var nodeOps = /*#__PURE__*/Object.freeze({
    createElement: createElement$1,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    setStyleScope: setStyleScope
  });
  /*  */

  var ref = {
    create: function create(_, vnode) {
      registerRef(vnode);
    },
    update: function update(oldVnode, vnode) {
      if (oldVnode.data.ref !== vnode.data.ref) {
        registerRef(oldVnode, true);
        registerRef(vnode);
      }
    },
    destroy: function destroy(vnode) {
      registerRef(vnode, true);
    }
  };

  function registerRef(vnode, isRemoval) {
    var key = vnode.data.ref;

    if (!isDef(key)) {
      return;
    }

    var vm = vnode.context;
    var ref = vnode.componentInstance || vnode.elm;
    var refs = vm.$refs;

    if (isRemoval) {
      if (Array.isArray(refs[key])) {
        remove(refs[key], ref);
      } else if (refs[key] === ref) {
        refs[key] = undefined;
      }
    } else {
      if (vnode.data.refInFor) {
        if (!Array.isArray(refs[key])) {
          refs[key] = [ref];
        } else if (refs[key].indexOf(ref) < 0) {
          // $flow-disable-line
          refs[key].push(ref);
        }
      } else {
        refs[key] = ref;
      }
    }
  }
  /**
   * Virtual DOM patching algorithm based on Snabbdom by
   * Simon Friis Vindum (@paldepind)
   * Licensed under the MIT License
   * https://github.com/paldepind/snabbdom/blob/master/LICENSE
   *
   * modified by Evan You (@yyx990803)
   *
   * Not type-checking this because this file is perf-critical and the cost
   * of making flow understand it is not worth it.
   */


  var emptyNode = new VNode('', {}, []);
  var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

  function sameVnode(a, b) {
    return a.key === b.key && a.asyncFactory === b.asyncFactory && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error));
  }

  function sameInputType(a, b) {
    if (a.tag !== 'input') {
      return true;
    }

    var i;
    var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
    var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
    return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
  }

  function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};

    for (i = beginIdx; i <= endIdx; ++i) {
      key = children[i].key;

      if (isDef(key)) {
        map[key] = i;
      }
    }

    return map;
  }

  function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules;
    var nodeOps = backend.nodeOps;

    for (i = 0; i < hooks.length; ++i) {
      cbs[hooks[i]] = [];

      for (j = 0; j < modules.length; ++j) {
        if (isDef(modules[j][hooks[i]])) {
          cbs[hooks[i]].push(modules[j][hooks[i]]);
        }
      }
    }

    function emptyNodeAt(elm) {
      return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }

    function createRmCb(childElm, listeners) {
      function remove$$1() {
        if (--remove$$1.listeners === 0) {
          removeNode(childElm);
        }
      }

      remove$$1.listeners = listeners;
      return remove$$1;
    }

    function removeNode(el) {
      var parent = nodeOps.parentNode(el); // element may have already been removed due to v-html / v-text

      if (isDef(parent)) {
        nodeOps.removeChild(parent, el);
      }
    }

    function isUnknownElement$$1(vnode, inVPre) {
      return !inVPre && !vnode.ns && !(config.ignoredElements.length && config.ignoredElements.some(function (ignore) {
        return isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
      })) && config.isUnknownElement(vnode.tag);
    }

    var creatingElmInVPre = 0;

    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
      if (isDef(vnode.elm) && isDef(ownerArray)) {
        // This vnode was used in a previous render!
        // now it's used as a new node, overwriting its elm would cause
        // potential patch errors down the road when it's used as an insertion
        // reference node. Instead, we clone the node on-demand before creating
        // associated DOM element for it.
        vnode = ownerArray[index] = cloneVNode(vnode);
      }

      vnode.isRootInsert = !nested; // for transition enter check

      if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
        return;
      }

      var data = vnode.data;
      var children = vnode.children;
      var tag = vnode.tag;

      if (isDef(tag)) {
        {
          if (data && data.pre) {
            creatingElmInVPre++;
          }

          if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
            warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.', vnode.context);
          }
        }
        vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
        setScope(vnode);
        /* istanbul ignore if */

        {
          createChildren(vnode, children, insertedVnodeQueue);

          if (isDef(data)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
          }

          insert(parentElm, vnode.elm, refElm);
        }

        if (data && data.pre) {
          creatingElmInVPre--;
        }
      } else if (isTrue(vnode.isComment)) {
        vnode.elm = nodeOps.createComment(vnode.text);
        insert(parentElm, vnode.elm, refElm);
      } else {
        vnode.elm = nodeOps.createTextNode(vnode.text);
        insert(parentElm, vnode.elm, refElm);
      }
    }

    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
      var i = vnode.data;

      if (isDef(i)) {
        var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;

        if (isDef(i = i.hook) && isDef(i = i.init)) {
          i(vnode, false
          /* hydrating */
          );
        } // after calling the init hook, if the vnode is a child component
        // it should've created a child instance and mounted it. the child
        // component also has set the placeholder vnode's elm.
        // in that case we can just return the element and be done.


        if (isDef(vnode.componentInstance)) {
          initComponent(vnode, insertedVnodeQueue);
          insert(parentElm, vnode.elm, refElm);

          if (isTrue(isReactivated)) {
            reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
          }

          return true;
        }
      }
    }

    function initComponent(vnode, insertedVnodeQueue) {
      if (isDef(vnode.data.pendingInsert)) {
        insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
        vnode.data.pendingInsert = null;
      }

      vnode.elm = vnode.componentInstance.$el;

      if (isPatchable(vnode)) {
        invokeCreateHooks(vnode, insertedVnodeQueue);
        setScope(vnode);
      } else {
        // empty component root.
        // skip all element-related modules except for ref (#3455)
        registerRef(vnode); // make sure to invoke the insert hook

        insertedVnodeQueue.push(vnode);
      }
    }

    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
      var i; // hack for #4339: a reactivated component with inner transition
      // does not trigger because the inner node's created hooks are not called
      // again. It's not ideal to involve module-specific logic in here but
      // there doesn't seem to be a better way to do it.

      var innerNode = vnode;

      while (innerNode.componentInstance) {
        innerNode = innerNode.componentInstance._vnode;

        if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
          for (i = 0; i < cbs.activate.length; ++i) {
            cbs.activate[i](emptyNode, innerNode);
          }

          insertedVnodeQueue.push(innerNode);
          break;
        }
      } // unlike a newly created component,
      // a reactivated keep-alive component doesn't insert itself


      insert(parentElm, vnode.elm, refElm);
    }

    function insert(parent, elm, ref$$1) {
      if (isDef(parent)) {
        if (isDef(ref$$1)) {
          if (nodeOps.parentNode(ref$$1) === parent) {
            nodeOps.insertBefore(parent, elm, ref$$1);
          }
        } else {
          nodeOps.appendChild(parent, elm);
        }
      }
    }

    function createChildren(vnode, children, insertedVnodeQueue) {
      if (Array.isArray(children)) {
        {
          checkDuplicateKeys(children);
        }

        for (var i = 0; i < children.length; ++i) {
          createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
        }
      } else if (isPrimitive(vnode.text)) {
        nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
      }
    }

    function isPatchable(vnode) {
      while (vnode.componentInstance) {
        vnode = vnode.componentInstance._vnode;
      }

      return isDef(vnode.tag);
    }

    function invokeCreateHooks(vnode, insertedVnodeQueue) {
      for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
        cbs.create[i$1](emptyNode, vnode);
      }

      i = vnode.data.hook; // Reuse variable

      if (isDef(i)) {
        if (isDef(i.create)) {
          i.create(emptyNode, vnode);
        }

        if (isDef(i.insert)) {
          insertedVnodeQueue.push(vnode);
        }
      }
    } // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.


    function setScope(vnode) {
      var i;

      if (isDef(i = vnode.fnScopeId)) {
        nodeOps.setStyleScope(vnode.elm, i);
      } else {
        var ancestor = vnode;

        while (ancestor) {
          if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
            nodeOps.setStyleScope(vnode.elm, i);
          }

          ancestor = ancestor.parent;
        }
      } // for slot content they should also get the scopeId from the host instance.


      if (isDef(i = activeInstance) && i !== vnode.context && i !== vnode.fnContext && isDef(i = i.$options._scopeId)) {
        nodeOps.setStyleScope(vnode.elm, i);
      }
    }

    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
      for (; startIdx <= endIdx; ++startIdx) {
        createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
      }
    }

    function invokeDestroyHook(vnode) {
      var i, j;
      var data = vnode.data;

      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.destroy)) {
          i(vnode);
        }

        for (i = 0; i < cbs.destroy.length; ++i) {
          cbs.destroy[i](vnode);
        }
      }

      if (isDef(i = vnode.children)) {
        for (j = 0; j < vnode.children.length; ++j) {
          invokeDestroyHook(vnode.children[j]);
        }
      }
    }

    function removeVnodes(vnodes, startIdx, endIdx) {
      for (; startIdx <= endIdx; ++startIdx) {
        var ch = vnodes[startIdx];

        if (isDef(ch)) {
          if (isDef(ch.tag)) {
            removeAndInvokeRemoveHook(ch);
            invokeDestroyHook(ch);
          } else {
            // Text node
            removeNode(ch.elm);
          }
        }
      }
    }

    function removeAndInvokeRemoveHook(vnode, rm) {
      if (isDef(rm) || isDef(vnode.data)) {
        var i;
        var listeners = cbs.remove.length + 1;

        if (isDef(rm)) {
          // we have a recursively passed down rm callback
          // increase the listeners count
          rm.listeners += listeners;
        } else {
          // directly removing
          rm = createRmCb(vnode.elm, listeners);
        } // recursively invoke hooks on child component root node


        if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
          removeAndInvokeRemoveHook(i, rm);
        }

        for (i = 0; i < cbs.remove.length; ++i) {
          cbs.remove[i](vnode, rm);
        }

        if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
          i(vnode, rm);
        } else {
          rm();
        }
      } else {
        removeNode(vnode.elm);
      }
    }

    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
      var oldStartIdx = 0;
      var newStartIdx = 0;
      var oldEndIdx = oldCh.length - 1;
      var oldStartVnode = oldCh[0];
      var oldEndVnode = oldCh[oldEndIdx];
      var newEndIdx = newCh.length - 1;
      var newStartVnode = newCh[0];
      var newEndVnode = newCh[newEndIdx];
      var oldKeyToIdx, idxInOld, vnodeToMove, refElm; // removeOnly is a special flag used only by <transition-group>
      // to ensure removed elements stay in correct relative positions
      // during leaving transitions

      var canMove = !removeOnly;
      {
        checkDuplicateKeys(newCh);
      }

      while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
        if (isUndef(oldStartVnode)) {
          oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
        } else if (isUndef(oldEndVnode)) {
          oldEndVnode = oldCh[--oldEndIdx];
        } else if (sameVnode(oldStartVnode, newStartVnode)) {
          patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
          oldStartVnode = oldCh[++oldStartIdx];
          newStartVnode = newCh[++newStartIdx];
        } else if (sameVnode(oldEndVnode, newEndVnode)) {
          patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
          oldEndVnode = oldCh[--oldEndIdx];
          newEndVnode = newCh[--newEndIdx];
        } else if (sameVnode(oldStartVnode, newEndVnode)) {
          // Vnode moved right
          patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
          canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
          oldStartVnode = oldCh[++oldStartIdx];
          newEndVnode = newCh[--newEndIdx];
        } else if (sameVnode(oldEndVnode, newStartVnode)) {
          // Vnode moved left
          patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
          canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
          oldEndVnode = oldCh[--oldEndIdx];
          newStartVnode = newCh[++newStartIdx];
        } else {
          if (isUndef(oldKeyToIdx)) {
            oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
          }

          idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);

          if (isUndef(idxInOld)) {
            // New element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          } else {
            vnodeToMove = oldCh[idxInOld];

            if (sameVnode(vnodeToMove, newStartVnode)) {
              patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
              oldCh[idxInOld] = undefined;
              canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
            } else {
              // same key but different element. treat as new element
              createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
            }
          }

          newStartVnode = newCh[++newStartIdx];
        }
      }

      if (oldStartIdx > oldEndIdx) {
        refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
        addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
      } else if (newStartIdx > newEndIdx) {
        removeVnodes(oldCh, oldStartIdx, oldEndIdx);
      }
    }

    function checkDuplicateKeys(children) {
      var seenKeys = {};

      for (var i = 0; i < children.length; i++) {
        var vnode = children[i];
        var key = vnode.key;

        if (isDef(key)) {
          if (seenKeys[key]) {
            warn("Duplicate keys detected: '" + key + "'. This may cause an update error.", vnode.context);
          } else {
            seenKeys[key] = true;
          }
        }
      }
    }

    function findIdxInOld(node, oldCh, start, end) {
      for (var i = start; i < end; i++) {
        var c = oldCh[i];

        if (isDef(c) && sameVnode(node, c)) {
          return i;
        }
      }
    }

    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
      if (oldVnode === vnode) {
        return;
      }

      if (isDef(vnode.elm) && isDef(ownerArray)) {
        // clone reused vnode
        vnode = ownerArray[index] = cloneVNode(vnode);
      }

      var elm = vnode.elm = oldVnode.elm;

      if (isTrue(oldVnode.isAsyncPlaceholder)) {
        if (isDef(vnode.asyncFactory.resolved)) {
          hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
        } else {
          vnode.isAsyncPlaceholder = true;
        }

        return;
      } // reuse element for static trees.
      // note we only do this if the vnode is cloned -
      // if the new node is not cloned it means the render functions have been
      // reset by the hot-reload-api and we need to do a proper re-render.


      if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
        vnode.componentInstance = oldVnode.componentInstance;
        return;
      }

      var i;
      var data = vnode.data;

      if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
        i(oldVnode, vnode);
      }

      var oldCh = oldVnode.children;
      var ch = vnode.children;

      if (isDef(data) && isPatchable(vnode)) {
        for (i = 0; i < cbs.update.length; ++i) {
          cbs.update[i](oldVnode, vnode);
        }

        if (isDef(i = data.hook) && isDef(i = i.update)) {
          i(oldVnode, vnode);
        }
      }

      if (isUndef(vnode.text)) {
        if (isDef(oldCh) && isDef(ch)) {
          if (oldCh !== ch) {
            updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
          }
        } else if (isDef(ch)) {
          {
            checkDuplicateKeys(ch);
          }

          if (isDef(oldVnode.text)) {
            nodeOps.setTextContent(elm, '');
          }

          addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
        } else if (isDef(oldCh)) {
          removeVnodes(oldCh, 0, oldCh.length - 1);
        } else if (isDef(oldVnode.text)) {
          nodeOps.setTextContent(elm, '');
        }
      } else if (oldVnode.text !== vnode.text) {
        nodeOps.setTextContent(elm, vnode.text);
      }

      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.postpatch)) {
          i(oldVnode, vnode);
        }
      }
    }

    function invokeInsertHook(vnode, queue, initial) {
      // delay insert hooks for component root nodes, invoke them after the
      // element is really inserted
      if (isTrue(initial) && isDef(vnode.parent)) {
        vnode.parent.data.pendingInsert = queue;
      } else {
        for (var i = 0; i < queue.length; ++i) {
          queue[i].data.hook.insert(queue[i]);
        }
      }
    }

    var hydrationBailed = false; // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).

    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key'); // Note: this is a browser-only function so we can assume elms are DOM nodes.

    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
      var i;
      var tag = vnode.tag;
      var data = vnode.data;
      var children = vnode.children;
      inVPre = inVPre || data && data.pre;
      vnode.elm = elm;

      if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
        vnode.isAsyncPlaceholder = true;
        return true;
      } // assert node match


      {
        if (!assertNodeMatch(elm, vnode, inVPre)) {
          return false;
        }
      }

      if (isDef(data)) {
        if (isDef(i = data.hook) && isDef(i = i.init)) {
          i(vnode, true
          /* hydrating */
          );
        }

        if (isDef(i = vnode.componentInstance)) {
          // child component. it should have hydrated its own tree.
          initComponent(vnode, insertedVnodeQueue);
          return true;
        }
      }

      if (isDef(tag)) {
        if (isDef(children)) {
          // empty element, allow client to pick up and populate children
          if (!elm.hasChildNodes()) {
            createChildren(vnode, children, insertedVnodeQueue);
          } else {
            // v-html and domProps: innerHTML
            if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
              if (i !== elm.innerHTML) {
                /* istanbul ignore if */
                if (typeof console !== 'undefined' && !hydrationBailed) {
                  hydrationBailed = true;
                  console.warn('Parent: ', elm);
                  console.warn('server innerHTML: ', i);
                  console.warn('client innerHTML: ', elm.innerHTML);
                }

                return false;
              }
            } else {
              // iterate and compare children lists
              var childrenMatch = true;
              var childNode = elm.firstChild;

              for (var i$1 = 0; i$1 < children.length; i$1++) {
                if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                  childrenMatch = false;
                  break;
                }

                childNode = childNode.nextSibling;
              } // if childNode is not null, it means the actual childNodes list is
              // longer than the virtual children list.


              if (!childrenMatch || childNode) {
                /* istanbul ignore if */
                if (typeof console !== 'undefined' && !hydrationBailed) {
                  hydrationBailed = true;
                  console.warn('Parent: ', elm);
                  console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                }

                return false;
              }
            }
          }
        }

        if (isDef(data)) {
          var fullInvoke = false;

          for (var key in data) {
            if (!isRenderedModule(key)) {
              fullInvoke = true;
              invokeCreateHooks(vnode, insertedVnodeQueue);
              break;
            }
          }

          if (!fullInvoke && data['class']) {
            // ensure collecting deps for deep class bindings for future updates
            traverse(data['class']);
          }
        }
      } else if (elm.data !== vnode.text) {
        elm.data = vnode.text;
      }

      return true;
    }

    function assertNodeMatch(node, vnode, inVPre) {
      if (isDef(vnode.tag)) {
        return vnode.tag.indexOf('vue-component') === 0 || !isUnknownElement$$1(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
      } else {
        return node.nodeType === (vnode.isComment ? 8 : 3);
      }
    }

    return function patch(oldVnode, vnode, hydrating, removeOnly) {
      if (isUndef(vnode)) {
        if (isDef(oldVnode)) {
          invokeDestroyHook(oldVnode);
        }

        return;
      }

      var isInitialPatch = false;
      var insertedVnodeQueue = [];

      if (isUndef(oldVnode)) {
        // empty mount (likely as component), create new root element
        isInitialPatch = true;
        createElm(vnode, insertedVnodeQueue);
      } else {
        var isRealElement = isDef(oldVnode.nodeType);

        if (!isRealElement && sameVnode(oldVnode, vnode)) {
          // patch existing root node
          patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
        } else {
          if (isRealElement) {
            // mounting to a real element
            // check if this is server-rendered content and if we can perform
            // a successful hydration.
            if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
              oldVnode.removeAttribute(SSR_ATTR);
              hydrating = true;
            }

            if (isTrue(hydrating)) {
              if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                invokeInsertHook(vnode, insertedVnodeQueue, true);
                return oldVnode;
              } else {
                warn('The client-side rendered virtual DOM tree is not matching ' + 'server-rendered content. This is likely caused by incorrect ' + 'HTML markup, for example nesting block-level elements inside ' + '<p>, or missing <tbody>. Bailing hydration and performing ' + 'full client-side render.');
              }
            } // either not server-rendered, or hydration failed.
            // create an empty node and replace it


            oldVnode = emptyNodeAt(oldVnode);
          } // replacing existing element


          var oldElm = oldVnode.elm;
          var parentElm = nodeOps.parentNode(oldElm); // create new node

          createElm(vnode, insertedVnodeQueue, // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm)); // update parent placeholder node element, recursively

          if (isDef(vnode.parent)) {
            var ancestor = vnode.parent;
            var patchable = isPatchable(vnode);

            while (ancestor) {
              for (var i = 0; i < cbs.destroy.length; ++i) {
                cbs.destroy[i](ancestor);
              }

              ancestor.elm = vnode.elm;

              if (patchable) {
                for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                  cbs.create[i$1](emptyNode, ancestor);
                } // #6513
                // invoke insert hooks that may have been merged by create hooks.
                // e.g. for directives that uses the "inserted" hook.


                var insert = ancestor.data.hook.insert;

                if (insert.merged) {
                  // start at index 1 to avoid re-invoking component mounted hook
                  for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                    insert.fns[i$2]();
                  }
                }
              } else {
                registerRef(ancestor);
              }

              ancestor = ancestor.parent;
            }
          } // destroy old node


          if (isDef(parentElm)) {
            removeVnodes([oldVnode], 0, 0);
          } else if (isDef(oldVnode.tag)) {
            invokeDestroyHook(oldVnode);
          }
        }
      }

      invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
      return vnode.elm;
    };
  }
  /*  */


  var directives = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
      updateDirectives(vnode, emptyNode);
    }
  };

  function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
      _update(oldVnode, vnode);
    }
  }

  function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;

    for (key in newDirs) {
      oldDir = oldDirs[key];
      dir = newDirs[key];

      if (!oldDir) {
        // new directive, bind
        callHook$1(dir, 'bind', vnode, oldVnode);

        if (dir.def && dir.def.inserted) {
          dirsWithInsert.push(dir);
        }
      } else {
        // existing directive, update
        dir.oldValue = oldDir.value;
        dir.oldArg = oldDir.arg;
        callHook$1(dir, 'update', vnode, oldVnode);

        if (dir.def && dir.def.componentUpdated) {
          dirsWithPostpatch.push(dir);
        }
      }
    }

    if (dirsWithInsert.length) {
      var callInsert = function () {
        for (var i = 0; i < dirsWithInsert.length; i++) {
          callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
        }
      };

      if (isCreate) {
        mergeVNodeHook(vnode, 'insert', callInsert);
      } else {
        callInsert();
      }
    }

    if (dirsWithPostpatch.length) {
      mergeVNodeHook(vnode, 'postpatch', function () {
        for (var i = 0; i < dirsWithPostpatch.length; i++) {
          callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
        }
      });
    }

    if (!isCreate) {
      for (key in oldDirs) {
        if (!newDirs[key]) {
          // no longer present, unbind
          callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
        }
      }
    }
  }

  var emptyModifiers = Object.create(null);

  function normalizeDirectives$1(dirs, vm) {
    var res = Object.create(null);

    if (!dirs) {
      // $flow-disable-line
      return res;
    }

    var i, dir;

    for (i = 0; i < dirs.length; i++) {
      dir = dirs[i];

      if (!dir.modifiers) {
        // $flow-disable-line
        dir.modifiers = emptyModifiers;
      }

      res[getRawDirName(dir)] = dir;
      dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
    } // $flow-disable-line


    return res;
  }

  function getRawDirName(dir) {
    return dir.rawName || dir.name + "." + Object.keys(dir.modifiers || {}).join('.');
  }

  function callHook$1(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];

    if (fn) {
      try {
        fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
      } catch (e) {
        handleError(e, vnode.context, "directive " + dir.name + " " + hook + " hook");
      }
    }
  }

  var baseModules = [ref, directives];
  /*  */

  function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;

    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
      return;
    }

    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
      return;
    }

    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {}; // clone observed objects, as the user probably wants to mutate it

    if (isDef(attrs.__ob__)) {
      attrs = vnode.data.attrs = extend({}, attrs);
    }

    for (key in attrs) {
      cur = attrs[key];
      old = oldAttrs[key];

      if (old !== cur) {
        setAttr(elm, key, cur, vnode.data.pre);
      }
    } // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max

    /* istanbul ignore if */


    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
      setAttr(elm, 'value', attrs.value);
    }

    for (key in oldAttrs) {
      if (isUndef(attrs[key])) {
        if (isXlink(key)) {
          elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
        } else if (!isEnumeratedAttr(key)) {
          elm.removeAttribute(key);
        }
      }
    }
  }

  function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
      baseSetAttr(el, key, value);
    } else if (isBooleanAttr(key)) {
      // set attribute for blank value
      // e.g. <option disabled>Select one</option>
      if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
      } else {
        // technically allowfullscreen is a boolean attribute for <iframe>,
        // but Flash expects a value of "true" when used on <embed> tag
        value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
        el.setAttribute(key, value);
      }
    } else if (isEnumeratedAttr(key)) {
      el.setAttribute(key, convertEnumeratedValue(key, value));
    } else if (isXlink(key)) {
      if (isFalsyAttrValue(value)) {
        el.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else {
        el.setAttributeNS(xlinkNS, key, value);
      }
    } else {
      baseSetAttr(el, key, value);
    }
  }

  function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.

      /* istanbul ignore if */
      if (isIE && !isIE9 && el.tagName === 'TEXTAREA' && key === 'placeholder' && value !== '' && !el.__ieph) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };

        el.addEventListener('input', blocker); // $flow-disable-line

        el.__ieph = true;
        /* IE placeholder patched */
      }

      el.setAttribute(key, value);
    }
  }

  var attrs = {
    create: updateAttrs,
    update: updateAttrs
  };
  /*  */

  function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;

    if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
      return;
    }

    var cls = genClassForVnode(vnode); // handle transition classes

    var transitionClass = el._transitionClasses;

    if (isDef(transitionClass)) {
      cls = concat(cls, stringifyClass(transitionClass));
    } // set the class


    if (cls !== el._prevClass) {
      el.setAttribute('class', cls);
      el._prevClass = cls;
    }
  }

  var klass = {
    create: updateClass,
    update: updateClass
  };
  /*  */

  var validDivisionCharRE = /[\w).+\-_$\]]/;

  function parseFilters(exp) {
    var inSingle = false;
    var inDouble = false;
    var inTemplateString = false;
    var inRegex = false;
    var curly = 0;
    var square = 0;
    var paren = 0;
    var lastFilterIndex = 0;
    var c, prev, i, expression, filters;

    for (i = 0; i < exp.length; i++) {
      prev = c;
      c = exp.charCodeAt(i);

      if (inSingle) {
        if (c === 0x27 && prev !== 0x5C) {
          inSingle = false;
        }
      } else if (inDouble) {
        if (c === 0x22 && prev !== 0x5C) {
          inDouble = false;
        }
      } else if (inTemplateString) {
        if (c === 0x60 && prev !== 0x5C) {
          inTemplateString = false;
        }
      } else if (inRegex) {
        if (c === 0x2f && prev !== 0x5C) {
          inRegex = false;
        }
      } else if (c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C && exp.charCodeAt(i - 1) !== 0x7C && !curly && !square && !paren) {
        if (expression === undefined) {
          // first filter, end of expression
          lastFilterIndex = i + 1;
          expression = exp.slice(0, i).trim();
        } else {
          pushFilter();
        }
      } else {
        switch (c) {
          case 0x22:
            inDouble = true;
            break;
          // "

          case 0x27:
            inSingle = true;
            break;
          // '

          case 0x60:
            inTemplateString = true;
            break;
          // `

          case 0x28:
            paren++;
            break;
          // (

          case 0x29:
            paren--;
            break;
          // )

          case 0x5B:
            square++;
            break;
          // [

          case 0x5D:
            square--;
            break;
          // ]

          case 0x7B:
            curly++;
            break;
          // {

          case 0x7D:
            curly--;
            break;
          // }
        }

        if (c === 0x2f) {
          // /
          var j = i - 1;
          var p = void 0; // find first non-whitespace prev char

          for (; j >= 0; j--) {
            p = exp.charAt(j);

            if (p !== ' ') {
              break;
            }
          }

          if (!p || !validDivisionCharRE.test(p)) {
            inRegex = true;
          }
        }
      }
    }

    if (expression === undefined) {
      expression = exp.slice(0, i).trim();
    } else if (lastFilterIndex !== 0) {
      pushFilter();
    }

    function pushFilter() {
      (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
      lastFilterIndex = i + 1;
    }

    if (filters) {
      for (i = 0; i < filters.length; i++) {
        expression = wrapFilter(expression, filters[i]);
      }
    }

    return expression;
  }

  function wrapFilter(exp, filter) {
    var i = filter.indexOf('(');

    if (i < 0) {
      // _f: resolveFilter
      return "_f(\"" + filter + "\")(" + exp + ")";
    } else {
      var name = filter.slice(0, i);
      var args = filter.slice(i + 1);
      return "_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args);
    }
  }
  /*  */

  /* eslint-disable no-unused-vars */


  function baseWarn(msg, range) {
    console.error("[Vue compiler]: " + msg);
  }
  /* eslint-enable no-unused-vars */


  function pluckModuleFunction(modules, key) {
    return modules ? modules.map(function (m) {
      return m[key];
    }).filter(function (_) {
      return _;
    }) : [];
  }

  function addProp(el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push(rangeSetItem({
      name: name,
      value: value,
      dynamic: dynamic
    }, range));
    el.plain = false;
  }

  function addAttr(el, name, value, range, dynamic) {
    var attrs = dynamic ? el.dynamicAttrs || (el.dynamicAttrs = []) : el.attrs || (el.attrs = []);
    attrs.push(rangeSetItem({
      name: name,
      value: value,
      dynamic: dynamic
    }, range));
    el.plain = false;
  } // add a raw attr (use this in preTransforms)


  function addRawAttr(el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push(rangeSetItem({
      name: name,
      value: value
    }, range));
  }

  function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
    (el.directives || (el.directives = [])).push(rangeSetItem({
      name: name,
      rawName: rawName,
      value: value,
      arg: arg,
      isDynamicArg: isDynamicArg,
      modifiers: modifiers
    }, range));
    el.plain = false;
  }

  function prependModifierMarker(symbol, name, dynamic) {
    return dynamic ? "_p(" + name + ",\"" + symbol + "\")" : symbol + name; // mark the event as captured
  }

  function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
    modifiers = modifiers || emptyObject; // warn prevent and passive modifier

    /* istanbul ignore if */

    if (warn && modifiers.prevent && modifiers.passive) {
      warn('passive and prevent can\'t be used together. ' + 'Passive handler can\'t prevent default event.', range);
    } // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.


    if (modifiers.right) {
      if (dynamic) {
        name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
      } else if (name === 'click') {
        name = 'contextmenu';
        delete modifiers.right;
      }
    } else if (modifiers.middle) {
      if (dynamic) {
        name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
      } else if (name === 'click') {
        name = 'mouseup';
      }
    } // check capture modifier


    if (modifiers.capture) {
      delete modifiers.capture;
      name = prependModifierMarker('!', name, dynamic);
    }

    if (modifiers.once) {
      delete modifiers.once;
      name = prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */


    if (modifiers.passive) {
      delete modifiers.passive;
      name = prependModifierMarker('&', name, dynamic);
    }

    var events;

    if (modifiers.native) {
      delete modifiers.native;
      events = el.nativeEvents || (el.nativeEvents = {});
    } else {
      events = el.events || (el.events = {});
    }

    var newHandler = rangeSetItem({
      value: value.trim(),
      dynamic: dynamic
    }, range);

    if (modifiers !== emptyObject) {
      newHandler.modifiers = modifiers;
    }

    var handlers = events[name];
    /* istanbul ignore if */

    if (Array.isArray(handlers)) {
      important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    } else if (handlers) {
      events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
    } else {
      events[name] = newHandler;
    }

    el.plain = false;
  }

  function getRawBindingAttr(el, name) {
    return el.rawAttrsMap[':' + name] || el.rawAttrsMap['v-bind:' + name] || el.rawAttrsMap[name];
  }

  function getBindingAttr(el, name, getStatic) {
    var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);

    if (dynamicValue != null) {
      return parseFilters(dynamicValue);
    } else if (getStatic !== false) {
      var staticValue = getAndRemoveAttr(el, name);

      if (staticValue != null) {
        return JSON.stringify(staticValue);
      }
    }
  } // note: this only removes the attr from the Array (attrsList) so that it
  // doesn't get processed by processAttrs.
  // By default it does NOT remove it from the map (attrsMap) because the map is
  // needed during codegen.


  function getAndRemoveAttr(el, name, removeFromMap) {
    var val;

    if ((val = el.attrsMap[name]) != null) {
      var list = el.attrsList;

      for (var i = 0, l = list.length; i < l; i++) {
        if (list[i].name === name) {
          list.splice(i, 1);
          break;
        }
      }
    }

    if (removeFromMap) {
      delete el.attrsMap[name];
    }

    return val;
  }

  function getAndRemoveAttrByRegex(el, name) {
    var list = el.attrsList;

    for (var i = 0, l = list.length; i < l; i++) {
      var attr = list[i];

      if (name.test(attr.name)) {
        list.splice(i, 1);
        return attr;
      }
    }
  }

  function rangeSetItem(item, range) {
    if (range) {
      if (range.start != null) {
        item.start = range.start;
      }

      if (range.end != null) {
        item.end = range.end;
      }
    }

    return item;
  }
  /*  */

  /**
   * Cross-platform code generation for component v-model
   */


  function genComponentModel(el, value, modifiers) {
    var ref = modifiers || {};
    var number = ref.number;
    var trim = ref.trim;
    var baseValueExpression = '$$v';
    var valueExpression = baseValueExpression;

    if (trim) {
      valueExpression = "(typeof " + baseValueExpression + " === 'string'" + "? " + baseValueExpression + ".trim()" + ": " + baseValueExpression + ")";
    }

    if (number) {
      valueExpression = "_n(" + valueExpression + ")";
    }

    var assignment = genAssignmentCode(value, valueExpression);
    el.model = {
      value: "(" + value + ")",
      expression: JSON.stringify(value),
      callback: "function (" + baseValueExpression + ") {" + assignment + "}"
    };
  }
  /**
   * Cross-platform codegen helper for generating v-model value assignment code.
   */


  function genAssignmentCode(value, assignment) {
    var res = parseModel(value);

    if (res.key === null) {
      return value + "=" + assignment;
    } else {
      return "$set(" + res.exp + ", " + res.key + ", " + assignment + ")";
    }
  }
  /**
   * Parse a v-model expression into a base path and a final key segment.
   * Handles both dot-path and possible square brackets.
   *
   * Possible cases:
   *
   * - test
   * - test[key]
   * - test[test1[key]]
   * - test["a"][key]
   * - xxx.test[a[a].test1[key]]
   * - test.xxx.a["asa"][test1[key]]
   *
   */


  var len, str, chr, index$1, expressionPos, expressionEndPos;

  function parseModel(val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    len = val.length;

    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
      index$1 = val.lastIndexOf('.');

      if (index$1 > -1) {
        return {
          exp: val.slice(0, index$1),
          key: '"' + val.slice(index$1 + 1) + '"'
        };
      } else {
        return {
          exp: val,
          key: null
        };
      }
    }

    str = val;
    index$1 = expressionPos = expressionEndPos = 0;

    while (!eof()) {
      chr = next();
      /* istanbul ignore if */

      if (isStringStart(chr)) {
        parseString(chr);
      } else if (chr === 0x5B) {
        parseBracket(chr);
      }
    }

    return {
      exp: val.slice(0, expressionPos),
      key: val.slice(expressionPos + 1, expressionEndPos)
    };
  }

  function next() {
    return str.charCodeAt(++index$1);
  }

  function eof() {
    return index$1 >= len;
  }

  function isStringStart(chr) {
    return chr === 0x22 || chr === 0x27;
  }

  function parseBracket(chr) {
    var inBracket = 1;
    expressionPos = index$1;

    while (!eof()) {
      chr = next();

      if (isStringStart(chr)) {
        parseString(chr);
        continue;
      }

      if (chr === 0x5B) {
        inBracket++;
      }

      if (chr === 0x5D) {
        inBracket--;
      }

      if (inBracket === 0) {
        expressionEndPos = index$1;
        break;
      }
    }
  }

  function parseString(chr) {
    var stringQuote = chr;

    while (!eof()) {
      chr = next();

      if (chr === stringQuote) {
        break;
      }
    }
  }
  /*  */


  var warn$1; // in some cases, the event used has to be determined at runtime
  // so we used some reserved tokens during compile.

  var RANGE_TOKEN = '__r';
  var CHECKBOX_RADIO_TOKEN = '__c';

  function model(el, dir, _warn) {
    warn$1 = _warn;
    var value = dir.value;
    var modifiers = dir.modifiers;
    var tag = el.tag;
    var type = el.attrsMap.type;
    {
      // inputs with type="file" are read only and setting the input's
      // value will throw an error.
      if (tag === 'input' && type === 'file') {
        warn$1("<" + el.tag + " v-model=\"" + value + "\" type=\"file\">:\n" + "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
      }
    }

    if (el.component) {
      genComponentModel(el, value, modifiers); // component v-model doesn't need extra runtime

      return false;
    } else if (tag === 'select') {
      genSelect(el, value, modifiers);
    } else if (tag === 'input' && type === 'checkbox') {
      genCheckboxModel(el, value, modifiers);
    } else if (tag === 'input' && type === 'radio') {
      genRadioModel(el, value, modifiers);
    } else if (tag === 'input' || tag === 'textarea') {
      genDefaultModel(el, value, modifiers);
    } else if (!config.isReservedTag(tag)) {
      genComponentModel(el, value, modifiers); // component v-model doesn't need extra runtime

      return false;
    } else {
      warn$1("<" + el.tag + " v-model=\"" + value + "\">: " + "v-model is not supported on this element type. " + 'If you are working with contenteditable, it\'s recommended to ' + 'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
    } // ensure runtime directive metadata


    return true;
  }

  function genCheckboxModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
    var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
    addProp(el, 'checked', "Array.isArray(" + value + ")" + "?_i(" + value + "," + valueBinding + ")>-1" + (trueValueBinding === 'true' ? ":(" + value + ")" : ":_q(" + value + "," + trueValueBinding + ")"));
    addHandler(el, 'change', "var $$a=" + value + "," + '$$el=$event.target,' + "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" + 'if(Array.isArray($$a)){' + "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," + '$$i=_i($$a,$$v);' + "if($$el.checked){$$i<0&&(" + genAssignmentCode(value, '$$a.concat([$$v])') + ")}" + "else{$$i>-1&&(" + genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))') + ")}" + "}else{" + genAssignmentCode(value, '$$c') + "}", null, true);
  }

  function genRadioModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? "_n(" + valueBinding + ")" : valueBinding;
    addProp(el, 'checked', "_q(" + value + "," + valueBinding + ")");
    addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
  }

  function genSelect(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var selectedVal = "Array.prototype.filter" + ".call($event.target.options,function(o){return o.selected})" + ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" + "return " + (number ? '_n(val)' : 'val') + "})";
    var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    var code = "var $$selectedVal = " + selectedVal + ";";
    code = code + " " + genAssignmentCode(value, assignment);
    addHandler(el, 'change', code, null, true);
  }

  function genDefaultModel(el, value, modifiers) {
    var type = el.attrsMap.type; // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type

    {
      var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
      var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];

      if (value$1 && !typeBinding) {
        var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
        warn$1(binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " + 'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
      }
    }
    var ref = modifiers || {};
    var lazy = ref.lazy;
    var number = ref.number;
    var trim = ref.trim;
    var needCompositionGuard = !lazy && type !== 'range';
    var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';
    var valueExpression = '$event.target.value';

    if (trim) {
      valueExpression = "$event.target.value.trim()";
    }

    if (number) {
      valueExpression = "_n(" + valueExpression + ")";
    }

    var code = genAssignmentCode(value, valueExpression);

    if (needCompositionGuard) {
      code = "if($event.target.composing)return;" + code;
    }

    addProp(el, 'value', "(" + value + ")");
    addHandler(el, event, code, null, true);

    if (trim || number) {
      addHandler(el, 'blur', '$forceUpdate()');
    }
  }
  /*  */
  // normalize v-model event tokens that can only be determined at runtime.
  // it's important to place the event as the first in the array because
  // the whole point is ensuring the v-model callback gets called before
  // user-attached handlers.


  function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
      // IE input[type=range] only supports `change` event
      var event = isIE ? 'change' : 'input';
      on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
      delete on[RANGE_TOKEN];
    } // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4

    /* istanbul ignore if */


    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
      on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
      delete on[CHECKBOX_RADIO_TOKEN];
    }
  }

  var target$1;

  function createOnceHandler$1(event, handler, capture) {
    var _target = target$1; // save current target element in closure

    return function onceHandler() {
      var res = handler.apply(null, arguments);

      if (res !== null) {
        remove$2(event, onceHandler, capture, _target);
      }
    };
  } // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
  // implementation and does not fire microtasks in between event propagation, so
  // safe to exclude.


  var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

  function add$1(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
      var attachedTimestamp = currentFlushTimestamp;
      var original = handler;

      handler = original._wrapper = function (e) {
        if ( // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget || // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp || // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 || // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document) {
          return original.apply(this, arguments);
        }
      };
    }

    target$1.addEventListener(name, handler, supportsPassive ? {
      capture: capture,
      passive: passive
    } : capture);
  }

  function remove$2(name, handler, capture, _target) {
    (_target || target$1).removeEventListener(name, handler._wrapper || handler, capture);
  }

  function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
      return;
    }

    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    target$1 = vnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
    target$1 = undefined;
  }

  var events = {
    create: updateDOMListeners,
    update: updateDOMListeners
  };
  /*  */

  var svgContainer;

  function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
      return;
    }

    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {}; // clone observed objects, as the user probably wants to mutate it

    if (isDef(props.__ob__)) {
      props = vnode.data.domProps = extend({}, props);
    }

    for (key in oldProps) {
      if (!(key in props)) {
        elm[key] = '';
      }
    }

    for (key in props) {
      cur = props[key]; // ignore children if the node has textContent or innerHTML,
      // as these will throw away existing DOM nodes and cause removal errors
      // on subsequent patches (#3360)

      if (key === 'textContent' || key === 'innerHTML') {
        if (vnode.children) {
          vnode.children.length = 0;
        }

        if (cur === oldProps[key]) {
          continue;
        } // #6601 work around Chrome version <= 55 bug where single textNode
        // replaced by innerHTML/textContent retains its parentNode property


        if (elm.childNodes.length === 1) {
          elm.removeChild(elm.childNodes[0]);
        }
      }

      if (key === 'value' && elm.tagName !== 'PROGRESS') {
        // store value as _value as well since
        // non-string values will be stringified
        elm._value = cur; // avoid resetting cursor position when value is the same

        var strCur = isUndef(cur) ? '' : String(cur);

        if (shouldUpdateValue(elm, strCur)) {
          elm.value = strCur;
        }
      } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
        // IE doesn't support innerHTML for SVG elements
        svgContainer = svgContainer || document.createElement('div');
        svgContainer.innerHTML = "<svg>" + cur + "</svg>";
        var svg = svgContainer.firstChild;

        while (elm.firstChild) {
          elm.removeChild(elm.firstChild);
        }

        while (svg.firstChild) {
          elm.appendChild(svg.firstChild);
        }
      } else if ( // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]) {
        // some property updates can throw
        // e.g. `value` on <progress> w/ non-finite value
        try {
          elm[key] = cur;
        } catch (e) {}
      }
    }
  } // check platforms/web/util/attrs.js acceptValue


  function shouldUpdateValue(elm, checkVal) {
    return !elm.composing && (elm.tagName === 'OPTION' || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal));
  }

  function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true; // #6157
    // work around IE bug when accessing document.activeElement in an iframe

    try {
      notInFocus = document.activeElement !== elm;
    } catch (e) {}

    return notInFocus && elm.value !== checkVal;
  }

  function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime

    if (isDef(modifiers)) {
      if (modifiers.number) {
        return toNumber(value) !== toNumber(newVal);
      }

      if (modifiers.trim) {
        return value.trim() !== newVal.trim();
      }
    }

    return value !== newVal;
  }

  var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
  };
  /*  */

  var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
      if (item) {
        var tmp = item.split(propertyDelimiter);
        tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
      }
    });
    return res;
  }); // merge static and dynamic style data on the same vnode

  function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style); // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it

    return data.staticStyle ? extend(data.staticStyle, style) : style;
  } // normalize possible array / string values into Object


  function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
      return toObject(bindingStyle);
    }

    if (typeof bindingStyle === 'string') {
      return parseStyleText(bindingStyle);
    }

    return bindingStyle;
  }
  /**
   * parent component style should be after child's
   * so that parent component's style could override it
   */


  function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;

    if (checkChild) {
      var childNode = vnode;

      while (childNode.componentInstance) {
        childNode = childNode.componentInstance._vnode;

        if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
          extend(res, styleData);
        }
      }
    }

    if (styleData = normalizeStyleData(vnode.data)) {
      extend(res, styleData);
    }

    var parentNode = vnode;

    while (parentNode = parentNode.parent) {
      if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
        extend(res, styleData);
      }
    }

    return res;
  }
  /*  */


  var cssVarRE = /^--/;
  var importantRE = /\s*!important$/;

  var setProp = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
      el.style.setProperty(name, val);
    } else if (importantRE.test(val)) {
      el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    } else {
      var normalizedName = normalize(name);

      if (Array.isArray(val)) {
        // Support values array created by autoprefixer, e.g.
        // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
        // Set them one by one, and the browser will only set those it can recognize
        for (var i = 0, len = val.length; i < len; i++) {
          el.style[normalizedName] = val[i];
        }
      } else {
        el.style[normalizedName] = val;
      }
    }
  };

  var vendorNames = ['Webkit', 'Moz', 'ms'];
  var emptyStyle;
  var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);

    if (prop !== 'filter' && prop in emptyStyle) {
      return prop;
    }

    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);

    for (var i = 0; i < vendorNames.length; i++) {
      var name = vendorNames[i] + capName;

      if (name in emptyStyle) {
        return name;
      }
    }
  });

  function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;

    if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
      return;
    }

    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {}; // if static style exists, stylebinding already merged into it when doing normalizeStyleData

    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {}; // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.

    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);

    for (name in oldStyle) {
      if (isUndef(newStyle[name])) {
        setProp(el, name, '');
      }
    }

    for (name in newStyle) {
      cur = newStyle[name];

      if (cur !== oldStyle[name]) {
        // ie9 setting to null has no effect, must use empty string
        setProp(el, name, cur == null ? '' : cur);
      }
    }
  }

  var style = {
    create: updateStyle,
    update: updateStyle
  };
  /*  */

  var whitespaceRE = /\s+/;
  /**
   * Add class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */

  function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
      return;
    }
    /* istanbul ignore else */


    if (el.classList) {
      if (cls.indexOf(' ') > -1) {
        cls.split(whitespaceRE).forEach(function (c) {
          return el.classList.add(c);
        });
      } else {
        el.classList.add(cls);
      }
    } else {
      var cur = " " + (el.getAttribute('class') || '') + " ";

      if (cur.indexOf(' ' + cls + ' ') < 0) {
        el.setAttribute('class', (cur + cls).trim());
      }
    }
  }
  /**
   * Remove class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */


  function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
      return;
    }
    /* istanbul ignore else */


    if (el.classList) {
      if (cls.indexOf(' ') > -1) {
        cls.split(whitespaceRE).forEach(function (c) {
          return el.classList.remove(c);
        });
      } else {
        el.classList.remove(cls);
      }

      if (!el.classList.length) {
        el.removeAttribute('class');
      }
    } else {
      var cur = " " + (el.getAttribute('class') || '') + " ";
      var tar = ' ' + cls + ' ';

      while (cur.indexOf(tar) >= 0) {
        cur = cur.replace(tar, ' ');
      }

      cur = cur.trim();

      if (cur) {
        el.setAttribute('class', cur);
      } else {
        el.removeAttribute('class');
      }
    }
  }
  /*  */


  function resolveTransition(def$$1) {
    if (!def$$1) {
      return;
    }
    /* istanbul ignore else */


    if (typeof def$$1 === 'object') {
      var res = {};

      if (def$$1.css !== false) {
        extend(res, autoCssTransition(def$$1.name || 'v'));
      }

      extend(res, def$$1);
      return res;
    } else if (typeof def$$1 === 'string') {
      return autoCssTransition(def$$1);
    }
  }

  var autoCssTransition = cached(function (name) {
    return {
      enterClass: name + "-enter",
      enterToClass: name + "-enter-to",
      enterActiveClass: name + "-enter-active",
      leaveClass: name + "-leave",
      leaveToClass: name + "-leave-to",
      leaveActiveClass: name + "-leave-active"
    };
  });
  var hasTransition = inBrowser && !isIE9;
  var TRANSITION = 'transition';
  var ANIMATION = 'animation'; // Transition property/event sniffing

  var transitionProp = 'transition';
  var transitionEndEvent = 'transitionend';
  var animationProp = 'animation';
  var animationEndEvent = 'animationend';

  if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
      transitionProp = 'WebkitTransition';
      transitionEndEvent = 'webkitTransitionEnd';
    }

    if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
      animationProp = 'WebkitAnimation';
      animationEndEvent = 'webkitAnimationEnd';
    }
  } // binding to window is necessary to make hot reload work in IE in strict mode


  var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout :
  /* istanbul ignore next */
  function (fn) {
    return fn();
  };

  function nextFrame(fn) {
    raf(function () {
      raf(fn);
    });
  }

  function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);

    if (transitionClasses.indexOf(cls) < 0) {
      transitionClasses.push(cls);
      addClass(el, cls);
    }
  }

  function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
      remove(el._transitionClasses, cls);
    }

    removeClass(el, cls);
  }

  function whenTransitionEnds(el, expectedType, cb) {
    var ref = getTransitionInfo(el, expectedType);
    var type = ref.type;
    var timeout = ref.timeout;
    var propCount = ref.propCount;

    if (!type) {
      return cb();
    }

    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;

    var end = function () {
      el.removeEventListener(event, onEnd);
      cb();
    };

    var onEnd = function (e) {
      if (e.target === el) {
        if (++ended >= propCount) {
          end();
        }
      }
    };

    setTimeout(function () {
      if (ended < propCount) {
        end();
      }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
  }

  var transformRE = /\b(transform|all)(,|$)/;

  function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el); // JSDOM may return undefined for transition properties

    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */

    if (expectedType === TRANSITION) {
      if (transitionTimeout > 0) {
        type = TRANSITION;
        timeout = transitionTimeout;
        propCount = transitionDurations.length;
      }
    } else if (expectedType === ANIMATION) {
      if (animationTimeout > 0) {
        type = ANIMATION;
        timeout = animationTimeout;
        propCount = animationDurations.length;
      }
    } else {
      timeout = Math.max(transitionTimeout, animationTimeout);
      type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
      propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }

    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
      type: type,
      timeout: timeout,
      propCount: propCount,
      hasTransform: hasTransform
    };
  }

  function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
      delays = delays.concat(delays);
    }

    return Math.max.apply(null, durations.map(function (d, i) {
      return toMs(d) + toMs(delays[i]);
    }));
  } // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
  // in a locale-dependent way, using a comma instead of a dot.
  // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
  // as a floor function) causing unexpected behaviors


  function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
  }
  /*  */


  function enter(vnode, toggleDisplay) {
    var el = vnode.elm; // call leave callback now

    if (isDef(el._leaveCb)) {
      el._leaveCb.cancelled = true;

      el._leaveCb();
    }

    var data = resolveTransition(vnode.data.transition);

    if (isUndef(data)) {
      return;
    }
    /* istanbul ignore if */


    if (isDef(el._enterCb) || el.nodeType !== 1) {
      return;
    }

    var css = data.css;
    var type = data.type;
    var enterClass = data.enterClass;
    var enterToClass = data.enterToClass;
    var enterActiveClass = data.enterActiveClass;
    var appearClass = data.appearClass;
    var appearToClass = data.appearToClass;
    var appearActiveClass = data.appearActiveClass;
    var beforeEnter = data.beforeEnter;
    var enter = data.enter;
    var afterEnter = data.afterEnter;
    var enterCancelled = data.enterCancelled;
    var beforeAppear = data.beforeAppear;
    var appear = data.appear;
    var afterAppear = data.afterAppear;
    var appearCancelled = data.appearCancelled;
    var duration = data.duration; // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.

    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;

    while (transitionNode && transitionNode.parent) {
      context = transitionNode.context;
      transitionNode = transitionNode.parent;
    }

    var isAppear = !context._isMounted || !vnode.isRootInsert;

    if (isAppear && !appear && appear !== '') {
      return;
    }

    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? typeof appear === 'function' ? appear : enter : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);

    if (explicitEnterDuration != null) {
      checkDuration(explicitEnterDuration, 'enter', vnode);
    }

    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = el._enterCb = once(function () {
      if (expectsCSS) {
        removeTransitionClass(el, toClass);
        removeTransitionClass(el, activeClass);
      }

      if (cb.cancelled) {
        if (expectsCSS) {
          removeTransitionClass(el, startClass);
        }

        enterCancelledHook && enterCancelledHook(el);
      } else {
        afterEnterHook && afterEnterHook(el);
      }

      el._enterCb = null;
    });

    if (!vnode.data.show) {
      // remove pending leave element on enter by injecting an insert hook
      mergeVNodeHook(vnode, 'insert', function () {
        var parent = el.parentNode;
        var pendingNode = parent && parent._pending && parent._pending[vnode.key];

        if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
          pendingNode.elm._leaveCb();
        }

        enterHook && enterHook(el, cb);
      });
    } // start enter transition


    beforeEnterHook && beforeEnterHook(el);

    if (expectsCSS) {
      addTransitionClass(el, startClass);
      addTransitionClass(el, activeClass);
      nextFrame(function () {
        removeTransitionClass(el, startClass);

        if (!cb.cancelled) {
          addTransitionClass(el, toClass);

          if (!userWantsControl) {
            if (isValidDuration(explicitEnterDuration)) {
              setTimeout(cb, explicitEnterDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }

    if (vnode.data.show) {
      toggleDisplay && toggleDisplay();
      enterHook && enterHook(el, cb);
    }

    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }

  function leave(vnode, rm) {
    var el = vnode.elm; // call enter callback now

    if (isDef(el._enterCb)) {
      el._enterCb.cancelled = true;

      el._enterCb();
    }

    var data = resolveTransition(vnode.data.transition);

    if (isUndef(data) || el.nodeType !== 1) {
      return rm();
    }
    /* istanbul ignore if */


    if (isDef(el._leaveCb)) {
      return;
    }

    var css = data.css;
    var type = data.type;
    var leaveClass = data.leaveClass;
    var leaveToClass = data.leaveToClass;
    var leaveActiveClass = data.leaveActiveClass;
    var beforeLeave = data.beforeLeave;
    var leave = data.leave;
    var afterLeave = data.afterLeave;
    var leaveCancelled = data.leaveCancelled;
    var delayLeave = data.delayLeave;
    var duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);

    if (isDef(explicitLeaveDuration)) {
      checkDuration(explicitLeaveDuration, 'leave', vnode);
    }

    var cb = el._leaveCb = once(function () {
      if (el.parentNode && el.parentNode._pending) {
        el.parentNode._pending[vnode.key] = null;
      }

      if (expectsCSS) {
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
      }

      if (cb.cancelled) {
        if (expectsCSS) {
          removeTransitionClass(el, leaveClass);
        }

        leaveCancelled && leaveCancelled(el);
      } else {
        rm();
        afterLeave && afterLeave(el);
      }

      el._leaveCb = null;
    });

    if (delayLeave) {
      delayLeave(performLeave);
    } else {
      performLeave();
    }

    function performLeave() {
      // the delayed leave may have already been cancelled
      if (cb.cancelled) {
        return;
      } // record leaving element


      if (!vnode.data.show && el.parentNode) {
        (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
      }

      beforeLeave && beforeLeave(el);

      if (expectsCSS) {
        addTransitionClass(el, leaveClass);
        addTransitionClass(el, leaveActiveClass);
        nextFrame(function () {
          removeTransitionClass(el, leaveClass);

          if (!cb.cancelled) {
            addTransitionClass(el, leaveToClass);

            if (!userWantsControl) {
              if (isValidDuration(explicitLeaveDuration)) {
                setTimeout(cb, explicitLeaveDuration);
              } else {
                whenTransitionEnds(el, type, cb);
              }
            }
          }
        });
      }

      leave && leave(el, cb);

      if (!expectsCSS && !userWantsControl) {
        cb();
      }
    }
  } // only used in dev mode


  function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
      warn("<transition> explicit " + name + " duration is not a valid number - " + "got " + JSON.stringify(val) + ".", vnode.context);
    } else if (isNaN(val)) {
      warn("<transition> explicit " + name + " duration is NaN - " + 'the duration expression might be incorrect.', vnode.context);
    }
  }

  function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
  }
  /**
   * Normalize a transition hook's argument length. The hook may be:
   * - a merged hook (invoker) with the original in .fns
   * - a wrapped component method (check ._length)
   * - a plain function (.length)
   */


  function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
      return false;
    }

    var invokerFns = fn.fns;

    if (isDef(invokerFns)) {
      // invoker
      return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    } else {
      return (fn._length || fn.length) > 1;
    }
  }

  function _enter(_, vnode) {
    if (vnode.data.show !== true) {
      enter(vnode);
    }
  }

  var transition = inBrowser ? {
    create: _enter,
    activate: _enter,
    remove: function remove$$1(vnode, rm) {
      /* istanbul ignore else */
      if (vnode.data.show !== true) {
        leave(vnode, rm);
      } else {
        rm();
      }
    }
  } : {};
  var platformModules = [attrs, klass, events, domProps, style, transition];
  /*  */
  // the directive module should be applied last, after all
  // built-in modules have been applied.

  var modules = platformModules.concat(baseModules);
  var patch = createPatchFunction({
    nodeOps: nodeOps,
    modules: modules
  });
  /**
   * Not type checking this file because flow doesn't like attaching
   * properties to Elements.
   */

  /* istanbul ignore if */

  if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
      var el = document.activeElement;

      if (el && el.vmodel) {
        trigger(el, 'input');
      }
    });
  }

  var directive = {
    inserted: function inserted(el, binding, vnode, oldVnode) {
      if (vnode.tag === 'select') {
        // #6903
        if (oldVnode.elm && !oldVnode.elm._vOptions) {
          mergeVNodeHook(vnode, 'postpatch', function () {
            directive.componentUpdated(el, binding, vnode);
          });
        } else {
          setSelected(el, binding, vnode.context);
        }

        el._vOptions = [].map.call(el.options, getValue);
      } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
        el._vModifiers = binding.modifiers;

        if (!binding.modifiers.lazy) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd); // Safari < 10.2 & UIWebView doesn't fire compositionend when
          // switching focus before confirming composition choice
          // this also fixes the issue where some browsers e.g. iOS Chrome
          // fires "change" instead of "input" on autocomplete.

          el.addEventListener('change', onCompositionEnd);
          /* istanbul ignore if */

          if (isIE9) {
            el.vmodel = true;
          }
        }
      }
    },
    componentUpdated: function componentUpdated(el, binding, vnode) {
      if (vnode.tag === 'select') {
        setSelected(el, binding, vnode.context); // in case the options rendered by v-for have changed,
        // it's possible that the value is out-of-sync with the rendered options.
        // detect such cases and filter out values that no longer has a matching
        // option in the DOM.

        var prevOptions = el._vOptions;
        var curOptions = el._vOptions = [].map.call(el.options, getValue);

        if (curOptions.some(function (o, i) {
          return !looseEqual(o, prevOptions[i]);
        })) {
          // trigger change event if
          // no matching option found for at least one value
          var needReset = el.multiple ? binding.value.some(function (v) {
            return hasNoMatchingOption(v, curOptions);
          }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);

          if (needReset) {
            trigger(el, 'change');
          }
        }
      }
    }
  };

  function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */

    if (isIE || isEdge) {
      setTimeout(function () {
        actuallySetSelected(el, binding, vm);
      }, 0);
    }
  }

  function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;

    if (isMultiple && !Array.isArray(value)) {
      warn("<select multiple v-model=\"" + binding.expression + "\"> " + "expects an Array value for its binding, but got " + Object.prototype.toString.call(value).slice(8, -1), vm);
      return;
    }

    var selected, option;

    for (var i = 0, l = el.options.length; i < l; i++) {
      option = el.options[i];

      if (isMultiple) {
        selected = looseIndexOf(value, getValue(option)) > -1;

        if (option.selected !== selected) {
          option.selected = selected;
        }
      } else {
        if (looseEqual(getValue(option), value)) {
          if (el.selectedIndex !== i) {
            el.selectedIndex = i;
          }

          return;
        }
      }
    }

    if (!isMultiple) {
      el.selectedIndex = -1;
    }
  }

  function hasNoMatchingOption(value, options) {
    return options.every(function (o) {
      return !looseEqual(o, value);
    });
  }

  function getValue(option) {
    return '_value' in option ? option._value : option.value;
  }

  function onCompositionStart(e) {
    e.target.composing = true;
  }

  function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing) {
      return;
    }

    e.target.composing = false;
    trigger(e.target, 'input');
  }

  function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
  }
  /*  */
  // recursively search for possible transition defined inside the component root


  function locateNode(vnode) {
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
  }

  var show = {
    bind: function bind(el, ref, vnode) {
      var value = ref.value;
      vnode = locateNode(vnode);
      var transition$$1 = vnode.data && vnode.data.transition;
      var originalDisplay = el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display;

      if (value && transition$$1) {
        vnode.data.show = true;
        enter(vnode, function () {
          el.style.display = originalDisplay;
        });
      } else {
        el.style.display = value ? originalDisplay : 'none';
      }
    },
    update: function update(el, ref, vnode) {
      var value = ref.value;
      var oldValue = ref.oldValue;
      /* istanbul ignore if */

      if (!value === !oldValue) {
        return;
      }

      vnode = locateNode(vnode);
      var transition$$1 = vnode.data && vnode.data.transition;

      if (transition$$1) {
        vnode.data.show = true;

        if (value) {
          enter(vnode, function () {
            el.style.display = el.__vOriginalDisplay;
          });
        } else {
          leave(vnode, function () {
            el.style.display = 'none';
          });
        }
      } else {
        el.style.display = value ? el.__vOriginalDisplay : 'none';
      }
    },
    unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
      if (!isDestroy) {
        el.style.display = el.__vOriginalDisplay;
      }
    }
  };
  var platformDirectives = {
    model: directive,
    show: show
  };
  /*  */

  var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
  }; // in case the child is also an abstract component, e.g. <keep-alive>
  // we want to recursively retrieve the real component to be rendered

  function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;

    if (compOptions && compOptions.Ctor.options.abstract) {
      return getRealChild(getFirstComponentChild(compOptions.children));
    } else {
      return vnode;
    }
  }

  function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options; // props

    for (var key in options.propsData) {
      data[key] = comp[key];
    } // events.
    // extract listeners and pass them directly to the transition methods


    var listeners = options._parentListeners;

    for (var key$1 in listeners) {
      data[camelize(key$1)] = listeners[key$1];
    }

    return data;
  }

  function placeholder(h, rawChild) {
    if (/\d-keep-alive$/.test(rawChild.tag)) {
      return h('keep-alive', {
        props: rawChild.componentOptions.propsData
      });
    }
  }

  function hasParentTransition(vnode) {
    while (vnode = vnode.parent) {
      if (vnode.data.transition) {
        return true;
      }
    }
  }

  function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
  }

  var isNotTextNode = function (c) {
    return c.tag || isAsyncPlaceholder(c);
  };

  var isVShowDirective = function (d) {
    return d.name === 'show';
  };

  var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function render(h) {
      var this$1 = this;
      var children = this.$slots.default;

      if (!children) {
        return;
      } // filter out text nodes (possible whitespaces)


      children = children.filter(isNotTextNode);
      /* istanbul ignore if */

      if (!children.length) {
        return;
      } // warn multiple elements


      if (children.length > 1) {
        warn('<transition> can only be used on a single element. Use ' + '<transition-group> for lists.', this.$parent);
      }

      var mode = this.mode; // warn invalid mode

      if (mode && mode !== 'in-out' && mode !== 'out-in') {
        warn('invalid <transition> mode: ' + mode, this.$parent);
      }

      var rawChild = children[0]; // if this is a component root node and the component's
      // parent container node also has transition, skip.

      if (hasParentTransition(this.$vnode)) {
        return rawChild;
      } // apply transition data to child
      // use getRealChild() to ignore abstract components e.g. keep-alive


      var child = getRealChild(rawChild);
      /* istanbul ignore if */

      if (!child) {
        return rawChild;
      }

      if (this._leaving) {
        return placeholder(h, rawChild);
      } // ensure a key that is unique to the vnode type and to this transition
      // component instance. This key will be used to remove pending leaving nodes
      // during entering.


      var id = "__transition-" + this._uid + "-";
      child.key = child.key == null ? child.isComment ? id + 'comment' : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;
      var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
      var oldRawChild = this._vnode;
      var oldChild = getRealChild(oldRawChild); // mark v-show
      // so that the transition module can hand over the control to the directive

      if (child.data.directives && child.data.directives.some(isVShowDirective)) {
        child.data.show = true;
      }

      if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) && // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
        // replace old child transition data with fresh one
        // important for dynamic transitions!
        var oldData = oldChild.data.transition = extend({}, data); // handle transition mode

        if (mode === 'out-in') {
          // return placeholder node and queue update when leave finishes
          this._leaving = true;
          mergeVNodeHook(oldData, 'afterLeave', function () {
            this$1._leaving = false;
            this$1.$forceUpdate();
          });
          return placeholder(h, rawChild);
        } else if (mode === 'in-out') {
          if (isAsyncPlaceholder(child)) {
            return oldRawChild;
          }

          var delayedLeave;

          var performLeave = function () {
            delayedLeave();
          };

          mergeVNodeHook(data, 'afterEnter', performLeave);
          mergeVNodeHook(data, 'enterCancelled', performLeave);
          mergeVNodeHook(oldData, 'delayLeave', function (leave) {
            delayedLeave = leave;
          });
        }
      }

      return rawChild;
    }
  };
  /*  */

  var props = extend({
    tag: String,
    moveClass: String
  }, transitionProps);
  delete props.mode;
  var TransitionGroup = {
    props: props,
    beforeMount: function beforeMount() {
      var this$1 = this;
      var update = this._update;

      this._update = function (vnode, hydrating) {
        var restoreActiveInstance = setActiveInstance(this$1); // force removing pass

        this$1.__patch__(this$1._vnode, this$1.kept, false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
        );

        this$1._vnode = this$1.kept;
        restoreActiveInstance();
        update.call(this$1, vnode, hydrating);
      };
    },
    render: function render(h) {
      var tag = this.tag || this.$vnode.data.tag || 'span';
      var map = Object.create(null);
      var prevChildren = this.prevChildren = this.children;
      var rawChildren = this.$slots.default || [];
      var children = this.children = [];
      var transitionData = extractTransitionData(this);

      for (var i = 0; i < rawChildren.length; i++) {
        var c = rawChildren[i];

        if (c.tag) {
          if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
            children.push(c);
            map[c.key] = c;
            (c.data || (c.data = {})).transition = transitionData;
          } else {
            var opts = c.componentOptions;
            var name = opts ? opts.Ctor.options.name || opts.tag || '' : c.tag;
            warn("<transition-group> children must be keyed: <" + name + ">");
          }
        }
      }

      if (prevChildren) {
        var kept = [];
        var removed = [];

        for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
          var c$1 = prevChildren[i$1];
          c$1.data.transition = transitionData;
          c$1.data.pos = c$1.elm.getBoundingClientRect();

          if (map[c$1.key]) {
            kept.push(c$1);
          } else {
            removed.push(c$1);
          }
        }

        this.kept = h(tag, null, kept);
        this.removed = removed;
      }

      return h(tag, null, children);
    },
    updated: function updated() {
      var children = this.prevChildren;
      var moveClass = this.moveClass || (this.name || 'v') + '-move';

      if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
        return;
      } // we divide the work into three loops to avoid mixing DOM reads and writes
      // in each iteration - which helps prevent layout thrashing.


      children.forEach(callPendingCbs);
      children.forEach(recordPosition);
      children.forEach(applyTranslation); // force reflow to put everything in position
      // assign to this to avoid being removed in tree-shaking
      // $flow-disable-line

      this._reflow = document.body.offsetHeight;
      children.forEach(function (c) {
        if (c.data.moved) {
          var el = c.elm;
          var s = el.style;
          addTransitionClass(el, moveClass);
          s.transform = s.WebkitTransform = s.transitionDuration = '';
          el.addEventListener(transitionEndEvent, el._moveCb = function cb(e) {
            if (e && e.target !== el) {
              return;
            }

            if (!e || /transform$/.test(e.propertyName)) {
              el.removeEventListener(transitionEndEvent, cb);
              el._moveCb = null;
              removeTransitionClass(el, moveClass);
            }
          });
        }
      });
    },
    methods: {
      hasMove: function hasMove(el, moveClass) {
        /* istanbul ignore if */
        if (!hasTransition) {
          return false;
        }
        /* istanbul ignore if */


        if (this._hasMove) {
          return this._hasMove;
        } // Detect whether an element with the move class applied has
        // CSS transitions. Since the element may be inside an entering
        // transition at this very moment, we make a clone of it and remove
        // all other transition classes applied to ensure only the move class
        // is applied.


        var clone = el.cloneNode();

        if (el._transitionClasses) {
          el._transitionClasses.forEach(function (cls) {
            removeClass(clone, cls);
          });
        }

        addClass(clone, moveClass);
        clone.style.display = 'none';
        this.$el.appendChild(clone);
        var info = getTransitionInfo(clone);
        this.$el.removeChild(clone);
        return this._hasMove = info.hasTransform;
      }
    }
  };

  function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
      c.elm._moveCb();
    }
    /* istanbul ignore if */


    if (c.elm._enterCb) {
      c.elm._enterCb();
    }
  }

  function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
  }

  function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;

    if (dx || dy) {
      c.data.moved = true;
      var s = c.elm.style;
      s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
      s.transitionDuration = '0s';
    }
  }

  var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
  };
  /*  */
  // install platform specific utils

  Vue.config.mustUseProp = mustUseProp;
  Vue.config.isReservedTag = isReservedTag;
  Vue.config.isReservedAttr = isReservedAttr;
  Vue.config.getTagNamespace = getTagNamespace;
  Vue.config.isUnknownElement = isUnknownElement; // install platform runtime directives & components

  extend(Vue.options.directives, platformDirectives);
  extend(Vue.options.components, platformComponents); // install platform patch function

  Vue.prototype.__patch__ = inBrowser ? patch : noop; // public mount method

  Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
  }; // devtools global hook

  /* istanbul ignore next */


  if (inBrowser) {
    setTimeout(function () {
      if (config.devtools) {
        if (devtools) {
          devtools.emit('init', Vue);
        } else {
          console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
        }
      }

      if (config.productionTip !== false && typeof console !== 'undefined') {
        console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" + "Make sure to turn on production mode when deploying for production.\n" + "See more tips at https://vuejs.org/guide/deployment.html");
      }
    }, 0);
  }
  /*  */


  var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
  var buildRegex = cached(function (delimiters) {
    var open = delimiters[0].replace(regexEscapeRE, '\\$&');
    var close = delimiters[1].replace(regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
  });

  function parseText(text, delimiters) {
    var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;

    if (!tagRE.test(text)) {
      return;
    }

    var tokens = [];
    var rawTokens = [];
    var lastIndex = tagRE.lastIndex = 0;
    var match, index, tokenValue;

    while (match = tagRE.exec(text)) {
      index = match.index; // push text token

      if (index > lastIndex) {
        rawTokens.push(tokenValue = text.slice(lastIndex, index));
        tokens.push(JSON.stringify(tokenValue));
      } // tag token


      var exp = parseFilters(match[1].trim());
      tokens.push("_s(" + exp + ")");
      rawTokens.push({
        '@binding': exp
      });
      lastIndex = index + match[0].length;
    }

    if (lastIndex < text.length) {
      rawTokens.push(tokenValue = text.slice(lastIndex));
      tokens.push(JSON.stringify(tokenValue));
    }

    return {
      expression: tokens.join('+'),
      tokens: rawTokens
    };
  }
  /*  */


  function transformNode(el, options) {
    var warn = options.warn || baseWarn;
    var staticClass = getAndRemoveAttr(el, 'class');

    if (staticClass) {
      var res = parseText(staticClass, options.delimiters);

      if (res) {
        warn("class=\"" + staticClass + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
      }
    }

    if (staticClass) {
      el.staticClass = JSON.stringify(staticClass);
    }

    var classBinding = getBindingAttr(el, 'class', false
    /* getStatic */
    );

    if (classBinding) {
      el.classBinding = classBinding;
    }
  }

  function genData(el) {
    var data = '';

    if (el.staticClass) {
      data += "staticClass:" + el.staticClass + ",";
    }

    if (el.classBinding) {
      data += "class:" + el.classBinding + ",";
    }

    return data;
  }

  var klass$1 = {
    staticKeys: ['staticClass'],
    transformNode: transformNode,
    genData: genData
  };
  /*  */

  function transformNode$1(el, options) {
    var warn = options.warn || baseWarn;
    var staticStyle = getAndRemoveAttr(el, 'style');

    if (staticStyle) {
      /* istanbul ignore if */
      {
        var res = parseText(staticStyle, options.delimiters);

        if (res) {
          warn("style=\"" + staticStyle + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
        }
      }
      el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
    }

    var styleBinding = getBindingAttr(el, 'style', false
    /* getStatic */
    );

    if (styleBinding) {
      el.styleBinding = styleBinding;
    }
  }

  function genData$1(el) {
    var data = '';

    if (el.staticStyle) {
      data += "staticStyle:" + el.staticStyle + ",";
    }

    if (el.styleBinding) {
      data += "style:(" + el.styleBinding + "),";
    }

    return data;
  }

  var style$1 = {
    staticKeys: ['staticStyle'],
    transformNode: transformNode$1,
    genData: genData$1
  };
  /*  */

  var decoder;
  var he = {
    decode: function decode(html) {
      decoder = decoder || document.createElement('div');
      decoder.innerHTML = html;
      return decoder.textContent;
    }
  };
  /*  */

  var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' + 'link,meta,param,source,track,wbr'); // Elements that you can, intentionally, leave open
  // (and which close themselves)

  var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'); // HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
  // Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content

  var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' + 'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' + 'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' + 'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' + 'title,tr,track');
  /**
   * Not type-checking this file because it's mostly vendor code.
   */
  // Regular Expressions for parsing tags and attributes

  var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
  var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
  var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + unicodeRegExp.source + "]*";
  var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
  var startTagOpen = new RegExp("^<" + qnameCapture);
  var startTagClose = /^\s*(\/?)>/;
  var endTag = new RegExp("^<\\/" + qnameCapture + "[^>]*>");
  var doctype = /^<!DOCTYPE [^>]+>/i; // #7298: escape - to avoid being passed as HTML comment when inlined in page

  var comment = /^<!\--/;
  var conditionalComment = /^<!\[/; // Special Elements (can contain anything)

  var isPlainTextElement = makeMap('script,style,textarea', true);
  var reCache = {};
  var decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
  };
  var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
  var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g; // #5992

  var isIgnoreNewlineTag = makeMap('pre,textarea', true);

  var shouldIgnoreFirstNewline = function (tag, html) {
    return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
  };

  function decodeAttr(value, shouldDecodeNewlines) {
    var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
    return value.replace(re, function (match) {
      return decodingMap[match];
    });
  }

  function parseHTML(html, options) {
    var stack = [];
    var expectHTML = options.expectHTML;
    var isUnaryTag$$1 = options.isUnaryTag || no;
    var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
    var index = 0;
    var last, lastTag;

    while (html) {
      last = html; // Make sure we're not in a plaintext content element like script/style

      if (!lastTag || !isPlainTextElement(lastTag)) {
        var textEnd = html.indexOf('<');

        if (textEnd === 0) {
          // Comment:
          if (comment.test(html)) {
            var commentEnd = html.indexOf('-->');

            if (commentEnd >= 0) {
              if (options.shouldKeepComment) {
                options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
              }

              advance(commentEnd + 3);
              continue;
            }
          } // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment


          if (conditionalComment.test(html)) {
            var conditionalEnd = html.indexOf(']>');

            if (conditionalEnd >= 0) {
              advance(conditionalEnd + 2);
              continue;
            }
          } // Doctype:


          var doctypeMatch = html.match(doctype);

          if (doctypeMatch) {
            advance(doctypeMatch[0].length);
            continue;
          } // End tag:


          var endTagMatch = html.match(endTag);

          if (endTagMatch) {
            var curIndex = index;
            advance(endTagMatch[0].length);
            parseEndTag(endTagMatch[1], curIndex, index);
            continue;
          } // Start tag:


          var startTagMatch = parseStartTag();

          if (startTagMatch) {
            handleStartTag(startTagMatch);

            if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
              advance(1);
            }

            continue;
          }
        }

        var text = void 0,
            rest = void 0,
            next = void 0;

        if (textEnd >= 0) {
          rest = html.slice(textEnd);

          while (!endTag.test(rest) && !startTagOpen.test(rest) && !comment.test(rest) && !conditionalComment.test(rest)) {
            // < in plain text, be forgiving and treat it as text
            next = rest.indexOf('<', 1);

            if (next < 0) {
              break;
            }

            textEnd += next;
            rest = html.slice(textEnd);
          }

          text = html.substring(0, textEnd);
        }

        if (textEnd < 0) {
          text = html;
        }

        if (text) {
          advance(text.length);
        }

        if (options.chars && text) {
          options.chars(text, index - text.length, index);
        }
      } else {
        var endTagLength = 0;
        var stackedTag = lastTag.toLowerCase();
        var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
        var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
          endTagLength = endTag.length;

          if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
            text = text.replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
          }

          if (shouldIgnoreFirstNewline(stackedTag, text)) {
            text = text.slice(1);
          }

          if (options.chars) {
            options.chars(text);
          }

          return '';
        });
        index += html.length - rest$1.length;
        html = rest$1;
        parseEndTag(stackedTag, index - endTagLength, index);
      }

      if (html === last) {
        options.chars && options.chars(html);

        if (!stack.length && options.warn) {
          options.warn("Mal-formatted tag at end of template: \"" + html + "\"", {
            start: index + html.length
          });
        }

        break;
      }
    } // Clean up any remaining tags


    parseEndTag();

    function advance(n) {
      index += n;
      html = html.substring(n);
    }

    function parseStartTag() {
      var start = html.match(startTagOpen);

      if (start) {
        var match = {
          tagName: start[1],
          attrs: [],
          start: index
        };
        advance(start[0].length);
        var end, attr;

        while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
          attr.start = index;
          advance(attr[0].length);
          attr.end = index;
          match.attrs.push(attr);
        }

        if (end) {
          match.unarySlash = end[1];
          advance(end[0].length);
          match.end = index;
          return match;
        }
      }
    }

    function handleStartTag(match) {
      var tagName = match.tagName;
      var unarySlash = match.unarySlash;

      if (expectHTML) {
        if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
          parseEndTag(lastTag);
        }

        if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
          parseEndTag(tagName);
        }
      }

      var unary = isUnaryTag$$1(tagName) || !!unarySlash;
      var l = match.attrs.length;
      var attrs = new Array(l);

      for (var i = 0; i < l; i++) {
        var args = match.attrs[i];
        var value = args[3] || args[4] || args[5] || '';
        var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href' ? options.shouldDecodeNewlinesForHref : options.shouldDecodeNewlines;
        attrs[i] = {
          name: args[1],
          value: decodeAttr(value, shouldDecodeNewlines)
        };

        if (options.outputSourceRange) {
          attrs[i].start = args.start + args[0].match(/^\s*/).length;
          attrs[i].end = args.end;
        }
      }

      if (!unary) {
        stack.push({
          tag: tagName,
          lowerCasedTag: tagName.toLowerCase(),
          attrs: attrs,
          start: match.start,
          end: match.end
        });
        lastTag = tagName;
      }

      if (options.start) {
        options.start(tagName, attrs, unary, match.start, match.end);
      }
    }

    function parseEndTag(tagName, start, end) {
      var pos, lowerCasedTagName;

      if (start == null) {
        start = index;
      }

      if (end == null) {
        end = index;
      } // Find the closest opened tag of the same type


      if (tagName) {
        lowerCasedTagName = tagName.toLowerCase();

        for (pos = stack.length - 1; pos >= 0; pos--) {
          if (stack[pos].lowerCasedTag === lowerCasedTagName) {
            break;
          }
        }
      } else {
        // If no tag name is provided, clean shop
        pos = 0;
      }

      if (pos >= 0) {
        // Close all the open elements, up the stack
        for (var i = stack.length - 1; i >= pos; i--) {
          if (i > pos || !tagName && options.warn) {
            options.warn("tag <" + stack[i].tag + "> has no matching end tag.", {
              start: stack[i].start,
              end: stack[i].end
            });
          }

          if (options.end) {
            options.end(stack[i].tag, start, end);
          }
        } // Remove the open elements from the stack


        stack.length = pos;
        lastTag = pos && stack[pos - 1].tag;
      } else if (lowerCasedTagName === 'br') {
        if (options.start) {
          options.start(tagName, [], true, start, end);
        }
      } else if (lowerCasedTagName === 'p') {
        if (options.start) {
          options.start(tagName, [], false, start, end);
        }

        if (options.end) {
          options.end(tagName, start, end);
        }
      }
    }
  }
  /*  */


  var onRE = /^@|^v-on:/;
  var dirRE = /^v-|^@|^:|^#/;
  var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
  var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  var stripParensRE = /^\(|\)$/g;
  var dynamicArgRE = /^\[.*\]$/;
  var argRE = /:(.*)$/;
  var bindRE = /^:|^\.|^v-bind:/;
  var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
  var slotRE = /^v-slot(:|$)|^#/;
  var lineBreakRE = /[\r\n]/;
  var whitespaceRE$1 = /[ \f\t\r\n]+/g;
  var invalidAttributeRE = /[\s"'<>\/=]/;
  var decodeHTMLCached = cached(he.decode);
  var emptySlotScopeToken = "_empty_"; // configurable state

  var warn$2;
  var delimiters;
  var transforms;
  var preTransforms;
  var postTransforms;
  var platformIsPreTag;
  var platformMustUseProp;
  var platformGetTagNamespace;
  var maybeComponent;

  function createASTElement(tag, attrs, parent) {
    return {
      type: 1,
      tag: tag,
      attrsList: attrs,
      attrsMap: makeAttrsMap(attrs),
      rawAttrsMap: {},
      parent: parent,
      children: []
    };
  }
  /**
   * Convert HTML string to AST.
   */


  function parse(template, options) {
    warn$2 = options.warn || baseWarn;
    platformIsPreTag = options.isPreTag || no;
    platformMustUseProp = options.mustUseProp || no;
    platformGetTagNamespace = options.getTagNamespace || no;
    var isReservedTag = options.isReservedTag || no;

    maybeComponent = function (el) {
      return !!(el.component || el.attrsMap[':is'] || el.attrsMap['v-bind:is'] || !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
    };

    transforms = pluckModuleFunction(options.modules, 'transformNode');
    preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
    postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
    delimiters = options.delimiters;
    var stack = [];
    var preserveWhitespace = options.preserveWhitespace !== false;
    var whitespaceOption = options.whitespace;
    var root;
    var currentParent;
    var inVPre = false;
    var inPre = false;
    var warned = false;

    function warnOnce(msg, range) {
      if (!warned) {
        warned = true;
        warn$2(msg, range);
      }
    }

    function closeElement(element) {
      trimEndingWhitespace(element);

      if (!inVPre && !element.processed) {
        element = processElement(element, options);
      } // tree management


      if (!stack.length && element !== root) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          {
            checkRootConstraints(element);
          }
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else {
          warnOnce("Component template should contain exactly one root element. " + "If you are using v-if on multiple elements, " + "use v-else-if to chain them instead.", {
            start: element.start
          });
        }
      }

      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else {
          if (element.slotScope) {
            // scoped slot
            // keep it in the children list so that v-else(-if) conditions can
            // find it as the prev node.
            var name = element.slotTarget || '"default"';
            (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
          }

          currentParent.children.push(element);
          element.parent = currentParent;
        }
      } // final children cleanup
      // filter out scoped slots


      element.children = element.children.filter(function (c) {
        return !c.slotScope;
      }); // remove trailing whitespace node again

      trimEndingWhitespace(element); // check pre state

      if (element.pre) {
        inVPre = false;
      }

      if (platformIsPreTag(element.tag)) {
        inPre = false;
      } // apply post-transforms


      for (var i = 0; i < postTransforms.length; i++) {
        postTransforms[i](element, options);
      }
    }

    function trimEndingWhitespace(el) {
      // remove trailing whitespace node
      if (!inPre) {
        var lastNode;

        while ((lastNode = el.children[el.children.length - 1]) && lastNode.type === 3 && lastNode.text === ' ') {
          el.children.pop();
        }
      }
    }

    function checkRootConstraints(el) {
      if (el.tag === 'slot' || el.tag === 'template') {
        warnOnce("Cannot use <" + el.tag + "> as component root element because it may " + 'contain multiple nodes.', {
          start: el.start
        });
      }

      if (el.attrsMap.hasOwnProperty('v-for')) {
        warnOnce('Cannot use v-for on stateful component root element because ' + 'it renders multiple elements.', el.rawAttrsMap['v-for']);
      }
    }

    parseHTML(template, {
      warn: warn$2,
      expectHTML: options.expectHTML,
      isUnaryTag: options.isUnaryTag,
      canBeLeftOpenTag: options.canBeLeftOpenTag,
      shouldDecodeNewlines: options.shouldDecodeNewlines,
      shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
      shouldKeepComment: options.comments,
      outputSourceRange: options.outputSourceRange,
      start: function start(tag, attrs, unary, start$1, end) {
        // check namespace.
        // inherit parent ns if there is one
        var ns = currentParent && currentParent.ns || platformGetTagNamespace(tag); // handle IE svg bug

        /* istanbul ignore if */

        if (isIE && ns === 'svg') {
          attrs = guardIESVGBug(attrs);
        }

        var element = createASTElement(tag, attrs, currentParent);

        if (ns) {
          element.ns = ns;
        }

        {
          if (options.outputSourceRange) {
            element.start = start$1;
            element.end = end;
            element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
              cumulated[attr.name] = attr;
              return cumulated;
            }, {});
          }

          attrs.forEach(function (attr) {
            if (invalidAttributeRE.test(attr.name)) {
              warn$2("Invalid dynamic argument expression: attribute names cannot contain " + "spaces, quotes, <, >, / or =.", {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              });
            }
          });
        }

        if (isForbiddenTag(element) && !isServerRendering()) {
          element.forbidden = true;
          warn$2('Templates should only be responsible for mapping the state to the ' + 'UI. Avoid placing tags with side-effects in your templates, such as ' + "<" + tag + ">" + ', as they will not be parsed.', {
            start: element.start
          });
        } // apply pre-transforms


        for (var i = 0; i < preTransforms.length; i++) {
          element = preTransforms[i](element, options) || element;
        }

        if (!inVPre) {
          processPre(element);

          if (element.pre) {
            inVPre = true;
          }
        }

        if (platformIsPreTag(element.tag)) {
          inPre = true;
        }

        if (inVPre) {
          processRawAttrs(element);
        } else if (!element.processed) {
          // structural directives
          processFor(element);
          processIf(element);
          processOnce(element);
        }

        if (!root) {
          root = element;
          {
            checkRootConstraints(root);
          }
        }

        if (!unary) {
          currentParent = element;
          stack.push(element);
        } else {
          closeElement(element);
        }
      },
      end: function end(tag, start, end$1) {
        var element = stack[stack.length - 1]; // pop stack

        stack.length -= 1;
        currentParent = stack[stack.length - 1];

        if (options.outputSourceRange) {
          element.end = end$1;
        }

        closeElement(element);
      },
      chars: function chars(text, start, end) {
        if (!currentParent) {
          {
            if (text === template) {
              warnOnce('Component template requires a root element, rather than just text.', {
                start: start
              });
            } else if (text = text.trim()) {
              warnOnce("text \"" + text + "\" outside root element will be ignored.", {
                start: start
              });
            }
          }
          return;
        } // IE textarea placeholder bug

        /* istanbul ignore if */


        if (isIE && currentParent.tag === 'textarea' && currentParent.attrsMap.placeholder === text) {
          return;
        }

        var children = currentParent.children;

        if (inPre || text.trim()) {
          text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
        } else if (!children.length) {
          // remove the whitespace-only node right after an opening tag
          text = '';
        } else if (whitespaceOption) {
          if (whitespaceOption === 'condense') {
            // in condense mode, remove the whitespace node if it contains
            // line break, otherwise condense to a single space
            text = lineBreakRE.test(text) ? '' : ' ';
          } else {
            text = ' ';
          }
        } else {
          text = preserveWhitespace ? ' ' : '';
        }

        if (text) {
          if (!inPre && whitespaceOption === 'condense') {
            // condense consecutive whitespaces into single space
            text = text.replace(whitespaceRE$1, ' ');
          }

          var res;
          var child;

          if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
            child = {
              type: 2,
              expression: res.expression,
              tokens: res.tokens,
              text: text
            };
          } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
            child = {
              type: 3,
              text: text
            };
          }

          if (child) {
            if (options.outputSourceRange) {
              child.start = start;
              child.end = end;
            }

            children.push(child);
          }
        }
      },
      comment: function comment(text, start, end) {
        // adding anything as a sibling to the root node is forbidden
        // comments should still be allowed, but ignored
        if (currentParent) {
          var child = {
            type: 3,
            text: text,
            isComment: true
          };

          if (options.outputSourceRange) {
            child.start = start;
            child.end = end;
          }

          currentParent.children.push(child);
        }
      }
    });
    return root;
  }

  function processPre(el) {
    if (getAndRemoveAttr(el, 'v-pre') != null) {
      el.pre = true;
    }
  }

  function processRawAttrs(el) {
    var list = el.attrsList;
    var len = list.length;

    if (len) {
      var attrs = el.attrs = new Array(len);

      for (var i = 0; i < len; i++) {
        attrs[i] = {
          name: list[i].name,
          value: JSON.stringify(list[i].value)
        };

        if (list[i].start != null) {
          attrs[i].start = list[i].start;
          attrs[i].end = list[i].end;
        }
      }
    } else if (!el.pre) {
      // non root node in pre blocks with no attributes
      el.plain = true;
    }
  }

  function processElement(element, options) {
    processKey(element); // determine whether this is a plain element after
    // removing structural attributes

    element.plain = !element.key && !element.scopedSlots && !element.attrsList.length;
    processRef(element);
    processSlotContent(element);
    processSlotOutlet(element);
    processComponent(element);

    for (var i = 0; i < transforms.length; i++) {
      element = transforms[i](element, options) || element;
    }

    processAttrs(element);
    return element;
  }

  function processKey(el) {
    var exp = getBindingAttr(el, 'key');

    if (exp) {
      {
        if (el.tag === 'template') {
          warn$2("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
        }

        if (el.for) {
          var iterator = el.iterator2 || el.iterator1;
          var parent = el.parent;

          if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
            warn$2("Do not use v-for index as key on <transition-group> children, " + "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true
            /* tip */
            );
          }
        }
      }
      el.key = exp;
    }
  }

  function processRef(el) {
    var ref = getBindingAttr(el, 'ref');

    if (ref) {
      el.ref = ref;
      el.refInFor = checkInFor(el);
    }
  }

  function processFor(el) {
    var exp;

    if (exp = getAndRemoveAttr(el, 'v-for')) {
      var res = parseFor(exp);

      if (res) {
        extend(el, res);
      } else {
        warn$2("Invalid v-for expression: " + exp, el.rawAttrsMap['v-for']);
      }
    }
  }

  function parseFor(exp) {
    var inMatch = exp.match(forAliasRE);

    if (!inMatch) {
      return;
    }

    var res = {};
    res.for = inMatch[2].trim();
    var alias = inMatch[1].trim().replace(stripParensRE, '');
    var iteratorMatch = alias.match(forIteratorRE);

    if (iteratorMatch) {
      res.alias = alias.replace(forIteratorRE, '').trim();
      res.iterator1 = iteratorMatch[1].trim();

      if (iteratorMatch[2]) {
        res.iterator2 = iteratorMatch[2].trim();
      }
    } else {
      res.alias = alias;
    }

    return res;
  }

  function processIf(el) {
    var exp = getAndRemoveAttr(el, 'v-if');

    if (exp) {
      el.if = exp;
      addIfCondition(el, {
        exp: exp,
        block: el
      });
    } else {
      if (getAndRemoveAttr(el, 'v-else') != null) {
        el.else = true;
      }

      var elseif = getAndRemoveAttr(el, 'v-else-if');

      if (elseif) {
        el.elseif = elseif;
      }
    }
  }

  function processIfConditions(el, parent) {
    var prev = findPrevElement(parent.children);

    if (prev && prev.if) {
      addIfCondition(prev, {
        exp: el.elseif,
        block: el
      });
    } else {
      warn$2("v-" + (el.elseif ? 'else-if="' + el.elseif + '"' : 'else') + " " + "used on element <" + el.tag + "> without corresponding v-if.", el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
    }
  }

  function findPrevElement(children) {
    var i = children.length;

    while (i--) {
      if (children[i].type === 1) {
        return children[i];
      } else {
        if (children[i].text !== ' ') {
          warn$2("text \"" + children[i].text.trim() + "\" between v-if and v-else(-if) " + "will be ignored.", children[i]);
        }

        children.pop();
      }
    }
  }

  function addIfCondition(el, condition) {
    if (!el.ifConditions) {
      el.ifConditions = [];
    }

    el.ifConditions.push(condition);
  }

  function processOnce(el) {
    var once$$1 = getAndRemoveAttr(el, 'v-once');

    if (once$$1 != null) {
      el.once = true;
    }
  } // handle content being passed to a component as slot,
  // e.g. <template slot="xxx">, <div slot-scope="xxx">


  function processSlotContent(el) {
    var slotScope;

    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */

      if (slotScope) {
        warn$2("the \"scope\" attribute for scoped slots have been deprecated and " + "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " + "can also be used on plain elements in addition to <template> to " + "denote scoped slots.", el.rawAttrsMap['scope'], true);
      }

      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if (slotScope = getAndRemoveAttr(el, 'slot-scope')) {
      /* istanbul ignore if */
      if (el.attrsMap['v-for']) {
        warn$2("Ambiguous combined usage of slot-scope and v-for on <" + el.tag + "> " + "(v-for takes higher priority). Use a wrapper <template> for the " + "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
      }

      el.slotScope = slotScope;
    } // slot="xxx"


    var slotTarget = getBindingAttr(el, 'slot');

    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']); // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.

      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
      }
    } // 2.6 v-slot syntax


    {
      if (el.tag === 'template') {
        // v-slot on <template>
        var slotBinding = getAndRemoveAttrByRegex(el, slotRE);

        if (slotBinding) {
          {
            if (el.slotTarget || el.slotScope) {
              warn$2("Unexpected mixed usage of different slot syntaxes.", el);
            }

            if (el.parent && !maybeComponent(el.parent)) {
              warn$2("<template v-slot> can only appear at the root level inside " + "the receiving component", el);
            }
          }
          var ref = getSlotName(slotBinding);
          var name = ref.name;
          var dynamic = ref.dynamic;
          el.slotTarget = name;
          el.slotTargetDynamic = dynamic;
          el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
        }
      } else {
        // v-slot on component, denotes default slot
        var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);

        if (slotBinding$1) {
          {
            if (!maybeComponent(el)) {
              warn$2("v-slot can only be used on components or <template>.", slotBinding$1);
            }

            if (el.slotScope || el.slotTarget) {
              warn$2("Unexpected mixed usage of different slot syntaxes.", el);
            }

            if (el.scopedSlots) {
              warn$2("To avoid scope ambiguity, the default slot should also use " + "<template> syntax when there are other named slots.", slotBinding$1);
            }
          } // add the component's children to its default slot

          var slots = el.scopedSlots || (el.scopedSlots = {});
          var ref$1 = getSlotName(slotBinding$1);
          var name$1 = ref$1.name;
          var dynamic$1 = ref$1.dynamic;
          var slotContainer = slots[name$1] = createASTElement('template', [], el);
          slotContainer.slotTarget = name$1;
          slotContainer.slotTargetDynamic = dynamic$1;
          slotContainer.children = el.children.filter(function (c) {
            if (!c.slotScope) {
              c.parent = slotContainer;
              return true;
            }
          });
          slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken; // remove children as they are returned from scopedSlots now

          el.children = []; // mark el non-plain so data gets generated

          el.plain = false;
        }
      }
    }
  }

  function getSlotName(binding) {
    var name = binding.name.replace(slotRE, '');

    if (!name) {
      if (binding.name[0] !== '#') {
        name = 'default';
      } else {
        warn$2("v-slot shorthand syntax requires a slot name.", binding);
      }
    }

    return dynamicArgRE.test(name) // dynamic [name]
    ? {
      name: name.slice(1, -1),
      dynamic: true
    } // static name
    : {
      name: "\"" + name + "\"",
      dynamic: false
    };
  } // handle <slot/> outlets


  function processSlotOutlet(el) {
    if (el.tag === 'slot') {
      el.slotName = getBindingAttr(el, 'name');

      if (el.key) {
        warn$2("`key` does not work on <slot> because slots are abstract outlets " + "and can possibly expand into multiple elements. " + "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
      }
    }
  }

  function processComponent(el) {
    var binding;

    if (binding = getBindingAttr(el, 'is')) {
      el.component = binding;
    }

    if (getAndRemoveAttr(el, 'inline-template') != null) {
      el.inlineTemplate = true;
    }
  }

  function processAttrs(el) {
    var list = el.attrsList;
    var i, l, name, rawName, value, modifiers, syncGen, isDynamic;

    for (i = 0, l = list.length; i < l; i++) {
      name = rawName = list[i].name;
      value = list[i].value;

      if (dirRE.test(name)) {
        // mark element as dynamic
        el.hasBindings = true; // modifiers

        modifiers = parseModifiers(name.replace(dirRE, '')); // support .foo shorthand syntax for the .prop modifier

        if (modifiers) {
          name = name.replace(modifierRE, '');
        }

        if (bindRE.test(name)) {
          // v-bind
          name = name.replace(bindRE, '');
          value = parseFilters(value);
          isDynamic = dynamicArgRE.test(name);

          if (isDynamic) {
            name = name.slice(1, -1);
          }

          if (value.trim().length === 0) {
            warn$2("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"");
          }

          if (modifiers) {
            if (modifiers.prop && !isDynamic) {
              name = camelize(name);

              if (name === 'innerHtml') {
                name = 'innerHTML';
              }
            }

            if (modifiers.camel && !isDynamic) {
              name = camelize(name);
            }

            if (modifiers.sync) {
              syncGen = genAssignmentCode(value, "$event");

              if (!isDynamic) {
                addHandler(el, "update:" + camelize(name), syncGen, null, false, warn$2, list[i]);

                if (hyphenate(name) !== camelize(name)) {
                  addHandler(el, "update:" + hyphenate(name), syncGen, null, false, warn$2, list[i]);
                }
              } else {
                // handler w/ dynamic event name
                addHandler(el, "\"update:\"+(" + name + ")", syncGen, null, false, warn$2, list[i], true // dynamic
                );
              }
            }
          }

          if (modifiers && modifiers.prop || !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
            addProp(el, name, value, list[i], isDynamic);
          } else {
            addAttr(el, name, value, list[i], isDynamic);
          }
        } else if (onRE.test(name)) {
          // v-on
          name = name.replace(onRE, '');
          isDynamic = dynamicArgRE.test(name);

          if (isDynamic) {
            name = name.slice(1, -1);
          }

          addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
        } else {
          // normal directives
          name = name.replace(dirRE, ''); // parse arg

          var argMatch = name.match(argRE);
          var arg = argMatch && argMatch[1];
          isDynamic = false;

          if (arg) {
            name = name.slice(0, -(arg.length + 1));

            if (dynamicArgRE.test(arg)) {
              arg = arg.slice(1, -1);
              isDynamic = true;
            }
          }

          addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);

          if (name === 'model') {
            checkForAliasModel(el, value);
          }
        }
      } else {
        // literal attribute
        {
          var res = parseText(value, delimiters);

          if (res) {
            warn$2(name + "=\"" + value + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
          }
        }
        addAttr(el, name, JSON.stringify(value), list[i]); // #6887 firefox doesn't update muted state if set via attribute
        // even immediately after element creation

        if (!el.component && name === 'muted' && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
          addProp(el, name, 'true', list[i]);
        }
      }
    }
  }

  function checkInFor(el) {
    var parent = el;

    while (parent) {
      if (parent.for !== undefined) {
        return true;
      }

      parent = parent.parent;
    }

    return false;
  }

  function parseModifiers(name) {
    var match = name.match(modifierRE);

    if (match) {
      var ret = {};
      match.forEach(function (m) {
        ret[m.slice(1)] = true;
      });
      return ret;
    }
  }

  function makeAttrsMap(attrs) {
    var map = {};

    for (var i = 0, l = attrs.length; i < l; i++) {
      if (map[attrs[i].name] && !isIE && !isEdge) {
        warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
      }

      map[attrs[i].name] = attrs[i].value;
    }

    return map;
  } // for script (e.g. type="x/template") or style, do not decode content


  function isTextTag(el) {
    return el.tag === 'script' || el.tag === 'style';
  }

  function isForbiddenTag(el) {
    return el.tag === 'style' || el.tag === 'script' && (!el.attrsMap.type || el.attrsMap.type === 'text/javascript');
  }

  var ieNSBug = /^xmlns:NS\d+/;
  var ieNSPrefix = /^NS\d+:/;
  /* istanbul ignore next */

  function guardIESVGBug(attrs) {
    var res = [];

    for (var i = 0; i < attrs.length; i++) {
      var attr = attrs[i];

      if (!ieNSBug.test(attr.name)) {
        attr.name = attr.name.replace(ieNSPrefix, '');
        res.push(attr);
      }
    }

    return res;
  }

  function checkForAliasModel(el, value) {
    var _el = el;

    while (_el) {
      if (_el.for && _el.alias === value) {
        warn$2("<" + el.tag + " v-model=\"" + value + "\">: " + "You are binding v-model directly to a v-for iteration alias. " + "This will not be able to modify the v-for source array because " + "writing to the alias is like modifying a function local variable. " + "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
      }

      _el = _el.parent;
    }
  }
  /*  */


  function preTransformNode(el, options) {
    if (el.tag === 'input') {
      var map = el.attrsMap;

      if (!map['v-model']) {
        return;
      }

      var typeBinding;

      if (map[':type'] || map['v-bind:type']) {
        typeBinding = getBindingAttr(el, 'type');
      }

      if (!map.type && !typeBinding && map['v-bind']) {
        typeBinding = "(" + map['v-bind'] + ").type";
      }

      if (typeBinding) {
        var ifCondition = getAndRemoveAttr(el, 'v-if', true);
        var ifConditionExtra = ifCondition ? "&&(" + ifCondition + ")" : "";
        var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
        var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true); // 1. checkbox

        var branch0 = cloneASTElement(el); // process for on the main node

        processFor(branch0);
        addRawAttr(branch0, 'type', 'checkbox');
        processElement(branch0, options);
        branch0.processed = true; // prevent it from double-processed

        branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
        addIfCondition(branch0, {
          exp: branch0.if,
          block: branch0
        }); // 2. add radio else-if condition

        var branch1 = cloneASTElement(el);
        getAndRemoveAttr(branch1, 'v-for', true);
        addRawAttr(branch1, 'type', 'radio');
        processElement(branch1, options);
        addIfCondition(branch0, {
          exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
          block: branch1
        }); // 3. other

        var branch2 = cloneASTElement(el);
        getAndRemoveAttr(branch2, 'v-for', true);
        addRawAttr(branch2, ':type', typeBinding);
        processElement(branch2, options);
        addIfCondition(branch0, {
          exp: ifCondition,
          block: branch2
        });

        if (hasElse) {
          branch0.else = true;
        } else if (elseIfCondition) {
          branch0.elseif = elseIfCondition;
        }

        return branch0;
      }
    }
  }

  function cloneASTElement(el) {
    return createASTElement(el.tag, el.attrsList.slice(), el.parent);
  }

  var model$1 = {
    preTransformNode: preTransformNode
  };
  var modules$1 = [klass$1, style$1, model$1];
  /*  */

  function text(el, dir) {
    if (dir.value) {
      addProp(el, 'textContent', "_s(" + dir.value + ")", dir);
    }
  }
  /*  */


  function html(el, dir) {
    if (dir.value) {
      addProp(el, 'innerHTML', "_s(" + dir.value + ")", dir);
    }
  }

  var directives$1 = {
    model: model,
    text: text,
    html: html
  };
  /*  */

  var baseOptions = {
    expectHTML: true,
    modules: modules$1,
    directives: directives$1,
    isPreTag: isPreTag,
    isUnaryTag: isUnaryTag,
    mustUseProp: mustUseProp,
    canBeLeftOpenTag: canBeLeftOpenTag,
    isReservedTag: isReservedTag,
    getTagNamespace: getTagNamespace,
    staticKeys: genStaticKeys(modules$1)
  };
  /*  */

  var isStaticKey;
  var isPlatformReservedTag;
  var genStaticKeysCached = cached(genStaticKeys$1);
  /**
   * Goal of the optimizer: walk the generated template AST tree
   * and detect sub-trees that are purely static, i.e. parts of
   * the DOM that never needs to change.
   *
   * Once we detect these sub-trees, we can:
   *
   * 1. Hoist them into constants, so that we no longer need to
   *    create fresh nodes for them on each re-render;
   * 2. Completely skip them in the patching process.
   */

  function optimize(root, options) {
    if (!root) {
      return;
    }

    isStaticKey = genStaticKeysCached(options.staticKeys || '');
    isPlatformReservedTag = options.isReservedTag || no; // first pass: mark all non-static nodes.

    markStatic$1(root); // second pass: mark static roots.

    markStaticRoots(root, false);
  }

  function genStaticKeys$1(keys) {
    return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' + (keys ? ',' + keys : ''));
  }

  function markStatic$1(node) {
    node.static = isStatic(node);

    if (node.type === 1) {
      // do not make component slot content static. this avoids
      // 1. components not able to mutate slot nodes
      // 2. static slot content fails for hot-reloading
      if (!isPlatformReservedTag(node.tag) && node.tag !== 'slot' && node.attrsMap['inline-template'] == null) {
        return;
      }

      for (var i = 0, l = node.children.length; i < l; i++) {
        var child = node.children[i];
        markStatic$1(child);

        if (!child.static) {
          node.static = false;
        }
      }

      if (node.ifConditions) {
        for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
          var block = node.ifConditions[i$1].block;
          markStatic$1(block);

          if (!block.static) {
            node.static = false;
          }
        }
      }
    }
  }

  function markStaticRoots(node, isInFor) {
    if (node.type === 1) {
      if (node.static || node.once) {
        node.staticInFor = isInFor;
      } // For a node to qualify as a static root, it should have children that
      // are not just static text. Otherwise the cost of hoisting out will
      // outweigh the benefits and it's better off to just always render it fresh.


      if (node.static && node.children.length && !(node.children.length === 1 && node.children[0].type === 3)) {
        node.staticRoot = true;
        return;
      } else {
        node.staticRoot = false;
      }

      if (node.children) {
        for (var i = 0, l = node.children.length; i < l; i++) {
          markStaticRoots(node.children[i], isInFor || !!node.for);
        }
      }

      if (node.ifConditions) {
        for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
          markStaticRoots(node.ifConditions[i$1].block, isInFor);
        }
      }
    }
  }

  function isStatic(node) {
    if (node.type === 2) {
      // expression
      return false;
    }

    if (node.type === 3) {
      // text
      return true;
    }

    return !!(node.pre || !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) && Object.keys(node).every(isStaticKey));
  }

  function isDirectChildOfTemplateFor(node) {
    while (node.parent) {
      node = node.parent;

      if (node.tag !== 'template') {
        return false;
      }

      if (node.for) {
        return true;
      }
    }

    return false;
  }
  /*  */


  var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
  var fnInvokeRE = /\([^)]*?\);*$/;
  var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/; // KeyboardEvent.keyCode aliases

  var keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    'delete': [8, 46]
  }; // KeyboardEvent.key aliases

  var keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: ['Esc', 'Escape'],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [' ', 'Spacebar'],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: ['Up', 'ArrowUp'],
    left: ['Left', 'ArrowLeft'],
    right: ['Right', 'ArrowRight'],
    down: ['Down', 'ArrowDown'],
    // #9112: IE11 uses `Del` for Delete key name.
    'delete': ['Backspace', 'Delete', 'Del']
  }; // #4868: modifiers that prevent the execution of the listener
  // need to explicitly return null so that we can determine whether to remove
  // the listener for .once

  var genGuard = function (condition) {
    return "if(" + condition + ")return null;";
  };

  var modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: genGuard("$event.target !== $event.currentTarget"),
    ctrl: genGuard("!$event.ctrlKey"),
    shift: genGuard("!$event.shiftKey"),
    alt: genGuard("!$event.altKey"),
    meta: genGuard("!$event.metaKey"),
    left: genGuard("'button' in $event && $event.button !== 0"),
    middle: genGuard("'button' in $event && $event.button !== 1"),
    right: genGuard("'button' in $event && $event.button !== 2")
  };

  function genHandlers(events, isNative) {
    var prefix = isNative ? 'nativeOn:' : 'on:';
    var staticHandlers = "";
    var dynamicHandlers = "";

    for (var name in events) {
      var handlerCode = genHandler(events[name]);

      if (events[name] && events[name].dynamic) {
        dynamicHandlers += name + "," + handlerCode + ",";
      } else {
        staticHandlers += "\"" + name + "\":" + handlerCode + ",";
      }
    }

    staticHandlers = "{" + staticHandlers.slice(0, -1) + "}";

    if (dynamicHandlers) {
      return prefix + "_d(" + staticHandlers + ",[" + dynamicHandlers.slice(0, -1) + "])";
    } else {
      return prefix + staticHandlers;
    }
  }

  function genHandler(handler) {
    if (!handler) {
      return 'function(){}';
    }

    if (Array.isArray(handler)) {
      return "[" + handler.map(function (handler) {
        return genHandler(handler);
      }).join(',') + "]";
    }

    var isMethodPath = simplePathRE.test(handler.value);
    var isFunctionExpression = fnExpRE.test(handler.value);
    var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

    if (!handler.modifiers) {
      if (isMethodPath || isFunctionExpression) {
        return handler.value;
      }

      return "function($event){" + (isFunctionInvocation ? "return " + handler.value : handler.value) + "}"; // inline statement
    } else {
      var code = '';
      var genModifierCode = '';
      var keys = [];

      for (var key in handler.modifiers) {
        if (modifierCode[key]) {
          genModifierCode += modifierCode[key]; // left/right

          if (keyCodes[key]) {
            keys.push(key);
          }
        } else if (key === 'exact') {
          var modifiers = handler.modifiers;
          genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta'].filter(function (keyModifier) {
            return !modifiers[keyModifier];
          }).map(function (keyModifier) {
            return "$event." + keyModifier + "Key";
          }).join('||'));
        } else {
          keys.push(key);
        }
      }

      if (keys.length) {
        code += genKeyFilter(keys);
      } // Make sure modifiers like prevent and stop get executed after key filtering


      if (genModifierCode) {
        code += genModifierCode;
      }

      var handlerCode = isMethodPath ? "return " + handler.value + ".apply(null, arguments)" : isFunctionExpression ? "return (" + handler.value + ").apply(null, arguments)" : isFunctionInvocation ? "return " + handler.value : handler.value;
      return "function($event){" + code + handlerCode + "}";
    }
  }

  function genKeyFilter(keys) {
    return (// make sure the key filters only apply to KeyboardEvents
      // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
      // key events that do not have keyCode property...
      "if(!$event.type.indexOf('key')&&" + keys.map(genFilterCode).join('&&') + ")return null;"
    );
  }

  function genFilterCode(key) {
    var keyVal = parseInt(key, 10);

    if (keyVal) {
      return "$event.keyCode!==" + keyVal;
    }

    var keyCode = keyCodes[key];
    var keyName = keyNames[key];
    return "_k($event.keyCode," + JSON.stringify(key) + "," + JSON.stringify(keyCode) + "," + "$event.key," + "" + JSON.stringify(keyName) + ")";
  }
  /*  */


  function on(el, dir) {
    if (dir.modifiers) {
      warn("v-on without argument does not support modifiers.");
    }

    el.wrapListeners = function (code) {
      return "_g(" + code + "," + dir.value + ")";
    };
  }
  /*  */


  function bind$1(el, dir) {
    el.wrapData = function (code) {
      return "_b(" + code + ",'" + el.tag + "'," + dir.value + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")";
    };
  }
  /*  */


  var baseDirectives = {
    on: on,
    bind: bind$1,
    cloak: noop
  };
  /*  */

  var CodegenState = function CodegenState(options) {
    this.options = options;
    this.warn = options.warn || baseWarn;
    this.transforms = pluckModuleFunction(options.modules, 'transformCode');
    this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
    this.directives = extend(extend({}, baseDirectives), options.directives);
    var isReservedTag = options.isReservedTag || no;

    this.maybeComponent = function (el) {
      return !!el.component || !isReservedTag(el.tag);
    };

    this.onceId = 0;
    this.staticRenderFns = [];
    this.pre = false;
  };

  function generate(ast, options) {
    var state = new CodegenState(options); // fix #11483, Root level <script> tags should not be rendered.

    var code = ast ? ast.tag === 'script' ? 'null' : genElement(ast, state) : '_c("div")';
    return {
      render: "with(this){return " + code + "}",
      staticRenderFns: state.staticRenderFns
    };
  }

  function genElement(el, state) {
    if (el.parent) {
      el.pre = el.pre || el.parent.pre;
    }

    if (el.staticRoot && !el.staticProcessed) {
      return genStatic(el, state);
    } else if (el.once && !el.onceProcessed) {
      return genOnce(el, state);
    } else if (el.for && !el.forProcessed) {
      return genFor(el, state);
    } else if (el.if && !el.ifProcessed) {
      return genIf(el, state);
    } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
      return genChildren(el, state) || 'void 0';
    } else if (el.tag === 'slot') {
      return genSlot(el, state);
    } else {
      // component or element
      var code;

      if (el.component) {
        code = genComponent(el.component, el, state);
      } else {
        var data;

        if (!el.plain || el.pre && state.maybeComponent(el)) {
          data = genData$2(el, state);
        }

        var children = el.inlineTemplate ? null : genChildren(el, state, true);
        code = "_c('" + el.tag + "'" + (data ? "," + data : '') + (children ? "," + children : '') + ")";
      } // module transforms


      for (var i = 0; i < state.transforms.length; i++) {
        code = state.transforms[i](el, code);
      }

      return code;
    }
  } // hoist static sub-trees out


  function genStatic(el, state) {
    el.staticProcessed = true; // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.

    var originalPreState = state.pre;

    if (el.pre) {
      state.pre = el.pre;
    }

    state.staticRenderFns.push("with(this){return " + genElement(el, state) + "}");
    state.pre = originalPreState;
    return "_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")";
  } // v-once


  function genOnce(el, state) {
    el.onceProcessed = true;

    if (el.if && !el.ifProcessed) {
      return genIf(el, state);
    } else if (el.staticInFor) {
      var key = '';
      var parent = el.parent;

      while (parent) {
        if (parent.for) {
          key = parent.key;
          break;
        }

        parent = parent.parent;
      }

      if (!key) {
        state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
        return genElement(el, state);
      }

      return "_o(" + genElement(el, state) + "," + state.onceId++ + "," + key + ")";
    } else {
      return genStatic(el, state);
    }
  }

  function genIf(el, state, altGen, altEmpty) {
    el.ifProcessed = true; // avoid recursion

    return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
  }

  function genIfConditions(conditions, state, altGen, altEmpty) {
    if (!conditions.length) {
      return altEmpty || '_e()';
    }

    var condition = conditions.shift();

    if (condition.exp) {
      return "(" + condition.exp + ")?" + genTernaryExp(condition.block) + ":" + genIfConditions(conditions, state, altGen, altEmpty);
    } else {
      return "" + genTernaryExp(condition.block);
    } // v-if with v-once should generate code like (a)?_m(0):_m(1)


    function genTernaryExp(el) {
      return altGen ? altGen(el, state) : el.once ? genOnce(el, state) : genElement(el, state);
    }
  }

  function genFor(el, state, altGen, altHelper) {
    var exp = el.for;
    var alias = el.alias;
    var iterator1 = el.iterator1 ? "," + el.iterator1 : '';
    var iterator2 = el.iterator2 ? "," + el.iterator2 : '';

    if (state.maybeComponent(el) && el.tag !== 'slot' && el.tag !== 'template' && !el.key) {
      state.warn("<" + el.tag + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " + "v-for should have explicit keys. " + "See https://vuejs.org/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true
      /* tip */
      );
    }

    el.forProcessed = true; // avoid recursion

    return (altHelper || '_l') + "((" + exp + ")," + "function(" + alias + iterator1 + iterator2 + "){" + "return " + (altGen || genElement)(el, state) + '})';
  }

  function genData$2(el, state) {
    var data = '{'; // directives first.
    // directives may mutate the el's other properties before they are generated.

    var dirs = genDirectives(el, state);

    if (dirs) {
      data += dirs + ',';
    } // key


    if (el.key) {
      data += "key:" + el.key + ",";
    } // ref


    if (el.ref) {
      data += "ref:" + el.ref + ",";
    }

    if (el.refInFor) {
      data += "refInFor:true,";
    } // pre


    if (el.pre) {
      data += "pre:true,";
    } // record original tag name for components using "is" attribute


    if (el.component) {
      data += "tag:\"" + el.tag + "\",";
    } // module data generation functions


    for (var i = 0; i < state.dataGenFns.length; i++) {
      data += state.dataGenFns[i](el);
    } // attributes


    if (el.attrs) {
      data += "attrs:" + genProps(el.attrs) + ",";
    } // DOM props


    if (el.props) {
      data += "domProps:" + genProps(el.props) + ",";
    } // event handlers


    if (el.events) {
      data += genHandlers(el.events, false) + ",";
    }

    if (el.nativeEvents) {
      data += genHandlers(el.nativeEvents, true) + ",";
    } // slot target
    // only for non-scoped slots


    if (el.slotTarget && !el.slotScope) {
      data += "slot:" + el.slotTarget + ",";
    } // scoped slots


    if (el.scopedSlots) {
      data += genScopedSlots(el, el.scopedSlots, state) + ",";
    } // component v-model


    if (el.model) {
      data += "model:{value:" + el.model.value + ",callback:" + el.model.callback + ",expression:" + el.model.expression + "},";
    } // inline-template


    if (el.inlineTemplate) {
      var inlineTemplate = genInlineTemplate(el, state);

      if (inlineTemplate) {
        data += inlineTemplate + ",";
      }
    }

    data = data.replace(/,$/, '') + '}'; // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.

    if (el.dynamicAttrs) {
      data = "_b(" + data + ",\"" + el.tag + "\"," + genProps(el.dynamicAttrs) + ")";
    } // v-bind data wrap


    if (el.wrapData) {
      data = el.wrapData(data);
    } // v-on data wrap


    if (el.wrapListeners) {
      data = el.wrapListeners(data);
    }

    return data;
  }

  function genDirectives(el, state) {
    var dirs = el.directives;

    if (!dirs) {
      return;
    }

    var res = 'directives:[';
    var hasRuntime = false;
    var i, l, dir, needRuntime;

    for (i = 0, l = dirs.length; i < l; i++) {
      dir = dirs[i];
      needRuntime = true;
      var gen = state.directives[dir.name];

      if (gen) {
        // compile-time directive that manipulates AST.
        // returns true if it also needs a runtime counterpart.
        needRuntime = !!gen(el, dir, state.warn);
      }

      if (needRuntime) {
        hasRuntime = true;
        res += "{name:\"" + dir.name + "\",rawName:\"" + dir.rawName + "\"" + (dir.value ? ",value:(" + dir.value + "),expression:" + JSON.stringify(dir.value) : '') + (dir.arg ? ",arg:" + (dir.isDynamicArg ? dir.arg : "\"" + dir.arg + "\"") : '') + (dir.modifiers ? ",modifiers:" + JSON.stringify(dir.modifiers) : '') + "},";
      }
    }

    if (hasRuntime) {
      return res.slice(0, -1) + ']';
    }
  }

  function genInlineTemplate(el, state) {
    var ast = el.children[0];

    if (el.children.length !== 1 || ast.type !== 1) {
      state.warn('Inline-template components must have exactly one child element.', {
        start: el.start
      });
    }

    if (ast && ast.type === 1) {
      var inlineRenderFns = generate(ast, state.options);
      return "inlineTemplate:{render:function(){" + inlineRenderFns.render + "},staticRenderFns:[" + inlineRenderFns.staticRenderFns.map(function (code) {
        return "function(){" + code + "}";
      }).join(',') + "]}";
    }
  }

  function genScopedSlots(el, slots, state) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
      var slot = slots[key];
      return slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
      ;
    }); // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.

    var needsKey = !!el.if; // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.

    if (!needsForceUpdate) {
      var parent = el.parent;

      while (parent) {
        if (parent.slotScope && parent.slotScope !== emptySlotScopeToken || parent.for) {
          needsForceUpdate = true;
          break;
        }

        if (parent.if) {
          needsKey = true;
        }

        parent = parent.parent;
      }
    }

    var generatedSlots = Object.keys(slots).map(function (key) {
      return genScopedSlot(slots[key], state);
    }).join(',');
    return "scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? ",null,false," + hash(generatedSlots) : "") + ")";
  }

  function hash(str) {
    var hash = 5381;
    var i = str.length;

    while (i) {
      hash = hash * 33 ^ str.charCodeAt(--i);
    }

    return hash >>> 0;
  }

  function containsSlotChild(el) {
    if (el.type === 1) {
      if (el.tag === 'slot') {
        return true;
      }

      return el.children.some(containsSlotChild);
    }

    return false;
  }

  function genScopedSlot(el, state) {
    var isLegacySyntax = el.attrsMap['slot-scope'];

    if (el.if && !el.ifProcessed && !isLegacySyntax) {
      return genIf(el, state, genScopedSlot, "null");
    }

    if (el.for && !el.forProcessed) {
      return genFor(el, state, genScopedSlot);
    }

    var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
    var fn = "function(" + slotScope + "){" + "return " + (el.tag === 'template' ? el.if && isLegacySyntax ? "(" + el.if + ")?" + (genChildren(el, state) || 'undefined') + ":undefined" : genChildren(el, state) || 'undefined' : genElement(el, state)) + "}"; // reverse proxy v-slot without scope on this.$slots

    var reverseProxy = slotScope ? "" : ",proxy:true";
    return "{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}";
  }

  function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
    var children = el.children;

    if (children.length) {
      var el$1 = children[0]; // optimize single v-for

      if (children.length === 1 && el$1.for && el$1.tag !== 'template' && el$1.tag !== 'slot') {
        var normalizationType = checkSkip ? state.maybeComponent(el$1) ? ",1" : ",0" : "";
        return "" + (altGenElement || genElement)(el$1, state) + normalizationType;
      }

      var normalizationType$1 = checkSkip ? getNormalizationType(children, state.maybeComponent) : 0;
      var gen = altGenNode || genNode;
      return "[" + children.map(function (c) {
        return gen(c, state);
      }).join(',') + "]" + (normalizationType$1 ? "," + normalizationType$1 : '');
    }
  } // determine the normalization needed for the children array.
  // 0: no normalization needed
  // 1: simple normalization needed (possible 1-level deep nested array)
  // 2: full normalization needed


  function getNormalizationType(children, maybeComponent) {
    var res = 0;

    for (var i = 0; i < children.length; i++) {
      var el = children[i];

      if (el.type !== 1) {
        continue;
      }

      if (needsNormalization(el) || el.ifConditions && el.ifConditions.some(function (c) {
        return needsNormalization(c.block);
      })) {
        res = 2;
        break;
      }

      if (maybeComponent(el) || el.ifConditions && el.ifConditions.some(function (c) {
        return maybeComponent(c.block);
      })) {
        res = 1;
      }
    }

    return res;
  }

  function needsNormalization(el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
  }

  function genNode(node, state) {
    if (node.type === 1) {
      return genElement(node, state);
    } else if (node.type === 3 && node.isComment) {
      return genComment(node);
    } else {
      return genText(node);
    }
  }

  function genText(text) {
    return "_v(" + (text.type === 2 ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")";
  }

  function genComment(comment) {
    return "_e(" + JSON.stringify(comment.text) + ")";
  }

  function genSlot(el, state) {
    var slotName = el.slotName || '"default"';
    var children = genChildren(el, state);
    var res = "_t(" + slotName + (children ? ",function(){return " + children + "}" : '');
    var attrs = el.attrs || el.dynamicAttrs ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) {
      return {
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      };
    })) : null;
    var bind$$1 = el.attrsMap['v-bind'];

    if ((attrs || bind$$1) && !children) {
      res += ",null";
    }

    if (attrs) {
      res += "," + attrs;
    }

    if (bind$$1) {
      res += (attrs ? '' : ',null') + "," + bind$$1;
    }

    return res + ')';
  } // componentName is el.component, take it as argument to shun flow's pessimistic refinement


  function genComponent(componentName, el, state) {
    var children = el.inlineTemplate ? null : genChildren(el, state, true);
    return "_c(" + componentName + "," + genData$2(el, state) + (children ? "," + children : '') + ")";
  }

  function genProps(props) {
    var staticProps = "";
    var dynamicProps = "";

    for (var i = 0; i < props.length; i++) {
      var prop = props[i];
      var value = transformSpecialNewlines(prop.value);

      if (prop.dynamic) {
        dynamicProps += prop.name + "," + value + ",";
      } else {
        staticProps += "\"" + prop.name + "\":" + value + ",";
      }
    }

    staticProps = "{" + staticProps.slice(0, -1) + "}";

    if (dynamicProps) {
      return "_d(" + staticProps + ",[" + dynamicProps.slice(0, -1) + "])";
    } else {
      return staticProps;
    }
  } // #3895, #4268


  function transformSpecialNewlines(text) {
    return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
  }
  /*  */
  // these keywords should not appear inside expressions, but operators like
  // typeof, instanceof and in are allowed


  var prohibitedKeywordRE = new RegExp('\\b' + ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' + 'super,throw,while,yield,delete,export,import,return,switch,default,' + 'extends,finally,continue,debugger,function,arguments').split(',').join('\\b|\\b') + '\\b'); // these unary operators should not be used as property/method names

  var unaryOperatorsRE = new RegExp('\\b' + 'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)'); // strip strings in expressions

  var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g; // detect problematic expressions in a template

  function detectErrors(ast, warn) {
    if (ast) {
      checkNode(ast, warn);
    }
  }

  function checkNode(node, warn) {
    if (node.type === 1) {
      for (var name in node.attrsMap) {
        if (dirRE.test(name)) {
          var value = node.attrsMap[name];

          if (value) {
            var range = node.rawAttrsMap[name];

            if (name === 'v-for') {
              checkFor(node, "v-for=\"" + value + "\"", warn, range);
            } else if (name === 'v-slot' || name[0] === '#') {
              checkFunctionParameterExpression(value, name + "=\"" + value + "\"", warn, range);
            } else if (onRE.test(name)) {
              checkEvent(value, name + "=\"" + value + "\"", warn, range);
            } else {
              checkExpression(value, name + "=\"" + value + "\"", warn, range);
            }
          }
        }
      }

      if (node.children) {
        for (var i = 0; i < node.children.length; i++) {
          checkNode(node.children[i], warn);
        }
      }
    } else if (node.type === 2) {
      checkExpression(node.expression, node.text, warn, node);
    }
  }

  function checkEvent(exp, text, warn, range) {
    var stripped = exp.replace(stripStringRE, '');
    var keywordMatch = stripped.match(unaryOperatorsRE);

    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
      warn("avoid using JavaScript unary operator as property name: " + "\"" + keywordMatch[0] + "\" in expression " + text.trim(), range);
    }

    checkExpression(exp, text, warn, range);
  }

  function checkFor(node, text, warn, range) {
    checkExpression(node.for || '', text, warn, range);
    checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
  }

  function checkIdentifier(ident, type, text, warn, range) {
    if (typeof ident === 'string') {
      try {
        new Function("var " + ident + "=_");
      } catch (e) {
        warn("invalid " + type + " \"" + ident + "\" in expression: " + text.trim(), range);
      }
    }
  }

  function checkExpression(exp, text, warn, range) {
    try {
      new Function("return " + exp);
    } catch (e) {
      var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);

      if (keywordMatch) {
        warn("avoid using JavaScript keyword as property name: " + "\"" + keywordMatch[0] + "\"\n  Raw expression: " + text.trim(), range);
      } else {
        warn("invalid expression: " + e.message + " in\n\n" + "    " + exp + "\n\n" + "  Raw expression: " + text.trim() + "\n", range);
      }
    }
  }

  function checkFunctionParameterExpression(exp, text, warn, range) {
    try {
      new Function(exp, '');
    } catch (e) {
      warn("invalid function parameter expression: " + e.message + " in\n\n" + "    " + exp + "\n\n" + "  Raw expression: " + text.trim() + "\n", range);
    }
  }
  /*  */


  var range = 2;

  function generateCodeFrame(source, start, end) {
    if (start === void 0) start = 0;
    if (end === void 0) end = source.length;
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];

    for (var i = 0; i < lines.length; i++) {
      count += lines[i].length + 1;

      if (count >= start) {
        for (var j = i - range; j <= i + range || end > count; j++) {
          if (j < 0 || j >= lines.length) {
            continue;
          }

          res.push("" + (j + 1) + repeat$1(" ", 3 - String(j + 1).length) + "|  " + lines[j]);
          var lineLength = lines[j].length;

          if (j === i) {
            // push underline
            var pad = start - (count - lineLength) + 1;
            var length = end > count ? lineLength - pad : end - start;
            res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
          } else if (j > i) {
            if (end > count) {
              var length$1 = Math.min(end - count, lineLength);
              res.push("   |  " + repeat$1("^", length$1));
            }

            count += lineLength + 1;
          }
        }

        break;
      }
    }

    return res.join('\n');
  }

  function repeat$1(str, n) {
    var result = '';

    if (n > 0) {
      while (true) {
        // eslint-disable-line
        if (n & 1) {
          result += str;
        }

        n >>>= 1;

        if (n <= 0) {
          break;
        }

        str += str;
      }
    }

    return result;
  }
  /*  */


  function createFunction(code, errors) {
    try {
      return new Function(code);
    } catch (err) {
      errors.push({
        err: err,
        code: code
      });
      return noop;
    }
  }

  function createCompileToFunctionFn(compile) {
    var cache = Object.create(null);
    return function compileToFunctions(template, options, vm) {
      options = extend({}, options);
      var warn$$1 = options.warn || warn;
      delete options.warn;
      /* istanbul ignore if */

      {
        // detect possible CSP restriction
        try {
          new Function('return 1');
        } catch (e) {
          if (e.toString().match(/unsafe-eval|CSP/)) {
            warn$$1('It seems you are using the standalone build of Vue.js in an ' + 'environment with Content Security Policy that prohibits unsafe-eval. ' + 'The template compiler cannot work in this environment. Consider ' + 'relaxing the policy to allow unsafe-eval or pre-compiling your ' + 'templates into render functions.');
          }
        }
      } // check cache

      var key = options.delimiters ? String(options.delimiters) + template : template;

      if (cache[key]) {
        return cache[key];
      } // compile


      var compiled = compile(template, options); // check compilation errors/tips

      {
        if (compiled.errors && compiled.errors.length) {
          if (options.outputSourceRange) {
            compiled.errors.forEach(function (e) {
              warn$$1("Error compiling template:\n\n" + e.msg + "\n\n" + generateCodeFrame(template, e.start, e.end), vm);
            });
          } else {
            warn$$1("Error compiling template:\n\n" + template + "\n\n" + compiled.errors.map(function (e) {
              return "- " + e;
            }).join('\n') + '\n', vm);
          }
        }

        if (compiled.tips && compiled.tips.length) {
          if (options.outputSourceRange) {
            compiled.tips.forEach(function (e) {
              return tip(e.msg, vm);
            });
          } else {
            compiled.tips.forEach(function (msg) {
              return tip(msg, vm);
            });
          }
        }
      } // turn code into functions

      var res = {};
      var fnGenErrors = [];
      res.render = createFunction(compiled.render, fnGenErrors);
      res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
        return createFunction(code, fnGenErrors);
      }); // check function generation errors.
      // this should only happen if there is a bug in the compiler itself.
      // mostly for codegen development use

      /* istanbul ignore if */

      {
        if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
          warn$$1("Failed to generate render function:\n\n" + fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;
            return err.toString() + " in\n\n" + code + "\n";
          }).join('\n'), vm);
        }
      }
      return cache[key] = res;
    };
  }
  /*  */


  function createCompilerCreator(baseCompile) {
    return function createCompiler(baseOptions) {
      function compile(template, options) {
        var finalOptions = Object.create(baseOptions);
        var errors = [];
        var tips = [];

        var warn = function (msg, range, tip) {
          (tip ? tips : errors).push(msg);
        };

        if (options) {
          if (options.outputSourceRange) {
            // $flow-disable-line
            var leadingSpaceLength = template.match(/^\s*/)[0].length;

            warn = function (msg, range, tip) {
              var data = {
                msg: msg
              };

              if (range) {
                if (range.start != null) {
                  data.start = range.start + leadingSpaceLength;
                }

                if (range.end != null) {
                  data.end = range.end + leadingSpaceLength;
                }
              }

              (tip ? tips : errors).push(data);
            };
          } // merge custom modules


          if (options.modules) {
            finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
          } // merge custom directives


          if (options.directives) {
            finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
          } // copy other options


          for (var key in options) {
            if (key !== 'modules' && key !== 'directives') {
              finalOptions[key] = options[key];
            }
          }
        }

        finalOptions.warn = warn;
        var compiled = baseCompile(template.trim(), finalOptions);
        {
          detectErrors(compiled.ast, warn);
        }
        compiled.errors = errors;
        compiled.tips = tips;
        return compiled;
      }

      return {
        compile: compile,
        compileToFunctions: createCompileToFunctionFn(compile)
      };
    };
  }
  /*  */
  // `createCompilerCreator` allows creating compilers that use alternative
  // parser/optimizer/codegen, e.g the SSR optimizing compiler.
  // Here we just export a default compiler using the default parts.


  var createCompiler = createCompilerCreator(function baseCompile(template, options) {
    var ast = parse(template.trim(), options);

    if (options.optimize !== false) {
      optimize(ast, options);
    }

    var code = generate(ast, options);
    return {
      ast: ast,
      render: code.render,
      staticRenderFns: code.staticRenderFns
    };
  });
  /*  */

  var ref$1 = createCompiler(baseOptions);
  var compile = ref$1.compile;
  var compileToFunctions = ref$1.compileToFunctions;
  /*  */
  // check whether current browser encodes a char inside attribute values

  var div;

  function getShouldDecode(href) {
    div = div || document.createElement('div');
    div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
    return div.innerHTML.indexOf('&#10;') > 0;
  } // #3663: IE encodes newlines inside attribute values while other browsers don't


  var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false; // #6828: chrome encodes content in a[href]

  var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;
  /*  */

  var idToTemplate = cached(function (id) {
    var el = query(id);
    return el && el.innerHTML;
  });
  var mount = Vue.prototype.$mount;

  Vue.prototype.$mount = function (el, hydrating) {
    el = el && query(el);
    /* istanbul ignore if */

    if (el === document.body || el === document.documentElement) {
      warn("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
      return this;
    }

    var options = this.$options; // resolve template/el and convert to render function

    if (!options.render) {
      var template = options.template;

      if (template) {
        if (typeof template === 'string') {
          if (template.charAt(0) === '#') {
            template = idToTemplate(template);
            /* istanbul ignore if */

            if (!template) {
              warn("Template element not found or is empty: " + options.template, this);
            }
          }
        } else if (template.nodeType) {
          template = template.innerHTML;
        } else {
          {
            warn('invalid template option:' + template, this);
          }
          return this;
        }
      } else if (el) {
        template = getOuterHTML(el);
      }

      if (template) {
        /* istanbul ignore if */
        if (config.performance && mark) {
          mark('compile');
        }

        var ref = compileToFunctions(template, {
          outputSourceRange: "development" !== 'production',
          shouldDecodeNewlines: shouldDecodeNewlines,
          shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
          delimiters: options.delimiters,
          comments: options.comments
        }, this);
        var render = ref.render;
        var staticRenderFns = ref.staticRenderFns;
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        /* istanbul ignore if */

        if (config.performance && mark) {
          mark('compile end');
          measure("vue " + this._name + " compile", 'compile', 'compile end');
        }
      }
    }

    return mount.call(this, el, hydrating);
  };
  /**
   * Get outerHTML of elements, taking care
   * of SVG elements in IE as well.
   */


  function getOuterHTML(el) {
    if (el.outerHTML) {
      return el.outerHTML;
    } else {
      var container = document.createElement('div');
      container.appendChild(el.cloneNode(true));
      return container.innerHTML;
    }
  }

  Vue.compile = compileToFunctions;
  return Vue;
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../timers-browserify/main.js */ "./node_modules/timers-browserify/main.js").setImmediate))

/***/ }),

/***/ "./node_modules/vuex/dist/vuex.esm.js":
/*!********************************************!*\
  !*** ./node_modules/vuex/dist/vuex.esm.js ***!
  \********************************************/
/*! exports provided: default, Store, createLogger, createNamespacedHelpers, install, mapActions, mapGetters, mapMutations, mapState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLogger", function() { return createLogger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNamespacedHelpers", function() { return createNamespacedHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapActions", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapGetters", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapMutations", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapState", function() { return mapState; });
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin(Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({
      beforeCreate: vuexInit
    });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;

    Vue.prototype._init = function (options) {
      if (options === void 0) options = {};
      options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;

      _init.call(this, options);
    };
  }
  /**
   * Vuex init hook, injected into each instances init hooks list.
   */


  function vuexInit() {
    var options = this.$options; // store injection

    if (options.store) {
      this.$store = typeof options.store === 'function' ? options.store() : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin(store) {
  if (!devtoolHook) {
    return;
  }

  store._devtoolHook = devtoolHook;
  devtoolHook.emit('vuex:init', store);
  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });
  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, {
    prepend: true
  });
  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, {
    prepend: true
  });
}
/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */


function find(list, f) {
  return list.filter(f)[0];
}
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


function deepCopy(obj, cache) {
  if (cache === void 0) cache = []; // just return if obj is immutable value

  if (obj === null || typeof obj !== 'object') {
    return obj;
  } // if obj is hit, it is in circular structure


  var hit = find(cache, function (c) {
    return c.original === obj;
  });

  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {}; // put the copy into cache at first
  // because we want to refer it in recursive deepCopy

  cache.push({
    original: obj,
    copy: copy
  });
  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });
  return copy;
}
/**
 * forEach for object
 */


function forEachValue(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function assert(condition, msg) {
  if (!condition) {
    throw new Error("[vuex] " + msg);
  }
}

function partial(fn, arg) {
  return function () {
    return fn(arg);
  };
} // Base data struct for store's module, package with some attribute and method


var Module = function Module(rawModule, runtime) {
  this.runtime = runtime; // Store some children item

  this._children = Object.create(null); // Store the origin module object which passed by programmer

  this._rawModule = rawModule;
  var rawState = rawModule.state; // Store the origin module's state

  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = {
  namespaced: {
    configurable: true
  }
};

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced;
};

Module.prototype.addChild = function addChild(key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild(key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild(key) {
  return this._children[key];
};

Module.prototype.hasChild = function hasChild(key) {
  return key in this._children;
};

Module.prototype.update = function update(rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;

  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }

  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }

  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild(fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter(fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction(fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation(fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties(Module.prototype, prototypeAccessors);

var ModuleCollection = function ModuleCollection(rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get(path) {
  return path.reduce(function (module, key) {
    return module.getChild(key);
  }, this.root);
};

ModuleCollection.prototype.getNamespace = function getNamespace(path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '');
  }, '');
};

ModuleCollection.prototype.update = function update$1(rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
  var this$1 = this;
  if (runtime === void 0) runtime = true;

  if (true) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);

  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  } // register nested modules


  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if (true) {
      console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
    }

    return;
  }

  if (!child.runtime) {
    return;
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key);
  }

  return false;
};

function update(path, targetModule, newModule) {
  if (true) {
    assertRawModule(path, newModule);
  } // update target module


  targetModule.update(newModule); // update nested modules

  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (true) {
          console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
        }

        return;
      }

      update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
  }
}

var functionAssert = {
  assert: function (value) {
    return typeof value === 'function';
  },
  expected: 'function'
};
var objectAssert = {
  assert: function (value) {
    return typeof value === 'function' || typeof value === 'object' && typeof value.handler === 'function';
  },
  expected: 'function or object with "handler" function'
};
var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule(path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) {
      return;
    }

    var assertOptions = assertTypes[key];
    forEachValue(rawModule[key], function (value, type) {
      assert(assertOptions.assert(value), makeAssertionMessage(path, key, type, value, assertOptions.expected));
    });
  });
}

function makeAssertionMessage(path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";

  if (path.length > 0) {
    buf += " in module \"" + path.join('.') + "\"";
  }

  buf += " is " + JSON.stringify(value) + ".";
  return buf;
}

var Vue; // bind on install

var Store = function Store(options) {
  var this$1 = this;
  if (options === void 0) options = {}; // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731

  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (true) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins;
  if (plugins === void 0) plugins = [];
  var strict = options.strict;
  if (strict === void 0) strict = false; // store internal state

  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null); // bind commit and dispatch to self

  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;

  this.dispatch = function boundDispatch(type, payload) {
    return dispatch.call(store, type, payload);
  };

  this.commit = function boundCommit(type, payload, options) {
    return commit.call(store, type, payload, options);
  }; // strict mode


  this.strict = strict;
  var state = this._modules.root.state; // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters

  installModule(this, state, [], this._modules.root); // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)

  resetStoreVM(this, state); // apply plugins

  plugins.forEach(function (plugin) {
    return plugin(this$1);
  });
  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;

  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = {
  state: {
    configurable: true
  }
};

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state;
};

prototypeAccessors$1.state.set = function (v) {
  if (true) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit(_type, _payload, _options) {
  var this$1 = this; // check object-style commit

  var ref = unifyObjectStyle(_type, _payload, _options);
  var type = ref.type;
  var payload = ref.payload;
  var options = ref.options;
  var mutation = {
    type: type,
    payload: payload
  };
  var entry = this._mutations[type];

  if (!entry) {
    if (true) {
      console.error("[vuex] unknown mutation type: " + type);
    }

    return;
  }

  this._withCommit(function () {
    entry.forEach(function commitIterator(handler) {
      handler(payload);
    });
  });

  this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
  .forEach(function (sub) {
    return sub(mutation, this$1.state);
  });

  if ( true && options && options.silent) {
    console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
  }
};

Store.prototype.dispatch = function dispatch(_type, _payload) {
  var this$1 = this; // check object-style dispatch

  var ref = unifyObjectStyle(_type, _payload);
  var type = ref.type;
  var payload = ref.payload;
  var action = {
    type: type,
    payload: payload
  };
  var entry = this._actions[type];

  if (!entry) {
    if (true) {
      console.error("[vuex] unknown action type: " + type);
    }

    return;
  }

  try {
    this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .filter(function (sub) {
      return sub.before;
    }).forEach(function (sub) {
      return sub.before(action, this$1.state);
    });
  } catch (e) {
    if (true) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1 ? Promise.all(entry.map(function (handler) {
    return handler(payload);
  })) : entry[0](payload);
  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers.filter(function (sub) {
          return sub.after;
        }).forEach(function (sub) {
          return sub.after(action, this$1.state);
        });
      } catch (e) {
        if (true) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }

      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers.filter(function (sub) {
          return sub.error;
        }).forEach(function (sub) {
          return sub.error(action, this$1.state, error);
        });
      } catch (e) {
        if (true) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }

      reject(error);
    });
  });
};

Store.prototype.subscribe = function subscribe(fn, options) {
  return genericSubscribe(fn, this._subscribers, options);
};

Store.prototype.subscribeAction = function subscribeAction(fn, options) {
  var subs = typeof fn === 'function' ? {
    before: fn
  } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options);
};

Store.prototype.watch = function watch(getter, cb, options) {
  var this$1 = this;

  if (true) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }

  return this._watcherVM.$watch(function () {
    return getter(this$1.state, this$1.getters);
  }, cb, options);
};

Store.prototype.replaceState = function replaceState(state) {
  var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule(path, rawModule, options) {
  if (options === void 0) options = {};

  if (typeof path === 'string') {
    path = [path];
  }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);

  installModule(this, this.state, path, this._modules.get(path), options.preserveState); // reset store to update getters...

  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule(path) {
  var this$1 = this;

  if (typeof path === 'string') {
    path = [path];
  }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);

  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });

  resetStore(this);
};

Store.prototype.hasModule = function hasModule(path) {
  if (typeof path === 'string') {
    path = [path];
  }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path);
};

Store.prototype.hotUpdate = function hotUpdate(newOptions) {
  this._modules.update(newOptions);

  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit(fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties(Store.prototype, prototypeAccessors$1);

function genericSubscribe(fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend ? subs.unshift(fn) : subs.push(fn);
  }

  return function () {
    var i = subs.indexOf(fn);

    if (i > -1) {
      subs.splice(i, 1);
    }
  };
}

function resetStore(store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state; // init all modules

  installModule(store, state, [], store._modules.root, true); // reset vm

  resetStoreVM(store, state, hot);
}

function resetStoreVM(store, state, hot) {
  var oldVm = store._vm; // bind store public getters

  store.getters = {}; // reset local getters cache

  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () {
        return store._vm[key];
      },
      enumerable: true // for local getters

    });
  }); // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins

  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent; // enable strict mode for new vm

  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }

    Vue.nextTick(function () {
      return oldVm.$destroy();
    });
  }
}

function installModule(store, rootState, path, module, hot) {
  var isRoot = !path.length;

  var namespace = store._modules.getNamespace(path); // register in namespace map


  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && "development" !== 'production') {
      console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
    }

    store._modulesNamespaceMap[namespace] = module;
  } // set state


  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];

    store._withCommit(function () {
      if (true) {
        if (moduleName in parentState) {
          console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
        }
      }

      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);
  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });
  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });
  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });
  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}
/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */


function makeLocalContext(store, namespace, path) {
  var noNamespace = namespace === '';
  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;

        if ( true && !store._actions[type]) {
          console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
          return;
        }
      }

      return store.dispatch(type, payload);
    },
    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;

        if ( true && !store._mutations[type]) {
          console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
          return;
        }
      }

      store.commit(type, payload, options);
    }
  }; // getters and state object must be gotten lazily
  // because they will be changed by vm update

  Object.defineProperties(local, {
    getters: {
      get: noNamespace ? function () {
        return store.getters;
      } : function () {
        return makeLocalGetters(store, namespace);
      }
    },
    state: {
      get: function () {
        return getNestedState(store.state, path);
      }
    }
  });
  return local;
}

function makeLocalGetters(store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) {
        return;
      } // extract local getter type


      var localType = type.slice(splitPos); // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.

      Object.defineProperty(gettersProxy, localType, {
        get: function () {
          return store.getters[type];
        },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace];
}

function registerMutation(store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler(payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction(store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler(payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);

    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }

    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);

        throw err;
      });
    } else {
      return res;
    }
  });
}

function registerGetter(store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (true) {
      console.error("[vuex] duplicate getter key: " + type);
    }

    return;
  }

  store._wrappedGetters[type] = function wrappedGetter(store) {
    return rawGetter(local.state, // local state
    local.getters, // local getters
    store.state, // root state
    store.getters // root getters
    );
  };
}

function enableStrictMode(store) {
  store._vm.$watch(function () {
    return this._data.$$state;
  }, function () {
    if (true) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, {
    deep: true,
    sync: true
  });
}

function getNestedState(state, path) {
  return path.reduce(function (state, key) {
    return state[key];
  }, state);
}

function unifyObjectStyle(type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (true) {
    assert(typeof type === 'string', "expects string as the type, but found " + typeof type + ".");
  }

  return {
    type: type,
    payload: payload,
    options: options
  };
}

function install(_Vue) {
  if (Vue && _Vue === Vue) {
    if (true) {
      console.error('[vuex] already installed. Vue.use(Vuex) should be called only once.');
    }

    return;
  }

  Vue = _Vue;
  applyMixin(Vue);
}
/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */


var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};

  if ( true && !isValidMap(states)) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }

  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState() {
      var state = this.$store.state;
      var getters = this.$store.getters;

      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);

        if (!module) {
          return;
        }

        state = module.context.state;
        getters = module.context.getters;
      }

      return typeof val === 'function' ? val.call(this, state, getters) : state[val];
    }; // mark vuex getter for devtools


    res[key].vuex = true;
  });
  return res;
});
/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};

  if ( true && !isValidMap(mutations)) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }

  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation() {
      var args = [],
          len = arguments.length;

      while (len--) {
        args[len] = arguments[len];
      } // Get the commit method from store


      var commit = this.$store.commit;

      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);

        if (!module) {
          return;
        }

        commit = module.context.commit;
      }

      return typeof val === 'function' ? val.apply(this, [commit].concat(args)) : commit.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});
/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};

  if ( true && !isValidMap(getters)) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }

  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val; // The namespace has been mutated by normalizeNamespace

    val = namespace + val;

    res[key] = function mappedGetter() {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return;
      }

      if ( true && !(val in this.$store.getters)) {
        console.error("[vuex] unknown getter: " + val);
        return;
      }

      return this.$store.getters[val];
    }; // mark vuex getter for devtools


    res[key].vuex = true;
  });
  return res;
});
/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};

  if ( true && !isValidMap(actions)) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }

  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction() {
      var args = [],
          len = arguments.length;

      while (len--) {
        args[len] = arguments[len];
      } // get dispatch function from store


      var dispatch = this.$store.dispatch;

      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);

        if (!module) {
          return;
        }

        dispatch = module.context.dispatch;
      }

      return typeof val === 'function' ? val.apply(this, [dispatch].concat(args)) : dispatch.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});
/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */

var createNamespacedHelpers = function (namespace) {
  return {
    mapState: mapState.bind(null, namespace),
    mapGetters: mapGetters.bind(null, namespace),
    mapMutations: mapMutations.bind(null, namespace),
    mapActions: mapActions.bind(null, namespace)
  };
};
/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */


function normalizeMap(map) {
  if (!isValidMap(map)) {
    return [];
  }

  return Array.isArray(map) ? map.map(function (key) {
    return {
      key: key,
      val: key
    };
  }) : Object.keys(map).map(function (key) {
    return {
      key: key,
      val: map[key]
    };
  });
}
/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */


function isValidMap(map) {
  return Array.isArray(map) || isObject(map);
}
/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */


function normalizeNamespace(fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }

    return fn(namespace, map);
  };
}
/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */


function getModuleByNamespace(store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];

  if ( true && !module) {
    console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
  }

  return module;
} // Credits: borrowed code from fcomb/redux-logger


function createLogger(ref) {
  if (ref === void 0) ref = {};
  var collapsed = ref.collapsed;
  if (collapsed === void 0) collapsed = true;
  var filter = ref.filter;
  if (filter === void 0) filter = function (mutation, stateBefore, stateAfter) {
    return true;
  };
  var transformer = ref.transformer;
  if (transformer === void 0) transformer = function (state) {
    return state;
  };
  var mutationTransformer = ref.mutationTransformer;
  if (mutationTransformer === void 0) mutationTransformer = function (mut) {
    return mut;
  };
  var actionFilter = ref.actionFilter;
  if (actionFilter === void 0) actionFilter = function (action, state) {
    return true;
  };
  var actionTransformer = ref.actionTransformer;
  if (actionTransformer === void 0) actionTransformer = function (act) {
    return act;
  };
  var logMutations = ref.logMutations;
  if (logMutations === void 0) logMutations = true;
  var logActions = ref.logActions;
  if (logActions === void 0) logActions = true;
  var logger = ref.logger;
  if (logger === void 0) logger = console;
  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return;
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + mutation.type + formattedTime;
          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + action.type + formattedTime;
          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  };
}

function startMessage(logger, message, collapsed) {
  var startMessage = collapsed ? logger.groupCollapsed : logger.group; // render

  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage(logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime() {
  var time = new Date();
  return " @ " + pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
}

function repeat(str, times) {
  return new Array(times + 1).join(str);
}

function pad(num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num;
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};
/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g; // This works in non-strict mode

g = function () {
  return this;
}();

try {
  // This works if eval is allowed (see CSP)
  g = g || new Function("return this")();
} catch (e) {
  // This works if the window reference is available
  if (typeof window === "object") g = window;
} // g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}


module.exports = g;

/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (module) {
  if (!module.webpackPolyfill) {
    module.deprecate = function () {};

    module.paths = []; // module.parent = undefined by default

    if (!module.children) module.children = [];
    Object.defineProperty(module, "loaded", {
      enumerable: true,
      get: function () {
        return module.l;
      }
    });
    Object.defineProperty(module, "id", {
      enumerable: true,
      get: function () {
        return module.i;
      }
    });
    module.webpackPolyfill = 1;
  }

  return module;
};

/***/ }),

/***/ "./src/assets/css/main.css":
/*!*********************************!*\
  !*** ./src/assets/css/main.css ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(/*! ../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__(/*! !../../../node_modules/css-loader/dist/cjs.js?importLoaders!../../../node_modules/postcss-loader/dist/cjs.js!./main.css */ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./src/assets/css/main.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./src/assets/js/lib/accessibility.js":
/*!********************************************!*\
  !*** ./src/assets/js/lib/accessibility.js ***!
  \********************************************/
/*! exports provided: initTabKeyListener, fixTrackingPixelImages */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initTabKeyListener", function() { return initTabKeyListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixTrackingPixelImages", function() { return fixTrackingPixelImages; });
var initTabKeyListener = () => {
  window.addEventListener('mousedown', () => {
    document.body.classList.remove('keyboard-active');
  });
  window.addEventListener('keydown', e => {
    if (e.keyCode === 9) {
      document.body.classList.add('keyboard-active');
    }
  });
};
var fixTrackingPixelImages = () => {
  // eslint-disable-next-line no-undef
  var observer = new MutationObserver(() => {
    var img = document.getElementById('fullthrottlelims_pxl_image_t');

    if (img && !img.hasAttribute('alt')) {
      img.setAttribute('alt', '');
      img.setAttribute('role', 'presentation');
      img.setAttribute('aria-hidden', 'true');
      observer.disconnect();
    }
  });
  var img = document.getElementById('fullthrottlelims_pxl_image_t');

  if (img && !img.hasAttribute('alt')) {
    img.setAttribute('alt', '');
    img.setAttribute('role', 'presentation');
    img.setAttribute('aria-hidden', 'true');
  } else if (!img) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
};

/***/ }),

/***/ "./src/assets/js/lib/appState.js":
/*!***************************************!*\
  !*** ./src/assets/js/lib/appState.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  isSearchOpen: false,
  isMiniCartOpen: false,
  isMiniCartLoaded: false,
  previouslyFocusedElement: null,
  headerSearchToggle: null,
  activeVariant: {},
  priceOverride: null,
  selectedOptions: {},
  cart: window.BARREL.cart,
  lastAdd: false
});

/***/ }),

/***/ "./src/assets/js/lib/cart.js":
/*!***********************************!*\
  !*** ./src/assets/js/lib/cart.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! nanoajax */ "./node_modules/nanoajax/index.js");
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nanoajax__WEBPACK_IMPORTED_MODULE_1__);



class Cart {
  isErrorResponse(data) {
    if (!data) return true;
    return data.status === 422 || Array.isArray(data.errors) && data.errors.length > 0;
  }

  dispatchCartUpdated(cart) {
    if (this.isErrorResponse(cart)) return;
    document.dispatchEvent(new CustomEvent('oishii:cart-updated', {
      detail: {
        cart
      }
    }));
  }

  get() {
    return new Promise(resolve => {
      nanoajax__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
        url: '/cart.js',
        method: 'get'
      }, (code, responseText, request) => {
        var cart = JSON.parse(responseText);
        resolve(cart);
      });
    });
  }

  updateNote(note) {
    return new Promise((resolve, reject) => {
      nanoajax__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
        url: '/cart/update.js',
        method: 'post',
        body: "note=".concat(note)
      }, (code, responseText, request) => {
        var cart = JSON.parse(responseText);

        if (Number(code) !== 200) {
          cart.errors = [cart.description];
        }

        this.dispatchCartUpdated(cart);
        resolve(cart);
      });
    });
  }

  generateShopifyCartChangeBody({
    id,
    quantity
  }) {
    return "quantity=".concat(quantity, "&id=").concat(id);
  }

  change(data) {
    return new Promise((resolve, reject) => {
      nanoajax__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
        url: '/cart/change.js',
        method: 'post',
        body: this.generateShopifyCartChangeBody(data)
      }, (code, responseText, request) => {
        var cart = JSON.parse(responseText);

        if (Number(code) !== 200) {
          cart.errors = [cart.description];
        }

        this.dispatchCartUpdated(cart);
        resolve(cart);
      });
    });
  }

  generateShopifyCartUpdateBody(data) {
    return data instanceof Array ? data.map(({
      id,
      quantity
    }) => "updates[".concat(id, "]=").concat(quantity)).join('&') : "updates[".concat(data.id, "]=").concat(data.quantity);
  }

  update(data) {
    return new Promise((resolve, reject) => {
      nanoajax__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
        url: '/cart/update.js',
        method: 'post',
        body: this.generateShopifyCartUpdateBody(data)
      }, (code, responseText, request) => {
        var cart = JSON.parse(responseText);

        if (Number(code) !== 200) {
          cart.errors = [cart.description];
        }

        this.dispatchCartUpdated(cart);
        resolve(cart);
      });
    });
  }
  /**
   * Update cart note attributes (Zapiet Checkout-Method, Delivery-*, etc.)
   * @param {Record<string, string>} attributes
   */


  updateAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes
      })
    }).then(response => response.json()).then(cart => {
      this.dispatchCartUpdated(cart);
      return cart;
    });
  }
  /**
   * Serialize request body
   *
   * @param {Array} variants [{id: <id>, quantity: <Number>}]
   * @returns {string} HTTP Query
   */


  generateShopifyCartAddBody(variants) {
    return variants.reduce((query, variant, index) => {
      var {
        id,
        quantity,
        properties
      } = variant;
      query += "&items[".concat(index, "][quantity]=").concat(quantity, "&items[").concat(index, "][id]=").concat(id);

      if (!properties || !Object.keys(properties).length) {
        return query;
      }

      return Object.keys(properties).reduce((query, key) => {
        query += "&items[".concat(index, "][properties][").concat(key, "]=").concat(encodeURIComponent(properties[key]));
        return query;
      }, query);
    }, '');
  }
  /**
   * Adds one or multiple variants to the cart
   *
   * @param {Array} variants [{id: <id>, quantity: <Number>}]
   * @returns {Promise} Resolves with the line items object
   */


  add(variants) {
    return new Promise(resolve => {
      nanoajax__WEBPACK_IMPORTED_MODULE_1___default.a.ajax({
        url: '/cart/add.js',
        method: 'post',
        body: this.generateShopifyCartAddBody(variants)
      }, (code, responseText, request) => {
        var cart = JSON.parse(responseText);

        if (!this.isErrorResponse(cart)) {
          this.dispatchCartUpdated(cart);
        }

        resolve(cart);
      });
    });
  }

  normalizeLineItemProperties(properties) {
    if (!properties) return {};
    return Object.keys(properties).reduce((result, key) => {
      var value = properties[key];

      if (value != null && value !== '') {
        result[key] = String(value);
      }

      return result;
    }, {});
  }
  /**
   * Change a line item by key (required when multiple lines share a variant id).
   * @param {{ id: string, quantity: number, properties?: Record<string, string> }} data
   */


  changeLineItem(data) {
    var body = {
      id: data.id,
      quantity: data.quantity
    };

    if (data.properties) {
      body.properties = this.normalizeLineItemProperties(data.properties);
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(response => response.json()).then(cart => {
      if (!this.isErrorResponse(cart)) {
        this.dispatchCartUpdated(cart);
      }

      return cart;
    });
  }
  /**
   * Add quantity to a variant, merging into one line when the variant already exists.
   * Quantity changes are atomic (batch update) so a failed merge cannot empty the cart.
   * @param {{ variantId: number|string, quantity?: number, properties?: Record<string, string> }} options
   */


  addOrMergeVariant({
    variantId,
    quantity = 1,
    properties
  }) {
    var _this = this;

    return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      var normalizedProperties = _this.normalizeLineItemProperties(properties);

      var currentCart = yield _this.get();
      var variantIdNum = Number(variantId);
      var matching = currentCart.items.filter(item => item.variant_id === variantIdNum);

      if (!matching.length) {
        return _this.add([{
          id: variantId,
          quantity,
          properties: normalizedProperties
        }]);
      }

      var totalQuantity = matching.reduce((sum, item) => sum + item.quantity, 0) + quantity;
      var [primaryLine, ...extraLines] = matching;

      if (extraLines.length > 0) {
        var updateResult = yield _this.update([{
          id: primaryLine.key,
          quantity: totalQuantity
        }, ...extraLines.map(line => ({
          id: line.key,
          quantity: 0
        }))]);
        if (_this.isErrorResponse(updateResult)) return updateResult;
      }

      return _this.changeLineItem({
        id: primaryLine.key,
        quantity: totalQuantity,
        properties: normalizedProperties
      });
    })();
  }

}

/* harmony default export */ __webpack_exports__["default"] = (new Cart());

/***/ }),

/***/ "./src/assets/js/lib/countryDialsAndFlags.js":
/*!***************************************************!*\
  !*** ./src/assets/js/lib/countryDialsAndFlags.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ([{
  name: 'Afghanistan',
  dial_code: '+93',
  code: 'AF',
  flag: '🇦🇫'
}, {
  name: 'Albania',
  dial_code: '+355',
  code: 'AL',
  flag: '🇦🇱'
}, {
  name: 'Algeria',
  dial_code: '+213',
  code: 'DZ',
  flag: '🇩🇿'
}, {
  name: 'AmericanSamoa',
  dial_code: '+1684',
  code: 'AS',
  flag: '🇦🇸'
}, {
  name: 'Andorra',
  dial_code: '+376',
  code: 'AD',
  flag: '🇦🇩'
}, {
  name: 'Angola',
  dial_code: '+244',
  code: 'AO',
  flag: '🇦🇴'
}, {
  name: 'Anguilla',
  dial_code: '+1264',
  code: 'AI',
  flag: '🇦🇮'
}, {
  name: 'Antarctica',
  dial_code: '+672',
  code: 'AQ',
  flag: '🇦🇶'
}, {
  name: 'Antigua and Barbuda',
  dial_code: '+1268',
  code: 'AG',
  flag: '🇦🇬'
}, {
  name: 'Argentina',
  dial_code: '+54',
  code: 'AR',
  flag: '🇦🇷'
}, {
  name: 'Armenia',
  dial_code: '+374',
  code: 'AM',
  flag: '🇦🇲'
}, {
  name: 'Aruba',
  dial_code: '+297',
  code: 'AW',
  flag: '🇦🇼'
}, {
  name: 'Australia',
  dial_code: '+61',
  code: 'AU',
  preferred: true,
  flag: '🇦🇺'
}, {
  name: 'Austria',
  dial_code: '+43',
  code: 'AT',
  flag: '🇦🇹'
}, {
  name: 'Azerbaijan',
  dial_code: '+994',
  code: 'AZ',
  flag: '🇦🇿'
}, {
  name: 'Bahamas',
  dial_code: '+1242',
  code: 'BS',
  flag: '🇧🇸'
}, {
  name: 'Bahrain',
  dial_code: '+973',
  code: 'BH',
  flag: '🇧🇭'
}, {
  name: 'Bangladesh',
  dial_code: '+880',
  code: 'BD',
  flag: '🇧🇩'
}, {
  name: 'Barbados',
  dial_code: '+1246',
  code: 'BB',
  flag: '🇧🇧'
}, {
  name: 'Belarus',
  dial_code: '+375',
  code: 'BY',
  flag: '🇧🇾'
}, {
  name: 'Belgium',
  dial_code: '+32',
  code: 'BE',
  flag: '🇧🇪'
}, {
  name: 'Belize',
  dial_code: '+501',
  code: 'BZ',
  flag: '🇧🇿'
}, {
  name: 'Benin',
  dial_code: '+229',
  code: 'BJ',
  flag: '🇧🇯'
}, {
  name: 'Bermuda',
  dial_code: '+1441',
  code: 'BM',
  flag: '🇧🇲'
}, {
  name: 'Bhutan',
  dial_code: '+975',
  code: 'BT',
  flag: '🇧🇹'
}, {
  name: 'Bolivia, Plurinational State of',
  dial_code: '+591',
  code: 'BO',
  flag: '🇧🇴'
}, {
  name: 'Bosnia and Herzegovina',
  dial_code: '+387',
  code: 'BA',
  flag: '🇧🇦'
}, {
  name: 'Botswana',
  dial_code: '+267',
  code: 'BW',
  flag: '🇧🇼'
}, {
  name: 'Brazil',
  dial_code: '+55',
  code: 'BR',
  flag: '🇧🇷'
}, {
  name: 'British Indian Ocean Territory',
  dial_code: '+246',
  code: 'IO',
  flag: '🇮🇴'
}, {
  name: 'Brunei Darussalam',
  dial_code: '+673',
  code: 'BN',
  flag: '🇧🇳'
}, {
  name: 'Bulgaria',
  dial_code: '+359',
  code: 'BG',
  flag: '🇧🇬'
}, {
  name: 'Burkina Faso',
  dial_code: '+226',
  code: 'BF',
  flag: '🇧🇫'
}, {
  name: 'Burundi',
  dial_code: '+257',
  code: 'BI',
  flag: '🇧🇮'
}, {
  name: 'Cambodia',
  dial_code: '+855',
  code: 'KH',
  flag: '🇰🇭'
}, {
  name: 'Cameroon',
  dial_code: '+237',
  code: 'CM',
  flag: '🇨🇲'
}, {
  name: 'Canada',
  dial_code: '+1',
  code: 'CA',
  flag: '🇨🇦'
}, {
  name: 'Cape Verde',
  dial_code: '+238',
  code: 'CV',
  flag: '🇨🇻'
}, {
  name: 'Cayman Islands',
  dial_code: '+345',
  code: 'KY',
  flag: '🇰🇾'
}, {
  name: 'Central African Republic',
  dial_code: '+236',
  code: 'CF',
  flag: '🇨🇫'
}, {
  name: 'Chad',
  dial_code: '+235',
  code: 'TD',
  flag: '🇹🇩'
}, {
  name: 'Chile',
  dial_code: '+56',
  code: 'CL',
  flag: '🇨🇱'
}, {
  name: 'China',
  dial_code: '+86',
  code: 'CN',
  flag: '🇨🇳'
}, {
  name: 'Christmas Island',
  dial_code: '+61',
  code: 'CX',
  flag: '🇨🇽'
}, {
  name: 'Cocos (Keeling) Islands',
  dial_code: '+61',
  code: 'CC',
  flag: '🇨🇨'
}, {
  name: 'Colombia',
  dial_code: '+57',
  code: 'CO',
  flag: '🇨🇴'
}, {
  name: 'Comoros',
  dial_code: '+269',
  code: 'KM',
  flag: '🇰🇲'
}, {
  name: 'Congo',
  dial_code: '+242',
  code: 'CG',
  flag: '🇨🇬'
}, {
  name: 'Congo, The Democratic Republic of the',
  dial_code: '+243',
  code: 'CD',
  flag: '🇨🇩'
}, {
  name: 'Cook Islands',
  dial_code: '+682',
  code: 'CK',
  flag: '🇨🇰'
}, {
  name: 'Costa Rica',
  dial_code: '+506',
  code: 'CR',
  flag: '🇨🇷'
}, {
  name: "Cote d'Ivoire",
  dial_code: '+225',
  code: 'CI',
  flag: '🇨🇮'
}, {
  name: 'Croatia',
  dial_code: '+385',
  code: 'HR',
  flag: '🇭🇷'
}, {
  name: 'Cuba',
  dial_code: '+53',
  code: 'CU',
  flag: '🇨🇺'
}, {
  name: 'Cyprus',
  dial_code: '+357',
  code: 'CY',
  flag: '🇨🇾'
}, {
  name: 'Czech Republic',
  dial_code: '+420',
  code: 'CZ',
  flag: '🇨🇿'
}, {
  name: 'Denmark',
  dial_code: '+45',
  code: 'DK',
  flag: '🇩🇰'
}, {
  name: 'Djibouti',
  dial_code: '+253',
  code: 'DJ',
  flag: '🇩🇯'
}, {
  name: 'Dominica',
  dial_code: '+1767',
  code: 'DM',
  flag: '🇩🇲'
}, {
  name: 'Dominican Republic',
  dial_code: '+1849',
  code: 'DO',
  flag: '🇩🇴'
}, {
  name: 'Ecuador',
  dial_code: '+593',
  code: 'EC',
  flag: '🇪🇨'
}, {
  name: 'Egypt',
  dial_code: '+20',
  code: 'EG',
  flag: '🇪🇬'
}, {
  name: 'El Salvador',
  dial_code: '+503',
  code: 'SV',
  flag: '🇸🇻'
}, {
  name: 'Equatorial Guinea',
  dial_code: '+240',
  code: 'GQ',
  flag: '🇬🇶'
}, {
  name: 'Eritrea',
  dial_code: '+291',
  code: 'ER',
  flag: '🇪🇷'
}, {
  name: 'Estonia',
  dial_code: '+372',
  code: 'EE',
  flag: '🇪🇪'
}, {
  name: 'Ethiopia',
  dial_code: '+251',
  code: 'ET',
  flag: '🇪🇹'
}, {
  name: 'Falkland Islands (Malvinas)',
  dial_code: '+500',
  code: 'FK',
  flag: '🇫🇰'
}, {
  name: 'Faroe Islands',
  dial_code: '+298',
  code: 'FO',
  flag: '🇫🇴'
}, {
  name: 'Fiji',
  dial_code: '+679',
  code: 'FJ',
  flag: '🇫🇯'
}, {
  name: 'Finland',
  dial_code: '+358',
  code: 'FI',
  flag: '🇫🇮'
}, {
  name: 'France',
  dial_code: '+33',
  code: 'FR',
  flag: '🇫🇷'
}, {
  name: 'French Guiana',
  dial_code: '+594',
  code: 'GF',
  flag: '🇬🇫'
}, {
  name: 'French Polynesia',
  dial_code: '+689',
  code: 'PF',
  flag: '🇵🇫'
}, {
  name: 'Gabon',
  dial_code: '+241',
  code: 'GA',
  flag: '🇬🇦'
}, {
  name: 'Gambia',
  dial_code: '+220',
  code: 'GM',
  flag: '🇬🇲'
}, {
  name: 'Georgia',
  dial_code: '+995',
  code: 'GE',
  flag: '🇬🇪'
}, {
  name: 'Germany',
  dial_code: '+49',
  code: 'DE',
  flag: '🇩🇪'
}, {
  name: 'Ghana',
  dial_code: '+233',
  code: 'GH',
  flag: '🇬🇭'
}, {
  name: 'Gibraltar',
  dial_code: '+350',
  code: 'GI',
  flag: '🇬🇮'
}, {
  name: 'Greece',
  dial_code: '+30',
  code: 'GR',
  flag: '🇬🇷'
}, {
  name: 'Greenland',
  dial_code: '+299',
  code: 'GL',
  flag: '🇬🇱'
}, {
  name: 'Grenada',
  dial_code: '+1473',
  code: 'GD',
  flag: '🇬🇩'
}, {
  name: 'Guadeloupe',
  dial_code: '+590',
  code: 'GP',
  flag: '🇬🇵'
}, {
  name: 'Guam',
  dial_code: '+1671',
  code: 'GU',
  flag: '🇬🇺'
}, {
  name: 'Guatemala',
  dial_code: '+502',
  code: 'GT',
  flag: '🇬🇹'
}, {
  name: 'Guernsey',
  dial_code: '+44',
  code: 'GG',
  flag: '🇬🇬'
}, {
  name: 'Guinea',
  dial_code: '+224',
  code: 'GN',
  flag: '🇬🇳'
}, {
  name: 'Guinea-Bissau',
  dial_code: '+245',
  code: 'GW',
  flag: '🇬🇼'
}, {
  name: 'Guyana',
  dial_code: '+592',
  code: 'GY',
  flag: '🇬🇾'
}, {
  name: 'Haiti',
  dial_code: '+509',
  code: 'HT',
  flag: '🇭🇹'
}, {
  name: 'Holy See (Vatican City State)',
  dial_code: '+379',
  code: 'VA',
  flag: '🇻🇦'
}, {
  name: 'Honduras',
  dial_code: '+504',
  code: 'HN',
  flag: '🇭🇳'
}, {
  name: 'Hong Kong',
  dial_code: '+852',
  code: 'HK',
  flag: '🇭🇰'
}, {
  name: 'Hungary',
  dial_code: '+36',
  code: 'HU',
  flag: '🇭🇺'
}, {
  name: 'Iceland',
  dial_code: '+354',
  code: 'IS',
  flag: '🇮🇸'
}, {
  name: 'India',
  dial_code: '+91',
  code: 'IN',
  preferred: true,
  flag: '🇮🇳'
}, {
  name: 'Indonesia',
  dial_code: '+62',
  code: 'ID',
  flag: '🇮🇩'
}, {
  name: 'Iran, Islamic Republic of',
  dial_code: '+98',
  code: 'IR',
  flag: '🇮🇷'
}, {
  name: 'Iraq',
  dial_code: '+964',
  code: 'IQ',
  flag: '🇮🇶'
}, {
  name: 'Ireland',
  dial_code: '+353',
  code: 'IE',
  flag: '🇮🇪'
}, {
  name: 'Isle of Man',
  dial_code: '+44',
  code: 'IM',
  flag: '🇮🇲'
}, {
  name: 'Israel',
  dial_code: '+972',
  code: 'IL',
  flag: '🇮🇱'
}, {
  name: 'Italy',
  dial_code: '+39',
  code: 'IT',
  flag: '🇮🇹'
}, {
  name: 'Jamaica',
  dial_code: '+1876',
  code: 'JM',
  flag: '🇯🇲'
}, {
  name: 'Japan',
  dial_code: '+81',
  code: 'JP',
  flag: '🇯🇵'
}, {
  name: 'Jersey',
  dial_code: '+44',
  code: 'JE',
  flag: '🇯🇪'
}, {
  name: 'Jordan',
  dial_code: '+962',
  code: 'JO',
  flag: '🇯🇴'
}, {
  name: 'Kazakhstan',
  dial_code: '+77',
  code: 'KZ',
  flag: '🇰🇿'
}, {
  name: 'Kenya',
  dial_code: '+254',
  code: 'KE',
  flag: '🇰🇪'
}, {
  name: 'Kiribati',
  dial_code: '+686',
  code: 'KI',
  flag: '🇰🇮'
}, {
  name: "Korea, Democratic People's Republic of",
  dial_code: '+850',
  code: 'KP',
  flag: '🇰🇵'
}, {
  name: 'Korea, Republic of',
  dial_code: '+82',
  code: 'KR',
  flag: '🇰🇷'
}, {
  name: 'Kuwait',
  dial_code: '+965',
  code: 'KW',
  flag: '🇰🇼'
}, {
  name: 'Kyrgyzstan',
  dial_code: '+996',
  code: 'KG',
  flag: '🇰🇬'
}, {
  name: "Lao People's Democratic Republic",
  dial_code: '+856',
  code: 'LA',
  flag: '🇱🇦'
}, {
  name: 'Latvia',
  dial_code: '+371',
  code: 'LV',
  flag: '🇱🇻'
}, {
  name: 'Lebanon',
  dial_code: '+961',
  code: 'LB',
  flag: '🇱🇧'
}, {
  name: 'Lesotho',
  dial_code: '+266',
  code: 'LS',
  flag: '🇱🇸'
}, {
  name: 'Liberia',
  dial_code: '+231',
  code: 'LR',
  flag: '🇱🇷'
}, {
  name: 'Libyan Arab Jamahiriya',
  dial_code: '+218',
  code: 'LY',
  flag: '🇱🇾'
}, {
  name: 'Liechtenstein',
  dial_code: '+423',
  code: 'LI',
  flag: '🇱🇮'
}, {
  name: 'Lithuania',
  dial_code: '+370',
  code: 'LT',
  flag: '🇱🇹'
}, {
  name: 'Luxembourg',
  dial_code: '+352',
  code: 'LU',
  flag: '🇱🇺'
}, {
  name: 'Macao',
  dial_code: '+853',
  code: 'MO',
  flag: '🇲🇴'
}, {
  name: 'Macedonia, The Former Yugoslav Republic of',
  dial_code: '+389',
  code: 'MK',
  flag: '🇲🇰'
}, {
  name: 'Madagascar',
  dial_code: '+261',
  code: 'MG',
  flag: '🇲🇬'
}, {
  name: 'Malawi',
  dial_code: '+265',
  code: 'MW',
  flag: '🇲🇼'
}, {
  name: 'Malaysia',
  dial_code: '+60',
  code: 'MY',
  flag: '🇲🇾'
}, {
  name: 'Maldives',
  dial_code: '+960',
  code: 'MV',
  flag: '🇲🇻'
}, {
  name: 'Mali',
  dial_code: '+223',
  code: 'ML',
  flag: '🇲🇱'
}, {
  name: 'Malta',
  dial_code: '+356',
  code: 'MT',
  flag: '🇲🇹'
}, {
  name: 'Marshall Islands',
  dial_code: '+692',
  code: 'MH',
  flag: '🇲🇭'
}, {
  name: 'Martinique',
  dial_code: '+596',
  code: 'MQ',
  flag: '🇲🇶'
}, {
  name: 'Mauritania',
  dial_code: '+222',
  code: 'MR',
  flag: '🇲🇷'
}, {
  name: 'Mauritius',
  dial_code: '+230',
  code: 'MU',
  flag: '🇲🇺'
}, {
  name: 'Mayotte',
  dial_code: '+262',
  code: 'YT',
  flag: '🇾🇹'
}, {
  name: 'Mexico',
  dial_code: '+52',
  code: 'MX',
  flag: '🇲🇽'
}, {
  name: 'Micronesia, Federated States of',
  dial_code: '+691',
  code: 'FM',
  flag: '🇫🇲'
}, {
  name: 'Moldova, Republic of',
  dial_code: '+373',
  code: 'MD',
  flag: '🇲🇩'
}, {
  name: 'Monaco',
  dial_code: '+377',
  code: 'MC',
  flag: '🇲🇨'
}, {
  name: 'Mongolia',
  dial_code: '+976',
  code: 'MN',
  flag: '🇲🇳'
}, {
  name: 'Montenegro',
  dial_code: '+382',
  code: 'ME',
  flag: '🇲🇪'
}, {
  name: 'Montserrat',
  dial_code: '+1664',
  code: 'MS',
  flag: '🇲🇸'
}, {
  name: 'Morocco',
  dial_code: '+212',
  code: 'MA',
  flag: '🇲🇦'
}, {
  name: 'Mozambique',
  dial_code: '+258',
  code: 'MZ',
  flag: '🇲🇿'
}, {
  name: 'Myanmar',
  dial_code: '+95',
  code: 'MM',
  flag: '🇲🇲'
}, {
  name: 'Namibia',
  dial_code: '+264',
  code: 'NA',
  flag: '🇳🇦'
}, {
  name: 'Nauru',
  dial_code: '+674',
  code: 'NR',
  flag: '🇳🇷'
}, {
  name: 'Nepal',
  dial_code: '+977',
  code: 'NP',
  flag: '🇳🇵'
}, {
  name: 'Netherlands',
  dial_code: '+31',
  code: 'NL',
  flag: '🇳🇱'
}, {
  name: 'Netherlands Antilles',
  dial_code: '+599',
  code: 'AN',
  flag: '🇦🇳'
}, {
  name: 'New Caledonia',
  dial_code: '+687',
  code: 'NC',
  flag: '🇳🇨'
}, {
  name: 'New Zealand',
  dial_code: '+64',
  code: 'NZ',
  flag: '🇳🇿'
}, {
  name: 'Nicaragua',
  dial_code: '+505',
  code: 'NI',
  flag: '🇳🇮'
}, {
  name: 'Niger',
  dial_code: '+227',
  code: 'NE',
  flag: '🇳🇪'
}, {
  name: 'Nigeria',
  dial_code: '+234',
  code: 'NG',
  flag: '🇳🇬'
}, {
  name: 'Niue',
  dial_code: '+683',
  code: 'NU',
  flag: '🇳🇺'
}, {
  name: 'Norfolk Island',
  dial_code: '+672',
  code: 'NF',
  flag: '🇳🇫'
}, {
  name: 'Northern Mariana Islands',
  dial_code: '+1670',
  code: 'MP',
  flag: '🇲🇵'
}, {
  name: 'Norway',
  dial_code: '+47',
  code: 'NO',
  flag: '🇳🇴'
}, {
  name: 'Oman',
  dial_code: '+968',
  code: 'OM',
  flag: '🇴🇲'
}, {
  name: 'Pakistan',
  dial_code: '+92',
  code: 'PK',
  flag: '🇵🇰'
}, {
  name: 'Palau',
  dial_code: '+680',
  code: 'PW',
  flag: '🇵🇼'
}, {
  name: 'Palestinian Territory, Occupied',
  dial_code: '+970',
  code: 'PS',
  flag: '🇵🇸'
}, {
  name: 'Panama',
  dial_code: '+507',
  code: 'PA',
  flag: '🇵🇦'
}, {
  name: 'Papua New Guinea',
  dial_code: '+675',
  code: 'PG',
  flag: '🇵🇬'
}, {
  name: 'Paraguay',
  dial_code: '+595',
  code: 'PY',
  flag: '🇵🇾'
}, {
  name: 'Peru',
  dial_code: '+51',
  code: 'PE',
  flag: '🇵🇪'
}, {
  name: 'Philippines',
  dial_code: '+63',
  code: 'PH',
  flag: '🇵🇭'
}, {
  name: 'Pitcairn',
  dial_code: '+872',
  code: 'PN',
  flag: '🇵🇳'
}, {
  name: 'Poland',
  dial_code: '+48',
  code: 'PL',
  flag: '🇵🇱'
}, {
  name: 'Portugal',
  dial_code: '+351',
  code: 'PT',
  flag: '🇵🇹'
}, {
  name: 'Puerto Rico',
  dial_code: '+1939',
  code: 'PR',
  flag: '🇵🇷'
}, {
  name: 'Qatar',
  dial_code: '+974',
  code: 'QA',
  flag: '🇶🇦'
}, {
  name: 'Romania',
  dial_code: '+40',
  code: 'RO',
  flag: '🇷🇴'
}, {
  name: 'Russia',
  dial_code: '+7',
  code: 'RU',
  flag: '🇷🇺'
}, {
  name: 'Rwanda',
  dial_code: '+250',
  code: 'RW',
  flag: '🇷🇼'
}, {
  name: 'Réunion',
  dial_code: '+262',
  code: 'RE',
  flag: '🇷🇪'
}, {
  name: 'Saint Barthélemy',
  dial_code: '+590',
  code: 'BL',
  flag: '🇧🇱'
}, {
  name: 'Saint Helena, Ascension and Tristan Da Cunha',
  dial_code: '+290',
  code: 'SH',
  flag: '🇸🇭'
}, {
  name: 'Saint Kitts and Nevis',
  dial_code: '+1869',
  code: 'KN',
  flag: '🇰🇳'
}, {
  name: 'Saint Lucia',
  dial_code: '+1758',
  code: 'LC',
  flag: '🇱🇨'
}, {
  name: 'Saint Martin',
  dial_code: '+590',
  code: 'MF',
  flag: '🇲🇫'
}, {
  name: 'Saint Pierre and Miquelon',
  dial_code: '+508',
  code: 'PM',
  flag: '🇵🇲'
}, {
  name: 'Saint Vincent and the Grenadines',
  dial_code: '+1784',
  code: 'VC',
  flag: '🇻🇨'
}, {
  name: 'Samoa',
  dial_code: '+685',
  code: 'WS',
  flag: '🇼🇸'
}, {
  name: 'San Marino',
  dial_code: '+378',
  code: 'SM',
  flag: '🇸🇲'
}, {
  name: 'Sao Tome and Principe',
  dial_code: '+239',
  code: 'ST',
  flag: '🇸🇹'
}, {
  name: 'Saudi Arabia',
  dial_code: '+966',
  code: 'SA',
  flag: '🇸🇦'
}, {
  name: 'Senegal',
  dial_code: '+221',
  code: 'SN',
  flag: '🇸🇳'
}, {
  name: 'Serbia',
  dial_code: '+381',
  code: 'RS',
  flag: '🇷🇸'
}, {
  name: 'Seychelles',
  dial_code: '+248',
  code: 'SC',
  flag: '🇸🇨'
}, {
  name: 'Sierra Leone',
  dial_code: '+232',
  code: 'SL',
  flag: '🇸🇱'
}, {
  name: 'Singapore',
  dial_code: '+65',
  code: 'SG',
  flag: '🇸🇬'
}, {
  name: 'Slovakia',
  dial_code: '+421',
  code: 'SK',
  flag: '🇸🇰'
}, {
  name: 'Slovenia',
  dial_code: '+386',
  code: 'SI',
  flag: '🇸🇮'
}, {
  name: 'Solomon Islands',
  dial_code: '+677',
  code: 'SB',
  flag: '🇸🇧'
}, {
  name: 'Somalia',
  dial_code: '+252',
  code: 'SO',
  flag: '🇸🇴'
}, {
  name: 'South Africa',
  dial_code: '+27',
  code: 'ZA',
  flag: '🇿🇦'
}, {
  name: 'South Georgia and the South Sandwich Islands',
  dial_code: '+500',
  code: 'GS',
  flag: '🇬🇸'
}, {
  name: 'Spain',
  dial_code: '+34',
  code: 'ES',
  flag: '🇪🇸'
}, {
  name: 'Sri Lanka',
  dial_code: '+94',
  code: 'LK',
  flag: '🇱🇰'
}, {
  name: 'Sudan',
  dial_code: '+249',
  code: 'SD',
  flag: '🇸🇩'
}, {
  name: 'South Sudan',
  dial_code: '+211',
  code: 'SS',
  flag: '🇸🇸'
}, {
  name: 'Suriname',
  dial_code: '+597',
  code: 'SR',
  flag: '🇸🇷'
}, {
  name: 'Svalbard and Jan Mayen',
  dial_code: '+47',
  code: 'SJ',
  flag: '🇸🇯'
}, {
  name: 'Swaziland',
  dial_code: '+268',
  code: 'SZ',
  flag: '🇸🇿'
}, {
  name: 'Sweden',
  dial_code: '+46',
  code: 'SE',
  flag: '🇸🇪'
}, {
  name: 'Switzerland',
  dial_code: '+41',
  code: 'CH',
  flag: '🇨🇭'
}, {
  name: 'Syrian Arab Republic',
  dial_code: '+963',
  code: 'SY',
  flag: '🇸🇾'
}, {
  name: 'Taiwan, Province of China',
  dial_code: '+886',
  code: 'TW',
  flag: '🇹🇼'
}, {
  name: 'Tajikistan',
  dial_code: '+992',
  code: 'TJ',
  flag: '🇹🇯'
}, {
  name: 'Tanzania, United Republic of',
  dial_code: '+255',
  code: 'TZ',
  flag: '🇹🇿'
}, {
  name: 'Thailand',
  dial_code: '+66',
  code: 'TH',
  flag: '🇹🇭'
}, {
  name: 'Timor-Leste',
  dial_code: '+670',
  code: 'TL',
  flag: '🇹🇱'
}, {
  name: 'Togo',
  dial_code: '+228',
  code: 'TG',
  flag: '🇹🇬'
}, {
  name: 'Tokelau',
  dial_code: '+690',
  code: 'TK',
  flag: '🇹🇰'
}, {
  name: 'Tonga',
  dial_code: '+676',
  code: 'TO',
  flag: '🇹🇴'
}, {
  name: 'Trinidad and Tobago',
  dial_code: '+1868',
  code: 'TT',
  flag: '🇹🇹'
}, {
  name: 'Tunisia',
  dial_code: '+216',
  code: 'TN',
  flag: '🇹🇳'
}, {
  name: 'Turkey',
  dial_code: '+90',
  code: 'TR',
  flag: '🇹🇷'
}, {
  name: 'Turkmenistan',
  dial_code: '+993',
  code: 'TM',
  flag: '🇹🇲'
}, {
  name: 'Turks and Caicos Islands',
  dial_code: '+1649',
  code: 'TC',
  flag: '🇹🇨'
}, {
  name: 'Tuvalu',
  dial_code: '+688',
  code: 'TV',
  flag: '🇹🇻'
}, {
  name: 'Uganda',
  dial_code: '+256',
  code: 'UG',
  flag: '🇺🇬'
}, {
  name: 'Ukraine',
  dial_code: '+380',
  code: 'UA',
  flag: '🇺🇦'
}, {
  name: 'United Arab Emirates',
  dial_code: '+971',
  code: 'AE',
  preferred: true,
  flag: '🇦🇪'
}, {
  name: 'United Kingdom',
  dial_code: '+44',
  code: 'GB',
  preferred: true,
  flag: '🇬🇧'
}, {
  name: 'United States',
  dial_code: '+1',
  code: 'US',
  preferred: true,
  flag: '🇺🇸'
}, {
  name: 'Uruguay',
  dial_code: '+598',
  code: 'UY',
  flag: '🇺🇾'
}, {
  name: 'Uzbekistan',
  dial_code: '+998',
  code: 'UZ',
  flag: '🇺🇿'
}, {
  name: 'Vanuatu',
  dial_code: '+678',
  code: 'VU',
  flag: '🇻🇺'
}, {
  name: 'Venezuela, Bolivarian Republic of',
  dial_code: '+58',
  code: 'VE',
  flag: '🇻🇪'
}, {
  name: 'Viet Nam',
  dial_code: '+84',
  code: 'VN',
  flag: '🇻🇳'
}, {
  name: 'Virgin Islands, British',
  dial_code: '+1284',
  code: 'VG',
  flag: '🇻🇬'
}, {
  name: 'Virgin Islands, U.S.',
  dial_code: '+1340',
  code: 'VI',
  flag: '🇻🇮'
}, {
  name: 'Wallis and Futuna',
  dial_code: '+681',
  code: 'WF',
  flag: '🇼🇫'
}, {
  name: 'Yemen',
  dial_code: '+967',
  code: 'YE',
  flag: '🇾🇪'
}, {
  name: 'Zambia',
  dial_code: '+260',
  code: 'ZM',
  flag: '🇿🇲'
}, {
  name: 'Zimbabwe',
  dial_code: '+263',
  code: 'ZW',
  flag: '🇿🇼'
}, {
  name: 'Åland Islands',
  dial_code: '+358',
  code: 'AX',
  flag: '🇦🇽'
}]);

/***/ }),

/***/ "./src/assets/js/lib/dom.js":
/*!**********************************!*\
  !*** ./src/assets/js/lib/dom.js ***!
  \**********************************/
/*! exports provided: addClass, append, appendHtml, createElement, createNodes, closest, delegate, doesSupportObjectFit, getAttribute, getChildren, getHeight, getTopOffset, getTopPosition, getData, getModuleOptions, getParent, getScrollTop, getStyle, getValue, hasClass, hide, on, off, onPassive, onCapture, loadScript, matches, preventDefault, ready, remove, removeAttribute, removeClass, select, selectAll, setAttribute, setData, setStyle, toggleClass, triggerReflow, trigger, isIosDevice, handleize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addClass", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "append", function() { return append; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendHtml", function() { return appendHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNodes", function() { return createNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closest", function() { return closest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delegate", function() { return delegate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doesSupportObjectFit", function() { return doesSupportObjectFit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttribute", function() { return getAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getChildren", function() { return getChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHeight", function() { return getHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTopOffset", function() { return getTopOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTopPosition", function() { return getTopPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getData", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModuleOptions", function() { return getModuleOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getParent", function() { return getParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getScrollTop", function() { return getScrollTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStyle", function() { return getStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValue", function() { return getValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasClass", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hide", function() { return hide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onPassive", function() { return onPassive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onCapture", function() { return onCapture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadScript", function() { return loadScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return matches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preventDefault", function() { return preventDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ready", function() { return ready; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeAttribute", function() { return removeAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeClass", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectAll", function() { return selectAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttribute", function() { return setAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setData", function() { return setData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStyle", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleClass", function() { return toggleClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triggerReflow", function() { return triggerReflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trigger", function() { return trigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIosDevice", function() { return isIosDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleize", function() { return handleize; });
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* global Promise, getComputedStyle, CustomEvent */


var _getElementRect = el => el.getBoundingClientRect();
/**
 * Add class to a list of elements. This is a curried function.
 *
 * @param {string} className
 * @param {Array<HTMLElement>} els
 * @return {Array<HTMLElement>} Same elements for chaining
 */


var addClass = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((className, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(el => {
  el.classList.add(className);
  return el;
}, els));
var append = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((parent, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(el => parent.appendChild(el), els));

var appendHtml = (el, html) => {
  el.insertAdjacentHTML('beforeend', html);
  return el;
};

var createNodes = html => {
  var wrapper = document.createElement('div');
  appendHtml(wrapper, html);
  return getChildren(wrapper);
};

var preventDefault = e => {
  e.preventDefault();
  return e;
};
/**
 * Set style for an element.
 *
 * This is a curried function.
 *
 * @param {string} k Style name
 * @param {string} v Style value
 * @param {HTMLElement} el Element
 * @return {HTMLElement}
 */


var setStyle = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((k, v, el) => {
  el.style[k] = v;
  return el;
});
var hide = setStyle('display', 'none');
/**
 * Get a style for an element.
 *
 * This is a curried function.
 *
 * @param {string} k Style name
 * @param {HTMLElement} el
 * @return {string}
 */

var getStyle = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((k, el) => getComputedStyle(el)[k]);
/**
 * Get actual height of an element, including padding
 *
 * @param {HTMLElement} el
 * @return {number}
 */

var getHeight = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["getProp"])('clientHeight');
/**
 * Get scroll top position of an element.
 *
 * Default to getting scrolling position of the viewport
 *
 * @param {HTMLElement} el
 * @return {number}
 */

var getScrollTop = (el = document.documentElement) => el === document.documentElement ? window.pageYOffset || el.scrollTop : el.scrollTop;
/**
 * Check to see if an element has a specified class.
 *
 * @param {string} className
 * @param {HTMLElement} el
 */


var hasClass = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((className, el) => el.classList.contains(className));
/**
 * Get attribute value for an element.
 *
 * @param {string} name
 * @param {HTMLElement} el
 * @return {string}
 * @private
 */

var _getAttribute = (name, el) => el.getAttribute(name);
/**
 * Get attribute value for an element.
 *
 * This is a curried function
 *
 * @param {string} name
 * @param {HTMLElement} el
 * @return {string}
 */


var getAttribute = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])(_getAttribute);
var setAttribute = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((name, value, el) => {
  el.setAttribute(name, value);
  return el;
});
var removeAttribute = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((name, el) => {
  el.removeAttribute(name);
});
/**
 * Get data attribute.
 *
 * @param {string} name
 * @param {HTMLElement} el
 * @return {string} Parsed JSON value or object
 * @private
 */

var _getData = (name, el) => _getAttribute('data-' + name, el);
/**
 * Get data attribute.
 *
 * This is a curried function
 *
 * @param {string} name
 * @param {HTMLElement} el
 * @return {string}
 */


var getData = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])(_getData);
var setData = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((name, value, el) => setAttribute('data-' + name, value, el));
/**
 * Attach event handler for a single event
 *
 * @param {string} event
 * @param {Function} handler
 * @param {Object} capture
 * @param {HTMLElement} el
 * @returns {HTMLElement}
 * @private
 */

var _on = (event, handler, capture, el) => {
  el.addEventListener(event, handler, capture);
  return el;
};

var _off = (event, handler, capture, el) => {
  el.removeEventListener(event, handler, capture);
  return el;
};

var matches = (selector, el) => {
  var funcs = ['matches', 'matchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector', 'webkitMatchesSelector'];

  for (var func of funcs) {
    if (typeof el[func] === 'function') {
      return el[func](selector);
    }
  }

  return false;
};
/**
 * Attach event handler for a list of events.
 *
 * This is a curried function
 *
 * @param {Array|Object} els Array or array-like object
 * @param {string} event
 * @param {Function} handler
 * @return {Array<HTMLElement>}
 */


var on = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((event, handler, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["partial"])(_on, event, handler, {}), els));
var off = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((event, handler, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["partial"])(_off, event, handler, {}), els));
var onPassive = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((event, handler, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["partial"])(_on, event, handler, {
  passive: true
}), els));
var onCapture = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((event, handler, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["partial"])(_on, event, handler, true), els));
/**
 * Check to see if document has loaded
 *
 * @return {boolean}
 * @private
 */

var _domLoaded = () => document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading';
/**
 * Call function when document is ready
 *
 * @param {Function} f
 */


var ready = f => _domLoaded() ? f() : on('DOMContentLoaded', f, document);

var closest = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((selector, el) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["whileDo"])(target => target && !matches(selector, target) && target.parentNode, target => target.parentNode === document ? null : target.parentNode, el.parentNode));

var _delegate = (event, handler, selector, el) => _on(event, e => {
  var matchedElement = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["whileDo"])(target => target && target !== document && !matches(selector, target) && target.parentNode, target => target.parentNode, e.target);

  if (matchedElement !== document && matches(selector, matchedElement)) {
    handler.apply(el, [e]);
  }
}, {}, el);

var delegate = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((event, handler, selector, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["partial"])(_delegate, event, handler, selector), els));
/**
 * Remove class from a list of elements. This is a curried function.
 *
 * @param {string} className
 * @param {Array<HTMLElement>} els
 * @return {Array<HTMLElement>} Same elements for chaining
 */

var removeClass = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((className, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(el => {
  el.classList.remove(className);
  return el;
}, els));
var toggleClass = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["curry"])((className, els) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(el => {
  el.classList.toggle(className);
  return el;
}, els));
/**
 * Select one element matching a selector, which is also decendant of a parent element (defaults to document)
 * @param {string} selector
 * @param {HTMLElement|HTMLDocument=} parent
 * @return {HTMLElement}
 */

var select = (selector, parent = document) => parent.querySelector(selector);
/**
 * Select all elements matching a selector, which are also decendant of a parent element (defaults to document)
 * @param {string} selector
 * @param {HTMLElement|HTMLDocument=} parent
 * @return {Array<HTMLElement>}
 */


var selectAll = (selector, parent = document) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["makeArray"])(parent.querySelectorAll(selector));

var getChildren = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["pipe"])(Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["getProp"])('children'), lib_util__WEBPACK_IMPORTED_MODULE_0__["makeArray"]);
var getParent = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["getProp"])('parentNode');

var getTopOffset = el => _getElementRect(el).top + getScrollTop();

var getTopPosition = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["getProp"])('offsetTop');
/**
 * Trigger reflows so that transition happens after DOM insertion
 */

var triggerReflow = els => {
  Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["map"])(Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["getProp"])('offsetHeight'), els);
  return els;
};

var doesSupportObjectFit = () => typeof document.documentElement.style.objectFit !== 'undefined' || typeof document.documentElement.style['object-fit'] !== 'undefined';

var trigger = (eventName, el, data = {}) => {
  var event;

  if (typeof window.CustomEvent === 'function') {
    event = new CustomEvent(eventName, {
      detail: data
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, data);
  }

  el.dispatchEvent(event);
  return el;
};

var createElement = tag => document.createElement(tag);

var createScriptTag = (src, async = true, defer = true) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["pipe"])(createElement, Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["setProp"])('src', src), Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["setProp"])('async', async), Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["setProp"])('defer', defer))('script');

var loadScript = (src, async = true, defer = true) => new Promise((resolve, reject) => {
  var tag = createScriptTag(src, async, defer);
  tag.onload = resolve;
  tag.onerror = reject;
  append(document.body, tag);
});

var getModuleOptions = (moduleName, el, def = {}) => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["parseOptions"])(getData(moduleName, el), def);

var getValue = Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["getProp"])('value');

var remove = el => el.parentNode.removeChild(el);

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iPad|iPhone|iPod/.test(window.navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

var handleize = string => string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');



/***/ }),

/***/ "./src/assets/js/lib/flying-scripts.js":
/*!*********************************************!*\
  !*** ./src/assets/js/lib/flying-scripts.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var loadScriptsTimer = setTimeout(loadScripts, parseInt(window.YETT_TIMEOUT));
var userInteractionEvents = ['mouseover', 'keydown', 'touchmove', 'touchstart'];
window.YETT_BLACKLIST.length && userInteractionEvents.forEach(function (event) {
  window.addEventListener(event, triggerScriptLoader, {
    passive: true
  });
});

function triggerScriptLoader() {
  loadScripts();
  clearTimeout(loadScriptsTimer);
  userInteractionEvents.forEach(function (event) {
    window.removeEventListener(event, triggerScriptLoader, {
      passive: true
    });
  });
}

function loadScripts() {
  window.yett.unblock();
}

/***/ }),

/***/ "./src/assets/js/lib/init.js":
/*!***********************************!*\
  !*** ./src/assets/js/lib/init.js ***!
  \***********************************/
/*! exports provided: loadVueModules, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadVueModules", function() { return loadVueModules; });
var __cache = {};
var errors = {
  duplicate([id, ...args]) {
    return ["a duplicate key ".concat(id, " was found in the cache. This instance will be overwritten."), ...args];
  },

  undefined([id, ...args]) {
    return ["can't find ".concat(id, " in the cache"), ...args];
  },

  error([id, ...args]) {
    return ["".concat(id, " threw an error\n\n"), ...args];
  }

};
/**
 * Logger
 *
 * @param {string} level Log level
 * @param {string} type Log type
 * @param {*} args Rest parameters
 */

function log(level, type, ...args) {
  console[level]('⚙️ micromanager -', ...errors[type](args));
}
/**
 * Module Name
 *
 * @param {Element} node DOM element
 * @returns {string} Module name
 */


function getModuleName(node) {
  return node.getAttribute('data-module') || '';
}
/**
 * Vue component name
 *
 * @param {Element} node DOM element
 * @returns {string} Component name
 */


function getVueName(node) {
  return (node.getAttribute('is') || '').replace('vue-', '');
}
/**
 * Load Vue module
 *
 * @param {string} vueName Vue component name
 * @returns {undefined}
 */


function requireVueModule(vueName = '') {
  if (vueName) {
    __webpack_require__("./src/modules sync recursive ^\\.\\/.*\\.vue\\.js$")("./".concat(vueName, "/").concat(vueName, ".vue.js"));
  }
}
/**
 * Load JS module
 *
 * @param {string} moduleName Module name
 * @param {Element} node DOM element
 * @returns {undefined}
 */


function requireModule(moduleName = '', node) {
  if (moduleName) {
    var fn = __webpack_require__("./src/modules sync recursive ^\\.\\/.*\\.js$")("./".concat(moduleName, "/").concat(moduleName, ".js")).default.bind(null, node);

    return {
      fn: fn,
      name: moduleName
    };
  }
}
/**
 * Get nodes inside a DOM element
 *
 * @param {Element} ctx DOM element
 * @param {string} selector selector
 * @returns {Array} DOM nodes
 */


function getNodes(ctx, selector) {
  return [].slice.call(ctx.querySelectorAll(selector));
}
/**
 * Load Vue modules inside a DOM element
 *
 * @param {Element} ctx DOM element
 * @returns {undefined}
 */


function loadVueModules(ctx = document) {
  var nodes = getNodes(ctx, '[is]');

  for (var i = 0; i < nodes.length; i++) {
    requireVueModule(getVueName(nodes[i]));
  }
}
/**
 * Initialize theme scripts
 *
 * @param {*} types Types
 * @param {Element} ctx DOM element
 * @returns {object} Initialize object
 */

function init(types, ctx = document) {
  return {
    cache: {
      set(id, instance) {
        if (__cache[id]) log('warn', 'duplicate', id);
        __cache[id] = instance;
      },

      get(id) {
        try {
          return __cache[id];
        } catch (e) {
          log('warn', 'undefined', id);
          return null;
        }
      },

      dump() {
        return __cache;
      }

    },

    mount() {
      var callModule = m => {
        var instance = m.fn();

        if (instance) {
          this.cache.set(m.name, instance);
        }

        return instance;
      };

      var loadModules = selector => {
        getNodes(ctx, selector).filter(getModuleName).forEach(node => {
          var instance = requireModule(getModuleName(node), node);
          node.removeAttribute('data-module');
          callModule(instance);
        });
      };

      loadVueModules(ctx);
      loadModules('[data-vue-app]');
      loadModules('[data-module]');
      return this;
    },

    unmount() {
      for (var key in __cache) {
        var instance = __cache[key];

        if (instance.unmount) {
          instance.unmount();
          delete __cache[key];
        }
      }

      return this;
    }

  };
}

/* harmony default export */ __webpack_exports__["default"] = (init);

/***/ }),

/***/ "./src/assets/js/lib/mixedCartPolicy.js":
/*!**********************************************!*\
  !*** ./src/assets/js/lib/mixedCartPolicy.js ***!
  \**********************************************/
/*! exports provided: isDeliveryOnlyLineItem, getMixedCartState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDeliveryOnlyLineItem", function() { return isDeliveryOnlyLineItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMixedCartState", function() { return getMixedCartState; });
var DELIVERY_ONLY_KEY = '_delivery_only';
function isDeliveryOnlyLineItem(item) {
  var _item$properties;

  var value = item === null || item === void 0 ? void 0 : (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties[DELIVERY_ONLY_KEY];
  return String(value).toLowerCase() === 'true';
}
function getMixedCartState(cart) {
  if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
    return {
      hasDeliveryOnlyItems: false,
      hasNonDeliveryOnlyItems: false,
      isMixedCart: false
    };
  }

  var hasDeliveryOnlyItems = cart.items.some(isDeliveryOnlyLineItem);
  var hasNonDeliveryOnlyItems = cart.items.some(item => !isDeliveryOnlyLineItem(item));
  return {
    hasDeliveryOnlyItems,
    hasNonDeliveryOnlyItems,
    isMixedCart: hasDeliveryOnlyItems && hasNonDeliveryOnlyItems
  };
}

/***/ }),

/***/ "./src/assets/js/lib/public-path.js":
/*!******************************************!*\
  !*** ./src/assets/js/lib/public-path.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// eslint-disable-next-line camelcase, no-undef
__webpack_require__.p = (function (path, proxy) {
          // use document.currentScript to know the currently processed JS file
          // see https://github.com/vuejs/vue-cli/commit/5b1709abf010413b2f0b3d1a94ebb9577218c051
          const currentScript = window.document.currentScript
          const hostname = new URL(currentScript.src).hostname
          if (!proxy) {
            proxy = 'localhost'
          };
          if (
            hostname === proxy ||
            hostname === 'localhost'
          ) {
            return path
          } else {
            return window.SHOPIFY_CDN
          };
        })("https://127.0.0.1:9393/", "127.0.0.1");

/***/ }),

/***/ "./src/assets/js/lib/util.js":
/*!***********************************!*\
  !*** ./src/assets/js/lib/util.js ***!
  \***********************************/
/*! exports provided: isMobile, supportsObjectFit, isIE, isIEorEdge, isFirefox, write, set, unset, contains, toggle, getHeight, getWidth, isOver, deepClone, formatPrice, formatMoney, getUrlParam, handleize, encode, decode, getImageWithSize, getProductImage, createArrayFromNumRange, createMonthArray, docOffset, trapFocus, getQueryVar, removeQueryVar, addQueryVar, fetchData, style, unstyle, isEmpty, removeElement, isTouchDevice, filterObject, getOffset, scrollTo, formatNumberMinLength, onWindowWidthChange, pipe, curry, map, getProp, makeArray, whileDo, parseOptions, partial, setProp, getDateLabel, trigger, handleizeShopify */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "supportsObjectFit", function() { return supportsObjectFit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIE", function() { return isIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIEorEdge", function() { return isIEorEdge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFirefox", function() { return isFirefox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "write", function() { return write; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unset", function() { return unset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return contains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggle", function() { return toggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHeight", function() { return getHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWidth", function() { return getWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isOver", function() { return isOver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepClone", function() { return deepClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatPrice", function() { return formatPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatMoney", function() { return formatMoney; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrlParam", function() { return getUrlParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleize", function() { return handleize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encode", function() { return encode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decode", function() { return decode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImageWithSize", function() { return getImageWithSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductImage", function() { return getProductImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createArrayFromNumRange", function() { return createArrayFromNumRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMonthArray", function() { return createMonthArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "docOffset", function() { return docOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trapFocus", function() { return trapFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryVar", function() { return getQueryVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeQueryVar", function() { return removeQueryVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addQueryVar", function() { return addQueryVar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchData", function() { return fetchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return style; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstyle", function() { return unstyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeElement", function() { return removeElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTouchDevice", function() { return isTouchDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterObject", function() { return filterObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOffset", function() { return getOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollTo", function() { return scrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatNumberMinLength", function() { return formatNumberMinLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onWindowWidthChange", function() { return onWindowWidthChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pipe", function() { return pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "curry", function() { return curry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProp", function() { return getProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeArray", function() { return makeArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whileDo", function() { return whileDo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseOptions", function() { return parseOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return partial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProp", function() { return setProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDateLabel", function() { return getDateLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trigger", function() { return trigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleizeShopify", function() { return handleizeShopify; });
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! nanoajax */ "./node_modules/nanoajax/index.js");
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(nanoajax__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var tweezer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! tweezer.js */ "./node_modules/tweezer.js/dist/tweezer.module.js");
/* global CustomEvent */




var isMobile = () => window.innerWidth < 768;
var supportsObjectFit = () => {
  var objectFit = false;

  for (var prop in document.documentElement.style) {
    if (/object(?:-f|F)it$/.test(prop)) {
      objectFit = true;
      break;
    }
  }

  return objectFit;
};
var isIE = () => {
  return navigator.userAgent.toLowerCase().indexOf('msie') > 0;
};
var isIEorEdge = () => {
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
};
var isFirefox = () => {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};
var write = (el, value) => {
  el.innerHTML = value;
};
var set = (item, selector) => {
  if (item instanceof Array) {
    for (var i of item) {
      i.classList.add(selector);
    }
  } else {
    item.classList.add(selector);
  }
};
var unset = (item, selector) => {
  if (item instanceof Array) {
    for (var i of item) {
      i.classList.remove(selector);
    }
  } else {
    item.classList.remove(selector);
  }
};
var contains = (item, selector) => {
  return item.classList.contains(selector);
};
var toggle = (item, selector) => {
  if (item instanceof Array) {
    for (var i of item) {
      i.classList.toggle(selector);
    }
  } else {
    item.classList.toggle(selector);
  }
};
var getHeight = el => {
  return "".concat(el.offsetHeight, "px");
};
var getWidth = el => {
  return "".concat(el.offsetWidth, "px");
};
var isOver = breakpoint => {
  return window.innerWidth > breakpoint;
};
var deepClone = obj => {
  return JSON.parse(JSON.stringify(obj));
};
var formatPrice = (num, fraction = 2) => {
  return (Number(num) / 100).toLocaleString('en-EN', {
    minimumFractionDigits: fraction
  });
};
var formatMoney = (cents, format = window.BARREL.moneyFormat) => {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;
  var value = '';

  var defaultOption = (opt, def) => {
    return typeof opt === 'undefined' ? def : opt;
  };

  var formatWithDelimiters = (number, precision, thousands, decimal) => {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  };

  if (formatString.match(placeholderRegex)) {
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;

      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;

      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;

      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  } else {
    formatString = '$' + '{{amount}}';
    value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};
var getUrlParam = name => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); // eslint-disable-line

  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var handleize = str => str.replace(/[ /_]/g, '-').toLowerCase();
var encode = str => encodeURI(str).split('%0A').map(item => decodeURI(item));
/**
 * Decodes a string that has been encode through the 'url_encode' Shopify filter
 *
 * @param {*} str encoded string
 * @returns {string} decoded string
 */

var decode = str => decodeURIComponent(str).replace(/\+/g, ' ');
/**
 * Generates a URL that is suitable for the Shopify
 * image CDN. Adds the current image size suffix.
 *
 * @param {string} src Image url
 * @param {*} size Image size
 * @returns {string} Sized image url
 */

var getImageWithSize = (src = '', size = 1000) => {
  return ('' + src).replace(/([.](?:jpe?g|png))/, "_".concat(size, "x$1"));
};
/**
 * Used by components like the product card to select
 * the current product image based on the active color.
 * If there is no active color, a fallback image
 * should be returned if it is defined.
 *
 * @param {string} name color
 * @param {string} value value
 * @param {Array} images images to loop over
 * @param {boolean} featured featured image
 * @param {boolean} fallback fallback image
 * @returns {string} product image url
 */

var getProductImage = (name = '', value = '', images, featured = false, fallback = false) => {
  var key = "".concat(name, "-").concat((value || '').replace(/[/ ]/g, '-')).toLowerCase();
  var image = (images || []).find(i => {
    return ~i.indexOf(key) && ~i.indexOf(featured ? 'pos-1' : 'pos-2');
  });

  if (!image) {
    return getImageWithSize(fallback, 600);
  }

  return getImageWithSize(image, featured ? 1200 : 600);
};
var createArrayFromNumRange = (size, start) => {
  return Array.from(Array(size), (_, i) => start + i);
};
var createMonthArray = () => {
  return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
};
var docOffset = el => {
  var rect = el.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft
  };
};
/* window.Element.closest() polyfill for IE11 */

if (!window.Element.prototype.matches) {
  window.Element.prototype.matches = window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
}

if (!window.Element.prototype.closest) {
  window.Element.prototype.closest = function (s) {
    var el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  };
}
/* CustomEvent polyfill */


(function () {
  if (typeof window.CustomEvent === 'function') return false;
  /**
   * Custom event
   *
   * @param {string} event Event name
   * @param {object} params Event options
   * @returns {undefined}
   */

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();
/* Trap focus into a particular element */
// TODO: remove this implementation of trapFocus, leverage the one in @shopify/theme-a11y


var trapFocus = elem => {
  var focusableEls = select_dom__WEBPACK_IMPORTED_MODULE_0__["default"].all(['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'], elem);

  if (focusableEls.length) {
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1]; // Redirect first Shift+Tab to the last focusable element

    dom_event__WEBPACK_IMPORTED_MODULE_1___default()(firstFocusableEl, 'keydown', e => {
      if (e.keyCode === 9 && e.shiftKey) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    }); // Redirect last Tab to the first focusable element

    dom_event__WEBPACK_IMPORTED_MODULE_1___default()(lastFocusableEl, 'keydown', e => {
      if (e.keyCode === 9 && !e.shiftKey) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    });
  }
};

var _getQueryPattern = key => new RegExp("[?&]".concat(key, "=([^&]+)"));

var getQueryVar = (key, url = window.location.href) => {
  var pattern = _getQueryPattern(key);

  var matches = url.match(pattern);
  return matches ? matches[1] : '';
};
var removeQueryVar = (key, url = window.location.href) => {
  var idx = url.indexOf('?');

  if (idx === -1) {
    return url;
  }

  var pattern = _getQueryPattern(key);

  var replaced = url.replace(pattern, '').replace(/\?$/, '');

  if (replaced.indexOf('&') !== -1 && replaced.indexOf('?') === -1) {
    return replaced.replace(/&/, '?');
  }

  return replaced;
};
var addQueryVar = (key, value, url = window.location.href) => {
  var removed = removeQueryVar(key, url);

  if (!value && value !== 0) {
    return removed;
  }

  return "".concat(removed).concat(removed.indexOf('?') === -1 ? '?' : '&').concat(key, "=").concat(value);
};
var fetchData = url => {
  return new Promise((resolve, reject) => {
    nanoajax__WEBPACK_IMPORTED_MODULE_2___default.a.ajax({
      url
    }, (code, res) => {
      res = JSON.parse(res);
      resolve(res);
    });
  });
};
var style = (item, property, value) => {
  if (item instanceof Array) {
    for (var i of item) {
      i.style[property] = value;
    }
  } else {
    item.style[property] = value;
  }
};
var unstyle = (item, property) => {
  if (item instanceof Array) {
    for (var i of item) {
      i.style.removeProperty(property);
    }
  } else {
    item.style.removeProperty(property);
  }
};
var isEmpty = obj => {
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }

  return true;
};
var removeElement = el => {
  el.parentNode.removeChild(el);
};
/**
 * Detect touch device
 *
 * @returns {boolean} is touch device
 *
 */

function isTouchDevice() {
  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
}
var filterObject = (obj, predicate) => {
  Object.keys(obj).filter(key => predicate(obj[key])).reduce((res, key) => Object.assign(res, {
    [key]: obj[key]
  }), {});
};
var getOffset = (el, win = window, docElem = document.documentElement, box = false) => {
  box = el.getBoundingClientRect();
  return box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0);
};
var scrollTo = (el, offset = 0, duration = 1000, callback = () => {}) => {
  new tweezer_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
    start: window.scrollY || window.pageYOffset,
    end: getOffset(el) - offset,
    duration: duration
  }).on('tick', v => window.scrollTo(0, v)).on('done', callback).begin();
};
var formatNumberMinLength = (number, minLength) => {
  var numberStr = number.toString();
  if (numberStr.length >= minLength) return numberStr;
  return numberStr.padStart(minLength, '0');
};
var onWindowWidthChange = handler => {
  var windowWidth = window.innerWidth;

  var onWindowChange = () => {
    if (window.innerWidth !== windowWidth) {
      windowWidth = window.innerWidth;
      handler();
    }
  };

  dom_event__WEBPACK_IMPORTED_MODULE_1___default()(window, 'resize', onWindowChange);
  dom_event__WEBPACK_IMPORTED_MODULE_1___default()(window, 'orientationchange', onWindowChange);
  return onWindowChange;
};
/**
 * Transform a value by chaining a list of function from left to right
 *
 * @param val
 * @param {..Function} funcs
 * @return {*}
 */

var pipe = (...funcs) => function (val) {
  return funcs.reduce((acc, f) => f.apply(this, [acc]), val);
};
/**
 * Returns a curried function of the provided function, so that:
 *
 * f(a, b, c) = f(a, b)(c) = f(a)(b)(c) = f(a)(b, c)
 *
 * @param {Function} f
 * @param {..*} Initial parameters
 * @return {Function} The curried function
 */

var curry = (f, ...args) => args.length >= f.length ? f(...args) : curry.bind(undefined, f, ...args);
/**
 * Functional wrapper for array map function.
 *
 * @param {Function} f
 * @param {*} arr
 */

var map = curry((f, arr) => Array.isArray(arr) ? arr.map(f) : f(arr));
/**
 * Get property of an object.
 *
 * This is a curried function.
 *
 * @param {string} prop
 * @param {Object} obj
 * @return {*}
 */

var getProp = curry((prop, obj) => {
  return obj[prop];
});
/**
 * Create an array out of an array-like object
 *
 * @param {Object} Array-like object
 * @return {Array} Array
 */

var makeArray = arrayLike => Array.prototype.slice.call(arrayLike);
var whileDo = (pred, fn, initial) => pred(initial) ? whileDo(pred, fn, fn(initial)) : initial;
var parseOptions = (string, def = {}) => {
  var options = {};

  try {
    options = JSON.parse(string);
  } catch (e) {
    console.warn('Invalid option JSON string.');
    console.trace();
    return def;
  }

  return Object.assign({}, def, options);
};
/**
 * Partial application
 * @param {Function} f
 * @param {..*} args Initial parameters
 */

var partial = (f, ...args) => f.bind(undefined, ...args);
var setProp = curry((prop, value, obj) => {
  obj[prop] = value;
  return obj;
});
var getDateLabel = label => {
  var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  var day = days.filter(day => label.includes(day));
  if (day.length) return label.replace(day[0], "".concat(day, ","));
  return label;
};
var trigger = (eventName, el, data = {}) => {
  var event;

  if (typeof window.CustomEvent === 'function') {
    event = new CustomEvent(eventName, {
      detail: data
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, data);
  }

  el.dispatchEvent(event);
  return el;
};
var handleizeShopify = (str = '') => {
  str = str.toLowerCase();
  var toReplace = ['"', "'", '\\', '(', ')', '[', ']']; // For the old browsers

  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], '');
  }

  str = str.replace(/\W+/g, '-');

  if (str.charAt(str.length - 1) === '-') {
    str = str.replace(/-+z/, '');
  }

  if (str.charAt(0) === '-') {
    str = str.replace(/A-+/, '');
  }

  return str;
};

/***/ }),

/***/ "./src/assets/js/lib/vue.js":
/*!**********************************!*\
  !*** ./src/assets/js/lib/vue.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ __webpack_exports__["default"] = ((el, options = {}) => {
  return new vue__WEBPACK_IMPORTED_MODULE_1___default.a(_objectSpread({
    el
  }, options));
});

/***/ }),

/***/ "./src/assets/js/lib/zapietDelivery.js":
/*!*********************************************!*\
  !*** ./src/assets/js/lib/zapietDelivery.js ***!
  \*********************************************/
/*! exports provided: ZAPIET_DELIVERY_STORAGE_KEY, CALENDAR_SCAN_DAY_LIMIT, saveZapietDeliveryPostcode, getStoredZapietDeliveryPostcode, getZapietDeliveryPostcodeFromCart, encodeZapietId, buildZapietId, formatDeliveryTimeSlot, pickDeliverySlot, getStartTimeFromSlot, parseDisabledCalendarRules, isDeliverableCalendarDate, findFirstDeliverableDate, getDeliverableDateCandidates, buildCartDeliveryAttributes, cartHasZapietDelivery, getZapietDeliverySummary, cartHasZapietCheckout, buildZapietCheckoutUrl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZAPIET_DELIVERY_STORAGE_KEY", function() { return ZAPIET_DELIVERY_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_SCAN_DAY_LIMIT", function() { return CALENDAR_SCAN_DAY_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveZapietDeliveryPostcode", function() { return saveZapietDeliveryPostcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStoredZapietDeliveryPostcode", function() { return getStoredZapietDeliveryPostcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getZapietDeliveryPostcodeFromCart", function() { return getZapietDeliveryPostcodeFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeZapietId", function() { return encodeZapietId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildZapietId", function() { return buildZapietId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDeliveryTimeSlot", function() { return formatDeliveryTimeSlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickDeliverySlot", function() { return pickDeliverySlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStartTimeFromSlot", function() { return getStartTimeFromSlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseDisabledCalendarRules", function() { return parseDisabledCalendarRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDeliverableCalendarDate", function() { return isDeliverableCalendarDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findFirstDeliverableDate", function() { return findFirstDeliverableDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDeliverableDateCandidates", function() { return getDeliverableDateCandidates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildCartDeliveryAttributes", function() { return buildCartDeliveryAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cartHasZapietDelivery", function() { return cartHasZapietDelivery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getZapietDeliverySummary", function() { return getZapietDeliverySummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cartHasZapietCheckout", function() { return cartHasZapietCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildZapietCheckoutUrl", function() { return buildZapietCheckoutUrl; });
var ZAPIET_DELIVERY_STORAGE_KEY = 'oishii_zapiet_delivery';
var CALENDAR_SCAN_DAY_LIMIT = 90;
function saveZapietDeliveryPostcode(zip) {
  var normalized = String(zip || '').trim();
  if (!normalized) return;

  try {
    sessionStorage.setItem(ZAPIET_DELIVERY_STORAGE_KEY, normalized);
  } catch (error) {// sessionStorage may be unavailable in private browsing
  }
}
function getStoredZapietDeliveryPostcode() {
  try {
    return String(sessionStorage.getItem(ZAPIET_DELIVERY_STORAGE_KEY) || '').trim();
  } catch (error) {
    return '';
  }
}
function getZapietDeliveryPostcodeFromCart(cart) {
  var stored = getStoredZapietDeliveryPostcode();
  if (stored) return stored;
  var attrs = (cart === null || cart === void 0 ? void 0 : cart.attributes) || {};

  if (attrs['Postal-Code']) {
    return String(attrs['Postal-Code']).trim();
  }

  return '';
}
function encodeZapietId(params) {
  return Object.keys(params).filter(key => params[key] != null && params[key] !== '').map(key => "".concat(key, "=").concat(params[key])).join('&');
}
/**
 * @param {{ locationId: number|string, deliveryDate: string, startTime: string }} params
 * @returns {string}
 */

function buildZapietId({
  locationId,
  deliveryDate,
  startTime
}) {
  var date = deliveryDate.replace(/\//g, '-');
  var isoDateTime = startTime ? "".concat(date, "T").concat(startTime, ":00Z") : "".concat(date, "T00:00:00Z");
  return encodeZapietId({
    M: 'D',
    L: String(locationId),
    D: isoDateTime
  });
}
function formatDeliveryTimeSlot(slot) {
  if (!slot) return '';
  var from = slot.available_from || slot.from;
  var until = slot.available_until || slot.until;
  if (!from || !until) return from || '';
  return "".concat(from, " - ").concat(until);
}
/**
 * First available slot on minDate from Calendar API response.
 * @param {object} calendarData
 */

function pickDeliverySlot(calendarData) {
  var _calendarData$minTime;

  var slots = calendarData === null || calendarData === void 0 ? void 0 : calendarData.minDateSlots;
  if (slots && slots.length) return slots[0];

  if (calendarData !== null && calendarData !== void 0 && calendarData.minDateTime) {
    var timeMatch = String(calendarData.minDateTime).match(/\s(\d{2}:\d{2}):\d{2}$/);
    var from = timeMatch ? timeMatch[1] : null;

    if (from && calendarData.minDate) {
      return {
        available_from: from,
        available_until: from
      };
    }
  }

  if (calendarData !== null && calendarData !== void 0 && calendarData.minDate && (calendarData === null || calendarData === void 0 ? void 0 : (_calendarData$minTime = calendarData.minTime) === null || _calendarData$minTime === void 0 ? void 0 : _calendarData$minTime.length) >= 2) {
    var _calendarData$maxTime;

    var _from = "".concat(calendarData.minTime[0], ":").concat(calendarData.minTime[1]);

    var until = _from;

    if (((_calendarData$maxTime = calendarData.maxTime) === null || _calendarData$maxTime === void 0 ? void 0 : _calendarData$maxTime.length) >= 2) {
      until = "".concat(calendarData.maxTime[0], ":").concat(calendarData.maxTime[1]);
    }

    return {
      available_from: _from,
      available_until: until
    };
  }

  return null;
}
function getStartTimeFromSlot(slot) {
  if (!slot) return null;
  return slot.available_from || slot.from || null;
}

function toDateKey(year, month, day) {
  return "".concat(year, "-").concat(String(month).padStart(2, '0'), "-").concat(String(day).padStart(2, '0'));
}
/**
 * Zapiet calendar disabled date tuples use JS 0-based months.
 * @see https://docs.zapiet.com/reference/local-delivery/calendar
 */


function toDateKeyFromZapietTuple(year, monthIndex, day) {
  return toDateKey(year, monthIndex + 1, day);
}

function normalizeDateKey(value) {
  var match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';
  return "".concat(match[1], "-").concat(match[2], "-").concat(match[3]);
}
/**
 * Parse Zapiet calendar `disabled` rules.
 * - Date tuples [year, monthIndex, day] block specific days (month is 0-based).
 * - Integers 1–7 block weekdays (1=Sunday … 7=Saturday).
 * - When the first entry is `true`, remaining entries are an allowlist only.
 */


function parseDisabledCalendarRules(disabled) {
  var disabledDates = new Set();
  var disabledWeekdays = new Set();
  var allowedDates = new Set();
  var isAllowlistMode = false;

  if (!Array.isArray(disabled) || !disabled.length) {
    return {
      disabledDates,
      disabledWeekdays,
      allowedDates,
      isAllowlistMode
    };
  }

  if (disabled[0] === true) {
    isAllowlistMode = true;
    disabled.slice(1).forEach(entry => {
      if (Array.isArray(entry) && entry.length >= 3) {
        allowedDates.add(toDateKeyFromZapietTuple(entry[0], entry[1], entry[2]));
        return;
      }

      var normalized = normalizeDateKey(entry);
      if (normalized) allowedDates.add(normalized);
    });
    return {
      disabledDates,
      disabledWeekdays,
      allowedDates,
      isAllowlistMode
    };
  }

  disabled.forEach(entry => {
    if (Array.isArray(entry) && entry.length >= 3) {
      disabledDates.add(toDateKeyFromZapietTuple(entry[0], entry[1], entry[2]));
      return;
    }

    if (typeof entry === 'number' && Number.isInteger(entry) && entry >= 1 && entry <= 7) {
      disabledWeekdays.add(entry);
    }
  });
  return {
    disabledDates,
    disabledWeekdays,
    allowedDates,
    isAllowlistMode
  };
}

function addDaysToDateKey(dateKey, days) {
  var [year, month, day] = dateKey.split('-').map(Number);
  var date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  return toDateKey(date.getFullYear(), date.getMonth() + 1, date.getDate());
}
/** Zapiet weekday numbering: 1=Sunday … 7=Saturday */


function getZapietWeekdayNumber(dateKey) {
  var [year, month, day] = dateKey.split('-').map(Number);
  var date = new Date(year, month - 1, day);
  return date.getDay() + 1;
}

function isDeliverableCalendarDate(dateKey, calendarData) {
  if (!dateKey || !calendarData) return false;
  var rules = parseDisabledCalendarRules(calendarData.disabled);

  if (rules.isAllowlistMode) {
    return rules.allowedDates.has(dateKey);
  }

  if (rules.disabledDates.has(dateKey)) return false;
  if (rules.disabledWeekdays.has(getZapietWeekdayNumber(dateKey))) return false;
  return true;
}
/**
 * First calendar date that respects Zapiet disabled[] rules.
 * @param {object} calendarData
 * @returns {string|null} YYYY-MM-DD
 */

function findFirstDeliverableDate(calendarData) {
  if (!(calendarData !== null && calendarData !== void 0 && calendarData.minDate)) return null;
  var candidates = getDeliverableDateCandidates(calendarData, 1);
  return candidates[0] || null;
}

function getCalendarScanEndDate(calendarData) {
  if (calendarData.maxDate) return calendarData.maxDate;
  return addDaysToDateKey(calendarData.minDate, CALENDAR_SCAN_DAY_LIMIT - 1);
}
/**
 * Scan minDate → maxDate (or 90-day fallback when maxDate is null) and return deliverable dates.
 * @param {object} calendarData
 * @param {number} limit
 * @returns {string[]} YYYY-MM-DD[]
 */


function getDeliverableDateCandidates(calendarData, limit = 3) {
  if (!(calendarData !== null && calendarData !== void 0 && calendarData.minDate) || limit <= 0) return [];
  var scanEndDate = getCalendarScanEndDate(calendarData);
  var current = calendarData.minDate;
  var results = [];

  while (current <= scanEndDate) {
    if (isDeliverableCalendarDate(current, calendarData)) {
      results.push(current);

      if (results.length >= limit) {
        return results;
      }
    }

    current = addDaysToDateKey(current, 1);
  }

  return results;
}
function buildCartDeliveryAttributes({
  locationId,
  deliveryDate,
  deliveryTime,
  zip
}) {
  return {
    'Checkout-Method': 'delivery',
    'Delivery-Location-Id': String(locationId),
    'Delivery-Date': deliveryDate,
    'Delivery-Time': deliveryTime,
    'Postal-Code': zip
  };
}
function cartHasZapietDelivery(cart) {
  var _cart$items;

  if (!(cart !== null && cart !== void 0 && (_cart$items = cart.items) !== null && _cart$items !== void 0 && _cart$items.length)) return false;
  return cart.items.some(item => item.properties && item.properties._ZapietId);
}
function getZapietDeliverySummary(cart) {
  var attrs = (cart === null || cart === void 0 ? void 0 : cart.attributes) || {};
  if (attrs['Checkout-Method'] !== 'delivery') return null;
  if (!attrs['Postal-Code'] && !attrs['Delivery-Date']) return null;
  return {
    zip: attrs['Postal-Code'] || '',
    date: attrs['Delivery-Date'] || '',
    time: attrs['Delivery-Time'] || ''
  };
}
/**
 * Cart was configured via custom PDP Zapiet flow (attributes + line item _ZapietId).
 */

function cartHasZapietCheckout(cart) {
  var attrs = (cart === null || cart === void 0 ? void 0 : cart.attributes) || {};
  var method = attrs['Checkout-Method'];
  if (!method || !cartHasZapietDelivery(cart)) return false;

  if (method === 'delivery') {
    return Boolean(attrs['Postal-Code'] && attrs['Delivery-Location-Id']);
  }

  if (method === 'pickup') {
    return Boolean(attrs['Pickup-Location-Id']);
  }

  return method === 'shipping';
}
/**
 * Checkout URL with query params matching Zapiet widget (method, shipping zip, etc.).
 * @param {object} cart Shopify cart object
 * @returns {string}
 */

function buildZapietCheckoutUrl(cart) {
  if (!cartHasZapietCheckout(cart)) {
    return '/checkout';
  }

  var attrs = cart.attributes || {};
  var method = attrs['Checkout-Method'];
  var params = new URLSearchParams();

  if (method === 'delivery') {
    params.set('method', 'delivery');
    params.set('checkout[shipping_address][zip]', attrs['Postal-Code'] || '');
  }

  return "/checkout?".concat(params.toString());
}

/***/ }),

/***/ "./src/assets/js/lib/zapietWidgetControl.js":
/*!**************************************************!*\
  !*** ./src/assets/js/lib/zapietWidgetControl.js ***!
  \**************************************************/
/*! exports provided: setZapietDeliveryPostcode, syncZapietDeliveryPostcodeFromCart, syncZapietMethodByCart, resetZapietWidget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setZapietDeliveryPostcode", function() { return setZapietDeliveryPostcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "syncZapietDeliveryPostcodeFromCart", function() { return syncZapietDeliveryPostcodeFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "syncZapietMethodByCart", function() { return syncZapietMethodByCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetZapietWidget", function() { return resetZapietWidget; });
/* harmony import */ var _zapietDelivery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./zapietDelivery */ "./src/assets/js/lib/zapietDelivery.js");

var DELIVERY_ONLY_MARKER_KEY = '_delivery_only';

function hasDeliveryOnlyItem(cart) {
  if (!cart || !Array.isArray(cart.items)) return false;
  return cart.items.some(item => {
    var properties = item && item.properties;
    return properties && String(properties[DELIVERY_ONLY_MARKER_KEY]).toLowerCase() === 'true';
  });
}

function canControlZapiet() {
  if (!window.Zapiet) return false;
  return typeof window.Zapiet.show === 'function' || typeof window.Zapiet.hide === 'function';
}

function setZapietDeliveryPostcode(zip) {
  if (!window.Zapiet || typeof window.Zapiet.setDeliveryPostcode !== 'function') return false;
  var normalized = String(zip || '').trim();
  if (!normalized) return false;
  window.Zapiet.setDeliveryPostcode(normalized);
  return true;
}
function syncZapietDeliveryPostcodeFromCart(cart) {
  if (!hasDeliveryOnlyItem(cart)) return false;
  var zip = Object(_zapietDelivery__WEBPACK_IMPORTED_MODULE_0__["getZapietDeliveryPostcodeFromCart"])(cart);
  return setZapietDeliveryPostcode(zip);
}
function syncZapietMethodByCart(cart) {
  if (!canControlZapiet()) return;
  if (!hasDeliveryOnlyItem(cart)) return;

  if (typeof window.Zapiet.show === 'function') {
    window.Zapiet.show('delivery');
  }

  if (typeof window.Zapiet.hide === 'function') {
    window.Zapiet.hide(['shipping', 'pickup']);
  }

  syncZapietDeliveryPostcodeFromCart(cart);
}
function resetZapietWidget() {
  if (!canControlZapiet()) return;
  if (typeof window.Zapiet.hide !== 'function') return;
  window.Zapiet.hide(['delivery', 'shipping', 'pickup']);
}

/***/ }),

/***/ "./src/assets/js/main.js":
/*!*******************************!*\
  !*** ./src/assets/js/main.js ***!
  \*******************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_public_path__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/public-path */ "./src/assets/js/lib/public-path.js");
/* harmony import */ var lib_public_path__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lib_public_path__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_accessibility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/accessibility */ "./src/assets/js/lib/accessibility.js");
/* harmony import */ var lib_init__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/init */ "./src/assets/js/lib/init.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var aos__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! aos */ "./node_modules/aos/dist/aos.js");
/* harmony import */ var aos__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(aos__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lib_flying_scripts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lib/flying-scripts */ "./src/assets/js/lib/flying-scripts.js");
/* harmony import */ var lib_flying_scripts__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lib_flying_scripts__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _css_main_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../css/main.css */ "./src/assets/css/main.css");
/* harmony import */ var _css_main_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_css_main_css__WEBPACK_IMPORTED_MODULE_6__);







document.addEventListener('DOMContentLoaded', () => {
  if (Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["isIEorEdge"])()) Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["set"])(document.body, 'ie');
  Object(lib_accessibility__WEBPACK_IMPORTED_MODULE_1__["initTabKeyListener"])();
  Object(lib_accessibility__WEBPACK_IMPORTED_MODULE_1__["fixTrackingPixelImages"])();
  Object(lib_init__WEBPACK_IMPORTED_MODULE_2__["default"])().mount();
  aos__WEBPACK_IMPORTED_MODULE_4___default.a.init({
    once: true,
    offset: 50,
    duration: 200,
    easing: 'ease-in-cubic',
    delay: 50
  });
});

/***/ }),

/***/ "./src/assets/js/mixins/validate.js":
/*!******************************************!*\
  !*** ./src/assets/js/mixins/validate.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    validate(e = false) {
      var isValid = this.$children.filter(c => typeof c.validate !== 'undefined').map(c => c.validate()).every(res => res);

      if (!isValid && e) {
        e.preventDefault();
      }

      return isValid;
    }

  }
});

/***/ }),

/***/ "./src/modules sync recursive ^\\.\\/.*\\.js$":
/*!***************************************!*\
  !*** ./src/modules sync ^\.\/.*\.js$ ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./animated-hero/animated-hero.js": "./src/modules/animated-hero/animated-hero.js",
	"./banner-cta/banner-cta.js": "./src/modules/banner-cta/banner-cta.js",
	"./berry-props/berry-props.js": "./src/modules/berry-props/berry-props.js",
	"./bundle-builder-form/bundle-builder-form.js": "./src/modules/bundle-builder-form/bundle-builder-form.js",
	"./bundle-builder-gallery/bundle-builder-gallery.js": "./src/modules/bundle-builder-gallery/bundle-builder-gallery.js",
	"./bundle-builder-header/bundle-builder-header.js": "./src/modules/bundle-builder-header/bundle-builder-header.js",
	"./cart-grid/@actions.js": "./src/modules/cart-grid/@actions.js",
	"./cart-grid/@getters.js": "./src/modules/cart-grid/@getters.js",
	"./cart-grid/@mutations.js": "./src/modules/cart-grid/@mutations.js",
	"./cart-grid/@store.js": "./src/modules/cart-grid/@store.js",
	"./cart-grid/cart-grid.js": "./src/modules/cart-grid/cart-grid.js",
	"./claims-bar/claims-bar.js": "./src/modules/claims-bar/claims-bar.js",
	"./collaboration/collaboration.js": "./src/modules/collaboration/collaboration.js",
	"./coming-soon/coming-soon.js": "./src/modules/coming-soon/coming-soon.js",
	"./contact-form/contact-form.js": "./src/modules/contact-form/contact-form.js",
	"./content-video/content-video.js": "./src/modules/content-video/content-video.js",
	"./example/example.js": "./src/modules/example/example.js",
	"./faq/faq.js": "./src/modules/faq/faq.js",
	"./featured-products/featured-products.js": "./src/modules/featured-products/featured-products.js",
	"./footer/footer.js": "./src/modules/footer/footer.js",
	"./header/header.js": "./src/modules/header/header.js",
	"./image-grid-gallery/image-grid-gallery.js": "./src/modules/image-grid-gallery/image-grid-gallery.js",
	"./instagram-feed/instagram-feed.js": "./src/modules/instagram-feed/instagram-feed.js",
	"./meet-farmers/meet-farmers.js": "./src/modules/meet-farmers/meet-farmers.js",
	"./mini-cart/mini-cart.js": "./src/modules/mini-cart/mini-cart.js",
	"./newsletter-modal/newsletter-modal.js": "./src/modules/newsletter-modal/newsletter-modal.js",
	"./newsletter-signup-banner-new/newsletter-signup-banner-new.js": "./src/modules/newsletter-signup-banner-new/newsletter-signup-banner-new.js",
	"./newsletter-signup-banner/newsletter-signup-banner.js": "./src/modules/newsletter-signup-banner/newsletter-signup-banner.js",
	"./notification-banner/notification-banner.js": "./src/modules/notification-banner/notification-banner.js",
	"./picture/picture.js": "./src/modules/picture/picture.js",
	"./plp-sidebar-link/plp-sidebar-link.vue.js": "./src/modules/plp-sidebar-link/plp-sidebar-link.vue.js",
	"./plp-sidebar/plp-sidebar.vue.js": "./src/modules/plp-sidebar/plp-sidebar.vue.js",
	"./plp/@connectors.js": "./src/modules/plp/@connectors.js",
	"./plp/@mutations.js": "./src/modules/plp/@mutations.js",
	"./plp/@store.js": "./src/modules/plp/@store.js",
	"./plp/@util.js": "./src/modules/plp/@util.js",
	"./plp/plp.js": "./src/modules/plp/plp.js",
	"./product-description/product-description.js": "./src/modules/product-description/product-description.js",
	"./product-form/product-form.js": "./src/modules/product-form/product-form.js",
	"./product-gallery/product-gallery.js": "./src/modules/product-gallery/product-gallery.js",
	"./product-main-berries/product-main-berries.js": "./src/modules/product-main-berries/product-main-berries.js",
	"./product-main-header/product-main-header.js": "./src/modules/product-main-header/product-main-header.js",
	"./recipe-filters/recipe-filters.js": "./src/modules/recipe-filters/recipe-filters.js",
	"./recipe-grid/recipe-grid.js": "./src/modules/recipe-grid/recipe-grid.js",
	"./related-products/related-products.js": "./src/modules/related-products/related-products.js",
	"./reviews/reviews.js": "./src/modules/reviews/reviews.js",
	"./sticky-promo-banner/sticky-promo-banner.js": "./src/modules/sticky-promo-banner/sticky-promo-banner.js",
	"./store-locator-tabs/store-locator-tabs.js": "./src/modules/store-locator-tabs/store-locator-tabs.js",
	"./style-guide/style-guide.js": "./src/modules/style-guide/style-guide.js",
	"./style-guide/style-guide.vue.js": "./src/modules/style-guide/style-guide.vue.js",
	"./testimonials/testimonials.js": "./src/modules/testimonials/testimonials.js",
	"./tiktok-carousel/tiktok-carousel.js": "./src/modules/tiktok-carousel/tiktok-carousel.js",
	"./video/video.js": "./src/modules/video/video.js",
	"./video/video.vue.js": "./src/modules/video/video.vue.js",
	"./wysiwyg/wysiwyg.js": "./src/modules/wysiwyg/wysiwyg.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules sync recursive ^\\.\\/.*\\.js$";

/***/ }),

/***/ "./src/modules sync recursive ^\\.\\/.*\\.vue\\.js$":
/*!********************************************!*\
  !*** ./src/modules sync ^\.\/.*\.vue\.js$ ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./plp-sidebar-link/plp-sidebar-link.vue.js": "./src/modules/plp-sidebar-link/plp-sidebar-link.vue.js",
	"./plp-sidebar/plp-sidebar.vue.js": "./src/modules/plp-sidebar/plp-sidebar.vue.js",
	"./style-guide/style-guide.vue.js": "./src/modules/style-guide/style-guide.vue.js",
	"./video/video.vue.js": "./src/modules/video/video.vue.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules sync recursive ^\\.\\/.*\\.vue\\.js$";

/***/ }),

/***/ "./src/modules/accordions/Accordion.vue":
/*!**********************************************!*\
  !*** ./src/modules/accordions/Accordion.vue ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Accordion_vue_vue_type_template_id_433a9225___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Accordion.vue?vue&type=template&id=433a9225& */ "./src/modules/accordions/Accordion.vue?vue&type=template&id=433a9225&");
/* harmony import */ var _Accordion_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Accordion.vue?vue&type=script&lang=js& */ "./src/modules/accordions/Accordion.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Accordion_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Accordion_vue_vue_type_template_id_433a9225___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Accordion_vue_vue_type_template_id_433a9225___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/accordions/Accordion.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/accordions/Accordion.vue?vue&type=script&lang=js&":
/*!***********************************************************************!*\
  !*** ./src/modules/accordions/Accordion.vue?vue&type=script&lang=js& ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordion_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Accordion.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/accordions/Accordion.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordion_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/accordions/Accordion.vue?vue&type=template&id=433a9225&":
/*!*****************************************************************************!*\
  !*** ./src/modules/accordions/Accordion.vue?vue&type=template&id=433a9225& ***!
  \*****************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordion_vue_vue_type_template_id_433a9225___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Accordion.vue?vue&type=template&id=433a9225& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/accordions/Accordion.vue?vue&type=template&id=433a9225&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordion_vue_vue_type_template_id_433a9225___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordion_vue_vue_type_template_id_433a9225___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/accordions/Accordions.vue":
/*!***********************************************!*\
  !*** ./src/modules/accordions/Accordions.vue ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Accordions_vue_vue_type_template_id_27c3539e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Accordions.vue?vue&type=template&id=27c3539e& */ "./src/modules/accordions/Accordions.vue?vue&type=template&id=27c3539e&");
/* harmony import */ var _Accordions_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Accordions.vue?vue&type=script&lang=js& */ "./src/modules/accordions/Accordions.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Accordions_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Accordions_vue_vue_type_template_id_27c3539e___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Accordions_vue_vue_type_template_id_27c3539e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/accordions/Accordions.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/accordions/Accordions.vue?vue&type=script&lang=js&":
/*!************************************************************************!*\
  !*** ./src/modules/accordions/Accordions.vue?vue&type=script&lang=js& ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordions_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Accordions.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/accordions/Accordions.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordions_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/accordions/Accordions.vue?vue&type=template&id=27c3539e&":
/*!******************************************************************************!*\
  !*** ./src/modules/accordions/Accordions.vue?vue&type=template&id=27c3539e& ***!
  \******************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordions_vue_vue_type_template_id_27c3539e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Accordions.vue?vue&type=template&id=27c3539e& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/accordions/Accordions.vue?vue&type=template&id=27c3539e&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordions_vue_vue_type_template_id_27c3539e___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Accordions_vue_vue_type_template_id_27c3539e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/animated-hero/animated-hero.js":
/*!****************************************************!*\
  !*** ./src/modules/animated-hero/animated-hero.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);


var clamp = (value, min, max) => Math.min(max, Math.max(min, value));

var getFrameWidth = () => {
  if (window.innerWidth < 768) return 750;
  if (window.innerWidth < 1024) return 1100;
  return 1920;
};

var withImageWidth = (url, width) => {
  if (!url) return url;

  if (/[?&]width=\d+/.test(url)) {
    return url.replace(/([?&])width=\d+/, "$1width=".concat(width));
  }

  return "".concat(url).concat(url.includes('?') ? '&' : '?', "width=").concat(width);
};

var getCanvasDpr = () => {
  var ratio = window.devicePixelRatio || 1;
  if (window.innerWidth < 768) return 1;
  return Math.min(ratio, 2);
};

var loadImage = url => new Promise((resolve, reject) => {
  var img = new Image();
  img.decoding = 'async';

  img.onload = () => resolve(img);

  img.onerror = reject;
  img.src = url;
});

var drawCover = (ctx, img, width, height) => {
  var iw = img.naturalWidth;
  var ih = img.naturalHeight;
  if (!iw || !ih) return;
  var scale = Math.max(width / iw, height / ih);
  var sw = iw * scale;
  var sh = ih * scale;
  var dx = (width - sw) / 2;
  var dy = (height - sh) / 2;
  ctx.clearRect(0, 0, width, height);
  ctx.drawImage(img, dx, dy, sw, sh);
};

var drawFit = (ctx, img, width, height) => {
  var iw = img.naturalWidth;
  var ih = img.naturalHeight;
  if (!iw || !ih) return;
  ctx.clearRect(0, 0, width, height);
  ctx.drawImage(img, 0, 0, width, height);
};

var getCanvasSize = (maxWidth, maxHeight, img) => {
  var iw = img.naturalWidth;
  var ih = img.naturalHeight;

  if (!iw || !ih || maxWidth <= 0 || maxHeight <= 0) {
    return {
      width: maxWidth,
      height: maxHeight,
      mode: 'fit'
    };
  }

  var fullWidthHeight = maxWidth * (ih / iw);

  if (fullWidthHeight <= maxHeight) {
    return {
      width: maxWidth,
      height: fullWidthHeight,
      mode: 'fit'
    };
  }

  return {
    width: maxWidth,
    height: maxHeight,
    mode: 'cover'
  };
};

var scheduleIdleWork = callback => {
  var ran = false;

  var run = () => {
    if (ran) return;
    ran = true;
    window.removeEventListener('scroll', run, {
      passive: true
    });
    callback();
  };

  window.addEventListener('scroll', run, {
    passive: true
  });

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run, {
      timeout: 3500
    });
  } else {
    window.setTimeout(run, 2000);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (el => {
  var scrubEl = el.querySelector('.js-animated-hero-scrub');
  var canvas = el.querySelector('.js-animated-hero-canvas');
  var framesEl = el.querySelector('.js-animated-hero-frames');
  var wrapEl = canvas === null || canvas === void 0 ? void 0 : canvas.parentElement;
  if (!scrubEl || !canvas || !framesEl) return;
  var frameUrls = [];

  try {
    frameUrls = JSON.parse(framesEl.textContent);
  } catch (error) {
    return;
  }

  if (!frameUrls.length) return;
  var frameWidth = getFrameWidth();
  frameUrls = frameUrls.map(url => withImageWidth(url, frameWidth));
  var stickyEl = scrubEl.querySelector('.animated-hero__scrub-sticky');
  var stageEl = stickyEl === null || stickyEl === void 0 ? void 0 : stickyEl.querySelector('.animated-hero__sequence-stage');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobileViewport = window.innerWidth < 768;
  var ctx = canvas.getContext('2d', {
    alpha: false
  });
  var dpr = getCanvasDpr();
  var images = [];
  var currentFrame = -1;
  var ticking = false;
  var remainingFramesLoading = false;

  var getCanvasDrawSize = () => {
    var wrapRect = wrapEl === null || wrapEl === void 0 ? void 0 : wrapEl.getBoundingClientRect();
    var stageRect = stageEl === null || stageEl === void 0 ? void 0 : stageEl.getBoundingClientRect();

    if (wrapRect !== null && wrapRect !== void 0 && wrapRect.width && wrapRect !== null && wrapRect !== void 0 && wrapRect.height) {
      return {
        width: wrapRect.width,
        height: wrapRect.height,
        mode: 'fit'
      };
    }

    if (!stageRect || !images.length) {
      return {
        width: (stageRect === null || stageRect === void 0 ? void 0 : stageRect.width) || 0,
        height: (stageRect === null || stageRect === void 0 ? void 0 : stageRect.height) || 0,
        mode: 'fit'
      };
    }

    return getCanvasSize(stageRect.width, stageRect.height, images[0]);
  };

  var resizeCanvas = () => {
    var {
      width,
      height
    } = getCanvasDrawSize();
    if (!width || !height) return;
    canvas.width = Math.floor(width * dpr);
    canvas.height = Math.floor(height * dpr);
    canvas.style.width = "".concat(Math.round(width), "px");
    canvas.style.height = "".concat(Math.round(height), "px");
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    if (images.length) {
      renderFrame(currentFrame >= 0 ? currentFrame : 0, true);
    }
  };

  var renderFrame = (index, force = false) => {
    var frameIndex = clamp(index, 0, images.length - 1);
    var img = images[frameIndex];
    if (!img) return;
    if (!force && frameIndex === currentFrame) return;
    currentFrame = frameIndex;
    var {
      width,
      height,
      mode
    } = getCanvasDrawSize();

    if (mode === 'cover') {
      drawCover(ctx, img, width, height);
      return;
    }

    drawFit(ctx, img, width, height);
  };

  var getProgress = () => {
    var rect = scrubEl.getBoundingClientRect();
    var viewport = window.innerHeight;
    var scrollable = rect.height - viewport;
    if (scrollable <= 0) return 0;
    return clamp(-rect.top / scrollable, 0, 1);
  };

  var update = () => {
    ticking = false;
    if (!images.length) return;

    if (reducedMotion) {
      renderFrame(0, true);
      return;
    }

    var progress = getProgress();
    var maxIndex = Math.max(images.length - 1, 0);
    var frameIndex = Math.round(progress * maxIndex);
    renderFrame(frameIndex);
  };

  var requestUpdate = () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  };

  var handleLayoutChange = () => {
    resizeCanvas();
    requestUpdate();
  };

  var loadRemainingFrames = /*#__PURE__*/function () {
    var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      if (remainingFramesLoading || frameUrls.length <= 1) return;
      remainingFramesLoading = true;

      try {
        var restUrls = frameUrls.slice(1);
        var restImages = [];

        if (isMobileViewport) {
          for (var url of restUrls) {
            restImages.push(yield loadImage(url));
          }
        } else {
          restImages = yield Promise.all(restUrls.map(url => loadImage(url)));
        }

        images = [images[0], ...restImages];
        handleLayoutChange();
      } catch (error) {}
    });

    return function loadRemainingFrames() {
      return _ref.apply(this, arguments);
    };
  }();

  var loadFrameSequence = /*#__PURE__*/function () {
    var _ref2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      try {
        var firstImage = yield loadImage(frameUrls[0]);
        images = [firstImage];
        handleLayoutChange();
        el.classList.add('animated-hero--canvas-ready');

        if (frameUrls.length > 1 && !reducedMotion) {
          scheduleIdleWork(loadRemainingFrames);
        }
      } catch (error) {}
    });

    return function loadFrameSequence() {
      return _ref2.apply(this, arguments);
    };
  }();

  loadFrameSequence();
  window.addEventListener('scroll', requestUpdate, {
    passive: true
  });
  window.addEventListener('resize', handleLayoutChange);

  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(handleLayoutChange);
    if (wrapEl) resizeObserver.observe(wrapEl);
    if (stageEl) resizeObserver.observe(stageEl);
  }

  requestUpdate();
});

/***/ }),

/***/ "./src/modules/availability-callout/availability-callout.css":
/*!*******************************************************************!*\
  !*** ./src/modules/availability-callout/availability-callout.css ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(/*! ../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = __webpack_require__(/*! !../../../node_modules/css-loader/dist/cjs.js?importLoaders!../../../node_modules/postcss-loader/dist/cjs.js!./availability-callout.css */ "./node_modules/css-loader/dist/cjs.js?importLoaders!./node_modules/postcss-loader/dist/cjs.js!./src/modules/availability-callout/availability-callout.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),

/***/ "./src/modules/banner-cta/banner-cta.js":
/*!**********************************************!*\
  !*** ./src/modules/banner-cta/banner-cta.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var in_viewport__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! in-viewport */ "./node_modules/in-viewport/in-viewport.js");
/* harmony import */ var in_viewport__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(in_viewport__WEBPACK_IMPORTED_MODULE_1__);


/* harmony default export */ __webpack_exports__["default"] = (el => {
  in_viewport__WEBPACK_IMPORTED_MODULE_1___default()(el, () => Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["set"])(el, 'is-active'));
});

/***/ }),

/***/ "./src/modules/berry-props/berry-props.js":
/*!************************************************!*\
  !*** ./src/modules/berry-props/berry-props.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper/modules/pagination/pagination.min.css */ "./node_modules/swiper/modules/pagination/pagination.min.css");
/* harmony import */ var swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");





/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    data() {
      return {
        isMobile: false
      };
    },

    watch: {
      isMobile(val) {
        if (!val) {
          this.swiperIns.destroy();
        } else {
          this.initCarousel();
        }
      }

    },

    mounted() {
      this.resizeHandler();
      this.$nextTick(() => {
        window.addEventListener('resize', this.resizeHandler);
      });
    },

    methods: {
      resizeHandler() {
        this.isMobile = Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["isMobile"])();
      },

      initCarousel() {
        var swiperEl = this.$refs.berryPropsCarousel;

        if (swiperEl) {
          this.swiperIns = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](swiperEl, {
            slidesPerView: 1,
            loop: false,
            loopedSlides: 4,
            modules: [swiper__WEBPACK_IMPORTED_MODULE_1__["Pagination"]],
            spaceBetween: 10,
            threshold: 50,
            grabCursor: true,
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            }
          });
        }
      }

    },

    destroy() {
      window.removeEventListener('resize', this.resizeHandler);
    }

  });
});

/***/ }),

/***/ "./src/modules/bundle-builder-form/BundleBuilderForm.vue":
/*!***************************************************************!*\
  !*** ./src/modules/bundle-builder-form/BundleBuilderForm.vue ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BundleBuilderForm_vue_vue_type_template_id_5b9eba7e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BundleBuilderForm.vue?vue&type=template&id=5b9eba7e& */ "./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=template&id=5b9eba7e&");
/* harmony import */ var _BundleBuilderForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BundleBuilderForm.vue?vue&type=script&lang=js& */ "./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _BundleBuilderForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _BundleBuilderForm_vue_vue_type_template_id_5b9eba7e___WEBPACK_IMPORTED_MODULE_0__["render"],
  _BundleBuilderForm_vue_vue_type_template_id_5b9eba7e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/bundle-builder-form/BundleBuilderForm.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=script&lang=js&":
/*!****************************************************************************************!*\
  !*** ./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=script&lang=js& ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./BundleBuilderForm.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=template&id=5b9eba7e&":
/*!**********************************************************************************************!*\
  !*** ./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=template&id=5b9eba7e& ***!
  \**********************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderForm_vue_vue_type_template_id_5b9eba7e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./BundleBuilderForm.vue?vue&type=template&id=5b9eba7e& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/bundle-builder-form/BundleBuilderForm.vue?vue&type=template&id=5b9eba7e&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderForm_vue_vue_type_template_id_5b9eba7e___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderForm_vue_vue_type_template_id_5b9eba7e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/bundle-builder-form/bundle-builder-form.js":
/*!****************************************************************!*\
  !*** ./src/modules/bundle-builder-form/bundle-builder-form.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_bundle_builder_form_BundleBuilderForm_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/bundle-builder-form/BundleBuilderForm.vue */ "./src/modules/bundle-builder-form/BundleBuilderForm.vue");
/* harmony import */ var modules_product_bundle_ProductBundle_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/product-bundle/ProductBundle.vue */ "./src/modules/product-bundle/ProductBundle.vue");
/* harmony import */ var modules_bundle_builder_header_BundleBuilderHeader_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/bundle-builder-header/BundleBuilderHeader.vue */ "./src/modules/bundle-builder-header/BundleBuilderHeader.vue");




/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Bundle Builder Form',
    components: {
      BundleBuilderForm: modules_bundle_builder_form_BundleBuilderForm_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
      ProductBundle: modules_product_bundle_ProductBundle_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
      BundleBuilderHeader: modules_bundle_builder_header_BundleBuilderHeader_vue__WEBPACK_IMPORTED_MODULE_3__["default"]
    }
  });
});

/***/ }),

/***/ "./src/modules/bundle-builder-gallery/bundle-builder-gallery.js":
/*!**********************************************************************!*\
  !*** ./src/modules/bundle-builder-gallery/bundle-builder-gallery.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! swiper/modules/pagination/pagination.min.css */ "./node_modules/swiper/modules/pagination/pagination.min.css");
/* harmony import */ var swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! modules/video-embed/VideoEmbed.vue */ "./src/modules/video-embed/VideoEmbed.vue");
/* harmony import */ var modules_video_Video_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! modules/video/Video.vue */ "./src/modules/video/Video.vue");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_zoomable_image_ZoomableImage_vue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! modules/zoomable-image/ZoomableImage.vue */ "./src/modules/zoomable-image/ZoomableImage.vue");











/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Bundle Builder Gallery',
    components: {
      VideoEmbed: modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_7__["default"],
      'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_9__["default"],
      ZoomableImage: modules_zoomable_image_ZoomableImage_vue__WEBPACK_IMPORTED_MODULE_10__["default"],
      'v-video': modules_video_Video_vue__WEBPACK_IMPORTED_MODULE_8__["default"]
    },

    data() {
      return {
        activeMedia: {},
        state: lib_appState__WEBPACK_IMPORTED_MODULE_1__["default"],
        product: window.BARREL.product,
        swiperThumbnailIns: null,
        isLoaded: false
      };
    },

    computed: {
      firstImage() {
        return (this.product.media || []).find(item => item.media_type === 'image');
      }

    },
    methods: {
      getImageWithSize: lib_util__WEBPACK_IMPORTED_MODULE_3__["getImageWithSize"],

      stopAllVideo() {
        var externalVideos = this.$refs.externalVideos;
        var videos = this.$refs.videos;

        if (externalVideos && externalVideos.length > 0) {
          externalVideos.forEach(externalVideo => {
            var video = externalVideo.$el.querySelector('iframe');
            video.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":"", "method":"pause"}', '*');
          });
        }

        if (videos && videos.length > 0) {
          videos.forEach(video => {
            video.pauseVideo();
          });
        }
      }

    },

    created() {
      this.activeMedia = (this.product.media || [])[0] || {};
    },

    mounted() {
      this.$nextTick(() => {
        var swiperMainEl = this.$refs.galleryMain;
        if (!swiperMainEl) return;
        var swiperMain = new swiper__WEBPACK_IMPORTED_MODULE_4__["default"](swiperMainEl, {
          spaceBetween: 10,
          slidesPerView: 1,
          modules: [swiper__WEBPACK_IMPORTED_MODULE_4__["Pagination"]],
          pagination: {
            el: '.js-swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        });
        var thumbnailItems = this.$refs.thumbnailItem;

        if (thumbnailItems) {
          thumbnailItems.forEach((thumbnail, index) => {
            dom_event__WEBPACK_IMPORTED_MODULE_2___default()(thumbnail, 'click', () => {
              this.activeMedia = this.product.media[index];
              swiperMain.slideTo(index, false);
            });
            dom_event__WEBPACK_IMPORTED_MODULE_2___default()(thumbnail, 'keydown', e => {
              if (e.keyCode === 13) {
                this.activeMedia = this.product.media[index];
                swiperMain.slideTo(index, false);
              }
            });
          });
        }

        swiperMain.on('slideChange', () => {
          this.activeMedia = this.product.media[swiperMain.activeIndex];
          this.stopAllVideo();
        });
        var galleryThumbnailEl = this.$refs.galleryThumbnail;

        if (galleryThumbnailEl) {
          this.swiperThumbnailIns = new swiper__WEBPACK_IMPORTED_MODULE_4__["default"](galleryThumbnailEl, {
            spaceBetween: 10,
            slidesPerView: 3,
            modules: [swiper__WEBPACK_IMPORTED_MODULE_4__["Navigation"]],
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            breakpoints: {
              768: {
                spaceBetween: 10,
                slidesPerView: 10
              },
              1024: {
                spaceBetween: 15,
                slidesPerView: 10
              }
            }
          });
        }

        this.isLoaded = true;
      });
    }

  });
});

/***/ }),

/***/ "./src/modules/bundle-builder-header/BundleBuilderHeader.vue":
/*!*******************************************************************!*\
  !*** ./src/modules/bundle-builder-header/BundleBuilderHeader.vue ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BundleBuilderHeader_vue_vue_type_template_id_79f70110___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BundleBuilderHeader.vue?vue&type=template&id=79f70110& */ "./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=template&id=79f70110&");
/* harmony import */ var _BundleBuilderHeader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BundleBuilderHeader.vue?vue&type=script&lang=js& */ "./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _BundleBuilderHeader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _BundleBuilderHeader_vue_vue_type_template_id_79f70110___WEBPACK_IMPORTED_MODULE_0__["render"],
  _BundleBuilderHeader_vue_vue_type_template_id_79f70110___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/bundle-builder-header/BundleBuilderHeader.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=script&lang=js&":
/*!********************************************************************************************!*\
  !*** ./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=script&lang=js& ***!
  \********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderHeader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./BundleBuilderHeader.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderHeader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=template&id=79f70110&":
/*!**************************************************************************************************!*\
  !*** ./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=template&id=79f70110& ***!
  \**************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderHeader_vue_vue_type_template_id_79f70110___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./BundleBuilderHeader.vue?vue&type=template&id=79f70110& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/bundle-builder-header/BundleBuilderHeader.vue?vue&type=template&id=79f70110&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderHeader_vue_vue_type_template_id_79f70110___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BundleBuilderHeader_vue_vue_type_template_id_79f70110___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/bundle-builder-header/bundle-builder-header.js":
/*!********************************************************************!*\
  !*** ./src/modules/bundle-builder-header/bundle-builder-header.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_bundle_builder_header_BundleBuilderHeader_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/bundle-builder-header/BundleBuilderHeader.vue */ "./src/modules/bundle-builder-header/BundleBuilderHeader.vue");




/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Bundle Builder Header',

    data() {
      return {
        state: lib_appState__WEBPACK_IMPORTED_MODULE_1__["default"]
      };
    },

    components: {
      BundleBuilderHeader: modules_bundle_builder_header_BundleBuilderHeader_vue__WEBPACK_IMPORTED_MODULE_3__["default"]
    },
    computed: {
      formattedPrice() {
        if (this.state.bundleItems && this.state.bundleItems.totalPrice) {
          return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["formatMoney"])(this.state.bundleItems.totalPrice, 'amount_no_decimals');
        }

        return '$0';
      },

      isPreOrder() {
        var _firstAvailableVarian;

        var firstAvailableVariant = window.BARREL.product && window.BARREL.product.firstAvailableVariant;
        if (!firstAvailableVariant) return false;
        var inventoryQuantity = (_firstAvailableVarian = firstAvailableVariant.inventoryQuantity) !== null && _firstAvailableVarian !== void 0 ? _firstAvailableVarian : firstAvailableVariant.inventory_quantity;
        return inventoryQuantity <= 0 && firstAvailableVariant.available;
      }

    }
  });
});

/***/ }),

/***/ "./src/modules/button/Button.vue":
/*!***************************************!*\
  !*** ./src/modules/button/Button.vue ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Button_vue_vue_type_template_id_10867284___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Button.vue?vue&type=template&id=10867284& */ "./src/modules/button/Button.vue?vue&type=template&id=10867284&");
/* harmony import */ var _Button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Button.vue?vue&type=script&lang=js& */ "./src/modules/button/Button.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Button_vue_vue_type_template_id_10867284___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Button_vue_vue_type_template_id_10867284___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/button/Button.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/button/Button.vue?vue&type=script&lang=js&":
/*!****************************************************************!*\
  !*** ./src/modules/button/Button.vue?vue&type=script&lang=js& ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Button.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/button/Button.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/button/Button.vue?vue&type=template&id=10867284&":
/*!**********************************************************************!*\
  !*** ./src/modules/button/Button.vue?vue&type=template&id=10867284& ***!
  \**********************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Button_vue_vue_type_template_id_10867284___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Button.vue?vue&type=template&id=10867284& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/button/Button.vue?vue&type=template&id=10867284&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Button_vue_vue_type_template_id_10867284___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Button_vue_vue_type_template_id_10867284___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/cart-grid/@actions.js":
/*!*******************************************!*\
  !*** ./src/modules/cart-grid/@actions.js ***!
  \*******************************************/
/*! exports provided: actions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/cart */ "./src/assets/js/lib/cart.js");


var latestCartToken = 0;
var actions = {
  getCart({
    commit,
    state
  }, payload) {
    commit('setLoading', true);
    var token = ++latestCartToken;
    return lib_cart__WEBPACK_IMPORTED_MODULE_1__["default"].get().then(data => {
      if (token !== latestCartToken) return;
      commit('refreshCart', data);
    }).catch(error => {
      if (token === latestCartToken) commit('setLoading', false);
      console.error('getCart failed:', error);
    });
  },

  updateItemQuantity({
    commit,
    dispatch,
    state
  }, {
    quantity,
    id
  }) {
    if (!id) {
      return;
    }

    commit('setLoading', true);
    var {
      items
    } = state.app.cart;
    var item = items.find(i => i.key === id || i.variant_id === id);
    var lineId = (item === null || item === void 0 ? void 0 : item.key) || id;
    var token = ++latestCartToken;
    return lib_cart__WEBPACK_IMPORTED_MODULE_1__["default"].change({
      quantity,
      id: lineId
    }).then(data => {
      if (token !== latestCartToken) return;

      if (data && data.errors) {
        return dispatch('getCart');
      }

      commit('refreshCart', data);

      if (quantity === 0) {
        commit('setRemovedItem', item);
      }
    }).catch(error => {
      console.error('updateItemQuantity failed:', error);
      if (token === latestCartToken) return dispatch('getCart');
    });
  },

  addToCart({
    dispatch,
    state
  }, {
    id,
    quantity
  }) {
    var {
      items
    } = state.app.cart; // Adds the requested `quantity` to the current item.quantity

    var item = items.find(i => i.variant_id === id);
    var totalQuantity = item ? item.quantity + quantity : quantity;
    return dispatch('updateItemQuantity', {
      id,
      quantity: totalQuantity
    });
  },

  trackAddToCart({
    dispatch,
    state
  }, {
    product,
    id
  }) {
    var fbq;
    var variant = product.variants.find(({
      id: _id
    }) => _id === id);
    fbq && fbq('track', 'AddToCart', {
      value: Number(variant.price) / 100,
      currency: 'USD',
      content_name: variant.name,
      content_type: 'product',
      content_ids: [id]
    });
  },

  removeItems({
    commit,
    dispatch,
    state
  }, data) {
    if (!data) {
      return;
    }

    commit('setLoading', true);
    var token = ++latestCartToken;
    return lib_cart__WEBPACK_IMPORTED_MODULE_1__["default"].update(data).then(result => {
      if (token !== latestCartToken) return;

      if (result && result.errors) {
        return dispatch('getCart');
      }

      commit('refreshCart', result);
    }).catch(error => {
      console.error('removeItems failed:', error);
      if (token === latestCartToken) return dispatch('getCart');
    });
  },

  updateGiftMessage({
    commit
  }, message) {
    return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      commit('updateGiftMessage', message);
      commit('giftMessageState', true);
    })();
  },

  saveGiftMessage({
    commit,
    getters
  }) {
    return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      commit('setLoading', true);

      try {
        yield lib_cart__WEBPACK_IMPORTED_MODULE_1__["default"].updateNote(getters.giftMessage);
        commit('giftMessageState', false);
      } catch (error) {
        console.log(error);
      } finally {
        commit('setLoading', false);
      }
    })();
  }

};

/***/ }),

/***/ "./src/modules/cart-grid/@getters.js":
/*!*******************************************!*\
  !*** ./src/modules/cart-grid/@getters.js ***!
  \*******************************************/
/*! exports provided: getters */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
var getters = {
  subtotal(state) {
    return state.app.cart.total_price;
  },

  giftMessage(state) {
    return state.app.cart.note;
  },

  giftMessageEdited(state) {
    return state.giftMessageEdited;
  }

};

/***/ }),

/***/ "./src/modules/cart-grid/@mutations.js":
/*!*********************************************!*\
  !*** ./src/modules/cart-grid/@mutations.js ***!
  \*********************************************/
/*! exports provided: mutations */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
var mutations = {
  bootstrap(state) {
    state.isBootstrapped = true;
  },

  setLoading(state, isLoading) {
    state.loading = isLoading;
  },

  refreshCart(state, data) {
    state.loading = false;

    if (data.errors) {
      state.app.cart.errors = data.errors;
    } else {
      state.app.cart = data;
    }
  },

  toggleMiniCart(state) {
    state.app.isMiniCartOpen = !state.app.isMiniCartOpen;
  },

  setRemovedItem(state, item) {
    state.removedItem = item;
  },

  updateGiftMessage(state, message = null) {
    state.app.cart.note = message;
  },

  giftMessageState(state, updated = false) {
    state.giftMessageEdited = updated;
  }

};

/***/ }),

/***/ "./src/modules/cart-grid/@store.js":
/*!*****************************************!*\
  !*** ./src/modules/cart-grid/@store.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./@mutations */ "./src/modules/cart-grid/@mutations.js");
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./@actions */ "./src/modules/cart-grid/@actions.js");
/* harmony import */ var _getters__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./@getters */ "./src/modules/cart-grid/@getters.js");
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");






vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(vuex__WEBPACK_IMPORTED_MODULE_1__["default"]);
var state = {
  app: lib_appState__WEBPACK_IMPORTED_MODULE_5__["default"],
  isBootstrapped: false,
  loading: false,
  removedItem: {},
  giftMessageEdited: false
};
/* harmony default export */ __webpack_exports__["default"] = (new vuex__WEBPACK_IMPORTED_MODULE_1__["default"].Store({
  state,
  actions: _actions__WEBPACK_IMPORTED_MODULE_3__["actions"],
  mutations: _mutations__WEBPACK_IMPORTED_MODULE_2__["mutations"],
  getters: _getters__WEBPACK_IMPORTED_MODULE_4__["getters"]
}));

/***/ }),

/***/ "./src/modules/cart-grid/CartGrid.vue":
/*!********************************************!*\
  !*** ./src/modules/cart-grid/CartGrid.vue ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _CartGrid_vue_vue_type_template_id_04df6483___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CartGrid.vue?vue&type=template&id=04df6483& */ "./src/modules/cart-grid/CartGrid.vue?vue&type=template&id=04df6483&");
/* harmony import */ var _CartGrid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CartGrid.vue?vue&type=script&lang=js& */ "./src/modules/cart-grid/CartGrid.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _CartGrid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _CartGrid_vue_vue_type_template_id_04df6483___WEBPACK_IMPORTED_MODULE_0__["render"],
  _CartGrid_vue_vue_type_template_id_04df6483___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/cart-grid/CartGrid.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/cart-grid/CartGrid.vue?vue&type=script&lang=js&":
/*!*********************************************************************!*\
  !*** ./src/modules/cart-grid/CartGrid.vue?vue&type=script&lang=js& ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CartGrid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./CartGrid.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-grid/CartGrid.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CartGrid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/cart-grid/CartGrid.vue?vue&type=template&id=04df6483&":
/*!***************************************************************************!*\
  !*** ./src/modules/cart-grid/CartGrid.vue?vue&type=template&id=04df6483& ***!
  \***************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartGrid_vue_vue_type_template_id_04df6483___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./CartGrid.vue?vue&type=template&id=04df6483& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-grid/CartGrid.vue?vue&type=template&id=04df6483&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartGrid_vue_vue_type_template_id_04df6483___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartGrid_vue_vue_type_template_id_04df6483___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/cart-grid/cart-grid.js":
/*!********************************************!*\
  !*** ./src/modules/cart-grid/cart-grid.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_cart_grid_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/cart-grid/@store */ "./src/modules/cart-grid/@store.js");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var modules_cart_grid_CartGrid_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/cart-grid/CartGrid.vue */ "./src/modules/cart-grid/CartGrid.vue");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_1__["default"])(el, {
    name: 'Cart Grid',
    components: {
      CartGrid: modules_cart_grid_CartGrid_vue__WEBPACK_IMPORTED_MODULE_5__["default"]
    },
    store: modules_cart_grid_store__WEBPACK_IMPORTED_MODULE_2__["default"],
    computed: _objectSpread(_objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_3__["mapState"])(['app'])), {}, {
      cart() {
        return this.app.cart;
      }

    }),
    methods: _objectSpread(_objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_3__["mapMutations"])(['toggleMiniCart'])), {}, {
      closeMiniCartOnEscape(event) {
        if (event.key === 'Escape' && this.app.isMiniCartOpen) {
          this.app.isMiniCartOpen = !this.app.isMiniCartOpen;
        }
      },

      setCartGridHeight() {
        var cartHeader = this.$refs.cartHeader;
        var cartGrid = this.$refs.cartGrid;

        if (cartHeader && cartGrid) {
          cartGrid.style.height = "calc(100% - ".concat(cartHeader.offsetHeight, "px)");
        }
      }

    }),
    watch: {
      'app.isMiniCartOpen'(value) {
        if (value) {
          this.app.previouslyFocusedElement = document.activeElement;
          this.setCartGridHeight();
        } else {
          this.app.previouslyFocusedElement.focus();
        }
      }

    },

    mounted() {
      dom_event__WEBPACK_IMPORTED_MODULE_4___default()(window, 'keydown', this.closeMiniCartOnEscape);
    }

  });
});

/***/ }),

/***/ "./src/modules/cart-item-bundle/CartItemBundle.vue":
/*!*********************************************************!*\
  !*** ./src/modules/cart-item-bundle/CartItemBundle.vue ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _CartItemBundle_vue_vue_type_template_id_23e38678___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CartItemBundle.vue?vue&type=template&id=23e38678& */ "./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=template&id=23e38678&");
/* harmony import */ var _CartItemBundle_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CartItemBundle.vue?vue&type=script&lang=js& */ "./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _CartItemBundle_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _CartItemBundle_vue_vue_type_template_id_23e38678___WEBPACK_IMPORTED_MODULE_0__["render"],
  _CartItemBundle_vue_vue_type_template_id_23e38678___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/cart-item-bundle/CartItemBundle.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=script&lang=js&":
/*!**********************************************************************************!*\
  !*** ./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=script&lang=js& ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItemBundle_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./CartItemBundle.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItemBundle_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=template&id=23e38678&":
/*!****************************************************************************************!*\
  !*** ./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=template&id=23e38678& ***!
  \****************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItemBundle_vue_vue_type_template_id_23e38678___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./CartItemBundle.vue?vue&type=template&id=23e38678& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-item-bundle/CartItemBundle.vue?vue&type=template&id=23e38678&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItemBundle_vue_vue_type_template_id_23e38678___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItemBundle_vue_vue_type_template_id_23e38678___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/cart-item/CartItem.vue":
/*!********************************************!*\
  !*** ./src/modules/cart-item/CartItem.vue ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _CartItem_vue_vue_type_template_id_25ef8b23___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CartItem.vue?vue&type=template&id=25ef8b23& */ "./src/modules/cart-item/CartItem.vue?vue&type=template&id=25ef8b23&");
/* harmony import */ var _CartItem_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CartItem.vue?vue&type=script&lang=js& */ "./src/modules/cart-item/CartItem.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _CartItem_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _CartItem_vue_vue_type_template_id_25ef8b23___WEBPACK_IMPORTED_MODULE_0__["render"],
  _CartItem_vue_vue_type_template_id_25ef8b23___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/cart-item/CartItem.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/cart-item/CartItem.vue?vue&type=script&lang=js&":
/*!*********************************************************************!*\
  !*** ./src/modules/cart-item/CartItem.vue?vue&type=script&lang=js& ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItem_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./CartItem.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-item/CartItem.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItem_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/cart-item/CartItem.vue?vue&type=template&id=25ef8b23&":
/*!***************************************************************************!*\
  !*** ./src/modules/cart-item/CartItem.vue?vue&type=template&id=25ef8b23& ***!
  \***************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItem_vue_vue_type_template_id_25ef8b23___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./CartItem.vue?vue&type=template&id=25ef8b23& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/cart-item/CartItem.vue?vue&type=template&id=25ef8b23&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItem_vue_vue_type_template_id_25ef8b23___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CartItem_vue_vue_type_template_id_25ef8b23___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/checkbox/Checkbox.vue":
/*!*******************************************!*\
  !*** ./src/modules/checkbox/Checkbox.vue ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Checkbox_vue_vue_type_template_id_1f6e331e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Checkbox.vue?vue&type=template&id=1f6e331e& */ "./src/modules/checkbox/Checkbox.vue?vue&type=template&id=1f6e331e&");
/* harmony import */ var _Checkbox_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Checkbox.vue?vue&type=script&lang=js& */ "./src/modules/checkbox/Checkbox.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Checkbox_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Checkbox_vue_vue_type_template_id_1f6e331e___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Checkbox_vue_vue_type_template_id_1f6e331e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/checkbox/Checkbox.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/checkbox/Checkbox.vue?vue&type=script&lang=js&":
/*!********************************************************************!*\
  !*** ./src/modules/checkbox/Checkbox.vue?vue&type=script&lang=js& ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Checkbox_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Checkbox.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/checkbox/Checkbox.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Checkbox_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/checkbox/Checkbox.vue?vue&type=template&id=1f6e331e&":
/*!**************************************************************************!*\
  !*** ./src/modules/checkbox/Checkbox.vue?vue&type=template&id=1f6e331e& ***!
  \**************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Checkbox_vue_vue_type_template_id_1f6e331e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Checkbox.vue?vue&type=template&id=1f6e331e& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/checkbox/Checkbox.vue?vue&type=template&id=1f6e331e&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Checkbox_vue_vue_type_template_id_1f6e331e___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Checkbox_vue_vue_type_template_id_1f6e331e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/claims-bar/claims-bar.js":
/*!**********************************************!*\
  !*** ./src/modules/claims-bar/claims-bar.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return claimsBar; });
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_modules_free_mode_free_mode_min_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper/modules/free-mode/free-mode.min.css */ "./node_modules/swiper/modules/free-mode/free-mode.min.css");
/* harmony import */ var swiper_modules_free_mode_free_mode_min_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_modules_free_mode_free_mode_min_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");





function claimsBar(el) {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    data() {
      return {
        isMobile: false
      };
    },

    watch: {
      isMobile(val) {
        if (val) {
          this.initCarousel();
        } else if (this.swiperIns) {
          this.swiperIns.destroy();
        }
      }

    },

    mounted() {
      this.resizeHandler();
      this.$nextTick(() => {
        window.addEventListener('resize', this.resizeHandler);
      });
    },

    methods: {
      resizeHandler() {
        this.isMobile = Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["isMobile"])();
      },

      initCarousel() {
        var swiperEl = this.$refs.claimsBarCarousel;

        if (swiperEl) {
          this.swiperIns = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            grabCursor: true,
            speed: 500,
            modules: [swiper__WEBPACK_IMPORTED_MODULE_1__["FreeMode"]],
            centerInsufficientSlides: true,
            freeMode: {
              enabled: true,
              sticky: true
            }
          });
        }
      }

    },

    destroy() {
      window.removeEventListener('resize', this.resizeHandler);
    }

  });
}

/***/ }),

/***/ "./src/modules/collaboration/collaboration.js":
/*!****************************************************!*\
  !*** ./src/modules/collaboration/collaboration.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");


/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    components: {
      'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
    }
  });
});

/***/ }),

/***/ "./src/modules/coming-soon/coming-soon.js":
/*!************************************************!*\
  !*** ./src/modules/coming-soon/coming-soon.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_newsletter_form_NewsletterForm_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/newsletter-form/NewsletterForm.vue */ "./src/modules/newsletter-form/NewsletterForm.vue");


/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    components: {
      NewsletterForm: modules_newsletter_form_NewsletterForm_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
    }
  });
});

/***/ }),

/***/ "./src/modules/contact-form/ContactForm.vue":
/*!**************************************************!*\
  !*** ./src/modules/contact-form/ContactForm.vue ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ContactForm_vue_vue_type_template_id_134ab687___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ContactForm.vue?vue&type=template&id=134ab687& */ "./src/modules/contact-form/ContactForm.vue?vue&type=template&id=134ab687&");
/* harmony import */ var _ContactForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ContactForm.vue?vue&type=script&lang=js& */ "./src/modules/contact-form/ContactForm.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ContactForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ContactForm_vue_vue_type_template_id_134ab687___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ContactForm_vue_vue_type_template_id_134ab687___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/contact-form/ContactForm.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/contact-form/ContactForm.vue?vue&type=script&lang=js&":
/*!***************************************************************************!*\
  !*** ./src/modules/contact-form/ContactForm.vue?vue&type=script&lang=js& ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ContactForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ContactForm.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/contact-form/ContactForm.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ContactForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/contact-form/ContactForm.vue?vue&type=template&id=134ab687&":
/*!*********************************************************************************!*\
  !*** ./src/modules/contact-form/ContactForm.vue?vue&type=template&id=134ab687& ***!
  \*********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContactForm_vue_vue_type_template_id_134ab687___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ContactForm.vue?vue&type=template&id=134ab687& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/contact-form/ContactForm.vue?vue&type=template&id=134ab687&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContactForm_vue_vue_type_template_id_134ab687___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContactForm_vue_vue_type_template_id_134ab687___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/contact-form/contact-form.js":
/*!**************************************************!*\
  !*** ./src/modules/contact-form/contact-form.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_contact_form_ContactForm_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/contact-form/ContactForm.vue */ "./src/modules/contact-form/ContactForm.vue");


/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'ContactFormModule',
    components: {
      ContactForm: modules_contact_form_ContactForm_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
    }
  });
});

/***/ }),

/***/ "./src/modules/content-video/content-video.js":
/*!****************************************************!*\
  !*** ./src/modules/content-video/content-video.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/video-embed/VideoEmbed.vue */ "./src/modules/video-embed/VideoEmbed.vue");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/button/Button.vue */ "./src/modules/button/Button.vue");
/* harmony import */ var modules_modal_Modal_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! modules/modal/Modal.vue */ "./src/modules/modal/Modal.vue");





/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Content Video',
    components: {
      VideoEmbed: modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
      'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
      'v-button': modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_3__["default"],
      Modal: modules_modal_Modal_vue__WEBPACK_IMPORTED_MODULE_4__["default"]
    },

    data() {
      return {
        isShowModal: false,
        video: null
      };
    },

    mounted() {
      this.video = this.parseVideoURL();
    },

    methods: {
      openModal() {
        this.isShowModal = true;
        var video = this.$el.querySelector('iframe');
        if (video) video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":"", "method":"play"}', '*');
      },

      stopAllVideo() {
        var video = this.$el.querySelector('iframe');
        if (video) video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":"", "method":"pause"}', '*');
      },

      parseVideoURL() {
        var url = el.dataset.url;

        if (url.indexOf('youtube.com/watch') !== -1) {
          var matches = url.match(/(\\?|&)v=([^&]*)(&|$)/);
          return {
            provider: 'youtube',
            id: matches ? matches[2] : ''
          };
        }

        if (url.indexOf('vimeo.com') !== -1) {
          var _matches = url.match(/vimeo.com\/(\d+)/);

          return {
            provider: 'vimeo',
            id: _matches ? _matches[1] : ''
          };
        }

        return null;
      }

    }
  });
});

/***/ }),

/***/ "./src/modules/example/Example.vue":
/*!*****************************************!*\
  !*** ./src/modules/example/Example.vue ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Example_vue_vue_type_template_id_73656258___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Example.vue?vue&type=template&id=73656258& */ "./src/modules/example/Example.vue?vue&type=template&id=73656258&");
/* harmony import */ var _Example_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Example.vue?vue&type=script&lang=js& */ "./src/modules/example/Example.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Example_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Example_vue_vue_type_template_id_73656258___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Example_vue_vue_type_template_id_73656258___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/example/Example.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/example/Example.vue?vue&type=script&lang=js&":
/*!******************************************************************!*\
  !*** ./src/modules/example/Example.vue?vue&type=script&lang=js& ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Example_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Example.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/example/Example.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Example_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/example/Example.vue?vue&type=template&id=73656258&":
/*!************************************************************************!*\
  !*** ./src/modules/example/Example.vue?vue&type=template&id=73656258& ***!
  \************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Example_vue_vue_type_template_id_73656258___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Example.vue?vue&type=template&id=73656258& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/example/Example.vue?vue&type=template&id=73656258&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Example_vue_vue_type_template_id_73656258___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Example_vue_vue_type_template_id_73656258___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/example/example.js":
/*!****************************************!*\
  !*** ./src/modules/example/example.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (el => {
  console.log('Example liquid module');
});

/***/ }),

/***/ "./src/modules/faq/faq.js":
/*!********************************!*\
  !*** ./src/modules/faq/faq.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_accordions_Accordions_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/accordions/Accordions.vue */ "./src/modules/accordions/Accordions.vue");
/* harmony import */ var modules_accordions_Accordion_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/accordions/Accordion.vue */ "./src/modules/accordions/Accordion.vue");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/button/Button.vue */ "./src/modules/button/Button.vue");






/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'FAQ',
    components: {
      Accordions: modules_accordions_Accordions_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
      Accordion: modules_accordions_Accordion_vue__WEBPACK_IMPORTED_MODULE_3__["default"],
      'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_4__["default"],
      'v-button': modules_button_Button_vue__WEBPACK_IMPORTED_MODULE_5__["default"]
    },

    data() {
      return {
        faqs: JSON.parse(Object(lib_util__WEBPACK_IMPORTED_MODULE_1__["decode"])(el.dataset.settings))
      };
    }

  });
});

/***/ }),

/***/ "./src/modules/featured-products/featured-products.js":
/*!************************************************************!*\
  !*** ./src/modules/featured-products/featured-products.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_product_card_ProductCard_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! modules/product-card/ProductCard.vue */ "./src/modules/product-card/ProductCard.vue");





/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Featured Products',
    components: {
      ProductCard: modules_product_card_ProductCard_vue__WEBPACK_IMPORTED_MODULE_4__["default"]
    },

    data() {
      return {
        products: el.dataset.settings ? JSON.parse(Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["decode"])(el.dataset.settings)) : [],
        isMobile: false
      };
    },

    watch: {
      isMobile(val) {
        if (!val) {
          this.swiperIns.destroy();
        } else {
          this.initCarousel();
        }
      }

    },

    mounted() {
      this.resizeHandler();
      this.$nextTick(() => {
        window.addEventListener('resize', this.resizeHandler);
      });
    },

    methods: {
      resizeHandler() {
        this.isMobile = Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["isMobile"])();
      },

      initCarousel() {
        if (this.products.length < 2) return;
        var swiperEl = this.$refs.featuredProductsCarousel;

        if (swiperEl) {
          this.swiperIns = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](swiperEl, {
            slidesPerView: 1.33,
            spaceBetween: 10,
            loop: false
          });
        }
      }

    },

    destroy() {
      window.removeEventListener('resize', this.resizeHandler);
    }

  });
});

/***/ }),

/***/ "./src/modules/footer/footer.js":
/*!**************************************!*\
  !*** ./src/modules/footer/footer.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_social_links_SocialLinks_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/social-links/SocialLinks.vue */ "./src/modules/social-links/SocialLinks.vue");



/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    components: {
      'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
      SocialLinks: modules_social_links_SocialLinks_vue__WEBPACK_IMPORTED_MODULE_2__["default"]
    }
  });
});

/***/ }),

/***/ "./src/modules/header-cart-icon/HeaderCartIcon.vue":
/*!*********************************************************!*\
  !*** ./src/modules/header-cart-icon/HeaderCartIcon.vue ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _HeaderCartIcon_vue_vue_type_template_id_33111d1e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./HeaderCartIcon.vue?vue&type=template&id=33111d1e& */ "./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=template&id=33111d1e&");
/* harmony import */ var _HeaderCartIcon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./HeaderCartIcon.vue?vue&type=script&lang=js& */ "./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _HeaderCartIcon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _HeaderCartIcon_vue_vue_type_template_id_33111d1e___WEBPACK_IMPORTED_MODULE_0__["render"],
  _HeaderCartIcon_vue_vue_type_template_id_33111d1e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/header-cart-icon/HeaderCartIcon.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=script&lang=js&":
/*!**********************************************************************************!*\
  !*** ./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=script&lang=js& ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HeaderCartIcon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./HeaderCartIcon.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HeaderCartIcon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=template&id=33111d1e&":
/*!****************************************************************************************!*\
  !*** ./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=template&id=33111d1e& ***!
  \****************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HeaderCartIcon_vue_vue_type_template_id_33111d1e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./HeaderCartIcon.vue?vue&type=template&id=33111d1e& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/header-cart-icon/HeaderCartIcon.vue?vue&type=template&id=33111d1e&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HeaderCartIcon_vue_vue_type_template_id_33111d1e___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HeaderCartIcon_vue_vue_type_template_id_33111d1e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/header/header.js":
/*!**************************************!*\
  !*** ./src/modules/header/header.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var scroll_lock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! scroll-lock */ "./node_modules/scroll-lock/dist/scroll-lock.js");
/* harmony import */ var scroll_lock__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(scroll_lock__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_social_links_SocialLinks_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/social-links/SocialLinks.vue */ "./src/modules/social-links/SocialLinks.vue");
/* harmony import */ var modules_header_cart_icon_HeaderCartIcon_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/header-cart-icon/HeaderCartIcon.vue */ "./src/modules/header-cart-icon/HeaderCartIcon.vue");







var BODY_CLASS = 'menu--active';
var BODY_SCROLLING = 'is-scrolling';
var HEADER_STICKY = 'header-sticky';
var bodyEl = document.body;
var BREAKPOINT = 768;
/* harmony default export */ __webpack_exports__["default"] = (el => {
  return new vue__WEBPACK_IMPORTED_MODULE_0___default.a({
    name: 'Header',
    el,
    components: {
      SocialLinks: modules_social_links_SocialLinks_vue__WEBPACK_IMPORTED_MODULE_5__["default"],
      HeaderCartIcon: modules_header_cart_icon_HeaderCartIcon_vue__WEBPACK_IMPORTED_MODULE_6__["default"]
    },

    data() {
      return {
        isSticky: JSON.parse(Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["decode"])(el.dataset.settings))
      };
    },

    methods: {
      openMobileMenu() {
        Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["set"])(bodyEl, BODY_CLASS);
        Object(scroll_lock__WEBPACK_IMPORTED_MODULE_3__["disablePageScroll"])();
      },

      closeMobileMenu() {
        Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["unset"])(bodyEl, BODY_CLASS);
        Object(scroll_lock__WEBPACK_IMPORTED_MODULE_3__["enablePageScroll"])();
      }

    },

    mounted() {
      if (!this.isSticky) {
        Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["unset"])(bodyEl, HEADER_STICKY);
      }

      var itemsHasChild = select_dom__WEBPACK_IMPORTED_MODULE_2__["default"].all('.js-nav-parent-item');

      if (itemsHasChild) {
        itemsHasChild.forEach(link => {
          dom_event__WEBPACK_IMPORTED_MODULE_1___default()(link, 'click', () => {
            link.classList.toggle('is-active');
          });
          dom_event__WEBPACK_IMPORTED_MODULE_1___default()(link, 'mouseenter', () => {
            if (window.innerWidth >= BREAKPOINT) {
              link.classList.add('is-active');
            }
          });
          dom_event__WEBPACK_IMPORTED_MODULE_1___default()(link, 'mouseleave', () => {
            if (window.innerWidth >= BREAKPOINT) {
              link.classList.remove('is-active');
            }
          });
        });
      }

      Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["onWindowWidthChange"])(() => {
        this.closeMobileMenu();
      });
      dom_event__WEBPACK_IMPORTED_MODULE_1___default()(window, 'scroll', () => {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 1) {
          if (!Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["contains"])(bodyEl, 'is-scrolling')) Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["set"])(bodyEl, BODY_SCROLLING);
        } else {
          if (Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["contains"])(bodyEl, 'is-scrolling')) Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["unset"])(bodyEl, BODY_SCROLLING);
        }
      });
    }

  });
});

/***/ }),

/***/ "./src/modules/icons/IconFacebook.vue":
/*!********************************************!*\
  !*** ./src/modules/icons/IconFacebook.vue ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconFacebook_vue_vue_type_template_id_79c1f375___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconFacebook.vue?vue&type=template&id=79c1f375& */ "./src/modules/icons/IconFacebook.vue?vue&type=template&id=79c1f375&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconFacebook_vue_vue_type_template_id_79c1f375___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconFacebook_vue_vue_type_template_id_79c1f375___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconFacebook.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconFacebook.vue?vue&type=template&id=79c1f375&":
/*!***************************************************************************!*\
  !*** ./src/modules/icons/IconFacebook.vue?vue&type=template&id=79c1f375& ***!
  \***************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconFacebook_vue_vue_type_template_id_79c1f375___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconFacebook.vue?vue&type=template&id=79c1f375& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconFacebook.vue?vue&type=template&id=79c1f375&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconFacebook_vue_vue_type_template_id_79c1f375___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconFacebook_vue_vue_type_template_id_79c1f375___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconInstagram.vue":
/*!*********************************************!*\
  !*** ./src/modules/icons/IconInstagram.vue ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconInstagram_vue_vue_type_template_id_4a4f3b13___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconInstagram.vue?vue&type=template&id=4a4f3b13& */ "./src/modules/icons/IconInstagram.vue?vue&type=template&id=4a4f3b13&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconInstagram_vue_vue_type_template_id_4a4f3b13___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconInstagram_vue_vue_type_template_id_4a4f3b13___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconInstagram.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconInstagram.vue?vue&type=template&id=4a4f3b13&":
/*!****************************************************************************!*\
  !*** ./src/modules/icons/IconInstagram.vue?vue&type=template&id=4a4f3b13& ***!
  \****************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconInstagram_vue_vue_type_template_id_4a4f3b13___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconInstagram.vue?vue&type=template&id=4a4f3b13& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconInstagram.vue?vue&type=template&id=4a4f3b13&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconInstagram_vue_vue_type_template_id_4a4f3b13___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconInstagram_vue_vue_type_template_id_4a4f3b13___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconLogo.vue":
/*!****************************************!*\
  !*** ./src/modules/icons/IconLogo.vue ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconLogo_vue_vue_type_template_id_eeb1714c___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconLogo.vue?vue&type=template&id=eeb1714c& */ "./src/modules/icons/IconLogo.vue?vue&type=template&id=eeb1714c&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconLogo_vue_vue_type_template_id_eeb1714c___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconLogo_vue_vue_type_template_id_eeb1714c___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconLogo.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconLogo.vue?vue&type=template&id=eeb1714c&":
/*!***********************************************************************!*\
  !*** ./src/modules/icons/IconLogo.vue?vue&type=template&id=eeb1714c& ***!
  \***********************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconLogo_vue_vue_type_template_id_eeb1714c___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconLogo.vue?vue&type=template&id=eeb1714c& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconLogo.vue?vue&type=template&id=eeb1714c&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconLogo_vue_vue_type_template_id_eeb1714c___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconLogo_vue_vue_type_template_id_eeb1714c___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconMute.vue":
/*!****************************************!*\
  !*** ./src/modules/icons/IconMute.vue ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconMute_vue_vue_type_template_id_438fecc8___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconMute.vue?vue&type=template&id=438fecc8& */ "./src/modules/icons/IconMute.vue?vue&type=template&id=438fecc8&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconMute_vue_vue_type_template_id_438fecc8___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconMute_vue_vue_type_template_id_438fecc8___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconMute.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconMute.vue?vue&type=template&id=438fecc8&":
/*!***********************************************************************!*\
  !*** ./src/modules/icons/IconMute.vue?vue&type=template&id=438fecc8& ***!
  \***********************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconMute_vue_vue_type_template_id_438fecc8___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconMute.vue?vue&type=template&id=438fecc8& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconMute.vue?vue&type=template&id=438fecc8&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconMute_vue_vue_type_template_id_438fecc8___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconMute_vue_vue_type_template_id_438fecc8___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconPause.vue":
/*!*****************************************!*\
  !*** ./src/modules/icons/IconPause.vue ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconPause_vue_vue_type_template_id_1d53e3d7___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconPause.vue?vue&type=template&id=1d53e3d7& */ "./src/modules/icons/IconPause.vue?vue&type=template&id=1d53e3d7&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconPause_vue_vue_type_template_id_1d53e3d7___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconPause_vue_vue_type_template_id_1d53e3d7___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconPause.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconPause.vue?vue&type=template&id=1d53e3d7&":
/*!************************************************************************!*\
  !*** ./src/modules/icons/IconPause.vue?vue&type=template&id=1d53e3d7& ***!
  \************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPause_vue_vue_type_template_id_1d53e3d7___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconPause.vue?vue&type=template&id=1d53e3d7& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconPause.vue?vue&type=template&id=1d53e3d7&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPause_vue_vue_type_template_id_1d53e3d7___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPause_vue_vue_type_template_id_1d53e3d7___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconPinterest.vue":
/*!*********************************************!*\
  !*** ./src/modules/icons/IconPinterest.vue ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconPinterest_vue_vue_type_template_id_0fc7920a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconPinterest.vue?vue&type=template&id=0fc7920a& */ "./src/modules/icons/IconPinterest.vue?vue&type=template&id=0fc7920a&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconPinterest_vue_vue_type_template_id_0fc7920a___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconPinterest_vue_vue_type_template_id_0fc7920a___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconPinterest.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconPinterest.vue?vue&type=template&id=0fc7920a&":
/*!****************************************************************************!*\
  !*** ./src/modules/icons/IconPinterest.vue?vue&type=template&id=0fc7920a& ***!
  \****************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPinterest_vue_vue_type_template_id_0fc7920a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconPinterest.vue?vue&type=template&id=0fc7920a& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconPinterest.vue?vue&type=template&id=0fc7920a&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPinterest_vue_vue_type_template_id_0fc7920a___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPinterest_vue_vue_type_template_id_0fc7920a___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconPlay.vue":
/*!****************************************!*\
  !*** ./src/modules/icons/IconPlay.vue ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconPlay_vue_vue_type_template_id_7fc92063___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconPlay.vue?vue&type=template&id=7fc92063& */ "./src/modules/icons/IconPlay.vue?vue&type=template&id=7fc92063&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconPlay_vue_vue_type_template_id_7fc92063___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconPlay_vue_vue_type_template_id_7fc92063___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconPlay.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconPlay.vue?vue&type=template&id=7fc92063&":
/*!***********************************************************************!*\
  !*** ./src/modules/icons/IconPlay.vue?vue&type=template&id=7fc92063& ***!
  \***********************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPlay_vue_vue_type_template_id_7fc92063___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconPlay.vue?vue&type=template&id=7fc92063& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconPlay.vue?vue&type=template&id=7fc92063&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPlay_vue_vue_type_template_id_7fc92063___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconPlay_vue_vue_type_template_id_7fc92063___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconRefresh.vue":
/*!*******************************************!*\
  !*** ./src/modules/icons/IconRefresh.vue ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconRefresh_vue_vue_type_template_id_6fcee7fc___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconRefresh.vue?vue&type=template&id=6fcee7fc& */ "./src/modules/icons/IconRefresh.vue?vue&type=template&id=6fcee7fc&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconRefresh_vue_vue_type_template_id_6fcee7fc___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconRefresh_vue_vue_type_template_id_6fcee7fc___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconRefresh.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconRefresh.vue?vue&type=template&id=6fcee7fc&":
/*!**************************************************************************!*\
  !*** ./src/modules/icons/IconRefresh.vue?vue&type=template&id=6fcee7fc& ***!
  \**************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconRefresh_vue_vue_type_template_id_6fcee7fc___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconRefresh.vue?vue&type=template&id=6fcee7fc& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconRefresh.vue?vue&type=template&id=6fcee7fc&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconRefresh_vue_vue_type_template_id_6fcee7fc___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconRefresh_vue_vue_type_template_id_6fcee7fc___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconShoppingBag.vue":
/*!***********************************************!*\
  !*** ./src/modules/icons/IconShoppingBag.vue ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconShoppingBag_vue_vue_type_template_id_f4dff0be___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconShoppingBag.vue?vue&type=template&id=f4dff0be& */ "./src/modules/icons/IconShoppingBag.vue?vue&type=template&id=f4dff0be&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconShoppingBag_vue_vue_type_template_id_f4dff0be___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconShoppingBag_vue_vue_type_template_id_f4dff0be___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconShoppingBag.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconShoppingBag.vue?vue&type=template&id=f4dff0be&":
/*!******************************************************************************!*\
  !*** ./src/modules/icons/IconShoppingBag.vue?vue&type=template&id=f4dff0be& ***!
  \******************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconShoppingBag_vue_vue_type_template_id_f4dff0be___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconShoppingBag.vue?vue&type=template&id=f4dff0be& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconShoppingBag.vue?vue&type=template&id=f4dff0be&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconShoppingBag_vue_vue_type_template_id_f4dff0be___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconShoppingBag_vue_vue_type_template_id_f4dff0be___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconTiktok.vue":
/*!******************************************!*\
  !*** ./src/modules/icons/IconTiktok.vue ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconTiktok_vue_vue_type_template_id_3ad7a969___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconTiktok.vue?vue&type=template&id=3ad7a969& */ "./src/modules/icons/IconTiktok.vue?vue&type=template&id=3ad7a969&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconTiktok_vue_vue_type_template_id_3ad7a969___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconTiktok_vue_vue_type_template_id_3ad7a969___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconTiktok.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconTiktok.vue?vue&type=template&id=3ad7a969&":
/*!*************************************************************************!*\
  !*** ./src/modules/icons/IconTiktok.vue?vue&type=template&id=3ad7a969& ***!
  \*************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconTiktok_vue_vue_type_template_id_3ad7a969___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconTiktok.vue?vue&type=template&id=3ad7a969& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconTiktok.vue?vue&type=template&id=3ad7a969&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconTiktok_vue_vue_type_template_id_3ad7a969___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconTiktok_vue_vue_type_template_id_3ad7a969___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/icons/IconUnmute.vue":
/*!******************************************!*\
  !*** ./src/modules/icons/IconUnmute.vue ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconUnmute_vue_vue_type_template_id_215388a1___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./IconUnmute.vue?vue&type=template&id=215388a1& */ "./src/modules/icons/IconUnmute.vue?vue&type=template&id=215388a1&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");

var script = {}


/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
  script,
  _IconUnmute_vue_vue_type_template_id_215388a1___WEBPACK_IMPORTED_MODULE_0__["render"],
  _IconUnmute_vue_vue_type_template_id_215388a1___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/icons/IconUnmute.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/icons/IconUnmute.vue?vue&type=template&id=215388a1&":
/*!*************************************************************************!*\
  !*** ./src/modules/icons/IconUnmute.vue?vue&type=template&id=215388a1& ***!
  \*************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconUnmute_vue_vue_type_template_id_215388a1___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./IconUnmute.vue?vue&type=template&id=215388a1& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/icons/IconUnmute.vue?vue&type=template&id=215388a1&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconUnmute_vue_vue_type_template_id_215388a1___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_IconUnmute_vue_vue_type_template_id_215388a1___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/image-grid-gallery/ImageGridGallery.vue":
/*!*************************************************************!*\
  !*** ./src/modules/image-grid-gallery/ImageGridGallery.vue ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ImageGridGallery_vue_vue_type_template_id_5c5d7a72___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ImageGridGallery.vue?vue&type=template&id=5c5d7a72& */ "./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=template&id=5c5d7a72&");
/* harmony import */ var _ImageGridGallery_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ImageGridGallery.vue?vue&type=script&lang=js& */ "./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ImageGridGallery_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ImageGridGallery_vue_vue_type_template_id_5c5d7a72___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ImageGridGallery_vue_vue_type_template_id_5c5d7a72___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/image-grid-gallery/ImageGridGallery.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=script&lang=js&":
/*!**************************************************************************************!*\
  !*** ./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=script&lang=js& ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageGridGallery_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ImageGridGallery.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageGridGallery_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=template&id=5c5d7a72&":
/*!********************************************************************************************!*\
  !*** ./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=template&id=5c5d7a72& ***!
  \********************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageGridGallery_vue_vue_type_template_id_5c5d7a72___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ImageGridGallery.vue?vue&type=template&id=5c5d7a72& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/image-grid-gallery/ImageGridGallery.vue?vue&type=template&id=5c5d7a72&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageGridGallery_vue_vue_type_template_id_5c5d7a72___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageGridGallery_vue_vue_type_template_id_5c5d7a72___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/image-grid-gallery/image-grid-gallery.js":
/*!**************************************************************!*\
  !*** ./src/modules/image-grid-gallery/image-grid-gallery.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_image_grid_gallery_ImageGridGallery_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/image-grid-gallery/ImageGridGallery.vue */ "./src/modules/image-grid-gallery/ImageGridGallery.vue");


/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Image Grid Gallery',
    components: {
      ImageGridGallery: modules_image_grid_gallery_ImageGridGallery_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
    },
    methods: {
      parseVideoURL(url) {
        if (url.indexOf('youtube.com/watch') !== -1) {
          var matches = url.match(/(\\?|&)v=([^&]*)(&|$)/);
          return {
            provider: 'youtube',
            id: matches ? matches[2] : ''
          };
        }

        if (url.indexOf('vimeo.com') !== -1) {
          var _matches = url.match(/vimeo.com\/(\d+)/);

          return {
            provider: 'vimeo',
            id: _matches ? _matches[1] : ''
          };
        }

        return {};
      }

    }
  });
});

/***/ }),

/***/ "./src/modules/instagram-feed/instagram-feed.js":
/*!******************************************************!*\
  !*** ./src/modules/instagram-feed/instagram-feed.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");

 // Selectors

var SELECTORS = {
  grid: '.instagram-feed__grid',
  gridItem: '.showcase-grid-item-post',
  showcaseViewer: 'showcase-viewer',
  showcaseDismiss: '.showcase-dismiss'
}; // Attributes

var ATTRIBUTES = {
  ariaLabel: 'aria-label',
  dataId: 'data-id',
  dataHref: 'data-href',
  href: 'href',
  role: 'role'
}; // Constants

var ARIA_LABELS = {
  post: 'View Instagram post',
  reel: 'View Instagram reel',
  photo: 'View Instagram photo post'
};
var FOCUSABLE_SELECTORS = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];
var TIMING = {
  initialCheckDelays: [1000, 2000, 3000, 5000],
  intervalCheckDelay: 3000,
  intervalCheckTimeout: 30000
};
/* harmony default export */ __webpack_exports__["default"] = (el => {
  var focusEl; // ===========================================
  // Aria Labels Management
  // ===========================================

  function addAriaLabels(container) {
    var links = container.querySelectorAll("a".concat(SELECTORS.gridItem));
    if (links.length === 0) return;
    links.forEach(link => {
      if (link.hasAttribute(ATTRIBUTES.ariaLabel)) return;
      var postId = link.getAttribute(ATTRIBUTES.dataId);
      var postUrl = link.getAttribute(ATTRIBUTES.dataHref) || link.getAttribute(ATTRIBUTES.href);
      var ariaLabel = ARIA_LABELS.post;

      if (postUrl) {
        if (postUrl.includes('/reel/')) {
          ariaLabel = ARIA_LABELS.reel;
        } else if (postUrl.includes('/p/')) {
          ariaLabel = ARIA_LABELS.photo;
        }

        if (postId) {
          ariaLabel += " ".concat(postId);
        }
      } else if (postId) {
        ariaLabel = "".concat(ARIA_LABELS.post, " ").concat(postId);
      }

      link.setAttribute(ATTRIBUTES.ariaLabel, ariaLabel);

      if (link.getAttribute(ATTRIBUTES.href) === '#') {
        link.setAttribute(ATTRIBUTES.role, 'button');
      }
    });
  } // ===========================================
  // Initialize Grid Observer
  // ===========================================


  var grid = el.querySelector(SELECTORS.grid);
  if (!grid) return; // Initial checks with delays

  TIMING.initialCheckDelays.forEach(delay => {
    setTimeout(() => addAriaLabels(grid), delay);
  }); // Observe grid for new items
  // eslint-disable-next-line no-undef

  var gridObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        addAriaLabels(grid);
      }
    });
  });
  gridObserver.observe(grid, {
    childList: true,
    subtree: true
  }); // Interval check as fallback

  var intervalCheck = setInterval(() => {
    addAriaLabels(grid);
  }, TIMING.intervalCheckDelay);
  setTimeout(() => {
    clearInterval(intervalCheck);
  }, TIMING.intervalCheckTimeout); // ===========================================
  // Showcase Viewer Focus Management
  // ===========================================

  var focusShowcaseViewer = (viewer, clickedItem) => {
    focusEl = clickedItem;
    var focusableEls = select_dom__WEBPACK_IMPORTED_MODULE_1__["default"].all(FOCUSABLE_SELECTORS, viewer);
    if (focusableEls.length) focusableEls[0].focus();
    Object(lib_util__WEBPACK_IMPORTED_MODULE_0__["trapFocus"])(viewer);
  };

  var waitForShowcaseViewer = clickedItem => {
    var existing = document.getElementById(SELECTORS.showcaseViewer);

    if (existing) {
      focusShowcaseViewer(existing, clickedItem);
      return;
    } // eslint-disable-next-line no-undef


    var viewerObserver = new MutationObserver(() => {
      var viewer = document.getElementById(SELECTORS.showcaseViewer);
      if (!viewer) return;
      viewerObserver.disconnect();
      focusShowcaseViewer(viewer, clickedItem);
    });
    viewerObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }; // ===========================================
  // Event Listeners
  // ===========================================
  // Handle grid item click


  el.addEventListener('click', e => {
    var item = e.target.closest(SELECTORS.gridItem);
    if (!item) return;
    waitForShowcaseViewer(item);
  }); // Restore focus when popup dismissed via click

  document.addEventListener('click', e => {
    if (e.target.closest(SELECTORS.showcaseDismiss) && focusEl) {
      focusEl.focus();
    }
  }); // Restore focus when popup dismissed via ESC key

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      var viewer = document.getElementById(SELECTORS.showcaseViewer);
      if (!focusEl || !viewer) return;
      focusEl.focus();
    }
  });
});

/***/ }),

/***/ "./src/modules/meet-farmers/meet-farmers.js":
/*!**************************************************!*\
  !*** ./src/modules/meet-farmers/meet-farmers.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");




/* harmony default export */ __webpack_exports__["default"] = (el => {
  var stackOnMobile = el.hasAttribute('data-stack-mobile');
  var gapWider = el.classList.contains('meet-farmers--gap-wider');
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    data() {
      return {
        isMobile: false,
        stackOnMobile,
        gapWider
      };
    },

    watch: {
      isMobile() {
        this.teardownSwiper();

        if (this.isMobile && !this.stackOnMobile) {
          this.$nextTick(() => this.initCarousel());
        }
      }

    },

    mounted() {
      this.resizeHandler();
      this.$nextTick(() => {
        window.addEventListener('resize', this.resizeHandler);
      });
    },

    methods: {
      resizeHandler() {
        this.isMobile = Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["isMobile"])();
      },

      teardownSwiper() {
        if (this.swiperIns) {
          this.swiperIns.destroy(true, true);
          this.swiperIns = null;
        }
      },

      initCarousel() {
        if (this.stackOnMobile || !this.isMobile) return;
        var swiperEl = this.$refs.meetFarmersCarousel;

        if (swiperEl) {
          this.swiperIns = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](swiperEl, {
            slidesPerView: 2,
            spaceBetween: this.gapWider ? 20 : 10,
            loop: false
          });
        }
      }

    },

    destroy() {
      this.teardownSwiper();
      window.removeEventListener('resize', this.resizeHandler);
    }

  });
});

/***/ }),

/***/ "./src/modules/mini-cart/mini-cart.js":
/*!********************************************!*\
  !*** ./src/modules/mini-cart/mini-cart.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_cart_grid_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/cart-grid/@store */ "./src/modules/cart-grid/@store.js");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var modules_cart_grid_CartGrid_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/cart-grid/CartGrid.vue */ "./src/modules/cart-grid/CartGrid.vue");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_1__["default"])(el, {
    name: 'Mini Cart',
    components: {
      CartGrid: modules_cart_grid_CartGrid_vue__WEBPACK_IMPORTED_MODULE_5__["default"]
    },
    store: modules_cart_grid_store__WEBPACK_IMPORTED_MODULE_2__["default"],
    computed: _objectSpread(_objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_3__["mapState"])(['app'])), {}, {
      cart() {
        return this.app.cart;
      }

    }),
    methods: _objectSpread(_objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_3__["mapMutations"])(['toggleMiniCart'])), {}, {
      closeMiniCartOnEscape(event) {
        if (event.key === 'Escape' && this.app.isMiniCartOpen) {
          this.app.isMiniCartOpen = !this.app.isMiniCartOpen;
        }
      }

    }),
    watch: {
      'app.isMiniCartOpen'(value) {
        if (value) {
          this.app.previouslyFocusedElement = document.activeElement;
          setTimeout(() => {
            this.$refs.closeButton.focus();
          }, 100);
          var lastFocusEl = this.$el.querySelector('.cart__footer-button');

          if (lastFocusEl) {
            lastFocusEl.addEventListener('keydown', e => {
              if (e.keyCode === 9 && !e.shiftKey) {
                e.preventDefault();
                this.$refs.closeButton.focus();
              }
            });
          }

          console.log('die');
          console.log(this.$refs.closeButton);
        } else {
          this.app.previouslyFocusedElement.focus();
        }
      }

    },

    mounted() {
      dom_event__WEBPACK_IMPORTED_MODULE_4___default()(window, 'keydown', this.closeMiniCartOnEscape);
    }

  });
});

/***/ }),

/***/ "./src/modules/modal/Modal.vue":
/*!*************************************!*\
  !*** ./src/modules/modal/Modal.vue ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Modal_vue_vue_type_template_id_c28e334c___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Modal.vue?vue&type=template&id=c28e334c& */ "./src/modules/modal/Modal.vue?vue&type=template&id=c28e334c&");
/* harmony import */ var _Modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Modal.vue?vue&type=script&lang=js& */ "./src/modules/modal/Modal.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Modal_vue_vue_type_template_id_c28e334c___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Modal_vue_vue_type_template_id_c28e334c___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/modal/Modal.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/modal/Modal.vue?vue&type=script&lang=js&":
/*!**************************************************************!*\
  !*** ./src/modules/modal/Modal.vue?vue&type=script&lang=js& ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Modal.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/modal/Modal.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/modal/Modal.vue?vue&type=template&id=c28e334c&":
/*!********************************************************************!*\
  !*** ./src/modules/modal/Modal.vue?vue&type=template&id=c28e334c& ***!
  \********************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_template_id_c28e334c___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Modal.vue?vue&type=template&id=c28e334c& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/modal/Modal.vue?vue&type=template&id=c28e334c&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_template_id_c28e334c___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Modal_vue_vue_type_template_id_c28e334c___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/more/More.vue":
/*!***********************************!*\
  !*** ./src/modules/more/More.vue ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _More_vue_vue_type_template_id_31b3c944___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./More.vue?vue&type=template&id=31b3c944& */ "./src/modules/more/More.vue?vue&type=template&id=31b3c944&");
/* harmony import */ var _More_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./More.vue?vue&type=script&lang=js& */ "./src/modules/more/More.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _More_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _More_vue_vue_type_template_id_31b3c944___WEBPACK_IMPORTED_MODULE_0__["render"],
  _More_vue_vue_type_template_id_31b3c944___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/more/More.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/more/More.vue?vue&type=script&lang=js&":
/*!************************************************************!*\
  !*** ./src/modules/more/More.vue?vue&type=script&lang=js& ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_More_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./More.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/more/More.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_More_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/more/More.vue?vue&type=template&id=31b3c944&":
/*!******************************************************************!*\
  !*** ./src/modules/more/More.vue?vue&type=template&id=31b3c944& ***!
  \******************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_More_vue_vue_type_template_id_31b3c944___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./More.vue?vue&type=template&id=31b3c944& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/more/More.vue?vue&type=template&id=31b3c944&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_More_vue_vue_type_template_id_31b3c944___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_More_vue_vue_type_template_id_31b3c944___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/newsletter-form/NewsletterForm.vue":
/*!********************************************************!*\
  !*** ./src/modules/newsletter-form/NewsletterForm.vue ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _NewsletterForm_vue_vue_type_template_id_1c63a516___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./NewsletterForm.vue?vue&type=template&id=1c63a516& */ "./src/modules/newsletter-form/NewsletterForm.vue?vue&type=template&id=1c63a516&");
/* harmony import */ var _NewsletterForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./NewsletterForm.vue?vue&type=script&lang=js& */ "./src/modules/newsletter-form/NewsletterForm.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _NewsletterForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _NewsletterForm_vue_vue_type_template_id_1c63a516___WEBPACK_IMPORTED_MODULE_0__["render"],
  _NewsletterForm_vue_vue_type_template_id_1c63a516___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/newsletter-form/NewsletterForm.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/newsletter-form/NewsletterForm.vue?vue&type=script&lang=js&":
/*!*********************************************************************************!*\
  !*** ./src/modules/newsletter-form/NewsletterForm.vue?vue&type=script&lang=js& ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NewsletterForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./NewsletterForm.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/newsletter-form/NewsletterForm.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NewsletterForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/newsletter-form/NewsletterForm.vue?vue&type=template&id=1c63a516&":
/*!***************************************************************************************!*\
  !*** ./src/modules/newsletter-form/NewsletterForm.vue?vue&type=template&id=1c63a516& ***!
  \***************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NewsletterForm_vue_vue_type_template_id_1c63a516___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./NewsletterForm.vue?vue&type=template&id=1c63a516& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/newsletter-form/NewsletterForm.vue?vue&type=template&id=1c63a516&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NewsletterForm_vue_vue_type_template_id_1c63a516___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NewsletterForm_vue_vue_type_template_id_1c63a516___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/newsletter-modal/newsletter-modal.js":
/*!**********************************************************!*\
  !*** ./src/modules/newsletter-modal/newsletter-modal.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_newsletter_form_NewsletterForm_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! modules/newsletter-form/NewsletterForm.vue */ "./src/modules/newsletter-form/NewsletterForm.vue");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");






var bodyEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])('body');
var triggerEls = select_dom__WEBPACK_IMPORTED_MODULE_1__["default"].all('.newsletter-trigger, a[href="#newsletter-trigger"]');
/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    components: {
      NewsletterForm: modules_newsletter_form_NewsletterForm_vue__WEBPACK_IMPORTED_MODULE_4__["default"],
      'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_5__["default"]
    },

    data() {
      return {
        isActive: false,
        delay: null,
        focusEl: null
      };
    },

    methods: {
      initNewsletterModal(e) {
        e.preventDefault();
        Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["style"])(bodyEl, 'overflow', 'hidden');
        setTimeout(() => {
          this.isActive = true;
        }, this.delay);
        setTimeout(() => {
          var newsletterModalWrapper = this.$refs.newsletterModalWrapper;

          if (newsletterModalWrapper) {
            this.focusEl = document.activeElement;
            newsletterModalWrapper.focus();
            Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["trapFocus"])(newsletterModalWrapper);
          }
        }, this.delay + 300);
      },

      closeNewsletterModal(delay = null) {
        Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["unstyle"])(bodyEl, 'overflow');

        if (delay > 0) {
          setTimeout(() => {
            this.isActive = false;
          }, delay);
        } else {
          this.isActive = false;
        }

        if (this.focusEl) {
          this.focusEl.focus();
        }
      },

      handleSuccessSignUp(isSuccessSignUp) {
        if (isSuccessSignUp) {
          this.closeNewsletterModal(this.delay);
        }
      },

      keyDownHandler(e) {
        if (this.isActive && e.key === 'Escape') {
          this.closeNewsletterModal();
        }
      }

    },

    mounted() {
      this.delay = el.getAttribute('data-modal-delay') * 1000;

      if (triggerEls.length) {
        for (var _el of triggerEls) {
          dom_event__WEBPACK_IMPORTED_MODULE_2___default()(_el, 'click', this.initNewsletterModal);
        }

        dom_event__WEBPACK_IMPORTED_MODULE_2___default()(window, 'keydown', this.keyDownHandler);
      }
    }

  });
});

/***/ }),

/***/ "./src/modules/newsletter-signup-banner-new/newsletter-signup-banner-new.js":
/*!**********************************************************************************!*\
  !*** ./src/modules/newsletter-signup-banner-new/newsletter-signup-banner-new.js ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_newsletter_form_NewsletterForm_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/newsletter-form/NewsletterForm.vue */ "./src/modules/newsletter-form/NewsletterForm.vue");


/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    components: {
      NewsletterForm: modules_newsletter_form_NewsletterForm_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
    },

    data() {
      return {
        isSuccess: false
      };
    },

    methods: {
      onSuccess() {
        this.isSuccess = true;
      }

    }
  });
});

/***/ }),

/***/ "./src/modules/newsletter-signup-banner/newsletter-signup-banner.js":
/*!**************************************************************************!*\
  !*** ./src/modules/newsletter-signup-banner/newsletter-signup-banner.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_newsletter_form_NewsletterForm_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/newsletter-form/NewsletterForm.vue */ "./src/modules/newsletter-form/NewsletterForm.vue");


/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    components: {
      NewsletterForm: modules_newsletter_form_NewsletterForm_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
    }
  });
});

/***/ }),

/***/ "./src/modules/notification-banner/notification-banner.js":
/*!****************************************************************!*\
  !*** ./src/modules/notification-banner/notification-banner.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");



var elements = select_dom__WEBPACK_IMPORTED_MODULE_0__["default"].all('.js-notification-banner');
var main = Object(select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])('body');
var skipLinkEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])('#skip_to_content');
/* eslint-disable-next-line */

var event = new CustomEvent('promobarChange', {});
/* harmony default export */ __webpack_exports__["default"] = (() => {
  var _loop = function (el) {
    main.insertBefore(el, skipLinkEl.nextSibling);
    var close = Object(select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])('.js-close', el);
    var content = Object(select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])('.js-content', el).innerHTML;

    var showPromoBar = () => {
      el.style.display = 'block';
      Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["set"])(main, 'has-promo');
      Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["unset"])(main, 'has-promo-closed');
      window.dispatchEvent(event);
    };

    var disablePromoBar = () => {
      window.sessionStorage.setItem('promo', content);
    };

    var hidePromoBar = () => {
      console.log(el.offsetHeight);
      el.style.marginTop = el.offsetHeight * -1 + 'px';
      Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["set"])(main, 'has-promo-closed');
      Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["unset"])(main, 'has-promo');
      window.dispatchEvent(event);
    };

    if (window.sessionStorage.getItem('promo') !== content) {
      showPromoBar();
    } else {
      hidePromoBar();
    }

    dom_event__WEBPACK_IMPORTED_MODULE_1___default()(close, 'click', () => {
      disablePromoBar();
      hidePromoBar();
    });
  };

  for (var el of elements) {
    _loop(el);
  }
});

/***/ }),

/***/ "./src/modules/pagination/Pagination.vue":
/*!***********************************************!*\
  !*** ./src/modules/pagination/Pagination.vue ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Pagination_vue_vue_type_template_id_50664f84___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Pagination.vue?vue&type=template&id=50664f84& */ "./src/modules/pagination/Pagination.vue?vue&type=template&id=50664f84&");
/* harmony import */ var _Pagination_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Pagination.vue?vue&type=script&lang=js& */ "./src/modules/pagination/Pagination.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Pagination_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Pagination_vue_vue_type_template_id_50664f84___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Pagination_vue_vue_type_template_id_50664f84___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/pagination/Pagination.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/pagination/Pagination.vue?vue&type=script&lang=js&":
/*!************************************************************************!*\
  !*** ./src/modules/pagination/Pagination.vue?vue&type=script&lang=js& ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Pagination.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/pagination/Pagination.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/pagination/Pagination.vue?vue&type=template&id=50664f84&":
/*!******************************************************************************!*\
  !*** ./src/modules/pagination/Pagination.vue?vue&type=template&id=50664f84& ***!
  \******************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_template_id_50664f84___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Pagination.vue?vue&type=template&id=50664f84& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/pagination/Pagination.vue?vue&type=template&id=50664f84&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_template_id_50664f84___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_template_id_50664f84___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/picture/Picture.vue":
/*!*****************************************!*\
  !*** ./src/modules/picture/Picture.vue ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Picture_vue_vue_type_template_id_18d33dfc_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Picture.vue?vue&type=template&id=18d33dfc&scoped=true& */ "./src/modules/picture/Picture.vue?vue&type=template&id=18d33dfc&scoped=true&");
/* harmony import */ var _Picture_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Picture.vue?vue&type=script&lang=js& */ "./src/modules/picture/Picture.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Picture_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Picture_vue_vue_type_template_id_18d33dfc_scoped_true___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Picture_vue_vue_type_template_id_18d33dfc_scoped_true___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  "18d33dfc",
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/picture/Picture.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/picture/Picture.vue?vue&type=script&lang=js&":
/*!******************************************************************!*\
  !*** ./src/modules/picture/Picture.vue?vue&type=script&lang=js& ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Picture_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Picture.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/picture/Picture.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Picture_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/picture/Picture.vue?vue&type=template&id=18d33dfc&scoped=true&":
/*!************************************************************************************!*\
  !*** ./src/modules/picture/Picture.vue?vue&type=template&id=18d33dfc&scoped=true& ***!
  \************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Picture_vue_vue_type_template_id_18d33dfc_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Picture.vue?vue&type=template&id=18d33dfc&scoped=true& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/picture/Picture.vue?vue&type=template&id=18d33dfc&scoped=true&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Picture_vue_vue_type_template_id_18d33dfc_scoped_true___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Picture_vue_vue_type_template_id_18d33dfc_scoped_true___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/picture/picture.js":
/*!****************************************!*\
  !*** ./src/modules/picture/picture.js ***!
  \****************************************/
/*! exports provided: loadSrc, loadSrcsets, initImageObserver, observeNewImage, init, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadSrc", function() { return loadSrc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadSrcsets", function() { return loadSrcsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initImageObserver", function() { return initImageObserver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observeNewImage", function() { return observeNewImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! object-fit-images */ "./node_modules/object-fit-images/dist/ofi.common-js.js");
/* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(object_fit_images__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");





__webpack_require__(/*! intersection-observer */ "./node_modules/intersection-observer/intersection-observer.js");

var loadSrc = (el, isVue = false) => {
  el.setAttribute('src', el.getAttribute('data-src'));
  if (!isVue) el.removeAttribute('data-src');
};
var loadSrcsets = (els, isVue = false) => {
  els.forEach(els => {
    els.setAttribute('srcset', els.getAttribute('data-srcset'));
    if (!isVue) els.removeAttribute('data-srcset');
  });
};
var initImageObserver = () => {
  var config = {
    threshold: 0
  };
  /* eslint-disable no-undef */

  window.imageObserver = new IntersectionObserver((entries, self) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (entry.target.hasAttribute('data-src')) loadSrc(entry.target, true);
        var sourceEls = select_dom__WEBPACK_IMPORTED_MODULE_0__["default"].all('[data-srcset]', entry.target.parentNode);
        if (sourceEls) loadSrcsets(sourceEls, true); // Observer has been passed as self to our callback

        self.unobserve(entry.target);
      }
    });
  }, config);
  /* eslint-enable */
};
var observeNewImage = el => {
  window.imageObserver.observe(el);
};
var init = (el, imgEl, sourceEls, isVue = false) => {
  // Check if native lazy-loading is supported, else use IntersectionObserver

  /* eslint-disable no-undef */
  if ('loading' in HTMLImageElement.prototype) {
    loadSrc(imgEl, isVue);
    if (sourceEls) loadSrcsets(sourceEls, isVue);
  } else {
    // Init imageObserver as a global variable
    if (!window.imageObserver) initImageObserver();
    observeNewImage(imgEl);
  }
  /* eslint-enable */


  dom_event__WEBPACK_IMPORTED_MODULE_1___default()(imgEl, 'load', () => {
    isVue ? el.isLoaded = true : Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["set"])(el, 'is-loaded');
    object_fit_images__WEBPACK_IMPORTED_MODULE_2___default()(imgEl);
  });
};
/* harmony default export */ __webpack_exports__["default"] = (el => {
  var imgEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])('[data-src]', el);
  var sourceEls = select_dom__WEBPACK_IMPORTED_MODULE_0__["default"].all('[data-srcset]', el);
  if (imgEl) init(el, imgEl, sourceEls, false);
});

/***/ }),

/***/ "./src/modules/plp-sidebar-link/plp-sidebar-link.vue.js":
/*!**************************************************************!*\
  !*** ./src/modules/plp-sidebar-link/plp-sidebar-link.vue.js ***!
  \**************************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

vue__WEBPACK_IMPORTED_MODULE_0___default.a.component('plp-sidebar-link', {
  props: ['href', 'isActive'],
  data: function () {
    return {};
  },
  methods: {
    onClick: function (e) {
      this.$emit('click', this.href);
    }
  },
  template: "\n  <a\n    class=\"plp-sidebar-link btn btn--plp-sidebar label\"\n    :class=\"{'is-active' : isActive }\"\n    @click.prevent=\"onClick\"\n    :href=\"href\">\n      <slot></slot>\n  </a>"
});

/***/ }),

/***/ "./src/modules/plp-sidebar/plp-sidebar.vue.js":
/*!****************************************************!*\
  !*** ./src/modules/plp-sidebar/plp-sidebar.vue.js ***!
  \****************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var modules_plp_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/plp/@util */ "./src/modules/plp/@util.js");
/* harmony import */ var modules_checkbox_Checkbox_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! modules/checkbox/Checkbox.vue */ "./src/modules/checkbox/Checkbox.vue");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





vue__WEBPACK_IMPORTED_MODULE_1___default.a.component('plp-sidebar', {
  props: ['title', 'isFilters'],

  data() {
    return {
      collectionListActive: false
    };
  },

  computed: _objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_2__["mapState"])(['facets', 'selectedFacets', 'showFilterMenu', 'showCollectionMenu'])),
  methods: _objectSpread(_objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_2__["mapActions"])(['updateSelectedFacets', 'toggleFilterMenu', 'resetSelectedFacets', 'toggleCollectionMenu'])), {}, {
    isActiveFilter(group, facet) {
      return ~Object(modules_plp_util__WEBPACK_IMPORTED_MODULE_3__["selectedFacetsIndex"])(this.selectedFacets, {
        name: group,
        value: facet
      });
    }

  }),
  template: "\n  <div :class=\"{'is-collection-list-active': showCollectionMenu}\">\n    <h2 class=\"sr-only\">Collection Sidebar</h2>\n    <div\n      class=\"plp-sidebar__show-collections\"\n      v-if=\"isFilters\"\n      @click=\"toggleCollectionMenu(!showCollectionMenu)\">\n      <a\n        href=\"javascript:void(0)\"\n        class=\"h5\">Category</a>\n      <i class=\"icon block\">\n        <svg viewBox=\"0 0 13 8\">\n          <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-arrow-down\" x=\"0\" y=\"0\"></use>\n        </svg>\n      </i>\n    </div>\n    <slot></slot>\n    <ul\n      class=\"plp-sidebar__list plp-sidebar__list--filters\"\n      v-if=\"isFilters\"\n      :class=\"{'is-active': showFilterMenu}\">\n      <div class=\"plp-sidebar__apply-filter\">\n        <a\n          href=\"javascript:void(0)\"\n          @click=\"toggleFilterMenu(false)\"\n          class=\"btn btn--primary block align-c w1\">Apply Filters</a>\n      </div>\n      <li\n        v-for=\"key in Object.keys(facets)\"\n        :key=\"'filter-group' + key\"\n        class=\"plp-sidebar__list-group plp-sidebar__list-group--shape\">\n        <h3 class=\"h5\">{{key}}</h3>\n        <ul>\n          <li\n            class=\"plp-sidebar__list-group-item plp-sidebar__list-group-item--filter\"\n            v-for=\"(facet, i) in facets[key]\"\n            @click=\"updateSelectedFacets({name: key, value: facet})\">\n            <checkbox\n              :key=\"facet + isActiveFilter(key, facet)\"\n              :checked=\"isActiveFilter(key, facet)\"\n              :label=\"facet\" />\n          </li>\n        </ul>\n      </li>\n      <div class=\"plp-sidebar__reset-filter align-c\">\n        <a\n          href=\"javascript:void(0)\"\n          v-on:click=\"resetSelectedFacets\"\n          class=underline>Reset Filters</a>\n      </div>\n    </ul>\n    <transition name=\"fade\">\n      <div\n        v-if=\"showFilterMenu\"\n        v-on:click=\"toggleFilterMenu(false)\"\n        class=\"plp-sidebar__list-overlay\"></div>\n    </transition>\n  </div>"
});

/***/ }),

/***/ "./src/modules/plp/@connectors.js":
/*!****************************************!*\
  !*** ./src/modules/plp/@connectors.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! nanoajax */ "./node_modules/nanoajax/index.js");
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nanoajax__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./@util */ "./src/modules/plp/@util.js");


/**
 * Called directly by the Redux action. This
 * sets up the promise chain that returns the data
 * from all pages that need to be requested. This
 * is important when a collection has more than
 * 50 products, like the /collections/all collection
 *
 * @param {string} handle Handle of the collection
 * @param {state} state State of the PLP
 * @param {Function} dispatch - Callback function called when we got data from the collection
 */

/* harmony default export */ __webpack_exports__["default"] = (function (handle, state, dispatch) {
  var {
    sort,
    isSearch,
    searchQuery
  } = state;
  getCollection({
    handle,
    isSearch,
    searchQuery
  }, sort, 1).then(data => {
    dispatch(data, true);
    return getAllPages({
      handle,
      isSearch,
      searchQuery
    }, data, state);
  }).then(data => {
    dispatch(data, false);
  }).catch(e => {
    console.log(e);
  });
});
/**
 * Sets up a promise chain to get all pages of products.
 * First, we fire a request for page 1 to see how many pages
 * we need to get. Then, we set up a Promise.all to get
 * all the other pages at the same time.
 *
 * @param {string} collection - The collection handle used in the URL
 * @param {object} data - The initial data of the collection
 * @param {object} state - State of the PLP
 * @returns {object} Collection data from all pages
 */

var getAllPages = ({
  handle,
  isSearch,
  searchQuery
}, data, state) => {
  var {
    sort
  } = state;
  var pages = Number(data.pages);

  if (pages > 1) {
    var iterations = [...Array(pages - 1).keys()];
    var chain = iterations.map(i => getCollection({
      handle,
      isSearch,
      searchQuery
    }, sort, i + 2));
    return Promise.all(chain).then(responses => {
      responses.forEach(res => {
        data.products = [...data.products, ...res.products];
      });
      return Promise.resolve(data);
    });
  } else {
    return Promise.resolve(data);
  }
};
/**
 * Fires the actual ajax request to get the json from shopify.
 * Wraps this in a promise so we can chain onto it after it
 * completes
 *
 * @param {string} collection - The collection handle used in the URL
 * @param {string} sort - The current sort value
 * @param {int} page - The page of paginated results to return
 * @returns {Promise} Resolves with the collection object
 */


var getCollection = ({
  handle,
  isSearch,
  searchQuery
}, sort, page) => {
  var host = "//".concat(window.location.host);
  var endpoint = !isSearch ? "".concat(handle, "?view=plp-endpoint&page=").concat(page, "&sort_by=").concat(sort) : "/search?q=".concat(searchQuery, "&type=product&view=plp-endpoint&page=").concat(page, "&sort_by=").concat(sort);
  var url = "".concat(host).concat(endpoint);
  return new Promise((resolve, reject) => {
    nanoajax__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
      url: url,
      method: 'GET',
      cors: true
    }, (code, res) => {
      res = Object(_util__WEBPACK_IMPORTED_MODULE_1__["parseJSON"])(res);
      decodeMeta(res);
      resolve(res);
    });
  });
};

var decodeMeta = data => {
  data.collection && Object(_util__WEBPACK_IMPORTED_MODULE_1__["decodeCollectionMeta"])(data.collection);
  return data;
};

/***/ }),

/***/ "./src/modules/plp/@mutations.js":
/*!***************************************!*\
  !*** ./src/modules/plp/@mutations.js ***!
  \***************************************/
/*! exports provided: mutations, actions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var _connectors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./@connectors */ "./src/modules/plp/@connectors.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./@util */ "./src/modules/plp/@util.js");


var mutations = {
  changeCollection(state, handle) {
    state.collection.handle = handle;
  },

  changeCollectionData(state, {
    menu,
    products,
    collection
  }) {
    state.menu = menu;
    state.collection = collection;
    state.products = (products || []).map(product => Object(_util__WEBPACK_IMPORTED_MODULE_1__["interpretTags"])(product, state.acceptedFilters));
    state.facets = Object(_util__WEBPACK_IMPORTED_MODULE_1__["aggregateProductOptionsWithTags"])(state.products, state.acceptedFilters);
    state.mounted = true;
  },

  changeAjaxingFlag(state, ajaxing) {
    state.ajaxing = ajaxing;
  },

  changeLoadingState(state, isLoading) {
    state.loading = isLoading;
  },

  updateSelectedFacets(state, facet) {
    state.selectedFacets = Object(_util__WEBPACK_IMPORTED_MODULE_1__["toggleSelectedFilter"])(state.selectedFacets, facet);
  },

  resetSelectedFacets(state) {
    state.selectedFacets = [];
  },

  updateSort(state, sort) {
    state.sort = sort;
  },

  toggleFilterMenu(state, show) {
    state.showFilterMenu = show;
  },

  toggleCollectionMenu(state, show) {
    state.showCollectionMenu = show;
  },

  toggleCompactView(state, show) {
    state.compactView = show;
  },

  updateFlowExperience(state, experience) {
    state.experience = experience;
  }

};
var actions = {
  fetchCollection({
    commit,
    state
  }, {
    handle = state.collection.handle,
    ajaxing = true,
    initial = false,
    resetSelectedFacets = true
  }) {
    !initial && commit('changeLoadingState', true);
    return new Promise((resolve, reject) => {
      Object(_connectors__WEBPACK_IMPORTED_MODULE_0__["default"])(handle, state, res => {
        var {
          menu,
          collection,
          products
        } = res;
        commit('changeCollectionData', {
          menu,
          collection,
          products
        });
        ajaxing && commit('changeAjaxingFlag', ajaxing);
        !initial && resetSelectedFacets && commit('resetSelectedFacets');
        commit('toggleCollectionMenu', false);
        commit('changeLoadingState', false);
        resolve();
      });
    });
  },

  updateSelectedFacets({
    commit,
    state
  }, facet) {
    commit('changeAjaxingFlag', true);
    commit('updateSelectedFacets', facet);
  },

  updateSort({
    commit,
    state
  }, sort) {
    commit('updateSort', sort);
  },

  toggleFilterMenu({
    commit,
    state
  }, show) {
    commit('toggleFilterMenu', show);
  },

  toggleCollectionMenu({
    commit,
    state
  }, show) {
    commit('toggleCollectionMenu', show);
  },

  toggleCompactView({
    commit,
    state
  }, show) {
    commit('toggleCompactView', show);
    commit('changeAjaxingFlag', true);
  },

  resetSelectedFacets({
    commit,
    state
  }) {
    commit('resetSelectedFacets');
  }

};

/***/ }),

/***/ "./src/modules/plp/@store.js":
/*!***********************************!*\
  !*** ./src/modules/plp/@store.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./@mutations */ "./src/modules/plp/@mutations.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./@util */ "./src/modules/plp/@util.js");





vue__WEBPACK_IMPORTED_MODULE_0___default.a.use(vuex__WEBPACK_IMPORTED_MODULE_1__["default"]);
var defaults = {
  isMobile: Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["isMobile"])(),
  isSearch: !!~document.location.href.indexOf('/search'),
  mounted: false,
  sort: 'manual',
  compactView: true,
  showFilterMenu: false,
  showCollectionMenu: false,
  searchQuery: '',
  acceptedFilters: ['style', 'material'],
  collection: {
    handle: '',
    image: '',
    title: '',
    description: '',
    fetched: false,
    id: ''
  },
  products: [],
  facets: {},
  selectedFacets: [],
  ajaxing: false,
  loading: false
};
/* harmony default export */ __webpack_exports__["default"] = (() => new vuex__WEBPACK_IMPORTED_MODULE_1__["default"].Store({
  state: Object.assign({}, defaults, Object(_util__WEBPACK_IMPORTED_MODULE_4__["getStateFromUrl"])(Object.keys(defaults))),
  actions: _mutations__WEBPACK_IMPORTED_MODULE_3__["actions"],
  mutations: _mutations__WEBPACK_IMPORTED_MODULE_3__["mutations"],
  plugins: [_util__WEBPACK_IMPORTED_MODULE_4__["updateURL"]]
}));

/***/ }),

/***/ "./src/modules/plp/@util.js":
/*!**********************************!*\
  !*** ./src/modules/plp/@util.js ***!
  \**********************************/
/*! exports provided: getStateFromUrl, keysThatRequireAjax, parseVal, updateURL, parseJSON, decode, decodeCollectionMeta, interpretTags, dehandelizeTag, aggregateProductOptionsWithTags, toggleSelectedFilter, selectedFacetsIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStateFromUrl", function() { return getStateFromUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keysThatRequireAjax", function() { return keysThatRequireAjax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseVal", function() { return parseVal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateURL", function() { return updateURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseJSON", function() { return parseJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decode", function() { return decode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeCollectionMeta", function() { return decodeCollectionMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interpretTags", function() { return interpretTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dehandelizeTag", function() { return dehandelizeTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "aggregateProductOptionsWithTags", function() { return aggregateProductOptionsWithTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSelectedFilter", function() { return toggleSelectedFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedFacetsIndex", function() { return selectedFacetsIndex; });
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! query-string */ "./node_modules/query-string/index.js");
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(query_string__WEBPACK_IMPORTED_MODULE_2__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/**
 * This is what we use to populate the initial state
 * of the application from the URL. This allows a user
 * to go back and forward between PDPs and PLPs, among
 * other things.
 *
 * @param {Array} keys state keys
 * @returns {object} data from url
 */

var getStateFromUrl = keys => {
  var parsed = query_string__WEBPACK_IMPORTED_MODULE_2___default.a.parse(window.location.search, {
    arrayFormat: 'bracket'
  });
  var selectedFacets = (parsed.selectedFacets || []).map(str => {
    var split = str.split(':');
    return {
      name: split[0],
      value: split[1]
    };
  });
  var filtered = Object.keys(parsed).reduce((obj, key) => {
    if (key === 'selectedFacets') {
      return obj;
    }

    if (~keys.indexOf(key)) {
      obj[key] = parseVal(parsed[key]);
    }

    return obj;
  }, {});

  if (keysThatRequireAjax(filtered).length) {
    filtered.ajaxing = true;
  }

  if (parsed.q) {
    filtered.searchQuery = parsed.q;
  }

  return _objectSpread(_objectSpread({}, filtered), {}, {
    selectedFacets
  });
};
/**
 * A utility function that sees if there are
 * any params in the URL that should force the
 * application to show an ajax view, rather then
 * the DOM rendered in the initial render.
 *
 * @param {object} obj params object
 * @returns {Array} params that make the app show the ajax view
 */

var keysThatRequireAjax = obj => {
  return Object.keys(obj).filter(k => {
    if (k === 'compactView' && !obj[k]) {
      return true;
    }

    if (k === 'sort' && obj[k] !== 'manual') {
      return true;
    }

    if (k === 'selectedFacets') {
      return true;
    }

    return false;
  });
};
/**
 * Converts boolean strings into
 * actual booleans
 *
 * @param {string} val value
 * @returns {bool} value
 */

var parseVal = val => {
  if (val === 'true') return true;
  if (val === 'false') return false;
  return val;
};
/**
 * This is a Vuex plugin that listens to the
 * store and updates the URL appropriately.
 *
 * @param {object} store Vuex store
 */

var updateURL = store => {
  store.subscribe((mutation, {
    collection,
    selectedFacets = [],
    sort,
    compactView,
    isSearch,
    exitted
  }) => {
    // Don't update if a page transition has occurred
    if (!/collections\/.+/.test(document.location.pathname)) {
      return;
    }

    var url = isSearch ? '/search' : collection.handle;
    var search = [];
    var filtersQs = query_string__WEBPACK_IMPORTED_MODULE_2___default.a.stringify({
      selectedFacets: selectedFacets.map(({
        name,
        value
      }) => "".concat(name, ":").concat(value))
    }, {
      arrayFormat: 'bracket'
    });
    filtersQs && search.push(filtersQs);
    var existing = query_string__WEBPACK_IMPORTED_MODULE_2___default.a.parse(window.location.search, {
      arrayFormat: 'bracket'
    });
    var uniqueExisting = Object.keys(existing).filter(key => {
      return !!key && !!existing[key] && !~['selectedFacets', 'sort', 'compactView'].indexOf(key);
    }).map(key => {
      return "".concat(key, "=").concat(existing[key]);
    });
    var regex = new RegExp("(".concat(collection.title, ")(.?\u2013.*)"), 'i');
    var title = document.title;

    if (!regex.test(title)) {
      document.title = title.replace(/^(.*)((?: | )?–.*)/, "".concat(collection.title, " $2")); // eslint-disable-line no-irregular-whitespace
    }

    uniqueExisting.length && search.push(...uniqueExisting);
    url = search && search.length ? url + '?' : url;
    window.history.replaceState({}, 'Collections', "".concat(url).concat(search.join('&')));
  });
};
/**
 * Parses JSON, removing any comments that
 * Shopify might throw at us.
 *
 * @param {string} string JSON string
 * @returns {object} JSON object
 */

var parseJSON = string => {
  var json = {};
  string = string.replace(/<!--.*-->/g, '');

  try {
    json = JSON.parse(string);
  } catch (e) {
    console.log(e);
  }

  return json;
};
var decode = str => decodeURIComponent(str).replace(/\+/g, ' ');
/**
 * Sometimes we need to encode data so that it doesn't break
 * the JSON parsing. This decodes it.
 *
 * @param {object} meta collection details
 */

var decodeCollectionMeta = meta => {
  for (var key in meta) {
    if (key !== 'json') {
      meta[key] = decode(meta[key]);
    }
  }
};
var interpretTags = (_ref, acceptedFilters = []) => {
  var {
    tags
  } = _ref,
      product = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default()(_ref, ["tags"]);

  var _loop = function (i) {
    var tag = tags[i];

    if (acceptedFilters.find(accepted => {
      return new RegExp(accepted, 'i').test(tag);
    })) {
      var {
        name = '',
        value = '',
        error = false
      } = dehandelizeTag(tag);

      if (error) {
        return "continue";
      }

      if (typeof product[name] === 'undefined') {
        product[name] = [];
      }

      if (typeof product.tagNames === 'undefined') {
        product.tagNames = [];
      }

      if (!~product.tagNames.indexOf(name)) {
        product.tagNames.push(name);
      }

      product[name].push(value);
    }
  };

  for (var i = 0; i < tags.length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }

  return _objectSpread(_objectSpread({}, product), {}, {
    tags
  });
};
var dehandelizeTag = tag => {
  var split = tag.split('-');

  if (split.length < 2) {
    return {
      error: true
    };
  }

  return {
    name: split.shift().toLowerCase(),
    value: split.join(' ').toLowerCase()
  };
};
/**
 * Compiles an array that combines strings that represent
 * product variant options with strings that represent
 * tag-based filters. This is used to generate the filters
 * in the PLP sidebar.
 *
 * @param {Array} products product list
 * @param {Array} acceptedFilters accepted filters list
 * @returns {object} filters object
 */

var aggregateProductOptionsWithTags = (products = [], acceptedFilters = []) => {
  var filters = products.reduce((obj, product) => {
    (product.tagNames || []).forEach(tagName => {
      if (typeof obj[tagName] === 'undefined') {
        obj[tagName] = {};
      }

      (product[tagName] || []).forEach(tagValue => {
        obj[tagName][tagValue] = true;
      });
    });
    (product.optionNames || []).forEach(optionName => {
      if (typeof obj[optionName] === 'undefined') {
        obj[optionName] = {};
      }

      (product[optionName] || []).forEach(optionValue => {
        obj[optionName][optionValue] = true;
      });
    });
    return obj;
  }, {});
  return Object.keys(filters).reduce((obj, key) => {
    obj[key] = Object.keys(filters[key]).sort((a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });
    return obj;
  }, {});
};
/**
 * Returns an array of filters with a filter
 * either added or removed.
 *
 * @param {Array} facets facet list
 * @param {object} facet facet to add/remove
 * @returns {Array} updated facet list
 */

var toggleSelectedFilter = (facets, facet) => {
  var index = selectedFacetsIndex(facets, facet);
  var updated = facets.splice(0);

  if (~index) {
    updated.splice(index, 1);
  } else {
    updated.push(facet);
  }

  return updated;
};
var selectedFacetsIndex = (facets = {}, facet) => {
  var index = -1;

  for (var i = 0; i < facets.length; i++) {
    var {
      name,
      value
    } = facets[i];

    if (facet.name === name && facet.value === value) {
      index = i;
    }
  }

  return index;
};

/***/ }),

/***/ "./src/modules/plp/plp.js":
/*!********************************!*\
  !*** ./src/modules/plp/plp.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./@store */ "./src/modules/plp/@store.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var modules_plp_sidebar_plp_sidebar_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/plp-sidebar/plp-sidebar.vue */ "./src/modules/plp-sidebar/plp-sidebar.vue.js");
/* harmony import */ var modules_plp_sidebar_link_plp_sidebar_link_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/plp-sidebar-link/plp-sidebar-link.vue */ "./src/modules/plp-sidebar-link/plp-sidebar-link.vue.js");
/* harmony import */ var modules_product_card_ProductCard_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! modules/product-card/ProductCard.vue */ "./src/modules/product-card/ProductCard.vue");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! modules/video-embed/VideoEmbed.vue */ "./src/modules/video-embed/VideoEmbed.vue");
/* harmony import */ var modules_video_Video_vue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! modules/video/Video.vue */ "./src/modules/video/Video.vue");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











/* harmony default export */ __webpack_exports__["default"] = (el => new vue__WEBPACK_IMPORTED_MODULE_1___default.a({
  name: 'PLP',
  el,
  store: Object(_store__WEBPACK_IMPORTED_MODULE_2__["default"])(),
  components: {
    'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_8__["default"],
    'v-video': modules_video_Video_vue__WEBPACK_IMPORTED_MODULE_10__["default"],
    'video-embed': modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_9__["default"],
    ProductCard: modules_product_card_ProductCard_vue__WEBPACK_IMPORTED_MODULE_7__["default"]
  },

  data() {
    return {
      settings: () => ({}),
      items: JSON.parse(Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["decode"])(el.dataset.items))
    };
  },

  mounted() {
    var initial = el.getAttribute('data-initial');
    var decodedImport = decodeURIComponent(initial);
    var collection = JSON.parse(decodedImport);
    this.$store.state.collection = collection;
    this.fetchCollectionHeroSettings();
    this.fetchCollection({
      handle: window.location.pathname,
      ajaxing: false,
      initial: true
    });
  },

  computed: _objectSpread(_objectSpread(_objectSpread({}, Object(vuex__WEBPACK_IMPORTED_MODULE_4__["mapState"])(['collection', 'products', 'mounted', 'ajaxing', 'loading', 'selectedFacets', 'sort', 'compactView', 'isMobile'])), Object(vuex__WEBPACK_IMPORTED_MODULE_4__["mapState"])({
    visibleProducts(state) {
      return (state.products || []).filter(p => this.shouldShowProduct(p));
    }

  })), {}, {
    bundleCard() {
      return window.bundleCardData || null;
    },

    groupProducts() {
      var list = this.visibleProducts.map(item => {
        return [item.title + '-' + item.productVendorLocation, item];
      });
      var productsUnique = this.visibleProducts.length > 0 ? [...new Map(list).values()] : [];

      if (productsUnique.length > 0) {
        productsUnique.forEach(item => {
          var title = item.title;
          var location = item.productVendorLocation;
          var type = item.productVendorType;
          this.visibleProducts.forEach(product => {
            if (title === product.title && location === product.productVendorLocation && type !== product.productVendorType) {
              item.productVendorType1 = product.productVendorType;
              item.handle1 = product.handle;
              item.url1 = product.url;
              item.available1 = product.available;
            }
          });
        });
      }

      return productsUnique;
    },

    blockSettings() {
      var collectionHandle = this.collection.handle.replace('/collections/', '');

      if (this.settings) {
        /* eslint-disable-next-line */
        var blocksSettings = this.settings.hasOwnProperty('blocks') ? this.settings.blocks : [];
        return blocksSettings.find(item => item.collection === collectionHandle);
      }
    },

    heroStyle() {
      return this.getCollectionSetting('hero_style');
    },

    heroInvertedMode() {
      return this.getCollectionSetting('inverted_mode');
    },

    heroEnableOverlay() {
      return this.getCollectionSetting('enable_overlay');
    },

    heroOverlayOpacity() {
      return this.getCollectionSetting('overlay_opacity');
    },

    heroBackgroundColor() {
      return this.getCollectionSetting('background_color');
    },

    heroVideo() {
      return this.getCollectionSetting('video');
    },

    heroVideoSmall() {
      return this.getCollectionSetting('video_s');
    },

    heroVideoLarge() {
      return this.getCollectionSetting('video_l');
    },

    heroImageMobile() {
      return this.getCollectionSetting('image_mobile');
    },

    heroImageIntermediate() {
      return this.getCollectionSetting('image_intermediate');
    },

    heroImage() {
      return this.getCollectionSetting('image');
    },

    heroContentAlignment() {
      return this.getCollectionSetting('content_alignment');
    },

    heroTextAlignment() {
      return this.getCollectionSetting('text_alignment');
    },

    heroType() {
      if (this.heroStyle === '2-up' || this.heroStyle === 'fullwidth-image') {
        return 'image';
      } else if (this.heroStyle === 'fullwidth-video') {
        return 'video';
      } else {
        return 'color';
      }
    },

    heroSources() {
      var images = [];

      if (this.blockSettings) {
        if (this.blockSettings.image_mobile) images.push(this.blockSettings.image_mobile);
        if (this.blockSettings.image_intermediate) images.push(this.blockSettings.image_intermediate);
      } else {
        if (this.heroImageMobile) images.push(this.heroImageMobile);
        if (this.heroImageIntermediate) images.push(this.heroImageIntermediate);
      }

      var heroImage = this.heroImage || this.collection.image;
      images.push(heroImage);
      return images.join('|');
    },

    heroBreakpoints() {
      var breakpoints = [];

      if (this.blockSettings) {
        if (this.blockSettings.image_mobile) breakpoints.push('(max-width: 767px)');
        if (this.blockSettings.image_intermediate) breakpoints.push('(min-width: 768px) and (max-width: 999px)');
      } else {
        if (this.heroImageMobile) breakpoints.push('(max-width: 767px)');
        if (this.heroImageIntermediate) breakpoints.push('(min-width: 768px) and (max-width: 999px)');
      }

      var heroImage = this.heroImage || this.collection.image;

      if (heroImage) {
        breakpoints.push('(min-width: 1000px)');
      }

      return breakpoints.join('|');
    }

  }),
  methods: _objectSpread({
    shouldShowProduct(product) {
      var productFacetMatches = this.selectedFacets.reduce((obj, facet) => {
        if (typeof obj.needed === 'undefined') {
          obj.needed = {};
        }

        if (typeof obj.matches === 'undefined') {
          obj.matches = {};
        }

        obj.needed[facet.name] = true;

        if (typeof product[facet.name] !== 'undefined' && ~product[facet.name].indexOf(facet.value)) {
          obj.matches[facet.name] = true;
        }

        return obj;
      }, {});

      if (!productFacetMatches.needed) {
        return true;
      }

      return Object.keys(productFacetMatches.needed).every(key => {
        return typeof productFacetMatches.matches[key] !== 'undefined';
      });
    },

    fetchCollectionHeroSettings() {
      var heroSettingsEl = this.$refs['plp-hero-settings'];

      if (heroSettingsEl) {
        var settings = heroSettingsEl.getAttribute('data-settings');
        var decodedSettings = decodeURIComponent(settings);
        this.settings = JSON.parse(decodedSettings);
      }
    },

    getCollectionSetting(name) {
      if (this.blockSettings) {
        return this.blockSettings[name];
      } else if (this.settings) {
        return this.settings[name];
      }
    }

  }, Object(vuex__WEBPACK_IMPORTED_MODULE_4__["mapActions"])(['fetchCollection', 'toggleFilterMenu', 'toggleCompactView']))
}));

/***/ }),

/***/ "./src/modules/pre-order-note/PreOrderNote.vue":
/*!*****************************************************!*\
  !*** ./src/modules/pre-order-note/PreOrderNote.vue ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _PreOrderNote_vue_vue_type_template_id_2c4f4ee0___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PreOrderNote.vue?vue&type=template&id=2c4f4ee0& */ "./src/modules/pre-order-note/PreOrderNote.vue?vue&type=template&id=2c4f4ee0&");
/* harmony import */ var _PreOrderNote_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PreOrderNote.vue?vue&type=script&lang=js& */ "./src/modules/pre-order-note/PreOrderNote.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _PreOrderNote_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _PreOrderNote_vue_vue_type_template_id_2c4f4ee0___WEBPACK_IMPORTED_MODULE_0__["render"],
  _PreOrderNote_vue_vue_type_template_id_2c4f4ee0___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/pre-order-note/PreOrderNote.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/pre-order-note/PreOrderNote.vue?vue&type=script&lang=js&":
/*!******************************************************************************!*\
  !*** ./src/modules/pre-order-note/PreOrderNote.vue?vue&type=script&lang=js& ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PreOrderNote_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./PreOrderNote.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/pre-order-note/PreOrderNote.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PreOrderNote_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/pre-order-note/PreOrderNote.vue?vue&type=template&id=2c4f4ee0&":
/*!************************************************************************************!*\
  !*** ./src/modules/pre-order-note/PreOrderNote.vue?vue&type=template&id=2c4f4ee0& ***!
  \************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PreOrderNote_vue_vue_type_template_id_2c4f4ee0___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./PreOrderNote.vue?vue&type=template&id=2c4f4ee0& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/pre-order-note/PreOrderNote.vue?vue&type=template&id=2c4f4ee0&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PreOrderNote_vue_vue_type_template_id_2c4f4ee0___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PreOrderNote_vue_vue_type_template_id_2c4f4ee0___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/product-bundle/ProductBundle.vue":
/*!******************************************************!*\
  !*** ./src/modules/product-bundle/ProductBundle.vue ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ProductBundle_vue_vue_type_template_id_81b9013a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProductBundle.vue?vue&type=template&id=81b9013a& */ "./src/modules/product-bundle/ProductBundle.vue?vue&type=template&id=81b9013a&");
/* harmony import */ var _ProductBundle_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ProductBundle.vue?vue&type=script&lang=js& */ "./src/modules/product-bundle/ProductBundle.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ProductBundle_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ProductBundle_vue_vue_type_template_id_81b9013a___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ProductBundle_vue_vue_type_template_id_81b9013a___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/product-bundle/ProductBundle.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/product-bundle/ProductBundle.vue?vue&type=script&lang=js&":
/*!*******************************************************************************!*\
  !*** ./src/modules/product-bundle/ProductBundle.vue?vue&type=script&lang=js& ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductBundle_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductBundle.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-bundle/ProductBundle.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductBundle_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/product-bundle/ProductBundle.vue?vue&type=template&id=81b9013a&":
/*!*************************************************************************************!*\
  !*** ./src/modules/product-bundle/ProductBundle.vue?vue&type=template&id=81b9013a& ***!
  \*************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductBundle_vue_vue_type_template_id_81b9013a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductBundle.vue?vue&type=template&id=81b9013a& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-bundle/ProductBundle.vue?vue&type=template&id=81b9013a&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductBundle_vue_vue_type_template_id_81b9013a___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductBundle_vue_vue_type_template_id_81b9013a___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/product-card/ProductCard.vue":
/*!**************************************************!*\
  !*** ./src/modules/product-card/ProductCard.vue ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ProductCard_vue_vue_type_template_id_6a2bc502___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProductCard.vue?vue&type=template&id=6a2bc502& */ "./src/modules/product-card/ProductCard.vue?vue&type=template&id=6a2bc502&");
/* harmony import */ var _ProductCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ProductCard.vue?vue&type=script&lang=js& */ "./src/modules/product-card/ProductCard.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ProductCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ProductCard_vue_vue_type_template_id_6a2bc502___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ProductCard_vue_vue_type_template_id_6a2bc502___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/product-card/ProductCard.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/product-card/ProductCard.vue?vue&type=script&lang=js&":
/*!***************************************************************************!*\
  !*** ./src/modules/product-card/ProductCard.vue?vue&type=script&lang=js& ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductCard.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-card/ProductCard.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/product-card/ProductCard.vue?vue&type=template&id=6a2bc502&":
/*!*********************************************************************************!*\
  !*** ./src/modules/product-card/ProductCard.vue?vue&type=template&id=6a2bc502& ***!
  \*********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_vue_vue_type_template_id_6a2bc502___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductCard.vue?vue&type=template&id=6a2bc502& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-card/ProductCard.vue?vue&type=template&id=6a2bc502&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_vue_vue_type_template_id_6a2bc502___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductCard_vue_vue_type_template_id_6a2bc502___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/product-description/product-description.js":
/*!****************************************************************!*\
  !*** ./src/modules/product-description/product-description.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_accordions_Accordions_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/accordions/Accordions.vue */ "./src/modules/accordions/Accordions.vue");
/* harmony import */ var modules_accordions_Accordion_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/accordions/Accordion.vue */ "./src/modules/accordions/Accordion.vue");
/* harmony import */ var modules_more_More_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/more/More.vue */ "./src/modules/more/More.vue");




/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    components: {
      Accordions: modules_accordions_Accordions_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
      Accordion: modules_accordions_Accordion_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
      More: modules_more_More_vue__WEBPACK_IMPORTED_MODULE_3__["default"]
    }
  });
});

/***/ }),

/***/ "./src/modules/product-form/ProductForm.vue":
/*!**************************************************!*\
  !*** ./src/modules/product-form/ProductForm.vue ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ProductForm_vue_vue_type_template_id_98594232___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProductForm.vue?vue&type=template&id=98594232& */ "./src/modules/product-form/ProductForm.vue?vue&type=template&id=98594232&");
/* harmony import */ var _ProductForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ProductForm.vue?vue&type=script&lang=js& */ "./src/modules/product-form/ProductForm.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ProductForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ProductForm_vue_vue_type_template_id_98594232___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ProductForm_vue_vue_type_template_id_98594232___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/product-form/ProductForm.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/product-form/ProductForm.vue?vue&type=script&lang=js&":
/*!***************************************************************************!*\
  !*** ./src/modules/product-form/ProductForm.vue?vue&type=script&lang=js& ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductForm.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-form/ProductForm.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductForm_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/product-form/ProductForm.vue?vue&type=template&id=98594232&":
/*!*********************************************************************************!*\
  !*** ./src/modules/product-form/ProductForm.vue?vue&type=template&id=98594232& ***!
  \*********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductForm_vue_vue_type_template_id_98594232___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductForm.vue?vue&type=template&id=98594232& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-form/ProductForm.vue?vue&type=template&id=98594232&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductForm_vue_vue_type_template_id_98594232___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductForm_vue_vue_type_template_id_98594232___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/product-form/product-form.js":
/*!**************************************************!*\
  !*** ./src/modules/product-form/product-form.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var modules_product_form_ProductForm_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/product-form/ProductForm.vue */ "./src/modules/product-form/ProductForm.vue");
/* harmony import */ var modules_select_input_SelectInput_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/select-input/SelectInput.vue */ "./src/modules/select-input/SelectInput.vue");
/* harmony import */ var modules_product_main_header_ProductMainHeader_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/product-main-header/ProductMainHeader.vue */ "./src/modules/product-main-header/ProductMainHeader.vue");
/* harmony import */ var modules_product_note_ProductNote_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! modules/product-note/ProductNote.vue */ "./src/modules/product-note/ProductNote.vue");
/* harmony import */ var modules_product_zip_ProductZip_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/product-zip/ProductZip.vue */ "./src/modules/product-zip/ProductZip.vue");
/* harmony import */ var modules_modal_Modal_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/modal/Modal.vue */ "./src/modules/modal/Modal.vue");







/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Product Form',
    components: {
      ProductForm: modules_product_form_ProductForm_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
      SelectInput: modules_select_input_SelectInput_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
      ProductMainHeader: modules_product_main_header_ProductMainHeader_vue__WEBPACK_IMPORTED_MODULE_3__["default"],
      ProductNote: modules_product_note_ProductNote_vue__WEBPACK_IMPORTED_MODULE_4__["default"],
      ProductZip: modules_product_zip_ProductZip_vue__WEBPACK_IMPORTED_MODULE_5__["default"],
      Modal: modules_modal_Modal_vue__WEBPACK_IMPORTED_MODULE_6__["default"]
    }
  });
});

/***/ }),

/***/ "./src/modules/product-gallery/product-gallery.js":
/*!********************************************************!*\
  !*** ./src/modules/product-gallery/product-gallery.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! swiper/modules/pagination/pagination.min.css */ "./node_modules/swiper/modules/pagination/pagination.min.css");
/* harmony import */ var swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_modules_pagination_pagination_min_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! modules/video-embed/VideoEmbed.vue */ "./src/modules/video-embed/VideoEmbed.vue");
/* harmony import */ var modules_video_Video_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! modules/video/Video.vue */ "./src/modules/video/Video.vue");
/* harmony import */ var modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! modules/picture/Picture.vue */ "./src/modules/picture/Picture.vue");
/* harmony import */ var modules_zoomable_image_ZoomableImage_vue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! modules/zoomable-image/ZoomableImage.vue */ "./src/modules/zoomable-image/ZoomableImage.vue");











/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Product Gallery',
    components: {
      VideoEmbed: modules_video_embed_VideoEmbed_vue__WEBPACK_IMPORTED_MODULE_7__["default"],
      'v-picture': modules_picture_Picture_vue__WEBPACK_IMPORTED_MODULE_9__["default"],
      ZoomableImage: modules_zoomable_image_ZoomableImage_vue__WEBPACK_IMPORTED_MODULE_10__["default"],
      'v-video': modules_video_Video_vue__WEBPACK_IMPORTED_MODULE_8__["default"]
    },

    data() {
      return {
        key: 'color',
        activeMedia: {},
        state: lib_appState__WEBPACK_IMPORTED_MODULE_1__["default"],
        product: window.BARREL.product,
        swiperMainIns: null,
        swiperThumbnailIns: null,
        isLoaded: false
      };
    },

    watch: {
      'state.activeVariant'(variant) {
        this.goToVariantMedia(variant);
      }

    },
    computed: {
      firstImage() {
        return this.product.media.find(item => item.media_type === 'image');
      }

    },
    methods: {
      getImageWithSize: lib_util__WEBPACK_IMPORTED_MODULE_3__["getImageWithSize"],

      goToVariantMedia(variant) {
        if (!variant || !this.swiperMainIns) return;
        var mediaId = variant.featuredMediaId;
        if (mediaId == null) return;
        var index = this.product.media.findIndex(media => String(media.id) === String(mediaId));
        if (index < 0) return;
        this.swiperMainIns.slideTo(index, false);
      },

      stopAllVideo() {
        var externalVideos = this.$refs.externalVideos;
        var videos = this.$refs.videos;

        if (externalVideos && externalVideos.length > 0) {
          externalVideos.forEach(externalVideo => {
            var video = externalVideo.$el.querySelector('iframe');
            video.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":"", "method":"pause"}', '*');
          });
        }

        if (videos && videos.length > 0) {
          videos.forEach(video => {
            video.pauseVideo();
          });
        }
      }

    },

    created() {
      this.activeMedia = this.product.media[0];
    },

    mounted() {
      this.$nextTick(() => {
        var swiperMainEl = this.$refs.galleryMain;
        var swiperMain = new swiper__WEBPACK_IMPORTED_MODULE_4__["default"](swiperMainEl, {
          spaceBetween: 10,
          slidesPerView: 1,
          modules: [swiper__WEBPACK_IMPORTED_MODULE_4__["Pagination"]],
          pagination: {
            el: '.js-swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        });
        this.swiperMainIns = swiperMain;
        var thumbnailItems = this.$refs.thumbnailItem;
        if (!thumbnailItems) return;
        thumbnailItems.forEach((thumbnail, index) => {
          dom_event__WEBPACK_IMPORTED_MODULE_2___default()(thumbnail, 'click', e => {
            this.activeMedia = this.product.media[index];
            swiperMain.slideTo(index, false);
          });
          dom_event__WEBPACK_IMPORTED_MODULE_2___default()(thumbnail, 'keydown', e => {
            if (e.keyCode === 13) {
              this.activeMedia = this.product.media[index];
              swiperMain.slideTo(index, false);
            }
          });
        });
        swiperMain.on('slideChange', () => {
          this.activeMedia = this.product.media[swiperMain.activeIndex];
          this.stopAllVideo();

          if (this.activeMedia.media_type === 'video') {
            var videos = this.$refs.videos;
            var indexVideo = 0;
            this.product.media.forEach((media, i) => {
              if (media.media_type === 'video' && i <= swiperMain.activeIndex) {
                indexVideo++;
              }
            });

            if (videos && videos.length > 0) {
              var video = videos[indexVideo - 1];

              if (video) {
                if (video.isLoaded) {
                  video.playVideo();
                } else {
                  video.loadVideo();
                }
              }
            }
          }
        });
        var galleryThumbnailEl = this.$refs.galleryThumbnail;
        this.swiperThumbnailIns = new swiper__WEBPACK_IMPORTED_MODULE_4__["default"](galleryThumbnailEl, {
          spaceBetween: 10,
          slidesPerView: 'auto',
          modules: [swiper__WEBPACK_IMPORTED_MODULE_4__["Navigation"]],
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            768: {
              spaceBetween: 10,
              slidesPerView: 'auto'
            },
            1024: {
              spaceBetween: 10,
              slidesPerView: 'auto'
            }
          }
        });
        this.isLoaded = true;
      });
    }

  });
});

/***/ }),

/***/ "./src/modules/product-main-berries/product-main-berries.js":
/*!******************************************************************!*\
  !*** ./src/modules/product-main-berries/product-main-berries.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var modules_availability_callout_availability_callout_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/availability-callout/availability-callout.css */ "./src/modules/availability-callout/availability-callout.css");
/* harmony import */ var modules_availability_callout_availability_callout_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(modules_availability_callout_availability_callout_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lib_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lib/cart */ "./src/assets/js/lib/cart.js");
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_product_main_header_ProductMainHeader_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! modules/product-main-header/ProductMainHeader.vue */ "./src/modules/product-main-header/ProductMainHeader.vue");
/* harmony import */ var lib_zapietDelivery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lib/zapietDelivery */ "./src/assets/js/lib/zapietDelivery.js");










var selectors = {
  priceEls: '.product-main-berries__price-vue',
  trays: '[data-tray]',
  flavorEl: '.js-product-main-berries-flavor',
  addBtn: '[data-add-to-cart]',
  addToCartError: '[data-add-to-cart-error]',
  zipSection: '[data-berries-zip]',
  soldOutSection: '[data-berries-sold-out]',
  zipcodeInput: '#product-main-berries-zip',
  zipcodeCta: '[data-zipcode-cta]',
  zipcodeSpinner: '[data-zipcode-spinner]',
  zipcodeStatus: '[data-zipcode-status]',
  zipcodeUnavailable: '[data-zipcode-unavailable]',
  unavailableZip: '.js-product-main-berries-unavailable-zip',
  unavailableFootnote: '.js-product-main-berries-unavailable-footnote',
  waitlistLink: '.js-product-main-berries-waitlist-link',
  zipcodeResult: '[data-zipcode-result]',
  zipDisplay: '.js-product-main-berries-zip-display',
  deliveryDateDisplay: '.js-product-main-berries-delivery-date',
  zipFootnote: '.js-product-main-berries-zip-footnote',
  availabilityBadge: '.js-product-main-berries-availability-badge'
};
var DAILY_LIMIT_REQUEST_TIMEOUT_MS = 1500;
var DELIVERY_ONLY_TAG = 'Delivery Only';
var CANDIDATE_DATE_SCAN_LIMIT = 90;
var DAILY_LIMITS_DISABLED_CODE = 'DAILY_LIMITS_DISABLED';
var NO_DAILY_LIMITS_CODE = 'NO_DAILY_LIMITS';

var isDailyLimitsBypassCode = code => code === DAILY_LIMITS_DISABLED_CODE || code === NO_DAILY_LIMITS_CODE;

var getEarliestDeliverableDate = calendarData => Object(lib_zapietDelivery__WEBPACK_IMPORTED_MODULE_9__["findFirstDeliverableDate"])(calendarData) || null;

var parseProductTags = rawTags => {
  if (Array.isArray(rawTags)) return rawTags;

  if (typeof rawTags === 'string') {
    return rawTags.split(',').map(tag => tag.trim()).filter(Boolean);
  }

  return [];
};

/* harmony default export */ __webpack_exports__["default"] = (el => {
  var _window$BARREL, _window$BARREL$produc;

  var priceEls = select_dom__WEBPACK_IMPORTED_MODULE_3__["default"].all(selectors.priceEls, el);
  var trays = select_dom__WEBPACK_IMPORTED_MODULE_3__["default"].all(selectors.trays, el);
  var flavorEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.flavorEl, el);
  var addBtn = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.addBtn, el);
  var addToCartErrorEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.addToCartError, el);
  var zipSection = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipSection, el);
  var soldOutSection = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.soldOutSection, el);
  var zipcodeInput = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipcodeInput, el);
  var zipcodeCta = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipcodeCta, el);
  var zipcodeSpinner = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipcodeSpinner, el);
  var zipcodeStatus = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipcodeStatus, el);
  var zipcodeUnavailable = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipcodeUnavailable, el);
  var unavailableZipEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.unavailableZip, el);
  var unavailableFootnoteEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.unavailableFootnote, el);
  var waitlistLink = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.waitlistLink, el);
  var zipcodeResult = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipcodeResult, el);
  var zipDisplayEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipDisplay, el);
  var deliveryDateEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.deliveryDateDisplay, el);
  var zipFootnoteEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.zipFootnote, el);
  var availabilityBadgeEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])(selectors.availabilityBadge, el);
  var variantId = el.dataset.variantId || '';
  var productAvailable = el.dataset.productAvailable !== 'false';
  var addToCartLabel = (addBtn === null || addBtn === void 0 ? void 0 : addBtn.dataset.addLabel) || 'Add to cart';
  var soldOutLabel = (addBtn === null || addBtn === void 0 ? void 0 : addBtn.dataset.soldOutLabel) || 'Sold out';
  var productTags = parseProductTags((_window$BARREL = window.BARREL) === null || _window$BARREL === void 0 ? void 0 : (_window$BARREL$produc = _window$BARREL.product) === null || _window$BARREL$produc === void 0 ? void 0 : _window$BARREL$produc.tags);
  var isDeliveryOnlyProduct = productTags.includes(DELIVERY_ONLY_TAG);
  var zipCheckPassed = false;
  var isGlobalSoldOut = !productAvailable;
  var isZipChecking = false;
  var isOutOfZone = false;
  lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].priceOverride = null;

  if (!lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].activeVariant || !lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].activeVariant.id) {
    var _window$BARREL2, _window$BARREL2$produ, _window$BARREL3, _window$BARREL3$produ;

    var variants = ((_window$BARREL2 = window.BARREL) === null || _window$BARREL2 === void 0 ? void 0 : (_window$BARREL2$produ = _window$BARREL2.product) === null || _window$BARREL2$produ === void 0 ? void 0 : _window$BARREL2$produ.variants) || [];
    var initialVariant = variantId ? variants.find(v => String(v.id) === String(variantId)) : null;
    lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].activeVariant = initialVariant || variants[0] || ((_window$BARREL3 = window.BARREL) === null || _window$BARREL3 === void 0 ? void 0 : (_window$BARREL3$produ = _window$BARREL3.product) === null || _window$BARREL3$produ === void 0 ? void 0 : _window$BARREL3$produ.firstAvailableVariant) || {};
  }

  var hideZipStatus = () => {
    if (!zipcodeStatus) return;
    zipcodeStatus.textContent = '';
    zipcodeStatus.hidden = true;
    zipcodeStatus.classList.remove('is-error');
  };

  var showZipError = message => {
    if (!zipcodeStatus) return;
    zipcodeStatus.textContent = message;
    zipcodeStatus.hidden = false;
    zipcodeStatus.classList.add('is-error');
  };

  var hideAddToCartError = () => {
    if (!addToCartErrorEl) return;
    addToCartErrorEl.textContent = '';
    addToCartErrorEl.hidden = true;
  };

  var showAddToCartError = message => {
    if (!addToCartErrorEl) return;
    addToCartErrorEl.textContent = message;
    addToCartErrorEl.hidden = false;
  };

  var updateZipcodeCtaState = () => {
    if (!zipcodeCta) return;
    var hasZip = Boolean(((zipcodeInput === null || zipcodeInput === void 0 ? void 0 : zipcodeInput.value) || '').trim());
    zipcodeCta.disabled = isZipChecking || !hasZip;
    zipcodeCta.classList.toggle('is-loading', isZipChecking);
  };

  var setZipLoading = isLoading => {
    isZipChecking = isLoading;
    updateZipcodeCtaState();

    if (zipcodeSpinner) {
      zipcodeSpinner.hidden = !isLoading;
      zipcodeSpinner.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
    }
  };

  var hideZipUnavailable = () => {
    if (zipcodeUnavailable) zipcodeUnavailable.hidden = true;
    if (unavailableZipEl) unavailableZipEl.textContent = '';
    if (unavailableFootnoteEl) unavailableFootnoteEl.textContent = '';
  };

  var showZipUnavailable = zip => {
    hideZipResult();
    hideZipStatus();
    isOutOfZone = true;
    if (unavailableZipEl) unavailableZipEl.textContent = zip;
    if (unavailableFootnoteEl) unavailableFootnoteEl.textContent = zip;
    if (zipcodeUnavailable) zipcodeUnavailable.hidden = false;

    if (waitlistLink) {
      var baseUrl = waitlistLink.dataset.baseUrl || waitlistLink.getAttribute('href') || '#';
      var separator = baseUrl.includes('?') ? '&' : '?';
      waitlistLink.setAttribute('href', "".concat(baseUrl).concat(separator, "zip=").concat(encodeURIComponent(zip)));
    }

    updateAddToCartState();
  };

  var hideZipResult = () => {
    if (zipcodeResult) zipcodeResult.hidden = true;
  };

  var hideZipFeedback = () => {
    hideZipResult();
    hideZipUnavailable();
    hideZipStatus();
    hideAddToCartError();
  };

  var resetZipCheck = () => {
    zipCheckPassed = false;
    isOutOfZone = false;
  };

  var syncActiveVariantFromTray = trayEl => {
    var _trayEl$dataset, _window$BARREL4, _window$BARREL4$produ;

    var id = trayEl === null || trayEl === void 0 ? void 0 : (_trayEl$dataset = trayEl.dataset) === null || _trayEl$dataset === void 0 ? void 0 : _trayEl$dataset.variantId;
    if (!id) return;
    var variants = ((_window$BARREL4 = window.BARREL) === null || _window$BARREL4 === void 0 ? void 0 : (_window$BARREL4$produ = _window$BARREL4.product) === null || _window$BARREL4$produ === void 0 ? void 0 : _window$BARREL4$produ.variants) || [];
    var variant = variants.find(v => String(v.id) === String(id));

    if (variant) {
      lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].activeVariant = variant;
      variantId = String(variant.id);
      el.dataset.variantId = variantId;
    }
  };

  var setActiveTray = trayEl => {
    if (!trayEl || trayEl.classList.contains('is-out-of-stock')) return;
    syncActiveVariantFromTray(trayEl);
    trays.forEach(tray => {
      var isActive = tray === trayEl;
      tray.classList.toggle('is-active', isActive);
      tray.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (flavorEl) {
      flavorEl.textContent = trayEl.dataset.label || '';
    }

    resetZipCheck();
    hideZipFeedback();
    updateAddToCartState();
  };

  var showGlobalSoldOut = () => {
    isGlobalSoldOut = true;
    resetZipCheck();
    hideZipFeedback();
    if (zipSection) zipSection.hidden = true;
    if (soldOutSection) soldOutSection.hidden = false;
    updateAddToCartState();
  };

  var showZipSection = () => {
    if (isGlobalSoldOut) return;
    if (zipSection) zipSection.hidden = false;
    if (soldOutSection) soldOutSection.hidden = true;
  };

  var isVariantPurchasable = () => {
    var variant = lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].activeVariant || {};
    if (!variant.available) return false;
    var isPreOrder = variant.inventoryQuantity <= 0 && variant.available;
    if (isPreOrder) return true;
    if (variant.inventoryQuantity == null) return true;
    return variant.inventoryQuantity >= 1;
  };

  var updateAvailabilityBadge = () => {
    if (!availabilityBadgeEl || !zipcodeResult || zipcodeResult.hidden) return;
    var availableLabel = availabilityBadgeEl.dataset.availableLabel || 'Available';
    availabilityBadgeEl.textContent = availableLabel;
    availabilityBadgeEl.classList.remove('is-sold-out');
  };

  var updateAddToCartState = () => {
    if (!addBtn) return;

    if (isGlobalSoldOut) {
      addBtn.disabled = true;
      addBtn.textContent = soldOutLabel;
      return;
    }

    addBtn.textContent = addToCartLabel;
    addBtn.disabled = isOutOfZone || !isVariantPurchasable();
  };

  var showZipResult = (zip, deliveryDateLabel) => {
    hideZipUnavailable();
    hideZipStatus();
    if (zipDisplayEl) zipDisplayEl.textContent = zip;
    if (zipFootnoteEl) zipFootnoteEl.textContent = zip;
    if (deliveryDateEl) deliveryDateEl.textContent = deliveryDateLabel;
    if (zipcodeResult) zipcodeResult.hidden = false;
    zipCheckPassed = true;
    Object(lib_zapietDelivery__WEBPACK_IMPORTED_MODULE_9__["saveZapietDeliveryPostcode"])(zip);
    updateAvailabilityBadge();
    updateAddToCartState();
  };

  var getShopDomain = () => window.Shopify && window.Shopify.shop || window.location.hostname;

  var getShoppingCartPayload = () => {
    var _window$BARREL5, _window$BARREL5$produ;

    var activeVariant = lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].activeVariant || {};
    var productId = (_window$BARREL5 = window.BARREL) === null || _window$BARREL5 === void 0 ? void 0 : (_window$BARREL5$produ = _window$BARREL5.product) === null || _window$BARREL5$produ === void 0 ? void 0 : _window$BARREL5$produ.id;
    return [{
      variant_id: activeVariant.id || variantId,
      product_id: productId,
      quantity: 1
    }];
  };

  var formatDeliveryDateLabel = dateKey => {
    if (!dateKey) return '';
    var [year, month, day] = dateKey.split('-').map(Number);
    var deliveryDate = new Date(year, month - 1, day, 12);
    var today = new Date();
    today.setHours(12, 0, 0, 0);
    var diffDays = Math.round((deliveryDate - today) / (24 * 60 * 60 * 1000));
    if (diffDays === 0) return 'today';
    if (diffDays === 1) return 'tomorrow';
    return deliveryDate.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    });
  };

  var fetchZapiet = /*#__PURE__*/function () {
    var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* (url, body, signal) {
      var response = yield fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        signal,
        body: JSON.stringify(body)
      });
      var data = yield response.json();
      return {
        response,
        data
      };
    });

    return function fetchZapiet(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  var withTimeout = /*#__PURE__*/function () {
    var _ref2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* (promiseFactory, timeoutMs) {
      if (typeof AbortController === 'undefined') {
        return promiseFactory();
      }

      var controller = new AbortController();
      var timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

      try {
        return yield promiseFactory(controller.signal);
      } finally {
        window.clearTimeout(timeoutId);
      }
    });

    return function withTimeout(_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  var normalizeDailyLimitDate = dateKey => dateKey.replace(/-/g, '/');

  var checkDailyLimitForDate = /*#__PURE__*/function () {
    var _ref3 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* ({
      shop,
      locationId,
      dateKey,
      shoppingCart
    }) {
      var date = normalizeDailyLimitDate(dateKey);
      var variants = shoppingCart.map(line => ({
        variant_id: line.variant_id,
        quantity: line.quantity
      }));

      try {
        var {
          response,
          data
        } = yield withTimeout(signal => fetchZapiet("https://api.zapiet.com/v1.0/pickup/locations/".concat(locationId, "/daily-limits?shop=").concat(encodeURIComponent(shop)), {
          date,
          variants
        }, signal), DAILY_LIMIT_REQUEST_TIMEOUT_MS);

        if (!(response !== null && response !== void 0 && response.ok) || !data || data.error) {
          return null;
        }

        if (isDailyLimitsBypassCode(data.code)) {
          return DAILY_LIMITS_DISABLED_CODE;
        }

        var isAvailable = null;

        if (Array.isArray(data.unavailable_variants) && data.unavailable_variants.length > 0) {
          isAvailable = false;
        } else if (Array.isArray(data.variants_availability) && data.variants_availability.length > 0) {
          var hasAnyQuantity = data.variants_availability.some(variant => {
            var rawQty = variant === null || variant === void 0 ? void 0 : variant.available_quantity;
            if (rawQty == null) return true;
            var qty = Number(rawQty);
            return Number.isFinite(qty) && qty > 0;
          });
          isAvailable = hasAnyQuantity;
        } else if (data.code === 'OK' && Array.isArray(data.unavailable_variants)) {
          // Response can still be valid with an empty variants list.
          isAvailable = data.unavailable_variants.length === 0;
        }

        return isAvailable;
      } catch (error) {
        return null;
      }
    });

    return function checkDailyLimitForDate(_x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  var pickBestDeliverableDate = /*#__PURE__*/function () {
    var _ref4 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* ({
      shop,
      locationId,
      calendarData,
      shoppingCart
    }) {
      var candidates = Object(lib_zapietDelivery__WEBPACK_IMPORTED_MODULE_9__["getDeliverableDateCandidates"])(calendarData, CANDIDATE_DATE_SCAN_LIMIT);
      if (!candidates.length) return null;

      for (var dateKey of candidates) {
        var isAvailable = yield checkDailyLimitForDate({
          shop,
          locationId,
          dateKey,
          shoppingCart
        });
        if (isAvailable === true) return dateKey;

        if (isAvailable === DAILY_LIMITS_DISABLED_CODE) {
          return getEarliestDeliverableDate(calendarData);
        }
      }

      return null;
    });

    return function pickBestDeliverableDate(_x7) {
      return _ref4.apply(this, arguments);
    };
  }();

  var applyDeliverableDate = (zip, deliverableDate) => {
    if (!deliverableDate) return false;
    showZipResult(zip, formatDeliveryDateLabel(deliverableDate));
    return true;
  };

  var checkAvailability = /*#__PURE__*/function () {
    var _ref5 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      if (!zipcodeInput || !zipcodeCta || isGlobalSoldOut) return;
      var zip = (zipcodeInput.value || '').trim();

      if (!zip) {
        resetZipCheck();
        hideZipFeedback();
        showZipError('Please enter a zip code.');
        updateAddToCartState();
        return;
      }

      var shop = getShopDomain();
      resetZipCheck();
      hideZipFeedback();
      updateAddToCartState();
      setZipLoading(true);

      try {
        var shoppingCart = getShoppingCartPayload();
        var {
          response: locationResponse,
          data: locationData
        } = yield fetchZapiet("https://api.zapiet.com/v1.0/delivery/locations?shop=".concat(encodeURIComponent(shop)), {
          geoSearchQuery: zip,
          shoppingCart
        });

        if (!locationResponse.ok || !locationData || locationData.error) {
          var _locationData$error;

          var noLocation = (locationData === null || locationData === void 0 ? void 0 : (_locationData$error = locationData.error) === null || _locationData$error === void 0 ? void 0 : _locationData$error.code) === 'NO_LOCATIONS_FOUND';

          if (noLocation) {
            showZipUnavailable(zip);
          } else {
            var _locationData$error2;

            showZipError((locationData === null || locationData === void 0 ? void 0 : (_locationData$error2 = locationData.error) === null || _locationData$error2 === void 0 ? void 0 : _locationData$error2.message) || 'Unable to check availability right now.');
          }

          updateAddToCartState();
          return;
        }

        var locationId = locationData.id;

        if (!locationId) {
          showZipError('Unable to check availability right now.');
          updateAddToCartState();
          return;
        }

        var {
          response: calendarResponse,
          data: calendarData
        } = yield fetchZapiet("https://api.zapiet.com/v1.0/delivery/locations/".concat(locationId, "/calendar?shop=").concat(encodeURIComponent(shop)), {
          shoppingCart
        });

        if (!calendarResponse.ok || !calendarData) {
          showZipError('Unable to check delivery dates right now.');
          updateAddToCartState();
          return;
        }

        var deliverableDate = yield pickBestDeliverableDate({
          shop,
          locationId,
          calendarData,
          shoppingCart
        });

        if (!deliverableDate) {
          showZipUnavailable(zip);
          return;
        }

        if (!applyDeliverableDate(zip, deliverableDate)) {
          showZipError('Unable to check availability right now.');
          updateAddToCartState();
        }
      } catch (error) {
        resetZipCheck();
        hideZipFeedback();
        showZipError('Unable to check availability right now.');
        updateAddToCartState();
      } finally {
        setZipLoading(false);
      }
    });

    return function checkAvailability() {
      return _ref5.apply(this, arguments);
    };
  }();

  var mountPrice = priceEl => Object(lib_vue__WEBPACK_IMPORTED_MODULE_2__["default"])(priceEl, {
    name: 'Product Main Berries Price',

    data() {
      return {
        state: lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"]
      };
    },

    components: {
      ProductMainHeader: modules_product_main_header_ProductMainHeader_vue__WEBPACK_IMPORTED_MODULE_8__["default"]
    },
    computed: {
      displayPrice() {
        return this.activeVariantPrice;
      },

      formattedPrice() {
        return Object(lib_util__WEBPACK_IMPORTED_MODULE_7__["formatMoney"])(this.displayPrice, 'amount_no_decimals');
      },

      formattedPriceCompareAt() {
        return Object(lib_util__WEBPACK_IMPORTED_MODULE_7__["formatMoney"])(this.activeVariant.compareAtPrice, 'amount_no_decimals');
      },

      activeVariantPrice() {
        return this.activeVariant.discount_variant_price || this.activeVariant.price;
      },

      activeVariant() {
        return this.state.activeVariant;
      },

      isPriceCompareAt() {
        return this.activeVariant.compareAtPrice > this.displayPrice;
      },

      isPreOrder() {
        return this.activeVariant.inventoryQuantity <= 0 && this.activeVariant.available;
      }

    }
  });

  priceEls.forEach(priceEl => {
    mountPrice(priceEl);
  });

  if (trays.length) {
    var initialTray = trays.find(tray => tray.classList.contains('is-active')) || trays[0];
    setActiveTray(initialTray);
    trays.forEach(tray => {
      dom_event__WEBPACK_IMPORTED_MODULE_4___default()(tray, 'click', () => setActiveTray(tray));
    });
  }

  if (productAvailable) {
    showZipSection();
  } else {
    showGlobalSoldOut();
  }

  if (zipcodeInput) {
    dom_event__WEBPACK_IMPORTED_MODULE_4___default()(zipcodeInput, 'input', () => {
      resetZipCheck();
      hideZipFeedback();
      updateZipcodeCtaState();
      updateAddToCartState();
    });
    dom_event__WEBPACK_IMPORTED_MODULE_4___default()(zipcodeInput, 'keydown', event => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      checkAvailability();
    });
  }

  if (zipcodeCta) {
    dom_event__WEBPACK_IMPORTED_MODULE_4___default()(zipcodeCta, 'click', checkAvailability);
    updateZipcodeCtaState();
  }

  updateAddToCartState();

  if (addBtn) {
    dom_event__WEBPACK_IMPORTED_MODULE_4___default()(addBtn, 'click', /*#__PURE__*/_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      if (!variantId || addBtn.disabled || isGlobalSoldOut || isOutOfZone) return;
      var activeVariant = lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].activeVariant || {};
      var isPreOrder = activeVariant.inventoryQuantity <= 0 && !!activeVariant.available;
      var zip = ((zipcodeInput === null || zipcodeInput === void 0 ? void 0 : zipcodeInput.value) || '').trim();
      addBtn.disabled = true;
      Object(lib_zapietDelivery__WEBPACK_IMPORTED_MODULE_9__["saveZapietDeliveryPostcode"])(zip);
      hideAddToCartError();

      try {
        var _state$activeVariant;

        var addResult = yield lib_cart__WEBPACK_IMPORTED_MODULE_5__["default"].addOrMergeVariant({
          variantId: ((_state$activeVariant = lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].activeVariant) === null || _state$activeVariant === void 0 ? void 0 : _state$activeVariant.id) || variantId,
          quantity: 1,
          properties: {
            _zipcode: zip,
            _inventory_quantity: activeVariant.inventoryQuantity,
            _is_pre_order: isPreOrder ? 'true' : 'false',
            _delivery_only: isDeliveryOnlyProduct ? 'true' : 'false'
          }
        });

        if ((addResult === null || addResult === void 0 ? void 0 : addResult.status) === 422) {
          showAddToCartError(addResult.description || 'Unable to add to cart. Please try again.');
          return;
        }

        hideAddToCartError();
        var data = yield lib_cart__WEBPACK_IMPORTED_MODULE_5__["default"].get();
        lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].cart = data;
        lib_appState__WEBPACK_IMPORTED_MODULE_6__["default"].isMiniCartOpen = true;
        resetZipCheck();
        hideZipFeedback();
        if (zipcodeInput) zipcodeInput.value = '';
        updateZipcodeCtaState();
      } catch (error) {
        showAddToCartError('Unable to add to cart. Please try again.');
      } finally {
        updateZipcodeCtaState();
        updateAddToCartState();
      }
    }));
  }
});

/***/ }),

/***/ "./src/modules/product-main-header/ProductMainHeader.vue":
/*!***************************************************************!*\
  !*** ./src/modules/product-main-header/ProductMainHeader.vue ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ProductMainHeader_vue_vue_type_template_id_4509bc10___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProductMainHeader.vue?vue&type=template&id=4509bc10& */ "./src/modules/product-main-header/ProductMainHeader.vue?vue&type=template&id=4509bc10&");
/* harmony import */ var _ProductMainHeader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ProductMainHeader.vue?vue&type=script&lang=js& */ "./src/modules/product-main-header/ProductMainHeader.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ProductMainHeader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ProductMainHeader_vue_vue_type_template_id_4509bc10___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ProductMainHeader_vue_vue_type_template_id_4509bc10___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/product-main-header/ProductMainHeader.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/product-main-header/ProductMainHeader.vue?vue&type=script&lang=js&":
/*!****************************************************************************************!*\
  !*** ./src/modules/product-main-header/ProductMainHeader.vue?vue&type=script&lang=js& ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductMainHeader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductMainHeader.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-main-header/ProductMainHeader.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductMainHeader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/product-main-header/ProductMainHeader.vue?vue&type=template&id=4509bc10&":
/*!**********************************************************************************************!*\
  !*** ./src/modules/product-main-header/ProductMainHeader.vue?vue&type=template&id=4509bc10& ***!
  \**********************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductMainHeader_vue_vue_type_template_id_4509bc10___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductMainHeader.vue?vue&type=template&id=4509bc10& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-main-header/ProductMainHeader.vue?vue&type=template&id=4509bc10&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductMainHeader_vue_vue_type_template_id_4509bc10___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductMainHeader_vue_vue_type_template_id_4509bc10___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/product-main-header/product-main-header.js":
/*!****************************************************************!*\
  !*** ./src/modules/product-main-header/product-main-header.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/appState */ "./src/assets/js/lib/appState.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_product_main_header_ProductMainHeader_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/product-main-header/ProductMainHeader.vue */ "./src/modules/product-main-header/ProductMainHeader.vue");




/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    name: 'Product Main Header',

    data() {
      return {
        state: lib_appState__WEBPACK_IMPORTED_MODULE_1__["default"]
      };
    },

    components: {
      ProductMainHeader: modules_product_main_header_ProductMainHeader_vue__WEBPACK_IMPORTED_MODULE_3__["default"]
    },
    computed: {
      formattedPrice() {
        return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["formatMoney"])(this.activeVariantPrice, 'amount_no_decimals');
      },

      formattedPriceCompareAt() {
        return Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["formatMoney"])(this.activeVariant.compareAtPrice, 'amount_no_decimals');
      },

      activeVariantPrice() {
        return this.activeVariant.discount_variant_price || this.activeVariant.price;
      },

      activeVariant() {
        return this.state.activeVariant;
      },

      isPriceCompareAt() {
        return this.activeVariant.compareAtPrice > this.activeVariantPrice;
      },

      isPreOrder() {
        return this.activeVariant.inventoryQuantity <= 0 && this.activeVariant.available;
      }

    }
  });
});

/***/ }),

/***/ "./src/modules/product-note/ProductNote.vue":
/*!**************************************************!*\
  !*** ./src/modules/product-note/ProductNote.vue ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ProductNote_vue_vue_type_template_id_36b94243___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProductNote.vue?vue&type=template&id=36b94243& */ "./src/modules/product-note/ProductNote.vue?vue&type=template&id=36b94243&");
/* harmony import */ var _ProductNote_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ProductNote.vue?vue&type=script&lang=js& */ "./src/modules/product-note/ProductNote.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ProductNote_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ProductNote_vue_vue_type_template_id_36b94243___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ProductNote_vue_vue_type_template_id_36b94243___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/product-note/ProductNote.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/product-note/ProductNote.vue?vue&type=script&lang=js&":
/*!***************************************************************************!*\
  !*** ./src/modules/product-note/ProductNote.vue?vue&type=script&lang=js& ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductNote_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductNote.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-note/ProductNote.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductNote_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/product-note/ProductNote.vue?vue&type=template&id=36b94243&":
/*!*********************************************************************************!*\
  !*** ./src/modules/product-note/ProductNote.vue?vue&type=template&id=36b94243& ***!
  \*********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductNote_vue_vue_type_template_id_36b94243___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductNote.vue?vue&type=template&id=36b94243& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-note/ProductNote.vue?vue&type=template&id=36b94243&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductNote_vue_vue_type_template_id_36b94243___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductNote_vue_vue_type_template_id_36b94243___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/product-zip/ProductZip.vue":
/*!************************************************!*\
  !*** ./src/modules/product-zip/ProductZip.vue ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ProductZip_vue_vue_type_template_id_6dcd56bf___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProductZip.vue?vue&type=template&id=6dcd56bf& */ "./src/modules/product-zip/ProductZip.vue?vue&type=template&id=6dcd56bf&");
/* harmony import */ var _ProductZip_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ProductZip.vue?vue&type=script&lang=js& */ "./src/modules/product-zip/ProductZip.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ProductZip_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ProductZip_vue_vue_type_template_id_6dcd56bf___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ProductZip_vue_vue_type_template_id_6dcd56bf___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/product-zip/ProductZip.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/product-zip/ProductZip.vue?vue&type=script&lang=js&":
/*!*************************************************************************!*\
  !*** ./src/modules/product-zip/ProductZip.vue?vue&type=script&lang=js& ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductZip_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductZip.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/product-zip/ProductZip.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductZip_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/product-zip/ProductZip.vue?vue&type=template&id=6dcd56bf&":
/*!*******************************************************************************!*\
  !*** ./src/modules/product-zip/ProductZip.vue?vue&type=template&id=6dcd56bf& ***!
  \*******************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductZip_vue_vue_type_template_id_6dcd56bf___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ProductZip.vue?vue&type=template&id=6dcd56bf& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/product-zip/ProductZip.vue?vue&type=template&id=6dcd56bf&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductZip_vue_vue_type_template_id_6dcd56bf___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ProductZip_vue_vue_type_template_id_6dcd56bf___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/quantity-selector/QuantitySelector.vue":
/*!************************************************************!*\
  !*** ./src/modules/quantity-selector/QuantitySelector.vue ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _QuantitySelector_vue_vue_type_template_id_35ae8739___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./QuantitySelector.vue?vue&type=template&id=35ae8739& */ "./src/modules/quantity-selector/QuantitySelector.vue?vue&type=template&id=35ae8739&");
/* harmony import */ var _QuantitySelector_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./QuantitySelector.vue?vue&type=script&lang=js& */ "./src/modules/quantity-selector/QuantitySelector.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _QuantitySelector_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _QuantitySelector_vue_vue_type_template_id_35ae8739___WEBPACK_IMPORTED_MODULE_0__["render"],
  _QuantitySelector_vue_vue_type_template_id_35ae8739___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/quantity-selector/QuantitySelector.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/quantity-selector/QuantitySelector.vue?vue&type=script&lang=js&":
/*!*************************************************************************************!*\
  !*** ./src/modules/quantity-selector/QuantitySelector.vue?vue&type=script&lang=js& ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./QuantitySelector.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/quantity-selector/QuantitySelector.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/quantity-selector/QuantitySelector.vue?vue&type=template&id=35ae8739&":
/*!*******************************************************************************************!*\
  !*** ./src/modules/quantity-selector/QuantitySelector.vue?vue&type=template&id=35ae8739& ***!
  \*******************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_template_id_35ae8739___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./QuantitySelector.vue?vue&type=template&id=35ae8739& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/quantity-selector/QuantitySelector.vue?vue&type=template&id=35ae8739&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_template_id_35ae8739___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_template_id_35ae8739___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/recipe-card/RecipeCard.vue":
/*!************************************************!*\
  !*** ./src/modules/recipe-card/RecipeCard.vue ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _RecipeCard_vue_vue_type_template_id_40ae529f___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./RecipeCard.vue?vue&type=template&id=40ae529f& */ "./src/modules/recipe-card/RecipeCard.vue?vue&type=template&id=40ae529f&");
/* harmony import */ var _RecipeCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./RecipeCard.vue?vue&type=script&lang=js& */ "./src/modules/recipe-card/RecipeCard.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _RecipeCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _RecipeCard_vue_vue_type_template_id_40ae529f___WEBPACK_IMPORTED_MODULE_0__["render"],
  _RecipeCard_vue_vue_type_template_id_40ae529f___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/recipe-card/RecipeCard.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/recipe-card/RecipeCard.vue?vue&type=script&lang=js&":
/*!*************************************************************************!*\
  !*** ./src/modules/recipe-card/RecipeCard.vue?vue&type=script&lang=js& ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./RecipeCard.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-card/RecipeCard.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/recipe-card/RecipeCard.vue?vue&type=template&id=40ae529f&":
/*!*******************************************************************************!*\
  !*** ./src/modules/recipe-card/RecipeCard.vue?vue&type=template&id=40ae529f& ***!
  \*******************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeCard_vue_vue_type_template_id_40ae529f___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./RecipeCard.vue?vue&type=template&id=40ae529f& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-card/RecipeCard.vue?vue&type=template&id=40ae529f&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeCard_vue_vue_type_template_id_40ae529f___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeCard_vue_vue_type_template_id_40ae529f___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/recipe-filters/recipe-filters.js":
/*!******************************************************!*\
  !*** ./src/modules/recipe-filters/recipe-filters.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue_scrollto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue-scrollto */ "./node_modules/vue-scrollto/vue-scrollto.js");
/* harmony import */ var vue_scrollto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue_scrollto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_recipe_grid_RecipeGrid_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/recipe-grid/RecipeGrid.vue */ "./src/modules/recipe-grid/RecipeGrid.vue");
/* harmony import */ var modules_recipe_grid_tab_RecipeGridTab_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/recipe-grid-tab/RecipeGridTab.vue */ "./src/modules/recipe-grid-tab/RecipeGridTab.vue");
/* harmony import */ var modules_select_input_SelectInput_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! modules/select-input/SelectInput.vue */ "./src/modules/select-input/SelectInput.vue");
/* harmony import */ var modules_pagination_Pagination_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! modules/pagination/Pagination.vue */ "./src/modules/pagination/Pagination.vue");









vue__WEBPACK_IMPORTED_MODULE_1___default.a.use(vue_scrollto__WEBPACK_IMPORTED_MODULE_2___default.a);
/* harmony default export */ __webpack_exports__["default"] = (el => new vue__WEBPACK_IMPORTED_MODULE_1___default.a({
  name: 'Recipe Filters',
  el,
  components: {
    RecipeGrid: modules_recipe_grid_RecipeGrid_vue__WEBPACK_IMPORTED_MODULE_5__["default"],
    SelectInput: modules_select_input_SelectInput_vue__WEBPACK_IMPORTED_MODULE_7__["default"],
    Pagination: modules_pagination_Pagination_vue__WEBPACK_IMPORTED_MODULE_8__["default"],
    RecipeGridTab: modules_recipe_grid_tab_RecipeGridTab_vue__WEBPACK_IMPORTED_MODULE_6__["default"]
  },

  data() {
    var isEvent = el.dataset.template && el.dataset.template === 'event';
    return {
      collection: {},
      articles: [],
      perPage: isEvent ? 900 : 9,
      currentPage: 1,
      totalPages: 1,
      totalCount: 1,
      currentTag: '',
      pathname: window.location.pathname,
      isEvent: isEvent,
      allTags: []
    };
  },

  computed: {
    handle() {
      if (this.currentTag) {
        return "".concat(this.collection.handle, "/tagged/").concat(Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"])(this.currentTag));
      }

      return this.collection.handle;
    },

    visibleArticles() {
      if (this.currentTag === 'all-event') {
        return this.articles;
      } else {
        return this.articles.filter(article => {
          var filteredArticles = article.eventTags.filter(tag => {
            return Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"])(tag).indexOf(Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"])(this.currentTag)) > -1;
          });
          return filteredArticles.length;
        });
      }
    },

    paginatedArticles() {
      if (!this.isEvent) return this.articles;
      var page = this.currentPage;
      var perPage = this.perPage;
      var from = page * perPage - perPage;
      var to = page * perPage;
      return this.visibleArticles.slice(from, to);
    }

  },

  mounted() {
    if (this.isEvent) {
      this.$nextTick(() => {
        var selectTag = window.localStorage.getItem('select-tag') || 'all-event';
        this.currentTag = Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"])(selectTag);
        this.getArticles(window.location.pathname, 1, true);
      });
    } else {
      if (this.pathname.includes('/tagged/')) {
        this.currentTag = this.pathname.substring(this.pathname.indexOf('/tagged/') + 8);
      }

      this.getArticles(this.pathname);
    }
  },

  methods: {
    handleizeShopify: lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"],

    getArticles(handle, page = 1, isFirst = false) {
      var _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
        var host = "//".concat(window.location.host);

        if (_this.isEvent) {
          var _endpoint = "".concat(handle, "?view=blog-event-endpoint");

          yield Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["fetchData"])("".concat(host).concat(_endpoint)).then(data => {
            _this.collection = data.collection || {};
            _this.articles = (data.articles || []).sort((obj1, obj2) => Number(new Date(obj1.eventStartDate).getTime()) - Number(new Date(obj2.eventStartDate).getTime()));

            if (isFirst) {
              var setA = new Set(_this.allTags);

              _this.articles.map(article => {
                if (article.eventTags.length > 0) {
                  article.eventTags.map(tag => {
                    if (!setA.has(tag)) {
                      _this.allTags.push(tag.toLowerCase());

                      setA.add(tag);
                    }

                    return true;
                  });
                }

                return true;
              });
            }
          });
          _this.totalCount = _this.articles.length;
          _this.totalPages = _this.articles.length / _this.perPage;
          return;
        }

        var endpoint = "".concat(handle, "?view=blog-endpoint&page=").concat(page);
        yield Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["fetchData"])("".concat(host).concat(endpoint)).then(data => {
          _this.collection = data.collection || {};
          _this.articles = data.articles || [];
          _this.currentPage = data.page || 1;
          _this.totalPages = data.pages || 1;
          _this.totalCount = data.total || 1;
        });
      })();
    },

    onSelectChange({
      name,
      value
    }) {
      if (!value.length || Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"])(value) === this.currentTag) return;
      this.currentTag = Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"])(value);
      window.history.pushState({}, this.pathname, this.handle);
      this.getArticles(this.handle);
    },

    onPaginationChange(page) {
      if (page === this.currentPage && !this.isEvent) return;

      if (this.isEvent) {
        this.currentPage = page;
      }

      if (!this.isEvent) {
        this.getArticles(this.handle, page);
      }

      this.$scrollTo(this.$refs.recipeFilters, 500, {
        offset: (this.getHeaderHeight() - 1) * -1
      });
    },

    getHeaderHeight() {
      var headerEl = Object(select_dom__WEBPACK_IMPORTED_MODULE_3__["default"])('.js-site-header');
      return headerEl ? headerEl.offsetHeight : 0;
    },

    selectTag(value) {
      if (!value || value === this.currentTag) return;
      window.localStorage.setItem('select-tag', Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"])(value));
      this.currentTag = Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["handleizeShopify"])(value);

      if (this.isEvent) {
        this.currentPage = 1;
      }
    }

  }
}));

/***/ }),

/***/ "./src/modules/recipe-grid-tab/RecipeGridTab.vue":
/*!*******************************************************!*\
  !*** ./src/modules/recipe-grid-tab/RecipeGridTab.vue ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _RecipeGridTab_vue_vue_type_template_id_31b6dfa4___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./RecipeGridTab.vue?vue&type=template&id=31b6dfa4& */ "./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=template&id=31b6dfa4&");
/* harmony import */ var _RecipeGridTab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./RecipeGridTab.vue?vue&type=script&lang=js& */ "./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _RecipeGridTab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _RecipeGridTab_vue_vue_type_template_id_31b6dfa4___WEBPACK_IMPORTED_MODULE_0__["render"],
  _RecipeGridTab_vue_vue_type_template_id_31b6dfa4___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/recipe-grid-tab/RecipeGridTab.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=script&lang=js&":
/*!********************************************************************************!*\
  !*** ./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=script&lang=js& ***!
  \********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGridTab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./RecipeGridTab.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGridTab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=template&id=31b6dfa4&":
/*!**************************************************************************************!*\
  !*** ./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=template&id=31b6dfa4& ***!
  \**************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGridTab_vue_vue_type_template_id_31b6dfa4___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./RecipeGridTab.vue?vue&type=template&id=31b6dfa4& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-grid-tab/RecipeGridTab.vue?vue&type=template&id=31b6dfa4&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGridTab_vue_vue_type_template_id_31b6dfa4___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGridTab_vue_vue_type_template_id_31b6dfa4___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/recipe-grid/RecipeGrid.vue":
/*!************************************************!*\
  !*** ./src/modules/recipe-grid/RecipeGrid.vue ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _RecipeGrid_vue_vue_type_template_id_7afbd642___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./RecipeGrid.vue?vue&type=template&id=7afbd642& */ "./src/modules/recipe-grid/RecipeGrid.vue?vue&type=template&id=7afbd642&");
/* harmony import */ var _RecipeGrid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./RecipeGrid.vue?vue&type=script&lang=js& */ "./src/modules/recipe-grid/RecipeGrid.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _RecipeGrid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _RecipeGrid_vue_vue_type_template_id_7afbd642___WEBPACK_IMPORTED_MODULE_0__["render"],
  _RecipeGrid_vue_vue_type_template_id_7afbd642___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/recipe-grid/RecipeGrid.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/recipe-grid/RecipeGrid.vue?vue&type=script&lang=js&":
/*!*************************************************************************!*\
  !*** ./src/modules/recipe-grid/RecipeGrid.vue?vue&type=script&lang=js& ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGrid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./RecipeGrid.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-grid/RecipeGrid.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGrid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/recipe-grid/RecipeGrid.vue?vue&type=template&id=7afbd642&":
/*!*******************************************************************************!*\
  !*** ./src/modules/recipe-grid/RecipeGrid.vue?vue&type=template&id=7afbd642& ***!
  \*******************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGrid_vue_vue_type_template_id_7afbd642___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./RecipeGrid.vue?vue&type=template&id=7afbd642& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/recipe-grid/RecipeGrid.vue?vue&type=template&id=7afbd642&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGrid_vue_vue_type_template_id_7afbd642___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RecipeGrid_vue_vue_type_template_id_7afbd642___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/recipe-grid/recipe-grid.js":
/*!************************************************!*\
  !*** ./src/modules/recipe-grid/recipe-grid.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");




/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_0__["default"])(el, {
    data() {
      return {
        totalItems: el.dataset.totalItems ? Number.parseInt(el.dataset.totalItems) : 0,
        isMobile: false
      };
    },

    watch: {
      isMobile(val) {
        if (!val) {
          this.swiperIns.destroy();
        } else {
          this.initCarousel();
        }
      }

    },

    mounted() {
      this.resizeHandler();
      this.$nextTick(() => {
        window.addEventListener('resize', this.resizeHandler);
      });
    },

    methods: {
      resizeHandler() {
        this.isMobile = Object(lib_util__WEBPACK_IMPORTED_MODULE_3__["isMobile"])();
      },

      initCarousel() {
        if (this.totalItems < 2) return;
        var swiperEl = this.$refs.recipeGridCarousel;

        if (swiperEl) {
          this.swiperIns = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](swiperEl, {
            slidesPerView: 1.33,
            spaceBetween: 10,
            loop: false
          });
        }
      }

    },

    destroy() {
      window.removeEventListener('resize', this.resizeHandler);
    }

  });
});

/***/ }),

/***/ "./src/modules/related-products/related-products.js":
/*!**********************************************************!*\
  !*** ./src/modules/related-products/related-products.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var modules_product_card_ProductCard_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/product-card/ProductCard.vue */ "./src/modules/product-card/ProductCard.vue");






/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_1__["default"])(el, {
    name: 'Related Products',
    components: {
      ProductCard: modules_product_card_ProductCard_vue__WEBPACK_IMPORTED_MODULE_5__["default"]
    },

    data() {
      return {
        products: [],
        product: window.BARREL.product,
        isMobile: false
      };
    },

    computed: {
      title() {
        if (this.product.productVendor) {
          var variables = this.product.productVendor.split(' - ');

          if (variables.length >= 1) {
            return "Also available for ".concat(variables[0]);
          }

          return "Also available for ".concat(variables[1].toLowerCase(), " in ").concat(variables[0]);
        }

        return null;
      },

      productList() {
        return this.products.slice(0, 3);
      }

    },
    watch: {
      isMobile(val) {
        if (!val) {
          this.swiperIns && this.swiperIns.destroy();
        } else {
          this.initCarousel();
        }
      }

    },

    mounted() {
      var _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
        yield _this.getProducts();

        _this.resizeHandler();

        _this.$nextTick(() => {
          window.addEventListener('resize', _this.resizeHandler);
        });
      })();
    },

    methods: {
      getProducts() {
        var _this2 = this;

        return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
          var host = "//".concat(window.location.host);
          var q = "vendor:\"".concat(_this2.product.productVendor, "\"+-id:").concat(_this2.product.id);
          yield Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["fetchData"])("".concat(host, "/search?q=").concat(q, "&type=product&view=related-products-endpoint")).then(data => {
            _this2.products = data.products || [];
          });
        })();
      },

      resizeHandler() {
        this.isMobile = Object(lib_util__WEBPACK_IMPORTED_MODULE_4__["isMobile"])();
      },

      initCarousel() {
        if (this.products.length < 2) return;
        var swiperEl = this.$refs.relatedProducts;

        if (swiperEl) {
          this.swiperIns = new swiper__WEBPACK_IMPORTED_MODULE_2__["default"](swiperEl, {
            slidesPerView: 1.33,
            spaceBetween: 10,
            loop: false
          });
        }
      }

    },

    destroy() {
      window.removeEventListener('resize', this.resizeHandler);
    }

  });
});

/***/ }),

/***/ "./src/modules/reviews/reviews.js":
/*!****************************************!*\
  !*** ./src/modules/reviews/reviews.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _picture_picture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../picture/picture */ "./src/modules/picture/picture.js");



var SWIPER_SELECTOR = '.js-reviews-swiper';
/* harmony default export */ __webpack_exports__["default"] = (el => {
  var swiperEl = el.querySelector(SWIPER_SELECTOR);
  var breakpointTablet = window.matchMedia('(min-width: 768px)');
  var swiper;

  var initSwiper = () => {
    if (!breakpointTablet.matches) {
      swiper = new swiper__WEBPACK_IMPORTED_MODULE_0__["default"](swiperEl, {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        on: {
          beforeLoopFix() {
            // Reinit images when looping carousel
            var pictureEls = el.querySelectorAll('[data-module="picture"]:not(.is-loaded)');
            pictureEls.length && pictureEls.forEach(pictureEl => Object(_picture_picture__WEBPACK_IMPORTED_MODULE_2__["default"])(pictureEl));
          }

        }
      });
    } else if (swiper !== undefined) {
      swiper.destroy();
      swiper = undefined;
    }
  };

  if (swiperEl) {
    initSwiper();
    breakpointTablet.addEventListener('change', initSwiper);
  }

  return swiper;
});

/***/ }),

/***/ "./src/modules/select-input/SelectInput.vue":
/*!**************************************************!*\
  !*** ./src/modules/select-input/SelectInput.vue ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _SelectInput_vue_vue_type_template_id_b9a41bce___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./SelectInput.vue?vue&type=template&id=b9a41bce& */ "./src/modules/select-input/SelectInput.vue?vue&type=template&id=b9a41bce&");
/* harmony import */ var _SelectInput_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SelectInput.vue?vue&type=script&lang=js& */ "./src/modules/select-input/SelectInput.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _SelectInput_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _SelectInput_vue_vue_type_template_id_b9a41bce___WEBPACK_IMPORTED_MODULE_0__["render"],
  _SelectInput_vue_vue_type_template_id_b9a41bce___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/select-input/SelectInput.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/select-input/SelectInput.vue?vue&type=script&lang=js&":
/*!***************************************************************************!*\
  !*** ./src/modules/select-input/SelectInput.vue?vue&type=script&lang=js& ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./SelectInput.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/select-input/SelectInput.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/select-input/SelectInput.vue?vue&type=template&id=b9a41bce&":
/*!*********************************************************************************!*\
  !*** ./src/modules/select-input/SelectInput.vue?vue&type=template&id=b9a41bce& ***!
  \*********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_template_id_b9a41bce___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./SelectInput.vue?vue&type=template&id=b9a41bce& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/select-input/SelectInput.vue?vue&type=template&id=b9a41bce&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_template_id_b9a41bce___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_template_id_b9a41bce___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/social-links/SocialLinks.vue":
/*!**************************************************!*\
  !*** ./src/modules/social-links/SocialLinks.vue ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _SocialLinks_vue_vue_type_template_id_cbda2e52___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./SocialLinks.vue?vue&type=template&id=cbda2e52& */ "./src/modules/social-links/SocialLinks.vue?vue&type=template&id=cbda2e52&");
/* harmony import */ var _SocialLinks_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SocialLinks.vue?vue&type=script&lang=js& */ "./src/modules/social-links/SocialLinks.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _SocialLinks_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _SocialLinks_vue_vue_type_template_id_cbda2e52___WEBPACK_IMPORTED_MODULE_0__["render"],
  _SocialLinks_vue_vue_type_template_id_cbda2e52___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/social-links/SocialLinks.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/social-links/SocialLinks.vue?vue&type=script&lang=js&":
/*!***************************************************************************!*\
  !*** ./src/modules/social-links/SocialLinks.vue?vue&type=script&lang=js& ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SocialLinks_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./SocialLinks.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/social-links/SocialLinks.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SocialLinks_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/social-links/SocialLinks.vue?vue&type=template&id=cbda2e52&":
/*!*********************************************************************************!*\
  !*** ./src/modules/social-links/SocialLinks.vue?vue&type=template&id=cbda2e52& ***!
  \*********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SocialLinks_vue_vue_type_template_id_cbda2e52___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./SocialLinks.vue?vue&type=template&id=cbda2e52& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/social-links/SocialLinks.vue?vue&type=template&id=cbda2e52&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SocialLinks_vue_vue_type_template_id_cbda2e52___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SocialLinks_vue_vue_type_template_id_cbda2e52___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/sticky-promo-banner/sticky-promo-banner.js":
/*!****************************************************************!*\
  !*** ./src/modules/sticky-promo-banner/sticky-promo-banner.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (el => {
  var lastWindowWidth = window.innerWidth;

  var setCssVars = () => {
    var height = el.clientHeight;
    document.body.style.setProperty('--sticky-promo-banner-height', "".concat(height, "px"));
  };

  setCssVars();
  window.addEventListener('resize', () => {
    if (lastWindowWidth === window.innerWidth) return;
    lastWindowWidth = window.innerWidth;
    setCssVars();
  });
});

/***/ }),

/***/ "./src/modules/store-locator-tabs/StoreLocatorTabs.vue":
/*!*************************************************************!*\
  !*** ./src/modules/store-locator-tabs/StoreLocatorTabs.vue ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _StoreLocatorTabs_vue_vue_type_template_id_9c52a820___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./StoreLocatorTabs.vue?vue&type=template&id=9c52a820& */ "./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=template&id=9c52a820&");
/* harmony import */ var _StoreLocatorTabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./StoreLocatorTabs.vue?vue&type=script&lang=js& */ "./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _StoreLocatorTabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _StoreLocatorTabs_vue_vue_type_template_id_9c52a820___WEBPACK_IMPORTED_MODULE_0__["render"],
  _StoreLocatorTabs_vue_vue_type_template_id_9c52a820___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/store-locator-tabs/StoreLocatorTabs.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=script&lang=js&":
/*!**************************************************************************************!*\
  !*** ./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=script&lang=js& ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StoreLocatorTabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./StoreLocatorTabs.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StoreLocatorTabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=template&id=9c52a820&":
/*!********************************************************************************************!*\
  !*** ./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=template&id=9c52a820& ***!
  \********************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StoreLocatorTabs_vue_vue_type_template_id_9c52a820___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./StoreLocatorTabs.vue?vue&type=template&id=9c52a820& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/store-locator-tabs/StoreLocatorTabs.vue?vue&type=template&id=9c52a820&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StoreLocatorTabs_vue_vue_type_template_id_9c52a820___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StoreLocatorTabs_vue_vue_type_template_id_9c52a820___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/store-locator-tabs/store-locator-tabs.js":
/*!**************************************************************!*\
  !*** ./src/modules/store-locator-tabs/store-locator-tabs.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var modules_store_locator_tabs_StoreLocatorTabs_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/store-locator-tabs/StoreLocatorTabs.vue */ "./src/modules/store-locator-tabs/StoreLocatorTabs.vue");


/* harmony default export */ __webpack_exports__["default"] = (el => new vue__WEBPACK_IMPORTED_MODULE_0___default.a({
  name: 'StoreLocatorTabsModule',
  el,
  components: {
    StoreLocatorTabs: modules_store_locator_tabs_StoreLocatorTabs_vue__WEBPACK_IMPORTED_MODULE_1__["default"]
  },

  data() {
    return {};
  }

}));

/***/ }),

/***/ "./src/modules/style-guide/style-guide.js":
/*!************************************************!*\
  !*** ./src/modules/style-guide/style-guide.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var modules_example_Example_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! modules/example/Example.vue */ "./src/modules/example/Example.vue");
/* harmony import */ var modules_select_input_SelectInput_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! modules/select-input/SelectInput.vue */ "./src/modules/select-input/SelectInput.vue");
/* harmony import */ var modules_text_input_TextInput_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! modules/text-input/TextInput.vue */ "./src/modules/text-input/TextInput.vue");
/* harmony import */ var modules_checkbox_Checkbox_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! modules/checkbox/Checkbox.vue */ "./src/modules/checkbox/Checkbox.vue");
/* harmony import */ var modules_pagination_Pagination_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/pagination/Pagination.vue */ "./src/modules/pagination/Pagination.vue");
/* harmony import */ var modules_social_links_SocialLinks_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/social-links/SocialLinks.vue */ "./src/modules/social-links/SocialLinks.vue");







/* harmony default export */ __webpack_exports__["default"] = (el => {
  return new vue__WEBPACK_IMPORTED_MODULE_0___default.a({
    name: 'StyleGuide',
    el,
    components: {
      Example: modules_example_Example_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
      Checkbox: modules_checkbox_Checkbox_vue__WEBPACK_IMPORTED_MODULE_4__["default"],
      TextInput: modules_text_input_TextInput_vue__WEBPACK_IMPORTED_MODULE_3__["default"],
      SelectInput: modules_select_input_SelectInput_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
      Pagination: modules_pagination_Pagination_vue__WEBPACK_IMPORTED_MODULE_5__["default"],
      SocialLinks: modules_social_links_SocialLinks_vue__WEBPACK_IMPORTED_MODULE_6__["default"]
    },

    data() {
      return {
        data: {}
      };
    },

    methods: {
      onInputChange(event) {}

    }
  });
});

/***/ }),

/***/ "./src/modules/style-guide/style-guide.vue.js":
/*!****************************************************!*\
  !*** ./src/modules/style-guide/style-guide.vue.js ***!
  \****************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

vue__WEBPACK_IMPORTED_MODULE_0___default.a.component('style-guide', {
  props: ['firstName', 'isDefault', 'items'],

  data() {
    return {};
  },

  methods: {
    getInitialValue(name) {
      var match = name.match(/\[(.*)\]/);

      if (!match[1]) {
        return '';
      }

      var str = match[1];

      switch (str) {
        case 'first_name':
          return this.firstName || '';

        case 'default':
          return this.isDefault || false;

        default:
          return this[str] || '';
      }
    },

    onInputChange({
      name,
      value
    }) {
      var match = /\D\[(\D+)\]/.exec(name);

      if (!match || !match[1]) {
        return false;
      }
    }

  },
  computed: {
    itemCount() {
      return this.items;
    },

    itemCountText() {
      return "Your bag - ".concat(this.itemCount, " items");
    }

  }
});

/***/ }),

/***/ "./src/modules/testimonial-card/TestimonialCard.vue":
/*!**********************************************************!*\
  !*** ./src/modules/testimonial-card/TestimonialCard.vue ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TestimonialCard_vue_vue_type_template_id_d829fa02___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TestimonialCard.vue?vue&type=template&id=d829fa02& */ "./src/modules/testimonial-card/TestimonialCard.vue?vue&type=template&id=d829fa02&");
/* harmony import */ var _TestimonialCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TestimonialCard.vue?vue&type=script&lang=js& */ "./src/modules/testimonial-card/TestimonialCard.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _TestimonialCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _TestimonialCard_vue_vue_type_template_id_d829fa02___WEBPACK_IMPORTED_MODULE_0__["render"],
  _TestimonialCard_vue_vue_type_template_id_d829fa02___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/testimonial-card/TestimonialCard.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/testimonial-card/TestimonialCard.vue?vue&type=script&lang=js&":
/*!***********************************************************************************!*\
  !*** ./src/modules/testimonial-card/TestimonialCard.vue?vue&type=script&lang=js& ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TestimonialCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./TestimonialCard.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/testimonial-card/TestimonialCard.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TestimonialCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/testimonial-card/TestimonialCard.vue?vue&type=template&id=d829fa02&":
/*!*****************************************************************************************!*\
  !*** ./src/modules/testimonial-card/TestimonialCard.vue?vue&type=template&id=d829fa02& ***!
  \*****************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TestimonialCard_vue_vue_type_template_id_d829fa02___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./TestimonialCard.vue?vue&type=template&id=d829fa02& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/testimonial-card/TestimonialCard.vue?vue&type=template&id=d829fa02&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TestimonialCard_vue_vue_type_template_id_d829fa02___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TestimonialCard_vue_vue_type_template_id_d829fa02___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/testimonials/testimonials.js":
/*!**************************************************!*\
  !*** ./src/modules/testimonials/testimonials.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_modules_effect_fade_effect_fade_min_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! swiper/modules/effect-fade/effect-fade.min.css */ "./node_modules/swiper/modules/effect-fade/effect-fade.min.css");
/* harmony import */ var swiper_modules_effect_fade_effect_fade_min_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_modules_effect_fade_effect_fade_min_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var modules_testimonial_card_TestimonialCard_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! modules/testimonial-card/TestimonialCard.vue */ "./src/modules/testimonial-card/TestimonialCard.vue");







/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_1__["default"])(el, {
    components: {
      TestimonialCard: modules_testimonial_card_TestimonialCard_vue__WEBPACK_IMPORTED_MODULE_6__["default"]
    },

    data() {
      return {
        items: el.dataset.settings ? JSON.parse(Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["decode"])(el.dataset.settings)) : [],
        swiperIns: null,
        testimonialCardInstances: []
      };
    },

    computed: {
      shouldLoop() {
        var _ref;

        return (_ref = this.items.length > 1) !== null && _ref !== void 0 ? _ref : 0;
      }

    },

    mounted() {
      this.$nextTick(() => {
        this.initCarousel();
      });
    },

    methods: {
      stopAllVideo() {
        this.testimonialCardInstances.forEach(ins => {
          ins.stopVideo();
        });
      },

      initCarousel() {
        var swiperEl = this.$refs.testimonialCarousel;

        if (swiperEl) {
          this.swiperIns = new swiper__WEBPACK_IMPORTED_MODULE_3__["default"](swiperEl, {
            loop: this.shouldLoop,
            loopAdditionalSlides: 1,
            modules: [swiper__WEBPACK_IMPORTED_MODULE_3__["EffectFade"], swiper__WEBPACK_IMPORTED_MODULE_3__["Navigation"], swiper__WEBPACK_IMPORTED_MODULE_3__["Autoplay"]],
            spaceBetween: 10,
            centeredSlides: true,
            slidesPerView: 1,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            speed: 500,
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
            autoplay: {
              delay: 6000
            },
            on: {
              afterInit: () => {
                var testimonialCardEls = this.$el.querySelectorAll('.testimonial-card');
                var TestimonialCardClass = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend(modules_testimonial_card_TestimonialCard_vue__WEBPACK_IMPORTED_MODULE_6__["default"]);
                this.testimonialCardInstances = []; // * Initialize Vue instance for all Testimonial Cards which created by Swiper

                testimonialCardEls.forEach((testimonialCardEl, index) => {
                  var parentEl = testimonialCardEl.parentNode;
                  var dataset = parentEl.dataset;
                  var newTestimonialCardIns = new TestimonialCardClass({
                    propsData: {
                      image: dataset.mcImage,
                      video: dataset.mcVideo,
                      title: dataset.mcTitle,
                      author: dataset.mcAuthor,
                      position: dataset.mcPosition,
                      thresholdGroup: "testimonial-item-".concat(index)
                    }
                  }); // * Call mount() to initialize $el inside a Vue instance

                  newTestimonialCardIns.$mount();
                  parentEl.appendChild(newTestimonialCardIns.$el);
                  this.testimonialCardInstances.push(newTestimonialCardIns); // * Hide the current Testimonial Card forever

                  testimonialCardEl.style.display = 'none';
                });
              }
            }
          }); // TODO: Reset slide position on window resize when using loop in swiper (swiper bug)

          window.addEventListener('change', () => {
            if (window.innerWidth >= 1024) {
              this.swiperIns.slideToLoop(0, 0);
            }
          });
          this.swiperIns.on('slideChange', () => {
            this.stopAllVideo();
          });
        }
      }

    }
  });
});

/***/ }),

/***/ "./src/modules/text-input/TextInput.vue":
/*!**********************************************!*\
  !*** ./src/modules/text-input/TextInput.vue ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TextInput_vue_vue_type_template_id_bc79848e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TextInput.vue?vue&type=template&id=bc79848e& */ "./src/modules/text-input/TextInput.vue?vue&type=template&id=bc79848e&");
/* harmony import */ var _TextInput_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TextInput.vue?vue&type=script&lang=js& */ "./src/modules/text-input/TextInput.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _TextInput_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _TextInput_vue_vue_type_template_id_bc79848e___WEBPACK_IMPORTED_MODULE_0__["render"],
  _TextInput_vue_vue_type_template_id_bc79848e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/text-input/TextInput.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/text-input/TextInput.vue?vue&type=script&lang=js&":
/*!***********************************************************************!*\
  !*** ./src/modules/text-input/TextInput.vue?vue&type=script&lang=js& ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TextInput_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./TextInput.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/text-input/TextInput.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TextInput_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/text-input/TextInput.vue?vue&type=template&id=bc79848e&":
/*!*****************************************************************************!*\
  !*** ./src/modules/text-input/TextInput.vue?vue&type=template&id=bc79848e& ***!
  \*****************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TextInput_vue_vue_type_template_id_bc79848e___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./TextInput.vue?vue&type=template&id=bc79848e& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/text-input/TextInput.vue?vue&type=template&id=bc79848e&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TextInput_vue_vue_type_template_id_bc79848e___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TextInput_vue_vue_type_template_id_bc79848e___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/tiktok-card/TiktokCard.vue":
/*!************************************************!*\
  !*** ./src/modules/tiktok-card/TiktokCard.vue ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TiktokCard_vue_vue_type_template_id_5e4c2112___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TiktokCard.vue?vue&type=template&id=5e4c2112& */ "./src/modules/tiktok-card/TiktokCard.vue?vue&type=template&id=5e4c2112&");
/* harmony import */ var _TiktokCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TiktokCard.vue?vue&type=script&lang=js& */ "./src/modules/tiktok-card/TiktokCard.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _TiktokCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _TiktokCard_vue_vue_type_template_id_5e4c2112___WEBPACK_IMPORTED_MODULE_0__["render"],
  _TiktokCard_vue_vue_type_template_id_5e4c2112___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/tiktok-card/TiktokCard.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/tiktok-card/TiktokCard.vue?vue&type=script&lang=js&":
/*!*************************************************************************!*\
  !*** ./src/modules/tiktok-card/TiktokCard.vue?vue&type=script&lang=js& ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TiktokCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./TiktokCard.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/tiktok-card/TiktokCard.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TiktokCard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/tiktok-card/TiktokCard.vue?vue&type=template&id=5e4c2112&":
/*!*******************************************************************************!*\
  !*** ./src/modules/tiktok-card/TiktokCard.vue?vue&type=template&id=5e4c2112& ***!
  \*******************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TiktokCard_vue_vue_type_template_id_5e4c2112___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./TiktokCard.vue?vue&type=template&id=5e4c2112& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/tiktok-card/TiktokCard.vue?vue&type=template&id=5e4c2112&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TiktokCard_vue_vue_type_template_id_5e4c2112___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TiktokCard_vue_vue_type_template_id_5e4c2112___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/tiktok-carousel/tiktok-carousel.js":
/*!********************************************************!*\
  !*** ./src/modules/tiktok-carousel/tiktok-carousel.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/vue */ "./src/assets/js/lib/vue.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.esm.js");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! swiper/swiper.min.css */ "./node_modules/swiper/swiper.min.css");
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var modules_tiktok_card_TiktokCard_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! modules/tiktok-card/TiktokCard.vue */ "./src/modules/tiktok-card/TiktokCard.vue");






/* harmony default export */ __webpack_exports__["default"] = (el => {
  return Object(lib_vue__WEBPACK_IMPORTED_MODULE_1__["default"])(el, {
    components: {
      TiktokCard: modules_tiktok_card_TiktokCard_vue__WEBPACK_IMPORTED_MODULE_5__["default"]
    },

    data() {
      return {
        items: el.dataset.settings ? JSON.parse(Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["decode"])(el.dataset.settings)) : [],
        swiperIns: null,
        clonedCardInstances: []
      };
    },

    computed: {
      shouldLoop() {
        var _ref;

        return (_ref = this.items.length > 1) !== null && _ref !== void 0 ? _ref : 0;
      }

    },

    mounted() {
      this.$nextTick(() => {
        this.initCarousel();
      });
    },

    methods: {
      stopAllVideo() {
        var tiktokCardRefs = this.$refs['tiktok-card'];

        if (tiktokCardRefs && tiktokCardRefs.length) {
          tiktokCardRefs.forEach(cardRef => {
            if (cardRef && cardRef.stopVideo) {
              cardRef.stopVideo();
            }
          });
        }

        if (this.clonedCardInstances.length) {
          this.clonedCardInstances.forEach(instance => {
            if (instance && instance.stopVideo) {
              instance.stopVideo();
            }
          });
        }
      },

      forceLoadVisibleVideos() {
        var tiktokCardRefs = this.$refs['tiktok-card'];

        if (tiktokCardRefs && tiktokCardRefs.length) {
          tiktokCardRefs.forEach(cardRef => {
            if (cardRef && cardRef.$refs.videoEl) {
              var videoComponent = cardRef.$refs.videoEl;

              if (videoComponent && typeof videoComponent.loadVideo === 'function') {
                if (videoComponent.videoEl && videoComponent.videoEl.readyState === 0) {
                  videoComponent.loadVideo();
                }
              }
            }
          });
        }

        if (this.clonedCardInstances.length) {
          this.clonedCardInstances.forEach(instance => {
            if (instance && instance.$refs.videoEl) {
              var videoComponent = instance.$refs.videoEl;

              if (videoComponent && typeof videoComponent.loadVideo === 'function') {
                if (videoComponent.videoEl && videoComponent.videoEl.readyState === 0) {
                  videoComponent.loadVideo();
                }
              }
            }
          });
        }
      },

      initClonedSlides() {
        var clonedSlides = this.$el.querySelectorAll('.swiper-slide-duplicate');
        var TiktokCardClass = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend(modules_tiktok_card_TiktokCard_vue__WEBPACK_IMPORTED_MODULE_5__["default"]);
        this.clonedCardInstances = [];
        clonedSlides.forEach(clonedSlide => {
          var tiktokCardEl = clonedSlide.querySelector('.tiktok-card');
          if (!tiktokCardEl) return;
          var dataset = clonedSlide.dataset;
          var index = parseInt(dataset.swiperSlideIndex) || 0;
          var newTiktokCardIns = new TiktokCardClass({
            propsData: {
              image: dataset.mcImage,
              video: dataset.mcVideo,
              index: index
            }
          });
          newTiktokCardIns.$mount();
          clonedSlide.appendChild(newTiktokCardIns.$el);
          this.clonedCardInstances.push(newTiktokCardIns);
          tiktokCardEl.style.display = 'none';
          clonedSlide.setAttribute('aria-hidden', 'true');
          clonedSlide.setAttribute('tabindex', '-1');
        });
      },

      updateSlideAccessibility() {
        if (!this.swiperIns) return;
        var allSlides = this.$el.querySelectorAll('.swiper-slide');
        var realIndex = this.swiperIns.realIndex;
        var currentlyFocusedElement = document.activeElement;
        allSlides.forEach((slide, index) => {
          var isDuplicate = slide.classList.contains('swiper-slide-duplicate');
          var slideIndex = isDuplicate ? parseInt(slide.dataset.swiperSlideIndex) : index;

          if (slideIndex === realIndex && slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('aria-hidden', 'false');
            slide.setAttribute('tabindex', '0');
          } else {
            if (slide.contains(currentlyFocusedElement)) {
              currentlyFocusedElement.blur();
            }

            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('tabindex', '-1');
          }
        });
      },

      setupFocusManagement() {
        var swiperEl = this.$refs.tiktokCarousel;
        if (!swiperEl) return;
        swiperEl.addEventListener('focusin', e => {
          if (!this.swiperIns) return;
          var activeSlide = this.$el.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)');

          if (activeSlide && !activeSlide.contains(e.target)) {
            var firstFocusable = activeSlide.querySelector('button, [tabindex="0"]') || activeSlide;

            if (firstFocusable) {
              firstFocusable.focus();
            }
          }
        });
        swiperEl.addEventListener('keydown', e => {
          if (!this.swiperIns) return;
          var key = e.key;
          var activeSlide = this.$el.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)');
          if (!activeSlide) return;

          if (key === 'ArrowRight') {
            e.preventDefault();
            this.swiperIns.slideNext();
            setTimeout(() => {
              var newActiveSlide = this.$el.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)');

              if (newActiveSlide) {
                var firstFocusable = newActiveSlide.querySelector('button, [tabindex="0"]') || newActiveSlide;

                if (firstFocusable) {
                  firstFocusable.focus();
                }
              }
            }, 300);
          }

          if (key === 'ArrowLeft') {
            e.preventDefault();
            this.swiperIns.slidePrev();
            setTimeout(() => {
              var newActiveSlide = this.$el.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)');

              if (newActiveSlide) {
                var firstFocusable = newActiveSlide.querySelector('button, [tabindex="0"]') || newActiveSlide;

                if (firstFocusable) {
                  firstFocusable.focus();
                }
              }
            }, 300);
          }

          if (key === 'Tab' && !e.shiftKey) {
            var focusableElements = Array.from(activeSlide.querySelectorAll('button, [tabindex="0"]'));
            var currentIndex = focusableElements.indexOf(document.activeElement);

            if (currentIndex === focusableElements.length - 1 || focusableElements.length === 0) {
              e.preventDefault();
              this.swiperIns.slideNext();
              setTimeout(() => {
                var newActiveSlide = this.$el.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)');

                if (newActiveSlide) {
                  var firstFocusable = newActiveSlide.querySelector('button, [tabindex="0"]') || newActiveSlide;

                  if (firstFocusable) {
                    firstFocusable.focus();
                  }
                }
              }, 300);
            }
          }

          if (key === 'Tab' && e.shiftKey) {
            var _focusableElements = Array.from(activeSlide.querySelectorAll('button, [tabindex="0"]'));

            var _currentIndex = _focusableElements.indexOf(document.activeElement);

            if (_currentIndex === 0 || _currentIndex === -1) {
              e.preventDefault();
              this.swiperIns.slidePrev();
              setTimeout(() => {
                var newActiveSlide = this.$el.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)');

                if (newActiveSlide) {
                  var focusableInPrev = Array.from(newActiveSlide.querySelectorAll('button, [tabindex="0"]'));
                  var lastFocusable = focusableInPrev[focusableInPrev.length - 1] || newActiveSlide;

                  if (lastFocusable) {
                    lastFocusable.focus();
                  }
                }
              }, 300);
            }
          }
        });
      },

      initCarousel() {
        var swiperEl = this.$refs.tiktokCarousel;

        if (swiperEl) {
          this.swiperIns = new swiper__WEBPACK_IMPORTED_MODULE_3__["default"](swiperEl, {
            loop: this.shouldLoop,
            loopedSlides: this.items.length,
            // Specify number of slides for proper looping
            loopAdditionalSlides: 1,
            modules: [swiper__WEBPACK_IMPORTED_MODULE_3__["Navigation"]],
            spaceBetween: 10,
            slidesPerView: 1.335,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            breakpoints: {
              // ! Swiper breakpoints do not inherit, so do not remove duplicated properties
              768: {
                spaceBetween: 10,
                slidesPerView: 2
              },
              1024: {
                spaceBetween: 15,
                slidesPerView: 2
              },
              1440: {
                spaceBetween: 22,
                slidesPerView: 2
              },
              1600: {
                spaceBetween: 25,
                slidesPerView: 2
              }
            },
            on: {
              init: () => {
                this.$nextTick(() => {
                  this.initClonedSlides();
                  this.updateSlideAccessibility();
                  this.setupFocusManagement();
                  this.forceLoadVisibleVideos();
                });
              },
              slideChangeTransitionEnd: () => {
                this.stopAllVideo();
                this.updateSlideAccessibility();
                this.$nextTick(() => {
                  this.forceLoadVisibleVideos();
                });
              }
            }
          }); // TODO: Reset slide position on window resize when using loop in swiper (swiper bug)

          window.addEventListener('resize', () => {
            if (window.innerWidth >= 1024) {
              this.swiperIns.slideToLoop(0, 0);
            }
          });
        }
      }

    }
  });
});

/***/ }),

/***/ "./src/modules/video-embed/VideoEmbed.vue":
/*!************************************************!*\
  !*** ./src/modules/video-embed/VideoEmbed.vue ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _VideoEmbed_vue_vue_type_template_id_32ef7c32___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VideoEmbed.vue?vue&type=template&id=32ef7c32& */ "./src/modules/video-embed/VideoEmbed.vue?vue&type=template&id=32ef7c32&");
/* harmony import */ var _VideoEmbed_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VideoEmbed.vue?vue&type=script&lang=js& */ "./src/modules/video-embed/VideoEmbed.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _VideoEmbed_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _VideoEmbed_vue_vue_type_template_id_32ef7c32___WEBPACK_IMPORTED_MODULE_0__["render"],
  _VideoEmbed_vue_vue_type_template_id_32ef7c32___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/video-embed/VideoEmbed.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/video-embed/VideoEmbed.vue?vue&type=script&lang=js&":
/*!*************************************************************************!*\
  !*** ./src/modules/video-embed/VideoEmbed.vue?vue&type=script&lang=js& ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VideoEmbed_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./VideoEmbed.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/video-embed/VideoEmbed.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VideoEmbed_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/video-embed/VideoEmbed.vue?vue&type=template&id=32ef7c32&":
/*!*******************************************************************************!*\
  !*** ./src/modules/video-embed/VideoEmbed.vue?vue&type=template&id=32ef7c32& ***!
  \*******************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VideoEmbed_vue_vue_type_template_id_32ef7c32___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./VideoEmbed.vue?vue&type=template&id=32ef7c32& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/video-embed/VideoEmbed.vue?vue&type=template&id=32ef7c32&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VideoEmbed_vue_vue_type_template_id_32ef7c32___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VideoEmbed_vue_vue_type_template_id_32ef7c32___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/video/Video.vue":
/*!*************************************!*\
  !*** ./src/modules/video/Video.vue ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Video_vue_vue_type_template_id_27d01976___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Video.vue?vue&type=template&id=27d01976& */ "./src/modules/video/Video.vue?vue&type=template&id=27d01976&");
/* harmony import */ var _Video_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Video.vue?vue&type=script&lang=js& */ "./src/modules/video/Video.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _Video_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Video_vue_vue_type_template_id_27d01976___WEBPACK_IMPORTED_MODULE_0__["render"],
  _Video_vue_vue_type_template_id_27d01976___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/video/Video.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/video/Video.vue?vue&type=script&lang=js&":
/*!**************************************************************!*\
  !*** ./src/modules/video/Video.vue?vue&type=script&lang=js& ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Video_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./Video.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/video/Video.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Video_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/video/Video.vue?vue&type=template&id=27d01976&":
/*!********************************************************************!*\
  !*** ./src/modules/video/Video.vue?vue&type=template&id=27d01976& ***!
  \********************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Video_vue_vue_type_template_id_27d01976___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./Video.vue?vue&type=template&id=27d01976& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/video/Video.vue?vue&type=template&id=27d01976&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Video_vue_vue_type_template_id_27d01976___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Video_vue_vue_type_template_id_27d01976___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/video/video.js":
/*!************************************!*\
  !*** ./src/modules/video/video.js ***!
  \************************************/
/*! exports provided: updateSource, controlButtonClickHandler, resetControlButton, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSource", function() { return updateSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "controlButtonClickHandler", function() { return controlButtonClickHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetControlButton", function() { return resetControlButton; });
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");
/* harmony import */ var enquire_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! enquire.js */ "./node_modules/enquire.js/src/index.js");
/* harmony import */ var enquire_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(enquire_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var in_viewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! in-viewport */ "./node_modules/in-viewport/in-viewport.js");
/* harmony import */ var in_viewport__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(in_viewport__WEBPACK_IMPORTED_MODULE_4__);





/**
 * Updates the src attribute of the <source> elements of the video module
 *
 * @param {Element} $source The <source> elements of the video
 * @param {Element} $video The <video> element
 * @param {object} config Configuration object
 */

var updateSource = ($source, $video, config) => {
  Array.prototype.forEach.call($source, $el => {
    var media = $el.media;

    if (!media) {
      loadVideo($el, $video, config);
      return;
    }

    var match = onMediaQueryMatch($el, $video, config);
    var unmatch = onMediaQueryUnmatch($el, $video);
    registerMediaQuery(media, match, unmatch);
  });
};
/**
 * Load the video when it's in viewport
 *
 * @param {Element} $source <source> element to update
 * @param {Element} $video <video> element to load
 * @param {object} config options for inViewport
 */

var loadVideo = ($source, $video, config) => {
  in_viewport__WEBPACK_IMPORTED_MODULE_4___default()($video, config, () => {
    $source.src = $source.dataset.src;
    $video.load();
  });
};
/**
 * Handles when a media query matches: update source, reload video
 *
 * @param {Element} $source <source> element
 * @param {Element} $video <video> element
 * @param {object} config for inViewport
 * @returns {undefined}
 */


var onMediaQueryMatch = ($source, $video, config) => {
  return () => {
    loadVideo($source, $video, config);
  };
};
/**
 * Handles when a media query doesn't match: update source, reload video
 *
 * @param {Element} $source <source> element
 * @param {Element} $video <video> element
 * @returns {undefined}
 */


var onMediaQueryUnmatch = ($source, $video) => {
  return () => {
    $source.removeAttribute('src');
    $video.load();
  };
};
/**
 * Registers handlers for a given media query
 *
 * @param {string} mediaQuery CSS media query
 * @param {Function} match Callback fired when a media query matches
 * @param {Function} unmatch Callback fired when a media query doesn't match
 */


var registerMediaQuery = (mediaQuery, match, unmatch) => {
  enquire_js__WEBPACK_IMPORTED_MODULE_3___default.a.register(mediaQuery, {
    match,
    unmatch
  });
};
/**
 * Control button click handler
 *
 * @param {Element} $controlButton <button> element
 * @param {Element} $video <video> element
 */


var controlButtonClickHandler = ($controlButton, $video) => {
  if ($video.paused) {
    $video.play();
    $controlButton.setAttribute('data-playing', 'true');
    $controlButton.setAttribute('aria-label', 'Pause Video');
  } else {
    $video.pause();
    $controlButton.setAttribute('data-playing', 'false');
    $controlButton.setAttribute('aria-label', 'Play Video');
  }
};
/**
 * Reset control button to initial state
 *
 * @param {Element} $controlButton <button> element
 */

var resetControlButton = $controlButton => {
  $controlButton.setAttribute('data-playing', 'true');
  $controlButton.setAttribute('aria-label', $controlButton.getAttribute('data-pause'));
};
/**
 * Main function of the video module
 *
 * @param {Element} $el Root element
 */

/* harmony default export */ __webpack_exports__["default"] = ($el => {
  var $video = Object(select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])('video', $el);
  var $source = select_dom__WEBPACK_IMPORTED_MODULE_0__["default"].all('source', $video);
  var $controlButton = Object(select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])('.js-control-button', $el);
  var offset = parseInt($el.dataset.offset);
  var config = {
    offset
  };
  if (!$video) return;

  if ($source.length) {
    updateSource($source, $video, config);
  }

  $video.addEventListener('canplay', e => {
    Object(lib_util__WEBPACK_IMPORTED_MODULE_2__["set"])($video, 'is-loaded');

    if ($controlButton) {
      dom_event__WEBPACK_IMPORTED_MODULE_1___default()($controlButton, 'click', () => {
        controlButtonClickHandler($controlButton, $video);
      });
    }
  }, {
    once: true
  });
  dom_event__WEBPACK_IMPORTED_MODULE_1___default()(window, 'resize', () => {
    if ($controlButton) {
      resetControlButton($controlButton);
    }
  });
});

/***/ }),

/***/ "./src/modules/video/video.vue":
/*!*************************************!*\
  !*** ./src/modules/video/video.vue ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _video_vue_vue_type_template_id_9f440cd4___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./video.vue?vue&type=template&id=9f440cd4& */ "./src/modules/video/video.vue?vue&type=template&id=9f440cd4&");
/* harmony import */ var _video_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./video.vue?vue&type=script&lang=js& */ "./src/modules/video/video.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _video_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _video_vue_vue_type_template_id_9f440cd4___WEBPACK_IMPORTED_MODULE_0__["render"],
  _video_vue_vue_type_template_id_9f440cd4___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/video/video.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/video/video.vue.js":
/*!****************************************!*\
  !*** ./src/modules/video/video.vue.js ***!
  \****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.js");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dom-event */ "./node_modules/dom-event/index.js");
/* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dom_event__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _video_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./video.js */ "./src/modules/video/video.js");



vue__WEBPACK_IMPORTED_MODULE_0___default.a.component('vue-video', {
  props: ['source', 'poster'],

  data() {
    return {
      isLoaded: false
    };
  },

  mounted() {
    var offset = parseInt(this.$el.dataset.offset);
    var config = {
      offset
    };
    Object(_video_js__WEBPACK_IMPORTED_MODULE_2__["updateSource"])(this.$refs.source, this.$refs.video, config);
    dom_event__WEBPACK_IMPORTED_MODULE_1___default()(window, 'resize', this.resizeHandler);
  },

  destroyed() {
    dom_event__WEBPACK_IMPORTED_MODULE_1___default.a.off(window, 'resize', this.resizeHandler);
  },

  methods: {
    onCanPlay() {
      this.isLoaded = true;
      dom_event__WEBPACK_IMPORTED_MODULE_1___default()(this.$refs.controlButton, 'click', () => {
        Object(_video_js__WEBPACK_IMPORTED_MODULE_2__["controlButtonClickHandler"])(this.$refs.controlButton, this.$refs.video);
      });
    },

    resizeHandler() {
      Object(_video_js__WEBPACK_IMPORTED_MODULE_2__["resetControlButton"])(this.$refs.controlButton);
    }

  }
});

/***/ }),

/***/ "./src/modules/video/video.vue?vue&type=script&lang=js&":
/*!**************************************************************!*\
  !*** ./src/modules/video/video.vue?vue&type=script&lang=js& ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_video_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./video.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/video/video.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_video_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/video/video.vue?vue&type=template&id=9f440cd4&":
/*!********************************************************************!*\
  !*** ./src/modules/video/video.vue?vue&type=template&id=9f440cd4& ***!
  \********************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_video_vue_vue_type_template_id_9f440cd4___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./video.vue?vue&type=template&id=9f440cd4& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/video/video.vue?vue&type=template&id=9f440cd4&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_video_vue_vue_type_template_id_9f440cd4___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_video_vue_vue_type_template_id_9f440cd4___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/modules/wysiwyg/wysiwyg.js":
/*!****************************************!*\
  !*** ./src/modules/wysiwyg/wysiwyg.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! select-dom */ "./node_modules/select-dom/index.js");
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lib/util */ "./src/assets/js/lib/util.js");


var IMAGE_WRAPPER_CLASS = 'wysiwyg__image-wrapper';
/* harmony default export */ __webpack_exports__["default"] = (el => {
  var images = select_dom__WEBPACK_IMPORTED_MODULE_0__["default"].all('img', el);

  if (images.length) {
    images.forEach(image => {
      var wrapper = document.createElement('div');
      var cotnentCaption = image.getAttribute('alt');
      Object(lib_util__WEBPACK_IMPORTED_MODULE_1__["set"])(wrapper, IMAGE_WRAPPER_CLASS);
      image.parentNode.insertBefore(wrapper, image);
      wrapper.appendChild(image);

      if (cotnentCaption) {
        var captionEl = document.createElement('span');
        Object(lib_util__WEBPACK_IMPORTED_MODULE_1__["set"])(captionEl, 'wysiwyg__image-caption');
        captionEl.innerText = cotnentCaption;
        wrapper.appendChild(captionEl);
      }
    });
  }
});

/***/ }),

/***/ "./src/modules/zoomable-image/ZoomableImage.vue":
/*!******************************************************!*\
  !*** ./src/modules/zoomable-image/ZoomableImage.vue ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ZoomableImage_vue_vue_type_template_id_3bec6f9b___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ZoomableImage.vue?vue&type=template&id=3bec6f9b& */ "./src/modules/zoomable-image/ZoomableImage.vue?vue&type=template&id=3bec6f9b&");
/* harmony import */ var _ZoomableImage_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ZoomableImage.vue?vue&type=script&lang=js& */ "./src/modules/zoomable-image/ZoomableImage.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js");





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
  _ZoomableImage_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ZoomableImage_vue_vue_type_template_id_3bec6f9b___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ZoomableImage_vue_vue_type_template_id_3bec6f9b___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/modules/zoomable-image/ZoomableImage.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/modules/zoomable-image/ZoomableImage.vue?vue&type=script&lang=js&":
/*!*******************************************************************************!*\
  !*** ./src/modules/zoomable-image/ZoomableImage.vue?vue&type=script&lang=js& ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ZoomableImage_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/babel-loader/lib!../../../node_modules/vue-loader/lib??vue-loader-options!./ZoomableImage.vue?vue&type=script&lang=js& */ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js?!./src/modules/zoomable-image/ZoomableImage.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ZoomableImage_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/modules/zoomable-image/ZoomableImage.vue?vue&type=template&id=3bec6f9b&":
/*!*************************************************************************************!*\
  !*** ./src/modules/zoomable-image/ZoomableImage.vue?vue&type=template&id=3bec6f9b& ***!
  \*************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZoomableImage_vue_vue_type_template_id_3bec6f9b___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib??vue-loader-options!./ZoomableImage.vue?vue&type=template&id=3bec6f9b& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js?!./node_modules/vue-loader/lib/index.js?!./src/modules/zoomable-image/ZoomableImage.vue?vue&type=template&id=3bec6f9b&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZoomableImage_vue_vue_type_template_id_3bec6f9b___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ZoomableImage_vue_vue_type_template_id_3bec6f9b___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ })

/******/ });